
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire823f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire823f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hCm5D", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $cd371ee1e36b4c33$export$ffb0004e005737fa; }, function (v) { return $cd371ee1e36b4c33$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $cd371ee1e36b4c33$export$34b9dba7ce09269b; }, function (v) { return $cd371ee1e36b4c33$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $cd371ee1e36b4c33$export$25062201e9e25d76; }, function (v) { return $cd371ee1e36b4c33$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cd371ee1e36b4c33$export$ffb0004e005737fa;
var $cd371ee1e36b4c33$export$34b9dba7ce09269b;
var $cd371ee1e36b4c33$export$25062201e9e25d76;
'use strict';

var $ieaan = parcelRequire("ieaan");
var $cd371ee1e36b4c33$var$k = Symbol.for("react.element"), $cd371ee1e36b4c33$var$l = Symbol.for("react.fragment"), $cd371ee1e36b4c33$var$m = Object.prototype.hasOwnProperty, $cd371ee1e36b4c33$var$n = $ieaan.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $cd371ee1e36b4c33$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cd371ee1e36b4c33$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$cd371ee1e36b4c33$var$m.call(a, b) && !$cd371ee1e36b4c33$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $cd371ee1e36b4c33$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $cd371ee1e36b4c33$var$n.current
    };
}
$cd371ee1e36b4c33$export$ffb0004e005737fa = $cd371ee1e36b4c33$var$l;
$cd371ee1e36b4c33$export$34b9dba7ce09269b = $cd371ee1e36b4c33$var$q;
$cd371ee1e36b4c33$export$25062201e9e25d76 = $cd371ee1e36b4c33$var$q;

});
parcelRegister("ieaan", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9ML7Q"));

});
parcelRegister("9ML7Q", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $71fd26e44c0b396c$export$dca3b0875bd9a954; }, function (v) { return $71fd26e44c0b396c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $71fd26e44c0b396c$export$16fa2f45be04daa8; }, function (v) { return $71fd26e44c0b396c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $71fd26e44c0b396c$export$ffb0004e005737fa; }, function (v) { return $71fd26e44c0b396c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $71fd26e44c0b396c$export$e2c29f18771995cb; }, function (v) { return $71fd26e44c0b396c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $71fd26e44c0b396c$export$221d75b3f55bb0bd; }, function (v) { return $71fd26e44c0b396c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $71fd26e44c0b396c$export$5f8d39834fd61797; }, function (v) { return $71fd26e44c0b396c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $71fd26e44c0b396c$export$74bf444e3cd11ea5; }, function (v) { return $71fd26e44c0b396c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $71fd26e44c0b396c$export$ae55be85d98224ed; }, function (v) { return $71fd26e44c0b396c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $71fd26e44c0b396c$export$3ba232387fd5d6dd; }, function (v) { return $71fd26e44c0b396c$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $71fd26e44c0b396c$export$e530037191fcd5d7; }, function (v) { return $71fd26e44c0b396c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $71fd26e44c0b396c$export$fd42f52fd3ae1109; }, function (v) { return $71fd26e44c0b396c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $71fd26e44c0b396c$export$c8a8987d4410bf2d; }, function (v) { return $71fd26e44c0b396c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $71fd26e44c0b396c$export$d38cd72104c1f0e9; }, function (v) { return $71fd26e44c0b396c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $71fd26e44c0b396c$export$7d1e3a5e95ceca43; }, function (v) { return $71fd26e44c0b396c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $71fd26e44c0b396c$export$257a8862b851cb5b; }, function (v) { return $71fd26e44c0b396c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $71fd26e44c0b396c$export$a8257692ac88316c; }, function (v) { return $71fd26e44c0b396c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $71fd26e44c0b396c$export$488013bae63b21da; }, function (v) { return $71fd26e44c0b396c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $71fd26e44c0b396c$export$7c73462e0d25e514; }, function (v) { return $71fd26e44c0b396c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $71fd26e44c0b396c$export$7568632d0d33d16d; }, function (v) { return $71fd26e44c0b396c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $71fd26e44c0b396c$export$88948ce120ea2619; }, function (v) { return $71fd26e44c0b396c$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $71fd26e44c0b396c$export$35808ee640e87ca7; }, function (v) { return $71fd26e44c0b396c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $71fd26e44c0b396c$export$fae74005e78b1a27; }, function (v) { return $71fd26e44c0b396c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $71fd26e44c0b396c$export$dc8fbce3eb94dc1e; }, function (v) { return $71fd26e44c0b396c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $71fd26e44c0b396c$export$6a7bc4e911dc01cf; }, function (v) { return $71fd26e44c0b396c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $71fd26e44c0b396c$export$6d9c69b0de29b591; }, function (v) { return $71fd26e44c0b396c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $71fd26e44c0b396c$export$f680877a34711e37; }, function (v) { return $71fd26e44c0b396c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $71fd26e44c0b396c$export$d5a552a76deda3c2; }, function (v) { return $71fd26e44c0b396c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $71fd26e44c0b396c$export$aaabe4eda9ed9969; }, function (v) { return $71fd26e44c0b396c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $71fd26e44c0b396c$export$e5c5a5f917a5871c; }, function (v) { return $71fd26e44c0b396c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $71fd26e44c0b396c$export$1538c33de8887b59; }, function (v) { return $71fd26e44c0b396c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $71fd26e44c0b396c$export$13e3392192263954; }, function (v) { return $71fd26e44c0b396c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $71fd26e44c0b396c$export$b8f5890fc79d6aca; }, function (v) { return $71fd26e44c0b396c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $71fd26e44c0b396c$export$60241385465d0a34; }, function (v) { return $71fd26e44c0b396c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $71fd26e44c0b396c$export$306c0aa65ff9ec16; }, function (v) { return $71fd26e44c0b396c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $71fd26e44c0b396c$export$7b286972b8d8ccbf; }, function (v) { return $71fd26e44c0b396c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $71fd26e44c0b396c$export$83d89fbfd8236492; }, function (v) { return $71fd26e44c0b396c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $71fd26e44c0b396c$export$dca3b0875bd9a954;
var $71fd26e44c0b396c$export$16fa2f45be04daa8;
var $71fd26e44c0b396c$export$ffb0004e005737fa;
var $71fd26e44c0b396c$export$e2c29f18771995cb;
var $71fd26e44c0b396c$export$221d75b3f55bb0bd;
var $71fd26e44c0b396c$export$5f8d39834fd61797;
var $71fd26e44c0b396c$export$74bf444e3cd11ea5;
var $71fd26e44c0b396c$export$ae55be85d98224ed;
var $71fd26e44c0b396c$export$3ba232387fd5d6dd;
var $71fd26e44c0b396c$export$e530037191fcd5d7;
var $71fd26e44c0b396c$export$fd42f52fd3ae1109;
var $71fd26e44c0b396c$export$c8a8987d4410bf2d;
var $71fd26e44c0b396c$export$d38cd72104c1f0e9;
var $71fd26e44c0b396c$export$7d1e3a5e95ceca43;
var $71fd26e44c0b396c$export$257a8862b851cb5b;
var $71fd26e44c0b396c$export$a8257692ac88316c;
var $71fd26e44c0b396c$export$488013bae63b21da;
var $71fd26e44c0b396c$export$7c73462e0d25e514;
var $71fd26e44c0b396c$export$7568632d0d33d16d;
var $71fd26e44c0b396c$export$88948ce120ea2619;
var $71fd26e44c0b396c$export$35808ee640e87ca7;
var $71fd26e44c0b396c$export$fae74005e78b1a27;
var $71fd26e44c0b396c$export$dc8fbce3eb94dc1e;
var $71fd26e44c0b396c$export$6a7bc4e911dc01cf;
var $71fd26e44c0b396c$export$6d9c69b0de29b591;
var $71fd26e44c0b396c$export$f680877a34711e37;
var $71fd26e44c0b396c$export$d5a552a76deda3c2;
var $71fd26e44c0b396c$export$aaabe4eda9ed9969;
var $71fd26e44c0b396c$export$e5c5a5f917a5871c;
var $71fd26e44c0b396c$export$1538c33de8887b59;
var $71fd26e44c0b396c$export$13e3392192263954;
var $71fd26e44c0b396c$export$b8f5890fc79d6aca;
var $71fd26e44c0b396c$export$60241385465d0a34;
var $71fd26e44c0b396c$export$306c0aa65ff9ec16;
var $71fd26e44c0b396c$export$7b286972b8d8ccbf;
var $71fd26e44c0b396c$export$83d89fbfd8236492;
'use strict';
var $71fd26e44c0b396c$var$l = Symbol.for("react.element"), $71fd26e44c0b396c$var$n = Symbol.for("react.portal"), $71fd26e44c0b396c$var$p = Symbol.for("react.fragment"), $71fd26e44c0b396c$var$q = Symbol.for("react.strict_mode"), $71fd26e44c0b396c$var$r = Symbol.for("react.profiler"), $71fd26e44c0b396c$var$t = Symbol.for("react.provider"), $71fd26e44c0b396c$var$u = Symbol.for("react.context"), $71fd26e44c0b396c$var$v = Symbol.for("react.forward_ref"), $71fd26e44c0b396c$var$w = Symbol.for("react.suspense"), $71fd26e44c0b396c$var$x = Symbol.for("react.memo"), $71fd26e44c0b396c$var$y = Symbol.for("react.lazy"), $71fd26e44c0b396c$var$z = Symbol.iterator;
function $71fd26e44c0b396c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $71fd26e44c0b396c$var$z && a[$71fd26e44c0b396c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $71fd26e44c0b396c$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $71fd26e44c0b396c$var$C = Object.assign, $71fd26e44c0b396c$var$D = {};
function $71fd26e44c0b396c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $71fd26e44c0b396c$var$D;
    this.updater = e || $71fd26e44c0b396c$var$B;
}
$71fd26e44c0b396c$var$E.prototype.isReactComponent = {};
$71fd26e44c0b396c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$71fd26e44c0b396c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $71fd26e44c0b396c$var$F() {}
$71fd26e44c0b396c$var$F.prototype = $71fd26e44c0b396c$var$E.prototype;
function $71fd26e44c0b396c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $71fd26e44c0b396c$var$D;
    this.updater = e || $71fd26e44c0b396c$var$B;
}
var $71fd26e44c0b396c$var$H = $71fd26e44c0b396c$var$G.prototype = new $71fd26e44c0b396c$var$F;
$71fd26e44c0b396c$var$H.constructor = $71fd26e44c0b396c$var$G;
$71fd26e44c0b396c$var$C($71fd26e44c0b396c$var$H, $71fd26e44c0b396c$var$E.prototype);
$71fd26e44c0b396c$var$H.isPureReactComponent = !0;
var $71fd26e44c0b396c$var$I = Array.isArray, $71fd26e44c0b396c$var$J = Object.prototype.hasOwnProperty, $71fd26e44c0b396c$var$K = {
    current: null
}, $71fd26e44c0b396c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $71fd26e44c0b396c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$71fd26e44c0b396c$var$J.call(b, d) && !$71fd26e44c0b396c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $71fd26e44c0b396c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $71fd26e44c0b396c$var$K.current
    };
}
function $71fd26e44c0b396c$var$N(a, b) {
    return {
        $$typeof: $71fd26e44c0b396c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $71fd26e44c0b396c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $71fd26e44c0b396c$var$l;
}
function $71fd26e44c0b396c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $71fd26e44c0b396c$var$P = /\/+/g;
function $71fd26e44c0b396c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $71fd26e44c0b396c$var$escape("" + a.key) : b.toString(36);
}
function $71fd26e44c0b396c$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $71fd26e44c0b396c$var$l:
                case $71fd26e44c0b396c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $71fd26e44c0b396c$var$Q(h, 0) : d, $71fd26e44c0b396c$var$I(c) ? (e = "", null != a && (e = a.replace($71fd26e44c0b396c$var$P, "$&/") + "/"), $71fd26e44c0b396c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($71fd26e44c0b396c$var$O(c) && (c = $71fd26e44c0b396c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($71fd26e44c0b396c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($71fd26e44c0b396c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $71fd26e44c0b396c$var$Q(k, g);
        h += $71fd26e44c0b396c$var$R(k, b, e, f, c);
    }
    else if (f = $71fd26e44c0b396c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $71fd26e44c0b396c$var$Q(k, g++), h += $71fd26e44c0b396c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $71fd26e44c0b396c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $71fd26e44c0b396c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $71fd26e44c0b396c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $71fd26e44c0b396c$var$U = {
    current: null
}, $71fd26e44c0b396c$var$V = {
    transition: null
}, $71fd26e44c0b396c$var$W = {
    ReactCurrentDispatcher: $71fd26e44c0b396c$var$U,
    ReactCurrentBatchConfig: $71fd26e44c0b396c$var$V,
    ReactCurrentOwner: $71fd26e44c0b396c$var$K
};
function $71fd26e44c0b396c$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$71fd26e44c0b396c$export$dca3b0875bd9a954 = {
    map: $71fd26e44c0b396c$var$S,
    forEach: function(a, b, e) {
        $71fd26e44c0b396c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $71fd26e44c0b396c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $71fd26e44c0b396c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$71fd26e44c0b396c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$71fd26e44c0b396c$export$16fa2f45be04daa8 = $71fd26e44c0b396c$var$E;
$71fd26e44c0b396c$export$ffb0004e005737fa = $71fd26e44c0b396c$var$p;
$71fd26e44c0b396c$export$e2c29f18771995cb = $71fd26e44c0b396c$var$r;
$71fd26e44c0b396c$export$221d75b3f55bb0bd = $71fd26e44c0b396c$var$G;
$71fd26e44c0b396c$export$5f8d39834fd61797 = $71fd26e44c0b396c$var$q;
$71fd26e44c0b396c$export$74bf444e3cd11ea5 = $71fd26e44c0b396c$var$w;
$71fd26e44c0b396c$export$ae55be85d98224ed = $71fd26e44c0b396c$var$W;
$71fd26e44c0b396c$export$3ba232387fd5d6dd = $71fd26e44c0b396c$var$X;
$71fd26e44c0b396c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $71fd26e44c0b396c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $71fd26e44c0b396c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$71fd26e44c0b396c$var$J.call(b, f) && !$71fd26e44c0b396c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $71fd26e44c0b396c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$71fd26e44c0b396c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $71fd26e44c0b396c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $71fd26e44c0b396c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$71fd26e44c0b396c$export$c8a8987d4410bf2d = $71fd26e44c0b396c$var$M;
$71fd26e44c0b396c$export$d38cd72104c1f0e9 = function(a) {
    var b = $71fd26e44c0b396c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$71fd26e44c0b396c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$71fd26e44c0b396c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $71fd26e44c0b396c$var$v,
        render: a
    };
};
$71fd26e44c0b396c$export$a8257692ac88316c = $71fd26e44c0b396c$var$O;
$71fd26e44c0b396c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $71fd26e44c0b396c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $71fd26e44c0b396c$var$T
    };
};
$71fd26e44c0b396c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $71fd26e44c0b396c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$71fd26e44c0b396c$export$7568632d0d33d16d = function(a) {
    var b = $71fd26e44c0b396c$var$V.transition;
    $71fd26e44c0b396c$var$V.transition = {};
    try {
        a();
    } finally{
        $71fd26e44c0b396c$var$V.transition = b;
    }
};
$71fd26e44c0b396c$export$88948ce120ea2619 = $71fd26e44c0b396c$var$X;
$71fd26e44c0b396c$export$35808ee640e87ca7 = function(a, b) {
    return $71fd26e44c0b396c$var$U.current.useCallback(a, b);
};
$71fd26e44c0b396c$export$fae74005e78b1a27 = function(a) {
    return $71fd26e44c0b396c$var$U.current.useContext(a);
};
$71fd26e44c0b396c$export$dc8fbce3eb94dc1e = function() {};
$71fd26e44c0b396c$export$6a7bc4e911dc01cf = function(a) {
    return $71fd26e44c0b396c$var$U.current.useDeferredValue(a);
};
$71fd26e44c0b396c$export$6d9c69b0de29b591 = function(a, b) {
    return $71fd26e44c0b396c$var$U.current.useEffect(a, b);
};
$71fd26e44c0b396c$export$f680877a34711e37 = function() {
    return $71fd26e44c0b396c$var$U.current.useId();
};
$71fd26e44c0b396c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $71fd26e44c0b396c$var$U.current.useImperativeHandle(a, b, e);
};
$71fd26e44c0b396c$export$aaabe4eda9ed9969 = function(a, b) {
    return $71fd26e44c0b396c$var$U.current.useInsertionEffect(a, b);
};
$71fd26e44c0b396c$export$e5c5a5f917a5871c = function(a, b) {
    return $71fd26e44c0b396c$var$U.current.useLayoutEffect(a, b);
};
$71fd26e44c0b396c$export$1538c33de8887b59 = function(a, b) {
    return $71fd26e44c0b396c$var$U.current.useMemo(a, b);
};
$71fd26e44c0b396c$export$13e3392192263954 = function(a, b, e) {
    return $71fd26e44c0b396c$var$U.current.useReducer(a, b, e);
};
$71fd26e44c0b396c$export$b8f5890fc79d6aca = function(a) {
    return $71fd26e44c0b396c$var$U.current.useRef(a);
};
$71fd26e44c0b396c$export$60241385465d0a34 = function(a) {
    return $71fd26e44c0b396c$var$U.current.useState(a);
};
$71fd26e44c0b396c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $71fd26e44c0b396c$var$U.current.useSyncExternalStore(a, b, e);
};
$71fd26e44c0b396c$export$7b286972b8d8ccbf = function() {
    return $71fd26e44c0b396c$var$U.current.useTransition();
};
$71fd26e44c0b396c$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("jofHE", function(module, exports) {

$parcel$export(module.exports, "enable", function () { return $e1dc708904eaae62$export$d7c4a0dd6a4567e5; }, function (v) { return $e1dc708904eaae62$export$d7c4a0dd6a4567e5 = v; });
var $e1dc708904eaae62$export$e20fbacbb41798b;
var $e1dc708904eaae62$export$d7c4a0dd6a4567e5;
'use strict';

var $4SONH = parcelRequire("4SONH");
var $e1dc708904eaae62$var$DEFAULT_WHITELIST = [
    ReferenceError,
    TypeError,
    RangeError
];
var $e1dc708904eaae62$var$enabled = false;
$e1dc708904eaae62$export$e20fbacbb41798b = $e1dc708904eaae62$var$disable;
function $e1dc708904eaae62$var$disable() {
    $e1dc708904eaae62$var$enabled = false;
    $4SONH._B = null;
    $4SONH._C = null;
}
$e1dc708904eaae62$export$d7c4a0dd6a4567e5 = $e1dc708904eaae62$var$enable;
function $e1dc708904eaae62$var$enable(options) {
    options = options || {};
    if ($e1dc708904eaae62$var$enabled) $e1dc708904eaae62$var$disable();
    $e1dc708904eaae62$var$enabled = true;
    var id = 0;
    var displayId = 0;
    var rejections = {};
    $4SONH._B = function(promise) {
        if (promise._y === 2 && // IS REJECTED
        rejections[promise._E]) {
            if (rejections[promise._E].logged) onHandled(promise._E);
            else clearTimeout(rejections[promise._E].timeout);
            delete rejections[promise._E];
        }
    };
    $4SONH._C = function(promise, err) {
        if (promise._x === 0) {
            promise._E = id++;
            rejections[promise._E] = {
                displayId: null,
                error: err,
                timeout: setTimeout(onUnhandled.bind(null, promise._E), // For reference errors and type errors, this almost always
                // means the programmer made a mistake, so log them after just
                // 100ms
                // otherwise, wait 2 seconds to see if they get handled
                $e1dc708904eaae62$var$matchWhitelist(err, $e1dc708904eaae62$var$DEFAULT_WHITELIST) ? 100 : 2000),
                logged: false
            };
        }
    };
    function onUnhandled(id) {
        if (options.allRejections || $e1dc708904eaae62$var$matchWhitelist(rejections[id].error, options.whitelist || $e1dc708904eaae62$var$DEFAULT_WHITELIST)) {
            rejections[id].displayId = displayId++;
            if (options.onUnhandled) {
                rejections[id].logged = true;
                options.onUnhandled(rejections[id].displayId, rejections[id].error);
            } else {
                rejections[id].logged = true;
                $e1dc708904eaae62$var$logError(rejections[id].displayId, rejections[id].error);
            }
        }
    }
    function onHandled(id) {
        if (rejections[id].logged) {
            if (options.onHandled) options.onHandled(rejections[id].displayId, rejections[id].error);
            else if (!rejections[id].onUnhandled) {
                console.warn('Promise Rejection Handled (id: ' + rejections[id].displayId + '):');
                console.warn('  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' + rejections[id].displayId + '.');
            }
        }
    }
}
function $e1dc708904eaae62$var$logError(id, error) {
    console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
    var errStr = (error && (error.stack || error)) + '';
    errStr.split('\n').forEach(function(line) {
        console.warn('  ' + line);
    });
}
function $e1dc708904eaae62$var$matchWhitelist(error, list) {
    return list.some(function(cls) {
        return error instanceof cls;
    });
}

});
parcelRegister("4SONH", function(module, exports) {
'use strict';

var $jQpSo = parcelRequire("jQpSo");
function $38e39c80b5765669$var$noop() {}
// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable
// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.
// to avoid using try/catch inside critical functions, we
// extract them to here.
var $38e39c80b5765669$var$LAST_ERROR = null;
var $38e39c80b5765669$var$IS_ERROR = {};
function $38e39c80b5765669$var$getThen(obj) {
    try {
        return obj.then;
    } catch (ex) {
        $38e39c80b5765669$var$LAST_ERROR = ex;
        return $38e39c80b5765669$var$IS_ERROR;
    }
}
function $38e39c80b5765669$var$tryCallOne(fn, a) {
    try {
        return fn(a);
    } catch (ex) {
        $38e39c80b5765669$var$LAST_ERROR = ex;
        return $38e39c80b5765669$var$IS_ERROR;
    }
}
function $38e39c80b5765669$var$tryCallTwo(fn, a, b) {
    try {
        fn(a, b);
    } catch (ex) {
        $38e39c80b5765669$var$LAST_ERROR = ex;
        return $38e39c80b5765669$var$IS_ERROR;
    }
}
module.exports = $38e39c80b5765669$var$Promise;
function $38e39c80b5765669$var$Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('Promise constructor\'s argument is not a function');
    this._x = 0;
    this._y = 0;
    this._z = null;
    this._A = null;
    if (fn === $38e39c80b5765669$var$noop) return;
    $38e39c80b5765669$var$doResolve(fn, this);
}
$38e39c80b5765669$var$Promise._B = null;
$38e39c80b5765669$var$Promise._C = null;
$38e39c80b5765669$var$Promise._D = $38e39c80b5765669$var$noop;
$38e39c80b5765669$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    if (this.constructor !== $38e39c80b5765669$var$Promise) return $38e39c80b5765669$var$safeThen(this, onFulfilled, onRejected);
    var res = new $38e39c80b5765669$var$Promise($38e39c80b5765669$var$noop);
    $38e39c80b5765669$var$handle(this, new $38e39c80b5765669$var$Handler(onFulfilled, onRejected, res));
    return res;
};
function $38e39c80b5765669$var$safeThen(self, onFulfilled, onRejected) {
    return new self.constructor(function(resolve, reject) {
        var res = new $38e39c80b5765669$var$Promise($38e39c80b5765669$var$noop);
        res.then(resolve, reject);
        $38e39c80b5765669$var$handle(self, new $38e39c80b5765669$var$Handler(onFulfilled, onRejected, res));
    });
}
function $38e39c80b5765669$var$handle(self, deferred) {
    while(self._y === 3)self = self._z;
    if ($38e39c80b5765669$var$Promise._B) $38e39c80b5765669$var$Promise._B(self);
    if (self._y === 0) {
        if (self._x === 0) {
            self._x = 1;
            self._A = deferred;
            return;
        }
        if (self._x === 1) {
            self._x = 2;
            self._A = [
                self._A,
                deferred
            ];
            return;
        }
        self._A.push(deferred);
        return;
    }
    $38e39c80b5765669$var$handleResolved(self, deferred);
}
function $38e39c80b5765669$var$handleResolved(self, deferred) {
    $jQpSo(function() {
        var cb = self._y === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            if (self._y === 1) $38e39c80b5765669$var$resolve(deferred.promise, self._z);
            else $38e39c80b5765669$var$reject(deferred.promise, self._z);
            return;
        }
        var ret = $38e39c80b5765669$var$tryCallOne(cb, self._z);
        if (ret === $38e39c80b5765669$var$IS_ERROR) $38e39c80b5765669$var$reject(deferred.promise, $38e39c80b5765669$var$LAST_ERROR);
        else $38e39c80b5765669$var$resolve(deferred.promise, ret);
    });
}
function $38e39c80b5765669$var$resolve(self, newValue) {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self) return $38e39c80b5765669$var$reject(self, new TypeError('A promise cannot be resolved with itself.'));
    if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = $38e39c80b5765669$var$getThen(newValue);
        if (then === $38e39c80b5765669$var$IS_ERROR) return $38e39c80b5765669$var$reject(self, $38e39c80b5765669$var$LAST_ERROR);
        if (then === self.then && newValue instanceof $38e39c80b5765669$var$Promise) {
            self._y = 3;
            self._z = newValue;
            $38e39c80b5765669$var$finale(self);
            return;
        } else if (typeof then === 'function') {
            $38e39c80b5765669$var$doResolve(then.bind(newValue), self);
            return;
        }
    }
    self._y = 1;
    self._z = newValue;
    $38e39c80b5765669$var$finale(self);
}
function $38e39c80b5765669$var$reject(self, newValue) {
    self._y = 2;
    self._z = newValue;
    if ($38e39c80b5765669$var$Promise._C) $38e39c80b5765669$var$Promise._C(self, newValue);
    $38e39c80b5765669$var$finale(self);
}
function $38e39c80b5765669$var$finale(self) {
    if (self._x === 1) {
        $38e39c80b5765669$var$handle(self, self._A);
        self._A = null;
    }
    if (self._x === 2) {
        for(var i = 0; i < self._A.length; i++)$38e39c80b5765669$var$handle(self, self._A[i]);
        self._A = null;
    }
}
function $38e39c80b5765669$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $38e39c80b5765669$var$doResolve(fn, promise) {
    var done = false;
    var res = $38e39c80b5765669$var$tryCallTwo(fn, function(value) {
        if (done) return;
        done = true;
        $38e39c80b5765669$var$resolve(promise, value);
    }, function(reason) {
        if (done) return;
        done = true;
        $38e39c80b5765669$var$reject(promise, reason);
    });
    if (!done && res === $38e39c80b5765669$var$IS_ERROR) {
        done = true;
        $38e39c80b5765669$var$reject(promise, $38e39c80b5765669$var$LAST_ERROR);
    }
}

});
parcelRegister("jQpSo", function(module, exports) {
"use strict";
// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = $e726f225b7e4c6c6$var$rawAsap;
function $e726f225b7e4c6c6$var$rawAsap(task) {
    if (!$e726f225b7e4c6c6$var$queue.length) {
        $e726f225b7e4c6c6$var$requestFlush();
        $e726f225b7e4c6c6$var$flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    $e726f225b7e4c6c6$var$queue[$e726f225b7e4c6c6$var$queue.length] = task;
}
var $e726f225b7e4c6c6$var$queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var $e726f225b7e4c6c6$var$flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var $e726f225b7e4c6c6$var$requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var $e726f225b7e4c6c6$var$index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var $e726f225b7e4c6c6$var$capacity = 1024;
// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function $e726f225b7e4c6c6$var$flush() {
    while($e726f225b7e4c6c6$var$index < $e726f225b7e4c6c6$var$queue.length){
        var currentIndex = $e726f225b7e4c6c6$var$index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        $e726f225b7e4c6c6$var$index = $e726f225b7e4c6c6$var$index + 1;
        $e726f225b7e4c6c6$var$queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if ($e726f225b7e4c6c6$var$index > $e726f225b7e4c6c6$var$capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for(var scan = 0, newLength = $e726f225b7e4c6c6$var$queue.length - $e726f225b7e4c6c6$var$index; scan < newLength; scan++)$e726f225b7e4c6c6$var$queue[scan] = $e726f225b7e4c6c6$var$queue[scan + $e726f225b7e4c6c6$var$index];
            $e726f225b7e4c6c6$var$queue.length -= $e726f225b7e4c6c6$var$index;
            $e726f225b7e4c6c6$var$index = 0;
        }
    }
    $e726f225b7e4c6c6$var$queue.length = 0;
    $e726f225b7e4c6c6$var$index = 0;
    $e726f225b7e4c6c6$var$flushing = false;
}
// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ var $e726f225b7e4c6c6$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
var $e726f225b7e4c6c6$var$BrowserMutationObserver = $e726f225b7e4c6c6$var$scope.MutationObserver || $e726f225b7e4c6c6$var$scope.WebKitMutationObserver;
// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof $e726f225b7e4c6c6$var$BrowserMutationObserver === "function") $e726f225b7e4c6c6$var$requestFlush = $e726f225b7e4c6c6$var$makeRequestCallFromMutationObserver($e726f225b7e4c6c6$var$flush);
else $e726f225b7e4c6c6$var$requestFlush = $e726f225b7e4c6c6$var$makeRequestCallFromTimer($e726f225b7e4c6c6$var$flush);
// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
$e726f225b7e4c6c6$var$rawAsap.requestFlush = $e726f225b7e4c6c6$var$requestFlush;
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function $e726f225b7e4c6c6$var$makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new $e726f225b7e4c6c6$var$BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
function $e726f225b7e4c6c6$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
$e726f225b7e4c6c6$var$rawAsap.makeRequestCallFromTimer = $e726f225b7e4c6c6$var$makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

});



parcelRegister("b0WhD", function(module, exports) {
'use strict';

var $4SONH = parcelRequire("4SONH");
module.exports = $4SONH;
/* Static Functions */ var $804ce7adfc1784b1$var$TRUE = $804ce7adfc1784b1$var$valuePromise(true);
var $804ce7adfc1784b1$var$FALSE = $804ce7adfc1784b1$var$valuePromise(false);
var $804ce7adfc1784b1$var$NULL = $804ce7adfc1784b1$var$valuePromise(null);
var $804ce7adfc1784b1$var$UNDEFINED = $804ce7adfc1784b1$var$valuePromise(undefined);
var $804ce7adfc1784b1$var$ZERO = $804ce7adfc1784b1$var$valuePromise(0);
var $804ce7adfc1784b1$var$EMPTYSTRING = $804ce7adfc1784b1$var$valuePromise('');
function $804ce7adfc1784b1$var$valuePromise(value) {
    var p = new $4SONH($4SONH._D);
    p._y = 1;
    p._z = value;
    return p;
}
$4SONH.resolve = function(value) {
    if (value instanceof $4SONH) return value;
    if (value === null) return $804ce7adfc1784b1$var$NULL;
    if (value === undefined) return $804ce7adfc1784b1$var$UNDEFINED;
    if (value === true) return $804ce7adfc1784b1$var$TRUE;
    if (value === false) return $804ce7adfc1784b1$var$FALSE;
    if (value === 0) return $804ce7adfc1784b1$var$ZERO;
    if (value === '') return $804ce7adfc1784b1$var$EMPTYSTRING;
    if (typeof value === 'object' || typeof value === 'function') try {
        var then = value.then;
        if (typeof then === 'function') return new $4SONH(then.bind(value));
    } catch (ex) {
        return new $4SONH(function(resolve, reject) {
            reject(ex);
        });
    }
    return $804ce7adfc1784b1$var$valuePromise(value);
};
var $804ce7adfc1784b1$var$iterableToArray = function(iterable) {
    if (typeof Array.from === 'function') {
        // ES2015+, iterables exist
        $804ce7adfc1784b1$var$iterableToArray = Array.from;
        return Array.from(iterable);
    }
    // ES5, only arrays and array-likes exist
    $804ce7adfc1784b1$var$iterableToArray = function(x) {
        return Array.prototype.slice.call(x);
    };
    return Array.prototype.slice.call(iterable);
};
$4SONH.all = function(arr) {
    var args = $804ce7adfc1784b1$var$iterableToArray(arr);
    return new $4SONH(function(resolve, reject) {
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                if (val instanceof $4SONH && val.then === $4SONH.prototype.then) {
                    while(val._y === 3)val = val._z;
                    if (val._y === 1) return res(i, val._z);
                    if (val._y === 2) reject(val._z);
                    val.then(function(val) {
                        res(i, val);
                    }, reject);
                    return;
                } else {
                    var then = val.then;
                    if (typeof then === 'function') {
                        var p = new $4SONH(then.bind(val));
                        p.then(function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
            }
            args[i] = val;
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
function $804ce7adfc1784b1$var$onSettledFulfill(value) {
    return {
        status: 'fulfilled',
        value: value
    };
}
function $804ce7adfc1784b1$var$onSettledReject(reason) {
    return {
        status: 'rejected',
        reason: reason
    };
}
function $804ce7adfc1784b1$var$mapAllSettled(item) {
    if (item && (typeof item === 'object' || typeof item === 'function')) {
        if (item instanceof $4SONH && item.then === $4SONH.prototype.then) return item.then($804ce7adfc1784b1$var$onSettledFulfill, $804ce7adfc1784b1$var$onSettledReject);
        var then = item.then;
        if (typeof then === 'function') return new $4SONH(then.bind(item)).then($804ce7adfc1784b1$var$onSettledFulfill, $804ce7adfc1784b1$var$onSettledReject);
    }
    return $804ce7adfc1784b1$var$onSettledFulfill(item);
}
$4SONH.allSettled = function(iterable) {
    return $4SONH.all($804ce7adfc1784b1$var$iterableToArray(iterable).map($804ce7adfc1784b1$var$mapAllSettled));
};
$4SONH.reject = function(value) {
    return new $4SONH(function(resolve, reject) {
        reject(value);
    });
};
$4SONH.race = function(values) {
    return new $4SONH(function(resolve, reject) {
        $804ce7adfc1784b1$var$iterableToArray(values).forEach(function(value) {
            $4SONH.resolve(value).then(resolve, reject);
        });
    });
};
/* Prototype Methods */ $4SONH.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
function $804ce7adfc1784b1$var$getAggregateError(errors) {
    if (typeof AggregateError === 'function') return new AggregateError(errors, 'All promises were rejected');
    var error = new Error('All promises were rejected');
    error.name = 'AggregateError';
    error.errors = errors;
    return error;
}
$4SONH.any = function promiseAny(values) {
    return new $4SONH(function(resolve, reject) {
        var promises = $804ce7adfc1784b1$var$iterableToArray(values);
        var hasResolved = false;
        var rejectionReasons = [];
        function resolveOnce(value) {
            if (!hasResolved) {
                hasResolved = true;
                resolve(value);
            }
        }
        function rejectionCheck(reason) {
            rejectionReasons.push(reason);
            if (rejectionReasons.length === promises.length) reject($804ce7adfc1784b1$var$getAggregateError(rejectionReasons));
        }
        if (promises.length === 0) reject($804ce7adfc1784b1$var$getAggregateError(rejectionReasons));
        else promises.forEach(function(value) {
            $4SONH.resolve(value).then(resolveOnce, rejectionCheck);
        });
    });
};

});

parcelRegister("aZEZV", function(module, exports) {

$parcel$export(module.exports, "Headers", function () { return $800f672d0d31be6d$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $800f672d0d31be6d$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $800f672d0d31be6d$export$9f633d56d7ec90d3; });
$parcel$export(module.exports, "DOMException", function () { return $800f672d0d31be6d$export$fe58bcf938607f6a; });
$parcel$export(module.exports, "fetch", function () { return $800f672d0d31be6d$export$e7aa7bc5c1b3cfb3; });
/* eslint-disable no-prototype-builtins */ var $800f672d0d31be6d$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $800f672d0d31be6d$var$support = {
    searchParams: 'URLSearchParams' in $800f672d0d31be6d$var$g,
    iterable: 'Symbol' in $800f672d0d31be6d$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $800f672d0d31be6d$var$g && 'Blob' in $800f672d0d31be6d$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $800f672d0d31be6d$var$g,
    arrayBuffer: 'ArrayBuffer' in $800f672d0d31be6d$var$g
};
function $800f672d0d31be6d$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($800f672d0d31be6d$var$support.arrayBuffer) {
    var $800f672d0d31be6d$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $800f672d0d31be6d$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $800f672d0d31be6d$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $800f672d0d31be6d$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $800f672d0d31be6d$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $800f672d0d31be6d$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($800f672d0d31be6d$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $800f672d0d31be6d$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $800f672d0d31be6d$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $800f672d0d31be6d$var$normalizeName(name);
    value = $800f672d0d31be6d$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$800f672d0d31be6d$var$normalizeName(name)];
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $800f672d0d31be6d$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($800f672d0d31be6d$var$normalizeName(name));
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$800f672d0d31be6d$var$normalizeName(name)] = $800f672d0d31be6d$var$normalizeValue(value);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $800f672d0d31be6d$var$iteratorFor(items);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $800f672d0d31be6d$var$iteratorFor(items);
};
$800f672d0d31be6d$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $800f672d0d31be6d$var$iteratorFor(items);
};
if ($800f672d0d31be6d$var$support.iterable) $800f672d0d31be6d$export$79b704688b15c0f4.prototype[Symbol.iterator] = $800f672d0d31be6d$export$79b704688b15c0f4.prototype.entries;
function $800f672d0d31be6d$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $800f672d0d31be6d$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $800f672d0d31be6d$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $800f672d0d31be6d$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $800f672d0d31be6d$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $800f672d0d31be6d$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $800f672d0d31be6d$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $800f672d0d31be6d$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $800f672d0d31be6d$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($800f672d0d31be6d$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($800f672d0d31be6d$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($800f672d0d31be6d$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($800f672d0d31be6d$var$support.arrayBuffer && $800f672d0d31be6d$var$support.blob && $800f672d0d31be6d$var$isDataView(body)) {
            this._bodyArrayBuffer = $800f672d0d31be6d$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($800f672d0d31be6d$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $800f672d0d31be6d$var$isArrayBufferView(body))) this._bodyArrayBuffer = $800f672d0d31be6d$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($800f672d0d31be6d$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($800f672d0d31be6d$var$support.blob) this.blob = function() {
        var rejected = $800f672d0d31be6d$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $800f672d0d31be6d$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($800f672d0d31be6d$var$support.blob) return this.blob().then($800f672d0d31be6d$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $800f672d0d31be6d$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $800f672d0d31be6d$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($800f672d0d31be6d$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($800f672d0d31be6d$var$support.formData) this.formData = function() {
        return this.text().then($800f672d0d31be6d$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $800f672d0d31be6d$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $800f672d0d31be6d$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $800f672d0d31be6d$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $800f672d0d31be6d$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $800f672d0d31be6d$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $800f672d0d31be6d$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $800f672d0d31be6d$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $800f672d0d31be6d$export$79b704688b15c0f4(options.headers);
    this.method = $800f672d0d31be6d$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $800f672d0d31be6d$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$800f672d0d31be6d$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $800f672d0d31be6d$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $800f672d0d31be6d$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $800f672d0d31be6d$var$parseHeaders(rawHeaders) {
    var headers = new $800f672d0d31be6d$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$800f672d0d31be6d$var$Body.call($800f672d0d31be6d$export$7fa6c5b6f8193917.prototype);
function $800f672d0d31be6d$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $800f672d0d31be6d$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $800f672d0d31be6d$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$800f672d0d31be6d$var$Body.call($800f672d0d31be6d$export$9f633d56d7ec90d3.prototype);
$800f672d0d31be6d$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $800f672d0d31be6d$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $800f672d0d31be6d$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$800f672d0d31be6d$export$9f633d56d7ec90d3.error = function() {
    var response = new $800f672d0d31be6d$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $800f672d0d31be6d$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$800f672d0d31be6d$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($800f672d0d31be6d$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $800f672d0d31be6d$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $800f672d0d31be6d$export$fe58bcf938607f6a = $800f672d0d31be6d$var$g.DOMException;
try {
    new $800f672d0d31be6d$export$fe58bcf938607f6a();
} catch (err) {
    $800f672d0d31be6d$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $800f672d0d31be6d$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $800f672d0d31be6d$export$fe58bcf938607f6a.prototype.constructor = $800f672d0d31be6d$export$fe58bcf938607f6a;
}
function $800f672d0d31be6d$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $800f672d0d31be6d$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $800f672d0d31be6d$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $800f672d0d31be6d$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $800f672d0d31be6d$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $800f672d0d31be6d$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $800f672d0d31be6d$var$g.location.href ? $800f672d0d31be6d$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($800f672d0d31be6d$var$support.blob) xhr.responseType = 'blob';
            else if ($800f672d0d31be6d$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $800f672d0d31be6d$export$79b704688b15c0f4 || $800f672d0d31be6d$var$g.Headers && init.headers instanceof $800f672d0d31be6d$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($800f672d0d31be6d$var$normalizeName(name));
                xhr.setRequestHeader(name, $800f672d0d31be6d$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$800f672d0d31be6d$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$800f672d0d31be6d$var$g.fetch) {
    $800f672d0d31be6d$var$g.fetch = $800f672d0d31be6d$export$e7aa7bc5c1b3cfb3;
    $800f672d0d31be6d$var$g.Headers = $800f672d0d31be6d$export$79b704688b15c0f4;
    $800f672d0d31be6d$var$g.Request = $800f672d0d31be6d$export$7fa6c5b6f8193917;
    $800f672d0d31be6d$var$g.Response = $800f672d0d31be6d$export$9f633d56d7ec90d3;
}

});

parcelRegister("cbYl1", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $8e055102d0a4bcdc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8e055102d0a4bcdc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8e055102d0a4bcdc$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $8e055102d0a4bcdc$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $8e055102d0a4bcdc$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $8e055102d0a4bcdc$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $8e055102d0a4bcdc$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($8e055102d0a4bcdc$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($8e055102d0a4bcdc$var$getOwnPropertySymbols) {
            symbols = $8e055102d0a4bcdc$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($8e055102d0a4bcdc$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7h4ZC", function(module, exports) {
'use strict';

var $13EFV = parcelRequire("13EFV");
parcelRequire("B3Rmu");
parcelRequire("7H6Ip");
parcelRequire("dqfzw");
parcelRequire("1Uru5");
parcelRequire("3CVe2");
parcelRequire("5UszO");
parcelRequire("cxaIU");
parcelRequire("kIR3S");
parcelRequire("2u8TL");
parcelRequire("khlXA");
module.exports = $13EFV;

});
parcelRegister("13EFV", function(module, exports) {
'use strict';

var $kvQwq = parcelRequire("kvQwq");
parcelRequire("4AEWC");
parcelRequire("h3JRe");
parcelRequire("haEFx");
parcelRequire("lYc2Q");
module.exports = $kvQwq;

});
parcelRegister("kvQwq", function(module, exports) {
'use strict';

var $bTQWA = parcelRequire("bTQWA");
parcelRequire("3SQhX");
module.exports = $bTQWA;

});
parcelRegister("bTQWA", function(module, exports) {
'use strict';
parcelRequire("lyoXg");
parcelRequire("1aLfi");
parcelRequire("dkMmr");
parcelRequire("bGQI8");
parcelRequire("sd6Ri");
parcelRequire("2poLz");
parcelRequire("b49To");
parcelRequire("7EE6t");
parcelRequire("2kqse");
parcelRequire("39hva");
parcelRequire("5XA6M");
parcelRequire("1yBYS");
parcelRequire("6knIt");
parcelRequire("fkY1G");
parcelRequire("dFgdm");
parcelRequire("crz9y");
parcelRequire("6fJW1");
parcelRequire("kJNPM");
parcelRequire("cgXro");
parcelRequire("hsROu");

var $9AtxJ = parcelRequire("9AtxJ");
module.exports = $9AtxJ.Symbol;

});
parcelRegister("lyoXg", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $bAE3C = parcelRequire("bAE3C");

var $ay2cC = parcelRequire("ay2cC");

var $9OhmT = parcelRequire("9OhmT");

var $hicPf = parcelRequire("hicPf");

var $6HcaS = parcelRequire("6HcaS");

var $hjGLe = parcelRequire("hjGLe");

var $7F0dl = parcelRequire("7F0dl");

var $lRrDo = parcelRequire("lRrDo");

var $6Sqdy = parcelRequire("6Sqdy");

var $mgvTx = parcelRequire("mgvTx");

var $9FPXB = parcelRequire("9FPXB");
var $fb10217466c7da75$var$IS_CONCAT_SPREADABLE = $mgvTx('isConcatSpreadable');
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $fb10217466c7da75$var$IS_CONCAT_SPREADABLE_SUPPORT = $9FPXB >= 51 || !$bAE3C(function() {
    var array = [];
    array[$fb10217466c7da75$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $fb10217466c7da75$var$isConcatSpreadable = function(O) {
    if (!$9OhmT(O)) return false;
    var spreadable = O[$fb10217466c7da75$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $ay2cC(O);
};
var $fb10217466c7da75$var$FORCED = !$fb10217466c7da75$var$IS_CONCAT_SPREADABLE_SUPPORT || !$6Sqdy('concat');
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$1XSJh({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $fb10217466c7da75$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $hicPf(this);
        var A = $lRrDo(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($fb10217466c7da75$var$isConcatSpreadable(E)) {
                len = $6HcaS(E);
                $hjGLe(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $7F0dl(A, n, E[k]);
            } else {
                $hjGLe(n + 1);
                $7F0dl(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});

});
parcelRegister("1XSJh", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $kmjYa = parcelRequire("kmjYa");
var $16e5c14025897904$require$getOwnPropertyDescriptor = $kmjYa.f;

var $aPaKH = parcelRequire("aPaKH");

var $2t4Gp = parcelRequire("2t4Gp");

var $f3kK8 = parcelRequire("f3kK8");

var $fnTTa = parcelRequire("fnTTa");

var $bp1kS = parcelRequire("bp1kS");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $kvDzZ;
    else if (STATIC) target = $kvDzZ[TARGET] || $f3kK8(TARGET, {});
    else target = $kvDzZ[TARGET] && $kvDzZ[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $16e5c14025897904$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $bp1kS(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $fnTTa(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $aPaKH(sourceProperty, 'sham', true);
        $2t4Gp(target, key, sourceProperty, options);
    }
};

});
parcelRegister("kvDzZ", function(module, exports) {
'use strict';
var $eee5678a9ae0b7c5$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$eee5678a9ae0b7c5$var$check(typeof globalThis == 'object' && globalThis) || $eee5678a9ae0b7c5$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$eee5678a9ae0b7c5$var$check(typeof self == 'object' && self) || $eee5678a9ae0b7c5$var$check(typeof $parcel$global == 'object' && $parcel$global) || $eee5678a9ae0b7c5$var$check(typeof module.exports == 'object' && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

});

parcelRegister("kmjYa", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $ed255a3f44f06044$export$2d1720544b23b823; }, function (v) { return $ed255a3f44f06044$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $ed255a3f44f06044$export$2d1720544b23b823;
'use strict';

var $9100U = parcelRequire("9100U");

var $8lKVU = parcelRequire("8lKVU");

var $5luz1 = parcelRequire("5luz1");

var $3qjfQ = parcelRequire("3qjfQ");

var $4EWOr = parcelRequire("4EWOr");

var $eSWL8 = parcelRequire("eSWL8");

var $keZ2c = parcelRequire("keZ2c");

var $fydMg = parcelRequire("fydMg");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ed255a3f44f06044$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$ed255a3f44f06044$export$2d1720544b23b823 = $9100U ? $ed255a3f44f06044$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4EWOr(O);
    P = $eSWL8(P);
    if ($fydMg) try {
        return $ed255a3f44f06044$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($keZ2c(O, P)) return $3qjfQ(!$8lKVU($5luz1.f, O, P), O[P]);
};

});
parcelRegister("9100U", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$bAE3C(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});
parcelRegister("bAE3C", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRegister("8lKVU", function(module, exports) {
'use strict';

var $c3otN = parcelRequire("c3otN");
var $6144b0d3c69220c6$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = $c3otN ? $6144b0d3c69220c6$var$call.bind($6144b0d3c69220c6$var$call) : function() {
    return $6144b0d3c69220c6$var$call.apply($6144b0d3c69220c6$var$call, arguments);
};

});
parcelRegister("c3otN", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");
module.exports = !$bAE3C(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

});


parcelRegister("5luz1", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3e469f440f32c89f$export$2d1720544b23b823; }, function (v) { return $3e469f440f32c89f$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $3e469f440f32c89f$export$2d1720544b23b823;
'use strict';
var $3e469f440f32c89f$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3e469f440f32c89f$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $3e469f440f32c89f$var$NASHORN_BUG = $3e469f440f32c89f$var$getOwnPropertyDescriptor && !$3e469f440f32c89f$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$3e469f440f32c89f$export$2d1720544b23b823 = $3e469f440f32c89f$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $3e469f440f32c89f$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $3e469f440f32c89f$var$$propertyIsEnumerable;

});

parcelRegister("3qjfQ", function(module, exports) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("4EWOr", function(module, exports) {
'use strict';

var $8SixO = parcelRequire("8SixO");

var $388Wm = parcelRequire("388Wm");
module.exports = function(it) {
    return $8SixO($388Wm(it));
};

});
parcelRegister("8SixO", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $fcHE3 = parcelRequire("fcHE3");
var $6761c06983d4c679$var$$Object = Object;
var $6761c06983d4c679$var$split = $7n9WH(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $bAE3C(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$6761c06983d4c679$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $fcHE3(it) === 'String' ? $6761c06983d4c679$var$split(it, '') : $6761c06983d4c679$var$$Object(it);
} : $6761c06983d4c679$var$$Object;

});
parcelRegister("7n9WH", function(module, exports) {
'use strict';

var $c3otN = parcelRequire("c3otN");
var $55e2656d548a6fc1$var$FunctionPrototype = Function.prototype;
var $55e2656d548a6fc1$var$call = $55e2656d548a6fc1$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $55e2656d548a6fc1$var$uncurryThisWithBind = $c3otN && $55e2656d548a6fc1$var$FunctionPrototype.bind.bind($55e2656d548a6fc1$var$call, $55e2656d548a6fc1$var$call);
module.exports = $c3otN ? $55e2656d548a6fc1$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $55e2656d548a6fc1$var$call.apply(fn, arguments);
    };
};

});

parcelRegister("fcHE3", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
var $b119d503052534af$var$toString = $7n9WH({}.toString);
var $b119d503052534af$var$stringSlice = $7n9WH(''.slice);
module.exports = function(it) {
    return $b119d503052534af$var$stringSlice($b119d503052534af$var$toString(it), 8, -1);
};

});


parcelRegister("388Wm", function(module, exports) {
'use strict';

var $hKX7u = parcelRequire("hKX7u");
var $24790dcafb0ddc3d$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($hKX7u(it)) throw new $24790dcafb0ddc3d$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("hKX7u", function(module, exports) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRegister("eSWL8", function(module, exports) {
'use strict';

var $2W54u = parcelRequire("2W54u");

var $1Q1gI = parcelRequire("1Q1gI");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $2W54u(argument, 'string');
    return $1Q1gI(key) ? key : key + '';
};

});
parcelRegister("2W54u", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $9OhmT = parcelRequire("9OhmT");

var $1Q1gI = parcelRequire("1Q1gI");

var $eZ5qV = parcelRequire("eZ5qV");

var $5ghrU = parcelRequire("5ghrU");

var $mgvTx = parcelRequire("mgvTx");
var $2234eea1b9da0598$var$$TypeError = TypeError;
var $2234eea1b9da0598$var$TO_PRIMITIVE = $mgvTx('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$9OhmT(input) || $1Q1gI(input)) return input;
    var exoticToPrim = $eZ5qV(input, $2234eea1b9da0598$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $8lKVU(exoticToPrim, input, pref);
        if (!$9OhmT(result) || $1Q1gI(result)) return result;
        throw new $2234eea1b9da0598$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $5ghrU(input, pref);
};

});
parcelRegister("9OhmT", function(module, exports) {
'use strict';

var $1ZKCr = parcelRequire("1ZKCr");
module.exports = function(it) {
    return typeof it == 'object' ? it !== null : $1ZKCr(it);
};

});
parcelRegister("1ZKCr", function(module, exports) {
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $173fa684f12168d1$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $173fa684f12168d1$var$documentAll == 'undefined' && $173fa684f12168d1$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $173fa684f12168d1$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

});


parcelRegister("1Q1gI", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $1ZKCr = parcelRequire("1ZKCr");

var $7mAhs = parcelRequire("7mAhs");

var $iqMxs = parcelRequire("iqMxs");
var $156ba1b3b70e8441$var$$Object = Object;
module.exports = $iqMxs ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $4uwSa('Symbol');
    return $1ZKCr($Symbol) && $7mAhs($Symbol.prototype, $156ba1b3b70e8441$var$$Object(it));
};

});
parcelRegister("4uwSa", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $1ZKCr = parcelRequire("1ZKCr");
var $3453769bace2d3ce$var$aFunction = function(argument) {
    return $1ZKCr(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $3453769bace2d3ce$var$aFunction($kvDzZ[namespace]) : $kvDzZ[namespace] && $kvDzZ[namespace][method];
};

});

parcelRegister("7mAhs", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
module.exports = $7n9WH({}.isPrototypeOf);

});

parcelRegister("iqMxs", function(module, exports) {
'use strict';

var $iKqSh = parcelRequire("iKqSh");
module.exports = $iKqSh && !Symbol.sham && typeof Symbol.iterator == 'symbol';

});
parcelRegister("iKqSh", function(module, exports) {
'use strict';

var $9FPXB = parcelRequire("9FPXB");

var $bAE3C = parcelRequire("bAE3C");

var $kvDzZ = parcelRequire("kvDzZ");
var $da615e9761d472e5$var$$String = $kvDzZ.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$bAE3C(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$da615e9761d472e5$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $9FPXB && $9FPXB < 41;
});

});
parcelRegister("9FPXB", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $7J63U = parcelRequire("7J63U");
var $70b03fa5d903865b$var$process = $kvDzZ.process;
var $70b03fa5d903865b$var$Deno = $kvDzZ.Deno;
var $70b03fa5d903865b$var$versions = $70b03fa5d903865b$var$process && $70b03fa5d903865b$var$process.versions || $70b03fa5d903865b$var$Deno && $70b03fa5d903865b$var$Deno.version;
var $70b03fa5d903865b$var$v8 = $70b03fa5d903865b$var$versions && $70b03fa5d903865b$var$versions.v8;
var $70b03fa5d903865b$var$match, $70b03fa5d903865b$var$version;
if ($70b03fa5d903865b$var$v8) {
    $70b03fa5d903865b$var$match = $70b03fa5d903865b$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $70b03fa5d903865b$var$version = $70b03fa5d903865b$var$match[0] > 0 && $70b03fa5d903865b$var$match[0] < 4 ? 1 : +($70b03fa5d903865b$var$match[0] + $70b03fa5d903865b$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$70b03fa5d903865b$var$version && $7J63U) {
    $70b03fa5d903865b$var$match = $7J63U.match(/Edge\/(\d+)/);
    if (!$70b03fa5d903865b$var$match || $70b03fa5d903865b$var$match[1] >= 74) {
        $70b03fa5d903865b$var$match = $7J63U.match(/Chrome\/(\d+)/);
        if ($70b03fa5d903865b$var$match) $70b03fa5d903865b$var$version = +$70b03fa5d903865b$var$match[1];
    }
}
module.exports = $70b03fa5d903865b$var$version;

});
parcelRegister("7J63U", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");
var $5a0170289caee550$var$navigator = $kvDzZ.navigator;
var $5a0170289caee550$var$userAgent = $5a0170289caee550$var$navigator && $5a0170289caee550$var$navigator.userAgent;
module.exports = $5a0170289caee550$var$userAgent ? String($5a0170289caee550$var$userAgent) : '';

});





parcelRegister("eZ5qV", function(module, exports) {
'use strict';

var $g7x3l = parcelRequire("g7x3l");

var $hKX7u = parcelRequire("hKX7u");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $hKX7u(func) ? undefined : $g7x3l(func);
};

});
parcelRegister("g7x3l", function(module, exports) {
'use strict';

var $1ZKCr = parcelRequire("1ZKCr");

var $7MtCT = parcelRequire("7MtCT");
var $bbc6f070263d3c4f$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($1ZKCr(argument)) return argument;
    throw new $bbc6f070263d3c4f$var$$TypeError($7MtCT(argument) + ' is not a function');
};

});
parcelRegister("7MtCT", function(module, exports) {
'use strict';
var $5aa3ff46ee7d982f$var$$String = String;
module.exports = function(argument) {
    try {
        return $5aa3ff46ee7d982f$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};

});



parcelRegister("5ghrU", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $1ZKCr = parcelRequire("1ZKCr");

var $9OhmT = parcelRequire("9OhmT");
var $3d4bfb64fa47d8ec$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $1ZKCr(fn = input.toString) && !$9OhmT(val = $8lKVU(fn, input))) return val;
    if ($1ZKCr(fn = input.valueOf) && !$9OhmT(val = $8lKVU(fn, input))) return val;
    if (pref !== 'string' && $1ZKCr(fn = input.toString) && !$9OhmT(val = $8lKVU(fn, input))) return val;
    throw new $3d4bfb64fa47d8ec$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("mgvTx", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $cITHp = parcelRequire("cITHp");

var $keZ2c = parcelRequire("keZ2c");

var $66HFQ = parcelRequire("66HFQ");

var $iKqSh = parcelRequire("iKqSh");

var $iqMxs = parcelRequire("iqMxs");
var $042edd699f2e22e9$var$Symbol = $kvDzZ.Symbol;
var $042edd699f2e22e9$var$WellKnownSymbolsStore = $cITHp('wks');
var $042edd699f2e22e9$var$createWellKnownSymbol = $iqMxs ? $042edd699f2e22e9$var$Symbol['for'] || $042edd699f2e22e9$var$Symbol : $042edd699f2e22e9$var$Symbol && $042edd699f2e22e9$var$Symbol.withoutSetter || $66HFQ;
module.exports = function(name) {
    if (!$keZ2c($042edd699f2e22e9$var$WellKnownSymbolsStore, name)) $042edd699f2e22e9$var$WellKnownSymbolsStore[name] = $iKqSh && $keZ2c($042edd699f2e22e9$var$Symbol, name) ? $042edd699f2e22e9$var$Symbol[name] : $042edd699f2e22e9$var$createWellKnownSymbol('Symbol.' + name);
    return $042edd699f2e22e9$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("cITHp", function(module, exports) {
'use strict';

var $kMeiU = parcelRequire("kMeiU");
module.exports = function(key, value) {
    return $kMeiU[key] || ($kMeiU[key] = value || {});
};

});
parcelRegister("kMeiU", function(module, exports) {
'use strict';

var $axseE = parcelRequire("axseE");

var $kvDzZ = parcelRequire("kvDzZ");

var $f3kK8 = parcelRequire("f3kK8");
var $f20362d5610dcd3f$var$SHARED = '__core-js_shared__';
var $f20362d5610dcd3f$var$store = module.exports = $kvDzZ[$f20362d5610dcd3f$var$SHARED] || $f3kK8($f20362d5610dcd3f$var$SHARED, {});
($f20362d5610dcd3f$var$store.versions || ($f20362d5610dcd3f$var$store.versions = [])).push({
    version: '3.41.0',
    mode: $axseE ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

});
parcelRegister("axseE", function(module, exports) {
'use strict';
module.exports = false;

});

parcelRegister("f3kK8", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $af5739fbebe226ea$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $af5739fbebe226ea$var$defineProperty($kvDzZ, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $kvDzZ[key] = value;
    }
    return value;
};

});



parcelRegister("keZ2c", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $hicPf = parcelRequire("hicPf");
var $ebc4759d72c8a37d$var$hasOwnProperty = $7n9WH({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $ebc4759d72c8a37d$var$hasOwnProperty($hicPf(it), key);
};

});
parcelRegister("hicPf", function(module, exports) {
'use strict';

var $388Wm = parcelRequire("388Wm");
var $c96e110268acaa11$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $c96e110268acaa11$var$$Object($388Wm(argument));
};

});


parcelRegister("66HFQ", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
var $47252e586adc78d7$var$id = 0;
var $47252e586adc78d7$var$postfix = Math.random();
var $47252e586adc78d7$var$toString = $7n9WH(1.0.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $47252e586adc78d7$var$toString(++$47252e586adc78d7$var$id + $47252e586adc78d7$var$postfix, 36);
};

});




parcelRegister("fydMg", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $bAE3C = parcelRequire("bAE3C");

var $iJAYS = parcelRequire("iJAYS");
// Thanks to IE8 for its funny defineProperty
module.exports = !$9100U && !$bAE3C(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($iJAYS('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("iJAYS", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $9OhmT = parcelRequire("9OhmT");
var $da391d9ae46ed13b$var$document = $kvDzZ.document;
// typeof document.createElement is 'object' in old IE
var $da391d9ae46ed13b$var$EXISTS = $9OhmT($da391d9ae46ed13b$var$document) && $9OhmT($da391d9ae46ed13b$var$document.createElement);
module.exports = function(it) {
    return $da391d9ae46ed13b$var$EXISTS ? $da391d9ae46ed13b$var$document.createElement(it) : {};
};

});



parcelRegister("aPaKH", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $dsVjX = parcelRequire("dsVjX");

var $3qjfQ = parcelRequire("3qjfQ");
module.exports = $9100U ? function(object, key, value) {
    return $dsVjX.f(object, key, $3qjfQ(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("dsVjX", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $9cda5aa3742e4370$export$2d1720544b23b823; }, function (v) { return $9cda5aa3742e4370$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $9cda5aa3742e4370$export$2d1720544b23b823;
'use strict';

var $9100U = parcelRequire("9100U");

var $fydMg = parcelRequire("fydMg");

var $kev11 = parcelRequire("kev11");

var $4LaI4 = parcelRequire("4LaI4");

var $eSWL8 = parcelRequire("eSWL8");
var $9cda5aa3742e4370$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9cda5aa3742e4370$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9cda5aa3742e4370$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9cda5aa3742e4370$var$ENUMERABLE = 'enumerable';
var $9cda5aa3742e4370$var$CONFIGURABLE = 'configurable';
var $9cda5aa3742e4370$var$WRITABLE = 'writable';
$9cda5aa3742e4370$export$2d1720544b23b823 = $9100U ? $kev11 ? function defineProperty(O, P, Attributes) {
    $4LaI4(O);
    P = $eSWL8(P);
    $4LaI4(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $9cda5aa3742e4370$var$WRITABLE in Attributes && !Attributes[$9cda5aa3742e4370$var$WRITABLE]) {
        var current = $9cda5aa3742e4370$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$9cda5aa3742e4370$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $9cda5aa3742e4370$var$CONFIGURABLE in Attributes ? Attributes[$9cda5aa3742e4370$var$CONFIGURABLE] : current[$9cda5aa3742e4370$var$CONFIGURABLE],
                enumerable: $9cda5aa3742e4370$var$ENUMERABLE in Attributes ? Attributes[$9cda5aa3742e4370$var$ENUMERABLE] : current[$9cda5aa3742e4370$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $9cda5aa3742e4370$var$$defineProperty(O, P, Attributes);
} : $9cda5aa3742e4370$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $4LaI4(O);
    P = $eSWL8(P);
    $4LaI4(Attributes);
    if ($fydMg) try {
        return $9cda5aa3742e4370$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $9cda5aa3742e4370$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("kev11", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $bAE3C = parcelRequire("bAE3C");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $9100U && $bAE3C(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("4LaI4", function(module, exports) {
'use strict';

var $9OhmT = parcelRequire("9OhmT");
var $3773dbf118076332$var$$String = String;
var $3773dbf118076332$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($9OhmT(argument)) return argument;
    throw new $3773dbf118076332$var$$TypeError($3773dbf118076332$var$$String(argument) + ' is not an object');
};

});



parcelRegister("2t4Gp", function(module, exports) {
'use strict';

var $1ZKCr = parcelRequire("1ZKCr");

var $dsVjX = parcelRequire("dsVjX");

var $lQepi = parcelRequire("lQepi");

var $f3kK8 = parcelRequire("f3kK8");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($1ZKCr(value)) $lQepi(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f3kK8(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $dsVjX.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

});
parcelRegister("lQepi", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");

var $keZ2c = parcelRequire("keZ2c");

var $9100U = parcelRequire("9100U");

var $hCoZT = parcelRequire("hCoZT");
var $fe69a14049adb05c$require$CONFIGURABLE_FUNCTION_NAME = $hCoZT.CONFIGURABLE;

var $f8Jih = parcelRequire("f8Jih");

var $4eljv = parcelRequire("4eljv");
var $fe69a14049adb05c$var$enforceInternalState = $4eljv.enforce;
var $fe69a14049adb05c$var$getInternalState = $4eljv.get;
var $fe69a14049adb05c$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $fe69a14049adb05c$var$defineProperty = Object.defineProperty;
var $fe69a14049adb05c$var$stringSlice = $7n9WH(''.slice);
var $fe69a14049adb05c$var$replace = $7n9WH(''.replace);
var $fe69a14049adb05c$var$join = $7n9WH([].join);
var $fe69a14049adb05c$var$CONFIGURABLE_LENGTH = $9100U && !$bAE3C(function() {
    return $fe69a14049adb05c$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $fe69a14049adb05c$var$TEMPLATE = String(String).split('String');
var $fe69a14049adb05c$var$makeBuiltIn = module.exports = function(value, name, options) {
    if ($fe69a14049adb05c$var$stringSlice($fe69a14049adb05c$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $fe69a14049adb05c$var$replace($fe69a14049adb05c$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$keZ2c(value, 'name') || $fe69a14049adb05c$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($9100U) $fe69a14049adb05c$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($fe69a14049adb05c$var$CONFIGURABLE_LENGTH && options && $keZ2c(options, 'arity') && value.length !== options.arity) $fe69a14049adb05c$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $keZ2c(options, 'constructor') && options.constructor) {
            if ($9100U) $fe69a14049adb05c$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $fe69a14049adb05c$var$enforceInternalState(value);
    if (!$keZ2c(state, 'source')) state.source = $fe69a14049adb05c$var$join($fe69a14049adb05c$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $fe69a14049adb05c$var$makeBuiltIn(function toString() {
    return $1ZKCr(this) && $fe69a14049adb05c$var$getInternalState(this).source || $f8Jih(this);
}, 'toString');

});
parcelRegister("hCoZT", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $keZ2c = parcelRequire("keZ2c");
var $cd396032df90257d$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $cd396032df90257d$var$getDescriptor = $9100U && Object.getOwnPropertyDescriptor;
var $cd396032df90257d$var$EXISTS = $keZ2c($cd396032df90257d$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $cd396032df90257d$var$PROPER = $cd396032df90257d$var$EXISTS && (function something() {}).name === 'something';
var $cd396032df90257d$var$CONFIGURABLE = $cd396032df90257d$var$EXISTS && (!$9100U || $9100U && $cd396032df90257d$var$getDescriptor($cd396032df90257d$var$FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: $cd396032df90257d$var$EXISTS,
    PROPER: $cd396032df90257d$var$PROPER,
    CONFIGURABLE: $cd396032df90257d$var$CONFIGURABLE
};

});

parcelRegister("f8Jih", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $1ZKCr = parcelRequire("1ZKCr");

var $kMeiU = parcelRequire("kMeiU");
var $b05abcc5ed289bb0$var$functionToString = $7n9WH(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$1ZKCr($kMeiU.inspectSource)) $kMeiU.inspectSource = function(it) {
    return $b05abcc5ed289bb0$var$functionToString(it);
};
module.exports = $kMeiU.inspectSource;

});

parcelRegister("4eljv", function(module, exports) {
'use strict';

var $aPGru = parcelRequire("aPGru");

var $kvDzZ = parcelRequire("kvDzZ");

var $9OhmT = parcelRequire("9OhmT");

var $aPaKH = parcelRequire("aPaKH");

var $keZ2c = parcelRequire("keZ2c");

var $kMeiU = parcelRequire("kMeiU");

var $k3YZr = parcelRequire("k3YZr");

var $3pX3o = parcelRequire("3pX3o");
var $314900ac05bea597$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $314900ac05bea597$var$TypeError = $kvDzZ.TypeError;
var $314900ac05bea597$var$WeakMap = $kvDzZ.WeakMap;
var $314900ac05bea597$var$set, $314900ac05bea597$var$get, $314900ac05bea597$var$has;
var $314900ac05bea597$var$enforce = function(it) {
    return $314900ac05bea597$var$has(it) ? $314900ac05bea597$var$get(it) : $314900ac05bea597$var$set(it, {});
};
var $314900ac05bea597$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$9OhmT(it) || (state = $314900ac05bea597$var$get(it)).type !== TYPE) throw new $314900ac05bea597$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($aPGru || $kMeiU.state) {
    var $314900ac05bea597$var$store = $kMeiU.state || ($kMeiU.state = new $314900ac05bea597$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $314900ac05bea597$var$store.get = $314900ac05bea597$var$store.get;
    $314900ac05bea597$var$store.has = $314900ac05bea597$var$store.has;
    $314900ac05bea597$var$store.set = $314900ac05bea597$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $314900ac05bea597$var$set = function(it, metadata) {
        if ($314900ac05bea597$var$store.has(it)) throw new $314900ac05bea597$var$TypeError($314900ac05bea597$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $314900ac05bea597$var$store.set(it, metadata);
        return metadata;
    };
    $314900ac05bea597$var$get = function(it) {
        return $314900ac05bea597$var$store.get(it) || {};
    };
    $314900ac05bea597$var$has = function(it) {
        return $314900ac05bea597$var$store.has(it);
    };
} else {
    var $314900ac05bea597$var$STATE = $k3YZr('state');
    $3pX3o[$314900ac05bea597$var$STATE] = true;
    $314900ac05bea597$var$set = function(it, metadata) {
        if ($keZ2c(it, $314900ac05bea597$var$STATE)) throw new $314900ac05bea597$var$TypeError($314900ac05bea597$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $aPaKH(it, $314900ac05bea597$var$STATE, metadata);
        return metadata;
    };
    $314900ac05bea597$var$get = function(it) {
        return $keZ2c(it, $314900ac05bea597$var$STATE) ? it[$314900ac05bea597$var$STATE] : {};
    };
    $314900ac05bea597$var$has = function(it) {
        return $keZ2c(it, $314900ac05bea597$var$STATE);
    };
}
module.exports = {
    set: $314900ac05bea597$var$set,
    get: $314900ac05bea597$var$get,
    has: $314900ac05bea597$var$has,
    enforce: $314900ac05bea597$var$enforce,
    getterFor: $314900ac05bea597$var$getterFor
};

});
parcelRegister("aPGru", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $1ZKCr = parcelRequire("1ZKCr");
var $7e2f96f426172600$var$WeakMap = $kvDzZ.WeakMap;
module.exports = $1ZKCr($7e2f96f426172600$var$WeakMap) && /native code/.test(String($7e2f96f426172600$var$WeakMap));

});

parcelRegister("k3YZr", function(module, exports) {
'use strict';

var $cITHp = parcelRequire("cITHp");

var $66HFQ = parcelRequire("66HFQ");
var $e9b365cbb1a86635$var$keys = $cITHp('keys');
module.exports = function(key) {
    return $e9b365cbb1a86635$var$keys[key] || ($e9b365cbb1a86635$var$keys[key] = $66HFQ(key));
};

});

parcelRegister("3pX3o", function(module, exports) {
'use strict';
module.exports = {};

});




parcelRegister("fnTTa", function(module, exports) {
'use strict';

var $keZ2c = parcelRequire("keZ2c");

var $bDDtb = parcelRequire("bDDtb");

var $kmjYa = parcelRequire("kmjYa");

var $dsVjX = parcelRequire("dsVjX");
module.exports = function(target, source, exceptions) {
    var keys = $bDDtb(source);
    var defineProperty = $dsVjX.f;
    var getOwnPropertyDescriptor = $kmjYa.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$keZ2c(target, key) && !(exceptions && $keZ2c(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("bDDtb", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $7n9WH = parcelRequire("7n9WH");

var $3GY1P = parcelRequire("3GY1P");

var $8pg8R = parcelRequire("8pg8R");

var $4LaI4 = parcelRequire("4LaI4");
var $8791f41b6639efea$var$concat = $7n9WH([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $4uwSa('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $3GY1P.f($4LaI4(it));
    var getOwnPropertySymbols = $8pg8R.f;
    return getOwnPropertySymbols ? $8791f41b6639efea$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("3GY1P", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $2b03dbb9ef92e3eb$export$2d1720544b23b823; }, function (v) { return $2b03dbb9ef92e3eb$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $2b03dbb9ef92e3eb$export$2d1720544b23b823;
'use strict';

var $d4Vda = parcelRequire("d4Vda");

var $liuRV = parcelRequire("liuRV");
var $2b03dbb9ef92e3eb$var$hiddenKeys = $liuRV.concat('length', 'prototype');
$2b03dbb9ef92e3eb$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $d4Vda(O, $2b03dbb9ef92e3eb$var$hiddenKeys);
};

});
parcelRegister("d4Vda", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $keZ2c = parcelRequire("keZ2c");

var $4EWOr = parcelRequire("4EWOr");

var $5oIxL = parcelRequire("5oIxL");
var $9858070d1fe0c2ed$require$indexOf = $5oIxL.indexOf;

var $3pX3o = parcelRequire("3pX3o");
var $9858070d1fe0c2ed$var$push = $7n9WH([].push);
module.exports = function(object, names) {
    var O = $4EWOr(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$keZ2c($3pX3o, key) && $keZ2c(O, key) && $9858070d1fe0c2ed$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($keZ2c(O, key = names[i++])) ~$9858070d1fe0c2ed$require$indexOf(result, key) || $9858070d1fe0c2ed$var$push(result, key);
    return result;
};

});
parcelRegister("5oIxL", function(module, exports) {
'use strict';

var $4EWOr = parcelRequire("4EWOr");

var $ceQt9 = parcelRequire("ceQt9");

var $6HcaS = parcelRequire("6HcaS");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $3ee1bf137d85ab12$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4EWOr($this);
        var length = $6HcaS(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $ceQt9(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $3ee1bf137d85ab12$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $3ee1bf137d85ab12$var$createMethod(false)
};

});
parcelRegister("ceQt9", function(module, exports) {
'use strict';

var $hXJr0 = parcelRequire("hXJr0");
var $8e8f7e1cc4b76412$var$max = Math.max;
var $8e8f7e1cc4b76412$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $hXJr0(index);
    return integer < 0 ? $8e8f7e1cc4b76412$var$max(integer + length, 0) : $8e8f7e1cc4b76412$var$min(integer, length);
};

});
parcelRegister("hXJr0", function(module, exports) {
'use strict';

var $lTLHG = parcelRequire("lTLHG");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $lTLHG(number);
};

});
parcelRegister("lTLHG", function(module, exports) {
'use strict';
var $ff13bcf0f708f706$var$ceil = Math.ceil;
var $ff13bcf0f708f706$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $ff13bcf0f708f706$var$floor : $ff13bcf0f708f706$var$ceil)(n);
};

});



parcelRegister("6HcaS", function(module, exports) {
'use strict';

var $dgesD = parcelRequire("dgesD");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $dgesD(obj.length);
};

});
parcelRegister("dgesD", function(module, exports) {
'use strict';

var $hXJr0 = parcelRequire("hXJr0");
var $9a77fc96b6f7f2f8$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $hXJr0(argument);
    return len > 0 ? $9a77fc96b6f7f2f8$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});




parcelRegister("liuRV", function(module, exports) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

});


parcelRegister("8pg8R", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $61ed2dfe80a4e214$export$2d1720544b23b823; }, function (v) { return $61ed2dfe80a4e214$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $61ed2dfe80a4e214$export$2d1720544b23b823;
'use strict';
$61ed2dfe80a4e214$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("bp1kS", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");
var $84d310c49c1d3101$var$replacement = /#|\.prototype\./;
var $84d310c49c1d3101$var$isForced = function(feature, detection) {
    var value = $84d310c49c1d3101$var$data[$84d310c49c1d3101$var$normalize(feature)];
    return value === $84d310c49c1d3101$var$POLYFILL ? true : value === $84d310c49c1d3101$var$NATIVE ? false : $1ZKCr(detection) ? $bAE3C(detection) : !!detection;
};
var $84d310c49c1d3101$var$normalize = $84d310c49c1d3101$var$isForced.normalize = function(string) {
    return String(string).replace($84d310c49c1d3101$var$replacement, '.').toLowerCase();
};
var $84d310c49c1d3101$var$data = $84d310c49c1d3101$var$isForced.data = {};
var $84d310c49c1d3101$var$NATIVE = $84d310c49c1d3101$var$isForced.NATIVE = 'N';
var $84d310c49c1d3101$var$POLYFILL = $84d310c49c1d3101$var$isForced.POLYFILL = 'P';
module.exports = $84d310c49c1d3101$var$isForced;

});


parcelRegister("ay2cC", function(module, exports) {
'use strict';

var $fcHE3 = parcelRequire("fcHE3");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $fcHE3(argument) === 'Array';
};

});

parcelRegister("hjGLe", function(module, exports) {
'use strict';
var $c9b56166eaab6985$var$$TypeError = TypeError;
var $c9b56166eaab6985$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
module.exports = function(it) {
    if (it > $c9b56166eaab6985$var$MAX_SAFE_INTEGER) throw $c9b56166eaab6985$var$$TypeError('Maximum allowed index exceeded');
    return it;
};

});

parcelRegister("7F0dl", function(module, exports) {
'use strict';

var $9100U = parcelRequire("9100U");

var $dsVjX = parcelRequire("dsVjX");

var $3qjfQ = parcelRequire("3qjfQ");
module.exports = function(object, key, value) {
    if ($9100U) $dsVjX.f(object, key, $3qjfQ(0, value));
    else object[key] = value;
};

});

parcelRegister("lRrDo", function(module, exports) {
'use strict';

var $iQoKD = parcelRequire("iQoKD");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new ($iQoKD(originalArray))(length === 0 ? 0 : length);
};

});
parcelRegister("iQoKD", function(module, exports) {
'use strict';

var $ay2cC = parcelRequire("ay2cC");

var $cmnjY = parcelRequire("cmnjY");

var $9OhmT = parcelRequire("9OhmT");

var $mgvTx = parcelRequire("mgvTx");
var $db80486136c437f9$var$SPECIES = $mgvTx('species');
var $db80486136c437f9$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if ($ay2cC(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($cmnjY(C) && (C === $db80486136c437f9$var$$Array || $ay2cC(C.prototype))) C = undefined;
        else if ($9OhmT(C)) {
            C = C[$db80486136c437f9$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $db80486136c437f9$var$$Array : C;
};

});
parcelRegister("cmnjY", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");

var $401SB = parcelRequire("401SB");

var $4uwSa = parcelRequire("4uwSa");

var $f8Jih = parcelRequire("f8Jih");
var $8ff9a136cc5c5311$var$noop = function() {};
var $8ff9a136cc5c5311$var$construct = $4uwSa('Reflect', 'construct');
var $8ff9a136cc5c5311$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $8ff9a136cc5c5311$var$exec = $7n9WH($8ff9a136cc5c5311$var$constructorRegExp.exec);
var $8ff9a136cc5c5311$var$INCORRECT_TO_STRING = !$8ff9a136cc5c5311$var$constructorRegExp.test($8ff9a136cc5c5311$var$noop);
var $8ff9a136cc5c5311$var$isConstructorModern = function isConstructor(argument) {
    if (!$1ZKCr(argument)) return false;
    try {
        $8ff9a136cc5c5311$var$construct($8ff9a136cc5c5311$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $8ff9a136cc5c5311$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$1ZKCr(argument)) return false;
    switch($401SB(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $8ff9a136cc5c5311$var$INCORRECT_TO_STRING || !!$8ff9a136cc5c5311$var$exec($8ff9a136cc5c5311$var$constructorRegExp, $f8Jih(argument));
    } catch (error) {
        return true;
    }
};
$8ff9a136cc5c5311$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$8ff9a136cc5c5311$var$construct || $bAE3C(function() {
    var called;
    return $8ff9a136cc5c5311$var$isConstructorModern($8ff9a136cc5c5311$var$isConstructorModern.call) || !$8ff9a136cc5c5311$var$isConstructorModern(Object) || !$8ff9a136cc5c5311$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $8ff9a136cc5c5311$var$isConstructorLegacy : $8ff9a136cc5c5311$var$isConstructorModern;

});
parcelRegister("401SB", function(module, exports) {
'use strict';

var $cSemj = parcelRequire("cSemj");

var $1ZKCr = parcelRequire("1ZKCr");

var $fcHE3 = parcelRequire("fcHE3");

var $mgvTx = parcelRequire("mgvTx");
var $2e989ec6822b6221$var$TO_STRING_TAG = $mgvTx('toStringTag');
var $2e989ec6822b6221$var$$Object = Object;
// ES3 wrong here
var $2e989ec6822b6221$var$CORRECT_ARGUMENTS = $fcHE3(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $2e989ec6822b6221$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $cSemj ? $fcHE3 : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $2e989ec6822b6221$var$tryGet(O = $2e989ec6822b6221$var$$Object(it), $2e989ec6822b6221$var$TO_STRING_TAG)) == 'string' ? tag : $2e989ec6822b6221$var$CORRECT_ARGUMENTS ? $fcHE3(O) : (result = $fcHE3(O)) === 'Object' && $1ZKCr(O.callee) ? 'Arguments' : result;
};

});
parcelRegister("cSemj", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");
var $95f5aa8bc1490bf8$var$TO_STRING_TAG = $mgvTx('toStringTag');
var $95f5aa8bc1490bf8$var$test = {};
$95f5aa8bc1490bf8$var$test[$95f5aa8bc1490bf8$var$TO_STRING_TAG] = 'z';
module.exports = String($95f5aa8bc1490bf8$var$test) === '[object z]';

});





parcelRegister("6Sqdy", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $mgvTx = parcelRequire("mgvTx");

var $9FPXB = parcelRequire("9FPXB");
var $501c1f84d7c8fa90$var$SPECIES = $mgvTx('species');
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $9FPXB >= 51 || !$bAE3C(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$501c1f84d7c8fa90$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

});


parcelRegister("1aLfi", function(module, exports) {
'use strict';

var $cSemj = parcelRequire("cSemj");

var $2t4Gp = parcelRequire("2t4Gp");

var $gMVfE = parcelRequire("gMVfE");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$cSemj) $2t4Gp(Object.prototype, 'toString', $gMVfE, {
    unsafe: true
});

});
parcelRegister("gMVfE", function(module, exports) {
'use strict';

var $cSemj = parcelRequire("cSemj");

var $401SB = parcelRequire("401SB");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $cSemj ? ({}).toString : function toString() {
    return '[object ' + $401SB(this) + ']';
};

});


parcelRegister("dkMmr", function(module, exports) {
'use strict';
parcelRequire("6F7XI");
parcelRequire("95iEZ");
parcelRequire("69KBB");
parcelRequire("1VW2X");
parcelRequire("jtDp7");

});
parcelRegister("6F7XI", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $kvDzZ = parcelRequire("kvDzZ");

var $8lKVU = parcelRequire("8lKVU");

var $7n9WH = parcelRequire("7n9WH");

var $axseE = parcelRequire("axseE");

var $9100U = parcelRequire("9100U");

var $iKqSh = parcelRequire("iKqSh");

var $bAE3C = parcelRequire("bAE3C");

var $keZ2c = parcelRequire("keZ2c");

var $7mAhs = parcelRequire("7mAhs");

var $4LaI4 = parcelRequire("4LaI4");

var $4EWOr = parcelRequire("4EWOr");

var $eSWL8 = parcelRequire("eSWL8");

var $1H3Lz = parcelRequire("1H3Lz");

var $3qjfQ = parcelRequire("3qjfQ");

var $emiQA = parcelRequire("emiQA");

var $1Eis3 = parcelRequire("1Eis3");

var $3GY1P = parcelRequire("3GY1P");

var $yJ9RD = parcelRequire("yJ9RD");

var $8pg8R = parcelRequire("8pg8R");

var $kmjYa = parcelRequire("kmjYa");

var $dsVjX = parcelRequire("dsVjX");

var $7fIoH = parcelRequire("7fIoH");

var $5luz1 = parcelRequire("5luz1");

var $2t4Gp = parcelRequire("2t4Gp");

var $4GKxk = parcelRequire("4GKxk");

var $cITHp = parcelRequire("cITHp");

var $k3YZr = parcelRequire("k3YZr");

var $3pX3o = parcelRequire("3pX3o");

var $66HFQ = parcelRequire("66HFQ");

var $mgvTx = parcelRequire("mgvTx");

var $gsYcM = parcelRequire("gsYcM");

var $18GwD = parcelRequire("18GwD");

var $3ppV5 = parcelRequire("3ppV5");

var $2Zevq = parcelRequire("2Zevq");

var $4eljv = parcelRequire("4eljv");

var $aqTg6 = parcelRequire("aqTg6");
var $4d9cbf85e18833d5$require$$forEach = $aqTg6.forEach;
var $4d9cbf85e18833d5$var$HIDDEN = $k3YZr('hidden');
var $4d9cbf85e18833d5$var$SYMBOL = 'Symbol';
var $4d9cbf85e18833d5$var$PROTOTYPE = 'prototype';
var $4d9cbf85e18833d5$var$setInternalState = $4eljv.set;
var $4d9cbf85e18833d5$var$getInternalState = $4eljv.getterFor($4d9cbf85e18833d5$var$SYMBOL);
var $4d9cbf85e18833d5$var$ObjectPrototype = Object[$4d9cbf85e18833d5$var$PROTOTYPE];
var $4d9cbf85e18833d5$var$$Symbol = $kvDzZ.Symbol;
var $4d9cbf85e18833d5$var$SymbolPrototype = $4d9cbf85e18833d5$var$$Symbol && $4d9cbf85e18833d5$var$$Symbol[$4d9cbf85e18833d5$var$PROTOTYPE];
var $4d9cbf85e18833d5$var$RangeError = $kvDzZ.RangeError;
var $4d9cbf85e18833d5$var$TypeError = $kvDzZ.TypeError;
var $4d9cbf85e18833d5$var$QObject = $kvDzZ.QObject;
var $4d9cbf85e18833d5$var$nativeGetOwnPropertyDescriptor = $kmjYa.f;
var $4d9cbf85e18833d5$var$nativeDefineProperty = $dsVjX.f;
var $4d9cbf85e18833d5$var$nativeGetOwnPropertyNames = $yJ9RD.f;
var $4d9cbf85e18833d5$var$nativePropertyIsEnumerable = $5luz1.f;
var $4d9cbf85e18833d5$var$push = $7n9WH([].push);
var $4d9cbf85e18833d5$var$AllSymbols = $cITHp('symbols');
var $4d9cbf85e18833d5$var$ObjectPrototypeSymbols = $cITHp('op-symbols');
var $4d9cbf85e18833d5$var$WellKnownSymbolsStore = $cITHp('wks');
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $4d9cbf85e18833d5$var$USE_SETTER = !$4d9cbf85e18833d5$var$QObject || !$4d9cbf85e18833d5$var$QObject[$4d9cbf85e18833d5$var$PROTOTYPE] || !$4d9cbf85e18833d5$var$QObject[$4d9cbf85e18833d5$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $4d9cbf85e18833d5$var$fallbackDefineProperty = function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $4d9cbf85e18833d5$var$nativeGetOwnPropertyDescriptor($4d9cbf85e18833d5$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $4d9cbf85e18833d5$var$ObjectPrototype[P];
    $4d9cbf85e18833d5$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $4d9cbf85e18833d5$var$ObjectPrototype) $4d9cbf85e18833d5$var$nativeDefineProperty($4d9cbf85e18833d5$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
};
var $4d9cbf85e18833d5$var$setSymbolDescriptor = $9100U && $bAE3C(function() {
    return $emiQA($4d9cbf85e18833d5$var$nativeDefineProperty({}, 'a', {
        get: function() {
            return $4d9cbf85e18833d5$var$nativeDefineProperty(this, 'a', {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $4d9cbf85e18833d5$var$fallbackDefineProperty : $4d9cbf85e18833d5$var$nativeDefineProperty;
var $4d9cbf85e18833d5$var$wrap = function(tag, description) {
    var symbol = $4d9cbf85e18833d5$var$AllSymbols[tag] = $emiQA($4d9cbf85e18833d5$var$SymbolPrototype);
    $4d9cbf85e18833d5$var$setInternalState(symbol, {
        type: $4d9cbf85e18833d5$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$9100U) symbol.description = description;
    return symbol;
};
var $4d9cbf85e18833d5$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $4d9cbf85e18833d5$var$ObjectPrototype) $4d9cbf85e18833d5$var$$defineProperty($4d9cbf85e18833d5$var$ObjectPrototypeSymbols, P, Attributes);
    $4LaI4(O);
    var key = $eSWL8(P);
    $4LaI4(Attributes);
    if ($keZ2c($4d9cbf85e18833d5$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$keZ2c(O, $4d9cbf85e18833d5$var$HIDDEN)) $4d9cbf85e18833d5$var$nativeDefineProperty(O, $4d9cbf85e18833d5$var$HIDDEN, $3qjfQ(1, $emiQA(null)));
            O[$4d9cbf85e18833d5$var$HIDDEN][key] = true;
        } else {
            if ($keZ2c(O, $4d9cbf85e18833d5$var$HIDDEN) && O[$4d9cbf85e18833d5$var$HIDDEN][key]) O[$4d9cbf85e18833d5$var$HIDDEN][key] = false;
            Attributes = $emiQA(Attributes, {
                enumerable: $3qjfQ(0, false)
            });
        }
        return $4d9cbf85e18833d5$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $4d9cbf85e18833d5$var$nativeDefineProperty(O, key, Attributes);
};
var $4d9cbf85e18833d5$var$$defineProperties = function defineProperties(O, Properties) {
    $4LaI4(O);
    var properties = $4EWOr(Properties);
    var keys = $1Eis3(properties).concat($4d9cbf85e18833d5$var$$getOwnPropertySymbols(properties));
    $4d9cbf85e18833d5$require$$forEach(keys, function(key) {
        if (!$9100U || $8lKVU($4d9cbf85e18833d5$var$$propertyIsEnumerable, properties, key)) $4d9cbf85e18833d5$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $4d9cbf85e18833d5$var$$create = function create(O, Properties) {
    return Properties === undefined ? $emiQA(O) : $4d9cbf85e18833d5$var$$defineProperties($emiQA(O), Properties);
};
var $4d9cbf85e18833d5$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $eSWL8(V);
    var enumerable = $8lKVU($4d9cbf85e18833d5$var$nativePropertyIsEnumerable, this, P);
    if (this === $4d9cbf85e18833d5$var$ObjectPrototype && $keZ2c($4d9cbf85e18833d5$var$AllSymbols, P) && !$keZ2c($4d9cbf85e18833d5$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$keZ2c(this, P) || !$keZ2c($4d9cbf85e18833d5$var$AllSymbols, P) || $keZ2c(this, $4d9cbf85e18833d5$var$HIDDEN) && this[$4d9cbf85e18833d5$var$HIDDEN][P] ? enumerable : true;
};
var $4d9cbf85e18833d5$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $4EWOr(O);
    var key = $eSWL8(P);
    if (it === $4d9cbf85e18833d5$var$ObjectPrototype && $keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && !$keZ2c($4d9cbf85e18833d5$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $4d9cbf85e18833d5$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && !($keZ2c(it, $4d9cbf85e18833d5$var$HIDDEN) && it[$4d9cbf85e18833d5$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $4d9cbf85e18833d5$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $4d9cbf85e18833d5$var$nativeGetOwnPropertyNames($4EWOr(O));
    var result = [];
    $4d9cbf85e18833d5$require$$forEach(names, function(key) {
        if (!$keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && !$keZ2c($3pX3o, key)) $4d9cbf85e18833d5$var$push(result, key);
    });
    return result;
};
var $4d9cbf85e18833d5$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $4d9cbf85e18833d5$var$ObjectPrototype;
    var names = $4d9cbf85e18833d5$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $4d9cbf85e18833d5$var$ObjectPrototypeSymbols : $4EWOr(O));
    var result = [];
    $4d9cbf85e18833d5$require$$forEach(names, function(key) {
        if ($keZ2c($4d9cbf85e18833d5$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $keZ2c($4d9cbf85e18833d5$var$ObjectPrototype, key))) $4d9cbf85e18833d5$var$push(result, $4d9cbf85e18833d5$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$iKqSh) {
    $4d9cbf85e18833d5$var$$Symbol = function Symbol() {
        if ($7mAhs($4d9cbf85e18833d5$var$SymbolPrototype, this)) throw new $4d9cbf85e18833d5$var$TypeError('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : $1H3Lz(arguments[0]);
        var tag = $66HFQ(description);
        var setter = function(value) {
            var $this = this === undefined ? $kvDzZ : this;
            if ($this === $4d9cbf85e18833d5$var$ObjectPrototype) $8lKVU(setter, $4d9cbf85e18833d5$var$ObjectPrototypeSymbols, value);
            if ($keZ2c($this, $4d9cbf85e18833d5$var$HIDDEN) && $keZ2c($this[$4d9cbf85e18833d5$var$HIDDEN], tag)) $this[$4d9cbf85e18833d5$var$HIDDEN][tag] = false;
            var descriptor = $3qjfQ(1, value);
            try {
                $4d9cbf85e18833d5$var$setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $4d9cbf85e18833d5$var$RangeError)) throw error;
                $4d9cbf85e18833d5$var$fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if ($9100U && $4d9cbf85e18833d5$var$USE_SETTER) $4d9cbf85e18833d5$var$setSymbolDescriptor($4d9cbf85e18833d5$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $4d9cbf85e18833d5$var$wrap(tag, description);
    };
    $4d9cbf85e18833d5$var$SymbolPrototype = $4d9cbf85e18833d5$var$$Symbol[$4d9cbf85e18833d5$var$PROTOTYPE];
    $2t4Gp($4d9cbf85e18833d5$var$SymbolPrototype, 'toString', function toString() {
        return $4d9cbf85e18833d5$var$getInternalState(this).tag;
    });
    $2t4Gp($4d9cbf85e18833d5$var$$Symbol, 'withoutSetter', function(description) {
        return $4d9cbf85e18833d5$var$wrap($66HFQ(description), description);
    });
    $5luz1.f = $4d9cbf85e18833d5$var$$propertyIsEnumerable;
    $dsVjX.f = $4d9cbf85e18833d5$var$$defineProperty;
    $7fIoH.f = $4d9cbf85e18833d5$var$$defineProperties;
    $kmjYa.f = $4d9cbf85e18833d5$var$$getOwnPropertyDescriptor;
    $3GY1P.f = $yJ9RD.f = $4d9cbf85e18833d5$var$$getOwnPropertyNames;
    $8pg8R.f = $4d9cbf85e18833d5$var$$getOwnPropertySymbols;
    $gsYcM.f = function(name) {
        return $4d9cbf85e18833d5$var$wrap($mgvTx(name), name);
    };
    if ($9100U) {
        // https://github.com/tc39/proposal-Symbol-description
        $4GKxk($4d9cbf85e18833d5$var$SymbolPrototype, 'description', {
            configurable: true,
            get: function description() {
                return $4d9cbf85e18833d5$var$getInternalState(this).description;
            }
        });
        if (!$axseE) $2t4Gp($4d9cbf85e18833d5$var$ObjectPrototype, 'propertyIsEnumerable', $4d9cbf85e18833d5$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$1XSJh({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$iKqSh,
    sham: !$iKqSh
}, {
    Symbol: $4d9cbf85e18833d5$var$$Symbol
});
$4d9cbf85e18833d5$require$$forEach($1Eis3($4d9cbf85e18833d5$var$WellKnownSymbolsStore), function(name) {
    $18GwD(name);
});
$1XSJh({
    target: $4d9cbf85e18833d5$var$SYMBOL,
    stat: true,
    forced: !$iKqSh
}, {
    useSetter: function() {
        $4d9cbf85e18833d5$var$USE_SETTER = true;
    },
    useSimple: function() {
        $4d9cbf85e18833d5$var$USE_SETTER = false;
    }
});
$1XSJh({
    target: 'Object',
    stat: true,
    forced: !$iKqSh,
    sham: !$9100U
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $4d9cbf85e18833d5$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $4d9cbf85e18833d5$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $4d9cbf85e18833d5$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $4d9cbf85e18833d5$var$$getOwnPropertyDescriptor
});
$1XSJh({
    target: 'Object',
    stat: true,
    forced: !$iKqSh
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $4d9cbf85e18833d5$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$3ppV5();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$2Zevq($4d9cbf85e18833d5$var$$Symbol, $4d9cbf85e18833d5$var$SYMBOL);
$3pX3o[$4d9cbf85e18833d5$var$HIDDEN] = true;

});
parcelRegister("1H3Lz", function(module, exports) {
'use strict';

var $401SB = parcelRequire("401SB");
var $13bcba7ed5bb5bd6$var$$String = String;
module.exports = function(argument) {
    if ($401SB(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $13bcba7ed5bb5bd6$var$$String(argument);
};

});

parcelRegister("emiQA", function(module, exports) {
'use strict';

var $4LaI4 = parcelRequire("4LaI4");

var $7fIoH = parcelRequire("7fIoH");

var $liuRV = parcelRequire("liuRV");

var $3pX3o = parcelRequire("3pX3o");

var $22Vf9 = parcelRequire("22Vf9");

var $iJAYS = parcelRequire("iJAYS");

var $k3YZr = parcelRequire("k3YZr");
var $a741bd69fc0f1bc8$var$GT = '>';
var $a741bd69fc0f1bc8$var$LT = '<';
var $a741bd69fc0f1bc8$var$PROTOTYPE = 'prototype';
var $a741bd69fc0f1bc8$var$SCRIPT = 'script';
var $a741bd69fc0f1bc8$var$IE_PROTO = $k3YZr('IE_PROTO');
var $a741bd69fc0f1bc8$var$EmptyConstructor = function() {};
var $a741bd69fc0f1bc8$var$scriptTag = function(content) {
    return $a741bd69fc0f1bc8$var$LT + $a741bd69fc0f1bc8$var$SCRIPT + $a741bd69fc0f1bc8$var$GT + content + $a741bd69fc0f1bc8$var$LT + '/' + $a741bd69fc0f1bc8$var$SCRIPT + $a741bd69fc0f1bc8$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $a741bd69fc0f1bc8$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($a741bd69fc0f1bc8$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $a741bd69fc0f1bc8$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $iJAYS('iframe');
    var JS = 'java' + $a741bd69fc0f1bc8$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $22Vf9.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($a741bd69fc0f1bc8$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $a741bd69fc0f1bc8$var$activeXDocument;
var $a741bd69fc0f1bc8$var$NullProtoObject = function() {
    try {
        $a741bd69fc0f1bc8$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $a741bd69fc0f1bc8$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $a741bd69fc0f1bc8$var$activeXDocument ? $a741bd69fc0f1bc8$var$NullProtoObjectViaActiveX($a741bd69fc0f1bc8$var$activeXDocument) // old IE
     : $a741bd69fc0f1bc8$var$NullProtoObjectViaIFrame() : $a741bd69fc0f1bc8$var$NullProtoObjectViaActiveX($a741bd69fc0f1bc8$var$activeXDocument); // WSH
    var length = $liuRV.length;
    while(length--)delete $a741bd69fc0f1bc8$var$NullProtoObject[$a741bd69fc0f1bc8$var$PROTOTYPE][$liuRV[length]];
    return $a741bd69fc0f1bc8$var$NullProtoObject();
};
$3pX3o[$a741bd69fc0f1bc8$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $a741bd69fc0f1bc8$var$EmptyConstructor[$a741bd69fc0f1bc8$var$PROTOTYPE] = $4LaI4(O);
        result = new $a741bd69fc0f1bc8$var$EmptyConstructor();
        $a741bd69fc0f1bc8$var$EmptyConstructor[$a741bd69fc0f1bc8$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$a741bd69fc0f1bc8$var$IE_PROTO] = O;
    } else result = $a741bd69fc0f1bc8$var$NullProtoObject();
    return Properties === undefined ? result : $7fIoH.f(result, Properties);
};

});
parcelRegister("7fIoH", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $547c5f86a946d88a$export$2d1720544b23b823; }, function (v) { return $547c5f86a946d88a$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $547c5f86a946d88a$export$2d1720544b23b823;
'use strict';

var $9100U = parcelRequire("9100U");

var $kev11 = parcelRequire("kev11");

var $dsVjX = parcelRequire("dsVjX");

var $4LaI4 = parcelRequire("4LaI4");

var $4EWOr = parcelRequire("4EWOr");

var $1Eis3 = parcelRequire("1Eis3");
$547c5f86a946d88a$export$2d1720544b23b823 = $9100U && !$kev11 ? Object.defineProperties : function defineProperties(O, Properties) {
    $4LaI4(O);
    var props = $4EWOr(Properties);
    var keys = $1Eis3(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$dsVjX.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("1Eis3", function(module, exports) {
'use strict';

var $d4Vda = parcelRequire("d4Vda");

var $liuRV = parcelRequire("liuRV");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $d4Vda(O, $liuRV);
};

});


parcelRegister("22Vf9", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");
module.exports = $4uwSa('document', 'documentElement');

});


parcelRegister("yJ9RD", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $0686348c533e1b6d$export$2d1720544b23b823; }, function (v) { return $0686348c533e1b6d$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $0686348c533e1b6d$export$2d1720544b23b823;
'use strict';

var $fcHE3 = parcelRequire("fcHE3");

var $4EWOr = parcelRequire("4EWOr");

var $3GY1P = parcelRequire("3GY1P");
var $0686348c533e1b6d$require$$getOwnPropertyNames = $3GY1P.f;

var $lKumW = parcelRequire("lKumW");
var $0686348c533e1b6d$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $0686348c533e1b6d$var$getWindowNames = function(it) {
    try {
        return $0686348c533e1b6d$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $lKumW($0686348c533e1b6d$var$windowNames);
    }
};
$0686348c533e1b6d$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $0686348c533e1b6d$var$windowNames && $fcHE3(it) === 'Window' ? $0686348c533e1b6d$var$getWindowNames(it) : $0686348c533e1b6d$require$$getOwnPropertyNames($4EWOr(it));
};

});
parcelRegister("lKumW", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");
module.exports = $7n9WH([].slice);

});


parcelRegister("4GKxk", function(module, exports) {
'use strict';

var $lQepi = parcelRequire("lQepi");

var $dsVjX = parcelRequire("dsVjX");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) $lQepi(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $lQepi(descriptor.set, name, {
        setter: true
    });
    return $dsVjX.f(target, name, descriptor);
};

});

parcelRegister("gsYcM", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $bfcdf65efd683741$export$2d1720544b23b823; }, function (v) { return $bfcdf65efd683741$export$2d1720544b23b823 = v; });
var $bfcdf65efd683741$export$2d1720544b23b823;
'use strict';

var $mgvTx = parcelRequire("mgvTx");
$bfcdf65efd683741$export$2d1720544b23b823 = $mgvTx;

});

parcelRegister("18GwD", function(module, exports) {
'use strict';

var $9AtxJ = parcelRequire("9AtxJ");

var $keZ2c = parcelRequire("keZ2c");

var $gsYcM = parcelRequire("gsYcM");

var $dsVjX = parcelRequire("dsVjX");
var $0d47867294a46a70$require$defineProperty = $dsVjX.f;
module.exports = function(NAME) {
    var Symbol = $9AtxJ.Symbol || ($9AtxJ.Symbol = {});
    if (!$keZ2c(Symbol, NAME)) $0d47867294a46a70$require$defineProperty(Symbol, NAME, {
        value: $gsYcM.f(NAME)
    });
};

});
parcelRegister("9AtxJ", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");
module.exports = $kvDzZ;

});


parcelRegister("3ppV5", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $4uwSa = parcelRequire("4uwSa");

var $mgvTx = parcelRequire("mgvTx");

var $2t4Gp = parcelRequire("2t4Gp");
module.exports = function() {
    var Symbol = $4uwSa('Symbol');
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $mgvTx('toPrimitive');
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $2t4Gp(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $8lKVU(valueOf, this);
    }, {
        arity: 1
    });
};

});

parcelRegister("2Zevq", function(module, exports) {
'use strict';

var $dsVjX = parcelRequire("dsVjX");
var $22cc87dd0f363230$require$defineProperty = $dsVjX.f;

var $keZ2c = parcelRequire("keZ2c");

var $mgvTx = parcelRequire("mgvTx");
var $22cc87dd0f363230$var$TO_STRING_TAG = $mgvTx('toStringTag');
module.exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$keZ2c(target, $22cc87dd0f363230$var$TO_STRING_TAG)) $22cc87dd0f363230$require$defineProperty(target, $22cc87dd0f363230$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

});

parcelRegister("aqTg6", function(module, exports) {
'use strict';

var $lvfol = parcelRequire("lvfol");

var $7n9WH = parcelRequire("7n9WH");

var $8SixO = parcelRequire("8SixO");

var $hicPf = parcelRequire("hicPf");

var $6HcaS = parcelRequire("6HcaS");

var $lRrDo = parcelRequire("lRrDo");
var $79873252e79d7f93$var$push = $7n9WH([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $79873252e79d7f93$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $hicPf($this);
        var self = $8SixO(O);
        var length = $6HcaS(self);
        var boundFunction = $lvfol(callbackfn, that);
        var index = 0;
        var create = specificCreate || $lRrDo;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $79873252e79d7f93$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $79873252e79d7f93$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $79873252e79d7f93$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $79873252e79d7f93$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $79873252e79d7f93$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $79873252e79d7f93$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $79873252e79d7f93$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $79873252e79d7f93$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $79873252e79d7f93$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $79873252e79d7f93$var$createMethod(7)
};

});
parcelRegister("lvfol", function(module, exports) {
'use strict';

var $fG0wf = parcelRequire("fG0wf");

var $g7x3l = parcelRequire("g7x3l");

var $c3otN = parcelRequire("c3otN");
var $fa786eb0c61cdd08$var$bind = $fG0wf($fG0wf.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $g7x3l(fn);
    return that === undefined ? fn : $c3otN ? $fa786eb0c61cdd08$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("fG0wf", function(module, exports) {
'use strict';

var $fcHE3 = parcelRequire("fcHE3");

var $7n9WH = parcelRequire("7n9WH");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($fcHE3(fn) === 'Function') return $7n9WH(fn);
};

});




parcelRegister("95iEZ", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $4uwSa = parcelRequire("4uwSa");

var $keZ2c = parcelRequire("keZ2c");

var $1H3Lz = parcelRequire("1H3Lz");

var $cITHp = parcelRequire("cITHp");

var $h4OsA = parcelRequire("h4OsA");
var $69d30e35ccee0219$var$StringToSymbolRegistry = $cITHp('string-to-symbol-registry');
var $69d30e35ccee0219$var$SymbolToStringRegistry = $cITHp('symbol-to-string-registry');
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$1XSJh({
    target: 'Symbol',
    stat: true,
    forced: !$h4OsA
}, {
    'for': function(key) {
        var string = $1H3Lz(key);
        if ($keZ2c($69d30e35ccee0219$var$StringToSymbolRegistry, string)) return $69d30e35ccee0219$var$StringToSymbolRegistry[string];
        var symbol = $4uwSa('Symbol')(string);
        $69d30e35ccee0219$var$StringToSymbolRegistry[string] = symbol;
        $69d30e35ccee0219$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});

});
parcelRegister("h4OsA", function(module, exports) {
'use strict';

var $iKqSh = parcelRequire("iKqSh");
/* eslint-disable es/no-symbol -- safe */ module.exports = $iKqSh && !!Symbol['for'] && !!Symbol.keyFor;

});


parcelRegister("69KBB", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $keZ2c = parcelRequire("keZ2c");

var $1Q1gI = parcelRequire("1Q1gI");

var $7MtCT = parcelRequire("7MtCT");

var $cITHp = parcelRequire("cITHp");

var $h4OsA = parcelRequire("h4OsA");
var $47b7bc340dbc2ec2$var$SymbolToStringRegistry = $cITHp('symbol-to-string-registry');
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$1XSJh({
    target: 'Symbol',
    stat: true,
    forced: !$h4OsA
}, {
    keyFor: function keyFor(sym) {
        if (!$1Q1gI(sym)) throw new TypeError($7MtCT(sym) + ' is not a symbol');
        if ($keZ2c($47b7bc340dbc2ec2$var$SymbolToStringRegistry, sym)) return $47b7bc340dbc2ec2$var$SymbolToStringRegistry[sym];
    }
});

});

parcelRegister("1VW2X", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $4uwSa = parcelRequire("4uwSa");

var $edBaQ = parcelRequire("edBaQ");

var $8lKVU = parcelRequire("8lKVU");

var $7n9WH = parcelRequire("7n9WH");

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");

var $1Q1gI = parcelRequire("1Q1gI");

var $lKumW = parcelRequire("lKumW");

var $gt3CE = parcelRequire("gt3CE");

var $iKqSh = parcelRequire("iKqSh");
var $1688242957791681$var$$String = String;
var $1688242957791681$var$$stringify = $4uwSa('JSON', 'stringify');
var $1688242957791681$var$exec = $7n9WH(/./.exec);
var $1688242957791681$var$charAt = $7n9WH(''.charAt);
var $1688242957791681$var$charCodeAt = $7n9WH(''.charCodeAt);
var $1688242957791681$var$replace = $7n9WH(''.replace);
var $1688242957791681$var$numberToString = $7n9WH(1.0.toString);
var $1688242957791681$var$tester = /[\uD800-\uDFFF]/g;
var $1688242957791681$var$low = /^[\uD800-\uDBFF]$/;
var $1688242957791681$var$hi = /^[\uDC00-\uDFFF]$/;
var $1688242957791681$var$WRONG_SYMBOLS_CONVERSION = !$iKqSh || $bAE3C(function() {
    var symbol = $4uwSa('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $1688242957791681$var$$stringify([
        symbol
    ]) !== '[null]' || $1688242957791681$var$$stringify({
        a: symbol
    }) !== '{}' || $1688242957791681$var$$stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var $1688242957791681$var$ILL_FORMED_UNICODE = $bAE3C(function() {
    return $1688242957791681$var$$stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $1688242957791681$var$$stringify('\uDEAD') !== '"\\udead"';
});
var $1688242957791681$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $lKumW(arguments);
    var $replacer = $gt3CE(replacer);
    if (!$1ZKCr($replacer) && (it === undefined || $1Q1gI(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($1ZKCr($replacer)) value = $8lKVU($replacer, this, $1688242957791681$var$$String(key), value);
        if (!$1Q1gI(value)) return value;
    };
    return $edBaQ($1688242957791681$var$$stringify, null, args);
};
var $1688242957791681$var$fixIllFormed = function(match, offset, string) {
    var prev = $1688242957791681$var$charAt(string, offset - 1);
    var next = $1688242957791681$var$charAt(string, offset + 1);
    if ($1688242957791681$var$exec($1688242957791681$var$low, match) && !$1688242957791681$var$exec($1688242957791681$var$hi, next) || $1688242957791681$var$exec($1688242957791681$var$hi, match) && !$1688242957791681$var$exec($1688242957791681$var$low, prev)) return '\\u' + $1688242957791681$var$numberToString($1688242957791681$var$charCodeAt(match, 0), 16);
    return match;
};
if ($1688242957791681$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$1XSJh({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: $1688242957791681$var$WRONG_SYMBOLS_CONVERSION || $1688242957791681$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $lKumW(arguments);
        var result = $edBaQ($1688242957791681$var$WRONG_SYMBOLS_CONVERSION ? $1688242957791681$var$stringifyWithSymbolsFix : $1688242957791681$var$$stringify, null, args);
        return $1688242957791681$var$ILL_FORMED_UNICODE && typeof result == 'string' ? $1688242957791681$var$replace(result, $1688242957791681$var$tester, $1688242957791681$var$fixIllFormed) : result;
    }
});

});
parcelRegister("edBaQ", function(module, exports) {
'use strict';

var $c3otN = parcelRequire("c3otN");
var $a59f1d910546347d$var$FunctionPrototype = Function.prototype;
var $a59f1d910546347d$var$apply = $a59f1d910546347d$var$FunctionPrototype.apply;
var $a59f1d910546347d$var$call = $a59f1d910546347d$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || ($c3otN ? $a59f1d910546347d$var$call.bind($a59f1d910546347d$var$apply) : function() {
    return $a59f1d910546347d$var$call.apply($a59f1d910546347d$var$apply, arguments);
});

});

parcelRegister("gt3CE", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $ay2cC = parcelRequire("ay2cC");

var $1ZKCr = parcelRequire("1ZKCr");

var $fcHE3 = parcelRequire("fcHE3");

var $1H3Lz = parcelRequire("1H3Lz");
var $bfd22a1f641eced4$var$push = $7n9WH([].push);
module.exports = function(replacer) {
    if ($1ZKCr(replacer)) return replacer;
    if (!$ay2cC(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') $bfd22a1f641eced4$var$push(keys, element);
        else if (typeof element == 'number' || $fcHE3(element) === 'Number' || $fcHE3(element) === 'String') $bfd22a1f641eced4$var$push(keys, $1H3Lz(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($ay2cC(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};

});


parcelRegister("jtDp7", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $iKqSh = parcelRequire("iKqSh");

var $bAE3C = parcelRequire("bAE3C");

var $8pg8R = parcelRequire("8pg8R");

var $hicPf = parcelRequire("hicPf");
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $e2df4a9e2cc08738$var$FORCED = !$iKqSh || $bAE3C(function() {
    $8pg8R.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$1XSJh({
    target: 'Object',
    stat: true,
    forced: $e2df4a9e2cc08738$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $8pg8R.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($hicPf(it)) : [];
    }
});

});


parcelRegister("bGQI8", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$18GwD('asyncIterator');

});

parcelRegister("sd6Ri", function(module, exports) {
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $9100U = parcelRequire("9100U");

var $kvDzZ = parcelRequire("kvDzZ");

var $7n9WH = parcelRequire("7n9WH");

var $keZ2c = parcelRequire("keZ2c");

var $1ZKCr = parcelRequire("1ZKCr");

var $7mAhs = parcelRequire("7mAhs");

var $1H3Lz = parcelRequire("1H3Lz");

var $4GKxk = parcelRequire("4GKxk");

var $fnTTa = parcelRequire("fnTTa");
var $054cc8effebf666b$var$NativeSymbol = $kvDzZ.Symbol;
var $054cc8effebf666b$var$SymbolPrototype = $054cc8effebf666b$var$NativeSymbol && $054cc8effebf666b$var$NativeSymbol.prototype;
if ($9100U && $1ZKCr($054cc8effebf666b$var$NativeSymbol) && (!('description' in $054cc8effebf666b$var$SymbolPrototype) || // Safari 12 bug
$054cc8effebf666b$var$NativeSymbol().description !== undefined)) {
    var $054cc8effebf666b$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $054cc8effebf666b$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $1H3Lz(arguments[0]);
        var result = $7mAhs($054cc8effebf666b$var$SymbolPrototype, this) ? new $054cc8effebf666b$var$NativeSymbol(description) : description === undefined ? $054cc8effebf666b$var$NativeSymbol() : $054cc8effebf666b$var$NativeSymbol(description);
        if (description === '') $054cc8effebf666b$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $fnTTa($054cc8effebf666b$var$SymbolWrapper, $054cc8effebf666b$var$NativeSymbol);
    $054cc8effebf666b$var$SymbolWrapper.prototype = $054cc8effebf666b$var$SymbolPrototype;
    $054cc8effebf666b$var$SymbolPrototype.constructor = $054cc8effebf666b$var$SymbolWrapper;
    var $054cc8effebf666b$var$NATIVE_SYMBOL = String($054cc8effebf666b$var$NativeSymbol('description detection')) === 'Symbol(description detection)';
    var $054cc8effebf666b$var$thisSymbolValue = $7n9WH($054cc8effebf666b$var$SymbolPrototype.valueOf);
    var $054cc8effebf666b$var$symbolDescriptiveString = $7n9WH($054cc8effebf666b$var$SymbolPrototype.toString);
    var $054cc8effebf666b$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $054cc8effebf666b$var$replace = $7n9WH(''.replace);
    var $054cc8effebf666b$var$stringSlice = $7n9WH(''.slice);
    $4GKxk($054cc8effebf666b$var$SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            var symbol = $054cc8effebf666b$var$thisSymbolValue(this);
            if ($keZ2c($054cc8effebf666b$var$EmptyStringDescriptionStore, symbol)) return '';
            var string = $054cc8effebf666b$var$symbolDescriptiveString(symbol);
            var desc = $054cc8effebf666b$var$NATIVE_SYMBOL ? $054cc8effebf666b$var$stringSlice(string, 7, -1) : $054cc8effebf666b$var$replace(string, $054cc8effebf666b$var$regexp, '$1');
            return desc === '' ? undefined : desc;
        }
    });
    $1XSJh({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $054cc8effebf666b$var$SymbolWrapper
    });
}

});

parcelRegister("2poLz", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$18GwD('hasInstance');

});

parcelRegister("b49To", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$18GwD('isConcatSpreadable');

});

parcelRegister("7EE6t", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$18GwD('iterator');

});

parcelRegister("2kqse", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$18GwD('match');

});

parcelRegister("39hva", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$18GwD('matchAll');

});

parcelRegister("5XA6M", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$18GwD('replace');

});

parcelRegister("1yBYS", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$18GwD('search');

});

parcelRegister("6knIt", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$18GwD('species');

});

parcelRegister("fkY1G", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$18GwD('split');

});

parcelRegister("dFgdm", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");

var $3ppV5 = parcelRequire("3ppV5");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$18GwD('toPrimitive');
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$3ppV5();

});

parcelRegister("crz9y", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $18GwD = parcelRequire("18GwD");

var $2Zevq = parcelRequire("2Zevq");
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$18GwD('toStringTag');
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$2Zevq($4uwSa('Symbol'), 'Symbol');

});

parcelRegister("6fJW1", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$18GwD('unscopables');

});

parcelRegister("kJNPM", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $2Zevq = parcelRequire("2Zevq");
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$2Zevq($kvDzZ.JSON, 'JSON', true);

});

parcelRegister("cgXro", function(module, exports) {
'use strict';

var $2Zevq = parcelRequire("2Zevq");
// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
$2Zevq(Math, 'Math', true);

});

parcelRegister("hsROu", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $kvDzZ = parcelRequire("kvDzZ");

var $2Zevq = parcelRequire("2Zevq");
$1XSJh({
    global: true
}, {
    Reflect: {}
});
// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
$2Zevq($kvDzZ.Reflect, 'Reflect', true);

});


parcelRegister("3SQhX", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $igLrZ = parcelRequire("igLrZ");

var $hWyQc = parcelRequire("hWyQc");

var $bvzmg = parcelRequire("bvzmg");

var $aPaKH = parcelRequire("aPaKH");

var $2Zevq = parcelRequire("2Zevq");

var $mgvTx = parcelRequire("mgvTx");
var $2d3ef9ab4e770834$var$ITERATOR = $mgvTx('iterator');
var $2d3ef9ab4e770834$var$ArrayValues = $bvzmg.values;
var $2d3ef9ab4e770834$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$2d3ef9ab4e770834$var$ITERATOR] !== $2d3ef9ab4e770834$var$ArrayValues) try {
            $aPaKH(CollectionPrototype, $2d3ef9ab4e770834$var$ITERATOR, $2d3ef9ab4e770834$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$2d3ef9ab4e770834$var$ITERATOR] = $2d3ef9ab4e770834$var$ArrayValues;
        }
        $2Zevq(CollectionPrototype, COLLECTION_NAME, true);
        if ($igLrZ[COLLECTION_NAME]) for(var METHOD_NAME in $bvzmg){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $bvzmg[METHOD_NAME]) try {
                $aPaKH(CollectionPrototype, METHOD_NAME, $bvzmg[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $bvzmg[METHOD_NAME];
            }
        }
    }
};
for(var $2d3ef9ab4e770834$var$COLLECTION_NAME in $igLrZ)$2d3ef9ab4e770834$var$handlePrototype($kvDzZ[$2d3ef9ab4e770834$var$COLLECTION_NAME] && $kvDzZ[$2d3ef9ab4e770834$var$COLLECTION_NAME].prototype, $2d3ef9ab4e770834$var$COLLECTION_NAME);
$2d3ef9ab4e770834$var$handlePrototype($hWyQc, 'DOMTokenList');

});
parcelRegister("igLrZ", function(module, exports) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});

parcelRegister("hWyQc", function(module, exports) {
'use strict';

var $iJAYS = parcelRequire("iJAYS");
var $d102e11c076179cf$var$classList = $iJAYS('span').classList;
var $d102e11c076179cf$var$DOMTokenListPrototype = $d102e11c076179cf$var$classList && $d102e11c076179cf$var$classList.constructor && $d102e11c076179cf$var$classList.constructor.prototype;
module.exports = $d102e11c076179cf$var$DOMTokenListPrototype === Object.prototype ? undefined : $d102e11c076179cf$var$DOMTokenListPrototype;

});

parcelRegister("bvzmg", function(module, exports) {
'use strict';

var $4EWOr = parcelRequire("4EWOr");

var $fe51S = parcelRequire("fe51S");

var $7HAsE = parcelRequire("7HAsE");

var $4eljv = parcelRequire("4eljv");

var $dsVjX = parcelRequire("dsVjX");
var $860e0454ad31c3c3$require$defineProperty = $dsVjX.f;

var $8Lwcp = parcelRequire("8Lwcp");

var $lQpvq = parcelRequire("lQpvq");

var $axseE = parcelRequire("axseE");

var $9100U = parcelRequire("9100U");
var $860e0454ad31c3c3$var$ARRAY_ITERATOR = 'Array Iterator';
var $860e0454ad31c3c3$var$setInternalState = $4eljv.set;
var $860e0454ad31c3c3$var$getInternalState = $4eljv.getterFor($860e0454ad31c3c3$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $8Lwcp(Array, 'Array', function(iterated, kind) {
    $860e0454ad31c3c3$var$setInternalState(this, {
        type: $860e0454ad31c3c3$var$ARRAY_ITERATOR,
        target: $4EWOr(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $860e0454ad31c3c3$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $lQpvq(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $lQpvq(index, false);
        case 'values':
            return $lQpvq(target[index], false);
    }
    return $lQpvq([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $860e0454ad31c3c3$var$values = $7HAsE.Arguments = $7HAsE.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$fe51S('keys');
$fe51S('values');
$fe51S('entries');
// V8 ~ Chrome 45- bug
if (!$axseE && $9100U && $860e0454ad31c3c3$var$values.name !== 'values') try {
    $860e0454ad31c3c3$require$defineProperty($860e0454ad31c3c3$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}

});
parcelRegister("fe51S", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");

var $emiQA = parcelRequire("emiQA");

var $dsVjX = parcelRequire("dsVjX");
var $b15c1088d3844b30$require$defineProperty = $dsVjX.f;
var $b15c1088d3844b30$var$UNSCOPABLES = $mgvTx('unscopables');
var $b15c1088d3844b30$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($b15c1088d3844b30$var$ArrayPrototype[$b15c1088d3844b30$var$UNSCOPABLES] === undefined) $b15c1088d3844b30$require$defineProperty($b15c1088d3844b30$var$ArrayPrototype, $b15c1088d3844b30$var$UNSCOPABLES, {
    configurable: true,
    value: $emiQA(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    $b15c1088d3844b30$var$ArrayPrototype[$b15c1088d3844b30$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("7HAsE", function(module, exports) {
'use strict';
module.exports = {};

});

parcelRegister("8Lwcp", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $8lKVU = parcelRequire("8lKVU");

var $axseE = parcelRequire("axseE");

var $hCoZT = parcelRequire("hCoZT");

var $1ZKCr = parcelRequire("1ZKCr");

var $5Jked = parcelRequire("5Jked");

var $eHPSS = parcelRequire("eHPSS");

var $BroF8 = parcelRequire("BroF8");

var $2Zevq = parcelRequire("2Zevq");

var $aPaKH = parcelRequire("aPaKH");

var $2t4Gp = parcelRequire("2t4Gp");

var $mgvTx = parcelRequire("mgvTx");

var $7HAsE = parcelRequire("7HAsE");

var $J9W4z = parcelRequire("J9W4z");
var $661bb09cba2f48ef$var$PROPER_FUNCTION_NAME = $hCoZT.PROPER;
var $661bb09cba2f48ef$var$CONFIGURABLE_FUNCTION_NAME = $hCoZT.CONFIGURABLE;
var $661bb09cba2f48ef$var$IteratorPrototype = $J9W4z.IteratorPrototype;
var $661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS = $J9W4z.BUGGY_SAFARI_ITERATORS;
var $661bb09cba2f48ef$var$ITERATOR = $mgvTx('iterator');
var $661bb09cba2f48ef$var$KEYS = 'keys';
var $661bb09cba2f48ef$var$VALUES = 'values';
var $661bb09cba2f48ef$var$ENTRIES = 'entries';
var $661bb09cba2f48ef$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5Jked(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $661bb09cba2f48ef$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $661bb09cba2f48ef$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $661bb09cba2f48ef$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$661bb09cba2f48ef$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $eHPSS(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$axseE && $eHPSS(CurrentIteratorPrototype) !== $661bb09cba2f48ef$var$IteratorPrototype) {
                if ($BroF8) $BroF8(CurrentIteratorPrototype, $661bb09cba2f48ef$var$IteratorPrototype);
                else if (!$1ZKCr(CurrentIteratorPrototype[$661bb09cba2f48ef$var$ITERATOR])) $2t4Gp(CurrentIteratorPrototype, $661bb09cba2f48ef$var$ITERATOR, $661bb09cba2f48ef$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $2Zevq(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($axseE) $7HAsE[TO_STRING_TAG] = $661bb09cba2f48ef$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($661bb09cba2f48ef$var$PROPER_FUNCTION_NAME && DEFAULT === $661bb09cba2f48ef$var$VALUES && nativeIterator && nativeIterator.name !== $661bb09cba2f48ef$var$VALUES) {
        if (!$axseE && $661bb09cba2f48ef$var$CONFIGURABLE_FUNCTION_NAME) $aPaKH(IterablePrototype, 'name', $661bb09cba2f48ef$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $8lKVU(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($661bb09cba2f48ef$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($661bb09cba2f48ef$var$KEYS),
            entries: getIterationMethod($661bb09cba2f48ef$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $2t4Gp(IterablePrototype, KEY, methods[KEY]);
        } else $1XSJh({
            target: NAME,
            proto: true,
            forced: $661bb09cba2f48ef$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$axseE || FORCED) && IterablePrototype[$661bb09cba2f48ef$var$ITERATOR] !== defaultIterator) $2t4Gp(IterablePrototype, $661bb09cba2f48ef$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $7HAsE[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("5Jked", function(module, exports) {
'use strict';

var $J9W4z = parcelRequire("J9W4z");
var $42c0d8a7ba4cc266$require$IteratorPrototype = $J9W4z.IteratorPrototype;

var $emiQA = parcelRequire("emiQA");

var $3qjfQ = parcelRequire("3qjfQ");

var $2Zevq = parcelRequire("2Zevq");

var $7HAsE = parcelRequire("7HAsE");
var $42c0d8a7ba4cc266$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $emiQA($42c0d8a7ba4cc266$require$IteratorPrototype, {
        next: $3qjfQ(+!ENUMERABLE_NEXT, next)
    });
    $2Zevq(IteratorConstructor, TO_STRING_TAG, false, true);
    $7HAsE[TO_STRING_TAG] = $42c0d8a7ba4cc266$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("J9W4z", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $1ZKCr = parcelRequire("1ZKCr");

var $9OhmT = parcelRequire("9OhmT");

var $emiQA = parcelRequire("emiQA");

var $eHPSS = parcelRequire("eHPSS");

var $2t4Gp = parcelRequire("2t4Gp");

var $mgvTx = parcelRequire("mgvTx");

var $axseE = parcelRequire("axseE");
var $087be9192a66014c$var$ITERATOR = $mgvTx('iterator');
var $087be9192a66014c$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $087be9192a66014c$var$IteratorPrototype, $087be9192a66014c$var$PrototypeOfArrayIteratorPrototype, $087be9192a66014c$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $087be9192a66014c$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $087be9192a66014c$var$arrayIterator)) $087be9192a66014c$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $087be9192a66014c$var$PrototypeOfArrayIteratorPrototype = $eHPSS($eHPSS($087be9192a66014c$var$arrayIterator));
        if ($087be9192a66014c$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $087be9192a66014c$var$IteratorPrototype = $087be9192a66014c$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $087be9192a66014c$var$NEW_ITERATOR_PROTOTYPE = !$9OhmT($087be9192a66014c$var$IteratorPrototype) || $bAE3C(function() {
    var test = {};
    // FF44- legacy iterators case
    return $087be9192a66014c$var$IteratorPrototype[$087be9192a66014c$var$ITERATOR].call(test) !== test;
});
if ($087be9192a66014c$var$NEW_ITERATOR_PROTOTYPE) $087be9192a66014c$var$IteratorPrototype = {};
else if ($axseE) $087be9192a66014c$var$IteratorPrototype = $emiQA($087be9192a66014c$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$1ZKCr($087be9192a66014c$var$IteratorPrototype[$087be9192a66014c$var$ITERATOR])) $2t4Gp($087be9192a66014c$var$IteratorPrototype, $087be9192a66014c$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $087be9192a66014c$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $087be9192a66014c$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("eHPSS", function(module, exports) {
'use strict';

var $keZ2c = parcelRequire("keZ2c");

var $1ZKCr = parcelRequire("1ZKCr");

var $hicPf = parcelRequire("hicPf");

var $k3YZr = parcelRequire("k3YZr");

var $eXils = parcelRequire("eXils");
var $ab4d53f8128d56b5$var$IE_PROTO = $k3YZr('IE_PROTO');
var $ab4d53f8128d56b5$var$$Object = Object;
var $ab4d53f8128d56b5$var$ObjectPrototype = $ab4d53f8128d56b5$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $eXils ? $ab4d53f8128d56b5$var$$Object.getPrototypeOf : function(O) {
    var object = $hicPf(O);
    if ($keZ2c(object, $ab4d53f8128d56b5$var$IE_PROTO)) return object[$ab4d53f8128d56b5$var$IE_PROTO];
    var constructor = object.constructor;
    if ($1ZKCr(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $ab4d53f8128d56b5$var$$Object ? $ab4d53f8128d56b5$var$ObjectPrototype : null;
};

});
parcelRegister("eXils", function(module, exports) {
'use strict';

var $bAE3C = parcelRequire("bAE3C");
module.exports = !$bAE3C(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});




parcelRegister("BroF8", function(module, exports) {
'use strict';

var $cO8Cy = parcelRequire("cO8Cy");

var $9OhmT = parcelRequire("9OhmT");

var $388Wm = parcelRequire("388Wm");

var $1RqXI = parcelRequire("1RqXI");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $cO8Cy(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $388Wm(O);
        $1RqXI(proto);
        if (!$9OhmT(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("cO8Cy", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $g7x3l = parcelRequire("g7x3l");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $7n9WH($g7x3l(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("1RqXI", function(module, exports) {
'use strict';

var $cpvpr = parcelRequire("cpvpr");
var $15afa7c928a92e4f$var$$String = String;
var $15afa7c928a92e4f$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($cpvpr(argument)) return argument;
    throw new $15afa7c928a92e4f$var$$TypeError("Can't set " + $15afa7c928a92e4f$var$$String(argument) + ' as a prototype');
};

});
parcelRegister("cpvpr", function(module, exports) {
'use strict';

var $9OhmT = parcelRequire("9OhmT");
module.exports = function(argument) {
    return $9OhmT(argument) || argument === null;
};

});




parcelRegister("lQpvq", function(module, exports) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});




parcelRegister("4AEWC", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");

var $dsVjX = parcelRequire("dsVjX");
var $357a48eab54f2feb$require$defineProperty = $dsVjX.f;
var $357a48eab54f2feb$var$METADATA = $mgvTx('metadata');
var $357a48eab54f2feb$var$FunctionPrototype = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if ($357a48eab54f2feb$var$FunctionPrototype[$357a48eab54f2feb$var$METADATA] === undefined) $357a48eab54f2feb$require$defineProperty($357a48eab54f2feb$var$FunctionPrototype, $357a48eab54f2feb$var$METADATA, {
    value: null
});

});

parcelRegister("h3JRe", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $18GwD = parcelRequire("18GwD");

var $dsVjX = parcelRequire("dsVjX");
var $c6b649d7aa758f3f$require$defineProperty = $dsVjX.f;

var $kmjYa = parcelRequire("kmjYa");
var $c6b649d7aa758f3f$require$getOwnPropertyDescriptor = $kmjYa.f;
var $c6b649d7aa758f3f$var$Symbol = $kvDzZ.Symbol;
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$18GwD('asyncDispose');
if ($c6b649d7aa758f3f$var$Symbol) {
    var $c6b649d7aa758f3f$var$descriptor = $c6b649d7aa758f3f$require$getOwnPropertyDescriptor($c6b649d7aa758f3f$var$Symbol, 'asyncDispose');
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($c6b649d7aa758f3f$var$descriptor.enumerable && $c6b649d7aa758f3f$var$descriptor.configurable && $c6b649d7aa758f3f$var$descriptor.writable) $c6b649d7aa758f3f$require$defineProperty($c6b649d7aa758f3f$var$Symbol, 'asyncDispose', {
        value: $c6b649d7aa758f3f$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}

});

parcelRegister("haEFx", function(module, exports) {
'use strict';

var $kvDzZ = parcelRequire("kvDzZ");

var $18GwD = parcelRequire("18GwD");

var $dsVjX = parcelRequire("dsVjX");
var $c802ead4b0931773$require$defineProperty = $dsVjX.f;

var $kmjYa = parcelRequire("kmjYa");
var $c802ead4b0931773$require$getOwnPropertyDescriptor = $kmjYa.f;
var $c802ead4b0931773$var$Symbol = $kvDzZ.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$18GwD('dispose');
if ($c802ead4b0931773$var$Symbol) {
    var $c802ead4b0931773$var$descriptor = $c802ead4b0931773$require$getOwnPropertyDescriptor($c802ead4b0931773$var$Symbol, 'dispose');
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($c802ead4b0931773$var$descriptor.enumerable && $c802ead4b0931773$var$descriptor.configurable && $c802ead4b0931773$var$descriptor.writable) $c802ead4b0931773$require$defineProperty($c802ead4b0931773$var$Symbol, 'dispose', {
        value: $c802ead4b0931773$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}

});

parcelRegister("lYc2Q", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$18GwD('metadata');

});


parcelRegister("B3Rmu", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $2pjhR = parcelRequire("2pjhR");
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$1XSJh({
    target: 'Symbol',
    stat: true
}, {
    isRegisteredSymbol: $2pjhR
});

});
parcelRegister("2pjhR", function(module, exports) {
'use strict';

var $4uwSa = parcelRequire("4uwSa");

var $7n9WH = parcelRequire("7n9WH");
var $1c0ce09382c54cbc$var$Symbol = $4uwSa('Symbol');
var $1c0ce09382c54cbc$var$keyFor = $1c0ce09382c54cbc$var$Symbol.keyFor;
var $1c0ce09382c54cbc$var$thisSymbolValue = $7n9WH($1c0ce09382c54cbc$var$Symbol.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
module.exports = $1c0ce09382c54cbc$var$Symbol.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return $1c0ce09382c54cbc$var$keyFor($1c0ce09382c54cbc$var$thisSymbolValue(value)) !== undefined;
    } catch (error) {
        return false;
    }
};

});


parcelRegister("7H6Ip", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $fNAJI = parcelRequire("fNAJI");
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$1XSJh({
    target: 'Symbol',
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: $fNAJI
});

});
parcelRegister("fNAJI", function(module, exports) {
'use strict';

var $cITHp = parcelRequire("cITHp");

var $4uwSa = parcelRequire("4uwSa");

var $7n9WH = parcelRequire("7n9WH");

var $1Q1gI = parcelRequire("1Q1gI");

var $mgvTx = parcelRequire("mgvTx");
var $b807edb17772293b$var$Symbol = $4uwSa('Symbol');
var $b807edb17772293b$var$$isWellKnownSymbol = $b807edb17772293b$var$Symbol.isWellKnownSymbol;
var $b807edb17772293b$var$getOwnPropertyNames = $4uwSa('Object', 'getOwnPropertyNames');
var $b807edb17772293b$var$thisSymbolValue = $7n9WH($b807edb17772293b$var$Symbol.prototype.valueOf);
var $b807edb17772293b$var$WellKnownSymbolsStore = $cITHp('wks');
for(var $b807edb17772293b$var$i = 0, $b807edb17772293b$var$symbolKeys = $b807edb17772293b$var$getOwnPropertyNames($b807edb17772293b$var$Symbol), $b807edb17772293b$var$symbolKeysLength = $b807edb17772293b$var$symbolKeys.length; $b807edb17772293b$var$i < $b807edb17772293b$var$symbolKeysLength; $b807edb17772293b$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $b807edb17772293b$var$symbolKey = $b807edb17772293b$var$symbolKeys[$b807edb17772293b$var$i];
    if ($1Q1gI($b807edb17772293b$var$Symbol[$b807edb17772293b$var$symbolKey])) $mgvTx($b807edb17772293b$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
module.exports = function isWellKnownSymbol(value) {
    if ($b807edb17772293b$var$$isWellKnownSymbol && $b807edb17772293b$var$$isWellKnownSymbol(value)) return true;
    try {
        var symbol = $b807edb17772293b$var$thisSymbolValue(value);
        for(var j = 0, keys = $b807edb17772293b$var$getOwnPropertyNames($b807edb17772293b$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            // eslint-disable-next-line eqeqeq -- polyfilled symbols case
            if ($b807edb17772293b$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};

});


parcelRegister("dqfzw", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.customMatcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$18GwD('customMatcher');

});

parcelRegister("1Uru5", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$18GwD('observable');

});

parcelRegister("3CVe2", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $2pjhR = parcelRequire("2pjhR");
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$1XSJh({
    target: 'Symbol',
    stat: true,
    name: 'isRegisteredSymbol'
}, {
    isRegistered: $2pjhR
});

});

parcelRegister("5UszO", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $fNAJI = parcelRequire("fNAJI");
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$1XSJh({
    target: 'Symbol',
    stat: true,
    name: 'isWellKnownSymbol',
    forced: true
}, {
    isWellKnown: $fNAJI
});

});

parcelRegister("cxaIU", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$18GwD('matcher');

});

parcelRegister("kIR3S", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$18GwD('metadataKey');

});

parcelRegister("2u8TL", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$18GwD('patternMatch');

});

parcelRegister("khlXA", function(module, exports) {
'use strict';

var $18GwD = parcelRequire("18GwD");
$18GwD('replaceAll');

});


parcelRegister("3MGWX", function(module, exports) {
'use strict';

var $9XOqv = parcelRequire("9XOqv");
module.exports = $9XOqv;

});
parcelRegister("9XOqv", function(module, exports) {
'use strict';

var $hX9IH = parcelRequire("hX9IH");
module.exports = $hX9IH;

});
parcelRegister("hX9IH", function(module, exports) {
'use strict';

var $k0dS9 = parcelRequire("k0dS9");
module.exports = $k0dS9;

});
parcelRegister("k0dS9", function(module, exports) {
'use strict';
parcelRequire("f7BYa");
parcelRequire("cvwxk");

var $9AtxJ = parcelRequire("9AtxJ");
module.exports = $9AtxJ.Array.from;

});
parcelRegister("f7BYa", function(module, exports) {
'use strict';

var $hkAQY = parcelRequire("hkAQY");
var $b024f66566f06736$require$charAt = $hkAQY.charAt;

var $1H3Lz = parcelRequire("1H3Lz");

var $4eljv = parcelRequire("4eljv");

var $8Lwcp = parcelRequire("8Lwcp");

var $lQpvq = parcelRequire("lQpvq");
var $b024f66566f06736$var$STRING_ITERATOR = 'String Iterator';
var $b024f66566f06736$var$setInternalState = $4eljv.set;
var $b024f66566f06736$var$getInternalState = $4eljv.getterFor($b024f66566f06736$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$8Lwcp(String, 'String', function(iterated) {
    $b024f66566f06736$var$setInternalState(this, {
        type: $b024f66566f06736$var$STRING_ITERATOR,
        string: $1H3Lz(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $b024f66566f06736$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $lQpvq(undefined, true);
    point = $b024f66566f06736$require$charAt(string, index);
    state.index += point.length;
    return $lQpvq(point, false);
});

});
parcelRegister("hkAQY", function(module, exports) {
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $hXJr0 = parcelRequire("hXJr0");

var $1H3Lz = parcelRequire("1H3Lz");

var $388Wm = parcelRequire("388Wm");
var $c9e0e4405f6933db$var$charAt = $7n9WH(''.charAt);
var $c9e0e4405f6933db$var$charCodeAt = $7n9WH(''.charCodeAt);
var $c9e0e4405f6933db$var$stringSlice = $7n9WH(''.slice);
var $c9e0e4405f6933db$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $1H3Lz($388Wm($this));
        var position = $hXJr0(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $c9e0e4405f6933db$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $c9e0e4405f6933db$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $c9e0e4405f6933db$var$charAt(S, position) : first : CONVERT_TO_STRING ? $c9e0e4405f6933db$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $c9e0e4405f6933db$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $c9e0e4405f6933db$var$createMethod(true)
};

});


parcelRegister("cvwxk", function(module, exports) {
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $lBNRQ = parcelRequire("lBNRQ");

var $haiBW = parcelRequire("haiBW");
var $91b19e5a13496a48$var$INCORRECT_ITERATION = !$haiBW(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$1XSJh({
    target: 'Array',
    stat: true,
    forced: $91b19e5a13496a48$var$INCORRECT_ITERATION
}, {
    from: $lBNRQ
});

});
parcelRegister("lBNRQ", function(module, exports) {
'use strict';

var $lvfol = parcelRequire("lvfol");

var $8lKVU = parcelRequire("8lKVU");

var $hicPf = parcelRequire("hicPf");

var $iEf5n = parcelRequire("iEf5n");

var $9r4Pz = parcelRequire("9r4Pz");

var $cmnjY = parcelRequire("cmnjY");

var $6HcaS = parcelRequire("6HcaS");

var $7F0dl = parcelRequire("7F0dl");

var $kD1mB = parcelRequire("kD1mB");

var $lyncN = parcelRequire("lyncN");
var $fbb3bc4d85a696a7$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $hicPf(arrayLike);
    var IS_CONSTRUCTOR = $cmnjY(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $lvfol(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $lyncN(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $fbb3bc4d85a696a7$var$$Array && $9r4Pz(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = $kD1mB(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = $8lKVU(next, iterator)).done; index++){
            value = mapping ? $iEf5n(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $7F0dl(result, index, value);
        }
    } else {
        length = $6HcaS(O);
        result = IS_CONSTRUCTOR ? new this(length) : $fbb3bc4d85a696a7$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $7F0dl(result, index, value);
        }
    }
    result.length = index;
    return result;
};

});
parcelRegister("iEf5n", function(module, exports) {
'use strict';

var $4LaI4 = parcelRequire("4LaI4");

var $gPp4U = parcelRequire("gPp4U");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($4LaI4(value)[0], value[1]) : fn(value);
    } catch (error) {
        $gPp4U(iterator, 'throw', error);
    }
};

});
parcelRegister("gPp4U", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $4LaI4 = parcelRequire("4LaI4");

var $eZ5qV = parcelRequire("eZ5qV");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $4LaI4(iterator);
    try {
        innerResult = $eZ5qV(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $8lKVU(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $4LaI4(innerResult);
    return value;
};

});


parcelRegister("9r4Pz", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");

var $7HAsE = parcelRequire("7HAsE");
var $6dea61f91d02b61c$var$ITERATOR = $mgvTx('iterator');
var $6dea61f91d02b61c$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($7HAsE.Array === it || $6dea61f91d02b61c$var$ArrayPrototype[$6dea61f91d02b61c$var$ITERATOR] === it);
};

});

parcelRegister("kD1mB", function(module, exports) {
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $g7x3l = parcelRequire("g7x3l");

var $4LaI4 = parcelRequire("4LaI4");

var $7MtCT = parcelRequire("7MtCT");

var $lyncN = parcelRequire("lyncN");
var $f04881f0a594a8f1$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $lyncN(argument) : usingIterator;
    if ($g7x3l(iteratorMethod)) return $4LaI4($8lKVU(iteratorMethod, argument));
    throw new $f04881f0a594a8f1$var$$TypeError($7MtCT(argument) + ' is not iterable');
};

});
parcelRegister("lyncN", function(module, exports) {
'use strict';

var $401SB = parcelRequire("401SB");

var $eZ5qV = parcelRequire("eZ5qV");

var $hKX7u = parcelRequire("hKX7u");

var $7HAsE = parcelRequire("7HAsE");

var $mgvTx = parcelRequire("mgvTx");
var $fb0ec61352810087$var$ITERATOR = $mgvTx('iterator');
module.exports = function(it) {
    if (!$hKX7u(it)) return $eZ5qV(it, $fb0ec61352810087$var$ITERATOR) || $eZ5qV(it, '@@iterator') || $7HAsE[$401SB(it)];
};

});



parcelRegister("haiBW", function(module, exports) {
'use strict';

var $mgvTx = parcelRequire("mgvTx");
var $c7f1ce996adbbdcb$var$ITERATOR = $mgvTx('iterator');
var $c7f1ce996adbbdcb$var$SAFE_CLOSING = false;
try {
    var $c7f1ce996adbbdcb$var$called = 0;
    var $c7f1ce996adbbdcb$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$c7f1ce996adbbdcb$var$called++
            };
        },
        'return': function() {
            $c7f1ce996adbbdcb$var$SAFE_CLOSING = true;
        }
    };
    $c7f1ce996adbbdcb$var$iteratorWithReturn[$c7f1ce996adbbdcb$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($c7f1ce996adbbdcb$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$c7f1ce996adbbdcb$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$c7f1ce996adbbdcb$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});






parcelRegister("a7k9U", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $75da31f4a46773b1$export$ae55be85d98224ed; }, function (v) { return $75da31f4a46773b1$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $75da31f4a46773b1$export$d39a5bbd09211389; }, function (v) { return $75da31f4a46773b1$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $75da31f4a46773b1$export$882461b6382ed46c; }, function (v) { return $75da31f4a46773b1$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $75da31f4a46773b1$export$466bfc07425424d5; }, function (v) { return $75da31f4a46773b1$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $75da31f4a46773b1$export$cd75ccfd720a3cd4; }, function (v) { return $75da31f4a46773b1$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $75da31f4a46773b1$export$fa8d919ba61d84db; }, function (v) { return $75da31f4a46773b1$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $75da31f4a46773b1$export$757ceba2d55c277e; }, function (v) { return $75da31f4a46773b1$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $75da31f4a46773b1$export$b3890eb0ae9dca99; }, function (v) { return $75da31f4a46773b1$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $75da31f4a46773b1$export$502457920280e6be; }, function (v) { return $75da31f4a46773b1$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $75da31f4a46773b1$export$c78a37762a8d58e1; }, function (v) { return $75da31f4a46773b1$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $75da31f4a46773b1$export$dc54d992c10e8a18; }, function (v) { return $75da31f4a46773b1$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $75da31f4a46773b1$export$83d89fbfd8236492; }, function (v) { return $75da31f4a46773b1$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $75da31f4a46773b1$export$ae55be85d98224ed;
var $75da31f4a46773b1$export$d39a5bbd09211389;
var $75da31f4a46773b1$export$882461b6382ed46c;
var $75da31f4a46773b1$export$466bfc07425424d5;
var $75da31f4a46773b1$export$cd75ccfd720a3cd4;
var $75da31f4a46773b1$export$fa8d919ba61d84db;
var $75da31f4a46773b1$export$757ceba2d55c277e;
var $75da31f4a46773b1$export$b3890eb0ae9dca99;
var $75da31f4a46773b1$export$502457920280e6be;
var $75da31f4a46773b1$export$c78a37762a8d58e1;
var $75da31f4a46773b1$export$dc54d992c10e8a18;
var $75da31f4a46773b1$export$83d89fbfd8236492;
'use strict';

var $ieaan = parcelRequire("ieaan");

var $3CIn6 = parcelRequire("3CIn6");
function $75da31f4a46773b1$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $75da31f4a46773b1$var$da = new Set, $75da31f4a46773b1$var$ea = {};
function $75da31f4a46773b1$var$fa(a, b) {
    $75da31f4a46773b1$var$ha(a, b);
    $75da31f4a46773b1$var$ha(a + "Capture", b);
}
function $75da31f4a46773b1$var$ha(a, b) {
    $75da31f4a46773b1$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$75da31f4a46773b1$var$da.add(b[a]);
}
var $75da31f4a46773b1$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $75da31f4a46773b1$var$ja = Object.prototype.hasOwnProperty, $75da31f4a46773b1$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $75da31f4a46773b1$var$la = {}, $75da31f4a46773b1$var$ma = {};
function $75da31f4a46773b1$var$oa(a) {
    if ($75da31f4a46773b1$var$ja.call($75da31f4a46773b1$var$ma, a)) return !0;
    if ($75da31f4a46773b1$var$ja.call($75da31f4a46773b1$var$la, a)) return !1;
    if ($75da31f4a46773b1$var$ka.test(a)) return $75da31f4a46773b1$var$ma[a] = !0;
    $75da31f4a46773b1$var$la[a] = !0;
    return !1;
}
function $75da31f4a46773b1$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $75da31f4a46773b1$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $75da31f4a46773b1$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $75da31f4a46773b1$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $75da31f4a46773b1$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $75da31f4a46773b1$var$z[b] = new $75da31f4a46773b1$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $75da31f4a46773b1$var$ra = /[\-:]([a-z])/g;
function $75da31f4a46773b1$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($75da31f4a46773b1$var$ra, $75da31f4a46773b1$var$sa);
    $75da31f4a46773b1$var$z[b] = new $75da31f4a46773b1$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($75da31f4a46773b1$var$ra, $75da31f4a46773b1$var$sa);
    $75da31f4a46773b1$var$z[b] = new $75da31f4a46773b1$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($75da31f4a46773b1$var$ra, $75da31f4a46773b1$var$sa);
    $75da31f4a46773b1$var$z[b] = new $75da31f4a46773b1$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$75da31f4a46773b1$var$z.xlinkHref = new $75da31f4a46773b1$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $75da31f4a46773b1$var$z[a] = new $75da31f4a46773b1$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $75da31f4a46773b1$var$ta(a, b, c, d) {
    var e = $75da31f4a46773b1$var$z.hasOwnProperty(b) ? $75da31f4a46773b1$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $75da31f4a46773b1$var$qa(b, c, e, d) && (c = null), d || null === e ? $75da31f4a46773b1$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $75da31f4a46773b1$var$ua = $ieaan.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $75da31f4a46773b1$var$va = Symbol.for("react.element"), $75da31f4a46773b1$var$wa = Symbol.for("react.portal"), $75da31f4a46773b1$var$ya = Symbol.for("react.fragment"), $75da31f4a46773b1$var$za = Symbol.for("react.strict_mode"), $75da31f4a46773b1$var$Aa = Symbol.for("react.profiler"), $75da31f4a46773b1$var$Ba = Symbol.for("react.provider"), $75da31f4a46773b1$var$Ca = Symbol.for("react.context"), $75da31f4a46773b1$var$Da = Symbol.for("react.forward_ref"), $75da31f4a46773b1$var$Ea = Symbol.for("react.suspense"), $75da31f4a46773b1$var$Fa = Symbol.for("react.suspense_list"), $75da31f4a46773b1$var$Ga = Symbol.for("react.memo"), $75da31f4a46773b1$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $75da31f4a46773b1$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $75da31f4a46773b1$var$Ja = Symbol.iterator;
function $75da31f4a46773b1$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $75da31f4a46773b1$var$Ja && a[$75da31f4a46773b1$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $75da31f4a46773b1$var$A = Object.assign, $75da31f4a46773b1$var$La;
function $75da31f4a46773b1$var$Ma(a) {
    if (void 0 === $75da31f4a46773b1$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $75da31f4a46773b1$var$La = b && b[1] || "";
    }
    return "\n" + $75da31f4a46773b1$var$La + a;
}
var $75da31f4a46773b1$var$Na = !1;
function $75da31f4a46773b1$var$Oa(a, b) {
    if (!a || $75da31f4a46773b1$var$Na) return "";
    $75da31f4a46773b1$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $75da31f4a46773b1$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $75da31f4a46773b1$var$Ma(a) : "";
}
function $75da31f4a46773b1$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $75da31f4a46773b1$var$Ma(a.type);
        case 16:
            return $75da31f4a46773b1$var$Ma("Lazy");
        case 13:
            return $75da31f4a46773b1$var$Ma("Suspense");
        case 19:
            return $75da31f4a46773b1$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $75da31f4a46773b1$var$Oa(a.type, !1), a;
        case 11:
            return a = $75da31f4a46773b1$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $75da31f4a46773b1$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $75da31f4a46773b1$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $75da31f4a46773b1$var$ya:
            return "Fragment";
        case $75da31f4a46773b1$var$wa:
            return "Portal";
        case $75da31f4a46773b1$var$Aa:
            return "Profiler";
        case $75da31f4a46773b1$var$za:
            return "StrictMode";
        case $75da31f4a46773b1$var$Ea:
            return "Suspense";
        case $75da31f4a46773b1$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $75da31f4a46773b1$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $75da31f4a46773b1$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $75da31f4a46773b1$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $75da31f4a46773b1$var$Ga:
            return b = a.displayName || null, null !== b ? b : $75da31f4a46773b1$var$Qa(a.type) || "Memo";
        case $75da31f4a46773b1$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $75da31f4a46773b1$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $75da31f4a46773b1$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $75da31f4a46773b1$var$Qa(b);
        case 8:
            return b === $75da31f4a46773b1$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $75da31f4a46773b1$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $75da31f4a46773b1$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $75da31f4a46773b1$var$Ua(a) {
    var b = $75da31f4a46773b1$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $75da31f4a46773b1$var$Va(a) {
    a._valueTracker || (a._valueTracker = $75da31f4a46773b1$var$Ua(a));
}
function $75da31f4a46773b1$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $75da31f4a46773b1$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $75da31f4a46773b1$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $75da31f4a46773b1$var$Ya(a, b) {
    var c = b.checked;
    return $75da31f4a46773b1$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $75da31f4a46773b1$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $75da31f4a46773b1$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $75da31f4a46773b1$var$ab(a, b) {
    b = b.checked;
    null != b && $75da31f4a46773b1$var$ta(a, "checked", b, !1);
}
function $75da31f4a46773b1$var$bb(a, b) {
    $75da31f4a46773b1$var$ab(a, b);
    var c = $75da31f4a46773b1$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $75da31f4a46773b1$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $75da31f4a46773b1$var$cb(a, b.type, $75da31f4a46773b1$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $75da31f4a46773b1$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $75da31f4a46773b1$var$cb(a, b, c) {
    if ("number" !== b || $75da31f4a46773b1$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $75da31f4a46773b1$var$eb = Array.isArray;
function $75da31f4a46773b1$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $75da31f4a46773b1$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $75da31f4a46773b1$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($75da31f4a46773b1$var$p(91));
    return $75da31f4a46773b1$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $75da31f4a46773b1$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($75da31f4a46773b1$var$p(92));
            if ($75da31f4a46773b1$var$eb(c)) {
                if (1 < c.length) throw Error($75da31f4a46773b1$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $75da31f4a46773b1$var$Sa(c)
    };
}
function $75da31f4a46773b1$var$ib(a, b) {
    var c = $75da31f4a46773b1$var$Sa(b.value), d = $75da31f4a46773b1$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $75da31f4a46773b1$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $75da31f4a46773b1$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $75da31f4a46773b1$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $75da31f4a46773b1$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $75da31f4a46773b1$var$mb, $75da31f4a46773b1$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $75da31f4a46773b1$var$mb = $75da31f4a46773b1$var$mb || document.createElement("div");
        $75da31f4a46773b1$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $75da31f4a46773b1$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $75da31f4a46773b1$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $75da31f4a46773b1$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $75da31f4a46773b1$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($75da31f4a46773b1$var$pb).forEach(function(a) {
    $75da31f4a46773b1$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $75da31f4a46773b1$var$pb[b] = $75da31f4a46773b1$var$pb[a];
    });
});
function $75da31f4a46773b1$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $75da31f4a46773b1$var$pb.hasOwnProperty(a) && $75da31f4a46773b1$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $75da31f4a46773b1$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $75da31f4a46773b1$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $75da31f4a46773b1$var$tb = $75da31f4a46773b1$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $75da31f4a46773b1$var$ub(a, b) {
    if (b) {
        if ($75da31f4a46773b1$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($75da31f4a46773b1$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($75da31f4a46773b1$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($75da31f4a46773b1$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($75da31f4a46773b1$var$p(62));
    }
}
function $75da31f4a46773b1$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $75da31f4a46773b1$var$wb = null;
function $75da31f4a46773b1$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $75da31f4a46773b1$var$yb = null, $75da31f4a46773b1$var$zb = null, $75da31f4a46773b1$var$Ab = null;
function $75da31f4a46773b1$var$Bb(a) {
    if (a = $75da31f4a46773b1$var$Cb(a)) {
        if ("function" !== typeof $75da31f4a46773b1$var$yb) throw Error($75da31f4a46773b1$var$p(280));
        var b = a.stateNode;
        b && (b = $75da31f4a46773b1$var$Db(b), $75da31f4a46773b1$var$yb(a.stateNode, a.type, b));
    }
}
function $75da31f4a46773b1$var$Eb(a) {
    $75da31f4a46773b1$var$zb ? $75da31f4a46773b1$var$Ab ? $75da31f4a46773b1$var$Ab.push(a) : $75da31f4a46773b1$var$Ab = [
        a
    ] : $75da31f4a46773b1$var$zb = a;
}
function $75da31f4a46773b1$var$Fb() {
    if ($75da31f4a46773b1$var$zb) {
        var a = $75da31f4a46773b1$var$zb, b = $75da31f4a46773b1$var$Ab;
        $75da31f4a46773b1$var$Ab = $75da31f4a46773b1$var$zb = null;
        $75da31f4a46773b1$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$75da31f4a46773b1$var$Bb(b[a]);
    }
}
function $75da31f4a46773b1$var$Gb(a, b) {
    return a(b);
}
function $75da31f4a46773b1$var$Hb() {}
var $75da31f4a46773b1$var$Ib = !1;
function $75da31f4a46773b1$var$Jb(a, b, c) {
    if ($75da31f4a46773b1$var$Ib) return a(b, c);
    $75da31f4a46773b1$var$Ib = !0;
    try {
        return $75da31f4a46773b1$var$Gb(a, b, c);
    } finally{
        if ($75da31f4a46773b1$var$Ib = !1, null !== $75da31f4a46773b1$var$zb || null !== $75da31f4a46773b1$var$Ab) $75da31f4a46773b1$var$Hb(), $75da31f4a46773b1$var$Fb();
    }
}
function $75da31f4a46773b1$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $75da31f4a46773b1$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($75da31f4a46773b1$var$p(231, b, typeof c));
    return c;
}
var $75da31f4a46773b1$var$Lb = !1;
if ($75da31f4a46773b1$var$ia) try {
    var $75da31f4a46773b1$var$Mb = {};
    Object.defineProperty($75da31f4a46773b1$var$Mb, "passive", {
        get: function() {
            $75da31f4a46773b1$var$Lb = !0;
        }
    });
    window.addEventListener("test", $75da31f4a46773b1$var$Mb, $75da31f4a46773b1$var$Mb);
    window.removeEventListener("test", $75da31f4a46773b1$var$Mb, $75da31f4a46773b1$var$Mb);
} catch (a) {
    $75da31f4a46773b1$var$Lb = !1;
}
function $75da31f4a46773b1$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $75da31f4a46773b1$var$Ob = !1, $75da31f4a46773b1$var$Pb = null, $75da31f4a46773b1$var$Qb = !1, $75da31f4a46773b1$var$Rb = null, $75da31f4a46773b1$var$Sb = {
    onError: function(a) {
        $75da31f4a46773b1$var$Ob = !0;
        $75da31f4a46773b1$var$Pb = a;
    }
};
function $75da31f4a46773b1$var$Tb(a, b, c, d, e, f, g, h, k) {
    $75da31f4a46773b1$var$Ob = !1;
    $75da31f4a46773b1$var$Pb = null;
    $75da31f4a46773b1$var$Nb.apply($75da31f4a46773b1$var$Sb, arguments);
}
function $75da31f4a46773b1$var$Ub(a, b, c, d, e, f, g, h, k) {
    $75da31f4a46773b1$var$Tb.apply(this, arguments);
    if ($75da31f4a46773b1$var$Ob) {
        if ($75da31f4a46773b1$var$Ob) {
            var l = $75da31f4a46773b1$var$Pb;
            $75da31f4a46773b1$var$Ob = !1;
            $75da31f4a46773b1$var$Pb = null;
        } else throw Error($75da31f4a46773b1$var$p(198));
        $75da31f4a46773b1$var$Qb || ($75da31f4a46773b1$var$Qb = !0, $75da31f4a46773b1$var$Rb = l);
    }
}
function $75da31f4a46773b1$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $75da31f4a46773b1$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $75da31f4a46773b1$var$Xb(a) {
    if ($75da31f4a46773b1$var$Vb(a) !== a) throw Error($75da31f4a46773b1$var$p(188));
}
function $75da31f4a46773b1$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $75da31f4a46773b1$var$Vb(a);
        if (null === b) throw Error($75da31f4a46773b1$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $75da31f4a46773b1$var$Xb(e), a;
                if (f === d) return $75da31f4a46773b1$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($75da31f4a46773b1$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($75da31f4a46773b1$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($75da31f4a46773b1$var$p(190));
    }
    if (3 !== c.tag) throw Error($75da31f4a46773b1$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $75da31f4a46773b1$var$Zb(a) {
    a = $75da31f4a46773b1$var$Yb(a);
    return null !== a ? $75da31f4a46773b1$var$$b(a) : null;
}
function $75da31f4a46773b1$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $75da31f4a46773b1$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $75da31f4a46773b1$var$ac = $3CIn6.unstable_scheduleCallback, $75da31f4a46773b1$var$bc = $3CIn6.unstable_cancelCallback, $75da31f4a46773b1$var$cc = $3CIn6.unstable_shouldYield, $75da31f4a46773b1$var$dc = $3CIn6.unstable_requestPaint, $75da31f4a46773b1$var$B = $3CIn6.unstable_now, $75da31f4a46773b1$var$ec = $3CIn6.unstable_getCurrentPriorityLevel, $75da31f4a46773b1$var$fc = $3CIn6.unstable_ImmediatePriority, $75da31f4a46773b1$var$gc = $3CIn6.unstable_UserBlockingPriority, $75da31f4a46773b1$var$hc = $3CIn6.unstable_NormalPriority, $75da31f4a46773b1$var$ic = $3CIn6.unstable_LowPriority, $75da31f4a46773b1$var$jc = $3CIn6.unstable_IdlePriority, $75da31f4a46773b1$var$kc = null, $75da31f4a46773b1$var$lc = null;
function $75da31f4a46773b1$var$mc(a) {
    if ($75da31f4a46773b1$var$lc && "function" === typeof $75da31f4a46773b1$var$lc.onCommitFiberRoot) try {
        $75da31f4a46773b1$var$lc.onCommitFiberRoot($75da31f4a46773b1$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $75da31f4a46773b1$var$oc = Math.clz32 ? Math.clz32 : $75da31f4a46773b1$var$nc, $75da31f4a46773b1$var$pc = Math.log, $75da31f4a46773b1$var$qc = Math.LN2;
function $75da31f4a46773b1$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($75da31f4a46773b1$var$pc(a) / $75da31f4a46773b1$var$qc | 0) | 0;
}
var $75da31f4a46773b1$var$rc = 64, $75da31f4a46773b1$var$sc = 4194304;
function $75da31f4a46773b1$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $75da31f4a46773b1$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $75da31f4a46773b1$var$tc(h) : (f &= g, 0 !== f && (d = $75da31f4a46773b1$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $75da31f4a46773b1$var$tc(g) : 0 !== f && (d = $75da31f4a46773b1$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $75da31f4a46773b1$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $75da31f4a46773b1$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $75da31f4a46773b1$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $75da31f4a46773b1$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $75da31f4a46773b1$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $75da31f4a46773b1$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $75da31f4a46773b1$var$yc() {
    var a = $75da31f4a46773b1$var$rc;
    $75da31f4a46773b1$var$rc <<= 1;
    0 === ($75da31f4a46773b1$var$rc & 4194240) && ($75da31f4a46773b1$var$rc = 64);
    return a;
}
function $75da31f4a46773b1$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $75da31f4a46773b1$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $75da31f4a46773b1$var$oc(b);
    a[b] = c;
}
function $75da31f4a46773b1$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $75da31f4a46773b1$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $75da31f4a46773b1$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $75da31f4a46773b1$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $75da31f4a46773b1$var$C = 0;
function $75da31f4a46773b1$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $75da31f4a46773b1$var$Ec, $75da31f4a46773b1$var$Fc, $75da31f4a46773b1$var$Gc, $75da31f4a46773b1$var$Hc, $75da31f4a46773b1$var$Ic, $75da31f4a46773b1$var$Jc = !1, $75da31f4a46773b1$var$Kc = [], $75da31f4a46773b1$var$Lc = null, $75da31f4a46773b1$var$Mc = null, $75da31f4a46773b1$var$Nc = null, $75da31f4a46773b1$var$Oc = new Map, $75da31f4a46773b1$var$Pc = new Map, $75da31f4a46773b1$var$Qc = [], $75da31f4a46773b1$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $75da31f4a46773b1$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $75da31f4a46773b1$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $75da31f4a46773b1$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $75da31f4a46773b1$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $75da31f4a46773b1$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $75da31f4a46773b1$var$Pc.delete(b.pointerId);
    }
}
function $75da31f4a46773b1$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $75da31f4a46773b1$var$Cb(b), null !== b && $75da31f4a46773b1$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $75da31f4a46773b1$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $75da31f4a46773b1$var$Lc = $75da31f4a46773b1$var$Tc($75da31f4a46773b1$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $75da31f4a46773b1$var$Mc = $75da31f4a46773b1$var$Tc($75da31f4a46773b1$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $75da31f4a46773b1$var$Nc = $75da31f4a46773b1$var$Tc($75da31f4a46773b1$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $75da31f4a46773b1$var$Oc.set(f, $75da31f4a46773b1$var$Tc($75da31f4a46773b1$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $75da31f4a46773b1$var$Pc.set(f, $75da31f4a46773b1$var$Tc($75da31f4a46773b1$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $75da31f4a46773b1$var$Vc(a) {
    var b = $75da31f4a46773b1$var$Wc(a.target);
    if (null !== b) {
        var c = $75da31f4a46773b1$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $75da31f4a46773b1$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $75da31f4a46773b1$var$Ic(a.priority, function() {
                        $75da31f4a46773b1$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $75da31f4a46773b1$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $75da31f4a46773b1$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $75da31f4a46773b1$var$wb = d;
            c.target.dispatchEvent(d);
            $75da31f4a46773b1$var$wb = null;
        } else return b = $75da31f4a46773b1$var$Cb(c), null !== b && $75da31f4a46773b1$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $75da31f4a46773b1$var$Zc(a, b, c) {
    $75da31f4a46773b1$var$Xc(a) && c.delete(b);
}
function $75da31f4a46773b1$var$$c() {
    $75da31f4a46773b1$var$Jc = !1;
    null !== $75da31f4a46773b1$var$Lc && $75da31f4a46773b1$var$Xc($75da31f4a46773b1$var$Lc) && ($75da31f4a46773b1$var$Lc = null);
    null !== $75da31f4a46773b1$var$Mc && $75da31f4a46773b1$var$Xc($75da31f4a46773b1$var$Mc) && ($75da31f4a46773b1$var$Mc = null);
    null !== $75da31f4a46773b1$var$Nc && $75da31f4a46773b1$var$Xc($75da31f4a46773b1$var$Nc) && ($75da31f4a46773b1$var$Nc = null);
    $75da31f4a46773b1$var$Oc.forEach($75da31f4a46773b1$var$Zc);
    $75da31f4a46773b1$var$Pc.forEach($75da31f4a46773b1$var$Zc);
}
function $75da31f4a46773b1$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $75da31f4a46773b1$var$Jc || ($75da31f4a46773b1$var$Jc = !0, $3CIn6.unstable_scheduleCallback($3CIn6.unstable_NormalPriority, $75da31f4a46773b1$var$$c)));
}
function $75da31f4a46773b1$var$bd(a) {
    function b(b) {
        return $75da31f4a46773b1$var$ad(b, a);
    }
    if (0 < $75da31f4a46773b1$var$Kc.length) {
        $75da31f4a46773b1$var$ad($75da31f4a46773b1$var$Kc[0], a);
        for(var c = 1; c < $75da31f4a46773b1$var$Kc.length; c++){
            var d = $75da31f4a46773b1$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $75da31f4a46773b1$var$Lc && $75da31f4a46773b1$var$ad($75da31f4a46773b1$var$Lc, a);
    null !== $75da31f4a46773b1$var$Mc && $75da31f4a46773b1$var$ad($75da31f4a46773b1$var$Mc, a);
    null !== $75da31f4a46773b1$var$Nc && $75da31f4a46773b1$var$ad($75da31f4a46773b1$var$Nc, a);
    $75da31f4a46773b1$var$Oc.forEach(b);
    $75da31f4a46773b1$var$Pc.forEach(b);
    for(c = 0; c < $75da31f4a46773b1$var$Qc.length; c++)d = $75da31f4a46773b1$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $75da31f4a46773b1$var$Qc.length && (c = $75da31f4a46773b1$var$Qc[0], null === c.blockedOn);)$75da31f4a46773b1$var$Vc(c), null === c.blockedOn && $75da31f4a46773b1$var$Qc.shift();
}
var $75da31f4a46773b1$var$cd = $75da31f4a46773b1$var$ua.ReactCurrentBatchConfig, $75da31f4a46773b1$var$dd = !0;
function $75da31f4a46773b1$var$ed(a, b, c, d) {
    var e = $75da31f4a46773b1$var$C, f = $75da31f4a46773b1$var$cd.transition;
    $75da31f4a46773b1$var$cd.transition = null;
    try {
        $75da31f4a46773b1$var$C = 1, $75da31f4a46773b1$var$fd(a, b, c, d);
    } finally{
        $75da31f4a46773b1$var$C = e, $75da31f4a46773b1$var$cd.transition = f;
    }
}
function $75da31f4a46773b1$var$gd(a, b, c, d) {
    var e = $75da31f4a46773b1$var$C, f = $75da31f4a46773b1$var$cd.transition;
    $75da31f4a46773b1$var$cd.transition = null;
    try {
        $75da31f4a46773b1$var$C = 4, $75da31f4a46773b1$var$fd(a, b, c, d);
    } finally{
        $75da31f4a46773b1$var$C = e, $75da31f4a46773b1$var$cd.transition = f;
    }
}
function $75da31f4a46773b1$var$fd(a, b, c, d) {
    if ($75da31f4a46773b1$var$dd) {
        var e = $75da31f4a46773b1$var$Yc(a, b, c, d);
        if (null === e) $75da31f4a46773b1$var$hd(a, b, d, $75da31f4a46773b1$var$id, c), $75da31f4a46773b1$var$Sc(a, d);
        else if ($75da31f4a46773b1$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($75da31f4a46773b1$var$Sc(a, d), b & 4 && -1 < $75da31f4a46773b1$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $75da31f4a46773b1$var$Cb(e);
                null !== f && $75da31f4a46773b1$var$Ec(f);
                f = $75da31f4a46773b1$var$Yc(a, b, c, d);
                null === f && $75da31f4a46773b1$var$hd(a, b, d, $75da31f4a46773b1$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $75da31f4a46773b1$var$hd(a, b, d, null, c);
    }
}
var $75da31f4a46773b1$var$id = null;
function $75da31f4a46773b1$var$Yc(a, b, c, d) {
    $75da31f4a46773b1$var$id = null;
    a = $75da31f4a46773b1$var$xb(d);
    a = $75da31f4a46773b1$var$Wc(a);
    if (null !== a) {
        if (b = $75da31f4a46773b1$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $75da31f4a46773b1$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $75da31f4a46773b1$var$id = a;
    return null;
}
function $75da31f4a46773b1$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($75da31f4a46773b1$var$ec()){
                case $75da31f4a46773b1$var$fc:
                    return 1;
                case $75da31f4a46773b1$var$gc:
                    return 4;
                case $75da31f4a46773b1$var$hc:
                case $75da31f4a46773b1$var$ic:
                    return 16;
                case $75da31f4a46773b1$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $75da31f4a46773b1$var$kd = null, $75da31f4a46773b1$var$ld = null, $75da31f4a46773b1$var$md = null;
function $75da31f4a46773b1$var$nd() {
    if ($75da31f4a46773b1$var$md) return $75da31f4a46773b1$var$md;
    var a, b = $75da31f4a46773b1$var$ld, c = b.length, d, e = "value" in $75da31f4a46773b1$var$kd ? $75da31f4a46773b1$var$kd.value : $75da31f4a46773b1$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $75da31f4a46773b1$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $75da31f4a46773b1$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $75da31f4a46773b1$var$pd() {
    return !0;
}
function $75da31f4a46773b1$var$qd() {
    return !1;
}
function $75da31f4a46773b1$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $75da31f4a46773b1$var$pd : $75da31f4a46773b1$var$qd;
        this.isPropagationStopped = $75da31f4a46773b1$var$qd;
        return this;
    }
    $75da31f4a46773b1$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $75da31f4a46773b1$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $75da31f4a46773b1$var$pd);
        },
        persist: function() {},
        isPersistent: $75da31f4a46773b1$var$pd
    });
    return b;
}
var $75da31f4a46773b1$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $75da31f4a46773b1$var$td = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$sd), $75da31f4a46773b1$var$ud = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$sd, {
    view: 0,
    detail: 0
}), $75da31f4a46773b1$var$vd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$ud), $75da31f4a46773b1$var$wd, $75da31f4a46773b1$var$xd, $75da31f4a46773b1$var$yd, $75da31f4a46773b1$var$Ad = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $75da31f4a46773b1$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $75da31f4a46773b1$var$yd && ($75da31f4a46773b1$var$yd && "mousemove" === a.type ? ($75da31f4a46773b1$var$wd = a.screenX - $75da31f4a46773b1$var$yd.screenX, $75da31f4a46773b1$var$xd = a.screenY - $75da31f4a46773b1$var$yd.screenY) : $75da31f4a46773b1$var$xd = $75da31f4a46773b1$var$wd = 0, $75da31f4a46773b1$var$yd = a);
        return $75da31f4a46773b1$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $75da31f4a46773b1$var$xd;
    }
}), $75da31f4a46773b1$var$Bd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Ad), $75da31f4a46773b1$var$Cd = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$Ad, {
    dataTransfer: 0
}), $75da31f4a46773b1$var$Dd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Cd), $75da31f4a46773b1$var$Ed = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$ud, {
    relatedTarget: 0
}), $75da31f4a46773b1$var$Fd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Ed), $75da31f4a46773b1$var$Gd = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $75da31f4a46773b1$var$Hd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Gd), $75da31f4a46773b1$var$Id = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $75da31f4a46773b1$var$Jd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Id), $75da31f4a46773b1$var$Kd = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$sd, {
    data: 0
}), $75da31f4a46773b1$var$Ld = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Kd), $75da31f4a46773b1$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $75da31f4a46773b1$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $75da31f4a46773b1$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $75da31f4a46773b1$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $75da31f4a46773b1$var$Od[a]) ? !!b[a] : !1;
}
function $75da31f4a46773b1$var$zd() {
    return $75da31f4a46773b1$var$Pd;
}
var $75da31f4a46773b1$var$Qd = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $75da31f4a46773b1$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $75da31f4a46773b1$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $75da31f4a46773b1$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $75da31f4a46773b1$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $75da31f4a46773b1$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $75da31f4a46773b1$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $75da31f4a46773b1$var$Rd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Qd), $75da31f4a46773b1$var$Sd = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $75da31f4a46773b1$var$Td = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Sd), $75da31f4a46773b1$var$Ud = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $75da31f4a46773b1$var$zd
}), $75da31f4a46773b1$var$Vd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Ud), $75da31f4a46773b1$var$Wd = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $75da31f4a46773b1$var$Xd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Wd), $75da31f4a46773b1$var$Yd = $75da31f4a46773b1$var$A({}, $75da31f4a46773b1$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $75da31f4a46773b1$var$Zd = $75da31f4a46773b1$var$rd($75da31f4a46773b1$var$Yd), $75da31f4a46773b1$var$$d = [
    9,
    13,
    27,
    32
], $75da31f4a46773b1$var$ae = $75da31f4a46773b1$var$ia && "CompositionEvent" in window, $75da31f4a46773b1$var$be = null;
$75da31f4a46773b1$var$ia && "documentMode" in document && ($75da31f4a46773b1$var$be = document.documentMode);
var $75da31f4a46773b1$var$ce = $75da31f4a46773b1$var$ia && "TextEvent" in window && !$75da31f4a46773b1$var$be, $75da31f4a46773b1$var$de = $75da31f4a46773b1$var$ia && (!$75da31f4a46773b1$var$ae || $75da31f4a46773b1$var$be && 8 < $75da31f4a46773b1$var$be && 11 >= $75da31f4a46773b1$var$be), $75da31f4a46773b1$var$ee = String.fromCharCode(32), $75da31f4a46773b1$var$fe = !1;
function $75da31f4a46773b1$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $75da31f4a46773b1$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $75da31f4a46773b1$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $75da31f4a46773b1$var$ie = !1;
function $75da31f4a46773b1$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $75da31f4a46773b1$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $75da31f4a46773b1$var$fe = !0;
            return $75da31f4a46773b1$var$ee;
        case "textInput":
            return a = b.data, a === $75da31f4a46773b1$var$ee && $75da31f4a46773b1$var$fe ? null : a;
        default:
            return null;
    }
}
function $75da31f4a46773b1$var$ke(a, b) {
    if ($75da31f4a46773b1$var$ie) return "compositionend" === a || !$75da31f4a46773b1$var$ae && $75da31f4a46773b1$var$ge(a, b) ? (a = $75da31f4a46773b1$var$nd(), $75da31f4a46773b1$var$md = $75da31f4a46773b1$var$ld = $75da31f4a46773b1$var$kd = null, $75da31f4a46773b1$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $75da31f4a46773b1$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $75da31f4a46773b1$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $75da31f4a46773b1$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$75da31f4a46773b1$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $75da31f4a46773b1$var$ne(a, b, c, d) {
    $75da31f4a46773b1$var$Eb(d);
    b = $75da31f4a46773b1$var$oe(b, "onChange");
    0 < b.length && (c = new $75da31f4a46773b1$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $75da31f4a46773b1$var$pe = null, $75da31f4a46773b1$var$qe = null;
function $75da31f4a46773b1$var$re(a) {
    $75da31f4a46773b1$var$se(a, 0);
}
function $75da31f4a46773b1$var$te(a) {
    var b = $75da31f4a46773b1$var$ue(a);
    if ($75da31f4a46773b1$var$Wa(b)) return a;
}
function $75da31f4a46773b1$var$ve(a, b) {
    if ("change" === a) return b;
}
var $75da31f4a46773b1$var$we = !1;
if ($75da31f4a46773b1$var$ia) {
    var $75da31f4a46773b1$var$xe;
    if ($75da31f4a46773b1$var$ia) {
        var $75da31f4a46773b1$var$ye = "oninput" in document;
        if (!$75da31f4a46773b1$var$ye) {
            var $75da31f4a46773b1$var$ze = document.createElement("div");
            $75da31f4a46773b1$var$ze.setAttribute("oninput", "return;");
            $75da31f4a46773b1$var$ye = "function" === typeof $75da31f4a46773b1$var$ze.oninput;
        }
        $75da31f4a46773b1$var$xe = $75da31f4a46773b1$var$ye;
    } else $75da31f4a46773b1$var$xe = !1;
    $75da31f4a46773b1$var$we = $75da31f4a46773b1$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $75da31f4a46773b1$var$Ae() {
    $75da31f4a46773b1$var$pe && ($75da31f4a46773b1$var$pe.detachEvent("onpropertychange", $75da31f4a46773b1$var$Be), $75da31f4a46773b1$var$qe = $75da31f4a46773b1$var$pe = null);
}
function $75da31f4a46773b1$var$Be(a) {
    if ("value" === a.propertyName && $75da31f4a46773b1$var$te($75da31f4a46773b1$var$qe)) {
        var b = [];
        $75da31f4a46773b1$var$ne(b, $75da31f4a46773b1$var$qe, a, $75da31f4a46773b1$var$xb(a));
        $75da31f4a46773b1$var$Jb($75da31f4a46773b1$var$re, b);
    }
}
function $75da31f4a46773b1$var$Ce(a, b, c) {
    "focusin" === a ? ($75da31f4a46773b1$var$Ae(), $75da31f4a46773b1$var$pe = b, $75da31f4a46773b1$var$qe = c, $75da31f4a46773b1$var$pe.attachEvent("onpropertychange", $75da31f4a46773b1$var$Be)) : "focusout" === a && $75da31f4a46773b1$var$Ae();
}
function $75da31f4a46773b1$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $75da31f4a46773b1$var$te($75da31f4a46773b1$var$qe);
}
function $75da31f4a46773b1$var$Ee(a, b) {
    if ("click" === a) return $75da31f4a46773b1$var$te(b);
}
function $75da31f4a46773b1$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $75da31f4a46773b1$var$te(b);
}
function $75da31f4a46773b1$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $75da31f4a46773b1$var$He = "function" === typeof Object.is ? Object.is : $75da31f4a46773b1$var$Ge;
function $75da31f4a46773b1$var$Ie(a, b) {
    if ($75da31f4a46773b1$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$75da31f4a46773b1$var$ja.call(b, e) || !$75da31f4a46773b1$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $75da31f4a46773b1$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $75da31f4a46773b1$var$Ke(a, b) {
    var c = $75da31f4a46773b1$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $75da31f4a46773b1$var$Je(c);
    }
}
function $75da31f4a46773b1$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $75da31f4a46773b1$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $75da31f4a46773b1$var$Me() {
    for(var a = window, b = $75da31f4a46773b1$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $75da31f4a46773b1$var$Xa(a.document);
    }
    return b;
}
function $75da31f4a46773b1$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $75da31f4a46773b1$var$Oe(a) {
    var b = $75da31f4a46773b1$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $75da31f4a46773b1$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $75da31f4a46773b1$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $75da31f4a46773b1$var$Ke(c, f);
                var g = $75da31f4a46773b1$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $75da31f4a46773b1$var$Pe = $75da31f4a46773b1$var$ia && "documentMode" in document && 11 >= document.documentMode, $75da31f4a46773b1$var$Qe = null, $75da31f4a46773b1$var$Re = null, $75da31f4a46773b1$var$Se = null, $75da31f4a46773b1$var$Te = !1;
function $75da31f4a46773b1$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $75da31f4a46773b1$var$Te || null == $75da31f4a46773b1$var$Qe || $75da31f4a46773b1$var$Qe !== $75da31f4a46773b1$var$Xa(d) || (d = $75da31f4a46773b1$var$Qe, "selectionStart" in d && $75da31f4a46773b1$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $75da31f4a46773b1$var$Se && $75da31f4a46773b1$var$Ie($75da31f4a46773b1$var$Se, d) || ($75da31f4a46773b1$var$Se = d, d = $75da31f4a46773b1$var$oe($75da31f4a46773b1$var$Re, "onSelect"), 0 < d.length && (b = new $75da31f4a46773b1$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $75da31f4a46773b1$var$Qe)));
}
function $75da31f4a46773b1$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $75da31f4a46773b1$var$We = {
    animationend: $75da31f4a46773b1$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $75da31f4a46773b1$var$Ve("Animation", "AnimationIteration"),
    animationstart: $75da31f4a46773b1$var$Ve("Animation", "AnimationStart"),
    transitionend: $75da31f4a46773b1$var$Ve("Transition", "TransitionEnd")
}, $75da31f4a46773b1$var$Xe = {}, $75da31f4a46773b1$var$Ye = {};
$75da31f4a46773b1$var$ia && ($75da31f4a46773b1$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $75da31f4a46773b1$var$We.animationend.animation, delete $75da31f4a46773b1$var$We.animationiteration.animation, delete $75da31f4a46773b1$var$We.animationstart.animation), "TransitionEvent" in window || delete $75da31f4a46773b1$var$We.transitionend.transition);
function $75da31f4a46773b1$var$Ze(a) {
    if ($75da31f4a46773b1$var$Xe[a]) return $75da31f4a46773b1$var$Xe[a];
    if (!$75da31f4a46773b1$var$We[a]) return a;
    var b = $75da31f4a46773b1$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $75da31f4a46773b1$var$Ye) return $75da31f4a46773b1$var$Xe[a] = b[c];
    return a;
}
var $75da31f4a46773b1$var$$e = $75da31f4a46773b1$var$Ze("animationend"), $75da31f4a46773b1$var$af = $75da31f4a46773b1$var$Ze("animationiteration"), $75da31f4a46773b1$var$bf = $75da31f4a46773b1$var$Ze("animationstart"), $75da31f4a46773b1$var$cf = $75da31f4a46773b1$var$Ze("transitionend"), $75da31f4a46773b1$var$df = new Map, $75da31f4a46773b1$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $75da31f4a46773b1$var$ff(a, b) {
    $75da31f4a46773b1$var$df.set(a, b);
    $75da31f4a46773b1$var$fa(b, [
        a
    ]);
}
for(var $75da31f4a46773b1$var$gf = 0; $75da31f4a46773b1$var$gf < $75da31f4a46773b1$var$ef.length; $75da31f4a46773b1$var$gf++){
    var $75da31f4a46773b1$var$hf = $75da31f4a46773b1$var$ef[$75da31f4a46773b1$var$gf], $75da31f4a46773b1$var$jf = $75da31f4a46773b1$var$hf.toLowerCase(), $75da31f4a46773b1$var$kf = $75da31f4a46773b1$var$hf[0].toUpperCase() + $75da31f4a46773b1$var$hf.slice(1);
    $75da31f4a46773b1$var$ff($75da31f4a46773b1$var$jf, "on" + $75da31f4a46773b1$var$kf);
}
$75da31f4a46773b1$var$ff($75da31f4a46773b1$var$$e, "onAnimationEnd");
$75da31f4a46773b1$var$ff($75da31f4a46773b1$var$af, "onAnimationIteration");
$75da31f4a46773b1$var$ff($75da31f4a46773b1$var$bf, "onAnimationStart");
$75da31f4a46773b1$var$ff("dblclick", "onDoubleClick");
$75da31f4a46773b1$var$ff("focusin", "onFocus");
$75da31f4a46773b1$var$ff("focusout", "onBlur");
$75da31f4a46773b1$var$ff($75da31f4a46773b1$var$cf, "onTransitionEnd");
$75da31f4a46773b1$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$75da31f4a46773b1$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$75da31f4a46773b1$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$75da31f4a46773b1$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$75da31f4a46773b1$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$75da31f4a46773b1$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$75da31f4a46773b1$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$75da31f4a46773b1$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$75da31f4a46773b1$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$75da31f4a46773b1$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $75da31f4a46773b1$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $75da31f4a46773b1$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($75da31f4a46773b1$var$lf));
function $75da31f4a46773b1$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $75da31f4a46773b1$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $75da31f4a46773b1$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $75da31f4a46773b1$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $75da31f4a46773b1$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($75da31f4a46773b1$var$Qb) throw a = $75da31f4a46773b1$var$Rb, $75da31f4a46773b1$var$Qb = !1, $75da31f4a46773b1$var$Rb = null, a;
}
function $75da31f4a46773b1$var$D(a, b) {
    var c = b[$75da31f4a46773b1$var$of];
    void 0 === c && (c = b[$75da31f4a46773b1$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($75da31f4a46773b1$var$pf(b, a, 2, !1), c.add(d));
}
function $75da31f4a46773b1$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $75da31f4a46773b1$var$pf(c, a, d, b);
}
var $75da31f4a46773b1$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $75da31f4a46773b1$var$sf(a) {
    if (!a[$75da31f4a46773b1$var$rf]) {
        a[$75da31f4a46773b1$var$rf] = !0;
        $75da31f4a46773b1$var$da.forEach(function(b) {
            "selectionchange" !== b && ($75da31f4a46773b1$var$mf.has(b) || $75da31f4a46773b1$var$qf(b, !1, a), $75da31f4a46773b1$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$75da31f4a46773b1$var$rf] || (b[$75da31f4a46773b1$var$rf] = !0, $75da31f4a46773b1$var$qf("selectionchange", !1, b));
    }
}
function $75da31f4a46773b1$var$pf(a, b, c, d) {
    switch($75da31f4a46773b1$var$jd(b)){
        case 1:
            var e = $75da31f4a46773b1$var$ed;
            break;
        case 4:
            e = $75da31f4a46773b1$var$gd;
            break;
        default:
            e = $75da31f4a46773b1$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$75da31f4a46773b1$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $75da31f4a46773b1$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $75da31f4a46773b1$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $75da31f4a46773b1$var$Jb(function() {
        var d = f, e = $75da31f4a46773b1$var$xb(c), g = [];
        a: {
            var h = $75da31f4a46773b1$var$df.get(a);
            if (void 0 !== h) {
                var k = $75da31f4a46773b1$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $75da31f4a46773b1$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $75da31f4a46773b1$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $75da31f4a46773b1$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $75da31f4a46773b1$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $75da31f4a46773b1$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $75da31f4a46773b1$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $75da31f4a46773b1$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $75da31f4a46773b1$var$Vd;
                        break;
                    case $75da31f4a46773b1$var$$e:
                    case $75da31f4a46773b1$var$af:
                    case $75da31f4a46773b1$var$bf:
                        k = $75da31f4a46773b1$var$Hd;
                        break;
                    case $75da31f4a46773b1$var$cf:
                        k = $75da31f4a46773b1$var$Xd;
                        break;
                    case "scroll":
                        k = $75da31f4a46773b1$var$vd;
                        break;
                    case "wheel":
                        k = $75da31f4a46773b1$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $75da31f4a46773b1$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $75da31f4a46773b1$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $75da31f4a46773b1$var$Kb(w, x), null != F && t.push($75da31f4a46773b1$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $75da31f4a46773b1$var$wb && (n = c.relatedTarget || c.fromElement) && ($75da31f4a46773b1$var$Wc(n) || n[$75da31f4a46773b1$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $75da31f4a46773b1$var$Wc(n) : null, null !== n && (J = $75da31f4a46773b1$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $75da31f4a46773b1$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $75da31f4a46773b1$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $75da31f4a46773b1$var$ue(k);
                        u = null == n ? h : $75da31f4a46773b1$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $75da31f4a46773b1$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $75da31f4a46773b1$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $75da31f4a46773b1$var$vf(F))u++;
                            for(; 0 < w - u;)t = $75da31f4a46773b1$var$vf(t), w--;
                            for(; 0 < u - w;)x = $75da31f4a46773b1$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $75da31f4a46773b1$var$vf(t);
                                x = $75da31f4a46773b1$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $75da31f4a46773b1$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $75da31f4a46773b1$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $75da31f4a46773b1$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $75da31f4a46773b1$var$ve;
                else if ($75da31f4a46773b1$var$me(h)) {
                    if ($75da31f4a46773b1$var$we) na = $75da31f4a46773b1$var$Fe;
                    else {
                        na = $75da31f4a46773b1$var$De;
                        var xa = $75da31f4a46773b1$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $75da31f4a46773b1$var$Ee);
                if (na && (na = na(a, d))) {
                    $75da31f4a46773b1$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $75da31f4a46773b1$var$cb(h, "number", h.value);
            }
            xa = d ? $75da31f4a46773b1$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($75da31f4a46773b1$var$me(xa) || "true" === xa.contentEditable) $75da31f4a46773b1$var$Qe = xa, $75da31f4a46773b1$var$Re = d, $75da31f4a46773b1$var$Se = null;
                    break;
                case "focusout":
                    $75da31f4a46773b1$var$Se = $75da31f4a46773b1$var$Re = $75da31f4a46773b1$var$Qe = null;
                    break;
                case "mousedown":
                    $75da31f4a46773b1$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $75da31f4a46773b1$var$Te = !1;
                    $75da31f4a46773b1$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($75da31f4a46773b1$var$Pe) break;
                case "keydown":
                case "keyup":
                    $75da31f4a46773b1$var$Ue(g, c, e);
            }
            var $a;
            if ($75da31f4a46773b1$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $75da31f4a46773b1$var$ie ? $75da31f4a46773b1$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($75da31f4a46773b1$var$de && "ko" !== c.locale && ($75da31f4a46773b1$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $75da31f4a46773b1$var$ie && ($a = $75da31f4a46773b1$var$nd()) : ($75da31f4a46773b1$var$kd = e, $75da31f4a46773b1$var$ld = "value" in $75da31f4a46773b1$var$kd ? $75da31f4a46773b1$var$kd.value : $75da31f4a46773b1$var$kd.textContent, $75da31f4a46773b1$var$ie = !0)), xa = $75da31f4a46773b1$var$oe(d, ba), 0 < xa.length && (ba = new $75da31f4a46773b1$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $75da31f4a46773b1$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $75da31f4a46773b1$var$ce ? $75da31f4a46773b1$var$je(a, c) : $75da31f4a46773b1$var$ke(a, c)) d = $75da31f4a46773b1$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $75da31f4a46773b1$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $75da31f4a46773b1$var$se(g, b);
    });
}
function $75da31f4a46773b1$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $75da31f4a46773b1$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $75da31f4a46773b1$var$Kb(a, c), null != f && d.unshift($75da31f4a46773b1$var$tf(a, f, e)), f = $75da31f4a46773b1$var$Kb(a, b), null != f && d.push($75da31f4a46773b1$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $75da31f4a46773b1$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $75da31f4a46773b1$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $75da31f4a46773b1$var$Kb(c, f), null != k && g.unshift($75da31f4a46773b1$var$tf(c, k, h))) : e || (k = $75da31f4a46773b1$var$Kb(c, f), null != k && g.push($75da31f4a46773b1$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $75da31f4a46773b1$var$xf = /\r\n?/g, $75da31f4a46773b1$var$yf = /\u0000|\uFFFD/g;
function $75da31f4a46773b1$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($75da31f4a46773b1$var$xf, "\n").replace($75da31f4a46773b1$var$yf, "");
}
function $75da31f4a46773b1$var$Af(a, b, c) {
    b = $75da31f4a46773b1$var$zf(b);
    if ($75da31f4a46773b1$var$zf(a) !== b && c) throw Error($75da31f4a46773b1$var$p(425));
}
function $75da31f4a46773b1$var$Bf() {}
var $75da31f4a46773b1$var$Cf = null, $75da31f4a46773b1$var$Df = null;
function $75da31f4a46773b1$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $75da31f4a46773b1$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $75da31f4a46773b1$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $75da31f4a46773b1$var$Hf = "function" === typeof Promise ? Promise : void 0, $75da31f4a46773b1$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $75da31f4a46773b1$var$Hf ? function(a) {
    return $75da31f4a46773b1$var$Hf.resolve(null).then(a).catch($75da31f4a46773b1$var$If);
} : $75da31f4a46773b1$var$Ff;
function $75da31f4a46773b1$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $75da31f4a46773b1$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $75da31f4a46773b1$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $75da31f4a46773b1$var$bd(b);
}
function $75da31f4a46773b1$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $75da31f4a46773b1$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $75da31f4a46773b1$var$Nf = Math.random().toString(36).slice(2), $75da31f4a46773b1$var$Of = "__reactFiber$" + $75da31f4a46773b1$var$Nf, $75da31f4a46773b1$var$Pf = "__reactProps$" + $75da31f4a46773b1$var$Nf, $75da31f4a46773b1$var$uf = "__reactContainer$" + $75da31f4a46773b1$var$Nf, $75da31f4a46773b1$var$of = "__reactEvents$" + $75da31f4a46773b1$var$Nf, $75da31f4a46773b1$var$Qf = "__reactListeners$" + $75da31f4a46773b1$var$Nf, $75da31f4a46773b1$var$Rf = "__reactHandles$" + $75da31f4a46773b1$var$Nf;
function $75da31f4a46773b1$var$Wc(a) {
    var b = a[$75da31f4a46773b1$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$75da31f4a46773b1$var$uf] || c[$75da31f4a46773b1$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $75da31f4a46773b1$var$Mf(a); null !== a;){
                if (c = a[$75da31f4a46773b1$var$Of]) return c;
                a = $75da31f4a46773b1$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $75da31f4a46773b1$var$Cb(a) {
    a = a[$75da31f4a46773b1$var$Of] || a[$75da31f4a46773b1$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $75da31f4a46773b1$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($75da31f4a46773b1$var$p(33));
}
function $75da31f4a46773b1$var$Db(a) {
    return a[$75da31f4a46773b1$var$Pf] || null;
}
var $75da31f4a46773b1$var$Sf = [], $75da31f4a46773b1$var$Tf = -1;
function $75da31f4a46773b1$var$Uf(a) {
    return {
        current: a
    };
}
function $75da31f4a46773b1$var$E(a) {
    0 > $75da31f4a46773b1$var$Tf || (a.current = $75da31f4a46773b1$var$Sf[$75da31f4a46773b1$var$Tf], $75da31f4a46773b1$var$Sf[$75da31f4a46773b1$var$Tf] = null, $75da31f4a46773b1$var$Tf--);
}
function $75da31f4a46773b1$var$G(a, b) {
    $75da31f4a46773b1$var$Tf++;
    $75da31f4a46773b1$var$Sf[$75da31f4a46773b1$var$Tf] = a.current;
    a.current = b;
}
var $75da31f4a46773b1$var$Vf = {}, $75da31f4a46773b1$var$H = $75da31f4a46773b1$var$Uf($75da31f4a46773b1$var$Vf), $75da31f4a46773b1$var$Wf = $75da31f4a46773b1$var$Uf(!1), $75da31f4a46773b1$var$Xf = $75da31f4a46773b1$var$Vf;
function $75da31f4a46773b1$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $75da31f4a46773b1$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $75da31f4a46773b1$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $75da31f4a46773b1$var$$f() {
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$Wf);
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$H);
}
function $75da31f4a46773b1$var$ag(a, b, c) {
    if ($75da31f4a46773b1$var$H.current !== $75da31f4a46773b1$var$Vf) throw Error($75da31f4a46773b1$var$p(168));
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$H, b);
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$Wf, c);
}
function $75da31f4a46773b1$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($75da31f4a46773b1$var$p(108, $75da31f4a46773b1$var$Ra(a) || "Unknown", e));
    return $75da31f4a46773b1$var$A({}, c, d);
}
function $75da31f4a46773b1$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $75da31f4a46773b1$var$Vf;
    $75da31f4a46773b1$var$Xf = $75da31f4a46773b1$var$H.current;
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$H, a);
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$Wf, $75da31f4a46773b1$var$Wf.current);
    return !0;
}
function $75da31f4a46773b1$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($75da31f4a46773b1$var$p(169));
    c ? (a = $75da31f4a46773b1$var$bg(a, b, $75da31f4a46773b1$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $75da31f4a46773b1$var$E($75da31f4a46773b1$var$Wf), $75da31f4a46773b1$var$E($75da31f4a46773b1$var$H), $75da31f4a46773b1$var$G($75da31f4a46773b1$var$H, a)) : $75da31f4a46773b1$var$E($75da31f4a46773b1$var$Wf);
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$Wf, c);
}
var $75da31f4a46773b1$var$eg = null, $75da31f4a46773b1$var$fg = !1, $75da31f4a46773b1$var$gg = !1;
function $75da31f4a46773b1$var$hg(a) {
    null === $75da31f4a46773b1$var$eg ? $75da31f4a46773b1$var$eg = [
        a
    ] : $75da31f4a46773b1$var$eg.push(a);
}
function $75da31f4a46773b1$var$ig(a) {
    $75da31f4a46773b1$var$fg = !0;
    $75da31f4a46773b1$var$hg(a);
}
function $75da31f4a46773b1$var$jg() {
    if (!$75da31f4a46773b1$var$gg && null !== $75da31f4a46773b1$var$eg) {
        $75da31f4a46773b1$var$gg = !0;
        var a = 0, b = $75da31f4a46773b1$var$C;
        try {
            var c = $75da31f4a46773b1$var$eg;
            for($75da31f4a46773b1$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $75da31f4a46773b1$var$eg = null;
            $75da31f4a46773b1$var$fg = !1;
        } catch (e) {
            throw null !== $75da31f4a46773b1$var$eg && ($75da31f4a46773b1$var$eg = $75da31f4a46773b1$var$eg.slice(a + 1)), $75da31f4a46773b1$var$ac($75da31f4a46773b1$var$fc, $75da31f4a46773b1$var$jg), e;
        } finally{
            $75da31f4a46773b1$var$C = b, $75da31f4a46773b1$var$gg = !1;
        }
    }
    return null;
}
var $75da31f4a46773b1$var$kg = [], $75da31f4a46773b1$var$lg = 0, $75da31f4a46773b1$var$mg = null, $75da31f4a46773b1$var$ng = 0, $75da31f4a46773b1$var$og = [], $75da31f4a46773b1$var$pg = 0, $75da31f4a46773b1$var$qg = null, $75da31f4a46773b1$var$rg = 1, $75da31f4a46773b1$var$sg = "";
function $75da31f4a46773b1$var$tg(a, b) {
    $75da31f4a46773b1$var$kg[$75da31f4a46773b1$var$lg++] = $75da31f4a46773b1$var$ng;
    $75da31f4a46773b1$var$kg[$75da31f4a46773b1$var$lg++] = $75da31f4a46773b1$var$mg;
    $75da31f4a46773b1$var$mg = a;
    $75da31f4a46773b1$var$ng = b;
}
function $75da31f4a46773b1$var$ug(a, b, c) {
    $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg++] = $75da31f4a46773b1$var$rg;
    $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg++] = $75da31f4a46773b1$var$sg;
    $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg++] = $75da31f4a46773b1$var$qg;
    $75da31f4a46773b1$var$qg = a;
    var d = $75da31f4a46773b1$var$rg;
    a = $75da31f4a46773b1$var$sg;
    var e = 32 - $75da31f4a46773b1$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $75da31f4a46773b1$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $75da31f4a46773b1$var$rg = 1 << 32 - $75da31f4a46773b1$var$oc(b) + e | c << e | d;
        $75da31f4a46773b1$var$sg = f + a;
    } else $75da31f4a46773b1$var$rg = 1 << f | c << e | d, $75da31f4a46773b1$var$sg = a;
}
function $75da31f4a46773b1$var$vg(a) {
    null !== a.return && ($75da31f4a46773b1$var$tg(a, 1), $75da31f4a46773b1$var$ug(a, 1, 0));
}
function $75da31f4a46773b1$var$wg(a) {
    for(; a === $75da31f4a46773b1$var$mg;)$75da31f4a46773b1$var$mg = $75da31f4a46773b1$var$kg[--$75da31f4a46773b1$var$lg], $75da31f4a46773b1$var$kg[$75da31f4a46773b1$var$lg] = null, $75da31f4a46773b1$var$ng = $75da31f4a46773b1$var$kg[--$75da31f4a46773b1$var$lg], $75da31f4a46773b1$var$kg[$75da31f4a46773b1$var$lg] = null;
    for(; a === $75da31f4a46773b1$var$qg;)$75da31f4a46773b1$var$qg = $75da31f4a46773b1$var$og[--$75da31f4a46773b1$var$pg], $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg] = null, $75da31f4a46773b1$var$sg = $75da31f4a46773b1$var$og[--$75da31f4a46773b1$var$pg], $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg] = null, $75da31f4a46773b1$var$rg = $75da31f4a46773b1$var$og[--$75da31f4a46773b1$var$pg], $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg] = null;
}
var $75da31f4a46773b1$var$xg = null, $75da31f4a46773b1$var$yg = null, $75da31f4a46773b1$var$I = !1, $75da31f4a46773b1$var$zg = null;
function $75da31f4a46773b1$var$Ag(a, b) {
    var c = $75da31f4a46773b1$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $75da31f4a46773b1$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $75da31f4a46773b1$var$xg = a, $75da31f4a46773b1$var$yg = $75da31f4a46773b1$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $75da31f4a46773b1$var$xg = a, $75da31f4a46773b1$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $75da31f4a46773b1$var$qg ? {
                id: $75da31f4a46773b1$var$rg,
                overflow: $75da31f4a46773b1$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $75da31f4a46773b1$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $75da31f4a46773b1$var$xg = a, $75da31f4a46773b1$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $75da31f4a46773b1$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $75da31f4a46773b1$var$Eg(a) {
    if ($75da31f4a46773b1$var$I) {
        var b = $75da31f4a46773b1$var$yg;
        if (b) {
            var c = b;
            if (!$75da31f4a46773b1$var$Cg(a, b)) {
                if ($75da31f4a46773b1$var$Dg(a)) throw Error($75da31f4a46773b1$var$p(418));
                b = $75da31f4a46773b1$var$Lf(c.nextSibling);
                var d = $75da31f4a46773b1$var$xg;
                b && $75da31f4a46773b1$var$Cg(a, b) ? $75da31f4a46773b1$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $75da31f4a46773b1$var$I = !1, $75da31f4a46773b1$var$xg = a);
            }
        } else {
            if ($75da31f4a46773b1$var$Dg(a)) throw Error($75da31f4a46773b1$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $75da31f4a46773b1$var$I = !1;
            $75da31f4a46773b1$var$xg = a;
        }
    }
}
function $75da31f4a46773b1$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $75da31f4a46773b1$var$xg = a;
}
function $75da31f4a46773b1$var$Gg(a) {
    if (a !== $75da31f4a46773b1$var$xg) return !1;
    if (!$75da31f4a46773b1$var$I) return $75da31f4a46773b1$var$Fg(a), $75da31f4a46773b1$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$75da31f4a46773b1$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $75da31f4a46773b1$var$yg)) {
        if ($75da31f4a46773b1$var$Dg(a)) throw $75da31f4a46773b1$var$Hg(), Error($75da31f4a46773b1$var$p(418));
        for(; b;)$75da31f4a46773b1$var$Ag(a, b), b = $75da31f4a46773b1$var$Lf(b.nextSibling);
    }
    $75da31f4a46773b1$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($75da31f4a46773b1$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $75da31f4a46773b1$var$yg = $75da31f4a46773b1$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $75da31f4a46773b1$var$yg = null;
        }
    } else $75da31f4a46773b1$var$yg = $75da31f4a46773b1$var$xg ? $75da31f4a46773b1$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $75da31f4a46773b1$var$Hg() {
    for(var a = $75da31f4a46773b1$var$yg; a;)a = $75da31f4a46773b1$var$Lf(a.nextSibling);
}
function $75da31f4a46773b1$var$Ig() {
    $75da31f4a46773b1$var$yg = $75da31f4a46773b1$var$xg = null;
    $75da31f4a46773b1$var$I = !1;
}
function $75da31f4a46773b1$var$Jg(a) {
    null === $75da31f4a46773b1$var$zg ? $75da31f4a46773b1$var$zg = [
        a
    ] : $75da31f4a46773b1$var$zg.push(a);
}
var $75da31f4a46773b1$var$Kg = $75da31f4a46773b1$var$ua.ReactCurrentBatchConfig;
function $75da31f4a46773b1$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($75da31f4a46773b1$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($75da31f4a46773b1$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($75da31f4a46773b1$var$p(284));
        if (!c._owner) throw Error($75da31f4a46773b1$var$p(290, a));
    }
    return a;
}
function $75da31f4a46773b1$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($75da31f4a46773b1$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $75da31f4a46773b1$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $75da31f4a46773b1$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $75da31f4a46773b1$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $75da31f4a46773b1$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $75da31f4a46773b1$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $75da31f4a46773b1$var$Ha && $75da31f4a46773b1$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $75da31f4a46773b1$var$Lg(a, b, c), d.return = a, d;
        d = $75da31f4a46773b1$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $75da31f4a46773b1$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $75da31f4a46773b1$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $75da31f4a46773b1$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $75da31f4a46773b1$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $75da31f4a46773b1$var$va:
                    return c = $75da31f4a46773b1$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $75da31f4a46773b1$var$Lg(a, null, b), c.return = a, c;
                case $75da31f4a46773b1$var$wa:
                    return b = $75da31f4a46773b1$var$Sg(b, a.mode, c), b.return = a, b;
                case $75da31f4a46773b1$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($75da31f4a46773b1$var$eb(b) || $75da31f4a46773b1$var$Ka(b)) return b = $75da31f4a46773b1$var$Tg(b, a.mode, c, null), b.return = a, b;
            $75da31f4a46773b1$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $75da31f4a46773b1$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $75da31f4a46773b1$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $75da31f4a46773b1$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($75da31f4a46773b1$var$eb(c) || $75da31f4a46773b1$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $75da31f4a46773b1$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $75da31f4a46773b1$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $75da31f4a46773b1$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $75da31f4a46773b1$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($75da31f4a46773b1$var$eb(d) || $75da31f4a46773b1$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $75da31f4a46773b1$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $75da31f4a46773b1$var$I && $75da31f4a46773b1$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $75da31f4a46773b1$var$I && $75da31f4a46773b1$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $75da31f4a46773b1$var$I && $75da31f4a46773b1$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $75da31f4a46773b1$var$Ka(h);
        if ("function" !== typeof l) throw Error($75da31f4a46773b1$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($75da31f4a46773b1$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $75da31f4a46773b1$var$I && $75da31f4a46773b1$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $75da31f4a46773b1$var$I && $75da31f4a46773b1$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $75da31f4a46773b1$var$I && $75da31f4a46773b1$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $75da31f4a46773b1$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $75da31f4a46773b1$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $75da31f4a46773b1$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $75da31f4a46773b1$var$Ha && $75da31f4a46773b1$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $75da31f4a46773b1$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $75da31f4a46773b1$var$ya ? (d = $75da31f4a46773b1$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $75da31f4a46773b1$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $75da31f4a46773b1$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $75da31f4a46773b1$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $75da31f4a46773b1$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $75da31f4a46773b1$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($75da31f4a46773b1$var$eb(f)) return n(a, d, f, h);
            if ($75da31f4a46773b1$var$Ka(f)) return t(a, d, f, h);
            $75da31f4a46773b1$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $75da31f4a46773b1$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $75da31f4a46773b1$var$Ug = $75da31f4a46773b1$var$Og(!0), $75da31f4a46773b1$var$Vg = $75da31f4a46773b1$var$Og(!1), $75da31f4a46773b1$var$Wg = $75da31f4a46773b1$var$Uf(null), $75da31f4a46773b1$var$Xg = null, $75da31f4a46773b1$var$Yg = null, $75da31f4a46773b1$var$Zg = null;
function $75da31f4a46773b1$var$$g() {
    $75da31f4a46773b1$var$Zg = $75da31f4a46773b1$var$Yg = $75da31f4a46773b1$var$Xg = null;
}
function $75da31f4a46773b1$var$ah(a) {
    var b = $75da31f4a46773b1$var$Wg.current;
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$Wg);
    a._currentValue = b;
}
function $75da31f4a46773b1$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $75da31f4a46773b1$var$ch(a, b) {
    $75da31f4a46773b1$var$Xg = a;
    $75da31f4a46773b1$var$Zg = $75da31f4a46773b1$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($75da31f4a46773b1$var$dh = !0), a.firstContext = null);
}
function $75da31f4a46773b1$var$eh(a) {
    var b = a._currentValue;
    if ($75da31f4a46773b1$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $75da31f4a46773b1$var$Yg) {
            if (null === $75da31f4a46773b1$var$Xg) throw Error($75da31f4a46773b1$var$p(308));
            $75da31f4a46773b1$var$Yg = a;
            $75da31f4a46773b1$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $75da31f4a46773b1$var$Yg = $75da31f4a46773b1$var$Yg.next = a;
    }
    return b;
}
var $75da31f4a46773b1$var$fh = null;
function $75da31f4a46773b1$var$gh(a) {
    null === $75da31f4a46773b1$var$fh ? $75da31f4a46773b1$var$fh = [
        a
    ] : $75da31f4a46773b1$var$fh.push(a);
}
function $75da31f4a46773b1$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $75da31f4a46773b1$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $75da31f4a46773b1$var$ih(a, d);
}
function $75da31f4a46773b1$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $75da31f4a46773b1$var$jh = !1;
function $75da31f4a46773b1$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $75da31f4a46773b1$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $75da31f4a46773b1$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $75da31f4a46773b1$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($75da31f4a46773b1$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $75da31f4a46773b1$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $75da31f4a46773b1$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $75da31f4a46773b1$var$ih(a, c);
}
function $75da31f4a46773b1$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $75da31f4a46773b1$var$Cc(a, c);
    }
}
function $75da31f4a46773b1$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $75da31f4a46773b1$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $75da31f4a46773b1$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $75da31f4a46773b1$var$A({}, q, r);
                            break a;
                        case 2:
                            $75da31f4a46773b1$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $75da31f4a46773b1$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $75da31f4a46773b1$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($75da31f4a46773b1$var$p(191, e));
            e.call(d);
        }
    }
}
var $75da31f4a46773b1$var$th = {}, $75da31f4a46773b1$var$uh = $75da31f4a46773b1$var$Uf($75da31f4a46773b1$var$th), $75da31f4a46773b1$var$vh = $75da31f4a46773b1$var$Uf($75da31f4a46773b1$var$th), $75da31f4a46773b1$var$wh = $75da31f4a46773b1$var$Uf($75da31f4a46773b1$var$th);
function $75da31f4a46773b1$var$xh(a) {
    if (a === $75da31f4a46773b1$var$th) throw Error($75da31f4a46773b1$var$p(174));
    return a;
}
function $75da31f4a46773b1$var$yh(a, b) {
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$wh, b);
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$vh, a);
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$uh, $75da31f4a46773b1$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $75da31f4a46773b1$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $75da31f4a46773b1$var$lb(b, a);
    }
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$uh);
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$uh, b);
}
function $75da31f4a46773b1$var$zh() {
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$uh);
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$vh);
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$wh);
}
function $75da31f4a46773b1$var$Ah(a) {
    $75da31f4a46773b1$var$xh($75da31f4a46773b1$var$wh.current);
    var b = $75da31f4a46773b1$var$xh($75da31f4a46773b1$var$uh.current);
    var c = $75da31f4a46773b1$var$lb(b, a.type);
    b !== c && ($75da31f4a46773b1$var$G($75da31f4a46773b1$var$vh, a), $75da31f4a46773b1$var$G($75da31f4a46773b1$var$uh, c));
}
function $75da31f4a46773b1$var$Bh(a) {
    $75da31f4a46773b1$var$vh.current === a && ($75da31f4a46773b1$var$E($75da31f4a46773b1$var$uh), $75da31f4a46773b1$var$E($75da31f4a46773b1$var$vh));
}
var $75da31f4a46773b1$var$L = $75da31f4a46773b1$var$Uf(0);
function $75da31f4a46773b1$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $75da31f4a46773b1$var$Dh = [];
function $75da31f4a46773b1$var$Eh() {
    for(var a = 0; a < $75da31f4a46773b1$var$Dh.length; a++)$75da31f4a46773b1$var$Dh[a]._workInProgressVersionPrimary = null;
    $75da31f4a46773b1$var$Dh.length = 0;
}
var $75da31f4a46773b1$var$Fh = $75da31f4a46773b1$var$ua.ReactCurrentDispatcher, $75da31f4a46773b1$var$Gh = $75da31f4a46773b1$var$ua.ReactCurrentBatchConfig, $75da31f4a46773b1$var$Hh = 0, $75da31f4a46773b1$var$M = null, $75da31f4a46773b1$var$N = null, $75da31f4a46773b1$var$O = null, $75da31f4a46773b1$var$Ih = !1, $75da31f4a46773b1$var$Jh = !1, $75da31f4a46773b1$var$Kh = 0, $75da31f4a46773b1$var$Lh = 0;
function $75da31f4a46773b1$var$P() {
    throw Error($75da31f4a46773b1$var$p(321));
}
function $75da31f4a46773b1$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$75da31f4a46773b1$var$He(a[c], b[c])) return !1;
    return !0;
}
function $75da31f4a46773b1$var$Nh(a, b, c, d, e, f) {
    $75da31f4a46773b1$var$Hh = f;
    $75da31f4a46773b1$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $75da31f4a46773b1$var$Fh.current = null === a || null === a.memoizedState ? $75da31f4a46773b1$var$Oh : $75da31f4a46773b1$var$Ph;
    a = c(d, e);
    if ($75da31f4a46773b1$var$Jh) {
        f = 0;
        do {
            $75da31f4a46773b1$var$Jh = !1;
            $75da31f4a46773b1$var$Kh = 0;
            if (25 <= f) throw Error($75da31f4a46773b1$var$p(301));
            f += 1;
            $75da31f4a46773b1$var$O = $75da31f4a46773b1$var$N = null;
            b.updateQueue = null;
            $75da31f4a46773b1$var$Fh.current = $75da31f4a46773b1$var$Qh;
            a = c(d, e);
        }while ($75da31f4a46773b1$var$Jh);
    }
    $75da31f4a46773b1$var$Fh.current = $75da31f4a46773b1$var$Rh;
    b = null !== $75da31f4a46773b1$var$N && null !== $75da31f4a46773b1$var$N.next;
    $75da31f4a46773b1$var$Hh = 0;
    $75da31f4a46773b1$var$O = $75da31f4a46773b1$var$N = $75da31f4a46773b1$var$M = null;
    $75da31f4a46773b1$var$Ih = !1;
    if (b) throw Error($75da31f4a46773b1$var$p(300));
    return a;
}
function $75da31f4a46773b1$var$Sh() {
    var a = 0 !== $75da31f4a46773b1$var$Kh;
    $75da31f4a46773b1$var$Kh = 0;
    return a;
}
function $75da31f4a46773b1$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $75da31f4a46773b1$var$O ? $75da31f4a46773b1$var$M.memoizedState = $75da31f4a46773b1$var$O = a : $75da31f4a46773b1$var$O = $75da31f4a46773b1$var$O.next = a;
    return $75da31f4a46773b1$var$O;
}
function $75da31f4a46773b1$var$Uh() {
    if (null === $75da31f4a46773b1$var$N) {
        var a = $75da31f4a46773b1$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $75da31f4a46773b1$var$N.next;
    var b = null === $75da31f4a46773b1$var$O ? $75da31f4a46773b1$var$M.memoizedState : $75da31f4a46773b1$var$O.next;
    if (null !== b) $75da31f4a46773b1$var$O = b, $75da31f4a46773b1$var$N = a;
    else {
        if (null === a) throw Error($75da31f4a46773b1$var$p(310));
        $75da31f4a46773b1$var$N = a;
        a = {
            memoizedState: $75da31f4a46773b1$var$N.memoizedState,
            baseState: $75da31f4a46773b1$var$N.baseState,
            baseQueue: $75da31f4a46773b1$var$N.baseQueue,
            queue: $75da31f4a46773b1$var$N.queue,
            next: null
        };
        null === $75da31f4a46773b1$var$O ? $75da31f4a46773b1$var$M.memoizedState = $75da31f4a46773b1$var$O = a : $75da31f4a46773b1$var$O = $75da31f4a46773b1$var$O.next = a;
    }
    return $75da31f4a46773b1$var$O;
}
function $75da31f4a46773b1$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $75da31f4a46773b1$var$Wh(a) {
    var b = $75da31f4a46773b1$var$Uh(), c = b.queue;
    if (null === c) throw Error($75da31f4a46773b1$var$p(311));
    c.lastRenderedReducer = a;
    var d = $75da31f4a46773b1$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($75da31f4a46773b1$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $75da31f4a46773b1$var$M.lanes |= m;
                $75da31f4a46773b1$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $75da31f4a46773b1$var$He(d, b.memoizedState) || ($75da31f4a46773b1$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $75da31f4a46773b1$var$M.lanes |= f, $75da31f4a46773b1$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $75da31f4a46773b1$var$Xh(a) {
    var b = $75da31f4a46773b1$var$Uh(), c = b.queue;
    if (null === c) throw Error($75da31f4a46773b1$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $75da31f4a46773b1$var$He(f, b.memoizedState) || ($75da31f4a46773b1$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $75da31f4a46773b1$var$Yh() {}
function $75da31f4a46773b1$var$Zh(a, b) {
    var c = $75da31f4a46773b1$var$M, d = $75da31f4a46773b1$var$Uh(), e = b(), f = !$75da31f4a46773b1$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $75da31f4a46773b1$var$dh = !0);
    d = d.queue;
    $75da31f4a46773b1$var$$h($75da31f4a46773b1$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $75da31f4a46773b1$var$O && $75da31f4a46773b1$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $75da31f4a46773b1$var$bi(9, $75da31f4a46773b1$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $75da31f4a46773b1$var$Q) throw Error($75da31f4a46773b1$var$p(349));
        0 !== ($75da31f4a46773b1$var$Hh & 30) || $75da31f4a46773b1$var$di(c, b, e);
    }
    return e;
}
function $75da31f4a46773b1$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $75da31f4a46773b1$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $75da31f4a46773b1$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $75da31f4a46773b1$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $75da31f4a46773b1$var$ei(b) && $75da31f4a46773b1$var$fi(a);
}
function $75da31f4a46773b1$var$ai(a, b, c) {
    return c(function() {
        $75da31f4a46773b1$var$ei(b) && $75da31f4a46773b1$var$fi(a);
    });
}
function $75da31f4a46773b1$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$75da31f4a46773b1$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $75da31f4a46773b1$var$fi(a) {
    var b = $75da31f4a46773b1$var$ih(a, 1);
    null !== b && $75da31f4a46773b1$var$gi(b, a, 1, -1);
}
function $75da31f4a46773b1$var$hi(a) {
    var b = $75da31f4a46773b1$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $75da31f4a46773b1$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $75da31f4a46773b1$var$ii.bind(null, $75da31f4a46773b1$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $75da31f4a46773b1$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $75da31f4a46773b1$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $75da31f4a46773b1$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $75da31f4a46773b1$var$ji() {
    return $75da31f4a46773b1$var$Uh().memoizedState;
}
function $75da31f4a46773b1$var$ki(a, b, c, d) {
    var e = $75da31f4a46773b1$var$Th();
    $75da31f4a46773b1$var$M.flags |= a;
    e.memoizedState = $75da31f4a46773b1$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $75da31f4a46773b1$var$li(a, b, c, d) {
    var e = $75da31f4a46773b1$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $75da31f4a46773b1$var$N) {
        var g = $75da31f4a46773b1$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $75da31f4a46773b1$var$Mh(d, g.deps)) {
            e.memoizedState = $75da31f4a46773b1$var$bi(b, c, f, d);
            return;
        }
    }
    $75da31f4a46773b1$var$M.flags |= a;
    e.memoizedState = $75da31f4a46773b1$var$bi(1 | b, c, f, d);
}
function $75da31f4a46773b1$var$mi(a, b) {
    return $75da31f4a46773b1$var$ki(8390656, 8, a, b);
}
function $75da31f4a46773b1$var$$h(a, b) {
    return $75da31f4a46773b1$var$li(2048, 8, a, b);
}
function $75da31f4a46773b1$var$ni(a, b) {
    return $75da31f4a46773b1$var$li(4, 2, a, b);
}
function $75da31f4a46773b1$var$oi(a, b) {
    return $75da31f4a46773b1$var$li(4, 4, a, b);
}
function $75da31f4a46773b1$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $75da31f4a46773b1$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $75da31f4a46773b1$var$li(4, 4, $75da31f4a46773b1$var$pi.bind(null, b, a), c);
}
function $75da31f4a46773b1$var$ri() {}
function $75da31f4a46773b1$var$si(a, b) {
    var c = $75da31f4a46773b1$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $75da31f4a46773b1$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $75da31f4a46773b1$var$ti(a, b) {
    var c = $75da31f4a46773b1$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $75da31f4a46773b1$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $75da31f4a46773b1$var$ui(a, b, c) {
    if (0 === ($75da31f4a46773b1$var$Hh & 21)) return a.baseState && (a.baseState = !1, $75da31f4a46773b1$var$dh = !0), a.memoizedState = c;
    $75da31f4a46773b1$var$He(c, b) || (c = $75da31f4a46773b1$var$yc(), $75da31f4a46773b1$var$M.lanes |= c, $75da31f4a46773b1$var$rh |= c, a.baseState = !0);
    return b;
}
function $75da31f4a46773b1$var$vi(a, b) {
    var c = $75da31f4a46773b1$var$C;
    $75da31f4a46773b1$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $75da31f4a46773b1$var$Gh.transition;
    $75da31f4a46773b1$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $75da31f4a46773b1$var$C = c, $75da31f4a46773b1$var$Gh.transition = d;
    }
}
function $75da31f4a46773b1$var$wi() {
    return $75da31f4a46773b1$var$Uh().memoizedState;
}
function $75da31f4a46773b1$var$xi(a, b, c) {
    var d = $75da31f4a46773b1$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($75da31f4a46773b1$var$zi(a)) $75da31f4a46773b1$var$Ai(b, c);
    else if (c = $75da31f4a46773b1$var$hh(a, b, c, d), null !== c) {
        var e = $75da31f4a46773b1$var$R();
        $75da31f4a46773b1$var$gi(c, a, d, e);
        $75da31f4a46773b1$var$Bi(c, b, d);
    }
}
function $75da31f4a46773b1$var$ii(a, b, c) {
    var d = $75da31f4a46773b1$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($75da31f4a46773b1$var$zi(a)) $75da31f4a46773b1$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($75da31f4a46773b1$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $75da31f4a46773b1$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $75da31f4a46773b1$var$hh(a, b, e, d);
        null !== c && (e = $75da31f4a46773b1$var$R(), $75da31f4a46773b1$var$gi(c, a, d, e), $75da31f4a46773b1$var$Bi(c, b, d));
    }
}
function $75da31f4a46773b1$var$zi(a) {
    var b = a.alternate;
    return a === $75da31f4a46773b1$var$M || null !== b && b === $75da31f4a46773b1$var$M;
}
function $75da31f4a46773b1$var$Ai(a, b) {
    $75da31f4a46773b1$var$Jh = $75da31f4a46773b1$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $75da31f4a46773b1$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $75da31f4a46773b1$var$Cc(a, c);
    }
}
var $75da31f4a46773b1$var$Rh = {
    readContext: $75da31f4a46773b1$var$eh,
    useCallback: $75da31f4a46773b1$var$P,
    useContext: $75da31f4a46773b1$var$P,
    useEffect: $75da31f4a46773b1$var$P,
    useImperativeHandle: $75da31f4a46773b1$var$P,
    useInsertionEffect: $75da31f4a46773b1$var$P,
    useLayoutEffect: $75da31f4a46773b1$var$P,
    useMemo: $75da31f4a46773b1$var$P,
    useReducer: $75da31f4a46773b1$var$P,
    useRef: $75da31f4a46773b1$var$P,
    useState: $75da31f4a46773b1$var$P,
    useDebugValue: $75da31f4a46773b1$var$P,
    useDeferredValue: $75da31f4a46773b1$var$P,
    useTransition: $75da31f4a46773b1$var$P,
    useMutableSource: $75da31f4a46773b1$var$P,
    useSyncExternalStore: $75da31f4a46773b1$var$P,
    useId: $75da31f4a46773b1$var$P,
    unstable_isNewReconciler: !1
}, $75da31f4a46773b1$var$Oh = {
    readContext: $75da31f4a46773b1$var$eh,
    useCallback: function(a, b) {
        $75da31f4a46773b1$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $75da31f4a46773b1$var$eh,
    useEffect: $75da31f4a46773b1$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $75da31f4a46773b1$var$ki(4194308, 4, $75da31f4a46773b1$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $75da31f4a46773b1$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $75da31f4a46773b1$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $75da31f4a46773b1$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $75da31f4a46773b1$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $75da31f4a46773b1$var$xi.bind(null, $75da31f4a46773b1$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $75da31f4a46773b1$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $75da31f4a46773b1$var$hi,
    useDebugValue: $75da31f4a46773b1$var$ri,
    useDeferredValue: function(a) {
        return $75da31f4a46773b1$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $75da31f4a46773b1$var$hi(!1), b = a[0];
        a = $75da31f4a46773b1$var$vi.bind(null, a[1]);
        $75da31f4a46773b1$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $75da31f4a46773b1$var$M, e = $75da31f4a46773b1$var$Th();
        if ($75da31f4a46773b1$var$I) {
            if (void 0 === c) throw Error($75da31f4a46773b1$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $75da31f4a46773b1$var$Q) throw Error($75da31f4a46773b1$var$p(349));
            0 !== ($75da31f4a46773b1$var$Hh & 30) || $75da31f4a46773b1$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $75da31f4a46773b1$var$mi($75da31f4a46773b1$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $75da31f4a46773b1$var$bi(9, $75da31f4a46773b1$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $75da31f4a46773b1$var$Th(), b = $75da31f4a46773b1$var$Q.identifierPrefix;
        if ($75da31f4a46773b1$var$I) {
            var c = $75da31f4a46773b1$var$sg;
            var d = $75da31f4a46773b1$var$rg;
            c = (d & ~(1 << 32 - $75da31f4a46773b1$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $75da31f4a46773b1$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $75da31f4a46773b1$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $75da31f4a46773b1$var$Ph = {
    readContext: $75da31f4a46773b1$var$eh,
    useCallback: $75da31f4a46773b1$var$si,
    useContext: $75da31f4a46773b1$var$eh,
    useEffect: $75da31f4a46773b1$var$$h,
    useImperativeHandle: $75da31f4a46773b1$var$qi,
    useInsertionEffect: $75da31f4a46773b1$var$ni,
    useLayoutEffect: $75da31f4a46773b1$var$oi,
    useMemo: $75da31f4a46773b1$var$ti,
    useReducer: $75da31f4a46773b1$var$Wh,
    useRef: $75da31f4a46773b1$var$ji,
    useState: function() {
        return $75da31f4a46773b1$var$Wh($75da31f4a46773b1$var$Vh);
    },
    useDebugValue: $75da31f4a46773b1$var$ri,
    useDeferredValue: function(a) {
        var b = $75da31f4a46773b1$var$Uh();
        return $75da31f4a46773b1$var$ui(b, $75da31f4a46773b1$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $75da31f4a46773b1$var$Wh($75da31f4a46773b1$var$Vh)[0], b = $75da31f4a46773b1$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $75da31f4a46773b1$var$Yh,
    useSyncExternalStore: $75da31f4a46773b1$var$Zh,
    useId: $75da31f4a46773b1$var$wi,
    unstable_isNewReconciler: !1
}, $75da31f4a46773b1$var$Qh = {
    readContext: $75da31f4a46773b1$var$eh,
    useCallback: $75da31f4a46773b1$var$si,
    useContext: $75da31f4a46773b1$var$eh,
    useEffect: $75da31f4a46773b1$var$$h,
    useImperativeHandle: $75da31f4a46773b1$var$qi,
    useInsertionEffect: $75da31f4a46773b1$var$ni,
    useLayoutEffect: $75da31f4a46773b1$var$oi,
    useMemo: $75da31f4a46773b1$var$ti,
    useReducer: $75da31f4a46773b1$var$Xh,
    useRef: $75da31f4a46773b1$var$ji,
    useState: function() {
        return $75da31f4a46773b1$var$Xh($75da31f4a46773b1$var$Vh);
    },
    useDebugValue: $75da31f4a46773b1$var$ri,
    useDeferredValue: function(a) {
        var b = $75da31f4a46773b1$var$Uh();
        return null === $75da31f4a46773b1$var$N ? b.memoizedState = a : $75da31f4a46773b1$var$ui(b, $75da31f4a46773b1$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $75da31f4a46773b1$var$Xh($75da31f4a46773b1$var$Vh)[0], b = $75da31f4a46773b1$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $75da31f4a46773b1$var$Yh,
    useSyncExternalStore: $75da31f4a46773b1$var$Zh,
    useId: $75da31f4a46773b1$var$wi,
    unstable_isNewReconciler: !1
};
function $75da31f4a46773b1$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $75da31f4a46773b1$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $75da31f4a46773b1$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $75da31f4a46773b1$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $75da31f4a46773b1$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $75da31f4a46773b1$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $75da31f4a46773b1$var$R(), e = $75da31f4a46773b1$var$yi(a), f = $75da31f4a46773b1$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $75da31f4a46773b1$var$nh(a, f, e);
        null !== b && ($75da31f4a46773b1$var$gi(b, a, e, d), $75da31f4a46773b1$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $75da31f4a46773b1$var$R(), e = $75da31f4a46773b1$var$yi(a), f = $75da31f4a46773b1$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $75da31f4a46773b1$var$nh(a, f, e);
        null !== b && ($75da31f4a46773b1$var$gi(b, a, e, d), $75da31f4a46773b1$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $75da31f4a46773b1$var$R(), d = $75da31f4a46773b1$var$yi(a), e = $75da31f4a46773b1$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $75da31f4a46773b1$var$nh(a, e, d);
        null !== b && ($75da31f4a46773b1$var$gi(b, a, d, c), $75da31f4a46773b1$var$oh(b, a, d));
    }
};
function $75da31f4a46773b1$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$75da31f4a46773b1$var$Ie(c, d) || !$75da31f4a46773b1$var$Ie(e, f) : !0;
}
function $75da31f4a46773b1$var$Gi(a, b, c) {
    var d = !1, e = $75da31f4a46773b1$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $75da31f4a46773b1$var$eh(f) : (e = $75da31f4a46773b1$var$Zf(b) ? $75da31f4a46773b1$var$Xf : $75da31f4a46773b1$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $75da31f4a46773b1$var$Yf(a, e) : $75da31f4a46773b1$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $75da31f4a46773b1$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $75da31f4a46773b1$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $75da31f4a46773b1$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $75da31f4a46773b1$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $75da31f4a46773b1$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $75da31f4a46773b1$var$eh(f) : (f = $75da31f4a46773b1$var$Zf(b) ? $75da31f4a46773b1$var$Xf : $75da31f4a46773b1$var$H.current, e.context = $75da31f4a46773b1$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($75da31f4a46773b1$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $75da31f4a46773b1$var$Ei.enqueueReplaceState(e, e.state, null), $75da31f4a46773b1$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $75da31f4a46773b1$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $75da31f4a46773b1$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $75da31f4a46773b1$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $75da31f4a46773b1$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $75da31f4a46773b1$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $75da31f4a46773b1$var$Ni(a, b, c) {
    c = $75da31f4a46773b1$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $75da31f4a46773b1$var$Oi || ($75da31f4a46773b1$var$Oi = !0, $75da31f4a46773b1$var$Pi = d);
        $75da31f4a46773b1$var$Li(a, b);
    };
    return c;
}
function $75da31f4a46773b1$var$Qi(a, b, c) {
    c = $75da31f4a46773b1$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $75da31f4a46773b1$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $75da31f4a46773b1$var$Li(a, b);
        "function" !== typeof d && (null === $75da31f4a46773b1$var$Ri ? $75da31f4a46773b1$var$Ri = new Set([
            this
        ]) : $75da31f4a46773b1$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $75da31f4a46773b1$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $75da31f4a46773b1$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $75da31f4a46773b1$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $75da31f4a46773b1$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $75da31f4a46773b1$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $75da31f4a46773b1$var$mh(-1, 1), b.tag = 2, $75da31f4a46773b1$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $75da31f4a46773b1$var$Wi = $75da31f4a46773b1$var$ua.ReactCurrentOwner, $75da31f4a46773b1$var$dh = !1;
function $75da31f4a46773b1$var$Xi(a, b, c, d) {
    b.child = null === a ? $75da31f4a46773b1$var$Vg(b, null, c, d) : $75da31f4a46773b1$var$Ug(b, a.child, c, d);
}
function $75da31f4a46773b1$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $75da31f4a46773b1$var$ch(b, e);
    d = $75da31f4a46773b1$var$Nh(a, b, c, d, f, e);
    c = $75da31f4a46773b1$var$Sh();
    if (null !== a && !$75da31f4a46773b1$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $75da31f4a46773b1$var$Zi(a, b, e);
    $75da31f4a46773b1$var$I && c && $75da31f4a46773b1$var$vg(b);
    b.flags |= 1;
    $75da31f4a46773b1$var$Xi(a, b, d, e);
    return b.child;
}
function $75da31f4a46773b1$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$75da31f4a46773b1$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $75da31f4a46773b1$var$bj(a, b, f, d, e);
        a = $75da31f4a46773b1$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $75da31f4a46773b1$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $75da31f4a46773b1$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $75da31f4a46773b1$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $75da31f4a46773b1$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($75da31f4a46773b1$var$Ie(f, d) && a.ref === b.ref) {
            if ($75da31f4a46773b1$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($75da31f4a46773b1$var$dh = !0);
            else return b.lanes = a.lanes, $75da31f4a46773b1$var$Zi(a, b, e);
        }
    }
    return $75da31f4a46773b1$var$cj(a, b, c, d, e);
}
function $75da31f4a46773b1$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $75da31f4a46773b1$var$G($75da31f4a46773b1$var$ej, $75da31f4a46773b1$var$fj), $75da31f4a46773b1$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $75da31f4a46773b1$var$G($75da31f4a46773b1$var$ej, $75da31f4a46773b1$var$fj), $75da31f4a46773b1$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $75da31f4a46773b1$var$G($75da31f4a46773b1$var$ej, $75da31f4a46773b1$var$fj);
            $75da31f4a46773b1$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $75da31f4a46773b1$var$G($75da31f4a46773b1$var$ej, $75da31f4a46773b1$var$fj), $75da31f4a46773b1$var$fj |= d;
    $75da31f4a46773b1$var$Xi(a, b, e, c);
    return b.child;
}
function $75da31f4a46773b1$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $75da31f4a46773b1$var$cj(a, b, c, d, e) {
    var f = $75da31f4a46773b1$var$Zf(c) ? $75da31f4a46773b1$var$Xf : $75da31f4a46773b1$var$H.current;
    f = $75da31f4a46773b1$var$Yf(b, f);
    $75da31f4a46773b1$var$ch(b, e);
    c = $75da31f4a46773b1$var$Nh(a, b, c, d, f, e);
    d = $75da31f4a46773b1$var$Sh();
    if (null !== a && !$75da31f4a46773b1$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $75da31f4a46773b1$var$Zi(a, b, e);
    $75da31f4a46773b1$var$I && d && $75da31f4a46773b1$var$vg(b);
    b.flags |= 1;
    $75da31f4a46773b1$var$Xi(a, b, c, e);
    return b.child;
}
function $75da31f4a46773b1$var$hj(a, b, c, d, e) {
    if ($75da31f4a46773b1$var$Zf(c)) {
        var f = !0;
        $75da31f4a46773b1$var$cg(b);
    } else f = !1;
    $75da31f4a46773b1$var$ch(b, e);
    if (null === b.stateNode) $75da31f4a46773b1$var$ij(a, b), $75da31f4a46773b1$var$Gi(b, c, d), $75da31f4a46773b1$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $75da31f4a46773b1$var$eh(l) : (l = $75da31f4a46773b1$var$Zf(c) ? $75da31f4a46773b1$var$Xf : $75da31f4a46773b1$var$H.current, l = $75da31f4a46773b1$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $75da31f4a46773b1$var$Hi(b, g, d, l);
        $75da31f4a46773b1$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $75da31f4a46773b1$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $75da31f4a46773b1$var$Wf.current || $75da31f4a46773b1$var$jh ? ("function" === typeof m && ($75da31f4a46773b1$var$Di(b, c, m, d), k = b.memoizedState), (h = $75da31f4a46773b1$var$jh || $75da31f4a46773b1$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $75da31f4a46773b1$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $75da31f4a46773b1$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $75da31f4a46773b1$var$eh(k) : (k = $75da31f4a46773b1$var$Zf(c) ? $75da31f4a46773b1$var$Xf : $75da31f4a46773b1$var$H.current, k = $75da31f4a46773b1$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $75da31f4a46773b1$var$Hi(b, g, d, k);
        $75da31f4a46773b1$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $75da31f4a46773b1$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $75da31f4a46773b1$var$Wf.current || $75da31f4a46773b1$var$jh ? ("function" === typeof y && ($75da31f4a46773b1$var$Di(b, c, y, d), n = b.memoizedState), (l = $75da31f4a46773b1$var$jh || $75da31f4a46773b1$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $75da31f4a46773b1$var$jj(a, b, c, d, f, e);
}
function $75da31f4a46773b1$var$jj(a, b, c, d, e, f) {
    $75da31f4a46773b1$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $75da31f4a46773b1$var$dg(b, c, !1), $75da31f4a46773b1$var$Zi(a, b, f);
    d = b.stateNode;
    $75da31f4a46773b1$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $75da31f4a46773b1$var$Ug(b, a.child, null, f), b.child = $75da31f4a46773b1$var$Ug(b, null, h, f)) : $75da31f4a46773b1$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $75da31f4a46773b1$var$dg(b, c, !0);
    return b.child;
}
function $75da31f4a46773b1$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $75da31f4a46773b1$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $75da31f4a46773b1$var$ag(a, b.context, !1);
    $75da31f4a46773b1$var$yh(a, b.containerInfo);
}
function $75da31f4a46773b1$var$lj(a, b, c, d, e) {
    $75da31f4a46773b1$var$Ig();
    $75da31f4a46773b1$var$Jg(e);
    b.flags |= 256;
    $75da31f4a46773b1$var$Xi(a, b, c, d);
    return b.child;
}
var $75da31f4a46773b1$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $75da31f4a46773b1$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $75da31f4a46773b1$var$oj(a, b, c) {
    var d = b.pendingProps, e = $75da31f4a46773b1$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, e & 1);
    if (null === a) {
        $75da31f4a46773b1$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $75da31f4a46773b1$var$pj(g, d, 0, null), a = $75da31f4a46773b1$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $75da31f4a46773b1$var$nj(c), b.memoizedState = $75da31f4a46773b1$var$mj, a) : $75da31f4a46773b1$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $75da31f4a46773b1$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $75da31f4a46773b1$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $75da31f4a46773b1$var$Pg(h, f) : (f = $75da31f4a46773b1$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $75da31f4a46773b1$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $75da31f4a46773b1$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $75da31f4a46773b1$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $75da31f4a46773b1$var$qj(a, b) {
    b = $75da31f4a46773b1$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $75da31f4a46773b1$var$sj(a, b, c, d) {
    null !== d && $75da31f4a46773b1$var$Jg(d);
    $75da31f4a46773b1$var$Ug(b, a.child, null, c);
    a = $75da31f4a46773b1$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $75da31f4a46773b1$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $75da31f4a46773b1$var$Ki(Error($75da31f4a46773b1$var$p(422))), $75da31f4a46773b1$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $75da31f4a46773b1$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $75da31f4a46773b1$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $75da31f4a46773b1$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $75da31f4a46773b1$var$nj(g);
        b.memoizedState = $75da31f4a46773b1$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $75da31f4a46773b1$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($75da31f4a46773b1$var$p(419));
        d = $75da31f4a46773b1$var$Ki(f, d, void 0);
        return $75da31f4a46773b1$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($75da31f4a46773b1$var$dh || h) {
        d = $75da31f4a46773b1$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $75da31f4a46773b1$var$ih(a, e), $75da31f4a46773b1$var$gi(d, a, e, -1));
        }
        $75da31f4a46773b1$var$tj();
        d = $75da31f4a46773b1$var$Ki(Error($75da31f4a46773b1$var$p(421)));
        return $75da31f4a46773b1$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $75da31f4a46773b1$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $75da31f4a46773b1$var$yg = $75da31f4a46773b1$var$Lf(e.nextSibling);
    $75da31f4a46773b1$var$xg = b;
    $75da31f4a46773b1$var$I = !0;
    $75da31f4a46773b1$var$zg = null;
    null !== a && ($75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg++] = $75da31f4a46773b1$var$rg, $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg++] = $75da31f4a46773b1$var$sg, $75da31f4a46773b1$var$og[$75da31f4a46773b1$var$pg++] = $75da31f4a46773b1$var$qg, $75da31f4a46773b1$var$rg = a.id, $75da31f4a46773b1$var$sg = a.overflow, $75da31f4a46773b1$var$qg = b);
    b = $75da31f4a46773b1$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $75da31f4a46773b1$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $75da31f4a46773b1$var$bh(a.return, b, c);
}
function $75da31f4a46773b1$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $75da31f4a46773b1$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $75da31f4a46773b1$var$Xi(a, b, d.children, c);
    d = $75da31f4a46773b1$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $75da31f4a46773b1$var$vj(a, c, b);
            else if (19 === a.tag) $75da31f4a46773b1$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $75da31f4a46773b1$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $75da31f4a46773b1$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $75da31f4a46773b1$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $75da31f4a46773b1$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $75da31f4a46773b1$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $75da31f4a46773b1$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $75da31f4a46773b1$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $75da31f4a46773b1$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($75da31f4a46773b1$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $75da31f4a46773b1$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $75da31f4a46773b1$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $75da31f4a46773b1$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $75da31f4a46773b1$var$kj(b);
            $75da31f4a46773b1$var$Ig();
            break;
        case 5:
            $75da31f4a46773b1$var$Ah(b);
            break;
        case 1:
            $75da31f4a46773b1$var$Zf(b.type) && $75da31f4a46773b1$var$cg(b);
            break;
        case 4:
            $75da31f4a46773b1$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $75da31f4a46773b1$var$G($75da31f4a46773b1$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, $75da31f4a46773b1$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $75da31f4a46773b1$var$oj(a, b, c);
                $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, $75da31f4a46773b1$var$L.current & 1);
                a = $75da31f4a46773b1$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, $75da31f4a46773b1$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $75da31f4a46773b1$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, $75da31f4a46773b1$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $75da31f4a46773b1$var$dj(a, b, c);
    }
    return $75da31f4a46773b1$var$Zi(a, b, c);
}
var $75da31f4a46773b1$var$zj, $75da31f4a46773b1$var$Aj, $75da31f4a46773b1$var$Bj, $75da31f4a46773b1$var$Cj;
$75da31f4a46773b1$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$75da31f4a46773b1$var$Aj = function() {};
$75da31f4a46773b1$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $75da31f4a46773b1$var$xh($75da31f4a46773b1$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $75da31f4a46773b1$var$Ya(a, e);
                d = $75da31f4a46773b1$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $75da31f4a46773b1$var$A({}, e, {
                    value: void 0
                });
                d = $75da31f4a46773b1$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $75da31f4a46773b1$var$gb(a, e);
                d = $75da31f4a46773b1$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $75da31f4a46773b1$var$Bf);
        }
        $75da31f4a46773b1$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($75da31f4a46773b1$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($75da31f4a46773b1$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $75da31f4a46773b1$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$75da31f4a46773b1$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $75da31f4a46773b1$var$Dj(a, b) {
    if (!$75da31f4a46773b1$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $75da31f4a46773b1$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $75da31f4a46773b1$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $75da31f4a46773b1$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $75da31f4a46773b1$var$S(b), null;
        case 1:
            return $75da31f4a46773b1$var$Zf(b.type) && $75da31f4a46773b1$var$$f(), $75da31f4a46773b1$var$S(b), null;
        case 3:
            d = b.stateNode;
            $75da31f4a46773b1$var$zh();
            $75da31f4a46773b1$var$E($75da31f4a46773b1$var$Wf);
            $75da31f4a46773b1$var$E($75da31f4a46773b1$var$H);
            $75da31f4a46773b1$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $75da31f4a46773b1$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $75da31f4a46773b1$var$zg && ($75da31f4a46773b1$var$Fj($75da31f4a46773b1$var$zg), $75da31f4a46773b1$var$zg = null));
            $75da31f4a46773b1$var$Aj(a, b);
            $75da31f4a46773b1$var$S(b);
            return null;
        case 5:
            $75da31f4a46773b1$var$Bh(b);
            var e = $75da31f4a46773b1$var$xh($75da31f4a46773b1$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $75da31f4a46773b1$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($75da31f4a46773b1$var$p(166));
                    $75da31f4a46773b1$var$S(b);
                    return null;
                }
                a = $75da31f4a46773b1$var$xh($75da31f4a46773b1$var$uh.current);
                if ($75da31f4a46773b1$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$75da31f4a46773b1$var$Of] = b;
                    d[$75da31f4a46773b1$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $75da31f4a46773b1$var$D("cancel", d);
                            $75da31f4a46773b1$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $75da31f4a46773b1$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $75da31f4a46773b1$var$lf.length; e++)$75da31f4a46773b1$var$D($75da31f4a46773b1$var$lf[e], d);
                            break;
                        case "source":
                            $75da31f4a46773b1$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $75da31f4a46773b1$var$D("error", d);
                            $75da31f4a46773b1$var$D("load", d);
                            break;
                        case "details":
                            $75da31f4a46773b1$var$D("toggle", d);
                            break;
                        case "input":
                            $75da31f4a46773b1$var$Za(d, f);
                            $75da31f4a46773b1$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $75da31f4a46773b1$var$D("invalid", d);
                            break;
                        case "textarea":
                            $75da31f4a46773b1$var$hb(d, f), $75da31f4a46773b1$var$D("invalid", d);
                    }
                    $75da31f4a46773b1$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $75da31f4a46773b1$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $75da31f4a46773b1$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $75da31f4a46773b1$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $75da31f4a46773b1$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $75da31f4a46773b1$var$Va(d);
                            $75da31f4a46773b1$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $75da31f4a46773b1$var$Va(d);
                            $75da31f4a46773b1$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $75da31f4a46773b1$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $75da31f4a46773b1$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$75da31f4a46773b1$var$Of] = b;
                    a[$75da31f4a46773b1$var$Pf] = d;
                    $75da31f4a46773b1$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $75da31f4a46773b1$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $75da31f4a46773b1$var$D("cancel", a);
                                $75da31f4a46773b1$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $75da31f4a46773b1$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $75da31f4a46773b1$var$lf.length; e++)$75da31f4a46773b1$var$D($75da31f4a46773b1$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $75da31f4a46773b1$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $75da31f4a46773b1$var$D("error", a);
                                $75da31f4a46773b1$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $75da31f4a46773b1$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $75da31f4a46773b1$var$Za(a, d);
                                e = $75da31f4a46773b1$var$Ya(a, d);
                                $75da31f4a46773b1$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $75da31f4a46773b1$var$A({}, d, {
                                    value: void 0
                                });
                                $75da31f4a46773b1$var$D("invalid", a);
                                break;
                            case "textarea":
                                $75da31f4a46773b1$var$hb(a, d);
                                e = $75da31f4a46773b1$var$gb(a, d);
                                $75da31f4a46773b1$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $75da31f4a46773b1$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $75da31f4a46773b1$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $75da31f4a46773b1$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $75da31f4a46773b1$var$ob(a, k) : "number" === typeof k && $75da31f4a46773b1$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($75da31f4a46773b1$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $75da31f4a46773b1$var$D("scroll", a) : null != k && $75da31f4a46773b1$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $75da31f4a46773b1$var$Va(a);
                                $75da31f4a46773b1$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $75da31f4a46773b1$var$Va(a);
                                $75da31f4a46773b1$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $75da31f4a46773b1$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $75da31f4a46773b1$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $75da31f4a46773b1$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $75da31f4a46773b1$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $75da31f4a46773b1$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $75da31f4a46773b1$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($75da31f4a46773b1$var$p(166));
                c = $75da31f4a46773b1$var$xh($75da31f4a46773b1$var$wh.current);
                $75da31f4a46773b1$var$xh($75da31f4a46773b1$var$uh.current);
                if ($75da31f4a46773b1$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$75da31f4a46773b1$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $75da31f4a46773b1$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $75da31f4a46773b1$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $75da31f4a46773b1$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$75da31f4a46773b1$var$Of] = b, b.stateNode = d;
            }
            $75da31f4a46773b1$var$S(b);
            return null;
        case 13:
            $75da31f4a46773b1$var$E($75da31f4a46773b1$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($75da31f4a46773b1$var$I && null !== $75da31f4a46773b1$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $75da31f4a46773b1$var$Hg(), $75da31f4a46773b1$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $75da31f4a46773b1$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($75da31f4a46773b1$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($75da31f4a46773b1$var$p(317));
                        f[$75da31f4a46773b1$var$Of] = b;
                    } else $75da31f4a46773b1$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $75da31f4a46773b1$var$S(b);
                    f = !1;
                } else null !== $75da31f4a46773b1$var$zg && ($75da31f4a46773b1$var$Fj($75da31f4a46773b1$var$zg), $75da31f4a46773b1$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($75da31f4a46773b1$var$L.current & 1) ? 0 === $75da31f4a46773b1$var$T && ($75da31f4a46773b1$var$T = 3) : $75da31f4a46773b1$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $75da31f4a46773b1$var$S(b);
            return null;
        case 4:
            return $75da31f4a46773b1$var$zh(), $75da31f4a46773b1$var$Aj(a, b), null === a && $75da31f4a46773b1$var$sf(b.stateNode.containerInfo), $75da31f4a46773b1$var$S(b), null;
        case 10:
            return $75da31f4a46773b1$var$ah(b.type._context), $75da31f4a46773b1$var$S(b), null;
        case 17:
            return $75da31f4a46773b1$var$Zf(b.type) && $75da31f4a46773b1$var$$f(), $75da31f4a46773b1$var$S(b), null;
        case 19:
            $75da31f4a46773b1$var$E($75da31f4a46773b1$var$L);
            f = b.memoizedState;
            if (null === f) return $75da31f4a46773b1$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $75da31f4a46773b1$var$Dj(f, !1);
                else {
                    if (0 !== $75da31f4a46773b1$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $75da31f4a46773b1$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $75da31f4a46773b1$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, $75da31f4a46773b1$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $75da31f4a46773b1$var$B() > $75da31f4a46773b1$var$Gj && (b.flags |= 128, d = !0, $75da31f4a46773b1$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $75da31f4a46773b1$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $75da31f4a46773b1$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$75da31f4a46773b1$var$I) return $75da31f4a46773b1$var$S(b), null;
                    } else 2 * $75da31f4a46773b1$var$B() - f.renderingStartTime > $75da31f4a46773b1$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $75da31f4a46773b1$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $75da31f4a46773b1$var$B(), b.sibling = null, c = $75da31f4a46773b1$var$L.current, $75da31f4a46773b1$var$G($75da31f4a46773b1$var$L, d ? c & 1 | 2 : c & 1), b;
            $75da31f4a46773b1$var$S(b);
            return null;
        case 22:
        case 23:
            return $75da31f4a46773b1$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($75da31f4a46773b1$var$fj & 1073741824) && ($75da31f4a46773b1$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $75da31f4a46773b1$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($75da31f4a46773b1$var$p(156, b.tag));
}
function $75da31f4a46773b1$var$Ij(a, b) {
    $75da31f4a46773b1$var$wg(b);
    switch(b.tag){
        case 1:
            return $75da31f4a46773b1$var$Zf(b.type) && $75da31f4a46773b1$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $75da31f4a46773b1$var$zh(), $75da31f4a46773b1$var$E($75da31f4a46773b1$var$Wf), $75da31f4a46773b1$var$E($75da31f4a46773b1$var$H), $75da31f4a46773b1$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $75da31f4a46773b1$var$Bh(b), null;
        case 13:
            $75da31f4a46773b1$var$E($75da31f4a46773b1$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($75da31f4a46773b1$var$p(340));
                $75da31f4a46773b1$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $75da31f4a46773b1$var$E($75da31f4a46773b1$var$L), null;
        case 4:
            return $75da31f4a46773b1$var$zh(), null;
        case 10:
            return $75da31f4a46773b1$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $75da31f4a46773b1$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $75da31f4a46773b1$var$Jj = !1, $75da31f4a46773b1$var$U = !1, $75da31f4a46773b1$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $75da31f4a46773b1$var$V = null;
function $75da31f4a46773b1$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $75da31f4a46773b1$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $75da31f4a46773b1$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $75da31f4a46773b1$var$W(a, b, d);
    }
}
var $75da31f4a46773b1$var$Nj = !1;
function $75da31f4a46773b1$var$Oj(a, b) {
    $75da31f4a46773b1$var$Cf = $75da31f4a46773b1$var$dd;
    a = $75da31f4a46773b1$var$Me();
    if ($75da31f4a46773b1$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $75da31f4a46773b1$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $75da31f4a46773b1$var$dd = !1;
    for($75da31f4a46773b1$var$V = b; null !== $75da31f4a46773b1$var$V;)if (b = $75da31f4a46773b1$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $75da31f4a46773b1$var$V = a;
    else for(; null !== $75da31f4a46773b1$var$V;){
        b = $75da31f4a46773b1$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $75da31f4a46773b1$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($75da31f4a46773b1$var$p(163));
            }
        } catch (F) {
            $75da31f4a46773b1$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $75da31f4a46773b1$var$V = a;
            break;
        }
        $75da31f4a46773b1$var$V = b.return;
    }
    n = $75da31f4a46773b1$var$Nj;
    $75da31f4a46773b1$var$Nj = !1;
    return n;
}
function $75da31f4a46773b1$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $75da31f4a46773b1$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $75da31f4a46773b1$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $75da31f4a46773b1$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $75da31f4a46773b1$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $75da31f4a46773b1$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$75da31f4a46773b1$var$Of], delete b[$75da31f4a46773b1$var$Pf], delete b[$75da31f4a46773b1$var$of], delete b[$75da31f4a46773b1$var$Qf], delete b[$75da31f4a46773b1$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $75da31f4a46773b1$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $75da31f4a46773b1$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $75da31f4a46773b1$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $75da31f4a46773b1$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $75da31f4a46773b1$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($75da31f4a46773b1$var$Vj(a, b, c), a = a.sibling; null !== a;)$75da31f4a46773b1$var$Vj(a, b, c), a = a.sibling;
}
function $75da31f4a46773b1$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($75da31f4a46773b1$var$Wj(a, b, c), a = a.sibling; null !== a;)$75da31f4a46773b1$var$Wj(a, b, c), a = a.sibling;
}
var $75da31f4a46773b1$var$X = null, $75da31f4a46773b1$var$Xj = !1;
function $75da31f4a46773b1$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$75da31f4a46773b1$var$Zj(a, b, c), c = c.sibling;
}
function $75da31f4a46773b1$var$Zj(a, b, c) {
    if ($75da31f4a46773b1$var$lc && "function" === typeof $75da31f4a46773b1$var$lc.onCommitFiberUnmount) try {
        $75da31f4a46773b1$var$lc.onCommitFiberUnmount($75da31f4a46773b1$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $75da31f4a46773b1$var$U || $75da31f4a46773b1$var$Lj(c, b);
        case 6:
            var d = $75da31f4a46773b1$var$X, e = $75da31f4a46773b1$var$Xj;
            $75da31f4a46773b1$var$X = null;
            $75da31f4a46773b1$var$Yj(a, b, c);
            $75da31f4a46773b1$var$X = d;
            $75da31f4a46773b1$var$Xj = e;
            null !== $75da31f4a46773b1$var$X && ($75da31f4a46773b1$var$Xj ? (a = $75da31f4a46773b1$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $75da31f4a46773b1$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $75da31f4a46773b1$var$X && ($75da31f4a46773b1$var$Xj ? (a = $75da31f4a46773b1$var$X, c = c.stateNode, 8 === a.nodeType ? $75da31f4a46773b1$var$Kf(a.parentNode, c) : 1 === a.nodeType && $75da31f4a46773b1$var$Kf(a, c), $75da31f4a46773b1$var$bd(a)) : $75da31f4a46773b1$var$Kf($75da31f4a46773b1$var$X, c.stateNode));
            break;
        case 4:
            d = $75da31f4a46773b1$var$X;
            e = $75da31f4a46773b1$var$Xj;
            $75da31f4a46773b1$var$X = c.stateNode.containerInfo;
            $75da31f4a46773b1$var$Xj = !0;
            $75da31f4a46773b1$var$Yj(a, b, c);
            $75da31f4a46773b1$var$X = d;
            $75da31f4a46773b1$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$75da31f4a46773b1$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $75da31f4a46773b1$var$Mj(c, b, g) : 0 !== (f & 4) && $75da31f4a46773b1$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $75da31f4a46773b1$var$Yj(a, b, c);
            break;
        case 1:
            if (!$75da31f4a46773b1$var$U && ($75da31f4a46773b1$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $75da31f4a46773b1$var$W(c, b, h);
            }
            $75da31f4a46773b1$var$Yj(a, b, c);
            break;
        case 21:
            $75da31f4a46773b1$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($75da31f4a46773b1$var$U = (d = $75da31f4a46773b1$var$U) || null !== c.memoizedState, $75da31f4a46773b1$var$Yj(a, b, c), $75da31f4a46773b1$var$U = d) : $75da31f4a46773b1$var$Yj(a, b, c);
            break;
        default:
            $75da31f4a46773b1$var$Yj(a, b, c);
    }
}
function $75da31f4a46773b1$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $75da31f4a46773b1$var$Kj);
        b.forEach(function(b) {
            var d = $75da31f4a46773b1$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $75da31f4a46773b1$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $75da31f4a46773b1$var$X = h.stateNode;
                        $75da31f4a46773b1$var$Xj = !1;
                        break a;
                    case 3:
                        $75da31f4a46773b1$var$X = h.stateNode.containerInfo;
                        $75da31f4a46773b1$var$Xj = !0;
                        break a;
                    case 4:
                        $75da31f4a46773b1$var$X = h.stateNode.containerInfo;
                        $75da31f4a46773b1$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $75da31f4a46773b1$var$X) throw Error($75da31f4a46773b1$var$p(160));
            $75da31f4a46773b1$var$Zj(f, g, e);
            $75da31f4a46773b1$var$X = null;
            $75da31f4a46773b1$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $75da31f4a46773b1$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$75da31f4a46773b1$var$dk(b, a), b = b.sibling;
}
function $75da31f4a46773b1$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            if (d & 4) {
                try {
                    $75da31f4a46773b1$var$Pj(3, a, a.return), $75da31f4a46773b1$var$Qj(3, a);
                } catch (t) {
                    $75da31f4a46773b1$var$W(a, a.return, t);
                }
                try {
                    $75da31f4a46773b1$var$Pj(5, a, a.return);
                } catch (t) {
                    $75da31f4a46773b1$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            d & 512 && null !== c && $75da31f4a46773b1$var$Lj(c, c.return);
            break;
        case 5:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            d & 512 && null !== c && $75da31f4a46773b1$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $75da31f4a46773b1$var$ob(e, "");
                } catch (t) {
                    $75da31f4a46773b1$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $75da31f4a46773b1$var$ab(e, f);
                    $75da31f4a46773b1$var$vb(h, g);
                    var l = $75da31f4a46773b1$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $75da31f4a46773b1$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $75da31f4a46773b1$var$nb(e, q) : "children" === m ? $75da31f4a46773b1$var$ob(e, q) : $75da31f4a46773b1$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $75da31f4a46773b1$var$bb(e, f);
                            break;
                        case "textarea":
                            $75da31f4a46773b1$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $75da31f4a46773b1$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $75da31f4a46773b1$var$fb(e, !!f.multiple, f.defaultValue, !0) : $75da31f4a46773b1$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$75da31f4a46773b1$var$Pf] = f;
                } catch (t) {
                    $75da31f4a46773b1$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($75da31f4a46773b1$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $75da31f4a46773b1$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $75da31f4a46773b1$var$bd(b.containerInfo);
            } catch (t) {
                $75da31f4a46773b1$var$W(a, a.return, t);
            }
            break;
        case 4:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            break;
        case 13:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($75da31f4a46773b1$var$fk = $75da31f4a46773b1$var$B()));
            d & 4 && $75da31f4a46773b1$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($75da31f4a46773b1$var$U = (l = $75da31f4a46773b1$var$U) || m, $75da31f4a46773b1$var$ck(b, a), $75da31f4a46773b1$var$U = l) : $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($75da31f4a46773b1$var$V = a, m = a.child; null !== m;){
                    for(q = $75da31f4a46773b1$var$V = m; null !== $75da31f4a46773b1$var$V;){
                        r = $75da31f4a46773b1$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $75da31f4a46773b1$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $75da31f4a46773b1$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $75da31f4a46773b1$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $75da31f4a46773b1$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $75da31f4a46773b1$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $75da31f4a46773b1$var$V = y) : $75da31f4a46773b1$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $75da31f4a46773b1$var$rb("display", g));
                            } catch (t) {
                                $75da31f4a46773b1$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $75da31f4a46773b1$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $75da31f4a46773b1$var$ck(b, a);
            $75da31f4a46773b1$var$ek(a);
            d & 4 && $75da31f4a46773b1$var$ak(a);
            break;
        case 21:
            break;
        default:
            $75da31f4a46773b1$var$ck(b, a), $75da31f4a46773b1$var$ek(a);
    }
}
function $75da31f4a46773b1$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($75da31f4a46773b1$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($75da31f4a46773b1$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($75da31f4a46773b1$var$ob(e, ""), d.flags &= -33);
                    var f = $75da31f4a46773b1$var$Uj(a);
                    $75da31f4a46773b1$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $75da31f4a46773b1$var$Uj(a);
                    $75da31f4a46773b1$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($75da31f4a46773b1$var$p(161));
            }
        } catch (k) {
            $75da31f4a46773b1$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $75da31f4a46773b1$var$hk(a, b, c) {
    $75da31f4a46773b1$var$V = a;
    $75da31f4a46773b1$var$ik(a, b, c);
}
function $75da31f4a46773b1$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $75da31f4a46773b1$var$V;){
        var e = $75da31f4a46773b1$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $75da31f4a46773b1$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $75da31f4a46773b1$var$U;
                h = $75da31f4a46773b1$var$Jj;
                var l = $75da31f4a46773b1$var$U;
                $75da31f4a46773b1$var$Jj = g;
                if (($75da31f4a46773b1$var$U = k) && !l) for($75da31f4a46773b1$var$V = e; null !== $75da31f4a46773b1$var$V;)g = $75da31f4a46773b1$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $75da31f4a46773b1$var$jk(e) : null !== k ? (k.return = g, $75da31f4a46773b1$var$V = k) : $75da31f4a46773b1$var$jk(e);
                for(; null !== f;)$75da31f4a46773b1$var$V = f, $75da31f4a46773b1$var$ik(f, b, c), f = f.sibling;
                $75da31f4a46773b1$var$V = e;
                $75da31f4a46773b1$var$Jj = h;
                $75da31f4a46773b1$var$U = l;
            }
            $75da31f4a46773b1$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $75da31f4a46773b1$var$V = f) : $75da31f4a46773b1$var$kk(a, b, c);
    }
}
function $75da31f4a46773b1$var$kk(a) {
    for(; null !== $75da31f4a46773b1$var$V;){
        var b = $75da31f4a46773b1$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $75da31f4a46773b1$var$U || $75da31f4a46773b1$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$75da31f4a46773b1$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $75da31f4a46773b1$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $75da31f4a46773b1$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $75da31f4a46773b1$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $75da31f4a46773b1$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($75da31f4a46773b1$var$p(163));
                }
                $75da31f4a46773b1$var$U || b.flags & 512 && $75da31f4a46773b1$var$Rj(b);
            } catch (r) {
                $75da31f4a46773b1$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $75da31f4a46773b1$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $75da31f4a46773b1$var$V = c;
            break;
        }
        $75da31f4a46773b1$var$V = b.return;
    }
}
function $75da31f4a46773b1$var$gk(a) {
    for(; null !== $75da31f4a46773b1$var$V;){
        var b = $75da31f4a46773b1$var$V;
        if (b === a) {
            $75da31f4a46773b1$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $75da31f4a46773b1$var$V = c;
            break;
        }
        $75da31f4a46773b1$var$V = b.return;
    }
}
function $75da31f4a46773b1$var$jk(a) {
    for(; null !== $75da31f4a46773b1$var$V;){
        var b = $75da31f4a46773b1$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $75da31f4a46773b1$var$Qj(4, b);
                    } catch (k) {
                        $75da31f4a46773b1$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $75da31f4a46773b1$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $75da31f4a46773b1$var$Rj(b);
                    } catch (k) {
                        $75da31f4a46773b1$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $75da31f4a46773b1$var$Rj(b);
                    } catch (k) {
                        $75da31f4a46773b1$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $75da31f4a46773b1$var$W(b, b.return, k);
        }
        if (b === a) {
            $75da31f4a46773b1$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $75da31f4a46773b1$var$V = h;
            break;
        }
        $75da31f4a46773b1$var$V = b.return;
    }
}
var $75da31f4a46773b1$var$lk = Math.ceil, $75da31f4a46773b1$var$mk = $75da31f4a46773b1$var$ua.ReactCurrentDispatcher, $75da31f4a46773b1$var$nk = $75da31f4a46773b1$var$ua.ReactCurrentOwner, $75da31f4a46773b1$var$ok = $75da31f4a46773b1$var$ua.ReactCurrentBatchConfig, $75da31f4a46773b1$var$K = 0, $75da31f4a46773b1$var$Q = null, $75da31f4a46773b1$var$Y = null, $75da31f4a46773b1$var$Z = 0, $75da31f4a46773b1$var$fj = 0, $75da31f4a46773b1$var$ej = $75da31f4a46773b1$var$Uf(0), $75da31f4a46773b1$var$T = 0, $75da31f4a46773b1$var$pk = null, $75da31f4a46773b1$var$rh = 0, $75da31f4a46773b1$var$qk = 0, $75da31f4a46773b1$var$rk = 0, $75da31f4a46773b1$var$sk = null, $75da31f4a46773b1$var$tk = null, $75da31f4a46773b1$var$fk = 0, $75da31f4a46773b1$var$Gj = Infinity, $75da31f4a46773b1$var$uk = null, $75da31f4a46773b1$var$Oi = !1, $75da31f4a46773b1$var$Pi = null, $75da31f4a46773b1$var$Ri = null, $75da31f4a46773b1$var$vk = !1, $75da31f4a46773b1$var$wk = null, $75da31f4a46773b1$var$xk = 0, $75da31f4a46773b1$var$yk = 0, $75da31f4a46773b1$var$zk = null, $75da31f4a46773b1$var$Ak = -1, $75da31f4a46773b1$var$Bk = 0;
function $75da31f4a46773b1$var$R() {
    return 0 !== ($75da31f4a46773b1$var$K & 6) ? $75da31f4a46773b1$var$B() : -1 !== $75da31f4a46773b1$var$Ak ? $75da31f4a46773b1$var$Ak : $75da31f4a46773b1$var$Ak = $75da31f4a46773b1$var$B();
}
function $75da31f4a46773b1$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($75da31f4a46773b1$var$K & 2) && 0 !== $75da31f4a46773b1$var$Z) return $75da31f4a46773b1$var$Z & -$75da31f4a46773b1$var$Z;
    if (null !== $75da31f4a46773b1$var$Kg.transition) return 0 === $75da31f4a46773b1$var$Bk && ($75da31f4a46773b1$var$Bk = $75da31f4a46773b1$var$yc()), $75da31f4a46773b1$var$Bk;
    a = $75da31f4a46773b1$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $75da31f4a46773b1$var$jd(a.type);
    return a;
}
function $75da31f4a46773b1$var$gi(a, b, c, d) {
    if (50 < $75da31f4a46773b1$var$yk) throw $75da31f4a46773b1$var$yk = 0, $75da31f4a46773b1$var$zk = null, Error($75da31f4a46773b1$var$p(185));
    $75da31f4a46773b1$var$Ac(a, c, d);
    if (0 === ($75da31f4a46773b1$var$K & 2) || a !== $75da31f4a46773b1$var$Q) a === $75da31f4a46773b1$var$Q && (0 === ($75da31f4a46773b1$var$K & 2) && ($75da31f4a46773b1$var$qk |= c), 4 === $75da31f4a46773b1$var$T && $75da31f4a46773b1$var$Ck(a, $75da31f4a46773b1$var$Z)), $75da31f4a46773b1$var$Dk(a, d), 1 === c && 0 === $75da31f4a46773b1$var$K && 0 === (b.mode & 1) && ($75da31f4a46773b1$var$Gj = $75da31f4a46773b1$var$B() + 500, $75da31f4a46773b1$var$fg && $75da31f4a46773b1$var$jg());
}
function $75da31f4a46773b1$var$Dk(a, b) {
    var c = a.callbackNode;
    $75da31f4a46773b1$var$wc(a, b);
    var d = $75da31f4a46773b1$var$uc(a, a === $75da31f4a46773b1$var$Q ? $75da31f4a46773b1$var$Z : 0);
    if (0 === d) null !== c && $75da31f4a46773b1$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $75da31f4a46773b1$var$bc(c);
        if (1 === b) 0 === a.tag ? $75da31f4a46773b1$var$ig($75da31f4a46773b1$var$Ek.bind(null, a)) : $75da31f4a46773b1$var$hg($75da31f4a46773b1$var$Ek.bind(null, a)), $75da31f4a46773b1$var$Jf(function() {
            0 === ($75da31f4a46773b1$var$K & 6) && $75da31f4a46773b1$var$jg();
        }), c = null;
        else {
            switch($75da31f4a46773b1$var$Dc(d)){
                case 1:
                    c = $75da31f4a46773b1$var$fc;
                    break;
                case 4:
                    c = $75da31f4a46773b1$var$gc;
                    break;
                case 16:
                    c = $75da31f4a46773b1$var$hc;
                    break;
                case 536870912:
                    c = $75da31f4a46773b1$var$jc;
                    break;
                default:
                    c = $75da31f4a46773b1$var$hc;
            }
            c = $75da31f4a46773b1$var$Fk(c, $75da31f4a46773b1$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $75da31f4a46773b1$var$Gk(a, b) {
    $75da31f4a46773b1$var$Ak = -1;
    $75da31f4a46773b1$var$Bk = 0;
    if (0 !== ($75da31f4a46773b1$var$K & 6)) throw Error($75da31f4a46773b1$var$p(327));
    var c = a.callbackNode;
    if ($75da31f4a46773b1$var$Hk() && a.callbackNode !== c) return null;
    var d = $75da31f4a46773b1$var$uc(a, a === $75da31f4a46773b1$var$Q ? $75da31f4a46773b1$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $75da31f4a46773b1$var$Ik(a, d);
    else {
        b = d;
        var e = $75da31f4a46773b1$var$K;
        $75da31f4a46773b1$var$K |= 2;
        var f = $75da31f4a46773b1$var$Jk();
        if ($75da31f4a46773b1$var$Q !== a || $75da31f4a46773b1$var$Z !== b) $75da31f4a46773b1$var$uk = null, $75da31f4a46773b1$var$Gj = $75da31f4a46773b1$var$B() + 500, $75da31f4a46773b1$var$Kk(a, b);
        for(;;)try {
            $75da31f4a46773b1$var$Lk();
            break;
        } catch (h) {
            $75da31f4a46773b1$var$Mk(a, h);
        }
        $75da31f4a46773b1$var$$g();
        $75da31f4a46773b1$var$mk.current = f;
        $75da31f4a46773b1$var$K = e;
        null !== $75da31f4a46773b1$var$Y ? b = 0 : ($75da31f4a46773b1$var$Q = null, $75da31f4a46773b1$var$Z = 0, b = $75da31f4a46773b1$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $75da31f4a46773b1$var$xc(a), 0 !== e && (d = e, b = $75da31f4a46773b1$var$Nk(a, e)));
        if (1 === b) throw c = $75da31f4a46773b1$var$pk, $75da31f4a46773b1$var$Kk(a, 0), $75da31f4a46773b1$var$Ck(a, d), $75da31f4a46773b1$var$Dk(a, $75da31f4a46773b1$var$B()), c;
        if (6 === b) $75da31f4a46773b1$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$75da31f4a46773b1$var$Ok(e) && (b = $75da31f4a46773b1$var$Ik(a, d), 2 === b && (f = $75da31f4a46773b1$var$xc(a), 0 !== f && (d = f, b = $75da31f4a46773b1$var$Nk(a, f))), 1 === b)) throw c = $75da31f4a46773b1$var$pk, $75da31f4a46773b1$var$Kk(a, 0), $75da31f4a46773b1$var$Ck(a, d), $75da31f4a46773b1$var$Dk(a, $75da31f4a46773b1$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($75da31f4a46773b1$var$p(345));
                case 2:
                    $75da31f4a46773b1$var$Pk(a, $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$uk);
                    break;
                case 3:
                    $75da31f4a46773b1$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $75da31f4a46773b1$var$fk + 500 - $75da31f4a46773b1$var$B(), 10 < b)) {
                        if (0 !== $75da31f4a46773b1$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $75da31f4a46773b1$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $75da31f4a46773b1$var$Ff($75da31f4a46773b1$var$Pk.bind(null, a, $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$uk), b);
                        break;
                    }
                    $75da31f4a46773b1$var$Pk(a, $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$uk);
                    break;
                case 4:
                    $75da31f4a46773b1$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $75da31f4a46773b1$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $75da31f4a46773b1$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $75da31f4a46773b1$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $75da31f4a46773b1$var$Ff($75da31f4a46773b1$var$Pk.bind(null, a, $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$uk), d);
                        break;
                    }
                    $75da31f4a46773b1$var$Pk(a, $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$uk);
                    break;
                case 5:
                    $75da31f4a46773b1$var$Pk(a, $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$uk);
                    break;
                default:
                    throw Error($75da31f4a46773b1$var$p(329));
            }
        }
    }
    $75da31f4a46773b1$var$Dk(a, $75da31f4a46773b1$var$B());
    return a.callbackNode === c ? $75da31f4a46773b1$var$Gk.bind(null, a) : null;
}
function $75da31f4a46773b1$var$Nk(a, b) {
    var c = $75da31f4a46773b1$var$sk;
    a.current.memoizedState.isDehydrated && ($75da31f4a46773b1$var$Kk(a, b).flags |= 256);
    a = $75da31f4a46773b1$var$Ik(a, b);
    2 !== a && (b = $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$tk = c, null !== b && $75da31f4a46773b1$var$Fj(b));
    return a;
}
function $75da31f4a46773b1$var$Fj(a) {
    null === $75da31f4a46773b1$var$tk ? $75da31f4a46773b1$var$tk = a : $75da31f4a46773b1$var$tk.push.apply($75da31f4a46773b1$var$tk, a);
}
function $75da31f4a46773b1$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$75da31f4a46773b1$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $75da31f4a46773b1$var$Ck(a, b) {
    b &= ~$75da31f4a46773b1$var$rk;
    b &= ~$75da31f4a46773b1$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $75da31f4a46773b1$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $75da31f4a46773b1$var$Ek(a) {
    if (0 !== ($75da31f4a46773b1$var$K & 6)) throw Error($75da31f4a46773b1$var$p(327));
    $75da31f4a46773b1$var$Hk();
    var b = $75da31f4a46773b1$var$uc(a, 0);
    if (0 === (b & 1)) return $75da31f4a46773b1$var$Dk(a, $75da31f4a46773b1$var$B()), null;
    var c = $75da31f4a46773b1$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $75da31f4a46773b1$var$xc(a);
        0 !== d && (b = d, c = $75da31f4a46773b1$var$Nk(a, d));
    }
    if (1 === c) throw c = $75da31f4a46773b1$var$pk, $75da31f4a46773b1$var$Kk(a, 0), $75da31f4a46773b1$var$Ck(a, b), $75da31f4a46773b1$var$Dk(a, $75da31f4a46773b1$var$B()), c;
    if (6 === c) throw Error($75da31f4a46773b1$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $75da31f4a46773b1$var$Pk(a, $75da31f4a46773b1$var$tk, $75da31f4a46773b1$var$uk);
    $75da31f4a46773b1$var$Dk(a, $75da31f4a46773b1$var$B());
    return null;
}
function $75da31f4a46773b1$var$Qk(a, b) {
    var c = $75da31f4a46773b1$var$K;
    $75da31f4a46773b1$var$K |= 1;
    try {
        return a(b);
    } finally{
        $75da31f4a46773b1$var$K = c, 0 === $75da31f4a46773b1$var$K && ($75da31f4a46773b1$var$Gj = $75da31f4a46773b1$var$B() + 500, $75da31f4a46773b1$var$fg && $75da31f4a46773b1$var$jg());
    }
}
function $75da31f4a46773b1$var$Rk(a) {
    null !== $75da31f4a46773b1$var$wk && 0 === $75da31f4a46773b1$var$wk.tag && 0 === ($75da31f4a46773b1$var$K & 6) && $75da31f4a46773b1$var$Hk();
    var b = $75da31f4a46773b1$var$K;
    $75da31f4a46773b1$var$K |= 1;
    var c = $75da31f4a46773b1$var$ok.transition, d = $75da31f4a46773b1$var$C;
    try {
        if ($75da31f4a46773b1$var$ok.transition = null, $75da31f4a46773b1$var$C = 1, a) return a();
    } finally{
        $75da31f4a46773b1$var$C = d, $75da31f4a46773b1$var$ok.transition = c, $75da31f4a46773b1$var$K = b, 0 === ($75da31f4a46773b1$var$K & 6) && $75da31f4a46773b1$var$jg();
    }
}
function $75da31f4a46773b1$var$Hj() {
    $75da31f4a46773b1$var$fj = $75da31f4a46773b1$var$ej.current;
    $75da31f4a46773b1$var$E($75da31f4a46773b1$var$ej);
}
function $75da31f4a46773b1$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $75da31f4a46773b1$var$Gf(c));
    if (null !== $75da31f4a46773b1$var$Y) for(c = $75da31f4a46773b1$var$Y.return; null !== c;){
        var d = c;
        $75da31f4a46773b1$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $75da31f4a46773b1$var$$f();
                break;
            case 3:
                $75da31f4a46773b1$var$zh();
                $75da31f4a46773b1$var$E($75da31f4a46773b1$var$Wf);
                $75da31f4a46773b1$var$E($75da31f4a46773b1$var$H);
                $75da31f4a46773b1$var$Eh();
                break;
            case 5:
                $75da31f4a46773b1$var$Bh(d);
                break;
            case 4:
                $75da31f4a46773b1$var$zh();
                break;
            case 13:
                $75da31f4a46773b1$var$E($75da31f4a46773b1$var$L);
                break;
            case 19:
                $75da31f4a46773b1$var$E($75da31f4a46773b1$var$L);
                break;
            case 10:
                $75da31f4a46773b1$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $75da31f4a46773b1$var$Hj();
        }
        c = c.return;
    }
    $75da31f4a46773b1$var$Q = a;
    $75da31f4a46773b1$var$Y = a = $75da31f4a46773b1$var$Pg(a.current, null);
    $75da31f4a46773b1$var$Z = $75da31f4a46773b1$var$fj = b;
    $75da31f4a46773b1$var$T = 0;
    $75da31f4a46773b1$var$pk = null;
    $75da31f4a46773b1$var$rk = $75da31f4a46773b1$var$qk = $75da31f4a46773b1$var$rh = 0;
    $75da31f4a46773b1$var$tk = $75da31f4a46773b1$var$sk = null;
    if (null !== $75da31f4a46773b1$var$fh) {
        for(b = 0; b < $75da31f4a46773b1$var$fh.length; b++)if (c = $75da31f4a46773b1$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $75da31f4a46773b1$var$fh = null;
    }
    return a;
}
function $75da31f4a46773b1$var$Mk(a, b) {
    do {
        var c = $75da31f4a46773b1$var$Y;
        try {
            $75da31f4a46773b1$var$$g();
            $75da31f4a46773b1$var$Fh.current = $75da31f4a46773b1$var$Rh;
            if ($75da31f4a46773b1$var$Ih) {
                for(var d = $75da31f4a46773b1$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $75da31f4a46773b1$var$Ih = !1;
            }
            $75da31f4a46773b1$var$Hh = 0;
            $75da31f4a46773b1$var$O = $75da31f4a46773b1$var$N = $75da31f4a46773b1$var$M = null;
            $75da31f4a46773b1$var$Jh = !1;
            $75da31f4a46773b1$var$Kh = 0;
            $75da31f4a46773b1$var$nk.current = null;
            if (null === c || null === c.return) {
                $75da31f4a46773b1$var$T = 1;
                $75da31f4a46773b1$var$pk = b;
                $75da31f4a46773b1$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $75da31f4a46773b1$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $75da31f4a46773b1$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $75da31f4a46773b1$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $75da31f4a46773b1$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $75da31f4a46773b1$var$Si(f, l, b);
                            $75da31f4a46773b1$var$tj();
                            break a;
                        }
                        k = Error($75da31f4a46773b1$var$p(426));
                    }
                } else if ($75da31f4a46773b1$var$I && h.mode & 1) {
                    var J = $75da31f4a46773b1$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $75da31f4a46773b1$var$Vi(J, g, h, f, b);
                        $75da31f4a46773b1$var$Jg($75da31f4a46773b1$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $75da31f4a46773b1$var$Ji(k, h);
                4 !== $75da31f4a46773b1$var$T && ($75da31f4a46773b1$var$T = 2);
                null === $75da31f4a46773b1$var$sk ? $75da31f4a46773b1$var$sk = [
                    f
                ] : $75da31f4a46773b1$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $75da31f4a46773b1$var$Ni(f, k, b);
                            $75da31f4a46773b1$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $75da31f4a46773b1$var$Ri || !$75da31f4a46773b1$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $75da31f4a46773b1$var$Qi(f, h, b);
                                $75da31f4a46773b1$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $75da31f4a46773b1$var$Sk(c);
        } catch (na) {
            b = na;
            $75da31f4a46773b1$var$Y === c && null !== c && ($75da31f4a46773b1$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $75da31f4a46773b1$var$Jk() {
    var a = $75da31f4a46773b1$var$mk.current;
    $75da31f4a46773b1$var$mk.current = $75da31f4a46773b1$var$Rh;
    return null === a ? $75da31f4a46773b1$var$Rh : a;
}
function $75da31f4a46773b1$var$tj() {
    if (0 === $75da31f4a46773b1$var$T || 3 === $75da31f4a46773b1$var$T || 2 === $75da31f4a46773b1$var$T) $75da31f4a46773b1$var$T = 4;
    null === $75da31f4a46773b1$var$Q || 0 === ($75da31f4a46773b1$var$rh & 268435455) && 0 === ($75da31f4a46773b1$var$qk & 268435455) || $75da31f4a46773b1$var$Ck($75da31f4a46773b1$var$Q, $75da31f4a46773b1$var$Z);
}
function $75da31f4a46773b1$var$Ik(a, b) {
    var c = $75da31f4a46773b1$var$K;
    $75da31f4a46773b1$var$K |= 2;
    var d = $75da31f4a46773b1$var$Jk();
    if ($75da31f4a46773b1$var$Q !== a || $75da31f4a46773b1$var$Z !== b) $75da31f4a46773b1$var$uk = null, $75da31f4a46773b1$var$Kk(a, b);
    for(;;)try {
        $75da31f4a46773b1$var$Tk();
        break;
    } catch (e) {
        $75da31f4a46773b1$var$Mk(a, e);
    }
    $75da31f4a46773b1$var$$g();
    $75da31f4a46773b1$var$K = c;
    $75da31f4a46773b1$var$mk.current = d;
    if (null !== $75da31f4a46773b1$var$Y) throw Error($75da31f4a46773b1$var$p(261));
    $75da31f4a46773b1$var$Q = null;
    $75da31f4a46773b1$var$Z = 0;
    return $75da31f4a46773b1$var$T;
}
function $75da31f4a46773b1$var$Tk() {
    for(; null !== $75da31f4a46773b1$var$Y;)$75da31f4a46773b1$var$Uk($75da31f4a46773b1$var$Y);
}
function $75da31f4a46773b1$var$Lk() {
    for(; null !== $75da31f4a46773b1$var$Y && !$75da31f4a46773b1$var$cc();)$75da31f4a46773b1$var$Uk($75da31f4a46773b1$var$Y);
}
function $75da31f4a46773b1$var$Uk(a) {
    var b = $75da31f4a46773b1$var$Vk(a.alternate, a, $75da31f4a46773b1$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $75da31f4a46773b1$var$Sk(a) : $75da31f4a46773b1$var$Y = b;
    $75da31f4a46773b1$var$nk.current = null;
}
function $75da31f4a46773b1$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $75da31f4a46773b1$var$Ej(c, b, $75da31f4a46773b1$var$fj), null !== c) {
                $75da31f4a46773b1$var$Y = c;
                return;
            }
        } else {
            c = $75da31f4a46773b1$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $75da31f4a46773b1$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $75da31f4a46773b1$var$T = 6;
                $75da31f4a46773b1$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $75da31f4a46773b1$var$Y = b;
            return;
        }
        $75da31f4a46773b1$var$Y = b = a;
    }while (null !== b);
    0 === $75da31f4a46773b1$var$T && ($75da31f4a46773b1$var$T = 5);
}
function $75da31f4a46773b1$var$Pk(a, b, c) {
    var d = $75da31f4a46773b1$var$C, e = $75da31f4a46773b1$var$ok.transition;
    try {
        $75da31f4a46773b1$var$ok.transition = null, $75da31f4a46773b1$var$C = 1, $75da31f4a46773b1$var$Wk(a, b, c, d);
    } finally{
        $75da31f4a46773b1$var$ok.transition = e, $75da31f4a46773b1$var$C = d;
    }
    return null;
}
function $75da31f4a46773b1$var$Wk(a, b, c, d) {
    do $75da31f4a46773b1$var$Hk();
    while (null !== $75da31f4a46773b1$var$wk);
    if (0 !== ($75da31f4a46773b1$var$K & 6)) throw Error($75da31f4a46773b1$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($75da31f4a46773b1$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $75da31f4a46773b1$var$Bc(a, f);
    a === $75da31f4a46773b1$var$Q && ($75da31f4a46773b1$var$Y = $75da31f4a46773b1$var$Q = null, $75da31f4a46773b1$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $75da31f4a46773b1$var$vk || ($75da31f4a46773b1$var$vk = !0, $75da31f4a46773b1$var$Fk($75da31f4a46773b1$var$hc, function() {
        $75da31f4a46773b1$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $75da31f4a46773b1$var$ok.transition;
        $75da31f4a46773b1$var$ok.transition = null;
        var g = $75da31f4a46773b1$var$C;
        $75da31f4a46773b1$var$C = 1;
        var h = $75da31f4a46773b1$var$K;
        $75da31f4a46773b1$var$K |= 4;
        $75da31f4a46773b1$var$nk.current = null;
        $75da31f4a46773b1$var$Oj(a, c);
        $75da31f4a46773b1$var$dk(c, a);
        $75da31f4a46773b1$var$Oe($75da31f4a46773b1$var$Df);
        $75da31f4a46773b1$var$dd = !!$75da31f4a46773b1$var$Cf;
        $75da31f4a46773b1$var$Df = $75da31f4a46773b1$var$Cf = null;
        a.current = c;
        $75da31f4a46773b1$var$hk(c, a, e);
        $75da31f4a46773b1$var$dc();
        $75da31f4a46773b1$var$K = h;
        $75da31f4a46773b1$var$C = g;
        $75da31f4a46773b1$var$ok.transition = f;
    } else a.current = c;
    $75da31f4a46773b1$var$vk && ($75da31f4a46773b1$var$vk = !1, $75da31f4a46773b1$var$wk = a, $75da31f4a46773b1$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($75da31f4a46773b1$var$Ri = null);
    $75da31f4a46773b1$var$mc(c.stateNode, d);
    $75da31f4a46773b1$var$Dk(a, $75da31f4a46773b1$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($75da31f4a46773b1$var$Oi) throw $75da31f4a46773b1$var$Oi = !1, a = $75da31f4a46773b1$var$Pi, $75da31f4a46773b1$var$Pi = null, a;
    0 !== ($75da31f4a46773b1$var$xk & 1) && 0 !== a.tag && $75da31f4a46773b1$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $75da31f4a46773b1$var$zk ? $75da31f4a46773b1$var$yk++ : ($75da31f4a46773b1$var$yk = 0, $75da31f4a46773b1$var$zk = a) : $75da31f4a46773b1$var$yk = 0;
    $75da31f4a46773b1$var$jg();
    return null;
}
function $75da31f4a46773b1$var$Hk() {
    if (null !== $75da31f4a46773b1$var$wk) {
        var a = $75da31f4a46773b1$var$Dc($75da31f4a46773b1$var$xk), b = $75da31f4a46773b1$var$ok.transition, c = $75da31f4a46773b1$var$C;
        try {
            $75da31f4a46773b1$var$ok.transition = null;
            $75da31f4a46773b1$var$C = 16 > a ? 16 : a;
            if (null === $75da31f4a46773b1$var$wk) var d = !1;
            else {
                a = $75da31f4a46773b1$var$wk;
                $75da31f4a46773b1$var$wk = null;
                $75da31f4a46773b1$var$xk = 0;
                if (0 !== ($75da31f4a46773b1$var$K & 6)) throw Error($75da31f4a46773b1$var$p(331));
                var e = $75da31f4a46773b1$var$K;
                $75da31f4a46773b1$var$K |= 4;
                for($75da31f4a46773b1$var$V = a.current; null !== $75da31f4a46773b1$var$V;){
                    var f = $75da31f4a46773b1$var$V, g = f.child;
                    if (0 !== ($75da31f4a46773b1$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($75da31f4a46773b1$var$V = l; null !== $75da31f4a46773b1$var$V;){
                                    var m = $75da31f4a46773b1$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $75da31f4a46773b1$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $75da31f4a46773b1$var$V = q;
                                    else for(; null !== $75da31f4a46773b1$var$V;){
                                        m = $75da31f4a46773b1$var$V;
                                        var r = m.sibling, y = m.return;
                                        $75da31f4a46773b1$var$Sj(m);
                                        if (m === l) {
                                            $75da31f4a46773b1$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $75da31f4a46773b1$var$V = r;
                                            break;
                                        }
                                        $75da31f4a46773b1$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $75da31f4a46773b1$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $75da31f4a46773b1$var$V = g;
                    else b: for(; null !== $75da31f4a46773b1$var$V;){
                        f = $75da31f4a46773b1$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $75da31f4a46773b1$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $75da31f4a46773b1$var$V = x;
                            break b;
                        }
                        $75da31f4a46773b1$var$V = f.return;
                    }
                }
                var w = a.current;
                for($75da31f4a46773b1$var$V = w; null !== $75da31f4a46773b1$var$V;){
                    g = $75da31f4a46773b1$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $75da31f4a46773b1$var$V = u;
                    else b: for(g = w; null !== $75da31f4a46773b1$var$V;){
                        h = $75da31f4a46773b1$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $75da31f4a46773b1$var$Qj(9, h);
                            }
                        } catch (na) {
                            $75da31f4a46773b1$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $75da31f4a46773b1$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $75da31f4a46773b1$var$V = F;
                            break b;
                        }
                        $75da31f4a46773b1$var$V = h.return;
                    }
                }
                $75da31f4a46773b1$var$K = e;
                $75da31f4a46773b1$var$jg();
                if ($75da31f4a46773b1$var$lc && "function" === typeof $75da31f4a46773b1$var$lc.onPostCommitFiberRoot) try {
                    $75da31f4a46773b1$var$lc.onPostCommitFiberRoot($75da31f4a46773b1$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $75da31f4a46773b1$var$C = c, $75da31f4a46773b1$var$ok.transition = b;
        }
    }
    return !1;
}
function $75da31f4a46773b1$var$Xk(a, b, c) {
    b = $75da31f4a46773b1$var$Ji(c, b);
    b = $75da31f4a46773b1$var$Ni(a, b, 1);
    a = $75da31f4a46773b1$var$nh(a, b, 1);
    b = $75da31f4a46773b1$var$R();
    null !== a && ($75da31f4a46773b1$var$Ac(a, 1, b), $75da31f4a46773b1$var$Dk(a, b));
}
function $75da31f4a46773b1$var$W(a, b, c) {
    if (3 === a.tag) $75da31f4a46773b1$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $75da31f4a46773b1$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $75da31f4a46773b1$var$Ri || !$75da31f4a46773b1$var$Ri.has(d))) {
                a = $75da31f4a46773b1$var$Ji(c, a);
                a = $75da31f4a46773b1$var$Qi(b, a, 1);
                b = $75da31f4a46773b1$var$nh(b, a, 1);
                a = $75da31f4a46773b1$var$R();
                null !== b && ($75da31f4a46773b1$var$Ac(b, 1, a), $75da31f4a46773b1$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $75da31f4a46773b1$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $75da31f4a46773b1$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $75da31f4a46773b1$var$Q === a && ($75da31f4a46773b1$var$Z & c) === c && (4 === $75da31f4a46773b1$var$T || 3 === $75da31f4a46773b1$var$T && ($75da31f4a46773b1$var$Z & 130023424) === $75da31f4a46773b1$var$Z && 500 > $75da31f4a46773b1$var$B() - $75da31f4a46773b1$var$fk ? $75da31f4a46773b1$var$Kk(a, 0) : $75da31f4a46773b1$var$rk |= c);
    $75da31f4a46773b1$var$Dk(a, b);
}
function $75da31f4a46773b1$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $75da31f4a46773b1$var$sc, $75da31f4a46773b1$var$sc <<= 1, 0 === ($75da31f4a46773b1$var$sc & 130023424) && ($75da31f4a46773b1$var$sc = 4194304)));
    var c = $75da31f4a46773b1$var$R();
    a = $75da31f4a46773b1$var$ih(a, b);
    null !== a && ($75da31f4a46773b1$var$Ac(a, b, c), $75da31f4a46773b1$var$Dk(a, c));
}
function $75da31f4a46773b1$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $75da31f4a46773b1$var$Yk(a, c);
}
function $75da31f4a46773b1$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($75da31f4a46773b1$var$p(314));
    }
    null !== d && d.delete(b);
    $75da31f4a46773b1$var$Yk(a, c);
}
var $75da31f4a46773b1$var$Vk;
$75da31f4a46773b1$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $75da31f4a46773b1$var$Wf.current) $75da31f4a46773b1$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $75da31f4a46773b1$var$dh = !1, $75da31f4a46773b1$var$yj(a, b, c);
            $75da31f4a46773b1$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $75da31f4a46773b1$var$dh = !1, $75da31f4a46773b1$var$I && 0 !== (b.flags & 1048576) && $75da31f4a46773b1$var$ug(b, $75da31f4a46773b1$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $75da31f4a46773b1$var$ij(a, b);
            a = b.pendingProps;
            var e = $75da31f4a46773b1$var$Yf(b, $75da31f4a46773b1$var$H.current);
            $75da31f4a46773b1$var$ch(b, c);
            e = $75da31f4a46773b1$var$Nh(null, b, d, a, e, c);
            var f = $75da31f4a46773b1$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $75da31f4a46773b1$var$Zf(d) ? (f = !0, $75da31f4a46773b1$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $75da31f4a46773b1$var$kh(b), e.updater = $75da31f4a46773b1$var$Ei, b.stateNode = e, e._reactInternals = b, $75da31f4a46773b1$var$Ii(b, d, a, c), b = $75da31f4a46773b1$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $75da31f4a46773b1$var$I && f && $75da31f4a46773b1$var$vg(b), $75da31f4a46773b1$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $75da31f4a46773b1$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $75da31f4a46773b1$var$Zk(d);
                a = $75da31f4a46773b1$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $75da31f4a46773b1$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $75da31f4a46773b1$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $75da31f4a46773b1$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $75da31f4a46773b1$var$$i(null, b, d, $75da31f4a46773b1$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($75da31f4a46773b1$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $75da31f4a46773b1$var$Ci(d, e), $75da31f4a46773b1$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $75da31f4a46773b1$var$Ci(d, e), $75da31f4a46773b1$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $75da31f4a46773b1$var$kj(b);
                if (null === a) throw Error($75da31f4a46773b1$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $75da31f4a46773b1$var$lh(a, b);
                $75da31f4a46773b1$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $75da31f4a46773b1$var$Ji(Error($75da31f4a46773b1$var$p(423)), b);
                        b = $75da31f4a46773b1$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $75da31f4a46773b1$var$Ji(Error($75da31f4a46773b1$var$p(424)), b);
                        b = $75da31f4a46773b1$var$lj(a, b, d, c, e);
                        break a;
                    } else for($75da31f4a46773b1$var$yg = $75da31f4a46773b1$var$Lf(b.stateNode.containerInfo.firstChild), $75da31f4a46773b1$var$xg = b, $75da31f4a46773b1$var$I = !0, $75da31f4a46773b1$var$zg = null, c = $75da31f4a46773b1$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $75da31f4a46773b1$var$Ig();
                    if (d === e) {
                        b = $75da31f4a46773b1$var$Zi(a, b, c);
                        break a;
                    }
                    $75da31f4a46773b1$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $75da31f4a46773b1$var$Ah(b), null === a && $75da31f4a46773b1$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $75da31f4a46773b1$var$Ef(d, e) ? g = null : null !== f && $75da31f4a46773b1$var$Ef(d, f) && (b.flags |= 32), $75da31f4a46773b1$var$gj(a, b), $75da31f4a46773b1$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $75da31f4a46773b1$var$Eg(b), null;
        case 13:
            return $75da31f4a46773b1$var$oj(a, b, c);
        case 4:
            return $75da31f4a46773b1$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $75da31f4a46773b1$var$Ug(b, null, d, c) : $75da31f4a46773b1$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $75da31f4a46773b1$var$Ci(d, e), $75da31f4a46773b1$var$Yi(a, b, d, e, c);
        case 7:
            return $75da31f4a46773b1$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $75da31f4a46773b1$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $75da31f4a46773b1$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $75da31f4a46773b1$var$G($75da31f4a46773b1$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($75da31f4a46773b1$var$He(f.value, g)) {
                        if (f.children === e.children && !$75da31f4a46773b1$var$Wf.current) {
                            b = $75da31f4a46773b1$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $75da31f4a46773b1$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $75da31f4a46773b1$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($75da31f4a46773b1$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $75da31f4a46773b1$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $75da31f4a46773b1$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $75da31f4a46773b1$var$ch(b, c), e = $75da31f4a46773b1$var$eh(e), d = d(e), b.flags |= 1, $75da31f4a46773b1$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $75da31f4a46773b1$var$Ci(d, b.pendingProps), e = $75da31f4a46773b1$var$Ci(d.type, e), $75da31f4a46773b1$var$$i(a, b, d, e, c);
        case 15:
            return $75da31f4a46773b1$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $75da31f4a46773b1$var$Ci(d, e), $75da31f4a46773b1$var$ij(a, b), b.tag = 1, $75da31f4a46773b1$var$Zf(d) ? (a = !0, $75da31f4a46773b1$var$cg(b)) : a = !1, $75da31f4a46773b1$var$ch(b, c), $75da31f4a46773b1$var$Gi(b, d, e), $75da31f4a46773b1$var$Ii(b, d, e, c), $75da31f4a46773b1$var$jj(null, b, d, !0, a, c);
        case 19:
            return $75da31f4a46773b1$var$xj(a, b, c);
        case 22:
            return $75da31f4a46773b1$var$dj(a, b, c);
    }
    throw Error($75da31f4a46773b1$var$p(156, b.tag));
};
function $75da31f4a46773b1$var$Fk(a, b) {
    return $75da31f4a46773b1$var$ac(a, b);
}
function $75da31f4a46773b1$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $75da31f4a46773b1$var$Bg(a, b, c, d) {
    return new $75da31f4a46773b1$var$$k(a, b, c, d);
}
function $75da31f4a46773b1$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $75da31f4a46773b1$var$Zk(a) {
    if ("function" === typeof a) return $75da31f4a46773b1$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $75da31f4a46773b1$var$Da) return 11;
        if (a === $75da31f4a46773b1$var$Ga) return 14;
    }
    return 2;
}
function $75da31f4a46773b1$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $75da31f4a46773b1$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $75da31f4a46773b1$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $75da31f4a46773b1$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $75da31f4a46773b1$var$ya:
            return $75da31f4a46773b1$var$Tg(c.children, e, f, b);
        case $75da31f4a46773b1$var$za:
            g = 8;
            e |= 8;
            break;
        case $75da31f4a46773b1$var$Aa:
            return a = $75da31f4a46773b1$var$Bg(12, c, b, e | 2), a.elementType = $75da31f4a46773b1$var$Aa, a.lanes = f, a;
        case $75da31f4a46773b1$var$Ea:
            return a = $75da31f4a46773b1$var$Bg(13, c, b, e), a.elementType = $75da31f4a46773b1$var$Ea, a.lanes = f, a;
        case $75da31f4a46773b1$var$Fa:
            return a = $75da31f4a46773b1$var$Bg(19, c, b, e), a.elementType = $75da31f4a46773b1$var$Fa, a.lanes = f, a;
        case $75da31f4a46773b1$var$Ia:
            return $75da31f4a46773b1$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $75da31f4a46773b1$var$Ba:
                    g = 10;
                    break a;
                case $75da31f4a46773b1$var$Ca:
                    g = 9;
                    break a;
                case $75da31f4a46773b1$var$Da:
                    g = 11;
                    break a;
                case $75da31f4a46773b1$var$Ga:
                    g = 14;
                    break a;
                case $75da31f4a46773b1$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($75da31f4a46773b1$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $75da31f4a46773b1$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $75da31f4a46773b1$var$Tg(a, b, c, d) {
    a = $75da31f4a46773b1$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $75da31f4a46773b1$var$pj(a, b, c, d) {
    a = $75da31f4a46773b1$var$Bg(22, a, d, b);
    a.elementType = $75da31f4a46773b1$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $75da31f4a46773b1$var$Qg(a, b, c) {
    a = $75da31f4a46773b1$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $75da31f4a46773b1$var$Sg(a, b, c) {
    b = $75da31f4a46773b1$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $75da31f4a46773b1$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $75da31f4a46773b1$var$zc(0);
    this.expirationTimes = $75da31f4a46773b1$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $75da31f4a46773b1$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $75da31f4a46773b1$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $75da31f4a46773b1$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $75da31f4a46773b1$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $75da31f4a46773b1$var$kh(f);
    return a;
}
function $75da31f4a46773b1$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $75da31f4a46773b1$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $75da31f4a46773b1$var$dl(a) {
    if (!a) return $75da31f4a46773b1$var$Vf;
    a = a._reactInternals;
    a: {
        if ($75da31f4a46773b1$var$Vb(a) !== a || 1 !== a.tag) throw Error($75da31f4a46773b1$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($75da31f4a46773b1$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($75da31f4a46773b1$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($75da31f4a46773b1$var$Zf(c)) return $75da31f4a46773b1$var$bg(a, c, b);
    }
    return b;
}
function $75da31f4a46773b1$var$el(a, b, c, d, e, f, g, h, k) {
    a = $75da31f4a46773b1$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $75da31f4a46773b1$var$dl(null);
    c = a.current;
    d = $75da31f4a46773b1$var$R();
    e = $75da31f4a46773b1$var$yi(c);
    f = $75da31f4a46773b1$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $75da31f4a46773b1$var$nh(c, f, e);
    a.current.lanes = e;
    $75da31f4a46773b1$var$Ac(a, e, d);
    $75da31f4a46773b1$var$Dk(a, d);
    return a;
}
function $75da31f4a46773b1$var$fl(a, b, c, d) {
    var e = b.current, f = $75da31f4a46773b1$var$R(), g = $75da31f4a46773b1$var$yi(e);
    c = $75da31f4a46773b1$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $75da31f4a46773b1$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $75da31f4a46773b1$var$nh(e, b, g);
    null !== a && ($75da31f4a46773b1$var$gi(a, e, g, f), $75da31f4a46773b1$var$oh(a, e, g));
    return g;
}
function $75da31f4a46773b1$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $75da31f4a46773b1$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $75da31f4a46773b1$var$il(a, b) {
    $75da31f4a46773b1$var$hl(a, b);
    (a = a.alternate) && $75da31f4a46773b1$var$hl(a, b);
}
function $75da31f4a46773b1$var$jl() {
    return null;
}
var $75da31f4a46773b1$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $75da31f4a46773b1$var$ll(a) {
    this._internalRoot = a;
}
$75da31f4a46773b1$var$ml.prototype.render = $75da31f4a46773b1$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($75da31f4a46773b1$var$p(409));
    $75da31f4a46773b1$var$fl(a, b, null, null);
};
$75da31f4a46773b1$var$ml.prototype.unmount = $75da31f4a46773b1$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $75da31f4a46773b1$var$Rk(function() {
            $75da31f4a46773b1$var$fl(null, a, null, null);
        });
        b[$75da31f4a46773b1$var$uf] = null;
    }
};
function $75da31f4a46773b1$var$ml(a) {
    this._internalRoot = a;
}
$75da31f4a46773b1$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $75da31f4a46773b1$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $75da31f4a46773b1$var$Qc.length && 0 !== b && b < $75da31f4a46773b1$var$Qc[c].priority; c++);
        $75da31f4a46773b1$var$Qc.splice(c, 0, a);
        0 === c && $75da31f4a46773b1$var$Vc(a);
    }
};
function $75da31f4a46773b1$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $75da31f4a46773b1$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $75da31f4a46773b1$var$pl() {}
function $75da31f4a46773b1$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $75da31f4a46773b1$var$gl(g);
                f.call(a);
            };
        }
        var g = $75da31f4a46773b1$var$el(b, d, a, 0, null, !1, !1, "", $75da31f4a46773b1$var$pl);
        a._reactRootContainer = g;
        a[$75da31f4a46773b1$var$uf] = g.current;
        $75da31f4a46773b1$var$sf(8 === a.nodeType ? a.parentNode : a);
        $75da31f4a46773b1$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $75da31f4a46773b1$var$gl(k);
            h.call(a);
        };
    }
    var k = $75da31f4a46773b1$var$bl(a, 0, !1, null, null, !1, !1, "", $75da31f4a46773b1$var$pl);
    a._reactRootContainer = k;
    a[$75da31f4a46773b1$var$uf] = k.current;
    $75da31f4a46773b1$var$sf(8 === a.nodeType ? a.parentNode : a);
    $75da31f4a46773b1$var$Rk(function() {
        $75da31f4a46773b1$var$fl(b, k, c, d);
    });
    return k;
}
function $75da31f4a46773b1$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $75da31f4a46773b1$var$gl(g);
                h.call(a);
            };
        }
        $75da31f4a46773b1$var$fl(b, g, a, e);
    } else g = $75da31f4a46773b1$var$ql(c, b, a, e, d);
    return $75da31f4a46773b1$var$gl(g);
}
$75da31f4a46773b1$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $75da31f4a46773b1$var$tc(b.pendingLanes);
                0 !== c && ($75da31f4a46773b1$var$Cc(b, c | 1), $75da31f4a46773b1$var$Dk(b, $75da31f4a46773b1$var$B()), 0 === ($75da31f4a46773b1$var$K & 6) && ($75da31f4a46773b1$var$Gj = $75da31f4a46773b1$var$B() + 500, $75da31f4a46773b1$var$jg()));
            }
            break;
        case 13:
            $75da31f4a46773b1$var$Rk(function() {
                var b = $75da31f4a46773b1$var$ih(a, 1);
                if (null !== b) {
                    var c = $75da31f4a46773b1$var$R();
                    $75da31f4a46773b1$var$gi(b, a, 1, c);
                }
            }), $75da31f4a46773b1$var$il(a, 1);
    }
};
$75da31f4a46773b1$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $75da31f4a46773b1$var$ih(a, 134217728);
        if (null !== b) {
            var c = $75da31f4a46773b1$var$R();
            $75da31f4a46773b1$var$gi(b, a, 134217728, c);
        }
        $75da31f4a46773b1$var$il(a, 134217728);
    }
};
$75da31f4a46773b1$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $75da31f4a46773b1$var$yi(a), c = $75da31f4a46773b1$var$ih(a, b);
        if (null !== c) {
            var d = $75da31f4a46773b1$var$R();
            $75da31f4a46773b1$var$gi(c, a, b, d);
        }
        $75da31f4a46773b1$var$il(a, b);
    }
};
$75da31f4a46773b1$var$Hc = function() {
    return $75da31f4a46773b1$var$C;
};
$75da31f4a46773b1$var$Ic = function(a, b) {
    var c = $75da31f4a46773b1$var$C;
    try {
        return $75da31f4a46773b1$var$C = a, b();
    } finally{
        $75da31f4a46773b1$var$C = c;
    }
};
$75da31f4a46773b1$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $75da31f4a46773b1$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $75da31f4a46773b1$var$Db(d);
                        if (!e) throw Error($75da31f4a46773b1$var$p(90));
                        $75da31f4a46773b1$var$Wa(d);
                        $75da31f4a46773b1$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $75da31f4a46773b1$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $75da31f4a46773b1$var$fb(a, !!c.multiple, b, !1);
    }
};
$75da31f4a46773b1$var$Gb = $75da31f4a46773b1$var$Qk;
$75da31f4a46773b1$var$Hb = $75da31f4a46773b1$var$Rk;
var $75da31f4a46773b1$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $75da31f4a46773b1$var$Cb,
        $75da31f4a46773b1$var$ue,
        $75da31f4a46773b1$var$Db,
        $75da31f4a46773b1$var$Eb,
        $75da31f4a46773b1$var$Fb,
        $75da31f4a46773b1$var$Qk
    ]
}, $75da31f4a46773b1$var$tl = {
    findFiberByHostInstance: $75da31f4a46773b1$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $75da31f4a46773b1$var$ul = {
    bundleType: $75da31f4a46773b1$var$tl.bundleType,
    version: $75da31f4a46773b1$var$tl.version,
    rendererPackageName: $75da31f4a46773b1$var$tl.rendererPackageName,
    rendererConfig: $75da31f4a46773b1$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $75da31f4a46773b1$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $75da31f4a46773b1$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $75da31f4a46773b1$var$tl.findFiberByHostInstance || $75da31f4a46773b1$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $75da31f4a46773b1$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$75da31f4a46773b1$var$vl.isDisabled && $75da31f4a46773b1$var$vl.supportsFiber) try {
        $75da31f4a46773b1$var$kc = $75da31f4a46773b1$var$vl.inject($75da31f4a46773b1$var$ul), $75da31f4a46773b1$var$lc = $75da31f4a46773b1$var$vl;
    } catch (a) {}
}
$75da31f4a46773b1$export$ae55be85d98224ed = $75da31f4a46773b1$var$sl;
$75da31f4a46773b1$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$75da31f4a46773b1$var$nl(b)) throw Error($75da31f4a46773b1$var$p(200));
    return $75da31f4a46773b1$var$cl(a, b, null, c);
};
$75da31f4a46773b1$export$882461b6382ed46c = function(a, b) {
    if (!$75da31f4a46773b1$var$nl(a)) throw Error($75da31f4a46773b1$var$p(299));
    var c = !1, d = "", e = $75da31f4a46773b1$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $75da31f4a46773b1$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$75da31f4a46773b1$var$uf] = b.current;
    $75da31f4a46773b1$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $75da31f4a46773b1$var$ll(b);
};
$75da31f4a46773b1$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($75da31f4a46773b1$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($75da31f4a46773b1$var$p(268, a));
    }
    a = $75da31f4a46773b1$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$75da31f4a46773b1$export$cd75ccfd720a3cd4 = function(a) {
    return $75da31f4a46773b1$var$Rk(a);
};
$75da31f4a46773b1$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$75da31f4a46773b1$var$ol(b)) throw Error($75da31f4a46773b1$var$p(200));
    return $75da31f4a46773b1$var$rl(null, a, b, !0, c);
};
$75da31f4a46773b1$export$757ceba2d55c277e = function(a, b, c) {
    if (!$75da31f4a46773b1$var$nl(a)) throw Error($75da31f4a46773b1$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $75da31f4a46773b1$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $75da31f4a46773b1$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$75da31f4a46773b1$var$uf] = b.current;
    $75da31f4a46773b1$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $75da31f4a46773b1$var$ml(b);
};
$75da31f4a46773b1$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$75da31f4a46773b1$var$ol(b)) throw Error($75da31f4a46773b1$var$p(200));
    return $75da31f4a46773b1$var$rl(null, a, b, !1, c);
};
$75da31f4a46773b1$export$502457920280e6be = function(a) {
    if (!$75da31f4a46773b1$var$ol(a)) throw Error($75da31f4a46773b1$var$p(40));
    return a._reactRootContainer ? ($75da31f4a46773b1$var$Rk(function() {
        $75da31f4a46773b1$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$75da31f4a46773b1$var$uf] = null;
        });
    }), !0) : !1;
};
$75da31f4a46773b1$export$c78a37762a8d58e1 = $75da31f4a46773b1$var$Qk;
$75da31f4a46773b1$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$75da31f4a46773b1$var$ol(c)) throw Error($75da31f4a46773b1$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($75da31f4a46773b1$var$p(38));
    return $75da31f4a46773b1$var$rl(a, b, c, !1, d);
};
$75da31f4a46773b1$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("3CIn6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hSMmi"));

});
parcelRegister("hSMmi", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d04cfdd32c068e5e$export$c4744153514ff05d; }, function (v) { return $d04cfdd32c068e5e$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d04cfdd32c068e5e$export$3e506c1ccc9cc1a7; }, function (v) { return $d04cfdd32c068e5e$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d04cfdd32c068e5e$export$e26fe2ed2fa76875; }, function (v) { return $d04cfdd32c068e5e$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d04cfdd32c068e5e$export$502329bbf4b505b1; }, function (v) { return $d04cfdd32c068e5e$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d04cfdd32c068e5e$export$6e3807111c4874c4; }, function (v) { return $d04cfdd32c068e5e$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d04cfdd32c068e5e$export$c27134553091fb3a; }, function (v) { return $d04cfdd32c068e5e$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d04cfdd32c068e5e$export$33ee1acdc04fd2a2; }, function (v) { return $d04cfdd32c068e5e$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d04cfdd32c068e5e$export$b00a404bbd5edef2; }, function (v) { return $d04cfdd32c068e5e$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d04cfdd32c068e5e$export$8352ce38b91d0c62; }, function (v) { return $d04cfdd32c068e5e$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d04cfdd32c068e5e$export$d66a1c1c77bd778b; }, function (v) { return $d04cfdd32c068e5e$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d04cfdd32c068e5e$export$d3dfb8e4810cb555; }, function (v) { return $d04cfdd32c068e5e$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d04cfdd32c068e5e$export$839f9183b0465a69; }, function (v) { return $d04cfdd32c068e5e$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d04cfdd32c068e5e$export$72fdf0e06517287b; }, function (v) { return $d04cfdd32c068e5e$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d04cfdd32c068e5e$export$4b844e58a3e414b4; }, function (v) { return $d04cfdd32c068e5e$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d04cfdd32c068e5e$export$816d2913ae6b83b1; }, function (v) { return $d04cfdd32c068e5e$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d04cfdd32c068e5e$export$61bcfe829111a1d0; }, function (v) { return $d04cfdd32c068e5e$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d04cfdd32c068e5e$export$7ee8c9beb337bc3f; }, function (v) { return $d04cfdd32c068e5e$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d04cfdd32c068e5e$export$b5836b71941fa3ed; }, function (v) { return $d04cfdd32c068e5e$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d04cfdd32c068e5e$export$cf845f2c119da08a; }, function (v) { return $d04cfdd32c068e5e$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d04cfdd32c068e5e$export$c4744153514ff05d;
var $d04cfdd32c068e5e$export$3e506c1ccc9cc1a7;
var $d04cfdd32c068e5e$export$e26fe2ed2fa76875;
var $d04cfdd32c068e5e$export$502329bbf4b505b1;
var $d04cfdd32c068e5e$export$6e3807111c4874c4;
var $d04cfdd32c068e5e$export$c27134553091fb3a;
var $d04cfdd32c068e5e$export$33ee1acdc04fd2a2;
var $d04cfdd32c068e5e$export$b00a404bbd5edef2;
var $d04cfdd32c068e5e$export$8352ce38b91d0c62;
var $d04cfdd32c068e5e$export$d66a1c1c77bd778b;
var $d04cfdd32c068e5e$export$d3dfb8e4810cb555;
var $d04cfdd32c068e5e$export$839f9183b0465a69;
var $d04cfdd32c068e5e$export$72fdf0e06517287b;
var $d04cfdd32c068e5e$export$4b844e58a3e414b4;
var $d04cfdd32c068e5e$export$816d2913ae6b83b1;
var $d04cfdd32c068e5e$export$61bcfe829111a1d0;
var $d04cfdd32c068e5e$export$7ee8c9beb337bc3f;
var $d04cfdd32c068e5e$export$b5836b71941fa3ed;
var $d04cfdd32c068e5e$export$cf845f2c119da08a;
'use strict';
function $d04cfdd32c068e5e$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $d04cfdd32c068e5e$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d04cfdd32c068e5e$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $d04cfdd32c068e5e$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $d04cfdd32c068e5e$var$g(C, c)) n < e && 0 > $d04cfdd32c068e5e$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $d04cfdd32c068e5e$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $d04cfdd32c068e5e$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d04cfdd32c068e5e$var$l = performance;
    $d04cfdd32c068e5e$export$c4744153514ff05d = function() {
        return $d04cfdd32c068e5e$var$l.now();
    };
} else {
    var $d04cfdd32c068e5e$var$p = Date, $d04cfdd32c068e5e$var$q = $d04cfdd32c068e5e$var$p.now();
    $d04cfdd32c068e5e$export$c4744153514ff05d = function() {
        return $d04cfdd32c068e5e$var$p.now() - $d04cfdd32c068e5e$var$q;
    };
}
var $d04cfdd32c068e5e$var$r = [], $d04cfdd32c068e5e$var$t = [], $d04cfdd32c068e5e$var$u = 1, $d04cfdd32c068e5e$var$v = null, $d04cfdd32c068e5e$var$y = 3, $d04cfdd32c068e5e$var$z = !1, $d04cfdd32c068e5e$var$A = !1, $d04cfdd32c068e5e$var$B = !1, $d04cfdd32c068e5e$var$D = "function" === typeof setTimeout ? setTimeout : null, $d04cfdd32c068e5e$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $d04cfdd32c068e5e$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $d04cfdd32c068e5e$var$G(a) {
    for(var b = $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$t); null !== b;){
        if (null === b.callback) $d04cfdd32c068e5e$var$k($d04cfdd32c068e5e$var$t);
        else if (b.startTime <= a) $d04cfdd32c068e5e$var$k($d04cfdd32c068e5e$var$t), b.sortIndex = b.expirationTime, $d04cfdd32c068e5e$var$f($d04cfdd32c068e5e$var$r, b);
        else break;
        b = $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$t);
    }
}
function $d04cfdd32c068e5e$var$H(a) {
    $d04cfdd32c068e5e$var$B = !1;
    $d04cfdd32c068e5e$var$G(a);
    if (!$d04cfdd32c068e5e$var$A) {
        if (null !== $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$r)) $d04cfdd32c068e5e$var$A = !0, $d04cfdd32c068e5e$var$I($d04cfdd32c068e5e$var$J);
        else {
            var b = $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$t);
            null !== b && $d04cfdd32c068e5e$var$K($d04cfdd32c068e5e$var$H, b.startTime - a);
        }
    }
}
function $d04cfdd32c068e5e$var$J(a, b) {
    $d04cfdd32c068e5e$var$A = !1;
    $d04cfdd32c068e5e$var$B && ($d04cfdd32c068e5e$var$B = !1, $d04cfdd32c068e5e$var$E($d04cfdd32c068e5e$var$L), $d04cfdd32c068e5e$var$L = -1);
    $d04cfdd32c068e5e$var$z = !0;
    var c = $d04cfdd32c068e5e$var$y;
    try {
        $d04cfdd32c068e5e$var$G(b);
        for($d04cfdd32c068e5e$var$v = $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$r); null !== $d04cfdd32c068e5e$var$v && (!($d04cfdd32c068e5e$var$v.expirationTime > b) || a && !$d04cfdd32c068e5e$var$M());){
            var d = $d04cfdd32c068e5e$var$v.callback;
            if ("function" === typeof d) {
                $d04cfdd32c068e5e$var$v.callback = null;
                $d04cfdd32c068e5e$var$y = $d04cfdd32c068e5e$var$v.priorityLevel;
                var e = d($d04cfdd32c068e5e$var$v.expirationTime <= b);
                b = $d04cfdd32c068e5e$export$c4744153514ff05d();
                "function" === typeof e ? $d04cfdd32c068e5e$var$v.callback = e : $d04cfdd32c068e5e$var$v === $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$r) && $d04cfdd32c068e5e$var$k($d04cfdd32c068e5e$var$r);
                $d04cfdd32c068e5e$var$G(b);
            } else $d04cfdd32c068e5e$var$k($d04cfdd32c068e5e$var$r);
            $d04cfdd32c068e5e$var$v = $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$r);
        }
        if (null !== $d04cfdd32c068e5e$var$v) var w = !0;
        else {
            var m = $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$t);
            null !== m && $d04cfdd32c068e5e$var$K($d04cfdd32c068e5e$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $d04cfdd32c068e5e$var$v = null, $d04cfdd32c068e5e$var$y = c, $d04cfdd32c068e5e$var$z = !1;
    }
}
var $d04cfdd32c068e5e$var$N = !1, $d04cfdd32c068e5e$var$O = null, $d04cfdd32c068e5e$var$L = -1, $d04cfdd32c068e5e$var$P = 5, $d04cfdd32c068e5e$var$Q = -1;
function $d04cfdd32c068e5e$var$M() {
    return $d04cfdd32c068e5e$export$c4744153514ff05d() - $d04cfdd32c068e5e$var$Q < $d04cfdd32c068e5e$var$P ? !1 : !0;
}
function $d04cfdd32c068e5e$var$R() {
    if (null !== $d04cfdd32c068e5e$var$O) {
        var a = $d04cfdd32c068e5e$export$c4744153514ff05d();
        $d04cfdd32c068e5e$var$Q = a;
        var b = !0;
        try {
            b = $d04cfdd32c068e5e$var$O(!0, a);
        } finally{
            b ? $d04cfdd32c068e5e$var$S() : ($d04cfdd32c068e5e$var$N = !1, $d04cfdd32c068e5e$var$O = null);
        }
    } else $d04cfdd32c068e5e$var$N = !1;
}
var $d04cfdd32c068e5e$var$S;
if ("function" === typeof $d04cfdd32c068e5e$var$F) $d04cfdd32c068e5e$var$S = function() {
    $d04cfdd32c068e5e$var$F($d04cfdd32c068e5e$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d04cfdd32c068e5e$var$T = new MessageChannel, $d04cfdd32c068e5e$var$U = $d04cfdd32c068e5e$var$T.port2;
    $d04cfdd32c068e5e$var$T.port1.onmessage = $d04cfdd32c068e5e$var$R;
    $d04cfdd32c068e5e$var$S = function() {
        $d04cfdd32c068e5e$var$U.postMessage(null);
    };
} else $d04cfdd32c068e5e$var$S = function() {
    $d04cfdd32c068e5e$var$D($d04cfdd32c068e5e$var$R, 0);
};
function $d04cfdd32c068e5e$var$I(a) {
    $d04cfdd32c068e5e$var$O = a;
    $d04cfdd32c068e5e$var$N || ($d04cfdd32c068e5e$var$N = !0, $d04cfdd32c068e5e$var$S());
}
function $d04cfdd32c068e5e$var$K(a, b) {
    $d04cfdd32c068e5e$var$L = $d04cfdd32c068e5e$var$D(function() {
        a($d04cfdd32c068e5e$export$c4744153514ff05d());
    }, b);
}
$d04cfdd32c068e5e$export$3e506c1ccc9cc1a7 = 5;
$d04cfdd32c068e5e$export$e26fe2ed2fa76875 = 1;
$d04cfdd32c068e5e$export$502329bbf4b505b1 = 4;
$d04cfdd32c068e5e$export$6e3807111c4874c4 = 3;
$d04cfdd32c068e5e$export$c27134553091fb3a = null;
$d04cfdd32c068e5e$export$33ee1acdc04fd2a2 = 2;
$d04cfdd32c068e5e$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d04cfdd32c068e5e$export$8352ce38b91d0c62 = function() {
    $d04cfdd32c068e5e$var$A || $d04cfdd32c068e5e$var$z || ($d04cfdd32c068e5e$var$A = !0, $d04cfdd32c068e5e$var$I($d04cfdd32c068e5e$var$J));
};
$d04cfdd32c068e5e$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d04cfdd32c068e5e$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$d04cfdd32c068e5e$export$d3dfb8e4810cb555 = function() {
    return $d04cfdd32c068e5e$var$y;
};
$d04cfdd32c068e5e$export$839f9183b0465a69 = function() {
    return $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$r);
};
$d04cfdd32c068e5e$export$72fdf0e06517287b = function(a) {
    switch($d04cfdd32c068e5e$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d04cfdd32c068e5e$var$y;
    }
    var c = $d04cfdd32c068e5e$var$y;
    $d04cfdd32c068e5e$var$y = b;
    try {
        return a();
    } finally{
        $d04cfdd32c068e5e$var$y = c;
    }
};
$d04cfdd32c068e5e$export$4b844e58a3e414b4 = function() {};
$d04cfdd32c068e5e$export$816d2913ae6b83b1 = function() {};
$d04cfdd32c068e5e$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d04cfdd32c068e5e$var$y;
    $d04cfdd32c068e5e$var$y = a;
    try {
        return b();
    } finally{
        $d04cfdd32c068e5e$var$y = c;
    }
};
$d04cfdd32c068e5e$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d04cfdd32c068e5e$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d04cfdd32c068e5e$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d04cfdd32c068e5e$var$f($d04cfdd32c068e5e$var$t, a), null === $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$r) && a === $d04cfdd32c068e5e$var$h($d04cfdd32c068e5e$var$t) && ($d04cfdd32c068e5e$var$B ? ($d04cfdd32c068e5e$var$E($d04cfdd32c068e5e$var$L), $d04cfdd32c068e5e$var$L = -1) : $d04cfdd32c068e5e$var$B = !0, $d04cfdd32c068e5e$var$K($d04cfdd32c068e5e$var$H, c - d))) : (a.sortIndex = e, $d04cfdd32c068e5e$var$f($d04cfdd32c068e5e$var$r, a), $d04cfdd32c068e5e$var$A || $d04cfdd32c068e5e$var$z || ($d04cfdd32c068e5e$var$A = !0, $d04cfdd32c068e5e$var$I($d04cfdd32c068e5e$var$J)));
    return a;
};
$d04cfdd32c068e5e$export$b5836b71941fa3ed = $d04cfdd32c068e5e$var$M;
$d04cfdd32c068e5e$export$cf845f2c119da08a = function(a) {
    var b = $d04cfdd32c068e5e$var$y;
    return function() {
        var c = $d04cfdd32c068e5e$var$y;
        $d04cfdd32c068e5e$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d04cfdd32c068e5e$var$y = c;
        }
    };
};

});



parcelRegister("iW5Se", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iKorB = parcelRequire("iKorB");
function $dc92333199a3d655$var$emptyFunction() {}
function $dc92333199a3d655$var$emptyFunctionWithReset() {}
$dc92333199a3d655$var$emptyFunctionWithReset.resetWarningCache = $dc92333199a3d655$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iKorB) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $dc92333199a3d655$var$emptyFunctionWithReset,
        resetWarningCache: $dc92333199a3d655$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iKorB", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $da5f7bf9332d10da$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $da5f7bf9332d10da$var$ReactPropTypesSecret;

});


parcelRegister("ljfqi", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("dxAMn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9dbae30b9379e857$var$_react = $9dbae30b9379e857$var$_interopRequireDefault((parcelRequire("ieaan")));

var $eSxRX = parcelRequire("eSxRX");

var $9dbae30b9379e857$var$_json2mq = $9dbae30b9379e857$var$_interopRequireDefault((parcelRequire("36Tc5")));

var $9dbae30b9379e857$var$_defaultProps = $9dbae30b9379e857$var$_interopRequireDefault((parcelRequire("1UV8k")));

var $6ikwB = parcelRequire("6ikwB");
function $9dbae30b9379e857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9dbae30b9379e857$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9dbae30b9379e857$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9dbae30b9379e857$var$_typeof(o);
}
function $9dbae30b9379e857$var$_extends() {
    $9dbae30b9379e857$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9dbae30b9379e857$var$_extends.apply(this, arguments);
}
function $9dbae30b9379e857$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9dbae30b9379e857$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9dbae30b9379e857$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9dbae30b9379e857$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9dbae30b9379e857$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9dbae30b9379e857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9dbae30b9379e857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9dbae30b9379e857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9dbae30b9379e857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9dbae30b9379e857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9dbae30b9379e857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9dbae30b9379e857$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9dbae30b9379e857$var$_setPrototypeOf(subClass, superClass);
}
function $9dbae30b9379e857$var$_setPrototypeOf(o, p) {
    $9dbae30b9379e857$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9dbae30b9379e857$var$_setPrototypeOf(o, p);
}
function $9dbae30b9379e857$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9dbae30b9379e857$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9dbae30b9379e857$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9dbae30b9379e857$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9dbae30b9379e857$var$_possibleConstructorReturn(this, result);
    };
}
function $9dbae30b9379e857$var$_possibleConstructorReturn(self, call) {
    if (call && ($9dbae30b9379e857$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9dbae30b9379e857$var$_assertThisInitialized(self);
}
function $9dbae30b9379e857$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9dbae30b9379e857$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9dbae30b9379e857$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9dbae30b9379e857$var$_getPrototypeOf(o) {
    $9dbae30b9379e857$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9dbae30b9379e857$var$_getPrototypeOf(o);
}
function $9dbae30b9379e857$var$_defineProperty(obj, key, value) {
    key = $9dbae30b9379e857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9dbae30b9379e857$var$_toPropertyKey(t) {
    var i = $9dbae30b9379e857$var$_toPrimitive(t, "string");
    return "symbol" == $9dbae30b9379e857$var$_typeof(i) ? i : String(i);
}
function $9dbae30b9379e857$var$_toPrimitive(t, r) {
    if ("object" != $9dbae30b9379e857$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9dbae30b9379e857$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $9dbae30b9379e857$var$enquire = (0, $6ikwB.canUseDOM)() && (parcelRequire("6Ib8k"));
var $9dbae30b9379e857$var$Slider = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    $9dbae30b9379e857$var$_inherits(Slider, _React$Component);
    var _super = $9dbae30b9379e857$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $9dbae30b9379e857$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $9dbae30b9379e857$var$_defineProperty($9dbae30b9379e857$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $9dbae30b9379e857$var$_defineProperty($9dbae30b9379e857$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $9dbae30b9379e857$var$_defineProperty($9dbae30b9379e857$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $9dbae30b9379e857$var$_defineProperty($9dbae30b9379e857$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $9dbae30b9379e857$var$_defineProperty($9dbae30b9379e857$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $9dbae30b9379e857$var$_defineProperty($9dbae30b9379e857$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $9dbae30b9379e857$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $9dbae30b9379e857$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $9dbae30b9379e857$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $9dbae30b9379e857$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $6ikwB.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $9dbae30b9379e857$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $6ikwB.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $9dbae30b9379e857$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $9dbae30b9379e857$var$_objectSpread($9dbae30b9379e857$var$_objectSpread($9dbae30b9379e857$var$_objectSpread({}, $9dbae30b9379e857$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $9dbae30b9379e857$var$_objectSpread($9dbae30b9379e857$var$_objectSpread({}, $9dbae30b9379e857$var$_defaultProps["default"]), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = $9dbae30b9379e857$var$_react["default"].Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $9dbae30b9379e857$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $9dbae30b9379e857$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $9dbae30b9379e857$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $9dbae30b9379e857$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $9dbae30b9379e857$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) settings.unslick = true;
                return /*#__PURE__*/ $9dbae30b9379e857$var$_react["default"].createElement($eSxRX.InnerSlider, $9dbae30b9379e857$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, (0, $6ikwB.filterSettings)(settings)), newChildren);
            }
        }
    ]);
    return Slider;
}($9dbae30b9379e857$var$_react["default"].Component);

});
parcelRegister("eSxRX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $ad50618f88191dd9$var$_react = $ad50618f88191dd9$var$_interopRequireDefault((parcelRequire("ieaan")));

var $ad50618f88191dd9$var$_initialState = $ad50618f88191dd9$var$_interopRequireDefault((parcelRequire("kR2nN")));

var $ad50618f88191dd9$var$_lodash = $ad50618f88191dd9$var$_interopRequireDefault((parcelRequire("3PAVQ")));

var $ad50618f88191dd9$var$_classnames = $ad50618f88191dd9$var$_interopRequireDefault((parcelRequire("ljfqi")));

var $6ikwB = parcelRequire("6ikwB");

var $aKQfO = parcelRequire("aKQfO");

var $kgLGn = parcelRequire("kgLGn");

var $jh82c = parcelRequire("jh82c");

var $ad50618f88191dd9$var$_resizeObserverPolyfill = $ad50618f88191dd9$var$_interopRequireDefault((parcelRequire("eHXbB")));
function $ad50618f88191dd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ad50618f88191dd9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ad50618f88191dd9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ad50618f88191dd9$var$_typeof(o);
}
function $ad50618f88191dd9$var$_extends() {
    $ad50618f88191dd9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad50618f88191dd9$var$_extends.apply(this, arguments);
}
function $ad50618f88191dd9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ad50618f88191dd9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ad50618f88191dd9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ad50618f88191dd9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad50618f88191dd9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad50618f88191dd9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ad50618f88191dd9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad50618f88191dd9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad50618f88191dd9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ad50618f88191dd9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ad50618f88191dd9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ad50618f88191dd9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ad50618f88191dd9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ad50618f88191dd9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ad50618f88191dd9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ad50618f88191dd9$var$_setPrototypeOf(subClass, superClass);
}
function $ad50618f88191dd9$var$_setPrototypeOf(o, p) {
    $ad50618f88191dd9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ad50618f88191dd9$var$_setPrototypeOf(o, p);
}
function $ad50618f88191dd9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ad50618f88191dd9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ad50618f88191dd9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ad50618f88191dd9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ad50618f88191dd9$var$_possibleConstructorReturn(this, result);
    };
}
function $ad50618f88191dd9$var$_possibleConstructorReturn(self, call) {
    if (call && ($ad50618f88191dd9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ad50618f88191dd9$var$_assertThisInitialized(self);
}
function $ad50618f88191dd9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ad50618f88191dd9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ad50618f88191dd9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ad50618f88191dd9$var$_getPrototypeOf(o) {
    $ad50618f88191dd9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ad50618f88191dd9$var$_getPrototypeOf(o);
}
function $ad50618f88191dd9$var$_defineProperty(obj, key, value) {
    key = $ad50618f88191dd9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad50618f88191dd9$var$_toPropertyKey(t) {
    var i = $ad50618f88191dd9$var$_toPrimitive(t, "string");
    return "symbol" == $ad50618f88191dd9$var$_typeof(i) ? i : String(i);
}
function $ad50618f88191dd9$var$_toPrimitive(t, r) {
    if ("object" != $ad50618f88191dd9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ad50618f88191dd9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ad50618f88191dd9$var$InnerSlider = module.exports.InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $ad50618f88191dd9$var$_inherits(InnerSlider, _React$Component);
    var _super = $ad50618f88191dd9$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $ad50618f88191dd9$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
                _this.list.style.height = (0, $6ikwB.getHeight)(elem) + "px";
            }
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $6ikwB.getOnDemandLazySlides)($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $ad50618f88191dd9$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $ad50618f88191dd9$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $6ikwB.getOnDemandLazySlides)($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $ad50618f88191dd9$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $ad50618f88191dd9$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $ad50618f88191dd9$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $6ikwB.initializedState)(spec);
            spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $6ikwB.getTrackLeft)(spec);
            spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $6ikwB.getTrackCSS)(spec);
            if (setTrackStyle || $ad50618f88191dd9$var$_react["default"].Children.count(_this.props.children) !== $ad50618f88191dd9$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $6ikwB.getPreClones)($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $6ikwB.getPostClones)($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $ad50618f88191dd9$var$_react["default"].Children.count(_this.props.children);
            var spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $6ikwB.getPreClones)(spec) + (0, $6ikwB.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $6ikwB.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $6ikwB.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $6ikwB.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $6ikwB.slideHandler)($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $ad50618f88191dd9$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $6ikwB.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $6ikwB.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $6ikwB.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $6ikwB.swipeMove)(e, $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $6ikwB.swipeEnd)(e, $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $6ikwB.canGoNext)($ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $ad50618f88191dd9$var$_defineProperty($ad50618f88191dd9$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $ad50618f88191dd9$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $6ikwB.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $6ikwB.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $ad50618f88191dd9$var$_react["default"].createElement($kgLGn.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $6ikwB.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $ad50618f88191dd9$var$_react["default"].createElement($jh82c.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $ad50618f88191dd9$var$_react["default"].createElement($jh82c.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $ad50618f88191dd9$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $ad50618f88191dd9$var$_react["default"].createElement("div", $ad50618f88191dd9$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $ad50618f88191dd9$var$_react["default"].createElement($aKQfO.Track, $ad50618f88191dd9$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, $ad50618f88191dd9$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
            slideCount: $ad50618f88191dd9$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $ad50618f88191dd9$var$_objectSpread($ad50618f88191dd9$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $ad50618f88191dd9$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($ad50618f88191dd9$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $ad50618f88191dd9$var$_react["default"].Children.count(this.props.children) !== $ad50618f88191dd9$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($ad50618f88191dd9$var$_react["default"].Component);

});
parcelRegister("kR2nN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $f2ea9b0d60efbcb4$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $f2ea9b0d60efbcb4$var$_default = module.exports["default"] = $f2ea9b0d60efbcb4$var$initialState;

});

parcelRegister("3PAVQ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $2ca2c870e492a987$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $2ca2c870e492a987$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $2ca2c870e492a987$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $2ca2c870e492a987$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $2ca2c870e492a987$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $2ca2c870e492a987$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $2ca2c870e492a987$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $2ca2c870e492a987$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $2ca2c870e492a987$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $2ca2c870e492a987$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2ca2c870e492a987$var$root = $2ca2c870e492a987$var$freeGlobal || $2ca2c870e492a987$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $2ca2c870e492a987$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2ca2c870e492a987$var$objectToString = $2ca2c870e492a987$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2ca2c870e492a987$var$nativeMax = Math.max, $2ca2c870e492a987$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2ca2c870e492a987$var$now = function() {
    return $2ca2c870e492a987$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $2ca2c870e492a987$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($2ca2c870e492a987$var$FUNC_ERROR_TEXT);
    wait = $2ca2c870e492a987$var$toNumber(wait) || 0;
    if ($2ca2c870e492a987$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $2ca2c870e492a987$var$nativeMax($2ca2c870e492a987$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $2ca2c870e492a987$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $2ca2c870e492a987$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($2ca2c870e492a987$var$now());
    }
    function debounced() {
        var time = $2ca2c870e492a987$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2ca2c870e492a987$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2ca2c870e492a987$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2ca2c870e492a987$var$isSymbol(value) {
    return typeof value == 'symbol' || $2ca2c870e492a987$var$isObjectLike(value) && $2ca2c870e492a987$var$objectToString.call(value) == $2ca2c870e492a987$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $2ca2c870e492a987$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2ca2c870e492a987$var$isSymbol(value)) return $2ca2c870e492a987$var$NAN;
    if ($2ca2c870e492a987$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $2ca2c870e492a987$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($2ca2c870e492a987$var$reTrim, '');
    var isBinary = $2ca2c870e492a987$var$reIsBinary.test(value);
    return isBinary || $2ca2c870e492a987$var$reIsOctal.test(value) ? $2ca2c870e492a987$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $2ca2c870e492a987$var$reIsBadHex.test(value) ? $2ca2c870e492a987$var$NAN : +value;
}
module.exports = $2ca2c870e492a987$var$debounce;

});

parcelRegister("6ikwB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $4954584f418c9708$var$clamp;
module.exports.extractObject = void 0;
module.exports.filterSettings = $4954584f418c9708$var$filterSettings;
module.exports.validSettings = module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = void 0;

var $4954584f418c9708$var$_react = $4954584f418c9708$var$_interopRequireDefault((parcelRequire("ieaan")));

var $4954584f418c9708$var$_defaultProps = $4954584f418c9708$var$_interopRequireDefault((parcelRequire("1UV8k")));
function $4954584f418c9708$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4954584f418c9708$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4954584f418c9708$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4954584f418c9708$var$_typeof(o);
}
function $4954584f418c9708$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4954584f418c9708$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4954584f418c9708$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4954584f418c9708$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4954584f418c9708$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4954584f418c9708$var$_defineProperty(obj, key, value) {
    key = $4954584f418c9708$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4954584f418c9708$var$_toPropertyKey(t) {
    var i = $4954584f418c9708$var$_toPrimitive(t, "string");
    return "symbol" == $4954584f418c9708$var$_typeof(i) ? i : String(i);
}
function $4954584f418c9708$var$_toPrimitive(t, r) {
    if ("object" != $4954584f418c9708$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4954584f418c9708$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4954584f418c9708$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $4954584f418c9708$var$safePreventDefault = module.exports.safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $4954584f418c9708$var$getOnDemandLazySlides = module.exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $4954584f418c9708$var$lazyStartIndex(spec);
    var endIndex = $4954584f418c9708$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
// return list of slides that need to be present
var $4954584f418c9708$var$getRequiredLazySlides = module.exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $4954584f418c9708$var$lazyStartIndex(spec);
    var endIndex = $4954584f418c9708$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
// startIndex that needs to be present
var $4954584f418c9708$var$lazyStartIndex = module.exports.lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $4954584f418c9708$var$lazySlidesOnLeft(spec);
};
var $4954584f418c9708$var$lazyEndIndex = module.exports.lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $4954584f418c9708$var$lazySlidesOnRight(spec);
};
var $4954584f418c9708$var$lazySlidesOnLeft = module.exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $4954584f418c9708$var$lazySlidesOnRight = module.exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
// get width of an element
var $4954584f418c9708$var$getWidth = module.exports.getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $4954584f418c9708$var$getHeight = module.exports.getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $4954584f418c9708$var$getSwipeDirection = module.exports.getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
// whether or not we can go next
var $4954584f418c9708$var$canGoNext = module.exports.canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
// given an object and a list of keys, return new object with given keys
var $4954584f418c9708$var$extractObject = module.exports.extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
// get initialized state
var $4954584f418c9708$var$initializedState = module.exports.initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $4954584f418c9708$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($4954584f418c9708$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($4954584f418c9708$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $4954584f418c9708$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $4954584f418c9708$var$getOnDemandLazySlides($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $4954584f418c9708$var$slideHandler = module.exports.slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $4954584f418c9708$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$4954584f418c9708$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $4954584f418c9708$var$getTrackLeft($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $4954584f418c9708$var$getTrackLeft($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($4954584f418c9708$var$getOnDemandLazySlides($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $4954584f418c9708$var$getTrackCSS($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $4954584f418c9708$var$getTrackAnimateCSS($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $4954584f418c9708$var$getTrackCSS($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $4954584f418c9708$var$changeSlide = module.exports.changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $4954584f418c9708$var$siblingDirection($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $4954584f418c9708$var$keyHandler = module.exports.keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $4954584f418c9708$var$swipeStart = module.exports.swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $4954584f418c9708$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $4954584f418c9708$var$swipeMove = module.exports.swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $4954584f418c9708$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $4954584f418c9708$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $4954584f418c9708$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $4954584f418c9708$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$4954584f418c9708$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $4954584f418c9708$var$getTrackCSS($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $4954584f418c9708$var$safePreventDefault(e);
    }
    return state;
};
var $4954584f418c9708$var$swipeEnd = module.exports.swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $4954584f418c9708$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $4954584f418c9708$var$getSwipeDirection(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $4954584f418c9708$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $4954584f418c9708$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $4954584f418c9708$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $4954584f418c9708$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $4954584f418c9708$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $4954584f418c9708$var$getTrackLeft(spec);
        state["trackStyle"] = $4954584f418c9708$var$getTrackAnimateCSS($4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $4954584f418c9708$var$getNavigableIndexes = module.exports.getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $4954584f418c9708$var$checkNavigable = module.exports.checkNavigable = function checkNavigable(spec, index) {
    var navigables = $4954584f418c9708$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $4954584f418c9708$var$getSlideCount = module.exports.getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $4954584f418c9708$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $4954584f418c9708$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $4954584f418c9708$var$checkSpecKeys = module.exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
var $4954584f418c9708$var$getTrackCSS = module.exports.getTrackCSS = function getTrackCSS(spec) {
    $4954584f418c9708$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $4954584f418c9708$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $4954584f418c9708$var$_objectSpread($4954584f418c9708$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $4954584f418c9708$var$getTrackAnimateCSS = module.exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $4954584f418c9708$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $4954584f418c9708$var$getTrackCSS(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $4954584f418c9708$var$getTrackLeft = module.exports.getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $4954584f418c9708$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$4954584f418c9708$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $4954584f418c9708$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $4954584f418c9708$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $4954584f418c9708$var$getPreClones = module.exports.getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $4954584f418c9708$var$getPostClones = module.exports.getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
var $4954584f418c9708$var$getTotalSlides = module.exports.getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $4954584f418c9708$var$getPreClones(spec) + spec.slideCount + $4954584f418c9708$var$getPostClones(spec);
};
var $4954584f418c9708$var$siblingDirection = module.exports.siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $4954584f418c9708$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $4954584f418c9708$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
var $4954584f418c9708$var$slidesOnRight = module.exports.slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $4954584f418c9708$var$slidesOnLeft = module.exports.slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $4954584f418c9708$var$canUseDOM = module.exports.canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var $4954584f418c9708$var$validSettings = module.exports.validSettings = Object.keys($4954584f418c9708$var$_defaultProps["default"]);
function $4954584f418c9708$var$filterSettings(settings) {
    return $4954584f418c9708$var$validSettings.reduce(function(acc, settingName) {
        if (settings.hasOwnProperty(settingName)) acc[settingName] = settings[settingName];
        return acc;
    }, {});
}

});
parcelRegister("1UV8k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $165756e190e0bb77$var$_react = $165756e190e0bb77$var$_interopRequireDefault((parcelRequire("ieaan")));
function $165756e190e0bb77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $165756e190e0bb77$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $165756e190e0bb77$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $165756e190e0bb77$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    asNavFor: null,
    unslick: false
};
var $165756e190e0bb77$var$_default = module.exports["default"] = $165756e190e0bb77$var$defaultProps;

});


parcelRegister("aKQfO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $7d46bbd66ce88d48$var$_react = $7d46bbd66ce88d48$var$_interopRequireDefault((parcelRequire("ieaan")));

var $7d46bbd66ce88d48$var$_classnames = $7d46bbd66ce88d48$var$_interopRequireDefault((parcelRequire("ljfqi")));

var $6ikwB = parcelRequire("6ikwB");
function $7d46bbd66ce88d48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7d46bbd66ce88d48$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d46bbd66ce88d48$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d46bbd66ce88d48$var$_typeof(o);
}
function $7d46bbd66ce88d48$var$_extends() {
    $7d46bbd66ce88d48$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d46bbd66ce88d48$var$_extends.apply(this, arguments);
}
function $7d46bbd66ce88d48$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d46bbd66ce88d48$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d46bbd66ce88d48$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d46bbd66ce88d48$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d46bbd66ce88d48$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d46bbd66ce88d48$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d46bbd66ce88d48$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7d46bbd66ce88d48$var$_setPrototypeOf(subClass, superClass);
}
function $7d46bbd66ce88d48$var$_setPrototypeOf(o, p) {
    $7d46bbd66ce88d48$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7d46bbd66ce88d48$var$_setPrototypeOf(o, p);
}
function $7d46bbd66ce88d48$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7d46bbd66ce88d48$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7d46bbd66ce88d48$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7d46bbd66ce88d48$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7d46bbd66ce88d48$var$_possibleConstructorReturn(this, result);
    };
}
function $7d46bbd66ce88d48$var$_possibleConstructorReturn(self, call) {
    if (call && ($7d46bbd66ce88d48$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7d46bbd66ce88d48$var$_assertThisInitialized(self);
}
function $7d46bbd66ce88d48$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7d46bbd66ce88d48$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7d46bbd66ce88d48$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7d46bbd66ce88d48$var$_getPrototypeOf(o) {
    $7d46bbd66ce88d48$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7d46bbd66ce88d48$var$_getPrototypeOf(o);
}
function $7d46bbd66ce88d48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d46bbd66ce88d48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d46bbd66ce88d48$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7d46bbd66ce88d48$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d46bbd66ce88d48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d46bbd66ce88d48$var$_defineProperty(obj, key, value) {
    key = $7d46bbd66ce88d48$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d46bbd66ce88d48$var$_toPropertyKey(t) {
    var i = $7d46bbd66ce88d48$var$_toPrimitive(t, "string");
    return "symbol" == $7d46bbd66ce88d48$var$_typeof(i) ? i : String(i);
}
function $7d46bbd66ce88d48$var$_toPrimitive(t, r) {
    if ("object" != $7d46bbd66ce88d48$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7d46bbd66ce88d48$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $7d46bbd66ce88d48$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $7d46bbd66ce88d48$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $7d46bbd66ce88d48$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $7d46bbd66ce88d48$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $7d46bbd66ce88d48$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $6ikwB.lazyStartIndex)(spec);
    var endIndex = (0, $6ikwB.lazyEndIndex)(spec);
    $7d46bbd66ce88d48$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $7d46bbd66ce88d48$var$_react["default"].createElement("div", null);
        var childStyle = $7d46bbd66ce88d48$var$getSlideStyle($7d46bbd66ce88d48$var$_objectSpread($7d46bbd66ce88d48$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $7d46bbd66ce88d48$var$getSlideClasses($7d46bbd66ce88d48$var$_objectSpread($7d46bbd66ce88d48$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $7d46bbd66ce88d48$var$_react["default"].cloneElement(child, {
            key: "original" + $7d46bbd66ce88d48$var$getKey(child, index),
            "data-index": index,
            className: (0, $7d46bbd66ce88d48$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $7d46bbd66ce88d48$var$_objectSpread($7d46bbd66ce88d48$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $6ikwB.getPreClones)(spec)) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $7d46bbd66ce88d48$var$getSlideClasses($7d46bbd66ce88d48$var$_objectSpread($7d46bbd66ce88d48$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $7d46bbd66ce88d48$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $7d46bbd66ce88d48$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $7d46bbd66ce88d48$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $7d46bbd66ce88d48$var$_objectSpread($7d46bbd66ce88d48$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            key = childrenCount + index;
            if (key < endIndex) child = elem;
            slideClasses = $7d46bbd66ce88d48$var$getSlideClasses($7d46bbd66ce88d48$var$_objectSpread($7d46bbd66ce88d48$var$_objectSpread({}, spec), {}, {
                index: key
            }));
            postCloneSlides.push(/*#__PURE__*/ $7d46bbd66ce88d48$var$_react["default"].cloneElement(child, {
                key: "postcloned" + $7d46bbd66ce88d48$var$getKey(child, key),
                "data-index": key,
                tabIndex: "-1",
                className: (0, $7d46bbd66ce88d48$var$_classnames["default"])(slideClasses, slideClass),
                "aria-hidden": !slideClasses["slick-active"],
                style: $7d46bbd66ce88d48$var$_objectSpread($7d46bbd66ce88d48$var$_objectSpread({}, child.props.style || {}), childStyle),
                onClick: function onClick(e) {
                    child.props && child.props.onClick && child.props.onClick(e);
                    if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                }
            }));
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $7d46bbd66ce88d48$var$Track = module.exports.Track = /*#__PURE__*/ function(_React$PureComponent) {
    $7d46bbd66ce88d48$var$_inherits(Track, _React$PureComponent);
    var _super = $7d46bbd66ce88d48$var$_createSuper(Track);
    function Track() {
        var _this;
        $7d46bbd66ce88d48$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $7d46bbd66ce88d48$var$_defineProperty($7d46bbd66ce88d48$var$_assertThisInitialized(_this), "node", null);
        $7d46bbd66ce88d48$var$_defineProperty($7d46bbd66ce88d48$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $7d46bbd66ce88d48$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $7d46bbd66ce88d48$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $7d46bbd66ce88d48$var$_react["default"].createElement("div", $7d46bbd66ce88d48$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($7d46bbd66ce88d48$var$_react["default"].PureComponent);

});

parcelRegister("kgLGn", function(module, exports) {
"use strict";
function $ec1a4a00b4230830$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec1a4a00b4230830$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec1a4a00b4230830$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $ec1a4a00b4230830$var$_react = $ec1a4a00b4230830$var$_interopRequireDefault((parcelRequire("ieaan")));

var $ec1a4a00b4230830$var$_classnames = $ec1a4a00b4230830$var$_interopRequireDefault((parcelRequire("ljfqi")));

var $6ikwB = parcelRequire("6ikwB");
function $ec1a4a00b4230830$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ec1a4a00b4230830$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec1a4a00b4230830$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec1a4a00b4230830$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ec1a4a00b4230830$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec1a4a00b4230830$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ec1a4a00b4230830$var$_defineProperty(obj, key, value) {
    key = $ec1a4a00b4230830$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec1a4a00b4230830$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ec1a4a00b4230830$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ec1a4a00b4230830$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ec1a4a00b4230830$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ec1a4a00b4230830$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ec1a4a00b4230830$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ec1a4a00b4230830$var$_toPropertyKey(t) {
    var i = $ec1a4a00b4230830$var$_toPrimitive(t, "string");
    return "symbol" == $ec1a4a00b4230830$var$_typeof(i) ? i : String(i);
}
function $ec1a4a00b4230830$var$_toPrimitive(t, r) {
    if ("object" != $ec1a4a00b4230830$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ec1a4a00b4230830$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec1a4a00b4230830$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ec1a4a00b4230830$var$_setPrototypeOf(subClass, superClass);
}
function $ec1a4a00b4230830$var$_setPrototypeOf(o, p) {
    $ec1a4a00b4230830$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ec1a4a00b4230830$var$_setPrototypeOf(o, p);
}
function $ec1a4a00b4230830$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ec1a4a00b4230830$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ec1a4a00b4230830$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ec1a4a00b4230830$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ec1a4a00b4230830$var$_possibleConstructorReturn(this, result);
    };
}
function $ec1a4a00b4230830$var$_possibleConstructorReturn(self, call) {
    if (call && ($ec1a4a00b4230830$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ec1a4a00b4230830$var$_assertThisInitialized(self);
}
function $ec1a4a00b4230830$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ec1a4a00b4230830$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ec1a4a00b4230830$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ec1a4a00b4230830$var$_getPrototypeOf(o) {
    $ec1a4a00b4230830$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ec1a4a00b4230830$var$_getPrototypeOf(o);
}
var $ec1a4a00b4230830$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $ec1a4a00b4230830$var$Dots = module.exports.Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $ec1a4a00b4230830$var$_inherits(Dots, _React$PureComponent);
    var _super = $ec1a4a00b4230830$var$_createSuper(Dots);
    function Dots() {
        $ec1a4a00b4230830$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $ec1a4a00b4230830$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $ec1a4a00b4230830$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $6ikwB.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $6ikwB.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $ec1a4a00b4230830$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $ec1a4a00b4230830$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $ec1a4a00b4230830$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $ec1a4a00b4230830$var$_react["default"].cloneElement(this.props.appendDots(dots), $ec1a4a00b4230830$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($ec1a4a00b4230830$var$_react["default"].PureComponent);

});

parcelRegister("jh82c", function(module, exports) {
"use strict";
function $e085d65413ef67a3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e085d65413ef67a3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e085d65413ef67a3$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $e085d65413ef67a3$var$_react = $e085d65413ef67a3$var$_interopRequireDefault((parcelRequire("ieaan")));

var $e085d65413ef67a3$var$_classnames = $e085d65413ef67a3$var$_interopRequireDefault((parcelRequire("ljfqi")));

var $6ikwB = parcelRequire("6ikwB");
function $e085d65413ef67a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e085d65413ef67a3$var$_extends() {
    $e085d65413ef67a3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e085d65413ef67a3$var$_extends.apply(this, arguments);
}
function $e085d65413ef67a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e085d65413ef67a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e085d65413ef67a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e085d65413ef67a3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e085d65413ef67a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e085d65413ef67a3$var$_defineProperty(obj, key, value) {
    key = $e085d65413ef67a3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e085d65413ef67a3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e085d65413ef67a3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e085d65413ef67a3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e085d65413ef67a3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e085d65413ef67a3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e085d65413ef67a3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e085d65413ef67a3$var$_toPropertyKey(t) {
    var i = $e085d65413ef67a3$var$_toPrimitive(t, "string");
    return "symbol" == $e085d65413ef67a3$var$_typeof(i) ? i : String(i);
}
function $e085d65413ef67a3$var$_toPrimitive(t, r) {
    if ("object" != $e085d65413ef67a3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e085d65413ef67a3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e085d65413ef67a3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e085d65413ef67a3$var$_setPrototypeOf(subClass, superClass);
}
function $e085d65413ef67a3$var$_setPrototypeOf(o, p) {
    $e085d65413ef67a3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e085d65413ef67a3$var$_setPrototypeOf(o, p);
}
function $e085d65413ef67a3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e085d65413ef67a3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e085d65413ef67a3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e085d65413ef67a3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e085d65413ef67a3$var$_possibleConstructorReturn(this, result);
    };
}
function $e085d65413ef67a3$var$_possibleConstructorReturn(self, call) {
    if (call && ($e085d65413ef67a3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e085d65413ef67a3$var$_assertThisInitialized(self);
}
function $e085d65413ef67a3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e085d65413ef67a3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e085d65413ef67a3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e085d65413ef67a3$var$_getPrototypeOf(o) {
    $e085d65413ef67a3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e085d65413ef67a3$var$_getPrototypeOf(o);
}
var $e085d65413ef67a3$var$PrevArrow = module.exports.PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $e085d65413ef67a3$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $e085d65413ef67a3$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $e085d65413ef67a3$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $e085d65413ef67a3$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $e085d65413ef67a3$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $e085d65413ef67a3$var$_react["default"].cloneElement(this.props.prevArrow, $e085d65413ef67a3$var$_objectSpread($e085d65413ef67a3$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $e085d65413ef67a3$var$_react["default"].createElement("button", $e085d65413ef67a3$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($e085d65413ef67a3$var$_react["default"].PureComponent);
var $e085d65413ef67a3$var$NextArrow = module.exports.NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $e085d65413ef67a3$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $e085d65413ef67a3$var$_createSuper(NextArrow);
    function NextArrow() {
        $e085d65413ef67a3$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $e085d65413ef67a3$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $6ikwB.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $e085d65413ef67a3$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $e085d65413ef67a3$var$_react["default"].cloneElement(this.props.nextArrow, $e085d65413ef67a3$var$_objectSpread($e085d65413ef67a3$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $e085d65413ef67a3$var$_react["default"].createElement("button", $e085d65413ef67a3$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($e085d65413ef67a3$var$_react["default"].PureComponent);

});

parcelRegister("eHXbB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ab52fdf35a99e13c$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $ab52fdf35a99e13c$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $ab52fdf35a99e13c$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $ab52fdf35a99e13c$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $ab52fdf35a99e13c$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($ab52fdf35a99e13c$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $ab52fdf35a99e13c$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $ab52fdf35a99e13c$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $ab52fdf35a99e13c$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $ab52fdf35a99e13c$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $ab52fdf35a99e13c$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $ab52fdf35a99e13c$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $ab52fdf35a99e13c$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $ab52fdf35a99e13c$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $ab52fdf35a99e13c$var$throttle(this.refresh.bind(this), $ab52fdf35a99e13c$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$ab52fdf35a99e13c$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($ab52fdf35a99e13c$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$ab52fdf35a99e13c$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $ab52fdf35a99e13c$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $ab52fdf35a99e13c$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $ab52fdf35a99e13c$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $ab52fdf35a99e13c$var$global$1;
};
// Placeholder of an empty content rectangle.
var $ab52fdf35a99e13c$var$emptyRect = $ab52fdf35a99e13c$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $ab52fdf35a99e13c$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $ab52fdf35a99e13c$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $ab52fdf35a99e13c$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $ab52fdf35a99e13c$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $ab52fdf35a99e13c$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $ab52fdf35a99e13c$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $ab52fdf35a99e13c$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $ab52fdf35a99e13c$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $ab52fdf35a99e13c$var$emptyRect;
    var styles = $ab52fdf35a99e13c$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $ab52fdf35a99e13c$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $ab52fdf35a99e13c$var$toFloat(styles.width), height = $ab52fdf35a99e13c$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $ab52fdf35a99e13c$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $ab52fdf35a99e13c$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$ab52fdf35a99e13c$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $ab52fdf35a99e13c$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $ab52fdf35a99e13c$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $ab52fdf35a99e13c$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $ab52fdf35a99e13c$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $ab52fdf35a99e13c$var$isDocumentElement(target) {
    return target === $ab52fdf35a99e13c$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $ab52fdf35a99e13c$var$getContentRect(target) {
    if (!$ab52fdf35a99e13c$var$isBrowser) return $ab52fdf35a99e13c$var$emptyRect;
    if ($ab52fdf35a99e13c$var$isSVGGraphicsElement(target)) return $ab52fdf35a99e13c$var$getSVGContentRect(target);
    return $ab52fdf35a99e13c$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $ab52fdf35a99e13c$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $ab52fdf35a99e13c$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $ab52fdf35a99e13c$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $ab52fdf35a99e13c$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $ab52fdf35a99e13c$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $ab52fdf35a99e13c$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $ab52fdf35a99e13c$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $ab52fdf35a99e13c$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $ab52fdf35a99e13c$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $ab52fdf35a99e13c$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $ab52fdf35a99e13c$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $ab52fdf35a99e13c$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $ab52fdf35a99e13c$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $ab52fdf35a99e13c$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $ab52fdf35a99e13c$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $ab52fdf35a99e13c$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $ab52fdf35a99e13c$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $ab52fdf35a99e13c$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $ab52fdf35a99e13c$var$ResizeObserverController.getInstance();
        var observer = new $ab52fdf35a99e13c$var$ResizeObserverSPI(callback, controller, this);
        $ab52fdf35a99e13c$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $ab52fdf35a99e13c$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $ab52fdf35a99e13c$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $ab52fdf35a99e13c$var$index = function() {
    // Export existing implementation if available.
    if (typeof $ab52fdf35a99e13c$var$global$1.ResizeObserver !== 'undefined') return $ab52fdf35a99e13c$var$global$1.ResizeObserver;
    return $ab52fdf35a99e13c$var$ResizeObserver;
}();
var $ab52fdf35a99e13c$export$2e2bcd8739ae039 = $ab52fdf35a99e13c$var$index;

});


parcelRegister("36Tc5", function(module, exports) {

var $SZ1YS = parcelRequire("SZ1YS");
var $243cbf068584e55c$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $243cbf068584e55c$var$obj2mq = function(obj) {
    var mq = '';
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $SZ1YS(feature);
        // Add px to dimension features
        if ($243cbf068584e55c$var$isDimension(feature) && typeof value === 'number') value = value + 'px';
        if (value === true) mq += feature;
        else if (value === false) mq += 'not ' + feature;
        else mq += '(' + feature + ': ' + value + ')';
        if (index < features.length - 1) mq += ' and ';
    });
    return mq;
};
var $243cbf068584e55c$var$json2mq = function(query) {
    var mq = '';
    if (typeof query === 'string') return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $243cbf068584e55c$var$obj2mq(q);
            if (index < query.length - 1) mq += ', ';
        });
        return mq;
    }
    // Handling single media query
    return $243cbf068584e55c$var$obj2mq(query);
};
module.exports = $243cbf068584e55c$var$json2mq;

});
parcelRegister("SZ1YS", function(module, exports) {
var $0a5462bc4ceea361$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return '-' + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $0a5462bc4ceea361$var$camel2hyphen;

});


parcelRegister("6Ib8k", function(module, exports) {

var $h1RRF = parcelRequire("h1RRF");
module.exports = new $h1RRF();

});
parcelRegister("h1RRF", function(module, exports) {

var $hteqh = parcelRequire("hteqh");

var $eugCq = parcelRequire("eugCq");
var $c65c5010f4b1787b$var$each = $eugCq.each;
var $c65c5010f4b1787b$var$isFunction = $eugCq.isFunction;
var $c65c5010f4b1787b$var$isArray = $eugCq.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $c65c5010f4b1787b$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error('matchMedia not present, legacy browsers require a polyfill');
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}
$c65c5010f4b1787b$var$MediaQueryDispatch.prototype = {
    constructor: $c65c5010f4b1787b$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $hteqh(q, isUnconditional);
        //normalise to object in an array
        if ($c65c5010f4b1787b$var$isFunction(options)) options = {
            match: options
        };
        if (!$c65c5010f4b1787b$var$isArray(options)) options = [
            options
        ];
        $c65c5010f4b1787b$var$each(options, function(handler) {
            if ($c65c5010f4b1787b$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $c65c5010f4b1787b$var$MediaQueryDispatch;

});
parcelRegister("hteqh", function(module, exports) {

var $4j7iD = parcelRequire("4j7iD");

var $eugCq = parcelRequire("eugCq");
var $cb80552f083c27d2$require$each = $eugCq.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $cb80552f083c27d2$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$cb80552f083c27d2$var$MediaQuery.prototype = {
    constuctor: $cb80552f083c27d2$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function(handler) {
        var qh = new $4j7iD(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function(handler) {
        var handlers = this.handlers;
        $cb80552f083c27d2$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function() {
        $cb80552f083c27d2$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function() {
        var action = this.matches() ? 'on' : 'off';
        $cb80552f083c27d2$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $cb80552f083c27d2$var$MediaQuery;

});
parcelRegister("4j7iD", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $322e99512342ced3$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$322e99512342ced3$var$QueryHandler.prototype = {
    constructor: $322e99512342ced3$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $322e99512342ced3$var$QueryHandler;

});

parcelRegister("eugCq", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $02b8c9535cbe98c3$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $02b8c9535cbe98c3$var$isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $02b8c9535cbe98c3$var$isFunction(target) {
    return typeof target === 'function';
}
module.exports = {
    isFunction: $02b8c9535cbe98c3$var$isFunction,
    isArray: $02b8c9535cbe98c3$var$isArray,
    each: $02b8c9535cbe98c3$var$each
};

});





var $651eb938f0d37749$exports = {};
$parcel$extendImportMap({
    "gjttY": "square-filler.55ff56a2.png",
    "dEznS": "custom_dnb_loading.fd10336f.svg",
    "3ehqk": "custom_dnb_calendar.5c698514.svg",
    "5Q54I": "ingen_hendelser_illustrasjon.76e5ce5b.png"
});

var $60739c7e3f826d8d$exports = {};
'use strict';

$60739c7e3f826d8d$exports = (parcelRequire("hCm5D"));


/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';


if (typeof Promise === 'undefined') {
    // Rejection tracking prevents a common issue where React gets into an
    // inconsistent state due to an error, but it gets swallowed by a Promise,
    // and the user has no idea what causes React's erratic future behavior.
    (parcelRequire("jofHE")).enable();
    self.Promise = (parcelRequire("b0WhD"));
}

// Make sure we're in a Browser-like environment before importing polyfills
// This prevents `fetch()` from being imported in a Node test environment
if (typeof window !== 'undefined') // fetch() polyfill for making API calls.
(parcelRequire("aZEZV"));

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = (parcelRequire("cbYl1"));
var $95671b6a94937336$exports = {};
'use strict';

$95671b6a94937336$exports = (parcelRequire("7h4ZC"));


var $93c028943c528744$exports = {};
'use strict';

$93c028943c528744$exports = (parcelRequire("3MGWX"));





var $ieaan = parcelRequire("ieaan");
var $c75051cfa147f10e$exports = {};

$parcel$export($c75051cfa147f10e$exports, "createRoot", function () { return $c75051cfa147f10e$export$882461b6382ed46c; }, function (v) { return $c75051cfa147f10e$export$882461b6382ed46c = v; });
$parcel$export($c75051cfa147f10e$exports, "hydrateRoot", function () { return $c75051cfa147f10e$export$757ceba2d55c277e; }, function (v) { return $c75051cfa147f10e$export$757ceba2d55c277e = v; });
var $c75051cfa147f10e$export$882461b6382ed46c;
var $c75051cfa147f10e$export$757ceba2d55c277e;
'use strict';
var $d44b6dac8b4642ae$exports = {};
'use strict';
function $d44b6dac8b4642ae$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d44b6dac8b4642ae$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d44b6dac8b4642ae$var$checkDCE();

$d44b6dac8b4642ae$exports = (parcelRequire("a7k9U"));


var $c75051cfa147f10e$var$i;
$c75051cfa147f10e$export$882461b6382ed46c = $d44b6dac8b4642ae$exports.createRoot;
$c75051cfa147f10e$export$757ceba2d55c277e = $d44b6dac8b4642ae$exports.hydrateRoot;



parcelRequire("ieaan");
/**
 * react-router v7.9.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $ieaan = parcelRequire("ieaan");
var $ee61663bcaa3deaf$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-NISHYRIK.mjs"
});
var $ee61663bcaa3deaf$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $ee61663bcaa3deaf$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $ee61663bcaa3deaf$var$__typeError("Cannot " + msg);
var $ee61663bcaa3deaf$var$__privateGet = (obj, member, getter)=>($ee61663bcaa3deaf$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $ee61663bcaa3deaf$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $ee61663bcaa3deaf$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $ee61663bcaa3deaf$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($ee61663bcaa3deaf$export$e19cd5f9376f8cee || {});
var $ee61663bcaa3deaf$var$PopStateEventType = "popstate";
function $ee61663bcaa3deaf$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $ee61663bcaa3deaf$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $ee61663bcaa3deaf$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $ee61663bcaa3deaf$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $ee61663bcaa3deaf$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $ee61663bcaa3deaf$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $ee61663bcaa3deaf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $ee61663bcaa3deaf$export$fe53371bee54353d(to);
    }
    return $ee61663bcaa3deaf$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $ee61663bcaa3deaf$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $ee61663bcaa3deaf$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $ee61663bcaa3deaf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $ee61663bcaa3deaf$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $ee61663bcaa3deaf$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $ee61663bcaa3deaf$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $ee61663bcaa3deaf$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $ee61663bcaa3deaf$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $ee61663bcaa3deaf$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $ee61663bcaa3deaf$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $ee61663bcaa3deaf$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $ee61663bcaa3deaf$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $ee61663bcaa3deaf$var$createKey()
    };
    return location;
}
function $ee61663bcaa3deaf$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $ee61663bcaa3deaf$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $ee61663bcaa3deaf$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $ee61663bcaa3deaf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $ee61663bcaa3deaf$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $ee61663bcaa3deaf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $ee61663bcaa3deaf$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $ee61663bcaa3deaf$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($ee61663bcaa3deaf$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($ee61663bcaa3deaf$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $ee61663bcaa3deaf$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $ee61663bcaa3deaf$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $ee61663bcaa3deaf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $ee61663bcaa3deaf$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $ee61663bcaa3deaf$var$_map;
var $ee61663bcaa3deaf$export$b8d3e69d4b3eff04 = class {
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($ee61663bcaa3deaf$var$__privateGet(this, $ee61663bcaa3deaf$var$_map).has(context)) return $ee61663bcaa3deaf$var$__privateGet(this, $ee61663bcaa3deaf$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $ee61663bcaa3deaf$var$__privateGet(this, $ee61663bcaa3deaf$var$_map).set(context, value);
    }
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $ee61663bcaa3deaf$var$__privateAdd(this, $ee61663bcaa3deaf$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
};
$ee61663bcaa3deaf$var$_map = new WeakMap();
var $ee61663bcaa3deaf$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $ee61663bcaa3deaf$var$isUnsupportedLazyRouteObjectKey(key) {
    return $ee61663bcaa3deaf$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $ee61663bcaa3deaf$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $ee61663bcaa3deaf$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $ee61663bcaa3deaf$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $ee61663bcaa3deaf$var$isIndexRoute(route) {
    return route.index === true;
}
function $ee61663bcaa3deaf$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $ee61663bcaa3deaf$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $ee61663bcaa3deaf$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($ee61663bcaa3deaf$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $ee61663bcaa3deaf$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $ee61663bcaa3deaf$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $ee61663bcaa3deaf$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $ee61663bcaa3deaf$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $ee61663bcaa3deaf$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $ee61663bcaa3deaf$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $ee61663bcaa3deaf$var$flattenRoutes(routes);
    $ee61663bcaa3deaf$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $ee61663bcaa3deaf$var$decodePath(pathname);
        matches = $ee61663bcaa3deaf$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $ee61663bcaa3deaf$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $ee61663bcaa3deaf$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $ee61663bcaa3deaf$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $ee61663bcaa3deaf$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $ee61663bcaa3deaf$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $ee61663bcaa3deaf$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $ee61663bcaa3deaf$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route_path;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $ee61663bcaa3deaf$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $ee61663bcaa3deaf$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $ee61663bcaa3deaf$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $ee61663bcaa3deaf$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $ee61663bcaa3deaf$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $ee61663bcaa3deaf$var$paramRe = /^:[\w-]+$/;
var $ee61663bcaa3deaf$var$dynamicSegmentValue = 3;
var $ee61663bcaa3deaf$var$indexRouteValue = 2;
var $ee61663bcaa3deaf$var$emptySegmentValue = 1;
var $ee61663bcaa3deaf$var$staticSegmentValue = 10;
var $ee61663bcaa3deaf$var$splatPenalty = -2;
var $ee61663bcaa3deaf$var$isSplat = (s)=>s === "*";
function $ee61663bcaa3deaf$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($ee61663bcaa3deaf$var$isSplat)) initialScore += $ee61663bcaa3deaf$var$splatPenalty;
    if (index) initialScore += $ee61663bcaa3deaf$var$indexRouteValue;
    return segments.filter((s)=>!$ee61663bcaa3deaf$var$isSplat(s)).reduce((score, segment)=>score + ($ee61663bcaa3deaf$var$paramRe.test(segment) ? $ee61663bcaa3deaf$var$dynamicSegmentValue : segment === "" ? $ee61663bcaa3deaf$var$emptySegmentValue : $ee61663bcaa3deaf$var$staticSegmentValue), initialScore);
}
function $ee61663bcaa3deaf$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $ee61663bcaa3deaf$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $ee61663bcaa3deaf$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $ee61663bcaa3deaf$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $ee61663bcaa3deaf$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $ee61663bcaa3deaf$var$normalizePathname($ee61663bcaa3deaf$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $ee61663bcaa3deaf$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $ee61663bcaa3deaf$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $ee61663bcaa3deaf$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $ee61663bcaa3deaf$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $ee61663bcaa3deaf$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $ee61663bcaa3deaf$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $ee61663bcaa3deaf$var$compilePath(path, caseSensitive = false, end = true) {
    $ee61663bcaa3deaf$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $ee61663bcaa3deaf$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $ee61663bcaa3deaf$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $ee61663bcaa3deaf$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $ee61663bcaa3deaf$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $ee61663bcaa3deaf$var$joinPaths([
        basename,
        pathname
    ]);
}
function $ee61663bcaa3deaf$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $ee61663bcaa3deaf$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $ee61663bcaa3deaf$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $ee61663bcaa3deaf$var$normalizeSearch(search),
        hash: $ee61663bcaa3deaf$var$normalizeHash(hash)
    };
}
function $ee61663bcaa3deaf$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $ee61663bcaa3deaf$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $ee61663bcaa3deaf$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $ee61663bcaa3deaf$var$getResolveToMatches(matches) {
    let pathMatches = $ee61663bcaa3deaf$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $ee61663bcaa3deaf$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $ee61663bcaa3deaf$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $ee61663bcaa3deaf$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $ee61663bcaa3deaf$var$getInvalidPathError("?", "pathname", "search", to));
        $ee61663bcaa3deaf$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $ee61663bcaa3deaf$var$getInvalidPathError("#", "pathname", "hash", to));
        $ee61663bcaa3deaf$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $ee61663bcaa3deaf$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $ee61663bcaa3deaf$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $ee61663bcaa3deaf$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $ee61663bcaa3deaf$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $ee61663bcaa3deaf$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $ee61663bcaa3deaf$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $ee61663bcaa3deaf$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $ee61663bcaa3deaf$export$4051a07651545597(data2, init) {
    return new $ee61663bcaa3deaf$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $ee61663bcaa3deaf$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $ee61663bcaa3deaf$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $ee61663bcaa3deaf$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $ee61663bcaa3deaf$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $ee61663bcaa3deaf$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $ee61663bcaa3deaf$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $ee61663bcaa3deaf$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $ee61663bcaa3deaf$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $ee61663bcaa3deaf$var$validMutationMethods = new Set($ee61663bcaa3deaf$var$validMutationMethodsArr);
var $ee61663bcaa3deaf$var$validRequestMethodsArr = [
    "GET",
    ...$ee61663bcaa3deaf$var$validMutationMethodsArr
];
var $ee61663bcaa3deaf$var$validRequestMethods = new Set($ee61663bcaa3deaf$var$validRequestMethodsArr);
var $ee61663bcaa3deaf$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $ee61663bcaa3deaf$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $ee61663bcaa3deaf$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $ee61663bcaa3deaf$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $ee61663bcaa3deaf$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $ee61663bcaa3deaf$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ee61663bcaa3deaf$var$isAbsoluteUrl = (url)=>$ee61663bcaa3deaf$var$ABSOLUTE_URL_REGEX.test(url);
var $ee61663bcaa3deaf$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $ee61663bcaa3deaf$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $ee61663bcaa3deaf$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $ee61663bcaa3deaf$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $ee61663bcaa3deaf$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let mapRouteProperties2 = init.mapRouteProperties || $ee61663bcaa3deaf$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $ee61663bcaa3deaf$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $ee61663bcaa3deaf$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $ee61663bcaa3deaf$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $ee61663bcaa3deaf$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $ee61663bcaa3deaf$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$ee61663bcaa3deaf$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$ee61663bcaa3deaf$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$ee61663bcaa3deaf$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $ee61663bcaa3deaf$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $ee61663bcaa3deaf$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $ee61663bcaa3deaf$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $ee61663bcaa3deaf$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$ee61663bcaa3deaf$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        var _location_state, _location_state1;
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $ee61663bcaa3deaf$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $ee61663bcaa3deaf$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $ee61663bcaa3deaf$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $ee61663bcaa3deaf$export$cbae47800eb95bc3(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $ee61663bcaa3deaf$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $ee61663bcaa3deaf$var$normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $ee61663bcaa3deaf$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $ee61663bcaa3deaf$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $ee61663bcaa3deaf$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $ee61663bcaa3deaf$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $ee61663bcaa3deaf$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $ee61663bcaa3deaf$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $ee61663bcaa3deaf$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $ee61663bcaa3deaf$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $ee61663bcaa3deaf$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $ee61663bcaa3deaf$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $ee61663bcaa3deaf$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $ee61663bcaa3deaf$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($ee61663bcaa3deaf$var$isErrorResult(result) && $ee61663bcaa3deaf$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $ee61663bcaa3deaf$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $ee61663bcaa3deaf$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$ee61663bcaa3deaf$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $ee61663bcaa3deaf$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $ee61663bcaa3deaf$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $ee61663bcaa3deaf$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $ee61663bcaa3deaf$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $ee61663bcaa3deaf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($ee61663bcaa3deaf$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $ee61663bcaa3deaf$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($ee61663bcaa3deaf$var$isErrorResult(result)) {
            let boundaryMatch = $ee61663bcaa3deaf$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $ee61663bcaa3deaf$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $ee61663bcaa3deaf$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $ee61663bcaa3deaf$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $ee61663bcaa3deaf$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $ee61663bcaa3deaf$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$ee61663bcaa3deaf$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $ee61663bcaa3deaf$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $ee61663bcaa3deaf$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $ee61663bcaa3deaf$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $ee61663bcaa3deaf$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $ee61663bcaa3deaf$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let matches = $ee61663bcaa3deaf$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $ee61663bcaa3deaf$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $ee61663bcaa3deaf$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $ee61663bcaa3deaf$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $ee61663bcaa3deaf$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ee61663bcaa3deaf$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ee61663bcaa3deaf$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ee61663bcaa3deaf$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $ee61663bcaa3deaf$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $ee61663bcaa3deaf$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($ee61663bcaa3deaf$var$isRedirectResult(actionResult) || $ee61663bcaa3deaf$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $ee61663bcaa3deaf$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($ee61663bcaa3deaf$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $ee61663bcaa3deaf$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $ee61663bcaa3deaf$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($ee61663bcaa3deaf$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $ee61663bcaa3deaf$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $ee61663bcaa3deaf$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $ee61663bcaa3deaf$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $ee61663bcaa3deaf$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $ee61663bcaa3deaf$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $ee61663bcaa3deaf$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $ee61663bcaa3deaf$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $ee61663bcaa3deaf$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $ee61663bcaa3deaf$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $ee61663bcaa3deaf$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $ee61663bcaa3deaf$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $ee61663bcaa3deaf$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ee61663bcaa3deaf$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ee61663bcaa3deaf$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ee61663bcaa3deaf$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $ee61663bcaa3deaf$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $ee61663bcaa3deaf$var$getDoneFetcher(void 0));
            return;
        }
        if ($ee61663bcaa3deaf$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $ee61663bcaa3deaf$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($ee61663bcaa3deaf$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $ee61663bcaa3deaf$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $ee61663bcaa3deaf$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $ee61663bcaa3deaf$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $ee61663bcaa3deaf$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($ee61663bcaa3deaf$var$isAbsoluteUrl(location)) {
                const url = $ee61663bcaa3deaf$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $ee61663bcaa3deaf$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $ee61663bcaa3deaf$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($ee61663bcaa3deaf$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $ee61663bcaa3deaf$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $ee61663bcaa3deaf$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $ee61663bcaa3deaf$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($ee61663bcaa3deaf$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $ee61663bcaa3deaf$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $ee61663bcaa3deaf$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $ee61663bcaa3deaf$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $ee61663bcaa3deaf$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $ee61663bcaa3deaf$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, $ee61663bcaa3deaf$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $ee61663bcaa3deaf$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $ee61663bcaa3deaf$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $ee61663bcaa3deaf$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $ee61663bcaa3deaf$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $ee61663bcaa3deaf$export$386d57f03f0b2883;
        $ee61663bcaa3deaf$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $ee61663bcaa3deaf$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $ee61663bcaa3deaf$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $ee61663bcaa3deaf$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $ee61663bcaa3deaf$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$ee61663bcaa3deaf$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $ee61663bcaa3deaf$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $ee61663bcaa3deaf$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $ee61663bcaa3deaf$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $ee61663bcaa3deaf$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $ee61663bcaa3deaf$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $ee61663bcaa3deaf$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $ee61663bcaa3deaf$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    return router;
}
function $ee61663bcaa3deaf$export$3336b097a6fbc59a(routes, opts) {
    $ee61663bcaa3deaf$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || $ee61663bcaa3deaf$var$defaultMapRouteProperties;
    let dataRoutes = $ee61663bcaa3deaf$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $ee61663bcaa3deaf$var$createLocation("", $ee61663bcaa3deaf$export$fe53371bee54353d(url), null, "default");
        let matches = $ee61663bcaa3deaf$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $ee61663bcaa3deaf$export$b8d3e69d4b3eff04();
        if (!$ee61663bcaa3deaf$var$isValidMethod(method) && method !== "HEAD") {
            let error = $ee61663bcaa3deaf$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $ee61663bcaa3deaf$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $ee61663bcaa3deaf$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ee61663bcaa3deaf$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $ee61663bcaa3deaf$export$f5708dca728d7177(requestContext instanceof $ee61663bcaa3deaf$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $ee61663bcaa3deaf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $ee61663bcaa3deaf$var$runServerMiddlewarePipeline({
                    request: request,
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        var _opts2_filterMatchesToLoad;
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true);
                        if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($ee61663bcaa3deaf$export$6e80290866a84dd4(error)) return error;
                    if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $ee61663bcaa3deaf$export$f2680fa305b734ca(error.status, error.statusText, await $ee61663bcaa3deaf$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(error)) error = $ee61663bcaa3deaf$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $ee61663bcaa3deaf$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $ee61663bcaa3deaf$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        var _matches_find;
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $ee61663bcaa3deaf$var$findNearestBoundary(matches, ((_matches_find = matches.find((m)=>m.route.id === routeId || m.route.loader)) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $ee61663bcaa3deaf$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $ee61663bcaa3deaf$export$f5708dca728d7177($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $ee61663bcaa3deaf$var$createLocation("", $ee61663bcaa3deaf$export$fe53371bee54353d(url), null, "default");
        let matches = $ee61663bcaa3deaf$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $ee61663bcaa3deaf$export$b8d3e69d4b3eff04();
        if (!$ee61663bcaa3deaf$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $ee61663bcaa3deaf$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $ee61663bcaa3deaf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $ee61663bcaa3deaf$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $ee61663bcaa3deaf$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $ee61663bcaa3deaf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $ee61663bcaa3deaf$export$f5708dca728d7177(requestContext instanceof $ee61663bcaa3deaf$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $ee61663bcaa3deaf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $ee61663bcaa3deaf$var$runServerMiddlewarePipeline({
                request: request,
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($ee61663bcaa3deaf$var$dataWithResponseInitToResponse(error));
                if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $ee61663bcaa3deaf$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($ee61663bcaa3deaf$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $ee61663bcaa3deaf$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($ee61663bcaa3deaf$var$isDataStrategyResult(e) && $ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($ee61663bcaa3deaf$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $ee61663bcaa3deaf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $ee61663bcaa3deaf$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($ee61663bcaa3deaf$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($ee61663bcaa3deaf$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($ee61663bcaa3deaf$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $ee61663bcaa3deaf$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $ee61663bcaa3deaf$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($ee61663bcaa3deaf$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $ee61663bcaa3deaf$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $ee61663bcaa3deaf$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw $ee61663bcaa3deaf$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $ee61663bcaa3deaf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, false);
                return $ee61663bcaa3deaf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $ee61663bcaa3deaf$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $ee61663bcaa3deaf$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $ee61663bcaa3deaf$var$callDataStrategyImpl(dataStrategy || $ee61663bcaa3deaf$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($ee61663bcaa3deaf$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $ee61663bcaa3deaf$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(result.result)) throw $ee61663bcaa3deaf$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $ee61663bcaa3deaf$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $ee61663bcaa3deaf$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $ee61663bcaa3deaf$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $ee61663bcaa3deaf$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $ee61663bcaa3deaf$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $ee61663bcaa3deaf$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $ee61663bcaa3deaf$var$resolveTo(to ? to : ".", $ee61663bcaa3deaf$var$getResolveToMatches(contextualMatches), $ee61663bcaa3deaf$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $ee61663bcaa3deaf$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $ee61663bcaa3deaf$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $ee61663bcaa3deaf$export$fe53371bee54353d(path);
}
function $ee61663bcaa3deaf$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$ee61663bcaa3deaf$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$ee61663bcaa3deaf$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $ee61663bcaa3deaf$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $ee61663bcaa3deaf$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $ee61663bcaa3deaf$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$ee61663bcaa3deaf$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$ee61663bcaa3deaf$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $ee61663bcaa3deaf$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $ee61663bcaa3deaf$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $ee61663bcaa3deaf$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $ee61663bcaa3deaf$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $ee61663bcaa3deaf$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($ee61663bcaa3deaf$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $ee61663bcaa3deaf$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $ee61663bcaa3deaf$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $ee61663bcaa3deaf$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $ee61663bcaa3deaf$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    var _state_matches_;
    let actionResult = pendingActionResult ? $ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$ee61663bcaa3deaf$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $ee61663bcaa3deaf$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($ee61663bcaa3deaf$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $ee61663bcaa3deaf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $ee61663bcaa3deaf$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $ee61663bcaa3deaf$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $ee61663bcaa3deaf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $ee61663bcaa3deaf$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $ee61663bcaa3deaf$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $ee61663bcaa3deaf$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($ee61663bcaa3deaf$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $ee61663bcaa3deaf$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $ee61663bcaa3deaf$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$ee61663bcaa3deaf$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $ee61663bcaa3deaf$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $ee61663bcaa3deaf$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $ee61663bcaa3deaf$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $ee61663bcaa3deaf$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $ee61663bcaa3deaf$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$ee61663bcaa3deaf$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $ee61663bcaa3deaf$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $ee61663bcaa3deaf$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $ee61663bcaa3deaf$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some((bChild)=>$ee61663bcaa3deaf$var$isSameRoute(aChild, bChild));
    });
}
var $ee61663bcaa3deaf$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $ee61663bcaa3deaf$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $ee61663bcaa3deaf$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $ee61663bcaa3deaf$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $ee61663bcaa3deaf$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $ee61663bcaa3deaf$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $ee61663bcaa3deaf$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $ee61663bcaa3deaf$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $ee61663bcaa3deaf$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $ee61663bcaa3deaf$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $ee61663bcaa3deaf$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $ee61663bcaa3deaf$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $ee61663bcaa3deaf$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $ee61663bcaa3deaf$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $ee61663bcaa3deaf$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $ee61663bcaa3deaf$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $ee61663bcaa3deaf$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $ee61663bcaa3deaf$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(()=>{});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $ee61663bcaa3deaf$var$isNonNullable(value) {
    return value !== void 0;
}
function $ee61663bcaa3deaf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $ee61663bcaa3deaf$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($ee61663bcaa3deaf$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $ee61663bcaa3deaf$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $ee61663bcaa3deaf$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $ee61663bcaa3deaf$var$defaultDataStrategy(args);
    return $ee61663bcaa3deaf$var$runClientMiddlewarePipeline(args, ()=>$ee61663bcaa3deaf$var$defaultDataStrategy(args));
}
function $ee61663bcaa3deaf$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $ee61663bcaa3deaf$var$runMiddlewarePipeline(args, handler, processResult, $ee61663bcaa3deaf$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(result) ? $ee61663bcaa3deaf$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $ee61663bcaa3deaf$var$runClientMiddlewarePipeline(args, handler) {
    return $ee61663bcaa3deaf$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $ee61663bcaa3deaf$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.unstable_shouldCallHandler()), 0));
            let boundaryRouteId = $ee61663bcaa3deaf$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $ee61663bcaa3deaf$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $ee61663bcaa3deaf$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $ee61663bcaa3deaf$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    var _request_signal_reason;
    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $ee61663bcaa3deaf$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result !== null && result !== void 0 ? result : nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $ee61663bcaa3deaf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $ee61663bcaa3deaf$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $ee61663bcaa3deaf$var$loadLazyRoute(match.route, $ee61663bcaa3deaf$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $ee61663bcaa3deaf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $ee61663bcaa3deaf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $ee61663bcaa3deaf$var$shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $ee61663bcaa3deaf$var$shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$ee61663bcaa3deaf$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && !isMiddlewareOnlyRoute) return $ee61663bcaa3deaf$var$callLoaderOrAction({
                request: request,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $ee61663bcaa3deaf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: $ee61663bcaa3deaf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $ee61663bcaa3deaf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $ee61663bcaa3deaf$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    })) await Promise.all(matches.map((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    }));
    let dataStrategyArgs = {
        request: request,
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $ee61663bcaa3deaf$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>{
            var _m__lazyPromises, _m__lazyPromises1;
            return [
                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
            ];
        }));
    } catch (e) {}
    return results;
}
async function $ee61663bcaa3deaf$var$callLoaderOrAction({ request: request, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $ee61663bcaa3deaf$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $ee61663bcaa3deaf$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $ee61663bcaa3deaf$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $ee61663bcaa3deaf$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $ee61663bcaa3deaf$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    var _result_init, _result_init1;
    let { result: result, type: type } = dataStrategyResult;
    if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $ee61663bcaa3deaf$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $ee61663bcaa3deaf$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(result)) {
            var _result_init2, _result_init3, _result_init4, _result_init5;
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $ee61663bcaa3deaf$export$f2680fa305b734ca(((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.status) || 500, void 0, result.data),
                statusCode: $ee61663bcaa3deaf$export$972111febbeef05b(result) ? result.status : void 0,
                headers: ((_result_init5 = result.init) === null || _result_init5 === void 0 ? void 0 : _result_init5.headers) ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $ee61663bcaa3deaf$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
        headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $ee61663bcaa3deaf$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $ee61663bcaa3deaf$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$ee61663bcaa3deaf$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $ee61663bcaa3deaf$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $ee61663bcaa3deaf$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($ee61663bcaa3deaf$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $ee61663bcaa3deaf$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $ee61663bcaa3deaf$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($ee61663bcaa3deaf$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $ee61663bcaa3deaf$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $ee61663bcaa3deaf$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $ee61663bcaa3deaf$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $ee61663bcaa3deaf$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $ee61663bcaa3deaf$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $ee61663bcaa3deaf$export$f5708dca728d7177(!$ee61663bcaa3deaf$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($ee61663bcaa3deaf$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $ee61663bcaa3deaf$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $ee61663bcaa3deaf$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $ee61663bcaa3deaf$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $ee61663bcaa3deaf$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $ee61663bcaa3deaf$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $ee61663bcaa3deaf$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($ee61663bcaa3deaf$var$isErrorResult(result)) {
            let boundaryMatch = $ee61663bcaa3deaf$var$findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($ee61663bcaa3deaf$var$isRedirectResult(result)) $ee61663bcaa3deaf$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $ee61663bcaa3deaf$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $ee61663bcaa3deaf$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $ee61663bcaa3deaf$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $ee61663bcaa3deaf$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $ee61663bcaa3deaf$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $ee61663bcaa3deaf$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $ee61663bcaa3deaf$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $ee61663bcaa3deaf$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $ee61663bcaa3deaf$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $ee61663bcaa3deaf$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($ee61663bcaa3deaf$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $ee61663bcaa3deaf$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $ee61663bcaa3deaf$export$8ccf933b0513f8d0(path) : path;
    return $ee61663bcaa3deaf$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $ee61663bcaa3deaf$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $ee61663bcaa3deaf$var$dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function $ee61663bcaa3deaf$var$dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new $ee61663bcaa3deaf$export$f2680fa305b734ca((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function $ee61663bcaa3deaf$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $ee61663bcaa3deaf$var$isDataStrategyResult(value));
}
function $ee61663bcaa3deaf$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $ee61663bcaa3deaf$var$isRedirectDataStrategyResult(result) {
    return $ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result.result) && $ee61663bcaa3deaf$var$redirectStatusCodes.has(result.result.status);
}
function $ee61663bcaa3deaf$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $ee61663bcaa3deaf$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $ee61663bcaa3deaf$export$794b2760043cf8cd(statusCode) {
    return $ee61663bcaa3deaf$var$redirectStatusCodes.has(statusCode);
}
function $ee61663bcaa3deaf$export$6e80290866a84dd4(result) {
    return $ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result) && $ee61663bcaa3deaf$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $ee61663bcaa3deaf$var$isValidMethod(method) {
    return $ee61663bcaa3deaf$var$validRequestMethods.has(method.toUpperCase());
}
function $ee61663bcaa3deaf$export$cbae47800eb95bc3(method) {
    return $ee61663bcaa3deaf$var$validMutationMethods.has(method.toUpperCase());
}
function $ee61663bcaa3deaf$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $ee61663bcaa3deaf$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $ee61663bcaa3deaf$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $ee61663bcaa3deaf$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $ee61663bcaa3deaf$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $ee61663bcaa3deaf$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $ee61663bcaa3deaf$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $ee61663bcaa3deaf$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $ee61663bcaa3deaf$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $ee61663bcaa3deaf$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $ee61663bcaa3deaf$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $ee61663bcaa3deaf$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($ee61663bcaa3deaf$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $ee61663bcaa3deaf$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($ee61663bcaa3deaf$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $ee61663bcaa3deaf$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $ee61663bcaa3deaf$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $ee61663bcaa3deaf$export$2eeee58951ff3c1c = $ieaan.createContext(null);
$ee61663bcaa3deaf$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $ee61663bcaa3deaf$export$315e3ffb01f217 = $ieaan.createContext(null);
$ee61663bcaa3deaf$export$315e3ffb01f217.displayName = "DataRouterState";
var $ee61663bcaa3deaf$export$717f757c655223f1 = $ieaan.createContext(false);
function $ee61663bcaa3deaf$var$useIsRSCRouterContext() {
    return $ieaan.useContext($ee61663bcaa3deaf$export$717f757c655223f1);
}
var $ee61663bcaa3deaf$export$3681f408decb40d1 = $ieaan.createContext({
    isTransitioning: false
});
$ee61663bcaa3deaf$export$3681f408decb40d1.displayName = "ViewTransition";
var $ee61663bcaa3deaf$export$cb3f1df1bef00a39 = $ieaan.createContext(/* @__PURE__ */ new Map());
$ee61663bcaa3deaf$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $ee61663bcaa3deaf$var$AwaitContext = $ieaan.createContext(null);
$ee61663bcaa3deaf$var$AwaitContext.displayName = "Await";
var $ee61663bcaa3deaf$export$2666c20e15407622 = (props)=>$ieaan.createElement($ee61663bcaa3deaf$var$AwaitContext.Provider, props);
var $ee61663bcaa3deaf$export$3044ab7fdabeaee6 = $ieaan.createContext(null);
$ee61663bcaa3deaf$export$3044ab7fdabeaee6.displayName = "Navigation";
var $ee61663bcaa3deaf$export$e6a44b110a0c44d3 = $ieaan.createContext(null);
$ee61663bcaa3deaf$export$e6a44b110a0c44d3.displayName = "Location";
var $ee61663bcaa3deaf$export$aac280ed165a4397 = $ieaan.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$ee61663bcaa3deaf$export$aac280ed165a4397.displayName = "Route";
var $ee61663bcaa3deaf$var$RouteErrorContext = $ieaan.createContext(null);
$ee61663bcaa3deaf$var$RouteErrorContext.displayName = "RouteError";
var $ee61663bcaa3deaf$export$945fecf35a8ef089 = true;
function $ee61663bcaa3deaf$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $ee61663bcaa3deaf$export$f5708dca728d7177($ee61663bcaa3deaf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $ee61663bcaa3deaf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $ee61663bcaa3deaf$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $ee61663bcaa3deaf$export$9c954a9d03d32f4a() {
    return $ieaan.useContext($ee61663bcaa3deaf$export$e6a44b110a0c44d3) != null;
}
function $ee61663bcaa3deaf$export$45d76561a5302f2b() {
    $ee61663bcaa3deaf$export$f5708dca728d7177($ee61663bcaa3deaf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $ieaan.useContext($ee61663bcaa3deaf$export$e6a44b110a0c44d3).location;
}
function $ee61663bcaa3deaf$export$1b3f31771c5d07c() {
    return $ieaan.useContext($ee61663bcaa3deaf$export$e6a44b110a0c44d3).navigationType;
}
function $ee61663bcaa3deaf$export$6c330e8992e8a295(pattern) {
    $ee61663bcaa3deaf$export$f5708dca728d7177($ee61663bcaa3deaf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    return $ieaan.useMemo(()=>$ee61663bcaa3deaf$export$81336c211d5ff295(pattern, $ee61663bcaa3deaf$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $ee61663bcaa3deaf$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $ee61663bcaa3deaf$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6).static;
    if (!isStatic) $ieaan.useLayoutEffect(cb);
}
function $ee61663bcaa3deaf$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    return isDataRoute ? $ee61663bcaa3deaf$var$useNavigateStable() : $ee61663bcaa3deaf$var$useNavigateUnstable();
}
function $ee61663bcaa3deaf$var$useNavigateUnstable() {
    $ee61663bcaa3deaf$export$f5708dca728d7177($ee61663bcaa3deaf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $ieaan.useContext($ee61663bcaa3deaf$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let { matches: matches } = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($ee61663bcaa3deaf$var$getResolveToMatches(matches));
    let activeRef = $ieaan.useRef(false);
    $ee61663bcaa3deaf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ieaan.useCallback((to, options = {})=>{
        $ee61663bcaa3deaf$var$warning(activeRef.current, $ee61663bcaa3deaf$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $ee61663bcaa3deaf$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $ee61663bcaa3deaf$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $ee61663bcaa3deaf$var$OutletContext = $ieaan.createContext(null);
function $ee61663bcaa3deaf$export$4138103a3ae699cc() {
    return $ieaan.useContext($ee61663bcaa3deaf$var$OutletContext);
}
function $ee61663bcaa3deaf$export$a3be3530d8e40d0b(context) {
    let outlet = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397).outlet;
    return $ieaan.useMemo(()=>outlet && /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $ee61663bcaa3deaf$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $ee61663bcaa3deaf$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($ee61663bcaa3deaf$var$getResolveToMatches(matches));
    return $ieaan.useMemo(()=>$ee61663bcaa3deaf$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $ee61663bcaa3deaf$export$5d3fca4a98652595(routes, locationArg) {
    return $ee61663bcaa3deaf$var$useRoutesImpl(routes, locationArg);
}
function $ee61663bcaa3deaf$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $ee61663bcaa3deaf$export$f5708dca728d7177($ee61663bcaa3deaf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($ee61663bcaa3deaf$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $ee61663bcaa3deaf$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        let parsedLocationArg = typeof locationArg === "string" ? $ee61663bcaa3deaf$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $ee61663bcaa3deaf$export$f5708dca728d7177(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $ee61663bcaa3deaf$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($ee61663bcaa3deaf$export$945fecf35a8ef089) {
        $ee61663bcaa3deaf$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $ee61663bcaa3deaf$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $ee61663bcaa3deaf$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $ee61663bcaa3deaf$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $ee61663bcaa3deaf$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $ee61663bcaa3deaf$var$DefaultErrorComponent() {
    let error = $ee61663bcaa3deaf$export$ed527bf60f6e05f2();
    let message = $ee61663bcaa3deaf$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($ee61663bcaa3deaf$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $ieaan.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $ieaan.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $ieaan.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $ieaan.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $ieaan.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $ee61663bcaa3deaf$var$defaultErrorElement = /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$DefaultErrorComponent, null);
var $ee61663bcaa3deaf$var$RenderErrorBoundary = class extends $ieaan.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
};
function $ee61663bcaa3deaf$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $ieaan.useContext($ee61663bcaa3deaf$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $ee61663bcaa3deaf$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0);
        $ee61663bcaa3deaf$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $ee61663bcaa3deaf$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $ee61663bcaa3deaf$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $ieaan.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            unstable_onError: unstable_onError
        }) : getChildren();
    }, null);
}
function $ee61663bcaa3deaf$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $ee61663bcaa3deaf$var$useDataRouterContext(hookName) {
    let ctx = $ieaan.useContext($ee61663bcaa3deaf$export$2eeee58951ff3c1c);
    $ee61663bcaa3deaf$export$f5708dca728d7177(ctx, $ee61663bcaa3deaf$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $ee61663bcaa3deaf$var$useDataRouterState(hookName) {
    let state = $ieaan.useContext($ee61663bcaa3deaf$export$315e3ffb01f217);
    $ee61663bcaa3deaf$export$f5708dca728d7177(state, $ee61663bcaa3deaf$var$getDataRouterConsoleError(hookName));
    return state;
}
function $ee61663bcaa3deaf$var$useRouteContext(hookName) {
    let route = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    $ee61663bcaa3deaf$export$f5708dca728d7177(route, $ee61663bcaa3deaf$var$getDataRouterConsoleError(hookName));
    return route;
}
function $ee61663bcaa3deaf$var$useCurrentRouteId(hookName) {
    let route = $ee61663bcaa3deaf$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $ee61663bcaa3deaf$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $ee61663bcaa3deaf$var$useRouteId() {
    return $ee61663bcaa3deaf$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $ee61663bcaa3deaf$export$d0fd4b7106de2769() {
    let state = $ee61663bcaa3deaf$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $ee61663bcaa3deaf$export$600dc272ed516c15() {
    let dataRouterContext = $ee61663bcaa3deaf$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $ee61663bcaa3deaf$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $ieaan.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $ieaan.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $ee61663bcaa3deaf$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $ee61663bcaa3deaf$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $ieaan.useMemo(()=>matches.map((m)=>$ee61663bcaa3deaf$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $ee61663bcaa3deaf$export$1448a5050d252c4d() {
    let state = $ee61663bcaa3deaf$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $ee61663bcaa3deaf$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $ee61663bcaa3deaf$export$fd5d37484eab868d(routeId) {
    let state = $ee61663bcaa3deaf$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $ee61663bcaa3deaf$export$fdc00f3f26066d5e() {
    let state = $ee61663bcaa3deaf$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $ee61663bcaa3deaf$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $ee61663bcaa3deaf$export$ed527bf60f6e05f2() {
    var _state_errors;
    let error = $ieaan.useContext($ee61663bcaa3deaf$var$RouteErrorContext);
    let state = $ee61663bcaa3deaf$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $ee61663bcaa3deaf$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function $ee61663bcaa3deaf$export$78a72ddb39bdd145() {
    let value = $ieaan.useContext($ee61663bcaa3deaf$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function $ee61663bcaa3deaf$export$17f53340677d5831() {
    let value = $ieaan.useContext($ee61663bcaa3deaf$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var $ee61663bcaa3deaf$var$blockerId = 0;
function $ee61663bcaa3deaf$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $ee61663bcaa3deaf$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $ee61663bcaa3deaf$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $ieaan.useState("");
    let blockerFunction = $ieaan.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $ee61663bcaa3deaf$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $ee61663bcaa3deaf$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $ieaan.useEffect(()=>{
        let key = String(++$ee61663bcaa3deaf$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $ieaan.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $ee61663bcaa3deaf$export$386d57f03f0b2883;
}
function $ee61663bcaa3deaf$var$useNavigateStable() {
    let { router: router } = $ee61663bcaa3deaf$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $ee61663bcaa3deaf$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $ieaan.useRef(false);
    $ee61663bcaa3deaf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ieaan.useCallback(async (to, options = {})=>{
        $ee61663bcaa3deaf$var$warning(activeRef.current, $ee61663bcaa3deaf$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $ee61663bcaa3deaf$var$alreadyWarned = {};
function $ee61663bcaa3deaf$var$warningOnce(key, cond, message) {
    if (!cond && !$ee61663bcaa3deaf$var$alreadyWarned[key]) {
        $ee61663bcaa3deaf$var$alreadyWarned[key] = true;
        $ee61663bcaa3deaf$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $ee61663bcaa3deaf$var$alreadyWarned2 = {};
function $ee61663bcaa3deaf$export$5b28268982f175ba(condition, message) {
    if (!condition && !$ee61663bcaa3deaf$var$alreadyWarned2[message]) {
        $ee61663bcaa3deaf$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function $ee61663bcaa3deaf$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($ee61663bcaa3deaf$export$945fecf35a8ef089) {
            if (route.element) $ee61663bcaa3deaf$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $ieaan.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($ee61663bcaa3deaf$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $ee61663bcaa3deaf$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $ieaan.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($ee61663bcaa3deaf$export$945fecf35a8ef089) {
            if (route.errorElement) $ee61663bcaa3deaf$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $ieaan.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $ee61663bcaa3deaf$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $ee61663bcaa3deaf$export$f30f7e456d254e83(routes, opts) {
    return $ee61663bcaa3deaf$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $ee61663bcaa3deaf$var$createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: $ee61663bcaa3deaf$export$e2fd2c03906469db,
        mapRouteProperties: $ee61663bcaa3deaf$export$9269a41d8c4635e,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}
var $ee61663bcaa3deaf$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $ee61663bcaa3deaf$var$shallowDiff(a, b) {
    if (a === b) return false;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return true;
    for (let key of aKeys){
        if (a[key] !== b[key]) return true;
    }
    return false;
}
function $ee61663bcaa3deaf$export$b23aa17f1e546c5e({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let fetcherData = $ieaan.useRef(/* @__PURE__ */ new Map());
    let [revalidating, startRevalidation] = $ieaan.useTransition();
    let [state, setState] = $ieaan.useState(router.state);
    router.__setPendingRerender = (promise)=>startRevalidation(// @ts-expect-error - need react 19 types for this to be async
        async ()=>{
            const rerender = await promise;
            startRevalidation(()=>{
                rerender();
            });
        });
    let navigator = $ieaan.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $ieaan.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    $ieaan.useLayoutEffect(()=>{
        return router.subscribe((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
            newState.fetchers.forEach((fetcher, key)=>{
                if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
            });
            deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
            const diff = $ee61663bcaa3deaf$var$shallowDiff(state, newState);
            if (!diff) return;
            if (flushSync) {
                if (reactDomFlushSyncImpl) reactDomFlushSyncImpl(()=>setState(newState));
                else setState(newState);
            } else $ieaan.startTransition(()=>{
                setState(newState);
            });
        });
    }, [
        router,
        reactDomFlushSyncImpl,
        state
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$315e3ffb01f217.Provider, {
        value: {
            ...state,
            revalidation: revalidating ? "loading" : state.revalidation
        }
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    }))))), null);
}
function $ee61663bcaa3deaf$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let [state, setStateImpl] = $ieaan.useState(router.state);
    let [pendingState, setPendingState] = $ieaan.useState();
    let [vtContext, setVtContext] = $ieaan.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $ieaan.useState();
    let [transition, setTransition] = $ieaan.useState();
    let [interruption, setInterruption] = $ieaan.useState();
    let fetcherData = $ieaan.useRef(/* @__PURE__ */ new Map());
    let logErrorsAndSetState = $ieaan.useCallback((newState)=>{
        setStateImpl((prevState)=>{
            if (newState.errors && unstable_onError) Object.entries(newState.errors).forEach(([routeId, error])=>{
                var _prevState_errors;
                if (((_prevState_errors = prevState.errors) === null || _prevState_errors === void 0 ? void 0 : _prevState_errors[routeId]) !== error) unstable_onError(error);
            });
            return newState;
        });
    }, [
        unstable_onError
    ]);
    let setState = $ieaan.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $ee61663bcaa3deaf$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $ee61663bcaa3deaf$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            else $ieaan.startTransition(()=>logErrorsAndSetState(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        logErrorsAndSetState
    ]);
    $ieaan.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $ieaan.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ee61663bcaa3deaf$var$Deferred());
    }, [
        vtContext
    ]);
    $ieaan.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $ieaan.startTransition(()=>logErrorsAndSetState(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        logErrorsAndSetState
    ]);
    $ieaan.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $ieaan.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $ieaan.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $ieaan.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
var $ee61663bcaa3deaf$var$MemoizedDataRoutes = $ieaan.memo($ee61663bcaa3deaf$var$DataRoutes);
function $ee61663bcaa3deaf$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $ee61663bcaa3deaf$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $ee61663bcaa3deaf$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $ieaan.useRef();
    if (historyRef.current == null) historyRef.current = $ee61663bcaa3deaf$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ee61663bcaa3deaf$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $ee61663bcaa3deaf$export$f5708dca728d7177($ee61663bcaa3deaf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    $ee61663bcaa3deaf$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let navigate = $ee61663bcaa3deaf$export$9770f232ac06a008();
    let path = $ee61663bcaa3deaf$var$resolveTo(to, $ee61663bcaa3deaf$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $ieaan.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $ee61663bcaa3deaf$export$910ae8079b2c2852(props) {
    return $ee61663bcaa3deaf$export$a3be3530d8e40d0b(props.context);
}
function $ee61663bcaa3deaf$export$e7b0ac011bb776c6(props) {
    $ee61663bcaa3deaf$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $ee61663bcaa3deaf$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false }) {
    $ee61663bcaa3deaf$export$f5708dca728d7177(!$ee61663bcaa3deaf$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $ieaan.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $ee61663bcaa3deaf$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $ieaan.useMemo(()=>{
        let trailingPathname = $ee61663bcaa3deaf$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $ee61663bcaa3deaf$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $ee61663bcaa3deaf$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $ee61663bcaa3deaf$export$5d3fca4a98652595($ee61663bcaa3deaf$export$16da398f5434bdec(children), location);
}
function $ee61663bcaa3deaf$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $ieaan.useContext($ee61663bcaa3deaf$export$2eeee58951ff3c1c);
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        unstable_onError: dataRouterContext === null || dataRouterContext === void 0 ? void 0 : dataRouterContext.unstable_onError
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$ResolveAwait, null, children));
}
var $ee61663bcaa3deaf$var$AwaitErrorBoundary = class extends $ieaan.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                var _this_props_unstable_onError, _this_props;
                (_this_props_unstable_onError = (_this_props = this.props).unstable_onError) === null || _this_props_unstable_onError === void 0 ? void 0 : _this_props_unstable_onError.call(_this_props, error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
};
function $ee61663bcaa3deaf$var$ResolveAwait({ children: children }) {
    let data2 = $ee61663bcaa3deaf$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, toRender);
}
function $ee61663bcaa3deaf$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $ieaan.Children.forEach(children, (element, index)=>{
        if (!$ieaan.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $ieaan.Fragment) {
            routes.push.apply(routes, $ee61663bcaa3deaf$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $ee61663bcaa3deaf$export$f5708dca728d7177(element.type === $ee61663bcaa3deaf$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $ee61663bcaa3deaf$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $ee61663bcaa3deaf$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $ee61663bcaa3deaf$export$9b5b6d122dea0c88 = $ee61663bcaa3deaf$export$16da398f5434bdec;
function $ee61663bcaa3deaf$export$daf73786167a7f72(matches) {
    return $ee61663bcaa3deaf$var$_renderMatches(matches);
}
function $ee61663bcaa3deaf$var$useRouteComponentProps() {
    return {
        params: $ee61663bcaa3deaf$export$99eaa27ddbbb95ef(),
        loaderData: $ee61663bcaa3deaf$export$1448a5050d252c4d(),
        actionData: $ee61663bcaa3deaf$export$fdc00f3f26066d5e(),
        matches: $ee61663bcaa3deaf$export$2378eb7f5ff86053()
    };
}
function $ee61663bcaa3deaf$export$6c4f3826290c37af({ children: children }) {
    const props = $ee61663bcaa3deaf$var$useRouteComponentProps();
    return $ieaan.cloneElement(children, props);
}
function $ee61663bcaa3deaf$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $ee61663bcaa3deaf$var$useRouteComponentProps();
        return $ieaan.createElement(Component4, props);
    };
}
function $ee61663bcaa3deaf$var$useHydrateFallbackProps() {
    return {
        params: $ee61663bcaa3deaf$export$99eaa27ddbbb95ef(),
        loaderData: $ee61663bcaa3deaf$export$1448a5050d252c4d(),
        actionData: $ee61663bcaa3deaf$export$fdc00f3f26066d5e()
    };
}
function $ee61663bcaa3deaf$export$f8cff34f39c1932a({ children: children }) {
    const props = $ee61663bcaa3deaf$var$useHydrateFallbackProps();
    return $ieaan.cloneElement(children, props);
}
function $ee61663bcaa3deaf$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $ee61663bcaa3deaf$var$useHydrateFallbackProps();
        return $ieaan.createElement(HydrateFallback, props);
    };
}
function $ee61663bcaa3deaf$var$useErrorBoundaryProps() {
    return {
        params: $ee61663bcaa3deaf$export$99eaa27ddbbb95ef(),
        loaderData: $ee61663bcaa3deaf$export$1448a5050d252c4d(),
        actionData: $ee61663bcaa3deaf$export$fdc00f3f26066d5e(),
        error: $ee61663bcaa3deaf$export$ed527bf60f6e05f2()
    };
}
function $ee61663bcaa3deaf$export$e5afde5c4b6d747b({ children: children }) {
    const props = $ee61663bcaa3deaf$var$useErrorBoundaryProps();
    return $ieaan.cloneElement(children, props);
}
function $ee61663bcaa3deaf$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $ee61663bcaa3deaf$var$useErrorBoundaryProps();
        return $ieaan.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $ee61663bcaa3deaf$var$defaultMethod = "get";
var $ee61663bcaa3deaf$var$defaultEncType = "application/x-www-form-urlencoded";
function $ee61663bcaa3deaf$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ee61663bcaa3deaf$var$isButtonElement(object) {
    return $ee61663bcaa3deaf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ee61663bcaa3deaf$var$isFormElement(object) {
    return $ee61663bcaa3deaf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ee61663bcaa3deaf$var$isInputElement(object) {
    return $ee61663bcaa3deaf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ee61663bcaa3deaf$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ee61663bcaa3deaf$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ee61663bcaa3deaf$var$isModifiedEvent(event);
}
function $ee61663bcaa3deaf$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ee61663bcaa3deaf$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ee61663bcaa3deaf$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $ee61663bcaa3deaf$var$_formDataSupportsSubmitter = null;
function $ee61663bcaa3deaf$var$isFormDataSubmitterSupported() {
    if ($ee61663bcaa3deaf$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ee61663bcaa3deaf$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ee61663bcaa3deaf$var$_formDataSupportsSubmitter = true;
    }
    return $ee61663bcaa3deaf$var$_formDataSupportsSubmitter;
}
var $ee61663bcaa3deaf$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ee61663bcaa3deaf$var$getFormEncType(encType) {
    if (encType != null && !$ee61663bcaa3deaf$var$supportedFormEncTypes.has(encType)) {
        $ee61663bcaa3deaf$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$ee61663bcaa3deaf$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $ee61663bcaa3deaf$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ee61663bcaa3deaf$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $ee61663bcaa3deaf$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $ee61663bcaa3deaf$var$defaultMethod;
        encType = $ee61663bcaa3deaf$var$getFormEncType(target.getAttribute("enctype")) || $ee61663bcaa3deaf$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ee61663bcaa3deaf$var$isButtonElement(target) || $ee61663bcaa3deaf$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $ee61663bcaa3deaf$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ee61663bcaa3deaf$var$defaultMethod;
        encType = $ee61663bcaa3deaf$var$getFormEncType(target.getAttribute("formenctype")) || $ee61663bcaa3deaf$var$getFormEncType(form.getAttribute("enctype")) || $ee61663bcaa3deaf$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$ee61663bcaa3deaf$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ee61663bcaa3deaf$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $ee61663bcaa3deaf$var$defaultMethod;
        action = null;
        encType = $ee61663bcaa3deaf$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $ee61663bcaa3deaf$var$HOLE = -1;
var $ee61663bcaa3deaf$var$NAN = -2;
var $ee61663bcaa3deaf$var$NEGATIVE_INFINITY = -3;
var $ee61663bcaa3deaf$var$NEGATIVE_ZERO = -4;
var $ee61663bcaa3deaf$var$NULL = -5;
var $ee61663bcaa3deaf$var$POSITIVE_INFINITY = -6;
var $ee61663bcaa3deaf$var$UNDEFINED = -7;
var $ee61663bcaa3deaf$var$TYPE_BIGINT = "B";
var $ee61663bcaa3deaf$var$TYPE_DATE = "D";
var $ee61663bcaa3deaf$var$TYPE_ERROR = "E";
var $ee61663bcaa3deaf$var$TYPE_MAP = "M";
var $ee61663bcaa3deaf$var$TYPE_NULL_OBJECT = "N";
var $ee61663bcaa3deaf$var$TYPE_PROMISE = "P";
var $ee61663bcaa3deaf$var$TYPE_REGEXP = "R";
var $ee61663bcaa3deaf$var$TYPE_SET = "S";
var $ee61663bcaa3deaf$var$TYPE_SYMBOL = "Y";
var $ee61663bcaa3deaf$var$TYPE_URL = "U";
var $ee61663bcaa3deaf$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $ee61663bcaa3deaf$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $ee61663bcaa3deaf$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $ee61663bcaa3deaf$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $ee61663bcaa3deaf$var$UNDEFINED;
    if (input === null) return $ee61663bcaa3deaf$var$NULL;
    if (Number.isNaN(input)) return $ee61663bcaa3deaf$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $ee61663bcaa3deaf$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $ee61663bcaa3deaf$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $ee61663bcaa3deaf$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $ee61663bcaa3deaf$var$stringify.call(this, input, index);
    return index;
}
function $ee61663bcaa3deaf$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$ee61663bcaa3deaf$var$flatten.call(this, k)}":${$ee61663bcaa3deaf$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$ee61663bcaa3deaf$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$ee61663bcaa3deaf$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $ee61663bcaa3deaf$var$flatten.call(this, input2[i]) : $ee61663bcaa3deaf$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$ee61663bcaa3deaf$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $ee61663bcaa3deaf$var$flatten.call(this, k),
                                    $ee61663bcaa3deaf$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$ee61663bcaa3deaf$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($ee61663bcaa3deaf$var$isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$ee61663bcaa3deaf$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$ee61663bcaa3deaf$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $ee61663bcaa3deaf$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $ee61663bcaa3deaf$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $ee61663bcaa3deaf$var$objectProtoNames;
}
// vendor/turbo-stream-v2/unflatten.ts
var $ee61663bcaa3deaf$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $ee61663bcaa3deaf$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $ee61663bcaa3deaf$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $ee61663bcaa3deaf$var$hydrate.call(this, startIndex);
}
function $ee61663bcaa3deaf$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $ee61663bcaa3deaf$var$UNDEFINED:
                set(void 0);
                continue;
            case $ee61663bcaa3deaf$var$NULL:
                set(null);
                continue;
            case $ee61663bcaa3deaf$var$NAN:
                set(NaN);
                continue;
            case $ee61663bcaa3deaf$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $ee61663bcaa3deaf$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $ee61663bcaa3deaf$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $ee61663bcaa3deaf$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $ee61663bcaa3deaf$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $ee61663bcaa3deaf$var$globalObj && $ee61663bcaa3deaf$var$globalObj[errorType] ? new $ee61663bcaa3deaf$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $ee61663bcaa3deaf$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $ee61663bcaa3deaf$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $ee61663bcaa3deaf$var$decode(readable, options) {
    const { plugins: plugins } = options !== null && options !== void 0 ? options : {};
    const done = new $ee61663bcaa3deaf$var$Deferred2();
    const reader = readable.pipeThrough($ee61663bcaa3deaf$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $ee61663bcaa3deaf$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $ee61663bcaa3deaf$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $ee61663bcaa3deaf$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $ee61663bcaa3deaf$var$unflatten.call(this, line)
    };
}
async function $ee61663bcaa3deaf$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $ee61663bcaa3deaf$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $ee61663bcaa3deaf$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $ee61663bcaa3deaf$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $ee61663bcaa3deaf$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $ee61663bcaa3deaf$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options !== null && options !== void 0 ? options : {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $ee61663bcaa3deaf$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $ee61663bcaa3deaf$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$ee61663bcaa3deaf$var$TYPE_PROMISE}${deferredId}:[["${$ee61663bcaa3deaf$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$ee61663bcaa3deaf$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$ee61663bcaa3deaf$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $ee61663bcaa3deaf$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$ee61663bcaa3deaf$var$TYPE_ERROR}${deferredId}:[["${$ee61663bcaa3deaf$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$ee61663bcaa3deaf$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$ee61663bcaa3deaf$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $ee61663bcaa3deaf$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $ee61663bcaa3deaf$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $ee61663bcaa3deaf$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $ee61663bcaa3deaf$export$4cf11838cdc2a8a8(html) {
    return html.replace($ee61663bcaa3deaf$var$ESCAPE_REGEX, (match)=>$ee61663bcaa3deaf$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $ee61663bcaa3deaf$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $ee61663bcaa3deaf$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $ee61663bcaa3deaf$var$SingleFetchNoResultError = class extends Error {
};
var $ee61663bcaa3deaf$export$ae9272e641ead836 = 202;
var $ee61663bcaa3deaf$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $ee61663bcaa3deaf$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $ieaan.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$ee61663bcaa3deaf$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, scriptTag, /* @__PURE__ */ $ieaan.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, scriptTag, /* @__PURE__ */ $ieaan.createElement($ieaan.Suspense, null, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $ee61663bcaa3deaf$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $ee61663bcaa3deaf$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $ee61663bcaa3deaf$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule === null || routeModule === void 0 ? void 0 : routeModule.shouldRevalidate)
        };
    }, $ee61663bcaa3deaf$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $ee61663bcaa3deaf$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $ee61663bcaa3deaf$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $ee61663bcaa3deaf$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $ee61663bcaa3deaf$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $ee61663bcaa3deaf$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $ee61663bcaa3deaf$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $ee61663bcaa3deaf$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $ee61663bcaa3deaf$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($ee61663bcaa3deaf$export$3f1eb41d9a6a6a27(result.result) || $ee61663bcaa3deaf$export$972111febbeef05b(result.result) || $ee61663bcaa3deaf$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $ee61663bcaa3deaf$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $ee61663bcaa3deaf$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $ee61663bcaa3deaf$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $ee61663bcaa3deaf$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$ee61663bcaa3deaf$var$createDeferred2());
    let singleFetchDfd = $ee61663bcaa3deaf$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $ee61663bcaa3deaf$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $ee61663bcaa3deaf$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $ee61663bcaa3deaf$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $ee61663bcaa3deaf$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    var _results_match_route_id;
                    middlewareError = routeResult.error;
                    if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $ee61663bcaa3deaf$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $ee61663bcaa3deaf$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $ee61663bcaa3deaf$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $ee61663bcaa3deaf$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $ee61663bcaa3deaf$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $ee61663bcaa3deaf$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $ee61663bcaa3deaf$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $ee61663bcaa3deaf$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $ee61663bcaa3deaf$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $ee61663bcaa3deaf$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $ee61663bcaa3deaf$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $ee61663bcaa3deaf$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $ee61663bcaa3deaf$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($ee61663bcaa3deaf$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $ee61663bcaa3deaf$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $ee61663bcaa3deaf$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($ee61663bcaa3deaf$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$ee61663bcaa3deaf$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
            $ee61663bcaa3deaf$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $ee61663bcaa3deaf$export$4023ad4ecd4126a2(body, global) {
    return $ee61663bcaa3deaf$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $ee61663bcaa3deaf$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$ee61663bcaa3deaf$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $ee61663bcaa3deaf$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $ee61663bcaa3deaf$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $ee61663bcaa3deaf$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $ee61663bcaa3deaf$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $ee61663bcaa3deaf$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $ee61663bcaa3deaf$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $ee61663bcaa3deaf$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        var _module_links;
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    let preloads = $ee61663bcaa3deaf$var$getModuleLinkHrefs(matches, manifest);
    return $ee61663bcaa3deaf$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $ee61663bcaa3deaf$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $ee61663bcaa3deaf$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $ee61663bcaa3deaf$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($ee61663bcaa3deaf$var$prefetchStyleLink));
}
async function $ee61663bcaa3deaf$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$ee61663bcaa3deaf$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$ee61663bcaa3deaf$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$ee61663bcaa3deaf$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($ee61663bcaa3deaf$var$prefetchStyleLink));
}
async function $ee61663bcaa3deaf$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $ee61663bcaa3deaf$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $ee61663bcaa3deaf$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $ee61663bcaa3deaf$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $ee61663bcaa3deaf$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $ee61663bcaa3deaf$var$dedupeLinkDescriptors(links.flat(1).filter($ee61663bcaa3deaf$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $ee61663bcaa3deaf$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $ee61663bcaa3deaf$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $ee61663bcaa3deaf$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $ee61663bcaa3deaf$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $ee61663bcaa3deaf$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $ee61663bcaa3deaf$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$ee61663bcaa3deaf$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($ee61663bcaa3deaf$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $ee61663bcaa3deaf$var$_isPreloadSupported;
function $ee61663bcaa3deaf$var$isPreloadSupported() {
    if ($ee61663bcaa3deaf$var$_isPreloadSupported !== void 0) return $ee61663bcaa3deaf$var$_isPreloadSupported;
    let el = document.createElement("link");
    $ee61663bcaa3deaf$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $ee61663bcaa3deaf$var$_isPreloadSupported;
}
function $ee61663bcaa3deaf$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $ee61663bcaa3deaf$export$945fecf35a8ef089 ? /* @__PURE__ */ $ieaan.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $ee61663bcaa3deaf$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $ee61663bcaa3deaf$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $ee61663bcaa3deaf$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $ee61663bcaa3deaf$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$RemixRootDefaultErrorBoundary, {
            error: $ee61663bcaa3deaf$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $ieaan.createElement(routeModule.Layout, null, /* @__PURE__ */ $ieaan.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $ieaan.createElement(routeModule.Layout, null, /* @__PURE__ */ $ieaan.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $ieaan.createElement(routeModule.Layout, null, /* @__PURE__ */ $ieaan.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $ee61663bcaa3deaf$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $ee61663bcaa3deaf$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $ee61663bcaa3deaf$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$ee61663bcaa3deaf$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $ee61663bcaa3deaf$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $ee61663bcaa3deaf$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $ee61663bcaa3deaf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $ee61663bcaa3deaf$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $ee61663bcaa3deaf$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $ee61663bcaa3deaf$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $ee61663bcaa3deaf$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $ee61663bcaa3deaf$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $ee61663bcaa3deaf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $ee61663bcaa3deaf$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $ee61663bcaa3deaf$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $ee61663bcaa3deaf$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $ee61663bcaa3deaf$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$ee61663bcaa3deaf$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $ee61663bcaa3deaf$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $ee61663bcaa3deaf$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            async serverLoader () {
                                $ee61663bcaa3deaf$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $ee61663bcaa3deaf$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $ee61663bcaa3deaf$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $ee61663bcaa3deaf$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        async serverAction () {
                            $ee61663bcaa3deaf$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $ee61663bcaa3deaf$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $ee61663bcaa3deaf$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $ee61663bcaa3deaf$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $ee61663bcaa3deaf$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $ee61663bcaa3deaf$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $ee61663bcaa3deaf$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $ee61663bcaa3deaf$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $ee61663bcaa3deaf$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $ee61663bcaa3deaf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $ee61663bcaa3deaf$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $ee61663bcaa3deaf$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $ee61663bcaa3deaf$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $ee61663bcaa3deaf$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $ee61663bcaa3deaf$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $ee61663bcaa3deaf$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $ee61663bcaa3deaf$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $ee61663bcaa3deaf$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $ee61663bcaa3deaf$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $ee61663bcaa3deaf$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $ee61663bcaa3deaf$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $ee61663bcaa3deaf$var$nextPaths = /* @__PURE__ */ new Set();
var $ee61663bcaa3deaf$var$discoveredPathsMaxSize = 1e3;
var $ee61663bcaa3deaf$var$discoveredPaths = /* @__PURE__ */ new Set();
var $ee61663bcaa3deaf$var$URL_LIMIT = 7680;
function $ee61663bcaa3deaf$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $ee61663bcaa3deaf$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $ee61663bcaa3deaf$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $ee61663bcaa3deaf$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$ee61663bcaa3deaf$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($ee61663bcaa3deaf$var$discoveredPaths.has(path)) return;
        await $ee61663bcaa3deaf$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $ee61663bcaa3deaf$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $ieaan.useEffect(()=>{
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!$ee61663bcaa3deaf$var$isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$ee61663bcaa3deaf$var$discoveredPaths.has(pathname)) $ee61663bcaa3deaf$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($ee61663bcaa3deaf$var$nextPaths.keys()).filter((path)=>{
                if ($ee61663bcaa3deaf$var$discoveredPaths.has(path)) {
                    $ee61663bcaa3deaf$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $ee61663bcaa3deaf$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $ee61663bcaa3deaf$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $ee61663bcaa3deaf$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $ee61663bcaa3deaf$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $ee61663bcaa3deaf$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($ee61663bcaa3deaf$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $ee61663bcaa3deaf$var$URL_LIMIT) {
        $ee61663bcaa3deaf$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($ee61663bcaa3deaf$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($ee61663bcaa3deaf$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($ee61663bcaa3deaf$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$ee61663bcaa3deaf$var$addToFifoQueue(p, $ee61663bcaa3deaf$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $ee61663bcaa3deaf$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $ee61663bcaa3deaf$var$addToFifoQueue(path, queue) {
    if (queue.size >= $ee61663bcaa3deaf$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $ee61663bcaa3deaf$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $ee61663bcaa3deaf$var$useDataRouterContext2() {
    let context = $ieaan.useContext($ee61663bcaa3deaf$export$2eeee58951ff3c1c);
    $ee61663bcaa3deaf$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $ee61663bcaa3deaf$var$useDataRouterStateContext() {
    let context = $ieaan.useContext($ee61663bcaa3deaf$export$315e3ffb01f217);
    $ee61663bcaa3deaf$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $ee61663bcaa3deaf$export$208d6a3bc3aa62bd = $ieaan.createContext(void 0);
$ee61663bcaa3deaf$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $ee61663bcaa3deaf$var$useFrameworkContext() {
    let context = $ieaan.useContext($ee61663bcaa3deaf$export$208d6a3bc3aa62bd);
    $ee61663bcaa3deaf$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $ee61663bcaa3deaf$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $ieaan.useContext($ee61663bcaa3deaf$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $ieaan.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $ieaan.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $ieaan.useRef(null);
    $ieaan.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $ieaan.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $ee61663bcaa3deaf$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $ee61663bcaa3deaf$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $ee61663bcaa3deaf$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $ee61663bcaa3deaf$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $ee61663bcaa3deaf$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $ee61663bcaa3deaf$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $ee61663bcaa3deaf$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$ee61663bcaa3deaf$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $ee61663bcaa3deaf$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $ee61663bcaa3deaf$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $ee61663bcaa3deaf$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $ee61663bcaa3deaf$var$useDataRouterStateContext();
    let matches = $ee61663bcaa3deaf$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $ieaan.useMemo(()=>$ee61663bcaa3deaf$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $ieaan.createElement("style", {
        [$ee61663bcaa3deaf$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $ieaan.createElement("link", {
        [$ee61663bcaa3deaf$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$ee61663bcaa3deaf$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $ieaan.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $ee61663bcaa3deaf$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $ee61663bcaa3deaf$var$useDataRouterContext2();
    let matches = $ieaan.useMemo(()=>$ee61663bcaa3deaf$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $ee61663bcaa3deaf$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $ee61663bcaa3deaf$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $ieaan.useState([]);
    $ieaan.useEffect(()=>{
        let interrupted = false;
        $ee61663bcaa3deaf$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $ee61663bcaa3deaf$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $ee61663bcaa3deaf$var$useFrameworkContext();
    let { basename: basename } = $ee61663bcaa3deaf$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $ee61663bcaa3deaf$var$useDataRouterStateContext();
    let newMatchesForData = $ieaan.useMemo(()=>$ee61663bcaa3deaf$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $ieaan.useMemo(()=>$ee61663bcaa3deaf$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $ieaan.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            var _routeModules_m_route_id;
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $ee61663bcaa3deaf$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $ieaan.useMemo(()=>$ee61663bcaa3deaf$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $ee61663bcaa3deaf$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $ieaan.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $ieaan.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $ieaan.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $ee61663bcaa3deaf$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $ee61663bcaa3deaf$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $ee61663bcaa3deaf$var$useDataRouterStateContext();
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let _matches = $ee61663bcaa3deaf$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$ee61663bcaa3deaf$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $ieaan.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $ieaan.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $ieaan.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $ieaan.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $ee61663bcaa3deaf$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $ieaan.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $ee61663bcaa3deaf$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $ee61663bcaa3deaf$var$isHydrated = false;
function $ee61663bcaa3deaf$export$3be068dde909e563() {
    $ee61663bcaa3deaf$var$isHydrated = true;
}
function $ee61663bcaa3deaf$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $ee61663bcaa3deaf$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $ee61663bcaa3deaf$var$useDataRouterContext2();
    let { matches: routerMatches } = $ee61663bcaa3deaf$var$useDataRouterStateContext();
    let isRSCRouterContext = $ee61663bcaa3deaf$var$useIsRSCRouterContext();
    let enableFogOfWar = $ee61663bcaa3deaf$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $ee61663bcaa3deaf$var$getActiveMatches(routerMatches, null, isSpaMode);
    $ieaan.useEffect(()=>{
        $ee61663bcaa3deaf$export$3be068dde909e563();
    }, []);
    let initialScripts = $ieaan.useMemo(()=>{
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $ee61663bcaa3deaf$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($ee61663bcaa3deaf$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $ieaan.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $ee61663bcaa3deaf$var$isHydrated || isRSCRouterContext ? [] : $ee61663bcaa3deaf$var$dedupe(manifest.entry.imports.concat($ee61663bcaa3deaf$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $ee61663bcaa3deaf$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $ee61663bcaa3deaf$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $ieaan.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $ieaan.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $ieaan.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $ieaan.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $ee61663bcaa3deaf$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $ee61663bcaa3deaf$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $ee61663bcaa3deaf$export$32e57f52df4b6e34 = class extends $ieaan.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
};
function $ee61663bcaa3deaf$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $ieaan.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($ee61663bcaa3deaf$export$972111febbeef05b(error)) return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $ieaan.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $ee61663bcaa3deaf$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $ieaan.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $ieaan.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $ee61663bcaa3deaf$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    var _routeModules_root;
    let { routeModules: routeModules } = $ee61663bcaa3deaf$var$useFrameworkContext();
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $ieaan.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $ieaan.createElement("head", null, /* @__PURE__ */ $ieaan.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $ieaan.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $ieaan.createElement("title", null, title)), /* @__PURE__ */ $ieaan.createElement("body", null, /* @__PURE__ */ $ieaan.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$ff0bf87698939488, null) : null)));
}
var $ee61663bcaa3deaf$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($ee61663bcaa3deaf$var$isBrowser) window.__reactRouterVersion = "7.9.3";
} catch (e) {}
function $ee61663bcaa3deaf$export$1f3f55432a00e06d(routes, opts) {
    return $ee61663bcaa3deaf$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $ee61663bcaa3deaf$export$719fc203c4e16dee({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $ee61663bcaa3deaf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $ee61663bcaa3deaf$export$9269a41d8c4635e,
        hydrationRouteProperties: $ee61663bcaa3deaf$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window
    }).initialize();
}
function $ee61663bcaa3deaf$export$1ba7ed8a3a7b3765(routes, opts) {
    return $ee61663bcaa3deaf$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $ee61663bcaa3deaf$var$createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $ee61663bcaa3deaf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $ee61663bcaa3deaf$export$9269a41d8c4635e,
        hydrationRouteProperties: $ee61663bcaa3deaf$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window
    }).initialize();
}
function $ee61663bcaa3deaf$var$parseHydrationData() {
    var _window;
    let state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $ee61663bcaa3deaf$var$deserializeErrors(state.errors)
    };
    return state;
}
function $ee61663bcaa3deaf$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $ee61663bcaa3deaf$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $ee61663bcaa3deaf$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $ieaan.useRef();
    if (historyRef.current == null) historyRef.current = $ee61663bcaa3deaf$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ee61663bcaa3deaf$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $ieaan.useRef();
    if (historyRef.current == null) historyRef.current = $ee61663bcaa3deaf$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ee61663bcaa3deaf$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $ieaan.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ieaan.useCallback((newState)=>{
        $ieaan.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ieaan.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$ee61663bcaa3deaf$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $ee61663bcaa3deaf$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ee61663bcaa3deaf$export$a6c7ac8248d6e38a = $ieaan.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $ee61663bcaa3deaf$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($ee61663bcaa3deaf$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $ee61663bcaa3deaf$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $ee61663bcaa3deaf$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $ee61663bcaa3deaf$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $ee61663bcaa3deaf$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $ee61663bcaa3deaf$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $ieaan.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $ee61663bcaa3deaf$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, link, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$ee61663bcaa3deaf$export$a6c7ac8248d6e38a.displayName = "Link";
var $ee61663bcaa3deaf$export$b0d92dbee9b5b60d = $ieaan.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $ee61663bcaa3deaf$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let routerState = $ieaan.useContext($ee61663bcaa3deaf$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ee61663bcaa3deaf$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $ee61663bcaa3deaf$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$ee61663bcaa3deaf$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $ee61663bcaa3deaf$export$a7fed597f4b8afd8 = $ieaan.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $ee61663bcaa3deaf$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $ee61663bcaa3deaf$export$47c85c6e3a081d3();
    let formAction = $ee61663bcaa3deaf$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $ee61663bcaa3deaf$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $ieaan.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$ee61663bcaa3deaf$export$a7fed597f4b8afd8.displayName = "Form";
function $ee61663bcaa3deaf$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $ieaan.useContext($ee61663bcaa3deaf$export$208d6a3bc3aa62bd);
    let { basename: basename } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let matches = $ee61663bcaa3deaf$export$2378eb7f5ff86053();
    $ee61663bcaa3deaf$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $ieaan.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $ee61663bcaa3deaf$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $ieaan.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $ee61663bcaa3deaf$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$ee61663bcaa3deaf$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $ee61663bcaa3deaf$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $ee61663bcaa3deaf$var$useDataRouterContext3(hookName) {
    let ctx = $ieaan.useContext($ee61663bcaa3deaf$export$2eeee58951ff3c1c);
    $ee61663bcaa3deaf$export$f5708dca728d7177(ctx, $ee61663bcaa3deaf$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $ee61663bcaa3deaf$var$useDataRouterState2(hookName) {
    let state = $ieaan.useContext($ee61663bcaa3deaf$export$315e3ffb01f217);
    $ee61663bcaa3deaf$export$f5708dca728d7177(state, $ee61663bcaa3deaf$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $ee61663bcaa3deaf$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $ee61663bcaa3deaf$export$9770f232ac06a008();
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let path = $ee61663bcaa3deaf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $ieaan.useCallback((event)=>{
        if ($ee61663bcaa3deaf$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $ee61663bcaa3deaf$export$fe53371bee54353d(location) === $ee61663bcaa3deaf$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $ee61663bcaa3deaf$export$f1a78c17382fe22a(defaultInit) {
    $ee61663bcaa3deaf$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $ieaan.useRef($ee61663bcaa3deaf$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $ieaan.useRef(false);
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let searchParams = $ieaan.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ee61663bcaa3deaf$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $ee61663bcaa3deaf$export$9770f232ac06a008();
    let setSearchParams = $ieaan.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ee61663bcaa3deaf$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $ee61663bcaa3deaf$var$fetcherId = 0;
var $ee61663bcaa3deaf$var$getUniqueFetcherId = ()=>`__${String(++$ee61663bcaa3deaf$var$fetcherId)}__`;
function $ee61663bcaa3deaf$export$47c85c6e3a081d3() {
    let { router: router } = $ee61663bcaa3deaf$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let currentRouteId = $ee61663bcaa3deaf$var$useRouteId();
    return $ieaan.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ee61663bcaa3deaf$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ee61663bcaa3deaf$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $ee61663bcaa3deaf$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let routeContext = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    $ee61663bcaa3deaf$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$ee61663bcaa3deaf$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $ee61663bcaa3deaf$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $ee61663bcaa3deaf$export$fe53371bee54353d(path);
}
function $ee61663bcaa3deaf$export$5b0d2d9a9921565a({ key: key } = {}) {
    var _route_matches_;
    let { router: router } = $ee61663bcaa3deaf$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $ee61663bcaa3deaf$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $ieaan.useContext($ee61663bcaa3deaf$export$cb3f1df1bef00a39);
    let route = $ieaan.useContext($ee61663bcaa3deaf$export$aac280ed165a4397);
    let routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    $ee61663bcaa3deaf$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $ee61663bcaa3deaf$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $ee61663bcaa3deaf$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $ieaan.useId();
    let [fetcherKey, setFetcherKey] = $ieaan.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $ieaan.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $ieaan.useCallback(async (href, opts)=>{
        $ee61663bcaa3deaf$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ee61663bcaa3deaf$export$47c85c6e3a081d3();
    let submit = $ieaan.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let unstable_reset = $ieaan.useCallback((opts)=>router.resetFetcher(fetcherKey, opts), [
        router,
        fetcherKey
    ]);
    let FetcherForm = $ieaan.useMemo(()=>{
        let FetcherForm2 = $ieaan.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $ee61663bcaa3deaf$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $ieaan.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            unstable_reset: unstable_reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        unstable_reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $ee61663bcaa3deaf$export$fa996778a3a31087() {
    let state = $ee61663bcaa3deaf$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $ee61663bcaa3deaf$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $ee61663bcaa3deaf$var$savedScrollPositions = {};
function $ee61663bcaa3deaf$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $ee61663bcaa3deaf$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $ee61663bcaa3deaf$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $ee61663bcaa3deaf$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ee61663bcaa3deaf$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $ieaan.useContext($ee61663bcaa3deaf$export$3044ab7fdabeaee6);
    let location = $ee61663bcaa3deaf$export$45d76561a5302f2b();
    let matches = $ee61663bcaa3deaf$export$2378eb7f5ff86053();
    let navigation = $ee61663bcaa3deaf$export$d0fd4b7106de2769();
    $ieaan.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $ee61663bcaa3deaf$var$usePageHide($ieaan.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $ee61663bcaa3deaf$var$getScrollRestorationKey(location, matches, basename, getKey);
            $ee61663bcaa3deaf$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ee61663bcaa3deaf$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ee61663bcaa3deaf$var$savedScrollPositions));
        } catch (error) {
            $ee61663bcaa3deaf$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $ieaan.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ee61663bcaa3deaf$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ee61663bcaa3deaf$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $ieaan.useLayoutEffect(()=>{
            let disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration($ee61663bcaa3deaf$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$ee61663bcaa3deaf$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $ieaan.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $ee61663bcaa3deaf$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $ee61663bcaa3deaf$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $ieaan.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $ee61663bcaa3deaf$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $ieaan.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $ee61663bcaa3deaf$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $ee61663bcaa3deaf$export$b273b3273281a049(when);
    $ieaan.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $ieaan.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $ee61663bcaa3deaf$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $ieaan.useContext($ee61663bcaa3deaf$export$3681f408decb40d1);
    $ee61663bcaa3deaf$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $ee61663bcaa3deaf$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $ee61663bcaa3deaf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $ee61663bcaa3deaf$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $ee61663bcaa3deaf$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $ee61663bcaa3deaf$export$81336c211d5ff295(path.pathname, nextPath) != null || $ee61663bcaa3deaf$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $ee61663bcaa3deaf$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $ee61663bcaa3deaf$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $ee61663bcaa3deaf$var$getStatelessNavigator();
    return /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $ee61663bcaa3deaf$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $ee61663bcaa3deaf$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $ee61663bcaa3deaf$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $ee61663bcaa3deaf$var$serializeErrors(context.errors)
        };
        let json = $ee61663bcaa3deaf$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $ieaan.createElement($ieaan.Fragment, null, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $ieaan.createElement($ee61663bcaa3deaf$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $ieaan.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $ee61663bcaa3deaf$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $ee61663bcaa3deaf$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $ee61663bcaa3deaf$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($ee61663bcaa3deaf$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $ee61663bcaa3deaf$var$getStatelessNavigator() {
    return {
        createHref: $ee61663bcaa3deaf$var$createHref,
        encodeLocation: $ee61663bcaa3deaf$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $ee61663bcaa3deaf$export$69163f0b72ec60d9(routes, opts) {
    return $ee61663bcaa3deaf$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $ee61663bcaa3deaf$export$9269a41d8c4635e
    });
}
function $ee61663bcaa3deaf$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $ee61663bcaa3deaf$export$87cb1a9238dc3fba(routes, $ee61663bcaa3deaf$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts === null || opts === void 0 ? void 0 : opts.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $ee61663bcaa3deaf$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $ee61663bcaa3deaf$var$createHref,
        encodeLocation: $ee61663bcaa3deaf$var$encodeLocation,
        getFetcher () {
            return $ee61663bcaa3deaf$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $ee61663bcaa3deaf$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $ee61663bcaa3deaf$var$createHref(to) {
    return typeof to === "string" ? to : $ee61663bcaa3deaf$export$fe53371bee54353d(to);
}
function $ee61663bcaa3deaf$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $ee61663bcaa3deaf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $ee61663bcaa3deaf$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $ee61663bcaa3deaf$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ee61663bcaa3deaf$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $ee61663bcaa3deaf$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $ee61663bcaa3deaf$var$htmlEscape(str) {
    return str.replace($ee61663bcaa3deaf$var$ESCAPE_REGEX2, (match)=>$ee61663bcaa3deaf$var$ESCAPE_LOOKUP2[match]);
}







function $8fc6b500ae8ef18e$export$2e2bcd8739ae039() {
    return $8fc6b500ae8ef18e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8fc6b500ae8ef18e$export$2e2bcd8739ae039.apply(null, arguments);
}


function $c00257230a3091f0$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}


function $cc6db30d337a65d4$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $3ed251c3e75e9f55$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cc6db30d337a65d4$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $6b3e3fc36145dce1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $6b3e3fc36145dce1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6b3e3fc36145dce1$export$2e2bcd8739ae039(o);
}



function $ff6513909c1c10e4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6b3e3fc36145dce1$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6b3e3fc36145dce1$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a7dadc728a8e104$export$2e2bcd8739ae039(t) {
    var i = (0, $ff6513909c1c10e4$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $6b3e3fc36145dce1$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $c7fdd987e3d59d6d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a7dadc728a8e104$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");


var $ljfqi = parcelRequire("ljfqi");

'use strict';

var $edBaQ = parcelRequire("edBaQ");

var $8lKVU = parcelRequire("8lKVU");

var $7n9WH = parcelRequire("7n9WH");
var $fde244843a4c7d73$exports = {};
'use strict';
'use strict';

var $1XSJh = parcelRequire("1XSJh");
var $012c14068dfabf16$exports = {};
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $7n9WH = parcelRequire("7n9WH");

var $1H3Lz = parcelRequire("1H3Lz");
var $8ad092342d78a6b5$exports = {};
'use strict';

var $4LaI4 = parcelRequire("4LaI4");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$8ad092342d78a6b5$exports = function() {
    var that = $4LaI4(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


var $90e5e0320ffaa8ee$exports = {};
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $kvDzZ = parcelRequire("kvDzZ");
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $90e5e0320ffaa8ee$var$$RegExp = $kvDzZ.RegExp;
var $90e5e0320ffaa8ee$var$UNSUPPORTED_Y = $bAE3C(function() {
    var re = $90e5e0320ffaa8ee$var$$RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $90e5e0320ffaa8ee$var$MISSED_STICKY = $90e5e0320ffaa8ee$var$UNSUPPORTED_Y || $bAE3C(function() {
    return !$90e5e0320ffaa8ee$var$$RegExp('a', 'y').sticky;
});
var $90e5e0320ffaa8ee$var$BROKEN_CARET = $90e5e0320ffaa8ee$var$UNSUPPORTED_Y || $bAE3C(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $90e5e0320ffaa8ee$var$$RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
$90e5e0320ffaa8ee$exports = {
    BROKEN_CARET: $90e5e0320ffaa8ee$var$BROKEN_CARET,
    MISSED_STICKY: $90e5e0320ffaa8ee$var$MISSED_STICKY,
    UNSUPPORTED_Y: $90e5e0320ffaa8ee$var$UNSUPPORTED_Y
};



var $cITHp = parcelRequire("cITHp");

var $emiQA = parcelRequire("emiQA");

var $4eljv = parcelRequire("4eljv");
var $012c14068dfabf16$require$getInternalState = $4eljv.get;
var $92210f9b01da3453$exports = {};
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $kvDzZ = parcelRequire("kvDzZ");
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $92210f9b01da3453$var$$RegExp = $kvDzZ.RegExp;
$92210f9b01da3453$exports = $bAE3C(function() {
    var re = $92210f9b01da3453$var$$RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});


var $8872bc8151bdb9ba$exports = {};
'use strict';

var $bAE3C = parcelRequire("bAE3C");

var $kvDzZ = parcelRequire("kvDzZ");
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $8872bc8151bdb9ba$var$$RegExp = $kvDzZ.RegExp;
$8872bc8151bdb9ba$exports = $bAE3C(function() {
    var re = $8872bc8151bdb9ba$var$$RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});


var $012c14068dfabf16$var$nativeReplace = $cITHp('native-string-replace', String.prototype.replace);
var $012c14068dfabf16$var$nativeExec = RegExp.prototype.exec;
var $012c14068dfabf16$var$patchedExec = $012c14068dfabf16$var$nativeExec;
var $012c14068dfabf16$var$charAt = $7n9WH(''.charAt);
var $012c14068dfabf16$var$indexOf = $7n9WH(''.indexOf);
var $012c14068dfabf16$var$replace = $7n9WH(''.replace);
var $012c14068dfabf16$var$stringSlice = $7n9WH(''.slice);
var $012c14068dfabf16$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $8lKVU($012c14068dfabf16$var$nativeExec, re1, 'a');
    $8lKVU($012c14068dfabf16$var$nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $012c14068dfabf16$var$UNSUPPORTED_Y = $90e5e0320ffaa8ee$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $012c14068dfabf16$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $012c14068dfabf16$var$PATCH = $012c14068dfabf16$var$UPDATES_LAST_INDEX_WRONG || $012c14068dfabf16$var$NPCG_INCLUDED || $012c14068dfabf16$var$UNSUPPORTED_Y || $92210f9b01da3453$exports || $8872bc8151bdb9ba$exports;
if ($012c14068dfabf16$var$PATCH) $012c14068dfabf16$var$patchedExec = function exec(string) {
    var re = this;
    var state = $012c14068dfabf16$require$getInternalState(re);
    var str = $1H3Lz(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $8lKVU($012c14068dfabf16$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $012c14068dfabf16$var$UNSUPPORTED_Y && re.sticky;
    var flags = $8lKVU($8ad092342d78a6b5$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $012c14068dfabf16$var$replace(flags, 'y', '');
        if ($012c14068dfabf16$var$indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = $012c14068dfabf16$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $012c14068dfabf16$var$charAt(str, re.lastIndex - 1) !== '\n')) {
            source = '(?: ' + source + ')';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if ($012c14068dfabf16$var$NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if ($012c14068dfabf16$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $8lKVU($012c14068dfabf16$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $012c14068dfabf16$var$stringSlice(match.input, charsAdded);
            match[0] = $012c14068dfabf16$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($012c14068dfabf16$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($012c14068dfabf16$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $8lKVU($012c14068dfabf16$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $emiQA(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$012c14068dfabf16$exports = $012c14068dfabf16$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$1XSJh({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== $012c14068dfabf16$exports
}, {
    exec: $012c14068dfabf16$exports
});



var $8lKVU = parcelRequire("8lKVU");

var $2t4Gp = parcelRequire("2t4Gp");


var $bAE3C = parcelRequire("bAE3C");

var $mgvTx = parcelRequire("mgvTx");

var $aPaKH = parcelRequire("aPaKH");
var $fde244843a4c7d73$var$SPECIES = $mgvTx('species');
var $fde244843a4c7d73$var$RegExpPrototype = RegExp.prototype;
$fde244843a4c7d73$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $mgvTx(KEY);
    var DELEGATES_TO_SYMBOL = !$bAE3C(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$bAE3C(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$fde244843a4c7d73$var$SPECIES] = function() {
                return re;
            };
            re.flags = '';
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $012c14068dfabf16$exports || $exec === $fde244843a4c7d73$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $8lKVU(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $8lKVU(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $2t4Gp(String.prototype, KEY, methods[0]);
        $2t4Gp($fde244843a4c7d73$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $aPaKH($fde244843a4c7d73$var$RegExpPrototype[SYMBOL], 'sham', true);
};



var $bAE3C = parcelRequire("bAE3C");

var $4LaI4 = parcelRequire("4LaI4");

var $1ZKCr = parcelRequire("1ZKCr");

var $hKX7u = parcelRequire("hKX7u");

var $hXJr0 = parcelRequire("hXJr0");

var $dgesD = parcelRequire("dgesD");

var $1H3Lz = parcelRequire("1H3Lz");

var $388Wm = parcelRequire("388Wm");
var $763d04c6034731a1$exports = {};
'use strict';

var $hkAQY = parcelRequire("hkAQY");
var $763d04c6034731a1$require$charAt = $hkAQY.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$763d04c6034731a1$exports = function(S, index, unicode) {
    return index + (unicode ? $763d04c6034731a1$require$charAt(S, index).length : 1);
};



var $eZ5qV = parcelRequire("eZ5qV");
var $f211dfce295455b5$exports = {};
'use strict';

var $7n9WH = parcelRequire("7n9WH");

var $hicPf = parcelRequire("hicPf");
var $f211dfce295455b5$var$floor = Math.floor;
var $f211dfce295455b5$var$charAt = $7n9WH(''.charAt);
var $f211dfce295455b5$var$replace = $7n9WH(''.replace);
var $f211dfce295455b5$var$stringSlice = $7n9WH(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $f211dfce295455b5$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $f211dfce295455b5$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$f211dfce295455b5$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $f211dfce295455b5$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $hicPf(namedCaptures);
        symbols = $f211dfce295455b5$var$SUBSTITUTION_SYMBOLS;
    }
    return $f211dfce295455b5$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($f211dfce295455b5$var$charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return $f211dfce295455b5$var$stringSlice(str, 0, position);
            case "'":
                return $f211dfce295455b5$var$stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[$f211dfce295455b5$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $f211dfce295455b5$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $f211dfce295455b5$var$charAt(ch, 1) : captures[f - 1] + $f211dfce295455b5$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};


var $07e85df7cdcd6a85$exports = {};
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $4LaI4 = parcelRequire("4LaI4");

var $1ZKCr = parcelRequire("1ZKCr");

var $fcHE3 = parcelRequire("fcHE3");

var $07e85df7cdcd6a85$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$07e85df7cdcd6a85$exports = function(R, S) {
    var exec = R.exec;
    if ($1ZKCr(exec)) {
        var result = $8lKVU(exec, R, S);
        if (result !== null) $4LaI4(result);
        return result;
    }
    if ($fcHE3(R) === 'RegExp') return $8lKVU($012c14068dfabf16$exports, R, S);
    throw new $07e85df7cdcd6a85$var$$TypeError('RegExp#exec called on incompatible receiver');
};



var $mgvTx = parcelRequire("mgvTx");
var $0500853f9bdbe87f$var$REPLACE = $mgvTx('replace');
var $0500853f9bdbe87f$var$max = Math.max;
var $0500853f9bdbe87f$var$min = Math.min;
var $0500853f9bdbe87f$var$concat = $7n9WH([].concat);
var $0500853f9bdbe87f$var$push = $7n9WH([].push);
var $0500853f9bdbe87f$var$stringIndexOf = $7n9WH(''.indexOf);
var $0500853f9bdbe87f$var$stringSlice = $7n9WH(''.slice);
var $0500853f9bdbe87f$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $0500853f9bdbe87f$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $0500853f9bdbe87f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$0500853f9bdbe87f$var$REPLACE]) return /./[$0500853f9bdbe87f$var$REPLACE]('a', '$0') === '';
    return false;
}();
var $0500853f9bdbe87f$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$bAE3C(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
$fde244843a4c7d73$exports('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $0500853f9bdbe87f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $388Wm(this);
            var replacer = $hKX7u(searchValue) ? undefined : $eZ5qV(searchValue, $0500853f9bdbe87f$var$REPLACE);
            return replacer ? $8lKVU(replacer, searchValue, O, replaceValue) : $8lKVU(nativeReplace, $1H3Lz(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $4LaI4(this);
            var S = $1H3Lz(string);
            if (typeof replaceValue == 'string' && $0500853f9bdbe87f$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $0500853f9bdbe87f$var$stringIndexOf(replaceValue, '$<') === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $1ZKCr(replaceValue);
            if (!functionalReplace) replaceValue = $1H3Lz(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $07e85df7cdcd6a85$exports(rx, S);
                if (result === null) break;
                $0500853f9bdbe87f$var$push(results, result);
                if (!global) break;
                var matchStr = $1H3Lz(result[0]);
                if (matchStr === '') rx.lastIndex = $763d04c6034731a1$exports(S, $dgesD(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $1H3Lz(result[0]);
                var position = $0500853f9bdbe87f$var$max($0500853f9bdbe87f$var$min($hXJr0(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$0500853f9bdbe87f$var$push(captures, $0500853f9bdbe87f$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $0500853f9bdbe87f$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $0500853f9bdbe87f$var$push(replacerArgs, namedCaptures);
                    replacement = $1H3Lz($edBaQ(replaceValue, undefined, replacerArgs));
                } else replacement = $f211dfce295455b5$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $0500853f9bdbe87f$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $0500853f9bdbe87f$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$0500853f9bdbe87f$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$0500853f9bdbe87f$var$REPLACE_KEEPS_$0 || $0500853f9bdbe87f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);



var $ieaan = parcelRequire("ieaan");
const $07b61efe40a5ad0e$export$9824d860d0b120d9 = 'nb-NO';
const $07b61efe40a5ad0e$export$ebe860a2db7990ad = 'NOK';
const $07b61efe40a5ad0e$export$dfbea0c7aa245503 = 'code';
const $07b61efe40a5ad0e$export$5cd3cf0adfc46395 = 'NO';



var $760f6e735ba35488$export$2e2bcd8739ae039 = {
    'nb-NO': {
        TextCounter: {
            characterDown: "%count av %max tegn gjenst\xe5r.",
            characterUp: 'Du har brukt %count av %max tegn.',
            characterExceeded: "%count tegn over grensen p\xe5 %max."
        },
        TimelineItem: {
            alt_label_completed: "Utf\xf8rt",
            alt_label_current: "N\xe5v\xe6rende",
            alt_label_upcoming: 'Kommende'
        },
        Breadcrumb: {
            navText: 'Sidehierarki',
            goBackText: 'Tilbake',
            homeText: 'Hjem',
            backToText: 'Tilbake til...'
        },
        DateFormat: {
            invalidDate: 'Ugyldig dato: {value}'
        },
        DatePicker: {
            day: 'dag',
            month: "m\xe5ned",
            year: "\xe5r",
            start: 'fra',
            end: 'til',
            selectedDate: 'Valgt dato: %s',
            selectedDateRange: 'Valgte datoer: %s',
            selectedMonth: "Valgt m\xe5ned %s",
            selectedYear: "Valgt \xe5r %s",
            nextMonth: "Neste m\xe5ned %s",
            prevMonth: "Forrige m\xe5ned %s",
            nextYear: "Neste \xe5r %s",
            prevYear: "Forrige \xe5r %s",
            openPickerText: "\xc5pne datovelger",
            maskOrder: 'dd/mm/yyyy',
            maskPlaceholder: "dd.mm.\xe5\xe5\xe5\xe5",
            dateFormat: 'yyyy-MM-dd',
            returnFormat: 'yyyy-MM-dd',
            firstDay: 'monday',
            submitButtonText: 'Ok',
            cancelButtonText: 'Avbryt',
            resetButtonText: 'Nullstill',
            placeholderCharacters: {
                day: 'd',
                month: 'm',
                year: "\xe5"
            }
        },
        Anchor: {
            targetBlankTitle: "\xc5pner et nytt vindu"
        },
        GlobalStatus: {
            default_title: 'En feil har skjedd',
            close_text: 'Lukk',
            status_anchor_text: "G\xe5 til %s"
        },
        GlobalError: {
            404: {
                title: "Vi finner ikke siden du leter etter \u2026",
                text: "Sikker p\xe5 at du har skrevet riktig adresse? Eller har vi rotet med lenkene?"
            },
            500: {
                title: 'Beklager, her skjedde det noe feil!',
                text: "Tjenesten fungerer ikke slik den skal for \xf8yeblikket, men pr\xf8v igjen senere."
            },
            code: 'Feilmeldings-kode:',
            errorMessageCode: 'Feilmeldings-kode: %statusCode',
            help: 'Her er noen lenker som kanskje kan hjelpe:'
        },
        ProgressIndicator: {
            indicator_label: 'Vennligst vent ...'
        },
        Dropdown: {
            title: 'Valgmeny'
        },
        Autocomplete: {
            title: 'Skriv og velg',
            submit_button_title: 'Vis alternativer',
            no_options: 'Ingen alternativer',
            show_all: 'Vis alt',
            show_options_sr: 'Bla gjennom alternativer, lukk med esc knappen',
            aria_live_options: '%s alternativer',
            selected_sr: 'Valgt:',
            indicator_label: 'Henter data ...'
        },
        Modal: {
            dialog_title: 'Separat Vindu',
            close_title: 'Lukk'
        },
        Dialog: {
            declineText: 'Avbryt',
            confirmText: 'Godta'
        },
        CopyOnClick: {
            clipboard_copy: 'Kopiert'
        },
        NumberFormat: {
            clipboard_copy: 'Kopiert',
            not_available: 'Ikke tilgjengelig'
        },
        HelpButton: {
            title: 'Hjelpetekst',
            aria_role: 'Hjelp-knapp'
        },
        Input: {
            submit_button_title: 'Send knapp',
            clear_button_title: 'Nullstill'
        },
        Pagination: {
            button_title: 'Side %s',
            next_title: 'Neste side',
            prev_title: 'Forrige side',
            more_pages: '%s flere sider',
            is_loading_text: 'Laster nytt innhold',
            load_button_text: 'Vis mer innhold'
        },
        Skeleton: {
            aria_busy: 'Behandler data ...',
            aria_ready: "Klar til \xe5 samhandle"
        },
        StepIndicator: {
            overview_title: 'Stegoversikt',
            step_title: 'Steg %step av %count:'
        },
        Slider: {
            addTitle: "\xd8k (%s)",
            subtractTitle: 'Reduser (%s)'
        },
        PaymentCard: {
            text_card_number: 'Kortnummer',
            text_blocked: 'Sperret',
            text_expired: "Utl\xf8pt",
            text_not_active: 'Inaktivt',
            text_new_order: 'Bestilt',
            text_order_in_process: "P\xe5 vei",
            text_replaced: 'Erstattet',
            text_renewed: 'Fornyes',
            text_new: 'Nytt',
            text_unknown: 'Ukjent'
        },
        Tag: {
            removeIconTitle: 'Fjern',
            addIconTitle: 'Legg til'
        },
        Table: {
            accordionToggleButtonSR: 'Vis mer innhold',
            accordionMoreContentSR: 'Mer innhold i neste rad',
            navigationButtonSR: 'Naviger til mer innhold'
        },
        Upload: {
            title: 'Last opp dokumenter',
            text: 'Dra og slipp eller velg hvilke filer du vil laste opp.',
            textSingular: 'Dra og slipp eller velg hvilken fil du vil laste opp.',
            fileTypeTableCaption: "Tillatte filformater og maks filst\xf8rrelse",
            fileTypeDescription: 'Tillatte filformater:',
            fileSizeDescription: "Maks filst\xf8rrelse:",
            fileAmountDescription: 'Maks antall filer:',
            fileSizeContent: '%size MB',
            buttonText: 'Velg filer',
            buttonTextSingular: 'Velg fil',
            loadingText: 'Laster',
            errorLargeFile: "Filen du pr\xf8ver \xe5 laste opp er for stor, den maksimale st\xf8ttede st\xf8rrelsen er %size MB.",
            errorAmountLimit: 'Det er begrenset hvor mange filer du kan laste opp (%amount).',
            errorUnsupportedFile: "Filen du pr\xf8ver \xe5 laste opp er ikke st\xf8ttet.",
            deleteButton: 'Slett',
            fileListAriaLabel: 'opplastede filer'
        }
    }
};


var $d904a064453aaabf$export$2e2bcd8739ae039 = {
    'en-GB': {
        TextCounter: {
            characterDown: '%count of %max characters remaining.',
            characterUp: 'You have used %count of %max characters.',
            characterExceeded: '%count characters over the limit of %max.'
        },
        TimelineItem: {
            alt_label_completed: 'Completed',
            alt_label_current: 'Current',
            alt_label_upcoming: 'Upcoming'
        },
        Breadcrumb: {
            navText: 'Page hierarchy',
            goBackText: 'Back',
            homeText: 'Home',
            backToText: 'Back to...'
        },
        DateFormat: {
            invalidDate: 'Invalid date: {value}'
        },
        DatePicker: {
            day: 'Day',
            month: 'Month',
            year: 'Year',
            start: 'from',
            end: 'to',
            selectedDate: 'Selected date: %s',
            selectedDateRange: 'Selected dates: %s',
            selectedMonth: 'Selected month %s',
            selectedYear: 'Selected year %s',
            nextMonth: 'Next month %s',
            prevMonth: 'Previous month %s',
            nextYear: 'Next year %s',
            prevYear: 'Previous year %s',
            openPickerText: 'Open date picker',
            maskOrder: 'dd/mm/yyyy',
            maskPlaceholder: 'dd/mm/yyyy',
            dateFormat: 'yyyy-MM-dd',
            returnFormat: 'yyyy-MM-dd',
            firstDay: 'monday',
            submitButtonText: 'OK',
            cancelButtonText: 'Cancel',
            resetButtonText: 'Reset',
            placeholderCharacters: {
                day: 'd',
                month: 'm',
                year: 'y'
            }
        },
        Anchor: {
            targetBlankTitle: 'Opens a new Window'
        },
        GlobalStatus: {
            default_title: 'An error has occurred',
            close_text: 'Close',
            status_anchor_text: 'Go to %s'
        },
        GlobalError: {
            404: {
                title: "We can't find the page you're looking for \u2026",
                text: 'Are you sure you have entered the correct address? Or have we messed with the links?'
            },
            500: {
                title: 'Sorry, a technical error happened!',
                text: 'The service is not working properly at the moment. Try again later.'
            },
            code: 'Error code:',
            errorMessageCode: 'Error code: %statusCode',
            help: 'Here are some links that might help:'
        },
        ProgressIndicator: {
            indicator_label: 'Please wait ...'
        },
        Dropdown: {
            title: 'Option Menu'
        },
        Autocomplete: {
            title: 'Type and select',
            submit_button_title: 'Show options',
            no_options: 'No option',
            show_all: 'Show everything',
            show_options_sr: 'Browse options, close with esc button',
            aria_live_options: '%s options',
            selected_sr: 'Selected:',
            indicator_label: 'Getting data ...'
        },
        Modal: {
            dialog_title: 'Dialog Window',
            close_title: 'Close'
        },
        Dialog: {
            declineText: 'Cancel',
            confirmText: 'Approve'
        },
        CopyOnClick: {
            clipboard_copy: 'Copied'
        },
        NumberFormat: {
            clipboard_copy: 'Copied',
            not_available: 'Not available'
        },
        HelpButton: {
            title: 'Help text',
            aria_role: 'Help button'
        },
        Skeleton: {
            aria_busy: 'In progress ...',
            aria_ready: 'Ready to interact'
        },
        Input: {
            submit_button_title: 'Submit button',
            clear_button_title: 'Clear value'
        },
        Pagination: {
            button_title: 'Page %s',
            next_title: 'Next page',
            prev_title: 'Previous page',
            more_pages: '%s more pages',
            is_loading_text: 'Loading new content',
            load_button_text: 'Show more content'
        },
        StepIndicator: {
            overview_title: 'Steps Overview',
            step_title: 'Step %step of %count:'
        },
        Slider: {
            addTitle: 'Increase (%s)',
            subtractTitle: 'Decrease (%s)'
        },
        PaymentCard: {
            text_card_number: 'Card number',
            text_blocked: 'Blocked',
            text_expired: 'Expired',
            text_not_active: 'Inactive',
            text_new_order: 'Ordered',
            text_order_in_process: 'On the way',
            text_replaced: 'Replaced',
            text_renewed: 'Renewed',
            text_new: 'New',
            text_unknown: 'Unknown'
        },
        Tag: {
            removeIconTitle: 'Remove',
            addIconTitle: 'Add'
        },
        Table: {
            accordionToggleButtonSR: 'Show more content',
            accordionMoreContentSR: 'More content in the next row',
            navigationButtonSR: 'Navigate to more content'
        },
        Upload: {
            title: 'Upload documents',
            text: 'Drag & drop your files or choose files to upload.',
            textSingular: 'Drag & drop your file or choose which file to upload.',
            fileTypeTableCaption: 'Allowed formats and max. file size',
            fileTypeDescription: 'Allowed formats:',
            fileSizeDescription: 'Max. file size:',
            fileAmountDescription: 'Max. number of files:',
            fileSizeContent: '%size MB',
            buttonText: 'Choose files',
            buttonTextSingular: 'Choose file',
            loadingText: 'Loading',
            errorLargeFile: 'The file you are trying to upload is too big, the maximum size supported is %size MB.',
            errorAmountLimit: 'There is a limit to how many files you can upload (%amount).',
            errorUnsupportedFile: 'The file you are trying to upload is not supported.',
            deleteButton: 'Delete',
            fileListAriaLabel: 'uploaded files'
        }
    }
};


function $cd34253258a667c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd34253258a667c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd34253258a667c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd34253258a667c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cd34253258a667c2$var$locales = $cd34253258a667c2$var$_objectSpread($cd34253258a667c2$var$_objectSpread({}, (0, $760f6e735ba35488$export$2e2bcd8739ae039)), (0, $d904a064453aaabf$export$2e2bcd8739ae039));
var $cd34253258a667c2$export$2e2bcd8739ae039 = $cd34253258a667c2$var$locales;




'use strict';
'use strict';

var $1XSJh = parcelRequire("1XSJh");

var $8lKVU = parcelRequire("8lKVU");

var $fG0wf = parcelRequire("fG0wf");

var $5Jked = parcelRequire("5Jked");

var $lQpvq = parcelRequire("lQpvq");

var $388Wm = parcelRequire("388Wm");

var $dgesD = parcelRequire("dgesD");

var $1H3Lz = parcelRequire("1H3Lz");

var $4LaI4 = parcelRequire("4LaI4");

var $hKX7u = parcelRequire("hKX7u");

var $fcHE3 = parcelRequire("fcHE3");
var $3239a101a2020587$exports = {};
'use strict';

var $9OhmT = parcelRequire("9OhmT");

var $fcHE3 = parcelRequire("fcHE3");

var $mgvTx = parcelRequire("mgvTx");
var $3239a101a2020587$var$MATCH = $mgvTx('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
$3239a101a2020587$exports = function(it) {
    var isRegExp;
    return $9OhmT(it) && ((isRegExp = it[$3239a101a2020587$var$MATCH]) !== undefined ? !!isRegExp : $fcHE3(it) === 'RegExp');
};


var $a9f9c059f620077d$exports = {};
'use strict';

var $8lKVU = parcelRequire("8lKVU");

var $keZ2c = parcelRequire("keZ2c");

var $7mAhs = parcelRequire("7mAhs");

var $a9f9c059f620077d$var$RegExpPrototype = RegExp.prototype;
$a9f9c059f620077d$exports = function(R) {
    var flags = R.flags;
    return flags === undefined && !('flags' in $a9f9c059f620077d$var$RegExpPrototype) && !$keZ2c(R, 'flags') && $7mAhs($a9f9c059f620077d$var$RegExpPrototype, R) ? $8lKVU($8ad092342d78a6b5$exports, R) : flags;
};



var $eZ5qV = parcelRequire("eZ5qV");

var $2t4Gp = parcelRequire("2t4Gp");

var $bAE3C = parcelRequire("bAE3C");

var $mgvTx = parcelRequire("mgvTx");
var $8d8f55530a416a95$exports = {};
'use strict';

var $4LaI4 = parcelRequire("4LaI4");
var $eb7b56f8944d03bc$exports = {};
'use strict';

var $cmnjY = parcelRequire("cmnjY");

var $7MtCT = parcelRequire("7MtCT");
var $eb7b56f8944d03bc$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$eb7b56f8944d03bc$exports = function(argument) {
    if ($cmnjY(argument)) return argument;
    throw new $eb7b56f8944d03bc$var$$TypeError($7MtCT(argument) + ' is not a constructor');
};



var $hKX7u = parcelRequire("hKX7u");

var $mgvTx = parcelRequire("mgvTx");
var $8d8f55530a416a95$var$SPECIES = $mgvTx('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$8d8f55530a416a95$exports = function(O, defaultConstructor) {
    var C = $4LaI4(O).constructor;
    var S;
    return C === undefined || $hKX7u(S = $4LaI4(C)[$8d8f55530a416a95$var$SPECIES]) ? defaultConstructor : $eb7b56f8944d03bc$exports(S);
};





var $4eljv = parcelRequire("4eljv");

var $axseE = parcelRequire("axseE");
var $5cd49f511b0aa85f$var$MATCH_ALL = $mgvTx('matchAll');
var $5cd49f511b0aa85f$var$REGEXP_STRING = 'RegExp String';
var $5cd49f511b0aa85f$var$REGEXP_STRING_ITERATOR = $5cd49f511b0aa85f$var$REGEXP_STRING + ' Iterator';
var $5cd49f511b0aa85f$var$setInternalState = $4eljv.set;
var $5cd49f511b0aa85f$var$getInternalState = $4eljv.getterFor($5cd49f511b0aa85f$var$REGEXP_STRING_ITERATOR);
var $5cd49f511b0aa85f$var$RegExpPrototype = RegExp.prototype;
var $5cd49f511b0aa85f$var$$TypeError = TypeError;
var $5cd49f511b0aa85f$var$stringIndexOf = $fG0wf(''.indexOf);
var $5cd49f511b0aa85f$var$nativeMatchAll = $fG0wf(''.matchAll);
var $5cd49f511b0aa85f$var$WORKS_WITH_NON_GLOBAL_REGEX = !!$5cd49f511b0aa85f$var$nativeMatchAll && !$bAE3C(function() {
    $5cd49f511b0aa85f$var$nativeMatchAll('a', /./);
});
var $5cd49f511b0aa85f$var$$RegExpStringIterator = $5Jked(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
    $5cd49f511b0aa85f$var$setInternalState(this, {
        type: $5cd49f511b0aa85f$var$REGEXP_STRING_ITERATOR,
        regexp: regexp,
        string: string,
        global: $global,
        unicode: fullUnicode,
        done: false
    });
}, $5cd49f511b0aa85f$var$REGEXP_STRING, function next() {
    var state = $5cd49f511b0aa85f$var$getInternalState(this);
    if (state.done) return $lQpvq(undefined, true);
    var R = state.regexp;
    var S = state.string;
    var match = $07e85df7cdcd6a85$exports(R, S);
    if (match === null) {
        state.done = true;
        return $lQpvq(undefined, true);
    }
    if (state.global) {
        if ($1H3Lz(match[0]) === '') R.lastIndex = $763d04c6034731a1$exports(S, $dgesD(R.lastIndex), state.unicode);
        return $lQpvq(match, false);
    }
    state.done = true;
    return $lQpvq(match, false);
});
var $5cd49f511b0aa85f$var$$matchAll = function(string) {
    var R = $4LaI4(this);
    var S = $1H3Lz(string);
    var C = $8d8f55530a416a95$exports(R, RegExp);
    var flags = $1H3Lz($a9f9c059f620077d$exports(R));
    var matcher, $global, fullUnicode;
    matcher = new C(C === RegExp ? R.source : R, flags);
    $global = !!~$5cd49f511b0aa85f$var$stringIndexOf(flags, 'g');
    fullUnicode = !!~$5cd49f511b0aa85f$var$stringIndexOf(flags, 'u');
    matcher.lastIndex = $dgesD(R.lastIndex);
    return new $5cd49f511b0aa85f$var$$RegExpStringIterator(matcher, S, $global, fullUnicode);
};
// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$1XSJh({
    target: 'String',
    proto: true,
    forced: $5cd49f511b0aa85f$var$WORKS_WITH_NON_GLOBAL_REGEX
}, {
    matchAll: function matchAll(regexp) {
        var O = $388Wm(this);
        var flags, S, matcher, rx;
        if (!$hKX7u(regexp)) {
            if ($3239a101a2020587$exports(regexp)) {
                flags = $1H3Lz($388Wm($a9f9c059f620077d$exports(regexp)));
                if (!~$5cd49f511b0aa85f$var$stringIndexOf(flags, 'g')) throw new $5cd49f511b0aa85f$var$$TypeError('`.matchAll` does not allow non-global regexes');
            }
            if ($5cd49f511b0aa85f$var$WORKS_WITH_NON_GLOBAL_REGEX) return $5cd49f511b0aa85f$var$nativeMatchAll(O, regexp);
            matcher = $eZ5qV(regexp, $5cd49f511b0aa85f$var$MATCH_ALL);
            if (matcher === undefined && $axseE && $fcHE3(regexp) === 'RegExp') matcher = $5cd49f511b0aa85f$var$$matchAll;
            if (matcher) return $8lKVU(matcher, regexp, O);
        } else if ($5cd49f511b0aa85f$var$WORKS_WITH_NON_GLOBAL_REGEX) return $5cd49f511b0aa85f$var$nativeMatchAll(O, regexp);
        S = $1H3Lz(O);
        rx = new RegExp(regexp, 'g');
        return $axseE ? $8lKVU($5cd49f511b0aa85f$var$$matchAll, rx, S) : rx[$5cd49f511b0aa85f$var$MATCH_ALL](S);
    }
});
$axseE || $5cd49f511b0aa85f$var$MATCH_ALL in $5cd49f511b0aa85f$var$RegExpPrototype || $2t4Gp($5cd49f511b0aa85f$var$RegExpPrototype, $5cd49f511b0aa85f$var$MATCH_ALL, $5cd49f511b0aa85f$var$$matchAll);




parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");

function $9c7aa0fd8d0ea04f$export$2e2bcd8739ae039(searchInput) {
    if (searchInput && 'object' === typeof searchInput) {
        const sI = searchInput;
        const foundKeyCode = sI.which || sI.keyCode || sI.charCode;
        if (foundKeyCode) searchInput = foundKeyCode;
        else if (sI.key) {
            searchInput = sI.key.toLowerCase();
            if (searchInput.startsWith('arrow')) searchInput = searchInput.replace('arrow', '');
            if (searchInput === 'spacebar') searchInput = searchInput.replace('bar', '');
            if (searchInput !== 'tab') return searchInput;
        }
    }
    if ('number' === typeof searchInput) return $9c7aa0fd8d0ea04f$export$e4b2ac9215619f8d[searchInput];
    const search = String(searchInput);
    {
        const foundNamedKey = $9c7aa0fd8d0ea04f$export$e45cb6485273080e[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
    }
    {
        const foundNamedKey = $9c7aa0fd8d0ea04f$export$9af93bb9e9126a2[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
    }
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
const $9c7aa0fd8d0ea04f$export$e45cb6485273080e = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    'pause/break': 19,
    'caps lock': 20,
    esc: 27,
    space: 32,
    'page up': 33,
    'page down': 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    delete: 46,
    command: 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
const $9c7aa0fd8d0ea04f$export$9af93bb9e9126a2 = {
    windows: 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    ctl: 17,
    control: 17,
    option: 18,
    pause: 19,
    break: 19,
    caps: 20,
    return: 13,
    escape: 27,
    spc: 32,
    spacebar: 32,
    pgup: 33,
    pgdn: 34,
    ins: 45,
    del: 46,
    cmd: 91
};
for(let i = 97; i < 123; i++)$9c7aa0fd8d0ea04f$export$e45cb6485273080e[String.fromCharCode(i)] = i - 32;
for(let i = 48; i < 58; i++)$9c7aa0fd8d0ea04f$export$e45cb6485273080e[i - 48] = i;
for(let i = 1; i < 13; i++)$9c7aa0fd8d0ea04f$export$e45cb6485273080e['f' + i] = i + 111;
for(let i = 0; i < 10; i++)$9c7aa0fd8d0ea04f$export$e45cb6485273080e['numpad ' + i] = i + 96;
const $9c7aa0fd8d0ea04f$export$e4b2ac9215619f8d = {};
for(const i in $9c7aa0fd8d0ea04f$export$e45cb6485273080e)$9c7aa0fd8d0ea04f$export$e4b2ac9215619f8d[$9c7aa0fd8d0ea04f$export$e45cb6485273080e[i]] = i;
for(const alias in $9c7aa0fd8d0ea04f$export$9af93bb9e9126a2)$9c7aa0fd8d0ea04f$export$e45cb6485273080e[alias] = $9c7aa0fd8d0ea04f$export$9af93bb9e9126a2[alias];


var $90e367f98610ff85$exports = {};
/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.12
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $90e367f98610ff85$exports = factory();
})($90e367f98610ff85$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ exports: {},
                /******/ id: moduleId,
                /******/ loaded: false
            };
            /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(0);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            'use strict';
            module1.exports = function() {
                /*
	   * bail out if there is no document or window
	   * (i.e. in a node/non-DOM environment)
	   *
	   * Return a stubbed API instead
	   */ if (typeof document === 'undefined' || typeof window === 'undefined') return {
                    // always return "initial" because no interaction will ever be detected
                    ask: function ask() {
                        return 'initial';
                    },
                    // always return null
                    element: function element() {
                        return null;
                    },
                    // no-op
                    ignoreKeys: function ignoreKeys() {},
                    // no-op
                    specificKeys: function specificKeys() {},
                    // no-op
                    registerOnChange: function registerOnChange() {},
                    // no-op
                    unRegisterOnChange: function unRegisterOnChange() {}
                };
                /*
	   * variables
	   */ // cache document.documentElement
                var docElem = document.documentElement;
                // currently focused dom element
                var currentElement = null;
                // last used input type
                var currentInput = 'initial';
                // last used input intent
                var currentIntent = currentInput;
                // UNIX timestamp of current event
                var currentTimestamp = Date.now();
                // check for a `data-whatpersist` attribute on either the `html` or `body` elements, defaults to `true`
                var shouldPersist = false;
                // form input types
                var formInputs = [
                    'button',
                    'input',
                    'select',
                    'textarea'
                ];
                // empty array for holding callback functions
                var functionList = [];
                // list of modifier keys commonly used with the mouse and
                // can be safely ignored to prevent false keyboard detection
                var ignoreMap = [
                    16,
                    17,
                    18,
                    91,
                    93 // Windows menu / right Apple cmd
                ];
                var specificMap = [];
                // mapping of events to input types
                var inputMap = {
                    keydown: 'keyboard',
                    keyup: 'keyboard',
                    mousedown: 'mouse',
                    mousemove: 'mouse',
                    MSPointerDown: 'pointer',
                    MSPointerMove: 'pointer',
                    pointerdown: 'pointer',
                    pointermove: 'pointer',
                    touchstart: 'touch',
                    touchend: 'touch'
                };
                var isScrolling = false;
                // store current mouse position
                var mousePos = {
                    x: null,
                    y: null
                };
                var pointerMap = {
                    2: 'touch',
                    3: 'touch',
                    4: 'mouse'
                };
                var supportsPassive = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function get() {
                            supportsPassive = true;
                        }
                    });
                    window.addEventListener('test', null, opts);
                } catch (e) {}
                // fail silently
                /*
	   * set up
	   */ var setUp = function setUp() {
                    // add correct mouse wheel event mapping to `inputMap`
                    inputMap[detectWheel()] = 'mouse';
                    addListeners();
                };
                /*
	   * events
	   */ var addListeners = function addListeners() {
                    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
                    // can only demonstrate potential, but not actual, interaction
                    // and are treated separately
                    var options = supportsPassive ? {
                        passive: true,
                        capture: true
                    } : true;
                    document.addEventListener('DOMContentLoaded', setPersist, true);
                    // pointer events (mouse, pen, touch)
                    if (window.PointerEvent) {
                        window.addEventListener('pointerdown', setInput, true);
                        window.addEventListener('pointermove', setIntent, true);
                    } else if (window.MSPointerEvent) {
                        window.addEventListener('MSPointerDown', setInput, true);
                        window.addEventListener('MSPointerMove', setIntent, true);
                    } else {
                        // mouse events
                        window.addEventListener('mousedown', setInput, true);
                        window.addEventListener('mousemove', setIntent, true);
                        // touch events
                        if ('ontouchstart' in window) {
                            window.addEventListener('touchstart', setInput, options);
                            window.addEventListener('touchend', setInput, true);
                        }
                    }
                    // mouse wheel
                    window.addEventListener(detectWheel(), setIntent, options);
                    // keyboard events
                    window.addEventListener('keydown', setInput, true);
                    window.addEventListener('keyup', setInput, true);
                    // focus events
                    window.addEventListener('focusin', setElement, true);
                    window.addEventListener('focusout', clearElement, true);
                };
                // checks if input persistence should happen and
                // get saved state from session storage if true (defaults to `false`)
                var setPersist = function setPersist() {
                    shouldPersist = !(docElem.getAttribute('data-whatpersist') === 'false' || document.body.getAttribute('data-whatpersist') === 'false');
                    if (shouldPersist) // check for session variables and use if available
                    try {
                        if (window.sessionStorage.getItem('what-input')) currentInput = window.sessionStorage.getItem('what-input');
                        if (window.sessionStorage.getItem('what-intent')) currentIntent = window.sessionStorage.getItem('what-intent');
                    } catch (e) {
                    // fail silently
                    }
                    // always run these so at least `initial` state is set
                    doUpdate('input');
                    doUpdate('intent');
                };
                // checks conditions before updating new input
                var setInput = function setInput(event) {
                    var eventKey = event.which;
                    var value = inputMap[event.type];
                    if (value === 'pointer') value = pointerType(event);
                    var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;
                    var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;
                    var shouldUpdate = value === 'keyboard' && eventKey && (ignoreMatch || specificMatch) || value === 'mouse' || value === 'touch';
                    // prevent touch detection from being overridden by event execution order
                    if (validateTouch(value)) shouldUpdate = false;
                    if (shouldUpdate && currentInput !== value) {
                        currentInput = value;
                        persistInput('input', currentInput);
                        doUpdate('input');
                    }
                    if (shouldUpdate && currentIntent !== value) {
                        // preserve intent for keyboard interaction with form fields
                        var activeElem = document.activeElement;
                        var notFormInput = activeElem && activeElem.nodeName && (formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1 || activeElem.nodeName.toLowerCase() === 'button' && !checkClosest(activeElem, 'form'));
                        if (notFormInput) {
                            currentIntent = value;
                            persistInput('intent', currentIntent);
                            doUpdate('intent');
                        }
                    }
                };
                // updates the doc and `inputTypes` array with new input
                var doUpdate = function doUpdate(which) {
                    docElem.setAttribute('data-what' + which, which === 'input' ? currentInput : currentIntent);
                    fireFunctions(which);
                };
                // updates input intent for `mousemove` and `pointermove`
                var setIntent = function setIntent(event) {
                    var value = inputMap[event.type];
                    if (value === 'pointer') value = pointerType(event);
                    // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove
                    detectScrolling(event);
                    // only execute if scrolling isn't happening
                    if ((!isScrolling && !validateTouch(value) || isScrolling && event.type === 'wheel' || event.type === 'mousewheel' || event.type === 'DOMMouseScroll') && currentIntent !== value) {
                        currentIntent = value;
                        persistInput('intent', currentIntent);
                        doUpdate('intent');
                    }
                };
                var setElement = function setElement(event) {
                    if (!event.target.nodeName) {
                        // If nodeName is undefined, clear the element
                        // This can happen if click inside an <svg> element.
                        clearElement();
                        return;
                    }
                    currentElement = event.target.nodeName.toLowerCase();
                    docElem.setAttribute('data-whatelement', currentElement);
                    if (event.target.classList && event.target.classList.length) docElem.setAttribute('data-whatclasses', event.target.classList.toString().replace(' ', ','));
                };
                var clearElement = function clearElement() {
                    currentElement = null;
                    docElem.removeAttribute('data-whatelement');
                    docElem.removeAttribute('data-whatclasses');
                };
                var persistInput = function persistInput(which, value) {
                    if (shouldPersist) try {
                        window.sessionStorage.setItem('what-' + which, value);
                    } catch (e) {
                    // fail silently
                    }
                };
                /*
	   * utilities
	   */ var pointerType = function pointerType(event) {
                    if (typeof event.pointerType === 'number') return pointerMap[event.pointerType];
                    else // treat pen like touch
                    return event.pointerType === 'pen' ? 'touch' : event.pointerType;
                };
                // prevent touch detection from being overridden by event execution order
                var validateTouch = function validateTouch(value) {
                    var timestamp = Date.now();
                    var touchIsValid = value === 'mouse' && currentInput === 'touch' && timestamp - currentTimestamp < 200;
                    currentTimestamp = timestamp;
                    return touchIsValid;
                };
                // detect version of mouse wheel event to use
                // via https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event
                var detectWheel = function detectWheel() {
                    var wheelType = null;
                    // Modern browsers support "wheel"
                    if ('onwheel' in document.createElement('div')) wheelType = 'wheel';
                    else // Webkit and IE support at least "mousewheel"
                    // or assume that remaining browsers are older Firefox
                    wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
                    return wheelType;
                };
                // runs callback functions
                var fireFunctions = function fireFunctions(type) {
                    for(var i = 0, len = functionList.length; i < len; i++)if (functionList[i].type === type) functionList[i].fn.call(undefined, type === 'input' ? currentInput : currentIntent);
                };
                // finds matching element in an object
                var objPos = function objPos(match) {
                    for(var i = 0, len = functionList.length; i < len; i++){
                        if (functionList[i].fn === match) return i;
                    }
                };
                var detectScrolling = function detectScrolling(event) {
                    if (mousePos.x !== event.screenX || mousePos.y !== event.screenY) {
                        isScrolling = false;
                        mousePos.x = event.screenX;
                        mousePos.y = event.screenY;
                    } else isScrolling = true;
                };
                // manual version of `closest()`
                var checkClosest = function checkClosest(elem, tag) {
                    var ElementPrototype = window.Element.prototype;
                    if (!ElementPrototype.matches) ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.webkitMatchesSelector;
                    if (!ElementPrototype.closest) {
                        do {
                            if (elem.matches(tag)) return elem;
                            elem = elem.parentElement || elem.parentNode;
                        }while (elem !== null && elem.nodeType === 1);
                        return null;
                    } else return elem.closest(tag);
                };
                /*
	   * init
	   */ // don't start script unless browser cuts the mustard
                // (also passes if polyfills are used)
                if ('addEventListener' in window && Array.prototype.indexOf) setUp();
                /*
	   * api
	   */ return {
                    // returns string: the current input type
                    // opt: 'intent'|'input'
                    // 'input' (default): returns the same value as the `data-whatinput` attribute
                    // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
                    ask: function ask(opt) {
                        return opt === 'intent' ? currentIntent : currentInput;
                    },
                    // returns string: the currently focused element or null
                    element: function element() {
                        return currentElement;
                    },
                    // overwrites ignored keys with provided array
                    ignoreKeys: function ignoreKeys(arr) {
                        ignoreMap = arr;
                    },
                    // overwrites specific char keys to update on
                    specificKeys: function specificKeys(arr) {
                        specificMap = arr;
                    },
                    // attach functions to input and intent "events"
                    // funct: function to fire on change
                    // eventType: 'input'|'intent'
                    registerOnChange: function registerOnChange(fn, eventType) {
                        functionList.push({
                            fn: fn,
                            type: eventType || 'input'
                        });
                    },
                    unRegisterOnChange: function unRegisterOnChange(fn) {
                        var position = objPos(fn);
                        if (position || position === 0) functionList.splice(position, 1);
                    },
                    clearStorage: function clearStorage() {
                        window.sessionStorage.clear();
                    }
                };
            }();
        /***/ }
    ]);
});



parcelRequire("3SQhX");

parcelRequire("3SQhX");
function $21b894ff0d4901e3$export$708d328211d9518d() {
    try {
        typeof document;
    } catch (error) {
        console.error(error);
    }
}



const $deeefef162515a83$export$38c6a3e5b70e61c0 = 'Mac|iPad|iPhone|iPod';
const $deeefef162515a83$export$336bae68914031bc = 'Win';
const $deeefef162515a83$export$1c2bb4c0f936e289 = 'Android';
const $deeefef162515a83$export$40a55710950a6734 = 'Linux';
const $deeefef162515a83$export$ef3703a40c1adf83 = 'iOS|iPhone|iPad|iPod';
let $deeefef162515a83$export$b58bee87d3d6da20 = false;
let $deeefef162515a83$export$9135b5fce2a2854d = false;
let $deeefef162515a83$export$af54264dae9065e6 = false;
let $deeefef162515a83$export$540767c3840af530 = false;
let $deeefef162515a83$export$ff23e6b4c4401383 = false;
let $deeefef162515a83$export$2760ddee6a71ee7d = false;
let $deeefef162515a83$export$25e95d65b6faeb9a = false;
const $deeefef162515a83$export$9ac100e40613ea10 = ()=>{
    var _navigator;
    return $deeefef162515a83$export$ff23e6b4c4401383 = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$38c6a3e5b70e61c0, 'i').test((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.platform);
};
const $deeefef162515a83$export$1ab4082fb43308c8 = ()=>{
    var _navigator2;
    return $deeefef162515a83$export$540767c3840af530 = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$336bae68914031bc, 'i').test((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.platform);
};
const $deeefef162515a83$export$a11b0059900ceec8 = ()=>{
    var _navigator3;
    return $deeefef162515a83$export$2760ddee6a71ee7d = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$1c2bb4c0f936e289, 'i').test((_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.userAgent);
};
const $deeefef162515a83$export$a10d59b01729022b = ()=>{
    var _navigator4;
    return $deeefef162515a83$export$25e95d65b6faeb9a = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$40a55710950a6734, 'i').test((_navigator4 = navigator) === null || _navigator4 === void 0 ? void 0 : _navigator4.platform);
};
const $deeefef162515a83$export$86c1a3f9ab33da5c = ()=>{
    var _navigator5;
    return $deeefef162515a83$export$9135b5fce2a2854d = typeof navigator !== 'undefined' && new RegExp($deeefef162515a83$export$ef3703a40c1adf83, 'i').test((_navigator5 = navigator) === null || _navigator5 === void 0 ? void 0 : _navigator5.platform);
};
const $deeefef162515a83$export$95df08bae54cb4df = ()=>{
    var _navigator6, _navigator7;
    return $deeefef162515a83$export$af54264dae9065e6 = typeof navigator !== 'undefined' && /safari/i.test((_navigator6 = navigator) === null || _navigator6 === void 0 ? void 0 : _navigator6.userAgent) && !/chrome/i.test((_navigator7 = navigator) === null || _navigator7 === void 0 ? void 0 : _navigator7.userAgent);
};
const $deeefef162515a83$export$cac3980734d91fbe = ()=>{
    var _navigator8;
    return $deeefef162515a83$export$b58bee87d3d6da20 = typeof navigator !== 'undefined' && /edge/i.test((_navigator8 = navigator) === null || _navigator8 === void 0 ? void 0 : _navigator8.userAgent);
};
$deeefef162515a83$export$cac3980734d91fbe();
$deeefef162515a83$export$86c1a3f9ab33da5c();
$deeefef162515a83$export$95df08bae54cb4df();
$deeefef162515a83$export$1ab4082fb43308c8();
$deeefef162515a83$export$a11b0059900ceec8();
$deeefef162515a83$export$9ac100e40613ea10();
$deeefef162515a83$export$a10d59b01729022b();
const $deeefef162515a83$var$pageFocusElements = {};
function $deeefef162515a83$export$c2c6e5b2f41473ad(selectorOrElement) {
    let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
    return $deeefef162515a83$var$pageFocusElements[key] = selectorOrElement;
}
function $deeefef162515a83$export$cb56c24ac2eb4e7e() {
    let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
        let element = /^[.#]/.test(selector) ? selector : $deeefef162515a83$var$pageFocusElements[selector];
        if (typeof element === 'string' && typeof document !== 'undefined') element = document.querySelector(element);
        else if (!element && typeof document !== 'undefined') element = document.querySelector('.dnb-no-focus');
        if (!(element instanceof HTMLElement)) return;
        const role = element.getAttribute('role');
        const list = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'label',
            'menu'
        ];
        const isInteractive = list.includes(String(element.nodeName).toLowerCase()) || list.includes(String(role).toLowerCase());
        const hasTabIndex = element.hasAttribute('tabindex');
        const hasNoFocus = element.classList.contains('dnb-no-focus');
        if (!isInteractive) {
            if (!hasTabIndex) element.setAttribute('tabindex', '-1');
            if (!hasNoFocus) element.classList.add('dnb-no-focus');
        }
        element.focus();
        const onBlur = ()=>{
            if (!isInteractive) {
                if (!hasTabIndex) element.removeAttribute('tabindex');
                if (!hasNoFocus) element.classList.remove('dnb-no-focus');
            }
        };
        element.addEventListener('blur', onBlur, {
            once: true
        });
        if (typeof callback === 'function') callback(element);
    } catch (e) {
        $deeefef162515a83$export$c106dd0671a0fc2d('Error on applyPageFocus:', e);
    }
}
function $deeefef162515a83$export$6fcff0dc60346367(elem) {
    let offsetTop = 0;
    if (elem) {
        do if (!isNaN(elem.offsetTop)) offsetTop += elem.offsetTop;
        while (elem = elem.offsetParent);
    }
    return offsetTop;
}
function $deeefef162515a83$export$a6a488ff68b1bf7b(elem) {
    let offsetLeft = 0;
    if (elem) {
        do if (!isNaN(elem.offsetLeft)) offsetLeft += elem.offsetLeft;
        while (elem = elem.offsetParent);
    }
    return offsetLeft;
}
function $deeefef162515a83$export$6f6442b1c96e0e12() {
    let { offset: offset = 0, delay: delay = null, onCompletion: onCompletion = null } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (typeof document !== 'undefined' && typeof window !== 'undefined' && window.location) try {
        let _timeout;
        const id = String(window.location.hash).replace('#', '');
        if (id.length > 0) {
            const handleScroll = ()=>{
                const runScroll = ()=>{
                    const totalOffset = $deeefef162515a83$export$6fcff0dc60346367(elem);
                    if (totalOffset <= 0) return;
                    const top = totalOffset - offset;
                    try {
                        if (typeof IntersectionObserver !== 'undefined') {
                            const intersectionObserver = new IntersectionObserver((entries)=>{
                                const [entry] = entries;
                                if (entry.isIntersecting) {
                                    intersectionObserver.unobserve(elem);
                                    if (typeof onCompletion === 'function') onCompletion(elem);
                                }
                            });
                            intersectionObserver.observe(elem);
                        }
                        if (window.scrollTo) window.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                        else window.scrollTop = top;
                    } catch (e) {
                        $deeefef162515a83$export$c106dd0671a0fc2d('Error on scrollToLocationHashId:', e);
                    }
                };
                if (delay > 0) {
                    clearTimeout(_timeout);
                    _timeout = setTimeout(runScroll, delay);
                } else runScroll();
            };
            const elem = document.getElementById(id);
            if (elem instanceof HTMLElement) {
                window.addEventListener('beforeunload', ()=>clearTimeout(_timeout));
                if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleScroll);
                else handleScroll();
            }
            return elem;
        }
    } catch (e) {
        $deeefef162515a83$export$c106dd0671a0fc2d('Error on scrollToLocationHashId:', e);
    }
}
function $deeefef162515a83$export$2aeb731651ce3319(elem) {
    try {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        range.cloneRange().insertNode(elem);
        selection.addRange(range);
    } catch (e) {}
}
function $deeefef162515a83$export$93850515e4be65a3() {
    try {
        return window.getSelection().toString();
    } catch (e) {}
}
function $deeefef162515a83$export$acc7c0c9db77f425() {
    try {
        if (window.getSelection && window.getSelection().empty) window.getSelection().empty();
    } catch (e) {}
}
function $deeefef162515a83$export$8f5e5df0ef949c4c() {
    return $deeefef162515a83$export$93850515e4be65a3().length > 0;
}
function $deeefef162515a83$export$48bc52c1b5641d9b() {
    try {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            let elem = selection.getRangeAt(0).startContainer;
            if (elem && typeof elem === 'object') elem = elem.parentNode;
            return elem;
        }
    } catch (e) {}
    return null;
}
async function $deeefef162515a83$export$2cdf1b96a9f86d16(string) {
    var _navigator9;
    if (typeof window === 'undefined' || typeof document === 'undefined') return false;
    const selection = window.getSelection();
    const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
    const resetSelection = ()=>{
        try {
            selection.removeAllRanges();
            selection.addRange(range);
        } catch (e) {}
    };
    const copyFallback = ()=>{
        try {
            const elem = document.createElement('textarea');
            elem.value = String(string);
            elem.contentEditable = true;
            elem.readOnly = false;
            elem.style.position = 'fixed';
            elem.style.top = '-1000px';
            document.body.appendChild(elem);
            const success = document.execCommand('copy');
            document.body.removeChild(elem);
            resetSelection();
            if (success) return true;
        } catch (e) {
            return e;
        }
        return `Could not copy! Unknown reason. ${string}`;
    };
    let success;
    if (typeof navigator !== 'undefined' && (_navigator9 = navigator) !== null && _navigator9 !== void 0 && _navigator9.clipboard) try {
        await navigator.clipboard.writeText(String(string));
        success = true;
        resetSelection();
    } catch (e) {
        success = e;
        const newTry = copyFallback();
        if (newTry === true) success = newTry;
    }
    else success = copyFallback();
    return success;
}
const $deeefef162515a83$export$c106dd0671a0fc2d = function() {
    var _len, params, _key;
};
function $deeefef162515a83$export$5551a2d24ff40153(value) {
    if (String(value).includes('--')) return value;
    return value ? !/#|var/.test(value) ? `var(--color-${value})` : value : undefined;
}
(0, $21b894ff0d4901e3$export$708d328211d9518d)();




const $1cd90c749d09b3aa$export$9cde4a31f3f732e7 = (selector, element)=>{
    try {
        const tagName = /[A-Z]/.test(selector) ? selector : null;
        const className = tagName ? null : selector.replace(/^\./, '');
        const contains = (element)=>{
            if (!element) return null;
            if (tagName) return (element === null || element === void 0 ? void 0 : element.tagName) === tagName;
            return element === null || element === void 0 ? void 0 : element.classList.contains(className);
        };
        if (contains(element)) return element;
        while((element = (_element = element) === null || _element === void 0 ? void 0 : _element.parentElement) && !contains(element))var _element;
    } catch (e) {
        (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
    }
    return element;
};



const $1f2378dc42ffeef6$export$83d89fbfd8236492 = '10.83.0';
const $1f2378dc42ffeef6$export$8256110f30169a5d = '3ad324864';


const $bce3ea05de26e767$export$c506eb22e615ba4a = ()=>{
    return 0, $1f2378dc42ffeef6$export$83d89fbfd8236492;
};
const $bce3ea05de26e767$export$60d52592423e9732 = ()=>{
    return 0, $1f2378dc42ffeef6$export$8256110f30169a5d;
};


const $179e89430ab61ea0$export$83d89fbfd8236492 = (0, $bce3ea05de26e767$export$c506eb22e615ba4a)();
const $179e89430ab61ea0$export$8256110f30169a5d = (0, $bce3ea05de26e767$export$60d52592423e9732)();
function $179e89430ab61ea0$export$2cd8252107eb640b() {
    if (typeof window !== 'undefined') {
        class Eufemia {
            get version() {
                return $179e89430ab61ea0$export$83d89fbfd8236492;
            }
            get sha() {
                return $179e89430ab61ea0$export$8256110f30169a5d;
            }
            get shas() {
                return window.__eufemiaSHAs;
            }
            get versions() {
                return window.__eufemiaSHAs.map((sha, i)=>{
                    const scopeElement = document.querySelector(`[data-scope-hash-id][data-scope-sha="${sha}"]`);
                    const styleElement = scopeElement === null || scopeElement === void 0 ? void 0 : scopeElement.querySelector('.dnb-core-style');
                    const css = window.getComputedStyle(styleElement || document.body).getPropertyValue('--eufemia-version').replace(/"/g, '');
                    const js = window.__eufemiaVersions[i] || window.__eufemiaVersions[0] || this.version;
                    return {
                        js: js,
                        css: css,
                        sha: sha,
                        scopeElement: scopeElement
                    };
                });
            }
            constructor(){
                if (!window.__eufemiaVersions) window.__eufemiaVersions = [];
                if (!window.__eufemiaVersions.includes(this.version)) window.__eufemiaVersions.push(this.version);
                if (!window.__eufemiaSHAs) window.__eufemiaSHAs = [];
                if (!window.__eufemiaSHAs.includes(this.sha)) window.__eufemiaSHAs.push(this.sha);
            }
        }
        window.Eufemia = new Eufemia();
    }
}



parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");


function $5cdea43e47e2bcbb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5cdea43e47e2bcbb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5cdea43e47e2bcbb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5cdea43e47e2bcbb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5cdea43e47e2bcbb$export$a1d0d20ee9546562() {
    if (typeof document !== 'undefined') {
        let intent = false;
        try {
            intent = document.documentElement.getAttribute('data-whatintent');
        } catch (e) {}
        return intent === 'touch';
    }
    return false;
}
function $5cdea43e47e2bcbb$export$50e883862acdbb29() {
    const handleNavigator = ()=>{
        if (typeof document === 'undefined' || typeof window === 'undefined' || typeof navigator === 'undefined') return;
        try {
            if (!(typeof window !== 'undefined' && window.IS_TEST)) {
                if (navigator.platform.match(new RegExp((0, $deeefef162515a83$export$38c6a3e5b70e61c0))) !== null) document.documentElement.setAttribute('data-os', 'mac');
                else if (navigator.platform.match(new RegExp((0, $deeefef162515a83$export$336bae68914031bc))) !== null) document.documentElement.setAttribute('data-os', 'win');
                else if (navigator.platform.match(new RegExp((0, $deeefef162515a83$export$40a55710950a6734))) !== null) document.documentElement.setAttribute('data-os', 'linux');
            } else document.documentElement.setAttribute('data-os', 'other');
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
        document.removeEventListener('DOMContentLoaded', handleNavigator);
    };
    if (typeof document !== 'undefined' && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleNavigator);
    else handleNavigator();
}
const $5cdea43e47e2bcbb$export$51751cece1adcf33 = (props)=>{
    if (!props) return null;
    if (typeof $parcel$global !== 'undefined' && Array.isArray($parcel$global.registeredElements) && $parcel$global.registeredElements.length > 0) {
        let cache = null;
        Object.entries(props).reverse().map((_ref)=>{
            let [key, cb] = _ref;
            if (key.includes('render_') && /^render_/.test(key)) {
                if (typeof cb === 'function') {
                    if (cache) {
                        if (Object.isFrozen(props)) props = $5cdea43e47e2bcbb$var$_objectSpread({}, props);
                        props.children = cache;
                    }
                    return cache = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, {
                        key: key
                    }, cb(props));
                }
            }
            return null;
        }).filter(Boolean);
        if (cache) return cache;
    }
    const res = typeof props.children === 'function' ? props.children(props) : props.children;
    if (Array.isArray(res)) {
        const onlyTexts = res.reduce((pV, cV)=>{
            if (typeof cV === 'string' || typeof cV === 'number') pV.push(cV);
            return pV;
        }, []);
        if (onlyTexts.length === res.length && onlyTexts.length > 0) return onlyTexts.join('');
    }
    return res;
};
const $5cdea43e47e2bcbb$export$4d3e60c1044d732d = (ignoreElements, onSuccess, options)=>new $5cdea43e47e2bcbb$export$be33f99ff14eb0df(ignoreElements, onSuccess, options);
class $5cdea43e47e2bcbb$export$be33f99ff14eb0df {
    remove() {
        if (this.handleClickOutside && typeof document !== 'undefined') {
            document.removeEventListener('mousedown', this.handleClickOutside);
            this.handleClickOutside = null;
        }
        if (this.keydownCallback && typeof window !== 'undefined') {
            window.removeEventListener('keydown', this.keydownCallback);
            this.keydownCallback = null;
        }
        if (this.keyupCallback && typeof window !== 'undefined') {
            window.removeEventListener('keyup', this.keyupCallback);
            this.keyupCallback = null;
        }
    }
    constructor(_ignoreElements, _onSuccess){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "checkOutsideClick", function(_ref2) {
            let { event: event, ignoreElements: ignoreElements } = _ref2;
            let onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            try {
                const currentElement = event.target;
                if ((currentElement === null || currentElement === void 0 ? void 0 : currentElement.tagName) === 'HTML' && (event.pageX > document.documentElement.clientWidth - 40 || event.pageY > document.documentElement.clientHeight - 40)) return;
                if ($5cdea43e47e2bcbb$export$54478a583b57e12a(currentElement)) return;
                for(let i = 0, elem, l = ignoreElements.length; i < l; ++i){
                    const ignoreElement = ignoreElements[i] && 'current' in ignoreElements[i] ? ignoreElements[i].current : ignoreElements[i];
                    elem = currentElement;
                    if (!ignoreElements[i]) continue;
                    do {
                        if (elem === ignoreElement) return;
                        elem = elem && elem.parentNode;
                    }while (elem);
                }
                if (typeof onSuccess === 'function') onSuccess();
            } catch (e) {
                (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
            }
        });
        if (!this.handleClickOutside && typeof document !== 'undefined' && typeof window !== 'undefined') {
            if (!Array.isArray(_ignoreElements)) _ignoreElements = [
                _ignoreElements
            ];
            this.handleClickOutside = (event)=>{
                this.checkOutsideClick({
                    event: event,
                    ignoreElements: _ignoreElements
                }, ()=>typeof _onSuccess === 'function' && _onSuccess({
                        event: event
                    }));
            };
            document.addEventListener('mousedown', this.handleClickOutside);
            this.keydownCallback = (event)=>{
                const keyCode = (0, $9c7aa0fd8d0ea04f$export$2e2bcd8739ae039)(event);
                if (keyCode === 'esc') {
                    window.removeEventListener('keydown', this.keydownCallback);
                    if (typeof _onSuccess === 'function') _onSuccess({
                        event: event
                    });
                }
            };
            window.addEventListener('keydown', this.keydownCallback);
            if (options.includedKeys) {
                this.keyupCallback = (event)=>{
                    const keyCode = (0, $9c7aa0fd8d0ea04f$export$2e2bcd8739ae039)(event);
                    if (options.includedKeys.includes(keyCode) && typeof this.handleClickOutside === 'function') this.handleClickOutside(event, ()=>{
                        if (this.keyupCallback) window.removeEventListener('keyup', this.keyupCallback);
                    });
                };
                window.addEventListener('keyup', this.keyupCallback);
            }
        }
    }
}
const $5cdea43e47e2bcbb$export$54478a583b57e12a = (elem)=>{
    return elem && (elem.scrollHeight > elem.offsetHeight || elem.scrollWidth > elem.offsetWidth) && $5cdea43e47e2bcbb$var$overflowIsScrollable(elem);
};
const $5cdea43e47e2bcbb$var$overflowIsScrollable = (elem)=>{
    const style = typeof window !== 'undefined' ? window.getComputedStyle(elem) : {};
    return /scroll|auto/i.test((style.overflow || '') + (style.overflowX || '') + (style.overflowY || ''));
};




parcelRequire("3SQhX");
function $be16b996e1dc94eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be16b996e1dc94eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be16b996e1dc94eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be16b996e1dc94eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $be16b996e1dc94eb$export$ad5cdd5a4635d9d0(props) {
    let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    props = $be16b996e1dc94eb$var$_objectSpread($be16b996e1dc94eb$var$_objectSpread({}, defaults), props);
    for(var _len = arguments.length, contexts = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)contexts[_key - 2] = arguments[_key];
    return $be16b996e1dc94eb$var$_objectSpread($be16b996e1dc94eb$var$_objectSpread({}, props), $be16b996e1dc94eb$var$reduceContextHasValue(props, defaults, contexts));
}
function $be16b996e1dc94eb$export$87ea024adc3494ce(props) {
    let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    for(var _len2 = arguments.length, contexts = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)contexts[_key2 - 2] = arguments[_key2];
    return $be16b996e1dc94eb$var$_objectSpread($be16b996e1dc94eb$var$_objectSpread({}, props), $be16b996e1dc94eb$var$reduceContextHasValue(props, defaults, contexts, {
        onlyMergeExistingProps: true
    }));
}
function $be16b996e1dc94eb$export$838a0b3a8912daf4(contexts) {
    return contexts.reduce((acc, cur)=>{
        if (cur) acc = $be16b996e1dc94eb$var$_objectSpread($be16b996e1dc94eb$var$_objectSpread({}, acc), cur);
        return acc;
    }, {});
}
function $be16b996e1dc94eb$var$reduceContextHasValue(props, defaults, contexts) {
    let { onlyMergeExistingProps: onlyMergeExistingProps = false } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const context = $be16b996e1dc94eb$export$838a0b3a8912daf4(contexts);
    return Object.entries(context).reduce((acc, _ref)=>{
        let [key, value] = _ref;
        if (!onlyMergeExistingProps || Object.prototype.hasOwnProperty.call(props, key)) {
            if (props[key] === (defaults === null || defaults === void 0 ? void 0 : defaults[key])) acc[key] = value;
        }
        return acc;
    }, {});
}



parcelRequire("3SQhX");
function $de502bdad3b5fb4d$export$d697c39a2985a4c(props) {
    let remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let allowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (Array.isArray(remove)) remove = remove.reduce((acc, key)=>{
        acc[key] = true;
        return acc;
    }, {});
    if (Array.isArray(allowed)) allowed = allowed.reduce((acc, key)=>{
        acc[key] = true;
        return acc;
    }, {});
    const isArray = Array.isArray(props);
    return Object.entries(props).reduce((acc, _ref)=>{
        var _remove, _allowed;
        let [k, v] = _ref;
        if (isArray) k = v;
        if ((typeof remove === 'function' ? !remove(k) : typeof ((_remove = remove) === null || _remove === void 0 ? void 0 : _remove[k]) === 'undefined') || (typeof allowed === 'function' ? allowed(k) : typeof ((_allowed = allowed) === null || _allowed === void 0 ? void 0 : _allowed[k]) !== 'undefined')) {
            if (isArray) acc.push(v);
            else acc[k] = v;
        }
        return acc;
    }, isArray ? [] : {});
}


function $11741836d1790446$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11741836d1790446$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11741836d1790446$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11741836d1790446$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
(0, $179e89430ab61ea0$export$2cd8252107eb640b)();
(0, (/*@__PURE__*/$parcel$interopDefault($90e367f98610ff85$exports))).specificKeys([
    9
]);
(0, $5cdea43e47e2bcbb$export$50e883862acdbb29)();
const $11741836d1790446$export$4ddc669a9a6a5940 = (props, params)=>{
    if (props && props.attributes) {
        let attr = props.attributes;
        if (attr) {
            if (attr[0] === '{') attr = JSON.parse(attr);
            if (attr && typeof attr === 'object') Object.entries(attr).forEach((_ref)=>{
                let [key, value] = _ref;
                Object.assign(params, {
                    [key]: value
                });
            });
            delete params.attributes;
        }
    }
    if (params.disabled === null || params.disabled === 'false') delete params.disabled;
    if (typeof params.space !== 'undefined') delete params.space;
    if (typeof params.top !== 'undefined') delete params.top;
    if (typeof params.right !== 'undefined') delete params.right;
    if (typeof params.bottom !== 'undefined') delete params.bottom;
    if (typeof params.left !== 'undefined') delete params.left;
    if (typeof params.no_collapse !== 'undefined') delete params.no_collapse;
    if (typeof params.innerSpace !== 'undefined') delete params.innerSpace;
    else if (params.disabled === 'true') params.disabled = true;
    if (params.disabled === true) params['aria-disabled'] = true;
    if (props && props.tabindex) {
        let tabIndex = props.tabindex;
        if (tabIndex === 'off') tabIndex = '-1';
        params['tabIndex'] = tabIndex;
    }
    if (params && typeof params === 'object') for(const i in params){
        if (typeof params[i] === 'function' && !/(^[a-z]{1,}[A-Z]{1})/.test(i)) delete params[i];
        else if (params[i] === null || /[^a-z-]/i.test(i)) delete params[i];
    }
    return params;
};
const $11741836d1790446$export$5924a7a9d08f3e63 = function() {
    let first = {};
    for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++)objects[_key] = arguments[_key];
    const keepRef = objects[0];
    if (keepRef === true || keepRef === false) {
        objects.shift();
        if (keepRef) first = objects.shift();
    }
    return objects.reduce((acc1, object)=>{
        if (object) acc1 = Object.assign(acc1, Object.entries(object).reduce((acc2, _ref2)=>{
            let [key, value] = _ref2;
            if (value !== null) {
                if (typeof value === 'object') {
                    value = $11741836d1790446$export$5924a7a9d08f3e63(acc1[key] || {}, value);
                    if (Object.keys(value).length > 0) acc2[key] = value;
                } else acc2[key] = value;
            }
            return acc2;
        }, {}));
        return acc1;
    }, first);
};
function $11741836d1790446$export$a6cdc56e425d0d0a(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $11741836d1790446$export$b29aee33601cce38() {
    let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    for(var _len2 = arguments.length, sources = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)sources[_key2 - 1] = arguments[_key2];
    for (const source of sources){
        if ($11741836d1790446$export$a6cdc56e425d0d0a(source)) for(const key in source){
            if (key === '__proto__' || key === 'constructor') continue;
            if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
            if (!$11741836d1790446$export$a6cdc56e425d0d0a(target)) continue;
            if ($11741836d1790446$export$a6cdc56e425d0d0a(source[key])) {
                if (!$11741836d1790446$export$a6cdc56e425d0d0a(target[key])) target[key] = {};
                $11741836d1790446$export$b29aee33601cce38(target[key], source[key]);
            } else target[key] = source[key];
        }
    }
    return target;
}
const $11741836d1790446$export$7afc298d8ffd816 = (value)=>{
    if (value !== null && typeof value !== 'undefined' && (String(value) === 'true' || String(value) === '1')) return true;
    return false;
};
const $11741836d1790446$export$89a1e257278b2134 = function(src, eventName) {
    let eventObjectOrig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    let ret = undefined;
    const eventObject = $11741836d1790446$var$_objectSpread($11741836d1790446$var$_objectSpread({}, eventObjectOrig && eventObjectOrig.event || {}), eventObjectOrig);
    if (eventObject && eventObject.attributes && eventObject.event) {
        const currentTarget = eventObject.event.currentTarget;
        if (currentTarget) try {
            const dataset = $11741836d1790446$var$_objectSpread({}, currentTarget.dataset || {});
            const attributes = $11741836d1790446$var$_objectSpread({}, eventObject.attributes);
            for(const i in attributes)if (/^data-/.test(i)) dataset[String(i).replace(/^data-/, '')] = attributes[i];
            for(const i in dataset){
                if (eventObject.event.currentTarget.dataset) eventObject.event.currentTarget.dataset[i] = dataset[i];
                if (eventObject.event.target && eventObject.event.target.dataset) eventObject.event.target.dataset[i] = dataset[i];
            }
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Error on handling dataset:', e);
        }
    }
    const props = src && src.props || src;
    if (eventName.includes('_')) {
        if (typeof props[eventName] === 'function') {
            const r = props[eventName].apply(src, [
                eventObject
            ]);
            if (typeof r !== 'undefined') ret = r;
        }
        eventName = $11741836d1790446$export$86f54f62aa7a7514(eventName);
        if (typeof props[eventName] === 'function') {
            const r = props[eventName].apply(src, [
                eventObject
            ]);
            if (typeof r !== 'undefined') ret = r;
        }
    } else {
        if (typeof props[eventName] === 'function') {
            const r = props[eventName].apply(src, [
                eventObject
            ]);
            if (typeof r !== 'undefined') ret = r;
        }
        eventName = $11741836d1790446$export$cc8b315fc368b20a(eventName);
        if (typeof props[eventName] === 'function') {
            const r = props[eventName].apply(src, [
                eventObject
            ]);
            if (typeof r !== 'undefined') ret = r;
        }
    }
    return ret;
};
const $11741836d1790446$export$86f54f62aa7a7514 = (s)=>s.split(/_/g).reduce((acc, cur, i)=>acc + (i === 0 ? cur : cur.replace(/(\w)(\w*)/g, (g0, g1, g2)=>g1.toUpperCase() + g2.toLowerCase())), '');
const $11741836d1790446$export$6fb43ff9addf7357 = (s)=>s.split(/_/g).reduce((acc, cur)=>acc + cur.replace(/(\w)(\w*)/g, (g0, g1, g2)=>g1.toUpperCase() + g2.toLowerCase()), '');
const $11741836d1790446$export$cc8b315fc368b20a = (str)=>str.replace(/\B[A-Z]/g, (letter)=>`_${letter}`).toLowerCase();
const $11741836d1790446$export$73bda83cddbc7187 = (str)=>str.replace(/\B[A-Z]/g, (letter)=>`-${letter}`).toLowerCase();
function $11741836d1790446$export$6c878285a9ef10a4(str) {
    return typeof str === 'string' ? str.toLowerCase().split('').map((char, index, arr)=>index === 0 || arr[index - 1] === ' ' || arr[index - 1] === '-' ? char.toUpperCase() : char).join('') : str;
}
const $11741836d1790446$export$d0c8ec0fe1b18b70 = function() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id-';
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    return prefix + String(Math.random().toString(36).substr(2, length) + $11741836d1790446$var$idIncrement++).slice(-length);
};
let $11741836d1790446$var$idIncrement = 0;
const $11741836d1790446$export$c383cdd2a518017a = (s)=>String(s).toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
const $11741836d1790446$export$c05c39859172f90c = (string, regex)=>{
    if (typeof string.matchAll === 'function') return Array.from(string.matchAll(regex));
    const matches = [];
    let match;
    while(match = regex.exec(string))matches.push(match);
    return matches;
};
const $11741836d1790446$export$5ebe8f8550508fde = function(element, target) {
    let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    try {
        const contains = (element)=>{
            if (callback) {
                const res = callback(element);
                if (res) return element;
            }
            return element && element === target;
        };
        if (contains(element)) return element;
        while((element = element && element.parentElement) && !contains(element));
    } catch (e) {}
    return element;
};
const $11741836d1790446$export$f72673597dacfcfa = (num, target)=>{
    const diff = num % target;
    return diff > target / 2 ? num - diff + target : num - diff;
};
const $11741836d1790446$export$6857ec1aec960893 = (currentElement)=>{
    return (0, $1cd90c749d09b3aa$export$9cde4a31f3f732e7)('.dnb-scroll-view', currentElement);
};
function $11741836d1790446$export$5bfc594bd2dc6e21(elements) {
    let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    let transformWord = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    if (!Array.isArray(elements)) elements = [
        elements
    ];
    const process = (word)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(word)) {
            if (transformWord) word = transformWord(word);
            if (Array.isArray(word.props.children)) word = word.props.children.reduce((acc, word)=>{
                if (typeof word !== 'string') word = process(word);
                if (typeof word === 'string') acc = (acc + (separator || '') + word).trim();
                return acc;
            }, '');
            else if (word.props.children) {
                word = word.props.children;
                if (typeof word !== 'string') word = process(word);
                if (typeof word === 'string') word = word.trim();
                else return undefined;
            } else return undefined;
        }
        return word;
    };
    return Array.from(elements).map((word)=>process(word)).filter(Boolean).join(separator).trim();
}
function $11741836d1790446$export$69913caddc9965f(status, state) {
    return status ? state : null;
}
function $11741836d1790446$export$a5f4aa7ad013c9e9(status) {
    return status && status !== 'error' && status !== 'warn' && status !== 'info';
}
function $11741836d1790446$export$b31873477fdbab59() {
    for(var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)params[_key3] = arguments[_key3];
    return $11741836d1790446$var$combineAriaBy('aria-labelledby', params);
}
function $11741836d1790446$export$ac6c18d26085326c() {
    for(var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)params[_key4] = arguments[_key4];
    return $11741836d1790446$var$combineAriaBy('aria-describedby', params);
}
function $11741836d1790446$export$39ac5896b2258c3f() {
    for(var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)params[_key5] = arguments[_key5];
    return $11741836d1790446$var$combineAriaBy('aria-details', params);
}
function $11741836d1790446$var$combineAriaBy(type, params) {
    params = params.map((cur)=>{
        if (Array.isArray(cur)) return cur.join(' ');
        if (cur && params.includes(cur[type])) return null;
        if (cur && typeof cur[type] !== 'undefined') cur = cur[type];
        if (typeof cur !== 'string') cur = null;
        return cur;
    });
    params = params.filter(Boolean).join(' ');
    if (params === '') params = undefined;
    return params;
}
function $11741836d1790446$export$b2730d17dab9d6f8(children, find) {
    if (!Array.isArray(children)) children = [
        children
    ];
    let result = null;
    children.some((cur)=>{
        if (cur && cur.props && cur.props.children) {
            const res = $11741836d1790446$export$b2730d17dab9d6f8(cur.props.children, find);
            if (res) return result = res;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(cur) && find(cur)) return result = cur;
        return null;
    });
    return result;
}
function $11741836d1790446$export$5e3c9d2a613b9083(str) {
    return str.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
}
function $11741836d1790446$export$130f9de4db4d93ea(object) {
    Object.keys(object || {}).forEach((key)=>{
        if (object[key] === undefined) delete object[key];
    });
    return object;
}


var $8b0e7c45585056fa$exports = {};
var $0d901be78cae4187$exports = {};

$parcel$export($0d901be78cae4187$exports, "get", function () { return $0d901be78cae4187$export$3988ae62b71be9a3; });
$parcel$export($0d901be78cae4187$exports, "parse", function () { return $0d901be78cae4187$export$98e6a39c04603d36; });
$parcel$export($0d901be78cae4187$exports, "set", function () { return $0d901be78cae4187$export$adaa4cf7ef1b65be; });
$parcel$export($0d901be78cae4187$exports, "remove", function () { return $0d901be78cae4187$export$cd7f480d6b8286c3; });
$parcel$export($0d901be78cae4187$exports, "dict", function () { return $0d901be78cae4187$export$b7eef48498bbd53e; });
$parcel$export($0d901be78cae4187$exports, "walk", function () { return $0d901be78cae4187$export$588732934346abbf; });
$parcel$export($0d901be78cae4187$exports, "compile", function () { return $0d901be78cae4187$export$ef7acd7185315e22; });
$parcel$export($0d901be78cae4187$exports, "has", function () { return $0d901be78cae4187$export$a4f4bb6b1453fff5; });
$parcel$export($0d901be78cae4187$exports, "escape", function () { return $0d901be78cae4187$export$4e7f196112fea3c5; });
$parcel$export($0d901be78cae4187$exports, "unescape", function () { return $0d901be78cae4187$export$e8bacd2802a88316; });


function $0d901be78cae4187$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d901be78cae4187$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d901be78cae4187$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d901be78cae4187$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0d901be78cae4187$export$3988ae62b71be9a3(obj, pointer) {
    const refTokens = Array.isArray(pointer) ? pointer : $0d901be78cae4187$export$98e6a39c04603d36(pointer);
    for(let i = 0; i < refTokens.length; ++i){
        const tok = refTokens[i];
        if (!(typeof obj == 'object' && tok in obj)) throw new Error('Invalid reference token: ' + tok);
        obj = obj[tok];
    }
    return obj;
}
function $0d901be78cae4187$export$adaa4cf7ef1b65be(obj, pointer, value) {
    const refTokens = Array.isArray(pointer) ? pointer : $0d901be78cae4187$export$98e6a39c04603d36(pointer);
    let nextTok = refTokens[0];
    if (refTokens.length === 0) throw Error('Cannot set the root object');
    for(let i = 0; i < refTokens.length - 1; ++i){
        let tok = refTokens[i];
        if (typeof tok !== 'string' && typeof tok !== 'number') tok = String(tok);
        if (tok === '__proto__' || tok === 'constructor' || tok === 'prototype') continue;
        if (tok === '-' && Array.isArray(obj)) tok = obj.length;
        nextTok = refTokens[i + 1];
        if (!(tok in obj)) {
            if (nextTok.match(/^(\d+|-)$/)) obj[tok] = [];
            else obj[tok] = {};
        }
        if (Object.isFrozen(obj[tok])) obj[tok] = $0d901be78cae4187$var$_objectSpread({}, obj[tok]);
        obj = obj[tok];
    }
    if (nextTok === '-' && Array.isArray(obj)) nextTok = obj.length;
    obj[nextTok] = value;
}
function $0d901be78cae4187$export$cd7f480d6b8286c3(obj, pointer) {
    const refTokens = Array.isArray(pointer) ? pointer : $0d901be78cae4187$export$98e6a39c04603d36(pointer);
    const finalToken = refTokens[refTokens.length - 1];
    if (finalToken === undefined) throw new Error('Invalid JSON pointer for remove: "' + pointer + '"');
    const parent = $0d901be78cae4187$export$3988ae62b71be9a3(obj, refTokens.slice(0, -1));
    if (Array.isArray(parent)) {
        const index = +finalToken;
        if (finalToken === '' && isNaN(index)) throw new Error('Invalid array index: "' + finalToken + '"');
        Array.prototype.splice.call(parent, index, 1);
    } else delete parent[finalToken];
}
function $0d901be78cae4187$export$b7eef48498bbd53e(obj) {
    let descend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const results = {};
    $0d901be78cae4187$export$588732934346abbf(obj, (value, pointer)=>{
        results[pointer] = value;
    }, descend);
    return results;
}
function $0d901be78cae4187$export$588732934346abbf(obj, iterator) {
    let descend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const refTokens = [];
    descend = descend || ((value)=>{
        const type = Object.prototype.toString.call(value);
        return type === '[object Object]' || type === '[object Array]';
    });
    $0d901be78cae4187$var$next(obj, refTokens, iterator, descend);
}
function $0d901be78cae4187$var$next(cur, refTokens, iterator, descend) {
    if (Array.isArray(cur)) cur = cur.reduce((acc, cur, i)=>{
        acc[i] = cur;
        return acc;
    }, {});
    let res;
    for(const key in cur){
        refTokens.push(String(key));
        if (descend(cur[key])) res = $0d901be78cae4187$var$next(cur[key], refTokens, iterator, descend);
        else res = iterator(cur[key], $0d901be78cae4187$export$ef7acd7185315e22(refTokens));
        if (res === false) return false;
        refTokens.pop();
    }
}
function $0d901be78cae4187$export$a4f4bb6b1453fff5(obj, pointer) {
    try {
        $0d901be78cae4187$export$3988ae62b71be9a3(obj, pointer);
    } catch (e) {
        return false;
    }
    return true;
}
function $0d901be78cae4187$export$4e7f196112fea3c5(str) {
    return str.toString().replace(/~/g, '~0').replace(/\//g, '~1');
}
function $0d901be78cae4187$export$e8bacd2802a88316(str) {
    return str.replace(/~1/g, '/').replace(/~0/g, '~');
}
function $0d901be78cae4187$export$98e6a39c04603d36(pointer) {
    if (pointer === '') return [];
    if ((pointer === null || pointer === void 0 ? void 0 : pointer.charAt(0)) !== '/') throw new Error('Invalid JSON pointer: ' + pointer);
    return pointer.substring(1).split(/\//).map($0d901be78cae4187$export$e8bacd2802a88316);
}
function $0d901be78cae4187$export$ef7acd7185315e22(refTokens) {
    if (refTokens.length === 0) return '';
    return '/' + refTokens.map($0d901be78cae4187$export$4e7f196112fea3c5).join('/');
}


$parcel$exportWildcard($8b0e7c45585056fa$exports, $0d901be78cae4187$exports);


"use client";
function $e220d71a88fa3fa1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e220d71a88fa3fa1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e220d71a88fa3fa1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e220d71a88fa3fa1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e220d71a88fa3fa1$export$9c634076e0a91d1f() {
    var _props;
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if ((_props = props) !== null && _props !== void 0 && _props.__context__) {
        props = Object.assign({}, props, props.__context__);
        delete props.__context__;
    }
    const translations = props.translations || props.locales ? (0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039), props.translations || props.locales) : (0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039));
    const localeWithFallback = $e220d71a88fa3fa1$var$handleLocaleFallbacks(props.locale || (0, $07b61efe40a5ad0e$export$9824d860d0b120d9), translations);
    const translation = $e220d71a88fa3fa1$export$ecdd031587aebaa5((0, $11741836d1790446$export$b29aee33601cce38)({}, (0, $cd34253258a667c2$export$2e2bcd8739ae039)[0, $07b61efe40a5ad0e$export$9824d860d0b120d9], translations[localeWithFallback]));
    const context = $e220d71a88fa3fa1$var$_objectSpread($e220d71a88fa3fa1$var$_objectSpread({}, props), {}, {
        updateTranslation: (locale, newTranslations)=>{
            context.translation = newTranslations[locale] || newTranslations[0, $07b61efe40a5ad0e$export$9824d860d0b120d9];
            context.translation = $e220d71a88fa3fa1$export$ecdd031587aebaa5(context.translation);
            context.translations = newTranslations;
            if (context.locales) context.locales = context.translations;
        },
        getTranslation: (localProps)=>{
            if (localProps) {
                const locale = localProps.lang || localProps.locale;
                if (locale && (context.translations || context.locales)[locale] && locale !== localeWithFallback) return $e220d71a88fa3fa1$export$ecdd031587aebaa5((context.translations || context.locales)[locale]);
            }
            return context.translation || (0, $cd34253258a667c2$export$2e2bcd8739ae039)[0, $07b61efe40a5ad0e$export$9824d860d0b120d9];
        },
        locales: translations,
        translations: translations,
        translation: translation
    });
    return $e220d71a88fa3fa1$var$_objectSpread({}, context);
}
function $e220d71a88fa3fa1$var$handleLocaleFallbacks(locale) {
    let translations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (locale === 'en' || String(locale).split('-')[0] === 'en') return 'en-GB';
    return translations[locale] ? locale : (0, $07b61efe40a5ad0e$export$9824d860d0b120d9);
}
const $e220d71a88fa3fa1$var$Context = (0, $ieaan.createContext)($e220d71a88fa3fa1$export$9c634076e0a91d1f({
    locale: (0, $07b61efe40a5ad0e$export$9824d860d0b120d9),
    currency: (0, $07b61efe40a5ad0e$export$ebe860a2db7990ad),
    currency_display: (0, $07b61efe40a5ad0e$export$dfbea0c7aa245503)
}));
var $e220d71a88fa3fa1$export$2e2bcd8739ae039 = $e220d71a88fa3fa1$var$Context;
function $e220d71a88fa3fa1$export$ecdd031587aebaa5(source) {
    for(const k in source)if (String(k).includes('.')) (0, $8b0e7c45585056fa$exports).set(source, '/' + k.replace(/\./g, '/'), source[k]);
    return source;
}






parcelRequire("3SQhX");

const $9a6e1a0e3c9a63a2$var$_excluded = [
    "space",
    "innerSpace",
    "top",
    "bottom",
    "left",
    "right"
];
function $9a6e1a0e3c9a63a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a6e1a0e3c9a63a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a6e1a0e3c9a63a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a6e1a0e3c9a63a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9a6e1a0e3c9a63a2$export$a46e7b2715edbfac = {
    space: null,
    innerSpace: null,
    top: null,
    right: null,
    bottom: null,
    left: null
};
const $9a6e1a0e3c9a63a2$export$a74ea660b7fc1317 = {
    'xx-small': 0.25,
    'x-small': 0.5,
    small: 1,
    medium: 1.5,
    large: 2,
    'x-large': 3,
    'xx-large': 3.5,
    'xx-large-x2': 7
};
globalThis.CALC_CACHE = {};
const $9a6e1a0e3c9a63a2$export$42bfa9b2d4dad91a = function() {
    for(var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++)types[_key] = arguments[_key];
    const hash = types.join('|');
    if (globalThis.CALC_CACHE[hash]) return globalThis.CALC_CACHE[hash];
    const result = [];
    types.forEach((rawTypes)=>{
        $9a6e1a0e3c9a63a2$export$98a895390d0f29a0(rawTypes).forEach((type)=>{
            result.push(`var(--spacing-${type})`);
        });
    });
    return result.length ? globalThis.CALC_CACHE[hash] = `calc(${result.join(' + ')})` : null;
};
const $9a6e1a0e3c9a63a2$export$bf9e5e8342b9e38f = (props)=>{
    if (props !== null && props !== void 0 && props.innerSpace) return $9a6e1a0e3c9a63a2$var$computeProperties(props.innerSpace);
    return {};
};
function $9a6e1a0e3c9a63a2$var$hasMediaSize(media) {
    const keys = Object.keys(media);
    return keys.includes('small') || keys.includes('medium') || keys.includes('large');
}
function $9a6e1a0e3c9a63a2$var$hasSize(space) {
    const keys = Object.keys(space);
    return keys.includes('top') || keys.includes('right') || keys.includes('bottom') || keys.includes('left');
}
function $9a6e1a0e3c9a63a2$var$computeProperties(space) {
    if (!$9a6e1a0e3c9a63a2$var$hasMediaSize(space)) space = {
        small: space,
        medium: space,
        large: space
    };
    const result = {};
    for(const size in space){
        var _space;
        const value = (_space = space) === null || _space === void 0 ? void 0 : _space[size];
        const props = $9a6e1a0e3c9a63a2$var$transformToAll(value);
        for(const key in props)if ($9a6e1a0e3c9a63a2$export$3eec253e4a999ac(key)) {
            const cur = props[key];
            const name = `--space-${key[0]}-${size[0]}`;
            if (String(cur) === '0' || String(cur) === 'false') result[name] = '0';
            else if (cur) {
                const typeModifiers = $9a6e1a0e3c9a63a2$export$98a895390d0f29a0(cur);
                const sum = $9a6e1a0e3c9a63a2$export$242e3b0ba02ab57b(typeModifiers);
                result[name] = `${sum}rem`;
            }
        }
    }
    return result;
}
function $9a6e1a0e3c9a63a2$var$transformToAll(value) {
    let result = value;
    if (!$9a6e1a0e3c9a63a2$var$hasSize(value)) result = {
        top: value,
        right: value,
        bottom: value,
        left: value
    };
    return result;
}
const $9a6e1a0e3c9a63a2$export$4b11373d92b857f4 = function(props) {
    let elementName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const p = Object.isFrozen(props) ? $9a6e1a0e3c9a63a2$var$_objectSpread({}, props) : props;
    if (typeof p.space !== 'undefined') {
        if (typeof p.space === 'string' || typeof p.space === 'number' || typeof p.space === 'boolean' && p.space) {
            var _p$left, _p$bottom, _p$right, _p$top;
            p.left = (_p$left = p.left) !== null && _p$left !== void 0 ? _p$left : p.space;
            p.bottom = (_p$bottom = p.bottom) !== null && _p$bottom !== void 0 ? _p$bottom : p.space;
            p.right = (_p$right = p.right) !== null && _p$right !== void 0 ? _p$right : p.space;
            p.top = (_p$top = p.top) !== null && _p$top !== void 0 ? _p$top : p.space;
        }
        if (typeof p.space === 'object') {
            for(const i in p.space)if (!p[i] && $9a6e1a0e3c9a63a2$export$3eec253e4a999ac(i)) p[i] = p.space[i];
        }
        delete p.space;
    }
    return Object.entries(p).reduce((acc, _ref)=>{
        let [direction, cur] = _ref;
        if ($9a6e1a0e3c9a63a2$export$3eec253e4a999ac(direction) && direction !== 'innerSpace') {
            if (String(cur) === '0' || String(cur) === 'false') acc.push(`dnb-space__${direction}--zero`);
            else if (cur) {
                const typeModifiers = $9a6e1a0e3c9a63a2$export$98a895390d0f29a0(cur);
                const sum = $9a6e1a0e3c9a63a2$export$242e3b0ba02ab57b(typeModifiers);
                if (sum > 10) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`Spacing of more than 10rem is not supported! You used ${sum} / (${typeModifiers.join(',')})`);
                else {
                    const nearestTypes = $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1(sum, true);
                    acc = [
                        ...acc,
                        ...nearestTypes.map((type)=>`dnb-space__${direction}--${type}`)
                    ];
                }
            }
        } else if (direction === 'no_collapse') {
            acc.push('dnb-space--no-collapse');
            if (elementName && $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e(elementName)) acc.push('dnb-space--inline');
        }
        return acc;
    }, []);
};
const $9a6e1a0e3c9a63a2$export$60fa8e172c58e469 = (type)=>{
    if (/-x2$/.test(String(type))) return $9a6e1a0e3c9a63a2$export$a74ea660b7fc1317[String(type).replace(/-x2$/, '')] * 2;
    return $9a6e1a0e3c9a63a2$export$a74ea660b7fc1317[String(type)] || 0;
};
const $9a6e1a0e3c9a63a2$export$18e0705ec1565a40 = (types)=>{
    if (typeof types === 'string') {
        const test = types.split(/ /g);
        return clean(test);
    } else if (typeof types === 'boolean') return [
        types ? 'small' : 0
    ];
    else if (typeof types === 'number') return [
        types
    ];
    return clean(types) || null;
    function clean(t) {
        return t === null || t === void 0 ? void 0 : t.filter((r)=>r && String(r).length > 0);
    }
};
const $9a6e1a0e3c9a63a2$export$242e3b0ba02ab57b = (types)=>$9a6e1a0e3c9a63a2$export$18e0705ec1565a40(types).map((type)=>$9a6e1a0e3c9a63a2$export$60fa8e172c58e469(type)).reduce((acc, cur)=>{
        if (cur > 0) acc += cur;
        else if (cur < 0) acc -= cur;
        return acc;
    }, 0);
const $9a6e1a0e3c9a63a2$export$98a895390d0f29a0 = (types)=>{
    return ($9a6e1a0e3c9a63a2$export$18e0705ec1565a40(types) || []).reduce((acc, type)=>{
        if (type) {
            const firstLetter = String(type)[0];
            if (parseFloat(firstLetter) > -1) {
                let num = parseFloat(String(type));
                if (num >= 8 && /[0-9]px/.test(String(type))) num = num / 16;
                const foundType = $9a6e1a0e3c9a63a2$export$d35f3ef497fe5c30(num);
                if (foundType) type = foundType;
                else $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1(num).forEach((type)=>{
                    if (type) acc.push(type);
                });
            }
            if (!(parseFloat(String(type)) > 0)) acc.push(type);
        }
        return acc;
    }, []);
};
const $9a6e1a0e3c9a63a2$export$d35f3ef497fe5c30 = (num)=>{
    const found = $9a6e1a0e3c9a63a2$export$3bc20d5818d8843(num);
    if (found) return found[0];
    return null;
};
const $9a6e1a0e3c9a63a2$export$3bc20d5818d8843 = (num)=>{
    const listOfSpacePatterns = Object.entries($9a6e1a0e3c9a63a2$export$a74ea660b7fc1317);
    const found = listOfSpacePatterns.find((_ref2)=>{
        let [k, v] = _ref2;
        return k && v === num;
    }) || null;
    return found;
};
const $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1 = function(num) {
    let multiply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let res = [];
    const near = Object.entries($9a6e1a0e3c9a63a2$export$a74ea660b7fc1317).reverse().filter((k)=>multiply ? true : !k[0].includes('-x')).find((_ref3)=>{
        let [k, v] = _ref3;
        return k && num >= v;
    });
    const nearNum = near && near[1] || num;
    const types = $9a6e1a0e3c9a63a2$export$3bc20d5818d8843(nearNum);
    if (types) {
        const nearType = types[0];
        res.push(nearType);
        const leftOver = num - parseFloat(String(types[1]));
        const foundMoreTypes = $9a6e1a0e3c9a63a2$export$3c46c89fd087dda1(leftOver, multiply);
        foundMoreTypes.forEach((type)=>{
            const index = res.indexOf(type);
            if (index !== -1) res[index] = multiply ? `${type}-x2` : type;
        });
        res = [
            ...res,
            ...foundMoreTypes
        ];
    }
    return res;
};
const $9a6e1a0e3c9a63a2$export$3eec253e4a999ac = (propName)=>propName && [
        'top',
        'right',
        'bottom',
        'left',
        'space',
        'innerSpace'
    ].includes(propName);
const $9a6e1a0e3c9a63a2$export$e275e554c9b8899e = (props)=>{
    const { space: space, innerSpace: innerSpace, top: top, bottom: bottom, left: left, right: right } = props, restProps = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $9a6e1a0e3c9a63a2$var$_excluded);
    return restProps;
};
const $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e = (elementName)=>{
    switch(elementName){
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
        case 'p':
            return true;
    }
    return false;
};






var $ieaan = parcelRequire("ieaan");



var $ljfqi = parcelRequire("ljfqi");
const $cf2e6f3341d791ce$var$_excluded = [
    "className",
    "children",
    "__element",
    "style"
];
function $cf2e6f3341d791ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf2e6f3341d791ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf2e6f3341d791ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf2e6f3341d791ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a = function(params, skeleton) {
    let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if ((0, $11741836d1790446$export$7afc298d8ffd816)(skeleton) || skeleton !== false && context !== null && context !== void 0 && context.skeleton) {
        var _context$translation, _context$translation$;
        params.disabled = true;
        params['aria-disabled'] = true;
        params['aria-label'] = context === null || context === void 0 ? void 0 : (_context$translation = context.translation) === null || _context$translation === void 0 ? void 0 : (_context$translation$ = _context$translation.Skeleton) === null || _context$translation$ === void 0 ? void 0 : _context$translation$.aria_busy;
    }
    return params;
};
const $cf2e6f3341d791ce$export$4165d624d0b91f0d = function(method, skeleton) {
    let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if ((0, $11741836d1790446$export$7afc298d8ffd816)(skeleton) || skeleton !== false && context !== null && context !== void 0 && context.skeleton) return (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(className, 'dnb-skeleton', method && `dnb-skeleton--${method}`);
    return className;
};
class $cf2e6f3341d791ce$export$c8a403edd36250a extends (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).PureComponent {
    render() {
        const _this$props = this.props, { className: className, children: children, __element: Comp, style: style } = _this$props, props = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_this$props, $cf2e6f3341d791ce$var$_excluded);
        const string = (0, $11741836d1790446$export$5bfc594bd2dc6e21)(children);
        if (typeof string === 'string') {
            const countChars = string.trim().length;
            if (countChars > 0) return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Comp, $cf2e6f3341d791ce$var$_objectSpread({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))("dnb-skeleton dnb-skeleton--font", className),
                'data-skeleton-chars': String(countChars),
                style: $cf2e6f3341d791ce$var$_objectSpread($cf2e6f3341d791ce$var$_objectSpread({}, style || {}), {}, {
                    '--skeleton-chars': `${countChars}ch`
                })
            }, props), children);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Comp, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, props, {
            className: className,
            style: style
        }));
    }
}
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($cf2e6f3341d791ce$export$c8a403edd36250a, "defaultProps", {
    __element: null,
    children: null,
    className: null,
    style: null
});






var $ieaan = parcelRequire("ieaan");
var $9bb40a131bb21204$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bb40a131bb21204$var$ReactIs, $9bb40a131bb21204$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$9bb40a131bb21204$exports = (parcelRequire("iW5Se"))();



var $ljfqi = parcelRequire("ljfqi");





function $c81beeaa1b3509d1$export$4fb86125780c91c0(props, validKeys, excludeKeys) {
    const res = {};
    const o = Object.prototype.hasOwnProperty;
    for(const key in props)if ((!validKeys || validKeys && o.call(validKeys, key)) && (!excludeKeys || excludeKeys && !o.call(excludeKeys, key))) res[key] = props[key];
    return res;
}
function $c81beeaa1b3509d1$export$8efbf5589742246(props, excludeProps) {
    return $c81beeaa1b3509d1$export$4fb86125780c91c0(props, $c81beeaa1b3509d1$var$validFormElementProps, excludeProps);
}
function $c81beeaa1b3509d1$export$c37735b23b2df049(props) {
    if ((0, $11741836d1790446$export$7afc298d8ffd816)(props.vertical)) {
        if (typeof props.labelDirection === 'undefined') props.labelDirection = 'vertical';
        if (typeof props.label_direction === 'undefined') props.label_direction = 'vertical';
    }
    return props;
}
const $c81beeaa1b3509d1$var$validFormElementProps = {
    skeleton: null,
    disabled: null,
    vertical: null,
    labelDirection: null,
    label_direction: null
};




var $ieaan = parcelRequire("ieaan");





parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");
const $7d158d8918c84be4$export$d96669d157c00c70 = 100;
const $7d158d8918c84be4$export$9bc82c3a98fe6dc = 500;
function $7d158d8918c84be4$export$f42bc933f51d0006(error) {
    let { message: message } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        message: null
    };
    let code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $7d158d8918c84be4$export$d96669d157c00c70;
    let thisError = this && this.err;
    if (typeof error === 'object') message = error.message;
    if (thisError) thisError = new Error(`${error}\n\n${message}`);
    if (code === $7d158d8918c84be4$export$9bc82c3a98fe6dc) throw thisError;
    else console.log(thisError);
}







const $17c197fe5e85d9a5$export$126bd5ddaa4ee61e = (name)=>String(name).replace(/((?!^)[A-Z])/g, '_$1').toLowerCase().replace(/^[0-9]/g, '$1').replace(/[^a-z0-9_]/gi, '_');


"use client";
const $18e1fb7032604f9e$var$_excluded = [
    "sizeAsString"
], $18e1fb7032604f9e$var$_excluded2 = [
    "icon",
    "size",
    "width",
    "height",
    "border",
    "color",
    "inheritColor",
    "inherit_color",
    "modifier",
    "alt",
    "title",
    "skeleton",
    "className"
];
var $18e1fb7032604f9e$var$_Fragment;
function $18e1fb7032604f9e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $18e1fb7032604f9e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $18e1fb7032604f9e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $18e1fb7032604f9e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $18e1fb7032604f9e$export$319c661b2c32450 = 16;
const $18e1fb7032604f9e$export$abf30d92431bd688 = {
    default: 16,
    medium: 24
};
const $18e1fb7032604f9e$export$52256abe9722101 = [
    [
        'default',
        16
    ],
    [
        'medium',
        24
    ]
];
const $18e1fb7032604f9e$export$973d29e2233a6203 = [
    'small',
    'default',
    'medium',
    'large',
    'x-large',
    'xx-large'
];
function $18e1fb7032604f9e$export$2e2bcd8739ae039(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, {}, {
        skeleton: context === null || context === void 0 ? void 0 : context.skeleton
    }, context.Icon);
    const { icon: iconProp, size: size, wrapperParams: wrapperParams, iconParams: iconParams, alt: alt, children: children } = $18e1fb7032604f9e$export$dbac4b0afb3666a7(props, context);
    const icon = iconProp !== null && iconProp !== void 0 ? iconProp : children;
    if (!icon) return null;
    const IconContainer = $18e1fb7032604f9e$export$20da8aa394d9a3ff({
        icon: icon,
        size: size,
        alt: alt
    });
    if (!IconContainer) return $18e1fb7032604f9e$var$_Fragment || ($18e1fb7032604f9e$var$_Fragment = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", wrapperParams, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(IconContainer, iconParams));
}
function $18e1fb7032604f9e$export$3168922d086c8fe7(icon) {
    var _icon;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(icon) && (_icon = icon) !== null && _icon !== void 0 && _icon.type) {
        var _icon2;
        icon = (_icon2 = icon) === null || _icon2 === void 0 ? void 0 : _icon2.type;
    }
    const name = typeof icon === 'function' ? icon.name : String(icon);
    if (/^data:image\//.test(name)) return null;
    return name;
}
function $18e1fb7032604f9e$export$ffb38d77b69e936e(props) {
    const { icon: icon, size: size, width: width, height: height } = props;
    let sizeAsInt = null;
    let sizeAsString = null;
    if (!size || size === $18e1fb7032604f9e$export$319c661b2c32450) {
        const name = $18e1fb7032604f9e$export$3168922d086c8fe7(icon);
        const nameParts = String(name || '').split('_');
        if (nameParts.length > 1) {
            var _ListDefaultIconSizes, _ListDefaultIconSizes2;
            const lastPartOfIconName = nameParts.reverse()[0];
            const potentialSize = (_ListDefaultIconSizes = $18e1fb7032604f9e$export$52256abe9722101.filter((_ref)=>{
                let [key] = _ref;
                return key === lastPartOfIconName;
            })) === null || _ListDefaultIconSizes === void 0 ? void 0 : (_ListDefaultIconSizes2 = _ListDefaultIconSizes[0]) === null || _ListDefaultIconSizes2 === void 0 ? void 0 : _ListDefaultIconSizes2[1];
            if (potentialSize) sizeAsInt = potentialSize;
            if ($18e1fb7032604f9e$export$973d29e2233a6203.includes(lastPartOfIconName)) sizeAsString = lastPartOfIconName;
        } else if (typeof icon === 'function') {
            const elem = icon();
            if (elem.props) {
                let potentialSize = null;
                if (elem.props.width) potentialSize = elem.props.width;
                if (!potentialSize && elem.props.viewBox) potentialSize = parseFloat(/[0-9]+ [0-9]+ ([0-9]+)/.exec(elem.props.viewBox)[1]);
                if (!isNaN(potentialSize)) sizeAsInt = potentialSize;
            }
        }
    } else if (typeof size === 'string' && !(parseFloat(size) > 0)) {
        var _ListDefaultIconSizes3, _ListDefaultIconSizes4, _ListDefaultIconSizes5;
        sizeAsInt = (_ListDefaultIconSizes3 = (_ListDefaultIconSizes4 = $18e1fb7032604f9e$export$52256abe9722101.filter((_ref2)=>{
            let [key] = _ref2;
            return key === size;
        })) === null || _ListDefaultIconSizes4 === void 0 ? void 0 : (_ListDefaultIconSizes5 = _ListDefaultIconSizes4[0]) === null || _ListDefaultIconSizes5 === void 0 ? void 0 : _ListDefaultIconSizes5[1]) !== null && _ListDefaultIconSizes3 !== void 0 ? _ListDefaultIconSizes3 : -1;
        if ($18e1fb7032604f9e$export$973d29e2233a6203.includes(size)) sizeAsString = size;
    } else if (parseFloat(String(size)) > 0) {
        var _ListDefaultIconSizes6, _ListDefaultIconSizes7, _ListDefaultIconSizes8;
        sizeAsInt = (_ListDefaultIconSizes6 = (_ListDefaultIconSizes7 = $18e1fb7032604f9e$export$52256abe9722101.filter((_ref3)=>{
            let [key, value] = _ref3;
            return key && value === parseFloat(String(size));
        })) === null || _ListDefaultIconSizes7 === void 0 ? void 0 : (_ListDefaultIconSizes8 = _ListDefaultIconSizes7[0]) === null || _ListDefaultIconSizes8 === void 0 ? void 0 : _ListDefaultIconSizes8[1]) !== null && _ListDefaultIconSizes6 !== void 0 ? _ListDefaultIconSizes6 : -1;
        if (sizeAsInt === -1) {
            sizeAsInt = parseFloat(String(size));
            sizeAsString = 'custom-size';
        }
    }
    if (!sizeAsString && sizeAsInt > 0) {
        const potentialSizeAsString = $18e1fb7032604f9e$export$52256abe9722101.reduce((acc, _ref4)=>{
            let [key, value] = _ref4;
            if (key && value === sizeAsInt) return key;
            return acc;
        }, null);
        if (potentialSizeAsString) sizeAsString = potentialSizeAsString;
    }
    const { sizeAsString: isCustomSize, params: iconParams } = $18e1fb7032604f9e$var$prepareIconParams({
        sizeAsString: sizeAsString,
        sizeAsInt: sizeAsInt,
        size: size,
        width: width,
        height: height
    });
    if (isCustomSize) sizeAsString = isCustomSize;
    if (!(sizeAsInt > 0)) sizeAsInt = $18e1fb7032604f9e$export$319c661b2c32450;
    if (size === 'auto') {
        iconParams.width = '100%';
        iconParams.height = '100%';
        sizeAsString = 'auto';
    }
    return {
        iconParams: iconParams,
        sizeAsInt: sizeAsInt,
        sizeAsString: sizeAsString
    };
}
function $18e1fb7032604f9e$var$prepareIconParams(_ref5) {
    let { sizeAsString: sizeAsString } = _ref5, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref5, $18e1fb7032604f9e$var$_excluded);
    const { size: size, width: width, height: height, sizeAsInt: sizeAsInt } = rest;
    const params = {};
    if (!sizeAsString && !(sizeAsInt > 0) && parseFloat(String(size)) > -1) params.width = params.height = parseFloat(String(size));
    else if (sizeAsString === 'custom-size') params.width = params.height = parseFloat(String(sizeAsInt));
    if (parseFloat(String(width)) > -1) {
        sizeAsString = 'custom-size';
        params.width = parseFloat(String(width));
    }
    if (parseFloat(String(height)) > -1) {
        sizeAsString = 'custom-size';
        params.height = parseFloat(String(height));
    }
    (0, $11741836d1790446$export$4ddc669a9a6a5940)({}, params);
    return {
        params: params,
        sizeAsString: sizeAsString
    };
}
function $18e1fb7032604f9e$export$dbac4b0afb3666a7(props, context) {
    const { icon: icon, size: size, width: width, height: height, border: border, color: color, inheritColor: inheritColor, inherit_color: inherit_color, modifier: modifier, alt: alt, title: title, skeleton: skeleton, className: className } = props, attributes = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $18e1fb7032604f9e$var$_excluded2);
    const { sizeAsString: sizeAsString, iconParams: iconParams } = $18e1fb7032604f9e$export$ffb38d77b69e936e({
        icon: icon,
        size: size,
        width: width,
        height: height
    });
    if (color) iconParams.color = color;
    const label = icon ? $18e1fb7032604f9e$export$3168922d086c8fe7(icon) : null;
    const wrapperParams = (0, $11741836d1790446$export$4ddc669a9a6a5940)(props, $18e1fb7032604f9e$var$_objectSpread({
        role: alt ? 'img' : 'presentation',
        alt: alt,
        'aria-label': label && !label.includes('default') ? label.replace(/_/g, ' ') + ' icon' : null,
        title: title
    }, attributes));
    if (!alt && typeof wrapperParams['aria-hidden'] === 'undefined') wrapperParams['aria-hidden'] = true;
    if (wrapperParams['aria-hidden']) {
        wrapperParams['data-testid'];
        delete wrapperParams['aria-label'];
    }
    wrapperParams.className = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-icon', sizeAsString ? `dnb-icon--${sizeAsString}` : 'dnb-icon--default', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(null, skeleton, context), (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(props), className, modifier && `dnb-icon--${modifier}`, border && 'dnb-icon--border', (inheritColor !== null && inheritColor !== void 0 ? inheritColor : inherit_color) !== false && 'dnb-icon--inherit-color');
    let iconToRender = $18e1fb7032604f9e$var$getIcon(props);
    if (iconToRender && typeof iconToRender.defaultProps !== 'undefined') iconToRender = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(iconToRender, (0, $11741836d1790446$export$4ddc669a9a6a5940)({}, {
        color: color,
        icon: icon,
        size: size,
        width: width,
        height: height
    }));
    return $18e1fb7032604f9e$var$_objectSpread($18e1fb7032604f9e$var$_objectSpread({}, props), {}, {
        icon: iconToRender,
        alt: alt,
        iconParams: iconParams,
        wrapperParams: wrapperParams
    });
}
function $18e1fb7032604f9e$export$20da8aa394d9a3ff(props) {
    const { size: size = null, listOfIcons: listOfIcons = null, alt: alt = null } = props;
    let { icon: icon } = props;
    if (typeof icon === 'string' && /^data:image\//.test(icon)) return ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("img", {
            src: String(icon),
            alt: alt || 'no-alt'
        });
    if (typeof icon === 'function') {
        const elem = icon();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(elem)) return icon;
        return elem;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(icon) || Array.isArray(icon)) return ()=>icon;
    try {
        icon = (0, $17c197fe5e85d9a5$export$126bd5ddaa4ee61e)(icon);
        if (size && $18e1fb7032604f9e$export$abf30d92431bd688[size] && size !== 'basis' && size !== 'default' && !(parseFloat(String(size)) > 0) && !icon.includes(size)) icon = `${icon}_${size}`;
        const mod = (listOfIcons.dnbIcons ? listOfIcons.dnbIcons : listOfIcons)[icon];
        return mod && mod.default ? mod.default : mod;
    } catch (e) {
        (0, $7d158d8918c84be4$export$f42bc933f51d0006)(`Icon '${icon}' did not exist!`);
        return null;
    }
}
function $18e1fb7032604f9e$var$getIcon(props) {
    if (props.icon) return props.icon;
    return (0, $5cdea43e47e2bcbb$export$51751cece1adcf33)(props);
}
$18e1fb7032604f9e$export$2e2bcd8739ae039._supportsSpacingProps = true;


var $1b716dc1cd8c4f3d$exports = {};

$parcel$export($1b716dc1cd8c4f3d$exports, "add", function () { return $9a54021c8c6f6897$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_down", function () { return $5aee06c6fc066da5$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_left", function () { return $8babd7d7600991e7$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_right", function () { return $079e46673ec03c5e$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "arrow_up", function () { return $ae30ddfe9ad8c794$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "bell", function () { return $b8b6cde80f792eaf$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "calendar", function () { return $e0e3e6756100882c$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "check", function () { return $e1eb14feba73fda7$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_down", function () { return $b92167770415d548$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_left", function () { return $caf45c133b27358d$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_right", function () { return $13d0d04576b49b35$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "chevron_up", function () { return $920948a19cb7e62b$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "close", function () { return $65cc4599df394246$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "download", function () { return $de01eaf7c361be3d$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "exclamation", function () { return $a6c3aec677391eef$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "information", function () { return $a8e4075cfe4eba94$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "loupe", function () { return $b8531b951e273ce2$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "more", function () { return $5a6006ddc7c84806$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "question", function () { return $24c044af95424c5c$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "reset", function () { return $ccec2cab17a546b6$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "save", function () { return $24ff9e3b07a8f88f$export$2e2bcd8739ae039; });
$parcel$export($1b716dc1cd8c4f3d$exports, "subtract", function () { return $d40f7ac5f17f0080$export$2e2bcd8739ae039; });


var $ieaan = parcelRequire("ieaan");
var $9a54021c8c6f6897$var$_path;
const $9a54021c8c6f6897$var$add = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $9a54021c8c6f6897$var$_path || ($9a54021c8c6f6897$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M8 14V2m6 6H2"
    })));
var $9a54021c8c6f6897$export$2e2bcd8739ae039 = $9a54021c8c6f6897$var$add;




var $ieaan = parcelRequire("ieaan");
var $5aee06c6fc066da5$var$_path;
const $5aee06c6fc066da5$var$arrow_down = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $5aee06c6fc066da5$var$_path || ($5aee06c6fc066da5$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m3 9.75 5 5m0 0 5-5m-5 5V1.25"
    })));
var $5aee06c6fc066da5$export$2e2bcd8739ae039 = $5aee06c6fc066da5$var$arrow_down;




var $ieaan = parcelRequire("ieaan");
var $8babd7d7600991e7$var$_path;
const $8babd7d7600991e7$var$arrow_left = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $8babd7d7600991e7$var$_path || ($8babd7d7600991e7$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M14.5 8H1m5-5L1 8m0 0 5 5"
    })));
var $8babd7d7600991e7$export$2e2bcd8739ae039 = $8babd7d7600991e7$var$arrow_left;




var $ieaan = parcelRequire("ieaan");
var $079e46673ec03c5e$var$_path;
const $079e46673ec03c5e$var$arrow_right = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $079e46673ec03c5e$var$_path || ($079e46673ec03c5e$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M1.5 8H15m-5 5 5-5m0 0-5-5"
    })));
var $079e46673ec03c5e$export$2e2bcd8739ae039 = $079e46673ec03c5e$var$arrow_right;




var $ieaan = parcelRequire("ieaan");
var $ae30ddfe9ad8c794$var$_path;
const $ae30ddfe9ad8c794$var$arrow_up = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $ae30ddfe9ad8c794$var$_path || ($ae30ddfe9ad8c794$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m3 6.25 5-5m0 0 5 5m-5-5v13.5"
    })));
var $ae30ddfe9ad8c794$export$2e2bcd8739ae039 = $ae30ddfe9ad8c794$var$arrow_up;




var $ieaan = parcelRequire("ieaan");
var $b8b6cde80f792eaf$var$_path;
const $b8b6cde80f792eaf$var$bell = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $b8b6cde80f792eaf$var$_path || ($b8b6cde80f792eaf$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M6.756 14.067a1.299 1.299 0 0 0 2.492 0M8 2.4a4.667 4.667 0 0 1 4.667 4.667c0 4.384.933 5.133.933 5.133H2.4s.933-1.192.933-5.133A4.667 4.667 0 0 1 8 2.4Zm0 0V1"
    })));
var $b8b6cde80f792eaf$export$2e2bcd8739ae039 = $b8b6cde80f792eaf$var$bell;




var $ieaan = parcelRequire("ieaan");
var $e0e3e6756100882c$var$_path;
const $e0e3e6756100882c$var$calendar = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $e0e3e6756100882c$var$_path || ($e0e3e6756100882c$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M5.256 1v3.256M10.75 1v3.256M1 7.5V3.628a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1V7.5m-14 0V14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7.5m-14 0h14"
    })));
var $e0e3e6756100882c$export$2e2bcd8739ae039 = $e0e3e6756100882c$var$calendar;




var $ieaan = parcelRequire("ieaan");
var $e1eb14feba73fda7$var$_path;
const $e1eb14feba73fda7$var$check = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $e1eb14feba73fda7$var$_path || ($e1eb14feba73fda7$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m1 10 4 4L15 2"
    })));
var $e1eb14feba73fda7$export$2e2bcd8739ae039 = $e1eb14feba73fda7$var$check;




var $ieaan = parcelRequire("ieaan");
var $b92167770415d548$var$_path;
const $b92167770415d548$var$chevron_down = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $b92167770415d548$var$_path || ($b92167770415d548$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m13 5.5-5 5-5-5"
    })));
var $b92167770415d548$export$2e2bcd8739ae039 = $b92167770415d548$var$chevron_down;




var $ieaan = parcelRequire("ieaan");
var $caf45c133b27358d$var$_path;
const $caf45c133b27358d$var$chevron_left = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $caf45c133b27358d$var$_path || ($caf45c133b27358d$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M10 3 5 8l5 5"
    })));
var $caf45c133b27358d$export$2e2bcd8739ae039 = $caf45c133b27358d$var$chevron_left;




var $ieaan = parcelRequire("ieaan");
var $13d0d04576b49b35$var$_path;
const $13d0d04576b49b35$var$chevron_right = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $13d0d04576b49b35$var$_path || ($13d0d04576b49b35$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m6 13 5-5-5-5"
    })));
var $13d0d04576b49b35$export$2e2bcd8739ae039 = $13d0d04576b49b35$var$chevron_right;




var $ieaan = parcelRequire("ieaan");
var $920948a19cb7e62b$var$_path;
const $920948a19cb7e62b$var$chevron_up = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $920948a19cb7e62b$var$_path || ($920948a19cb7e62b$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m3 10.5 5-5 5 5"
    })));
var $920948a19cb7e62b$export$2e2bcd8739ae039 = $920948a19cb7e62b$var$chevron_up;




var $ieaan = parcelRequire("ieaan");
var $65cc4599df394246$var$_path;
const $65cc4599df394246$var$close = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $65cc4599df394246$var$_path || ($65cc4599df394246$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M3 13 13 3m0 10L3 3"
    })));
var $65cc4599df394246$export$2e2bcd8739ae039 = $65cc4599df394246$var$close;




var $ieaan = parcelRequire("ieaan");
var $de01eaf7c361be3d$var$_path;
const $de01eaf7c361be3d$var$download = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $de01eaf7c361be3d$var$_path || ($de01eaf7c361be3d$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M5.344 8.281 8 10.937m0 0 2.656-2.656M8 10.937V2.5M3 14h10"
    })));
var $de01eaf7c361be3d$export$2e2bcd8739ae039 = $de01eaf7c361be3d$var$download;




var $ieaan = parcelRequire("ieaan");
var $a6c3aec677391eef$var$_path;
const $a6c3aec677391eef$var$exclamation = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $a6c3aec677391eef$var$_path || ($a6c3aec677391eef$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M8 10.412V2m-.177 11.519h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    })));
var $a6c3aec677391eef$export$2e2bcd8739ae039 = $a6c3aec677391eef$var$exclamation;




var $ieaan = parcelRequire("ieaan");
var $a8e4075cfe4eba94$var$_path;
const $a8e4075cfe4eba94$var$information = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $a8e4075cfe4eba94$var$_path || ($a8e4075cfe4eba94$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M9.914 13.5h-.75a1.5 1.5 0 0 1-1.498-1.499V6.914a.75.75 0 0 0-.75-.75h-.75m.825-3.487h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    })));
var $a8e4075cfe4eba94$export$2e2bcd8739ae039 = $a8e4075cfe4eba94$var$information;




var $ieaan = parcelRequire("ieaan");
var $b8531b951e273ce2$var$_path;
const $b8531b951e273ce2$var$loupe = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $b8531b951e273ce2$var$_path || ($b8531b951e273ce2$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M11.5 11.5 15 15m-3.182-8.59A5.41 5.41 0 1 1 1 6.41a5.41 5.41 0 0 1 10.818 0Z"
    })));
var $b8531b951e273ce2$export$2e2bcd8739ae039 = $b8531b951e273ce2$var$loupe;




var $ieaan = parcelRequire("ieaan");
var $5a6006ddc7c84806$var$_path;
const $5a6006ddc7c84806$var$more = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $5a6006ddc7c84806$var$_path || ($5a6006ddc7c84806$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        fill: "#000",
        d: "M4.5 8A1.25 1.25 0 1 1 2 8a1.25 1.25 0 0 1 2.5 0ZM8 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
    })));
var $5a6006ddc7c84806$export$2e2bcd8739ae039 = $5a6006ddc7c84806$var$more;




var $ieaan = parcelRequire("ieaan");
var $24c044af95424c5c$var$_path;
const $24c044af95424c5c$var$question = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $24c044af95424c5c$var$_path || ($24c044af95424c5c$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M5.392 4.876c0-1.642 1.452-2.98 3.074-2.868 1.638.113 2.874 1.653 2.65 3.264a2.923 2.923 0 0 1-1.89 2.316c-1.216.43-.958 1.9-.958 2.913m-.177 3.004h.346m.079 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    })));
var $24c044af95424c5c$export$2e2bcd8739ae039 = $24c044af95424c5c$var$question;




var $ieaan = parcelRequire("ieaan");
var $ccec2cab17a546b6$var$_path;
const $ccec2cab17a546b6$var$reset = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $ccec2cab17a546b6$var$_path || ($ccec2cab17a546b6$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        fill: "#000",
        d: "m5.333 14.474.634-.401-.128-.202-.22-.09-.286.693Zm1.084-3.807a.75.75 0 0 0-1.5 0h1.5ZM5.667 15v.75a.75.75 0 0 0 .75-.75h-.75Zm-4.334-.75a.75.75 0 0 0 0 1.5v-1.5Zm8.007-.144a.75.75 0 1 0 .32 1.466l-.32-1.466ZM1.75 8A6.25 6.25 0 0 1 8 1.75V.25A7.75 7.75 0 0 0 .25 8h1.5ZM8 1.75A6.25 6.25 0 0 1 14.25 8h1.5A7.75 7.75 0 0 0 8 .25v1.5ZM5.62 13.78A6.252 6.252 0 0 1 1.75 8H.25a7.752 7.752 0 0 0 4.797 7.168l.572-1.387Zm-.703-3.113V15h1.5v-4.333h-1.5Zm.75 3.583H1.333v1.5h4.334v-1.5Zm-.967.626.333.526 1.267-.803-.333-.526-1.267.803ZM14.25 8a6.253 6.253 0 0 1-4.91 6.106l.32 1.466A7.753 7.753 0 0 0 15.75 8h-1.5Z"
    })));
var $ccec2cab17a546b6$export$2e2bcd8739ae039 = $ccec2cab17a546b6$var$reset;




var $ieaan = parcelRequire("ieaan");
var $24ff9e3b07a8f88f$var$_path;
const $24ff9e3b07a8f88f$var$save = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $24ff9e3b07a8f88f$var$_path || ($24ff9e3b07a8f88f$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M6.133 5.2 8 7.067m0 0L9.867 5.2M8 7.067V1m.5 11.5H4m8.044 0h-.622M1.933 15h12.134a.933.933 0 0 0 .933-.933v-3.734a.933.933 0 0 0-.933-.933H1.933a.933.933 0 0 0-.933.933v3.734c0 .515.418.933.933.933Z"
    })));
var $24ff9e3b07a8f88f$export$2e2bcd8739ae039 = $24ff9e3b07a8f88f$var$save;




var $ieaan = parcelRequire("ieaan");
var $d40f7ac5f17f0080$var$_path;
const $d40f7ac5f17f0080$var$subtract = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $d40f7ac5f17f0080$var$_path || ($d40f7ac5f17f0080$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M14 8H2"
    })));
var $d40f7ac5f17f0080$export$2e2bcd8739ae039 = $d40f7ac5f17f0080$var$subtract;




var $bacfbed3ffaac4a1$exports = {};

$parcel$export($bacfbed3ffaac4a1$exports, "add_medium", function () { return $6c7aad60512f1bd2$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_down_medium", function () { return $1722948fe2ec1072$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_left_medium", function () { return $c8884ce0dd63d21c$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_right_medium", function () { return $c4a7a100eb7a35e3$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "arrow_up_medium", function () { return $8326f19009e9b9ac$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "bell_medium", function () { return $2bc7da0c258affa2$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "calendar_medium", function () { return $dfc76dabefdc1b23$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "check_medium", function () { return $90e0e6911f5d437e$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_down_medium", function () { return $cd251e77d96cb4cc$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_left_medium", function () { return $b67ce929b86d1adc$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_right_medium", function () { return $a25fbe10272cbc4c$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "chevron_up_medium", function () { return $64105c8f87464477$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "close_medium", function () { return $cd24f0389f82a2ee$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "download_medium", function () { return $580bbde317508449$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "exclamation_medium", function () { return $c6167291c77af966$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "information_medium", function () { return $e23a478b825be356$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "loupe_medium", function () { return $4f9316fa6caedf83$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "more_medium", function () { return $7b3a2c9055c45800$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "question_medium", function () { return $d146b05d533b9a8b$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "reset_medium", function () { return $b63a1b80751f3d37$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "save_medium", function () { return $94d44e796cd0d521$export$2e2bcd8739ae039; });
$parcel$export($bacfbed3ffaac4a1$exports, "subtract_medium", function () { return $156563afed3b2b82$export$2e2bcd8739ae039; });


var $ieaan = parcelRequire("ieaan");
var $6c7aad60512f1bd2$var$_path;
const $6c7aad60512f1bd2$var$add_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $6c7aad60512f1bd2$var$_path || ($6c7aad60512f1bd2$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M12 21V3m9 9H3"
    })));
var $6c7aad60512f1bd2$export$2e2bcd8739ae039 = $6c7aad60512f1bd2$var$add_medium;




var $ieaan = parcelRequire("ieaan");
var $1722948fe2ec1072$var$_path;
const $1722948fe2ec1072$var$arrow_down_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $1722948fe2ec1072$var$_path || ($1722948fe2ec1072$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m4.5 14.625 7.5 7.5m0 0 7.5-7.5m-7.5 7.5V1.875"
    })));
var $1722948fe2ec1072$export$2e2bcd8739ae039 = $1722948fe2ec1072$var$arrow_down_medium;




var $ieaan = parcelRequire("ieaan");
var $c8884ce0dd63d21c$var$_path;
const $c8884ce0dd63d21c$var$arrow_left_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $c8884ce0dd63d21c$var$_path || ($c8884ce0dd63d21c$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M22.25 11.5H2M9.5 4 2 11.5m0 0L9.5 19"
    })));
var $c8884ce0dd63d21c$export$2e2bcd8739ae039 = $c8884ce0dd63d21c$var$arrow_left_medium;




var $ieaan = parcelRequire("ieaan");
var $c4a7a100eb7a35e3$var$_path;
const $c4a7a100eb7a35e3$var$arrow_right_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $c4a7a100eb7a35e3$var$_path || ($c4a7a100eb7a35e3$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M2.25 12H22.5M15 19.5l7.5-7.5m0 0L15 4.5"
    })));
var $c4a7a100eb7a35e3$export$2e2bcd8739ae039 = $c4a7a100eb7a35e3$var$arrow_right_medium;




var $ieaan = parcelRequire("ieaan");
var $8326f19009e9b9ac$var$_path;
const $8326f19009e9b9ac$var$arrow_up_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $8326f19009e9b9ac$var$_path || ($8326f19009e9b9ac$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m4.5 9.375 7.5-7.5m0 0 7.5 7.5m-7.5-7.5v20.25"
    })));
var $8326f19009e9b9ac$export$2e2bcd8739ae039 = $8326f19009e9b9ac$var$arrow_up_medium;




var $ieaan = parcelRequire("ieaan");
var $2bc7da0c258affa2$var$_path;
const $2bc7da0c258affa2$var$bell_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $2bc7da0c258affa2$var$_path || ($2bc7da0c258affa2$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M10 21.75a2.087 2.087 0 0 0 4.005 0M12 3a7.5 7.5 0 0 1 7.5 7.5c0 7.046 1.5 8.25 1.5 8.25H3s1.5-1.916 1.5-8.25A7.5 7.5 0 0 1 12 3Zm0 0V.75"
    })));
var $2bc7da0c258affa2$export$2e2bcd8739ae039 = $2bc7da0c258affa2$var$bell_medium;




var $ieaan = parcelRequire("ieaan");
var $dfc76dabefdc1b23$var$_path;
const $dfc76dabefdc1b23$var$calendar_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $dfc76dabefdc1b23$var$_path || ($dfc76dabefdc1b23$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M6.5 1v5m11-5v5m-16 3.5v-5a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v5m-21 0v12a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-12m-21 0h21"
    })));
var $dfc76dabefdc1b23$export$2e2bcd8739ae039 = $dfc76dabefdc1b23$var$calendar_medium;




var $ieaan = parcelRequire("ieaan");
var $90e0e6911f5d437e$var$_path;
const $90e0e6911f5d437e$var$check_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $90e0e6911f5d437e$var$_path || ($90e0e6911f5d437e$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m1.5 15 6 6 15-18"
    })));
var $90e0e6911f5d437e$export$2e2bcd8739ae039 = $90e0e6911f5d437e$var$check_medium;




var $ieaan = parcelRequire("ieaan");
var $cd251e77d96cb4cc$var$_path;
const $cd251e77d96cb4cc$var$chevron_down_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $cd251e77d96cb4cc$var$_path || ($cd251e77d96cb4cc$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m19 8.5-7 7-7-7"
    })));
var $cd251e77d96cb4cc$export$2e2bcd8739ae039 = $cd251e77d96cb4cc$var$chevron_down_medium;




var $ieaan = parcelRequire("ieaan");
var $b67ce929b86d1adc$var$_path;
const $b67ce929b86d1adc$var$chevron_left_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $b67ce929b86d1adc$var$_path || ($b67ce929b86d1adc$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m15 5-7 7 7 7"
    })));
var $b67ce929b86d1adc$export$2e2bcd8739ae039 = $b67ce929b86d1adc$var$chevron_left_medium;




var $ieaan = parcelRequire("ieaan");
var $a25fbe10272cbc4c$var$_path;
const $a25fbe10272cbc4c$var$chevron_right_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $a25fbe10272cbc4c$var$_path || ($a25fbe10272cbc4c$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m9 19 7-7-7-7"
    })));
var $a25fbe10272cbc4c$export$2e2bcd8739ae039 = $a25fbe10272cbc4c$var$chevron_right_medium;




var $ieaan = parcelRequire("ieaan");
var $64105c8f87464477$var$_path;
const $64105c8f87464477$var$chevron_up_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $64105c8f87464477$var$_path || ($64105c8f87464477$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m5 15.5 7-7 7 7"
    })));
var $64105c8f87464477$export$2e2bcd8739ae039 = $64105c8f87464477$var$chevron_up_medium;




var $ieaan = parcelRequire("ieaan");
var $cd24f0389f82a2ee$var$_path;
const $cd24f0389f82a2ee$var$close_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $cd24f0389f82a2ee$var$_path || ($cd24f0389f82a2ee$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M5 19 19 5m0 14L5 5"
    })));
var $cd24f0389f82a2ee$export$2e2bcd8739ae039 = $cd24f0389f82a2ee$var$close_medium;




var $ieaan = parcelRequire("ieaan");
var $580bbde317508449$var$_path;
const $580bbde317508449$var$download_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $580bbde317508449$var$_path || ($580bbde317508449$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M7.75 12.25 12 16.5m0 0 4.25-4.25M12 16.5V3M4 21.25h16"
    })));
var $580bbde317508449$export$2e2bcd8739ae039 = $580bbde317508449$var$download_medium;




var $ieaan = parcelRequire("ieaan");
var $c6167291c77af966$var$_path;
const $c6167291c77af966$var$exclamation_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $c6167291c77af966$var$_path || ($c6167291c77af966$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M11.997 15.118V3.25m-.646 16.765h1.31m.089 0c0 .438-.31.747-.753.747a.718.718 0 0 1-.747-.747c0-.442.31-.753.747-.753.443 0 .753.31.753.753Z"
    })));
var $c6167291c77af966$export$2e2bcd8739ae039 = $c6167291c77af966$var$exclamation_medium;




var $ieaan = parcelRequire("ieaan");
var $e23a478b825be356$var$_path;
const $e23a478b825be356$var$information_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $e23a478b825be356$var$_path || ($e23a478b825be356$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M14.872 20.74h-1.125a2.249 2.249 0 0 1-2.248-2.248V10.87c0-.62-.504-1.124-1.125-1.124H9.25m.85-5.244h1.31m.09 0c0 .437-.31.747-.754.747A.718.718 0 0 1 10 4.502c0-.443.31-.753.747-.753.443 0 .753.31.753.753Z"
    })));
var $e23a478b825be356$export$2e2bcd8739ae039 = $e23a478b825be356$var$information_medium;




var $ieaan = parcelRequire("ieaan");
var $4f9316fa6caedf83$var$_path;
const $4f9316fa6caedf83$var$loupe_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $4f9316fa6caedf83$var$_path || ($4f9316fa6caedf83$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M17.5 17.5 23 23M18 9.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z"
    })));
var $4f9316fa6caedf83$export$2e2bcd8739ae039 = $4f9316fa6caedf83$var$loupe_medium;




var $ieaan = parcelRequire("ieaan");
var $7b3a2c9055c45800$var$_path;
const $7b3a2c9055c45800$var$more_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $7b3a2c9055c45800$var$_path || ($7b3a2c9055c45800$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        fill: "#000",
        d: "M8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    })));
var $7b3a2c9055c45800$export$2e2bcd8739ae039 = $7b3a2c9055c45800$var$more_medium;




var $ieaan = parcelRequire("ieaan");
var $d146b05d533b9a8b$var$_path;
const $d146b05d533b9a8b$var$question_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $d146b05d533b9a8b$var$_path || ($d146b05d533b9a8b$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M7.75 7.429c0-2.39 2.106-4.332 4.467-4.168 2.384.164 4.177 2.398 3.851 4.743a4.215 4.215 0 0 1-2.746 3.366c-1.743.616-1.393 2.671-1.393 4.13m-.577 4.5h1.31m.09 0c0 .437-.31.747-.754.747a.718.718 0 0 1-.747-.747c0-.443.31-.753.747-.753.443 0 .753.31.753.753Z"
    })));
var $d146b05d533b9a8b$export$2e2bcd8739ae039 = $d146b05d533b9a8b$var$question_medium;




var $ieaan = parcelRequire("ieaan");
var $b63a1b80751f3d37$var$_path;
const $b63a1b80751f3d37$var$reset_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $b63a1b80751f3d37$var$_path || ($b63a1b80751f3d37$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        fill: "#000",
        d: "M13.628 21.615a.75.75 0 1 0 .248 1.48l-.248-1.48ZM8 21.71l.633-.401-.127-.201-.22-.091L8 21.71ZM9.25 16a.75.75 0 0 0-1.5 0h1.5Zm-.75 6.5v.75a.75.75 0 0 0 .75-.75H8.5ZM2 21.75a.75.75 0 0 0 0 1.5v-1.5ZM2.25 12A9.75 9.75 0 0 1 12 2.25V.75C5.787.75.75 5.787.75 12h1.5ZM12 2.25A9.75 9.75 0 0 1 21.75 12h1.5C23.25 5.787 18.213.75 12 .75v1.5ZM21.75 12c0 4.83-3.512 8.84-8.122 9.615l.248 1.48c5.32-.894 9.374-5.52 9.374-11.095h-1.5ZM8.286 21.018A9.753 9.753 0 0 1 2.25 12H.75c0 4.697 2.878 8.72 6.964 10.405l.572-1.387ZM7.75 16v6.5h1.5V16h-1.5Zm.75 5.75H2v1.5h6.5v-1.5Zm-1.133.363.5.788 1.266-.802-.5-.79-1.266.804Z"
    })));
var $b63a1b80751f3d37$export$2e2bcd8739ae039 = $b63a1b80751f3d37$var$reset_medium;




var $ieaan = parcelRequire("ieaan");
var $94d44e796cd0d521$var$_path;
const $94d44e796cd0d521$var$save_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $94d44e796cd0d521$var$_path || ($94d44e796cd0d521$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m9 7.5 3 3m0 0 3-3m-3 3V.75m7.5 19.5h-15m14-3h-1m-15.25 6h19.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5H2.25a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5Z"
    })));
var $94d44e796cd0d521$export$2e2bcd8739ae039 = $94d44e796cd0d521$var$save_medium;




var $ieaan = parcelRequire("ieaan");
var $156563afed3b2b82$var$_path;
const $156563afed3b2b82$var$subtract_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $156563afed3b2b82$var$_path || ($156563afed3b2b82$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M21 12H3"
    })));
var $156563afed3b2b82$export$2e2bcd8739ae039 = $156563afed3b2b82$var$subtract_medium;




"use client";
var $cad17f9ce60a2b23$var$_Fragment;
function $cad17f9ce60a2b23$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cad17f9ce60a2b23$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cad17f9ce60a2b23$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cad17f9ce60a2b23$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cad17f9ce60a2b23$var$icons = $cad17f9ce60a2b23$var$_objectSpread($cad17f9ce60a2b23$var$_objectSpread({}, $1b716dc1cd8c4f3d$exports), $bacfbed3ffaac4a1$exports);
function $cad17f9ce60a2b23$export$2e2bcd8739ae039(localProps) {
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, {}, {
        skeleton: context === null || context === void 0 ? void 0 : context.skeleton
    }, context.Icon, context.IconPrimary);
    const { icon: icon, size: size, wrapperParams: wrapperParams, iconParams: iconParams, alt: alt } = (0, $18e1fb7032604f9e$export$dbac4b0afb3666a7)(props, context);
    const IconContainer = (0, $18e1fb7032604f9e$export$20da8aa394d9a3ff)({
        icon: icon,
        size: size,
        alt: alt,
        listOfIcons: $cad17f9ce60a2b23$var$icons
    });
    if (!IconContainer) return $cad17f9ce60a2b23$var$_Fragment || ($cad17f9ce60a2b23$var$_Fragment = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", wrapperParams, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(IconContainer, iconParams));
}
$cad17f9ce60a2b23$export$2e2bcd8739ae039._supportsSpacingProps = true;







var $ieaan = parcelRequire("ieaan");


var $ljfqi = parcelRequire("ljfqi");


var $ieaan = parcelRequire("ieaan");

"use client";
function $ad7f813f95b3e41b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad7f813f95b3e41b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad7f813f95b3e41b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad7f813f95b3e41b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad7f813f95b3e41b$export$2e2bcd8739ae039() {
    const { theme: theme } = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039)) || {};
    if (theme) {
        const { name: name } = theme;
        return $ad7f813f95b3e41b$var$_objectSpread($ad7f813f95b3e41b$var$_objectSpread({}, theme), {}, {
            isUi: name === 'ui',
            isSbanken: name === 'sbanken',
            isEiendom: name === 'eiendom'
        });
    }
    return null;
}







var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");
parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");

function $268ea9ed428cf6d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $268ea9ed428cf6d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $268ea9ed428cf6d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $268ea9ed428cf6d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $268ea9ed428cf6d0$export$2e2bcd8739ae039 {
    callAnimationStart() {
        this.startTime = Date.now();
        if (!this.firstTime) this.firstTime = this.startTime;
        if (this.onStartStack) this.onStartStack.forEach((fn)=>{
            if (typeof fn === 'function') fn(this.state);
        });
    }
    callAnimationEnd() {
        this.isAnimating = false;
        if (this.state !== 'opened') delete this.__currentHeight;
        this.removeEndEvents();
        if (this.onEndStack) this.onEndStack.forEach((fn)=>{
            if (typeof fn === 'function') fn(this.state);
        });
    }
    addEndEvent(listener) {
        var _this$elem, _this$elem$addEventLi;
        this.removeEndEvents();
        const handleTransitionEnd = (e)=>{
            if (this.canFinish()) listener(e);
            else {
                const delay = this.duration - (Date.now() - this.startTime);
                if (delay === -1) listener(e);
                else this.timeouts.push(setTimeout(()=>listener(e), delay));
            }
        };
        this.events.push(handleTransitionEnd);
        (_this$elem = this.elem) === null || _this$elem === void 0 || (_this$elem$addEventLi = _this$elem.addEventListener) === null || _this$elem$addEventLi === void 0 || _this$elem$addEventLi.call(_this$elem, 'transitionend', handleTransitionEnd);
    }
    removeEndEvents() {
        this.events.forEach((listener)=>{
            var _this$elem2, _this$elem2$removeEve;
            (_this$elem2 = this.elem) === null || _this$elem2 === void 0 || (_this$elem2$removeEve = _this$elem2.removeEventListener) === null || _this$elem2$removeEve === void 0 || _this$elem2$removeEve.call(_this$elem2, 'transitionend', listener);
        });
        this.events = [];
    }
    setElement(elem) {
        var _this$elem3, _globalThis$animation;
        this.elem = elem || typeof document !== 'undefined' && document.createElement('div');
        if (String((_this$elem3 = this.elem) === null || _this$elem3 === void 0 ? void 0 : _this$elem3.nodeName).toLowerCase() === 'td') this.elem = this.elem.parentElement;
        this.duration = (_globalThis$animation = globalThis.animationDuration) !== null && _globalThis$animation !== void 0 ? _globalThis$animation : parseFloat(window.getComputedStyle(this.elem).transitionDuration) * 1000 || 400;
    }
    setState(state) {
        this.state = Object.freeze(state);
    }
    setOptions(opts) {
        this.opts = Object.freeze($268ea9ed428cf6d0$var$_objectSpread($268ea9ed428cf6d0$var$_objectSpread({}, this.opts), opts));
    }
    getOptions() {
        return this.opts;
    }
    remove() {
        this.stop();
        this.removeEndEvents();
        this.setState('init');
        this.isAnimating = false;
        this.onEndStack = [];
        this.onStartStack = [];
        this.__currentHeight = undefined;
        this.elem = undefined;
    }
    setAsOpen() {
        if (this.state === 'opened') return;
        this.setState('opening');
        this.callAnimationStart();
        this.setState('opened');
        this.callAnimationEnd();
    }
    setAsClosed() {
        if (this.state === 'closed') return;
        this.setState('closing');
        this.callAnimationStart();
        this.setState('closed');
        this.callAnimationEnd();
    }
    getHeight() {
        var _this$withFallback;
        return (_this$withFallback = this.withFallback(this.elem, 'clientHeight')) !== null && _this$withFallback !== void 0 ? _this$withFallback : null;
    }
    getUnknownHeight() {
        var _this$elem$parentNode, _this$withFallback2, _this$withFallback3, _clonedElem$parentNod;
        if (!this.elem) return null;
        if (this.isAnimating && typeof this.__currentHeight !== 'undefined') return this.__currentHeight;
        const clonedElem = this.elem.cloneNode(true);
        const inputs = clonedElem.querySelectorAll('input');
        inputs.forEach((input)=>{
            input.removeAttribute('name');
            input.removeAttribute('id');
        });
        for(const key in this.firstPaintStyle)clonedElem.style[key] = this.firstPaintStyle[key];
        clonedElem.style.position = 'absolute';
        (_this$elem$parentNode = this.elem.parentNode) === null || _this$elem$parentNode === void 0 || _this$elem$parentNode.insertBefore(clonedElem, this.elem.nextSibling);
        const elemWidth = this.elem.clientWidth;
        const clonedWidth = (_this$withFallback2 = this.withFallback(clonedElem, 'clientWidth', 'data-width')) !== null && _this$withFallback2 !== void 0 ? _this$withFallback2 : 0;
        if (clonedWidth > elemWidth) clonedElem.style.width = `${elemWidth}px`;
        const height = (_this$withFallback3 = this.withFallback(this.elem, 'clientHeight', 'data-height')) !== null && _this$withFallback3 !== void 0 ? _this$withFallback3 : null;
        (_clonedElem$parentNod = clonedElem.parentNode) === null || _clonedElem$parentNod === void 0 || _clonedElem$parentNod.removeChild(clonedElem);
        if (height) this.__currentHeight = height;
        return height;
    }
    withFallback(elem, key, fallback) {
        const val = fallback && elem.hasAttribute(fallback) ? parseFloat(elem.getAttribute(fallback)) : elem === null || elem === void 0 ? void 0 : elem[key];
        if (isNaN(val)) return null;
        return val;
    }
    onStart(fn) {
        this.onStartStack.push(fn);
    }
    onEnd(fn) {
        this.onEndStack.push(fn);
    }
    start(fromHeight, toHeight) {
        if (!this.elem || !(this.isInBrowser && typeof window.requestAnimationFrame === 'function')) return;
        const opts = this.getOptions();
        if (opts.animate === false) return;
        this.stop();
        this.isAnimating = true;
        this.reqId1 = window.requestAnimationFrame(()=>{
            if (!this.elem || toHeight !== 0 && this.elem.classList.contains('dnb-height-animation--stop')) return;
            this.elem.style.height = `${fromHeight}px`;
            this.reqId2 = window.requestAnimationFrame(()=>{
                if (!this.elem) return;
                this.elem.style.height = `${toHeight}px`;
            });
        });
    }
    stop() {
        this.timeouts.forEach((id)=>clearTimeout(id));
        this.timeouts = [];
        if (this.isInBrowser && typeof window.requestAnimationFrame === 'function') {
            window.cancelAnimationFrame(this.reqId1);
            window.cancelAnimationFrame(this.reqId2);
        }
    }
    open() {
        if (this.state === 'opened' || this.state === 'opening' || this.shouldBypassAnimation()) {
            this.setAsOpen();
            return;
        }
        this.setState('opening');
        this.callAnimationStart();
        const toHeight = this.getUnknownHeight();
        this.addEndEvent((e)=>{
            if (this.state === 'opening' && e.target === e.currentTarget || !e.currentTarget) {
                if (this.elem) this.elem.style.overflowY = '';
                this.setState('opened');
                this.readjust();
            }
        });
        this.start(0, toHeight);
    }
    close() {
        if (this.state === 'closed' || this.state === 'closing' || this.shouldBypassAnimation()) {
            this.setAsClosed();
            return;
        }
        this.setState('closing');
        this.callAnimationStart();
        const fromHeight = this.getHeight();
        this.addEndEvent((e)=>{
            if (this.state === 'closing' && e.target === e.currentTarget || !e.currentTarget) {
                if (this.elem) {
                    this.elem.style.visibility = 'hidden';
                    this.elem.style.overflowY = 'clip';
                }
                this.setState('closed');
                this.callAnimationEnd();
            }
        });
        this.start(fromHeight, 0);
    }
    adjustTo() {
        let fromHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let toHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        const opts = this.getOptions();
        if (!this.elem || opts.animate === false || this.state === 'opening' || this.state === 'closing') return;
        if (fromHeight === null) fromHeight = this.getHeight();
        if (toHeight === null) toHeight = this.getUnknownHeight();
        if (fromHeight === toHeight) {
            this.setState('adjusted');
            return;
        }
        this.setState('adjusting');
        this.callAnimationStart();
        this.addEndEvent((e)=>{
            if (this.state === 'adjusting' && (e.target === e.currentTarget || !e.currentTarget)) {
                if (this.elem) this.elem.style.height = 'auto';
                this.setState('adjusted');
            }
            this.callAnimationEnd();
        });
        this.start(fromHeight, toHeight);
    }
    readjust() {
        const endHeight = this.getHeight();
        if (this.elem) this.elem.style.height = 'auto';
        this.__currentHeight = undefined;
        const newHeight = this.getUnknownHeight();
        if (endHeight !== newHeight) this.adjustTo(endHeight, newHeight);
        else this.callAnimationEnd();
    }
    canFinish() {
        var _globalThis$animation2;
        return Boolean(this.startTime && Date.now() - this.startTime > ((_globalThis$animation2 = globalThis.animationDuration) !== null && _globalThis$animation2 !== void 0 ? _globalThis$animation2 : this.duration));
    }
    shouldBypassAnimation() {
        var _globalThis$bypassTim;
        const opts = this.getOptions();
        if (!this.elem || opts.animate === false) return true;
        if (this.isInBrowser && (globalThis.IS_TEST || globalThis.bypassTime === -1)) return false;
        return Boolean(this.firstTime && Date.now() - this.firstTime < ((_globalThis$bypassTim = globalThis.bypassTime) !== null && _globalThis$bypassTim !== void 0 ? _globalThis$bypassTim : 100));
    }
    constructor(){
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onStartStack", []);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onEndStack", []);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "events", []);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "opts", {
            animate: true
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "timeouts", []);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "firstTime", 0);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "startTime", 0);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "duration", 0);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "firstPaintStyle", {
            visibility: 'hidden',
            opacity: '0',
            height: 'auto'
        });
        this.isInBrowser = typeof window !== 'undefined';
        this.setState('init');
        this.setOptions(opts);
    }
}


"use client";
const $d548f0d9e45b963b$var$useLayoutEffect = typeof window === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useEffect : (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useLayoutEffect;
function $d548f0d9e45b963b$export$6149b93ac8ab7004(targetRef) {
    var _instRef$current2;
    let { open: open = true, animate: animate = true, children: children = null, compensateForGap: compensateForGap, onInit: onInit = null, onOpen: onOpen = null, onAnimationStart: onAnimationStart = null, onAnimationEnd: onAnimationEnd = null } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const instRef = (0, $ieaan.useRef)(null);
    const isInitialRenderRef = (0, $ieaan.useRef)(typeof globalThis !== 'undefined' ? globalThis.readjustTime !== -1 : true);
    const [isOpen, setIsOpen] = (0, $ieaan.useState)(open);
    const [isVisible, setIsVisible] = (0, $ieaan.useState)(false);
    const [isAnimating, setIsAnimating] = (0, $ieaan.useState)(false);
    const [isVisibleParallax, setParallax] = (0, $ieaan.useState)(open);
    const eventsRef = (0, $ieaan.useRef)({
        onInit: onInit,
        onAnimationEnd: onAnimationEnd,
        onAnimationStart: onAnimationStart,
        onOpen: onOpen
    });
    eventsRef.current.onInit = onInit;
    eventsRef.current.onAnimationEnd = onAnimationEnd;
    eventsRef.current.onAnimationStart = onAnimationStart;
    eventsRef.current.onOpen = onOpen;
    $d548f0d9e45b963b$var$useLayoutEffect(()=>{
        var _eventsRef$current$on, _eventsRef$current;
        instRef.current = new (0, $268ea9ed428cf6d0$export$2e2bcd8739ae039)();
        (_eventsRef$current$on = (_eventsRef$current = eventsRef.current).onInit) === null || _eventsRef$current$on === void 0 || _eventsRef$current$on.call(_eventsRef$current, instRef.current);
        return ()=>{
            var _instRef$current;
            (_instRef$current = instRef.current) === null || _instRef$current === void 0 || _instRef$current.remove();
            instRef.current = null;
        };
    }, []);
    $d548f0d9e45b963b$var$useLayoutEffect(()=>{
        instRef.current.setOptions({
            animate: animate
        });
        if (typeof $parcel$global !== 'undefined' && globalThis.IS_TEST) instRef.current.setOptions({
            animate: false
        });
    }, [
        animate
    ]);
    const handleCompensateForGap = (0, $ieaan.useCallback)(()=>{
        if (compensateForGap) {
            let gap = compensateForGap;
            const { elem: elem } = instRef.current;
            if (compensateForGap === 'auto') gap = window.getComputedStyle(elem.parentElement).getPropertyValue('row-gap');
            elem.style.marginTop = `calc(${gap} * -1)`;
            const inner = elem.querySelector('.compensateForGap');
            inner.style.marginTop = gap;
        }
    }, [
        compensateForGap
    ]);
    $d548f0d9e45b963b$var$useLayoutEffect(()=>{
        instRef.current.onStart((state)=>{
            switch(state){
                case 'opening':
                    handleCompensateForGap();
                    setIsVisible(true);
                    setParallax(true);
                    setIsAnimating(true);
                    break;
                case 'closing':
                    setParallax(false);
                    setIsAnimating(true);
                    break;
                case 'adjusting':
                    setIsAnimating(true);
                    break;
            }
            if (!isInitialRenderRef.current) {
                var _eventsRef$current$on2, _eventsRef$current2;
                (_eventsRef$current$on2 = (_eventsRef$current2 = eventsRef.current).onAnimationStart) === null || _eventsRef$current$on2 === void 0 || _eventsRef$current$on2.call(_eventsRef$current2, state);
            }
        });
        instRef.current.onEnd((state)=>{
            var _eventsRef$current$on3, _eventsRef$current3, _eventsRef$current$on4, _eventsRef$current4;
            switch(state){
                case 'opened':
                    setIsVisible(true);
                    setIsOpen(true);
                    setIsAnimating(false);
                    (_eventsRef$current$on3 = (_eventsRef$current3 = eventsRef.current).onOpen) === null || _eventsRef$current$on3 === void 0 || _eventsRef$current$on3.call(_eventsRef$current3, true);
                    break;
                case 'closed':
                    setIsVisible(false);
                    setIsOpen(false);
                    setParallax(false);
                    setIsAnimating(false);
                    (_eventsRef$current$on4 = (_eventsRef$current4 = eventsRef.current).onOpen) === null || _eventsRef$current$on4 === void 0 || _eventsRef$current$on4.call(_eventsRef$current4, false);
                    break;
                case 'adjusted':
                    setIsAnimating(false);
                    break;
            }
            if (!isInitialRenderRef.current) {
                var _eventsRef$current$on5, _eventsRef$current5;
                (_eventsRef$current$on5 = (_eventsRef$current5 = eventsRef.current).onAnimationEnd) === null || _eventsRef$current$on5 === void 0 || _eventsRef$current$on5.call(_eventsRef$current5, state);
            }
        });
    }, [
        compensateForGap,
        handleCompensateForGap
    ]);
    $d548f0d9e45b963b$var$useOpenClose({
        open: open,
        instRef: instRef,
        isInitialRenderRef: isInitialRenderRef,
        targetRef: targetRef
    });
    $d548f0d9e45b963b$var$useAdjust({
        children: children,
        instRef: instRef,
        isInitialRenderRef: isInitialRenderRef,
        targetRef: targetRef
    });
    const firstPaintStyle = open && !isVisible && !isAnimating && ((_instRef$current2 = instRef.current) === null || _instRef$current2 === void 0 ? void 0 : _instRef$current2.firstPaintStyle) || {};
    const isInDOM = open || isVisible;
    return {
        open: open,
        isOpen: isOpen,
        isInDOM: isInDOM,
        isVisible: isVisible,
        isVisibleParallax: isVisibleParallax,
        isAnimating: isAnimating,
        firstPaintStyle: firstPaintStyle
    };
}
function $d548f0d9e45b963b$var$useOpenClose(_ref) {
    let { open: open, instRef: instRef, isInitialRenderRef: isInitialRenderRef, targetRef: targetRef } = _ref;
    const isTest = false;
    $d548f0d9e45b963b$var$useLayoutEffect(()=>{
        instRef.current.setElement(targetRef.current);
        if (!targetRef.current || instRef.current.state === 'init' && isInitialRenderRef.current) {
            if (open) instRef.current.setAsOpen();
            else instRef.current.setAsClosed();
        } else if (open) instRef.current.open();
        else instRef.current.close();
        if (isTest) {
            var _targetRef$current;
            const event = new CustomEvent('transitionend');
            (_targetRef$current = targetRef.current) === null || _targetRef$current === void 0 || _targetRef$current.dispatchEvent(event);
        }
    }, [
        open,
        targetRef,
        instRef,
        isInitialRenderRef,
        isTest
    ]);
    $d548f0d9e45b963b$var$useLayoutEffect(()=>{
        const run = ()=>{
            isInitialRenderRef.current = false;
        };
        if (globalThis.bypassTime === -1 || isTest) run();
        else {
            var _window$requestAnimat, _window;
            (_window$requestAnimat = (_window = window).requestAnimationFrame) === null || _window$requestAnimat === void 0 || _window$requestAnimat.call(_window, run);
        }
    }, [
        isInitialRenderRef,
        isTest
    ]);
}
function $d548f0d9e45b963b$var$useAdjust(_ref2) {
    let { children: children, instRef: instRef, isInitialRenderRef: isInitialRenderRef, targetRef: targetRef } = _ref2;
    const fromHeight = (0, $ieaan.useRef)(0);
    const [timer] = (0, $ieaan.useState)(()=>Date.now());
    const shouldAdjust = ()=>{
        var _instRef$current3;
        switch((_instRef$current3 = instRef.current) === null || _instRef$current3 === void 0 ? void 0 : _instRef$current3.state){
            case 'opened':
            case 'adjusted':
            case 'adjusting':
                return !isInitialRenderRef.current && Date.now() - timer > (globalThis.readjustTime || 100);
        }
        return false;
    };
    (0, $ieaan.useMemo)(()=>{
        if (shouldAdjust()) {
            var _instRef$current4;
            fromHeight.current = (_instRef$current4 = instRef.current) === null || _instRef$current4 === void 0 ? void 0 : _instRef$current4.getHeight();
        }
    }, [
        children
    ]);
    $d548f0d9e45b963b$var$useLayoutEffect(()=>{
        if (shouldAdjust()) {
            instRef.current.setElement(targetRef.current);
            instRef.current.elem.style.height = '';
            const toHeight = instRef.current.getHeight();
            instRef.current.adjustTo(fromHeight.current, toHeight);
        }
    }, [
        children
    ]);
}






var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");





"use client";
const $92bd738e6af0b834$var$_excluded = [
    "element",
    "inline",
    "no_collapse",
    "top",
    "right",
    "bottom",
    "left",
    "style",
    "space",
    "innerSpace",
    "stretch",
    "skeleton",
    "innerRef",
    "className",
    "children"
], $92bd738e6af0b834$var$_excluded2 = [
    "element",
    "no_collapse",
    "children",
    "innerRef"
];
function $92bd738e6af0b834$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92bd738e6af0b834$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92bd738e6af0b834$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92bd738e6af0b834$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $92bd738e6af0b834$var$defaultProps = {};
function $92bd738e6af0b834$export$2e2bcd8739ae039(localProps) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useContext((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = context.space ? (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $92bd738e6af0b834$var$defaultProps, {
        space: context.space
    }, {
        skeleton: context === null || context === void 0 ? void 0 : context.skeleton
    }) : localProps;
    const { element: element = 'div', inline: inline, no_collapse: no_collapse, top: top, right: right, bottom: bottom, left: left, style: style, space: space, innerSpace: innerSpace, stretch: stretch, skeleton: skeleton, innerRef: innerRef, className: className, children: children } = props, attributes = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $92bd738e6af0b834$var$_excluded);
    const params = $92bd738e6af0b834$var$_objectSpread({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-space', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(null, skeleton), (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)({
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            space: space
        }), className, (0, $11741836d1790446$export$7afc298d8ffd816)(stretch) && 'dnb-space--stretch', (0, $11741836d1790446$export$7afc298d8ffd816)(inline) && 'dnb-space--inline')
    }, attributes);
    const styleObj = $92bd738e6af0b834$var$_objectSpread($92bd738e6af0b834$var$_objectSpread({}, style), (0, $9a6e1a0e3c9a63a2$export$bf9e5e8342b9e38f)(props));
    (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(params, skeleton);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($92bd738e6af0b834$var$Element, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        element: element,
        no_collapse: no_collapse,
        innerRef: innerRef,
        style: styleObj
    }, params), children);
}
$92bd738e6af0b834$export$2e2bcd8739ae039._supportsSpacingProps = true;
function $92bd738e6af0b834$var$Element(_ref) {
    let { element: element, no_collapse: no_collapse, children: children, innerRef: innerRef } = _ref, props = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $92bd738e6af0b834$var$_excluded2);
    const ElementDynamic = element;
    if ((element === null || element === void 0 ? void 0 : element['_name']) === 'Section') props['innerRef'] = innerRef;
    else {
        (0, $11741836d1790446$export$4ddc669a9a6a5940)({}, props);
        props['ref'] = innerRef;
    }
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(ElementDynamic, props, children);
    if ((0, $11741836d1790446$export$7afc298d8ffd816)(no_collapse)) {
        const R = ElementDynamic === 'span' || (0, $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e)(element) ? 'span' : 'div';
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(R, {
            className: 'dnb-space--no-collapse' + ((0, $9a6e1a0e3c9a63a2$export$ff307ae11ac2408e)(element) ? " dnb-space--inline" : "")
        }, component);
    }
    return component;
}


"use client";
const $c329544388f437e5$var$_excluded = [
    "open",
    "animate",
    "keepInDOM",
    "showOverflow",
    "element",
    "duration",
    "delay",
    "className",
    "innerRef",
    "children",
    "compensateForGap",
    "onInit",
    "onOpen",
    "onAnimationStart",
    "onAnimationEnd"
];
function $c329544388f437e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c329544388f437e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c329544388f437e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c329544388f437e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c329544388f437e5$var$HeightAnimation(_ref) {
    let { open: open = true, animate: animate = true, keepInDOM: keepInDOM = false, showOverflow: showOverflow = false, element: element, duration: duration, delay: delay, className: className, innerRef: innerRef, children: children, compensateForGap: compensateForGap, onInit: onInit = null, onOpen: onOpen = null, onAnimationStart: onAnimationStart = null, onAnimationEnd: onAnimationEnd = null } = _ref, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $c329544388f437e5$var$_excluded);
    const elementRef = (0, $ieaan.useRef)();
    const targetRef = innerRef || elementRef;
    const { isInDOM: isInDOM, isVisible: isVisible, isVisibleParallax: isVisibleParallax, isAnimating: isAnimating, firstPaintStyle: firstPaintStyle } = (0, $d548f0d9e45b963b$export$6149b93ac8ab7004)(targetRef, {
        open: open,
        animate: animate,
        children: children,
        compensateForGap: compensateForGap,
        onInit: onInit,
        onOpen: onOpen,
        onAnimationStart: onAnimationStart,
        onAnimationEnd: onAnimationEnd
    });
    if (!keepInDOM && !isInDOM && !isAnimating) return null;
    if (duration) firstPaintStyle['--duration'] = `${duration}ms`;
    if (delay) firstPaintStyle['--delay'] = `${delay}ms`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        innerRef: targetRef,
        element: element || 'div',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-height-animation', className, isVisible ? 'dnb-height-animation--is-visible' : !isAnimating && !open && 'dnb-height-animation--hidden', isInDOM && 'dnb-height-animation--is-in-dom', animate && isVisibleParallax && 'dnb-height-animation--parallax', isAnimating && 'dnb-height-animation--animating', showOverflow && 'dnb-height-animation--show-overflow'),
        style: $c329544388f437e5$var$_objectSpread($c329544388f437e5$var$_objectSpread({}, firstPaintStyle), rest === null || rest === void 0 ? void 0 : rest.style),
        "aria-hidden": keepInDOM ? !open : undefined
    }, rest), compensateForGap ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", {
        className: "compensateForGap"
    }, children) : children);
}
$c329544388f437e5$var$HeightAnimation._supportsSpacingProps = 'children';
var $c329544388f437e5$export$2e2bcd8739ae039 = $c329544388f437e5$var$HeightAnimation;






var $fe477a1647186b55$var$_GlobalStatusProvider;
function $fe477a1647186b55$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe477a1647186b55$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe477a1647186b55$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe477a1647186b55$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $fe477a1647186b55$export$fac78e8a55bae6a6 {
    onUpdate(event) {
        if (this._onUpdateEvents.filter((cb)=>cb === event).length === 0) this._onUpdateEvents.push(event);
    }
    forceRerender(globalStatus, props) {
        let { buffer_delay: buffer_delay = 0, isEmpty: isEmpty = false } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const run = ()=>{
            this._onUpdateEvents.forEach((event)=>{
                if (typeof event === 'function') event(globalStatus, props, {
                    isEmpty: isEmpty
                });
            });
        };
        if (buffer_delay > 0) {
            clearTimeout(this._bufferDelayId);
            this._bufferDelayId = setTimeout(run, buffer_delay);
        } else run();
    }
    init(props) {
        return this.add(props, {
            preventRerender: true
        });
    }
    add(props) {
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.remove('internal-close', {
            preventRerender: true
        });
        const newProps = $fe477a1647186b55$var$_objectSpread({}, props);
        if (!newProps.status_id) newProps.status_id = (0, $11741836d1790446$export$d0c8ec0fe1b18b70)();
        if (typeof newProps.show === 'undefined') newProps.show = true;
        if (newProps.children) {
            newProps.text = newProps.children;
            delete newProps.children;
        }
        const stackIndex = this.stack.findIndex((cur)=>cur.status_id === newProps.status_id);
        if (stackIndex > -1) this.stack[stackIndex] = newProps;
        else this.stack.push(newProps);
        const globalStatus = $fe477a1647186b55$var$GlobalStatusProvider.combineMessages(this.stack);
        if (!(opts !== null && opts !== void 0 && opts.preventRerender)) this.forceRerender(globalStatus, props, {
            buffer_delay: (props === null || props === void 0 ? void 0 : props.buffer_delay) > -1 ? props.buffer_delay : 0
        });
        return globalStatus;
    }
    get(status_id) {
        return this.stack.find((cur)=>cur.status_id === status_id);
    }
    update(status_id, newProps) {
        let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const item = this.get(status_id);
        if (!item) this.add(newProps, {
            preventRerender: true
        });
        else this.stack = this.stack.map((cur, i, arr)=>{
            if (status_id ? cur.status_id === status_id : i === arr.length - 1) return $fe477a1647186b55$var$_objectSpread($fe477a1647186b55$var$_objectSpread({}, cur), newProps);
            return cur;
        });
        this.restack(status_id);
        const globalStatus = $fe477a1647186b55$var$GlobalStatusProvider.combineMessages(this.stack);
        if (!(opts !== null && opts !== void 0 && opts.preventRerender)) this.forceRerender(globalStatus, null, {
            buffer_delay: (newProps === null || newProps === void 0 ? void 0 : newProps.buffer_delay) > -1 ? newProps.buffer_delay : 1
        });
    }
    restack(status_id) {
        const item = this.get(status_id);
        if (item) {
            this.stack = this.stack.filter((cur)=>{
                return cur.status_id !== status_id;
            });
            this.stack.push(item);
        }
    }
    remove(status_id) {
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (status_id) {
            this.stack = this.stack.filter((cur)=>{
                return cur.status_id !== status_id;
            });
            const globalStatus = $fe477a1647186b55$var$GlobalStatusProvider.combineMessages(this.stack);
            if (!(opts !== null && opts !== void 0 && opts.preventRerender)) this.forceRerender(globalStatus, null, {
                buffer_delay: (opts === null || opts === void 0 ? void 0 : opts.buffer_delay) > -1 ? opts.buffer_delay : 1
            });
        }
    }
    empty() {
        this._onUpdateEvents.forEach((cb, i)=>{
            this._onUpdateEvents[i] = null;
        });
        this._onUpdateEvents = [];
        this._onReadyEvents.forEach((cb, i)=>{
            this._onReadyEvents[i] = null;
        });
        this._onReadyEvents = [];
    }
    unbind() {
        this.empty();
        $fe477a1647186b55$var$GlobalStatusProvider.remove(this.internal_id);
    }
    isReady() {
        this._onReadyEvents = this._onReadyEvents.filter((_ref, i)=>{
            let { status: status, cb: cb } = _ref;
            if (typeof cb === 'function') cb(status);
            this._onReadyEvents[i] = null;
            return false;
        });
        return true;
    }
    addOnReady(status, cb) {
        this._onReadyEvents.push({
            status: status,
            cb: cb
        });
    }
    constructor(id){
        let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "stack", []);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "globalStatus", {});
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "_onUpdateEvents", []);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "_onReadyEvents", []);
        this.internal_id = id;
        if (props) this.add(props);
    }
}
class $fe477a1647186b55$var$GlobalStatusProvider {
    static init() {
        let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';
        let onReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        const existingStatus = $fe477a1647186b55$var$GlobalStatusProvider.get(id);
        if (existingStatus) {
            if (props) existingStatus.add(props);
            if (typeof onReady === 'function') onReady(existingStatus);
            return existingStatus;
        }
        const newStatus = $fe477a1647186b55$var$GlobalStatusProvider.create(id, props);
        if (onReady) newStatus.addOnReady(newStatus, onReady);
        if (id !== 'main') (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`No <GlobalStatus ${`id="${id}"`} /> found.`);
        return newStatus;
    }
    static get() {
        let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';
        return $fe477a1647186b55$var$GlobalStatusProvider.providers[id] || null;
    }
    static remove() {
        let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';
        if ($fe477a1647186b55$var$GlobalStatusProvider.providers[id]) delete $fe477a1647186b55$var$GlobalStatusProvider.providers[id];
    }
    static prepareItemWithStatusId(item) {
        let status_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof item === 'string') item = {
            text: item
        };
        if (!item.item_id) {
            if (status_id && status_id !== 'status-main') item.item_id = status_id;
            else {
                var _item;
                if ((_item = item) !== null && _item !== void 0 && _item.text) item.item_id = (0, $11741836d1790446$export$c383cdd2a518017a)((0, $11741836d1790446$export$5bfc594bd2dc6e21)(item.text));
                else item.item_id = (0, $11741836d1790446$export$c383cdd2a518017a)(item);
            }
        }
        return item;
    }
    static combineMessages(stack) {
        const globalStatus = stack.reduce((acc, cur)=>{
            cur = $fe477a1647186b55$var$_objectSpread({}, cur);
            if (typeof cur.items === 'string' && cur.items[0] === '[') cur.items = JSON.parse(cur.items);
            if (cur.item) {
                if (typeof cur.item === 'string' && cur.item[0] === '{') cur.item = JSON.parse(cur.item);
                cur.items = cur.items || [];
                cur.items.push(cur.item);
            }
            if (cur.items) cur.items = cur.items.reduce((_acc, item)=>{
                item = $fe477a1647186b55$var$GlobalStatusProvider.prepareItemWithStatusId(item);
                const foundAtIndex = _acc.findIndex((_ref2)=>{
                    let { item_id: item_id } = _ref2;
                    return item_id === item.item_id;
                });
                if (foundAtIndex > -1) _acc[foundAtIndex] = item;
                else _acc.push(item);
                return _acc;
            }, acc.items || []);
            Object.assign(acc, cur);
            return acc;
        }, {});
        return globalStatus;
    }
}
$fe477a1647186b55$var$_GlobalStatusProvider = $fe477a1647186b55$var$GlobalStatusProvider;
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($fe477a1647186b55$var$GlobalStatusProvider, "providers", {});
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($fe477a1647186b55$var$GlobalStatusProvider, "create", function() {
    let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return $fe477a1647186b55$var$_GlobalStatusProvider.providers[id] = new $fe477a1647186b55$export$fac78e8a55bae6a6(id, props);
});
if (typeof window !== 'undefined') window.GlobalStatusProvider = $fe477a1647186b55$var$GlobalStatusProvider;
$fe477a1647186b55$var$GlobalStatusProvider._supportsSpacingProps = true;
var $fe477a1647186b55$export$2e2bcd8739ae039 = $fe477a1647186b55$var$GlobalStatusProvider;




var $f07eb1c0f8c3fc0b$export$2e2bcd8739ae039 = {
    '--sb-font-family-default': '"Roboto", "Helvetica", "Arial", sans-serif',
    '--sb-font-family-heading': '"MaisonNeueHeadings", "Roboto", "Helvetica",',
    '--sb-font-weight-default': 'normal',
    '--sb-font-weight-basis': 'normal',
    '--sb-font-weight-regular': 'normal',
    '--sb-font-weight-medium': '500',
    '--sb-font-weight-bold': '700',
    '--sb-font-size-x-small': '0.75rem',
    '--sb-font-size-small': '0.875rem',
    '--sb-font-size-basis': '1rem',
    '--sb-font-size-basis--em': '1em',
    '--sb-font-size-lead': 'var(--font-size-medium)',
    '--sb-font-size-medium': '1.25rem',
    '--sb-font-size-medium--plus': '1.625rem',
    '--sb-font-size-large': '2rem',
    '--sb-font-size-x-large': '2.375rem',
    '--sb-font-size-xx-large': '3rem',
    '--sb-line-height-x-small': '1.125rem',
    '--sb-line-height-small': '1.25rem',
    '--sb-line-height-basis': '1.5rem',
    '--sb-line-height-basis--em': '1.5em',
    '--sb-line-height-lead': '1.75rem',
    '--sb-line-height-medium': '2rem',
    '--sb-line-height-large': '2.375rem',
    '--sb-line-height-x-large': '2.75rem',
    '--sb-line-height-xx-large': '3.375rem',
    '--sb-color-black': '#000',
    '--sb-color-text': '#18172a',
    '--sb-color-gray-dark-3': '#3a3a4a',
    '--sb-color-gray-dark-3-neutral': '#3e3e4a',
    '--sb-color-gray-dark-2': '#4a4a5b',
    '--sb-color-gray-dark-2-neutral': '#656472',
    '--sb-color-gray-dark': '#666578',
    '--sb-color-gray-dark-neutral': '#9494a3',
    '--sb-color-gray': '#bbbbce',
    '--sb-color-gray-neutral': '#bdbdc6',
    '--sb-color-gray-light': '#d9d9e4',
    '--sb-color-gray-light-2': '#ebebf2',
    '--sb-color-gray-light-3': '#f9f9fd',
    '--sb-color-purple': '#1c1b4e',
    '--sb-color-purple-alternative': '#222163',
    '--sb-color-green': '#92eecd',
    '--sb-color-white': '#fff',
    '--sb-color-red': '#d8134b',
    '--sb-color-magenta': '#ff3c64',
    '--sb-color-orange': '#ff5b44',
    '--sb-color-yellow-dark': '#f7bf16',
    '--sb-color-yellow': '#ffef57',
    '--sb-color-green-dark-3': '#00785b',
    '--sb-color-green-dark-2': '#1e9f73',
    '--sb-color-violet': '#4e08bc',
    '--sb-color-violet-light': '#7129e2',
    '--sb-color-blue-dark-2': '#044ccc',
    '--sb-color-blue-dark': '#005cff',
    '--sb-color-blue': '#008eff',
    '--sb-color-orange-light': '#ff817b',
    '--sb-color-orange-light-2': '#ffd7d5',
    '--sb-color-orange-light-3': '#fff0ef',
    '--sb-color-magenta-light': '#ffb6d2',
    '--sb-color-magenta-light-2': '#ffdbe9',
    '--sb-color-magenta-light-3': '#fff5f9',
    '--sb-color-yellow-light': '#fff489',
    '--sb-color-yellow-light-2': '#fff9c4',
    '--sb-color-yellow-light-3': '#fffce5',
    '--sb-color-green-dark': '#64d7b4',
    '--sb-color-green-light': '#c8f6e5',
    '--sb-color-green-light-2': '#e5fff7',
    '--sb-color-violet-light-2': '#be99ff',
    '--sb-color-violet-light-3': '#e0d0ff',
    '--sb-color-violet-light-4': '#f1ebff',
    '--sb-color-blue-light': '#61b9ff',
    '--sb-color-blue-light-2': '#bfe3ff',
    '--sb-color-blue-light-3': '#ebf6ff',
    '--sb-spacing-x-small': '0.5rem',
    '--sb-spacing-small': '1rem',
    '--sb-spacing-medium': '1.5rem',
    '--sb-spacing-large': '2rem',
    '--sb-spacing-x-large': '3rem',
    '--sb-spacing-xx-large': '3.5rem',
    '--sb-layout-small': '40em',
    '--sb-layout-medium': '60em',
    '--sb-layout-large': '72em',
    '--sb-layout-x-large': '80em',
    '--sb-layout-xx-large': '90em',
    '--sb-shadow-small': '0 2px 4px rgba(38 35 66 / 12%)',
    '--sb-shadow-medium': '0 5px 20px rgba(38 35 66 / 10%)',
    '--sb-shadow-large': '0 5px 20px rgba(38 35 66 / 20%)',
    '--sb-shadow-hover': '0 20px 40px rgba(38 35 66 / 20%)',
    '--sb-easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--sb-text-block-max-width': '60ch',
    '--color-emerald-green-50': '#89aaac',
    '--color-emerald-green-25': '#c4d4d6',
    '--color-emerald-green-10': '#e8eeef',
    '--font-family-default': '"DNB", sans-serif',
    '--font-family-heading': 'var(--font-family-default)',
    '--font-family-monospace': '"DNBMono", "Menlo", "Consolas", "Roboto Mono",',
    '--font-weight-default': 'normal',
    '--font-weight-basis': 'normal',
    '--font-weight-regular': 'normal',
    '--font-weight-medium': '500',
    '--font-weight-bold': '600',
    '--font-size-x-small': '0.875rem',
    '--font-size-small': '1rem',
    '--font-size-basis': '1.125rem',
    '--font-size-basis--em': '1em',
    '--font-size-lead': 'var(--font-size-medium)',
    '--font-size-medium': '1.25rem',
    '--font-size-large': '1.625rem',
    '--font-size-x-large': '2.125rem',
    '--font-size-xx-large': '3rem',
    '--line-height-xx-small--em': '1em',
    '--line-height-x-small': '1.125rem',
    '--line-height-small': '1.25rem',
    '--line-height-basis': '1.5rem',
    '--line-height-basis--em': '1.333em',
    '--line-height-lead': '1.5rem',
    '--line-height-medium': '2rem',
    '--line-height-large': '2.5rem',
    '--line-height-x-large': '3.5rem',
    '--line-height-xx-large': 'var(--line-height-x-large)',
    '--color-mint-green-50': '#d2f0e9',
    '--color-mint-green-25': '#e9f8f4',
    '--color-mint-green-12': '#f4fbf9',
    '--color-sea-green-30': '#b3d5d5',
    '--color-accent-yellow-30': '#feebc1',
    '--color-signal-orange': '#ff5400',
    '--color-fire-red': '#dc2a2a',
    '--color-success-green': '#007b5e',
    '--color-fire-red-8': '#fdeeee',
    '--color-black': '#000',
    '--color-black-80': '#333',
    '--color-black-55': '#737373',
    '--color-black-20': '#ccc',
    '--color-black-8': '#ebebeb',
    '--color-black-3': '#f8f8f8',
    '--color-white': '#fff',
    '--color-black-border': '#cdcdcd',
    '--color-black-background': '#fafafa',
    '--color-sea-green': '#007272',
    '--color-mint-green': '#a5e1d2',
    '--color-summer-green': '#28b482',
    '--color-emerald-green': '#14555a',
    '--color-ocean-green': '#00343e',
    '--color-accent-yellow': '#fdbb31',
    '--color-indigo': '#23195a',
    '--color-violet': '#6e2382',
    '--color-sky-blue': '#4bbed2',
    '--color-lavender': '#f2f2f5',
    '--color-sand-yellow': '#fbf6ec',
    '--color-pistachio': '#f2f4ec',
    '--color-mint-green-alt': '#ebfffa',
    '--color-indigo-medium': '#6e6491',
    '--color-indigo-light': '#b9afc8',
    '--color-violet-medium': '#a06eaf',
    '--color-violet-light': '#cfb9d7',
    '--color-sky-blue-medium': '#87d2e1',
    '--color-sky-blue-light': '#c3ebf0',
    '--spacing-xx-small': '0.25rem',
    '--spacing-x-small': '0.5rem',
    '--spacing-small': '1rem',
    '--spacing-medium': '1.5rem',
    '--spacing-large': '2rem',
    '--spacing-x-large': '3rem',
    '--spacing-xx-large': '3.5rem',
    '--layout-small': '40em',
    '--layout-medium': '60em',
    '--layout-large': '72em',
    '--layout-x-large': '80em',
    '--layout-xx-large': '90em',
    '--shadow-default': '0 8px 16px rgb(51 51 51 / 8%)',
    '--shadow-default-x': '0',
    '--shadow-default-y': '8px',
    '--shadow-default-blur-radius': '16px',
    '--shadow-default-color': 'rgb(51 51 51 / 8%)',
    '--shadow-sharp': '0 1px 6px rgb(0 0 0 / 16%)',
    '--shadow-sharp-x': '0',
    '--shadow-sharp-y': '1px',
    '--shadow-sharp-blur-radius': '6px',
    '--shadow-sharp-color': 'rgb(0 0 0 / 16%)',
    '--easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--text-block-max-width': '60ch'
};


var $e30fb43d1d1e507b$export$2e2bcd8739ae039 = {
    '--sb-font-family-default': '"Roboto", "Helvetica", "Arial", sans-serif',
    '--sb-font-family-heading': '"MaisonNeueHeadings", "Roboto", "Helvetica",',
    '--sb-font-weight-default': 'normal',
    '--sb-font-weight-basis': 'normal',
    '--sb-font-weight-regular': 'normal',
    '--sb-font-weight-medium': '500',
    '--sb-font-weight-bold': '700',
    '--sb-font-size-x-small': '0.75rem',
    '--sb-font-size-small': '0.875rem',
    '--sb-font-size-basis': '1rem',
    '--sb-font-size-basis--em': '1em',
    '--sb-font-size-lead': 'var(--font-size-medium)',
    '--sb-font-size-medium': '1.25rem',
    '--sb-font-size-medium--plus': '1.625rem',
    '--sb-font-size-large': '2rem',
    '--sb-font-size-x-large': '2.375rem',
    '--sb-font-size-xx-large': '3rem',
    '--sb-line-height-x-small': '1.125rem',
    '--sb-line-height-small': '1.25rem',
    '--sb-line-height-basis': '1.5rem',
    '--sb-line-height-basis--em': '1.5em',
    '--sb-line-height-lead': '1.75rem',
    '--sb-line-height-medium': '2rem',
    '--sb-line-height-large': '2.375rem',
    '--sb-line-height-x-large': '2.75rem',
    '--sb-line-height-xx-large': '3.375rem',
    '--sb-color-black': '#000',
    '--sb-color-text': '#18172a',
    '--sb-color-gray-dark-3': '#3a3a4a',
    '--sb-color-gray-dark-3-neutral': '#3e3e4a',
    '--sb-color-gray-dark-2': '#4a4a5b',
    '--sb-color-gray-dark-2-neutral': '#656472',
    '--sb-color-gray-dark': '#666578',
    '--sb-color-gray-dark-neutral': '#9494a3',
    '--sb-color-gray': '#bbbbce',
    '--sb-color-gray-neutral': '#bdbdc6',
    '--sb-color-gray-light': '#d9d9e4',
    '--sb-color-gray-light-2': '#ebebf2',
    '--sb-color-gray-light-3': '#f9f9fd',
    '--sb-color-purple': '#1c1b4e',
    '--sb-color-purple-alternative': '#222163',
    '--sb-color-green': '#92eecd',
    '--sb-color-white': '#fff',
    '--sb-color-red': '#d8134b',
    '--sb-color-magenta': '#ff3c64',
    '--sb-color-orange': '#ff5b44',
    '--sb-color-yellow-dark': '#f7bf16',
    '--sb-color-yellow': '#ffef57',
    '--sb-color-green-dark-3': '#00785b',
    '--sb-color-green-dark-2': '#1e9f73',
    '--sb-color-violet': '#4e08bc',
    '--sb-color-violet-light': '#7129e2',
    '--sb-color-blue-dark-2': '#044ccc',
    '--sb-color-blue-dark': '#005cff',
    '--sb-color-blue': '#008eff',
    '--sb-color-orange-light': '#ff817b',
    '--sb-color-orange-light-2': '#ffd7d5',
    '--sb-color-orange-light-3': '#fff0ef',
    '--sb-color-magenta-light': '#ffb6d2',
    '--sb-color-magenta-light-2': '#ffdbe9',
    '--sb-color-magenta-light-3': '#fff5f9',
    '--sb-color-yellow-light': '#fff489',
    '--sb-color-yellow-light-2': '#fff9c4',
    '--sb-color-yellow-light-3': '#fffce5',
    '--sb-color-green-dark': '#64d7b4',
    '--sb-color-green-light': '#c8f6e5',
    '--sb-color-green-light-2': '#e5fff7',
    '--sb-color-violet-light-2': '#be99ff',
    '--sb-color-violet-light-3': '#e0d0ff',
    '--sb-color-violet-light-4': '#f1ebff',
    '--sb-color-blue-light': '#61b9ff',
    '--sb-color-blue-light-2': '#bfe3ff',
    '--sb-color-blue-light-3': '#ebf6ff',
    '--sb-spacing-x-small': '0.5rem',
    '--sb-spacing-small': '1rem',
    '--sb-spacing-medium': '1.5rem',
    '--sb-spacing-large': '2rem',
    '--sb-spacing-x-large': '3rem',
    '--sb-spacing-xx-large': '3.5rem',
    '--sb-layout-small': '40em',
    '--sb-layout-medium': '60em',
    '--sb-layout-large': '72em',
    '--sb-layout-x-large': '80em',
    '--sb-layout-xx-large': '90em',
    '--sb-shadow-small': '0 2px 4px rgba(38 35 66 / 12%)',
    '--sb-shadow-medium': '0 5px 20px rgba(38 35 66 / 10%)',
    '--sb-shadow-large': '0 5px 20px rgba(38 35 66 / 20%)',
    '--sb-shadow-hover': '0 20px 40px rgba(38 35 66 / 20%)',
    '--sb-easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--sb-text-block-max-width': '60ch',
    '--color-emerald-green-50': '#89aaac',
    '--color-emerald-green-25': '#c4d4d6',
    '--color-emerald-green-10': '#e8eeef',
    '--font-family-default': 'var(--sb-font-family-default)',
    '--font-family-heading': 'var(--sb-font-family-heading)',
    '--font-family-monospace': '"DNBMono", "Menlo", "Consolas", "Roboto Mono",',
    '--font-weight-default': 'normal',
    '--font-weight-basis': 'normal',
    '--font-weight-regular': 'normal',
    '--font-weight-medium': 'var(--sb-font-weight-medium)',
    '--font-weight-bold': 'var(--sb-font-weight-bold)',
    '--font-size-x-small': 'var(--sb-font-size-x-small)',
    '--font-size-small': 'var(--sb-font-size-small)',
    '--font-size-basis': 'var(--sb-font-size-basis)',
    '--font-size-basis--em': 'var(--sb-font-size-basis--em)',
    '--font-size-lead': 'var(--sb-font-size-lead)',
    '--font-size-medium': 'var(--sb-font-size-medium)',
    '--font-size-large': 'var(--sb-font-size-large)',
    '--font-size-x-large': 'var(--sb-font-size-x-large)',
    '--font-size-xx-large': 'var(--sb-font-size-xx-large)',
    '--line-height-xx-small--em': '1em',
    '--line-height-x-small': 'var(--sb-line-height-x-small)',
    '--line-height-small': 'var(--sb-line-height-small)',
    '--line-height-basis': 'var(--sb-line-height-basis)',
    '--line-height-basis--em': 'var(--sb-line-height-basis--em)',
    '--line-height-lead': 'var(--sb-line-height-lead)',
    '--line-height-medium': 'var(--sb-line-height-medium)',
    '--line-height-large': 'var(--sb-line-height-large)',
    '--line-height-x-large': 'var(--sb-line-height-x-large)',
    '--line-height-xx-large': 'var(--sb-line-height-xx-large)',
    '--color-mint-green-50': '#d2f0e9',
    '--color-mint-green-25': '#e9f8f4',
    '--color-mint-green-12': '#f4fbf9',
    '--color-sea-green-30': '#b3d5d5',
    '--color-accent-yellow-30': '#feebc1',
    '--color-signal-orange': '#ff5400',
    '--color-fire-red': '#dc2a2a',
    '--color-success-green': '#007b5e',
    '--color-fire-red-8': '#fdeeee',
    '--color-black': '#000',
    '--color-black-80': '#333',
    '--color-black-55': '#737373',
    '--color-black-20': '#ccc',
    '--color-black-8': '#ebebeb',
    '--color-black-3': '#f8f8f8',
    '--color-white': '#fff',
    '--color-black-border': '#cdcdcd',
    '--color-black-background': '#fafafa',
    '--color-sea-green': '#007272',
    '--color-mint-green': '#a5e1d2',
    '--color-summer-green': '#28b482',
    '--color-emerald-green': '#14555a',
    '--color-ocean-green': '#00343e',
    '--color-accent-yellow': '#fdbb31',
    '--color-indigo': '#23195a',
    '--color-violet': '#6e2382',
    '--color-sky-blue': '#4bbed2',
    '--color-lavender': '#f2f2f5',
    '--color-sand-yellow': '#fbf6ec',
    '--color-pistachio': '#f2f4ec',
    '--color-mint-green-alt': '#ebfffa',
    '--color-indigo-medium': '#6e6491',
    '--color-indigo-light': '#b9afc8',
    '--color-violet-medium': '#a06eaf',
    '--color-violet-light': '#cfb9d7',
    '--color-sky-blue-medium': '#87d2e1',
    '--color-sky-blue-light': '#c3ebf0',
    '--spacing-xx-small': '0.25rem',
    '--spacing-x-small': '0.5rem',
    '--spacing-small': '1rem',
    '--spacing-medium': '1.5rem',
    '--spacing-large': '2rem',
    '--spacing-x-large': '3rem',
    '--spacing-xx-large': '3.5rem',
    '--layout-small': '40em',
    '--layout-medium': '60em',
    '--layout-large': '72em',
    '--layout-x-large': '80em',
    '--layout-xx-large': '90em',
    '--shadow-default': '0 8px 16px rgb(51 51 51 / 8%)',
    '--shadow-default-x': '0',
    '--shadow-default-y': '8px',
    '--shadow-default-blur-radius': '16px',
    '--shadow-default-color': 'rgb(51 51 51 / 8%)',
    '--shadow-sharp': '0 1px 6px rgb(0 0 0 / 16%)',
    '--shadow-sharp-x': '0',
    '--shadow-sharp-y': '1px',
    '--shadow-sharp-blur-radius': '6px',
    '--shadow-sharp-color': 'rgb(0 0 0 / 16%)',
    '--easing-default': 'cubic-bezier(0.42, 0, 0, 1)',
    '--text-block-max-width': '60ch',
    '--theme-color-body': 'var(--sb-color-text)'
};


"use client";
const $2fad1ad7e24667d0$var$_excluded = [
    "title",
    "state",
    "size",
    "variant",
    "className",
    "stretch",
    "shellSpace",
    "text_id",
    "show",
    "no_animation",
    "label",
    "status_id",
    "globalStatus",
    "id",
    "text",
    "icon",
    "icon_size",
    "skeleton",
    "children",
    "role"
];
function $2fad1ad7e24667d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2fad1ad7e24667d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2fad1ad7e24667d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2fad1ad7e24667d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2fad1ad7e24667d0$var$properties = {
    ui: $f07eb1c0f8c3fc0b$export$2e2bcd8739ae039,
    sbanken: $e30fb43d1d1e507b$export$2e2bcd8739ae039
};
class $2fad1ad7e24667d0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).PureComponent {
    static getContent(props) {
        if (props.text) {
            if ((0, $11741836d1790446$export$7afc298d8ffd816)(props.text)) return null;
            return props.text;
        }
        return (0, $5cdea43e47e2bcbb$export$51751cece1adcf33)(props);
    }
    static correctStatus(state) {
        switch(state){
            case 'information':
                state = 'info';
                break;
            case 'warning':
                state = 'warn';
                break;
        }
        return state;
    }
    static getIcon(_ref) {
        let { state: state, icon: icon, icon_size: icon_size } = _ref;
        if (typeof icon !== 'string') return icon;
        let IconToLoad = icon;
        switch($2fad1ad7e24667d0$export$2e2bcd8739ae039.correctStatus(state)){
            case 'info':
            case 'success':
                IconToLoad = $2fad1ad7e24667d0$export$2957fc44b3d2481;
                break;
            case 'warn':
                IconToLoad = $2fad1ad7e24667d0$export$4b8ba45ae34f741a;
                break;
            case 'marketing':
                IconToLoad = $2fad1ad7e24667d0$export$ddb421af37c7fad5;
                break;
            case 'error':
            default:
                IconToLoad = $2fad1ad7e24667d0$export$19bc16ee58e19b3d;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(IconToLoad, {
                title: null,
                state: state
            }),
            size: icon_size,
            inheritColor: false
        });
    }
    static getDerivedStateFromProps(props, state) {
        if (state._id !== props.id && props.id) state.id = props.id;
        state._id = props.id;
        return state;
    }
    componentDidMount() {
        this._isMounted = true;
        if (document.readyState === 'complete') this.init();
        else if (typeof window !== 'undefined') window.addEventListener('load', this.init);
        if (typeof window !== 'undefined') window.addEventListener('resize', this.updateWidth);
    }
    fillCache() {
        const shouldAnimate = this.shouldAnimate();
        const content = shouldAnimate && $2fad1ad7e24667d0$export$2e2bcd8739ae039.getContent(this.props);
        if (content && content !== this.contentCache) this.contentCache = content;
        const state = shouldAnimate && $2fad1ad7e24667d0$export$2e2bcd8739ae039.correctStatus(this.props.state);
        if (state) this.stateCache = state;
    }
    componentWillUnmount() {
        this._isMounted = false;
        const status_id = this.getStatusId();
        this._globalStatus.remove(status_id);
        if (typeof window !== 'undefined') {
            window.removeEventListener('load', this.init);
            window.removeEventListener('resize', this.updateWidth);
        }
    }
    componentDidUpdate(prevProps) {
        var _prevProps$globalStat;
        const { state: state, show: show, text: text, globalStatus: globalStatus, children: children, label: label } = this.getProps();
        if (prevProps.text !== text || prevProps.children !== children || prevProps.show !== show || ((_prevProps$globalStat = prevProps.globalStatus) === null || _prevProps$globalStat === void 0 ? void 0 : _prevProps$globalStat.show) !== (globalStatus === null || globalStatus === void 0 ? void 0 : globalStatus.show) || prevProps.state !== state) {
            this.fillCache();
            if (state === 'error') {
                const status_id = this.getStatusId();
                if ((0, $11741836d1790446$export$7afc298d8ffd816)(show)) this._globalStatus.update(status_id, $2fad1ad7e24667d0$var$_objectSpread({
                    state: state,
                    status_id: status_id,
                    item: {
                        item_id: this.state.id,
                        text: (globalStatus === null || globalStatus === void 0 ? void 0 : globalStatus.message) || text || children,
                        status_anchor_label: label,
                        status_anchor_url: true
                    }
                }, globalStatus), {
                    preventRestack: true
                });
                else if (!$2fad1ad7e24667d0$export$2e2bcd8739ae039.getContent(this.props)) {
                    const status_id = this.getStatusId();
                    this._globalStatus.remove(status_id);
                }
            }
            if (this.isReadyToGetVisible()) this.updateWidth();
        }
    }
    getProps() {
        let context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
        return (0, $be16b996e1dc94eb$export$87ea024adc3494ce)(this.props, $2fad1ad7e24667d0$export$2e2bcd8739ae039.defaultProps, {
            skeleton: context === null || context === void 0 ? void 0 : context.skeleton
        }, (0, $c81beeaa1b3509d1$export$8efbf5589742246)(context === null || context === void 0 ? void 0 : context.FormRow), (0, $c81beeaa1b3509d1$export$8efbf5589742246)(context === null || context === void 0 ? void 0 : context.formElement), context === null || context === void 0 ? void 0 : context.FormStatus);
    }
    getStatusId() {
        return `${this.state.id}-gs`;
    }
    shouldAnimate() {
        return this.props.no_animation === false;
    }
    isReadyToGetVisible() {
        let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return (0, $11741836d1790446$export$7afc298d8ffd816)(props.show) && $2fad1ad7e24667d0$export$2e2bcd8739ae039.getContent(props) ? true : false;
    }
    render() {
        const props = this.getProps();
        const { title: title, state: rawState, size: size, variant: variant, className: className, stretch: stretch, shellSpace: shellSpace, text_id: text_id, show: show, no_animation: no_animation, label: label, status_id: status_id, globalStatus: globalStatus, id: id, text: text, icon: icon, icon_size: icon_size, skeleton: skeleton, children: children, role: role } = props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $2fad1ad7e24667d0$var$_excluded);
        const state = $2fad1ad7e24667d0$export$2e2bcd8739ae039.correctStatus(rawState) || this.stateCache;
        const iconToRender = $2fad1ad7e24667d0$export$2e2bcd8739ae039.getIcon({
            state: state,
            icon: icon,
            icon_size: icon_size
        });
        const contentToRender = $2fad1ad7e24667d0$export$2e2bcd8739ae039.getContent(this.props);
        const hasStringContent = typeof contentToRender === 'string' && contentToRender.length > 0;
        const params = $2fad1ad7e24667d0$var$_objectSpread({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(`dnb-form-status dnb-form-status__size--${size}`, (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(props), className, state && `dnb-form-status--${state}`, variant && `dnb-form-status__variant--${variant}`, stretch && 'dnb-form-status--stretch', hasStringContent && 'dnb-form-status--has-content'),
            id: !String(id).startsWith('null') ? this.state.id : null,
            title: title,
            role: role
        }, rest);
        if (!role) switch(state){
            case 'info':
                params.role = 'status';
                break;
            default:
                params.role = 'alert';
        }
        const textParams = {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-form-status__text', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)('font', skeleton, this.context)),
            id: !String(text_id).startsWith('null') ? text_id : null
        };
        const shellParams = {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-form-status__shell', (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)({
                space: shellSpace
            }))
        };
        (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(params, skeleton, this.context);
        (0, $11741836d1790446$export$4ddc669a9a6a5940)(this.props, params);
        (0, $11741836d1790446$export$4ddc669a9a6a5940)(null, textParams);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $c329544388f437e5$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
            element: "span",
            open: this.isReadyToGetVisible(),
            animate: this.shouldAnimate(),
            duration: 600
        }, params, {
            innerRef: this._ref
        }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", shellParams, iconToRender, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", textParams, contentToRender || this.contentCache)));
    }
    constructor(props, context){
        var _props$globalStatus, _context$FormStatus, _context$FormStatus$g, _context$FormRow, _context$FormRow$glob, _context$formElement, _context$formElement$;
        super(props);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "state", {
            id: null
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "init", ()=>{
            if (this._isMounted) {
                this._globalStatus.isReady();
                this.updateWidth();
                this.fillCache();
            }
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "updateWidth", ()=>{
            if (this._ref.current) {
                const { width_element: width_element, width_selector: width_selector } = this.props;
                $2fad1ad7e24667d0$export$5cee5f2e6530e9ba({
                    element: this._ref.current,
                    widthElement: width_element && width_element.current,
                    widthSelector: width_selector
                });
            }
        });
        this.state.id = props.id || (0, $11741836d1790446$export$d0c8ec0fe1b18b70)();
        this._globalStatus = (0, $fe477a1647186b55$export$2e2bcd8739ae039).init((props === null || props === void 0 ? void 0 : (_props$globalStatus = props.globalStatus) === null || _props$globalStatus === void 0 ? void 0 : _props$globalStatus.id) || (context === null || context === void 0 ? void 0 : (_context$FormStatus = context.FormStatus) === null || _context$FormStatus === void 0 ? void 0 : (_context$FormStatus$g = _context$FormStatus.globalStatus) === null || _context$FormStatus$g === void 0 ? void 0 : _context$FormStatus$g.id) || (context === null || context === void 0 ? void 0 : (_context$FormRow = context.FormRow) === null || _context$FormRow === void 0 ? void 0 : (_context$FormRow$glob = _context$FormRow.globalStatus) === null || _context$FormRow$glob === void 0 ? void 0 : _context$FormRow$glob.id) || (context === null || context === void 0 ? void 0 : (_context$formElement = context.formElement) === null || _context$formElement === void 0 ? void 0 : (_context$formElement$ = _context$formElement.globalStatus) === null || _context$formElement$ === void 0 ? void 0 : _context$formElement$.id) || 'main', (provider)=>{
            if (this.props.state === 'error' && this.isReadyToGetVisible()) {
                const { state: state, text: text, children: children, globalStatus: globalStatus, label: label } = this.getProps(context);
                provider.add($2fad1ad7e24667d0$var$_objectSpread({
                    state: state,
                    status_id: this.getStatusId(),
                    item: {
                        item_id: this.state.id,
                        text: (globalStatus === null || globalStatus === void 0 ? void 0 : globalStatus.message) || text || children,
                        status_anchor_label: label,
                        status_anchor_url: true
                    }
                }, globalStatus));
            }
        });
        this._ref = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createRef();
    }
}
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($2fad1ad7e24667d0$export$2e2bcd8739ae039, "contextType", (0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($2fad1ad7e24667d0$export$2e2bcd8739ae039, "defaultProps", {
    id: null,
    title: null,
    show: true,
    text: null,
    globalStatus: null,
    label: null,
    icon: 'error',
    icon_size: 'medium',
    size: 'default',
    variant: null,
    state: 'error',
    attributes: null,
    text_id: null,
    width_selector: null,
    width_element: null,
    no_animation: null,
    skeleton: null,
    stretch: null,
    role: null,
    className: null,
    children: null
});
const $2fad1ad7e24667d0$export$19bc16ee58e19b3d = (props)=>{
    var _useTheme;
    const { title: title = 'error' } = props || {};
    const isSbankenTheme = ((_useTheme = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()) === null || _useTheme === void 0 ? void 0 : _useTheme.name) === 'sbanken';
    const fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-magenta'] : $2fad1ad7e24667d0$var$properties.ui['--color-fire-red'];
    const line = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-magenta-light-2'] : $2fad1ad7e24667d0$var$properties.ui['--color-white'];
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("title", null, title), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M23.625 17.864A3.547 3.547 0 0120.45 23H3.548a3.546 3.546 0 01-3.172-5.136l8.45-14.902a3.548 3.548 0 016.347 0l8.452 14.902z",
        fill: fill
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M12 16.286a1.286 1.286 0 100 2.572 1.286 1.286 0 000-2.572z",
        fill: line
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M12 13.818v-5",
        stroke: line,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
const $2fad1ad7e24667d0$export$4b8ba45ae34f741a = (props)=>{
    var _useTheme2;
    const { title: title = 'error' } = props || {};
    const isSbankenTheme = ((_useTheme2 = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()) === null || _useTheme2 === void 0 ? void 0 : _useTheme2.name) === 'sbanken';
    const fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-yellow-dark'] : $2fad1ad7e24667d0$var$properties.ui['--color-accent-yellow'];
    const line = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-black'] : $2fad1ad7e24667d0$var$properties.ui['--color-black-80'];
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("title", null, title), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M23.625 17.864A3.547 3.547 0 0120.45 23H3.548a3.546 3.546 0 01-3.172-5.136l8.45-14.902a3.548 3.548 0 016.347 0l8.452 14.902z",
        fill: fill
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M12 16.286a1.286 1.286 0 100 2.572 1.286 1.286 0 000-2.572z",
        fill: line
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M12 13.818v-5",
        stroke: line,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
const $2fad1ad7e24667d0$export$2957fc44b3d2481 = (props)=>{
    var _useTheme3;
    const { title: title = 'info' } = props || {};
    const isSbankenTheme = ((_useTheme3 = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()) === null || _useTheme3 === void 0 ? void 0 : _useTheme3.name) === 'sbanken';
    let fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-green-dark-2'] : $2fad1ad7e24667d0$var$properties.ui['--color-sea-green'];
    if (props && (props === null || props === void 0 ? void 0 : props.state) === 'success') fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-green-dark-3'] : $2fad1ad7e24667d0$var$properties.ui['--color-summer-green'];
    const line = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-green-light-2'] : $2fad1ad7e24667d0$var$properties.ui['--color-white'];
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("title", null, title), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.268 0a11.25 11.25 0 105.566 21.017l6.112 2.91a.75.75 0 001-1l-2.911-6.112A11.234 11.234 0 0011.268 0z",
        fill: fill
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("circle", {
        cx: "11",
        cy: "6.5",
        r: ".5",
        fill: "#fff",
        stroke: line
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M13.75 16H13a1.5 1.5 0 01-1.5-1.5v-3.75a.75.75 0 00-.75-.75H10",
        stroke: line,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
const $2fad1ad7e24667d0$export$ddb421af37c7fad5 = (props)=>{
    var _useTheme4;
    const { title: title = 'marketing' } = props || {};
    const isSbankenTheme = ((_useTheme4 = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)()) === null || _useTheme4 === void 0 ? void 0 : _useTheme4.name) === 'sbanken';
    const fill = isSbankenTheme ? $2fad1ad7e24667d0$var$properties.sbanken['--sb-color-violet-light'] : $2fad1ad7e24667d0$var$properties.ui['--color-black-80'];
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        width: "24",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("title", null, title), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        d: "M6 15.25H4.5c-2.042 0-3.75-1.707-3.75-3.75S2.458 7.75 4.5 7.75H6v7.5ZM7.5 15.25c4.801 0 8.846 1.897 12.75 4.5V3.25c-3.904 2.603-7.949 4.5-12.75 4.5v7.5ZM23.25 10a.75.75 0 0 0-1.5 0h1.5Zm-1.5 3a.75.75 0 0 0 1.5 0h-1.5ZM8.483 21.043a.75.75 0 1 0 1.034-1.086l-1.034 1.086ZM21.75 10v3h1.5v-3h-1.5ZM6 15.25a8.058 8.058 0 0 0 2.483 5.793l1.034-1.086A6.559 6.559 0 0 1 7.5 15.25H6Z",
        fill: fill
    }));
};
function $2fad1ad7e24667d0$export$5cee5f2e6530e9ba(_ref2) {
    let { element: element, id: id = null, widthElement: widthElement = null, widthSelector: widthSelector = null } = _ref2;
    if (!(element && typeof window !== 'undefined')) return;
    try {
        var _id;
        if (!id && !widthSelector) id = element.getAttribute('id');
        widthSelector = widthSelector || ((_id = id) === null || _id === void 0 ? void 0 : _id.replace('-form-status', '')) || id;
        let width = $2fad1ad7e24667d0$var$sumElementWidth({
            widthElement: widthElement,
            widthSelector: widthSelector
        });
        if (width > 40) {
            const maxWidth = 480;
            if (width < maxWidth) width = maxWidth;
            const remWidth = `${width / 16}rem`;
            const style = window.getComputedStyle(element);
            const hasCustomWidth = element.style.maxWidth ? false : style.minWidth !== '' && style.minWidth !== 'auto' || style.maxWidth !== '' && style.maxWidth !== 'none';
            if (!hasCustomWidth) element.style.maxWidth = remWidth;
        }
    } catch (e) {}
}
function $2fad1ad7e24667d0$var$sumElementWidth(_ref3) {
    let { widthElement: widthElement, widthSelector: widthSelector } = _ref3;
    let width = 0;
    if (typeof document === 'undefined') return width;
    try {
        const ids = widthElement ? [
            widthElement
        ] : widthSelector.split(/, |,/g);
        width = ids.reduce((acc, cur)=>{
            const elem = typeof cur === 'string' ? cur[0] === '.' ? document.querySelector(cur) : document.getElementById(cur) : cur;
            let width = elem && elem.offsetWidth || window.getComputedStyle(elem).width;
            if (/em|rem/.test(width)) width = parseFloat(width) * 16;
            if (width > 0) {
                if (acc > 0) acc += 16;
                acc += width;
            }
            return acc;
        }, width);
    } catch (e) {}
    return width;
}
$2fad1ad7e24667d0$export$2e2bcd8739ae039._supportsSpacingProps = true;






var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");



var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");




"use client";
const $3d090471d65e4fa1$var$_excluded = [
    "className",
    "internalClass",
    "as",
    "innerRef",
    "skeleton",
    "skeletonMethod"
];
const $3d090471d65e4fa1$export$9c21a3269931e1e6 = {
    skeletonMethod: 'font'
};
const $3d090471d65e4fa1$var$Element = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).forwardRef((props, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($3d090471d65e4fa1$var$ElementInstance, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        innerRef: ref
    }, props));
});
function $3d090471d65e4fa1$var$ElementInstance(localProps) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useContext((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $3d090471d65e4fa1$export$9c21a3269931e1e6, {
        skeleton: context === null || context === void 0 ? void 0 : context.skeleton
    });
    const { className: className, internalClass: internalClass, as: as, innerRef: innerRef, skeleton: skeleton, skeletonMethod: skeletonMethod } = props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $3d090471d65e4fa1$var$_excluded);
    const Tag = as;
    const attributes = rest;
    const tagClass = internalClass === false ? '' : (internalClass === true ? undefined : internalClass) || (typeof Tag === 'string' ? `dnb-${Tag}` : '');
    const internalClassName = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(className, (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(skeletonMethod, skeleton, context), (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(attributes, typeof Tag === 'string' ? `dnb-${Tag}` : null), !new RegExp(`${tagClass}(\\s|$)`).test(String(className)) && tagClass);
    (0, $11741836d1790446$export$4ddc669a9a6a5940)(null, attributes);
    (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(attributes, skeleton, context);
    if (typeof Tag !== 'function' && innerRef) attributes.ref = innerRef;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Tag, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        className: internalClassName
    }, attributes));
}
var $3d090471d65e4fa1$export$2e2bcd8739ae039 = $3d090471d65e4fa1$var$Element;









parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");






parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");



parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");



var $ljfqi = parcelRequire("ljfqi");
function $102c8da1eed7491d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $102c8da1eed7491d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $102c8da1eed7491d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $102c8da1eed7491d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $102c8da1eed7491d$export$2e2bcd8739ae039(props) {
    const { internalId: internalId, active: active, attributes: attributes, arrow: arrow, position: position, align: align, hideDelay: hideDelay, fixedPosition: fixedPosition, noAnimation: noAnimation, skipPortal: skipPortal, useHover: useHover, children: children, targetElement: target } = props;
    const [style, setStyle] = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useState(null);
    const [arrowStyle, setArrowStyle] = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useState(null);
    const [hover, setHover] = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useState(false);
    const isActive = (0, $11741836d1790446$export$7afc298d8ffd816)(active) || hover;
    const [wasActive, makeActive] = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useState(false);
    const [renewStyles, forceRerender] = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useState(getBodySize);
    const elementRef = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef(null);
    const offset = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef(16);
    const debounceTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef();
    const resizeObserver = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef(null);
    function getBodySize() {
        if (!isActive || typeof document === 'undefined') return 0;
        const { width: width, height: height } = document.body.getBoundingClientRect();
        return width + height;
    }
    const clearTimers = ()=>{
        clearTimeout(debounceTimeout.current);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useLayoutEffect(()=>{
        const addPositionObserver = ()=>{
            if (resizeObserver.current || typeof document === 'undefined') return;
            try {
                resizeObserver.current = new ResizeObserver(()=>{
                    clearTimers();
                    debounceTimeout.current = setTimeout(()=>forceRerender(getBodySize()), 100);
                });
                resizeObserver.current.observe(document.body);
            } catch (e) {}
        };
        const removePositionObserver = ()=>{
            var _resizeObserver$curre;
            clearTimers();
            (_resizeObserver$curre = resizeObserver.current) === null || _resizeObserver$curre === void 0 || _resizeObserver$curre.disconnect();
        };
        if (isActive) {
            makeActive(true);
            addPositionObserver();
        } else removePositionObserver();
        return removePositionObserver;
    }, [
        isActive
    ]);
    const offsetLeft = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef(0);
    const offsetTop = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useLayoutEffect(()=>{
        var _stylesFromPosition$p, _stylesFromArrow$arro;
        if (!isActive) {
            if (wasActive) {
                clearTimeout(debounceTimeout.current);
                debounceTimeout.current = setTimeout(()=>setStyle(null), hideDelay);
            }
            return;
        }
        const element = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (typeof window === 'undefined' || !element || !(target !== null && target !== void 0 && target.getBoundingClientRect)) return;
        let alignOffset = 0;
        const elementWidth = element.offsetWidth;
        const elementHeight = element.offsetHeight;
        const rect = target.getBoundingClientRect();
        const targetBodySize = {
            width: rect.width || target.offsetWidth,
            height: rect.height || target.offsetHeight
        };
        if (skipPortal && (!offsetLeft.current || !offsetTop.current)) {
            offsetLeft.current = (0, $deeefef162515a83$export$a6a488ff68b1bf7b)(element) - offset.current;
            offsetTop.current = (0, $deeefef162515a83$export$6fcff0dc60346367)(element) - offset.current;
        }
        const scrollY = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
        const scrollX = window.scrollX !== undefined ? window.scrollX : window.pageXOffset;
        const top = ((0, $11741836d1790446$export$7afc298d8ffd816)(fixedPosition) ? 0 : scrollY) + rect.top - offsetTop.current;
        const widthBased = scrollX + rect.left;
        const left = widthBased - offsetLeft.current;
        const style = $102c8da1eed7491d$var$_objectSpread({}, props.style);
        const arrowStyle = {
            top: null,
            left: null
        };
        if (align === 'left') alignOffset = -targetBodySize.width / 2;
        else if (align === 'right') alignOffset = targetBodySize.width / 2;
        const topHorizontal = top + targetBodySize.height / 2 - elementHeight / 2;
        const leftVertical = left - elementWidth / 2 + targetBodySize.width / 2 + alignOffset;
        const stylesFromPosition = {
            left: ()=>{
                style.top = topHorizontal;
                style.left = left - elementWidth - offset.current;
            },
            right: ()=>{
                style.top = topHorizontal;
                style.left = left + targetBodySize.width + offset.current;
            },
            top: ()=>{
                style.left = leftVertical;
                style.top = top - elementHeight - offset.current;
            },
            bottom: ()=>{
                style.left = leftVertical;
                style.top = top + targetBodySize.height + offset.current;
            }
        };
        const stylesFromArrow = {
            left: ()=>{
                style.left = left + targetBodySize.width / 2 - offset.current + alignOffset;
            },
            right: ()=>{
                style.left = left - elementWidth + targetBodySize.width / 2 + offset.current + alignOffset;
            },
            top: ()=>{
                style.top = top + targetBodySize.height / 2 - offset.current;
            },
            bottom: ()=>{
                style.top = top + targetBodySize.height / 2 - elementHeight + offset.current;
            }
        };
        (_stylesFromPosition$p = stylesFromPosition[position]) === null || _stylesFromPosition$p === void 0 || _stylesFromPosition$p.call(stylesFromPosition);
        (_stylesFromArrow$arro = stylesFromArrow[arrow]) === null || _stylesFromArrow$arro === void 0 || _stylesFromArrow$arro.call(stylesFromArrow);
        const rightOffset = parseFloat(String(style.left)) + elementWidth - window.innerWidth;
        if (rightOffset > 0) style.left = window.innerWidth - elementWidth;
        if (parseFloat(String(style.left)) < 0) {
            style.left = 0;
            if (position === 'top' || position === 'bottom') {
                const arrowWidth = 16;
                const arrowStyleBasisWidth = left - arrowWidth / 2;
                if (align === 'left') arrowStyle.left = arrowStyleBasisWidth;
                else if (align === 'right') arrowStyle.left = arrowStyleBasisWidth + targetBodySize.width;
                else arrowStyle.left = arrowStyleBasisWidth + targetBodySize.width / 2;
            }
        }
        if (parseFloat(String(style.top)) < 0) {
            style.top = 0;
            arrowStyle.top = 0;
        }
        setStyle(style);
        setArrowStyle(arrowStyle);
    }, [
        active,
        arrow,
        position,
        children,
        renewStyles,
        align
    ]);
    const handleMouseEnter = ()=>{
        if ((0, $11741836d1790446$export$7afc298d8ffd816)(active) && useHover !== false) setHover(true);
    };
    const handleMouseLeave = ()=>{
        if (useHover !== false) setHover(false);
    };
    const handlePropagation = (e)=>e.stopPropagation();
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        role: "tooltip",
        "aria-hidden": target ? true : undefined,
        ref: elementRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseMove: handlePropagation,
        onMouseDown: handlePropagation,
        onTouchStart: handlePropagation
    }, attributes, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(attributes === null || attributes === void 0 ? void 0 : attributes.className, isActive ? 'dnb-tooltip--active' : wasActive && 'dnb-tooltip--hide', (0, $11741836d1790446$export$7afc298d8ffd816)(noAnimation) && 'dnb-tooltip--no-animation', (0, $11741836d1790446$export$7afc298d8ffd816)(fixedPosition) && 'dnb-tooltip--fixed'),
        style: $102c8da1eed7491d$var$_objectSpread($102c8da1eed7491d$var$_objectSpread({}, style), attributes.style)
    }), arrow && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", {
        className: `dnb-tooltip__arrow dnb-tooltip__arrow__arrow--${arrow} dnb-tooltip__arrow__position--${position}`,
        style: $102c8da1eed7491d$var$_objectSpread({}, arrowStyle)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", {
        id: internalId,
        className: "dnb-tooltip__content"
    }, children));
}



var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");

function $911842e5a561b5ca$export$22dfc7bb2d427754(params) {
    params.tabIndex = '0';
    params.className = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))("dnb-tooltip__wrapper dnb-tab-focus", params.className);
    return params;
}
const $911842e5a561b5ca$export$9c21a3269931e1e6 = {
    id: null,
    size: 'basis',
    active: null,
    position: 'top',
    arrow: 'center',
    align: null,
    fixedPosition: false,
    skipPortal: null,
    noAnimation: false,
    showDelay: 300,
    hideDelay: 500,
    targetSelector: null,
    targetElement: null,
    className: null,
    children: null,
    tooltip: null
};
function $911842e5a561b5ca$export$2562999169740ceb(target) {
    if (typeof document !== 'undefined') return typeof target === 'string' ? typeof document !== 'undefined' && document.querySelector(target) : target;
}
function $911842e5a561b5ca$export$6ea2c3c743cd2a2f(targetElement, internalId) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useEffect(()=>{
        try {
            const existing = {
                'aria-describedby': targetElement.getAttribute('aria-describedby')
            };
            targetElement.setAttribute('aria-describedby', (0, $11741836d1790446$export$ac6c18d26085326c)(existing, internalId));
        } catch (e) {}
    }, [
        targetElement,
        internalId
    ]);
}
function $911842e5a561b5ca$export$2414da066cdcef(localProps) {
    return localProps.tooltip ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(localProps.tooltip) && localProps.tooltip.props ? localProps.tooltip.props : {
        children: localProps.tooltip
    } : null;
}
function $911842e5a561b5ca$export$446ddc3de119a35c(target) {
    var _unknownTarget$curren;
    const unknownTarget = target;
    let element = target;
    if (unknownTarget !== null && unknownTarget !== void 0 && (_unknownTarget$curren = unknownTarget.current) !== null && _unknownTarget$curren !== void 0 && _unknownTarget$curren._ref) element = $911842e5a561b5ca$export$446ddc3de119a35c(unknownTarget.current._ref);
    if (element && Object.prototype.hasOwnProperty.call(element, 'current')) element = element.current;
    return element;
}
const $911842e5a561b5ca$export$971e5333ff27c622 = (type)=>{
    return /touch/i.test(type);
};



parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");

parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");
"use client";
function $9738f50fda5b2f16$export$2e2bcd8739ae039(callback) {
    (0, $ieaan.useEffect)(function() {
        return callback(...arguments);
    }, []);
}







var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");



parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");


"use client";
const $8311cfcd13326d81$var$_excluded = [
    "children"
], $8311cfcd13326d81$var$_excluded2 = [
    "value"
];
function $8311cfcd13326d81$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8311cfcd13326d81$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8311cfcd13326d81$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8311cfcd13326d81$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8311cfcd13326d81$export$2e2bcd8739ae039(localProps) {
    const nestedContext = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const [localContext, setLocalContext] = (0, $ieaan.useState)(null);
    const updateCurrent = (0, $ieaan.useCallback)((props)=>{
        setLocalContext({
            __context__: props
        });
    }, []);
    const setCurrentLocale = (0, $ieaan.useCallback)((locale)=>{
        setLocalContext({
            __context__: {
                locale: locale
            }
        });
    }, []);
    const update = (0, $ieaan.useCallback)((props)=>{
        var _nestedContext$update;
        (_nestedContext$update = nestedContext.update) === null || _nestedContext$update === void 0 || _nestedContext$update.call(nestedContext, props);
        setLocalContext({
            __context__: props
        });
    }, [
        nestedContext
    ]);
    const setLocale = (0, $ieaan.useCallback)((locale)=>{
        update({
            locale: locale
        });
    }, [
        update
    ]);
    const value = (0, $ieaan.useMemo)(()=>{
        const { children: children } = localProps, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(localProps, $8311cfcd13326d81$var$_excluded);
        const preparedContext = $8311cfcd13326d81$var$_objectSpread({}, (0, $e220d71a88fa3fa1$export$9c634076e0a91d1f)($8311cfcd13326d81$var$mergeContextWithProps(nestedContext, $8311cfcd13326d81$var$_objectSpread($8311cfcd13326d81$var$_objectSpread({}, localContext), rest))));
        preparedContext.update = update;
        preparedContext.setLocale = setLocale;
        preparedContext.updateCurrent = updateCurrent;
        preparedContext.setCurrentLocale = setCurrentLocale;
        nestedContext.updateTranslation(preparedContext.locale, preparedContext.translations);
        return preparedContext;
    }, [
        localProps,
        nestedContext,
        localContext,
        update,
        setLocale,
        updateCurrent,
        setCurrentLocale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039).Provider, {
        value: value
    }, localProps.children);
}
function $8311cfcd13326d81$var$mergeContextWithProps(nestedContext, localProps) {
    const { value: value } = localProps, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(localProps, $8311cfcd13326d81$var$_excluded2);
    const props = $8311cfcd13326d81$var$_objectSpread($8311cfcd13326d81$var$_objectSpread({}, value), rest);
    const mergedContext = $8311cfcd13326d81$var$_objectSpread($8311cfcd13326d81$var$_objectSpread({}, nestedContext), props);
    if (nestedContext !== null && nestedContext !== void 0 && nestedContext.formElement && props.formElement) {
        mergedContext.formElement = $8311cfcd13326d81$var$_objectSpread($8311cfcd13326d81$var$_objectSpread({}, nestedContext.formElement), props.formElement);
        mergedContext.formElement = (0, $c81beeaa1b3509d1$export$c37735b23b2df049)(mergedContext.formElement);
    }
    if (nestedContext !== null && nestedContext !== void 0 && nestedContext.FormRow && props.FormRow) {
        mergedContext.FormRow = $8311cfcd13326d81$var$_objectSpread($8311cfcd13326d81$var$_objectSpread({}, nestedContext.FormRow), props.FormRow);
        mergedContext.FormRow = (0, $c81beeaa1b3509d1$export$c37735b23b2df049)(mergedContext.FormRow);
    }
    return mergedContext;
}



"use client";
const $db09087c4569f84b$var$_excluded = [
    "children",
    "element",
    "name",
    "variant",
    "size",
    "propMapping",
    "contrastMode",
    "darkMode",
    "darkBackground"
], $db09087c4569f84b$var$_excluded2 = [
    "element"
], $db09087c4569f84b$var$_excluded3 = [
    "children",
    "theme",
    "element",
    "className"
];
function $db09087c4569f84b$export$2e2bcd8739ae039(themeProps) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useContext((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const { children: children, element: element, name: name, variant: variant, size: size, propMapping: propMapping, contrastMode: contrastMode, darkMode: darkMode, darkBackground: darkBackground } = themeProps, restProps = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(themeProps, $db09087c4569f84b$var$_excluded);
    const theme = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)({
        name: name,
        variant: variant,
        size: size,
        propMapping: propMapping,
        contrastMode: contrastMode,
        darkMode: darkMode,
        darkBackground: darkBackground
    }, null, context === null || context === void 0 ? void 0 : context.theme);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $8311cfcd13326d81$export$2e2bcd8739ae039), {
        theme: theme
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($db09087c4569f84b$export$cf6495336e7980c8, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        element: element,
        theme: theme
    }, restProps), children));
}
$db09087c4569f84b$export$2e2bcd8739ae039.Provider = (_ref)=>{
    let { element: element } = _ref, themeProps = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $db09087c4569f84b$var$_excluded2);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($db09087c4569f84b$export$2e2bcd8739ae039, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, themeProps, {
        element: false
    }));
};
$db09087c4569f84b$export$2e2bcd8739ae039.Provider['_supportsSpacingProps'] = 'children';
function $db09087c4569f84b$export$cf6495336e7980c8(_ref2) {
    let { children: children, theme: theme, element: element = null, className: className = null } = _ref2, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref2, $db09087c4569f84b$var$_excluded3);
    const Wrapper = element === false ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment : element || 'div';
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef(null);
    if (Wrapper === (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment) return children;
    rest['ref'] = ref;
    const classNames = $db09087c4569f84b$export$23c366e92bb8901c(theme, className);
    const { name: name, variant: variant, size: size } = theme;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Wrapper, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        "data-name": name,
        "data-variant": variant,
        "data-size": size,
        className: classNames
    }, rest), children);
}
function $db09087c4569f84b$export$23c366e92bb8901c(theme) {
    let className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!theme) return className;
    const { name: name, variant: variant, size: size, propMapping: propMapping, contrastMode: contrastMode, darkMode: darkMode } = theme;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(className, 'eufemia-theme', name && `eufemia-theme__${name}` + (variant ? ` eufemia-theme__${name}--${variant}` : ""), propMapping && `eufemia-theme__prop-mapping--${propMapping}`, contrastMode && 'eufemia-theme__contrast-mode', darkMode && 'eufemia-theme__dark-mode', size && `eufemia-theme__size--${size}`);
}






var $ieaan = parcelRequire("ieaan");


var $ljfqi = parcelRequire("ljfqi");
parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");


const $8898afc1b6d058e7$var$slugify = (s)=>String(s).toLowerCase().replace(/[^a-z0-9-]/g, '_');
const $8898afc1b6d058e7$export$bd0a6d13e5f3800b = function() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    const version = (opts === null || opts === void 0 ? void 0 : opts.version) || (0, $bce3ea05de26e767$export$c506eb22e615ba4a)();
    const isVersion = String(version).match(/^\d/);
    const isBranch = String(version).includes('/');
    if (isVersion) return $8898afc1b6d058e7$var$slugify(`eufemia-scope--${version}`);
    if (isBranch) {
        const sha = (opts === null || opts === void 0 ? void 0 : opts.sha) || (0, $bce3ea05de26e767$export$60d52592423e9732)();
        return $8898afc1b6d058e7$var$slugify(`eufemia-scope--${sha}`);
    }
    return 'eufemia-scope--default';
};



"use client";
const $ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4 = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createContext(undefined);
const $ce0e0ed7ebbe2d2a$var$parentScopeContextMap = new Map();
function $ce0e0ed7ebbe2d2a$export$2e2bcd8739ae039(props) {
    const styleScopeContext = (0, $ieaan.useContext)($ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4);
    const { scopeHash: scopeHash = 'auto', disableCoreStyleWrapper: disableCoreStyleWrapper = false, uniqueKey: uniqueKey = 'default', innerRef: innerRef, children: children, style: style } = props;
    const localRef = (0, $ieaan.useRef)();
    const scopeElementRef = innerRef || localRef;
    const generatedScopeHash = scopeHash === 'auto' ? (styleScopeContext === null || styleScopeContext === void 0 ? void 0 : styleScopeContext.generatedScopeHash) || (0, $8898afc1b6d058e7$export$bd0a6d13e5f3800b)() : scopeHash;
    const isNestedWithNewScope = styleScopeContext && styleScopeContext.generatedScopeHash && styleScopeContext.generatedScopeHash !== generatedScopeHash;
    const parentContextMap = (styleScopeContext === null || styleScopeContext === void 0 ? void 0 : styleScopeContext.parentContextMap) || $ce0e0ed7ebbe2d2a$var$parentScopeContextMap;
    if (styleScopeContext !== null && styleScopeContext !== void 0 && styleScopeContext.generatedScopeHash) parentContextMap.set(styleScopeContext.generatedScopeHash, styleScopeContext);
    if (styleScopeContext !== null && styleScopeContext !== void 0 && styleScopeContext.generatedScopeHash ? props.scopeHash : true) {
        var _styleScopeContext$in;
        if (uniqueKey === false || !(styleScopeContext !== null && styleScopeContext !== void 0 && (_styleScopeContext$in = styleScopeContext.internalKeys) !== null && _styleScopeContext$in !== void 0 && _styleScopeContext$in.has(uniqueKey)) || isNestedWithNewScope) {
            var _styleScopeContext$sc;
            const internalKeys = new Set((styleScopeContext === null || styleScopeContext === void 0 ? void 0 : styleScopeContext.internalKeys) || []);
            if (typeof uniqueKey === 'string') internalKeys.add(uniqueKey);
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4.Provider, {
                value: {
                    scopeHash: scopeHash,
                    generatedScopeHash: generatedScopeHash,
                    disableCoreStyleWrapper: disableCoreStyleWrapper,
                    style: style,
                    scopeElementRef: scopeElementRef,
                    internalKeys: internalKeys,
                    parentContextMap: parentContextMap
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", {
                "data-scope-hash": scopeHash === 'auto' ? (_styleScopeContext$sc = styleScopeContext === null || styleScopeContext === void 0 ? void 0 : styleScopeContext.scopeHash) !== null && _styleScopeContext$sc !== void 0 ? _styleScopeContext$sc : scopeHash : scopeHash,
                "data-scope-hash-id": uniqueKey || undefined,
                "data-scope-sha": uniqueKey ? (0, $bce3ea05de26e767$export$60d52592423e9732)() : undefined,
                className: generatedScopeHash,
                style: style || (styleScopeContext === null || styleScopeContext === void 0 ? void 0 : styleScopeContext.style),
                ref: scopeElementRef
            }, disableCoreStyleWrapper ? children : (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", {
                className: "dnb-core-style"
            }, children)));
        }
    }
    return children;
}
function $ce0e0ed7ebbe2d2a$export$5cf7a780904d1670(currentElement) {
    let scopeHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
    let fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (scopeHash === 'auto') scopeHash = (0, $8898afc1b6d058e7$export$bd0a6d13e5f3800b)();
    if (typeof window === 'undefined') return undefined;
    if (scopeHash) return currentElement.closest(`.${scopeHash}`);
    return fallback || document.body;
}
function $ce0e0ed7ebbe2d2a$export$885c19c3d536c50f(scopeHash) {
    const styleScopeContext = (0, $ieaan.useContext)($ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4);
    const { scopeElementRef: scopeElementRef, generatedScopeHash: generatedScopeHash, parentContextMap: parentContextMap } = styleScopeContext || {};
    const getScopeElement = (0, $ieaan.useCallback)(()=>{
        var _parentCtx$scopeEleme;
        if (!scopeHash || scopeHash === generatedScopeHash) return scopeElementRef === null || scopeElementRef === void 0 ? void 0 : scopeElementRef.current;
        const map = parentContextMap || $ce0e0ed7ebbe2d2a$var$parentScopeContextMap;
        const parentCtx = map.get(scopeHash);
        return parentCtx === null || parentCtx === void 0 ? void 0 : (_parentCtx$scopeEleme = parentCtx.scopeElementRef) === null || _parentCtx$scopeEleme === void 0 ? void 0 : _parentCtx$scopeEleme.current;
    }, [
        scopeElementRef,
        generatedScopeHash,
        parentContextMap,
        scopeHash
    ]);
    return {
        getScopeElement: getScopeElement
    };
}


"use client";
const $3f8ee7b36ba48dd0$var$_excluded = [
    "innerRef",
    "className",
    "style",
    "children"
];
function $3f8ee7b36ba48dd0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f8ee7b36ba48dd0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f8ee7b36ba48dd0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f8ee7b36ba48dd0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3f8ee7b36ba48dd0$var$PortalRoot(_ref) {
    let { innerRef: innerRef, className: className, style: style, children: children } = _ref, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $3f8ee7b36ba48dd0$var$_excluded);
    const { style: scopeStyle } = (0, $ieaan.useContext)((0, $ce0e0ed7ebbe2d2a$export$2fcd721fd39775d4)) || {};
    const id = 'eufemia-portal-root';
    const initialElement = (0, $ieaan.useMemo)(()=>$3f8ee7b36ba48dd0$export$19d5eea5285f880d(id), []);
    const localRef = (0, $ieaan.useRef)(initialElement);
    (0, $ieaan.useEffect)(()=>{
        const elem = $3f8ee7b36ba48dd0$export$19d5eea5285f880d(id);
        localRef.current = elem;
        if (innerRef) {
            if (typeof innerRef === 'function') innerRef(elem);
            else {
                const ref = innerRef;
                ref.current = elem;
            }
        }
    }, [
        id,
        innerRef
    ]);
    if (!localRef.current) return null;
    return (0, $d44b6dac8b4642ae$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $ce0e0ed7ebbe2d2a$export$2e2bcd8739ae039), {
        scopeHash: "auto",
        disableCoreStyleWrapper: true,
        uniqueKey: false
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-core-style', className),
        style: $3f8ee7b36ba48dd0$var$_objectSpread($3f8ee7b36ba48dd0$var$_objectSpread({}, scopeStyle), style)
    }, rest), children)), localRef.current);
}
function $3f8ee7b36ba48dd0$export$19d5eea5285f880d(id) {
    if (typeof window === 'undefined' || typeof document === 'undefined') return null;
    let elem = document.getElementById(id);
    if (!elem) {
        elem = document.createElement('div');
        elem.setAttribute('id', id);
        elem.setAttribute('role', 'presentation');
        document.body.insertBefore(elem, document.body.firstChild);
    }
    return elem;
}
var $3f8ee7b36ba48dd0$export$2e2bcd8739ae039 = $3f8ee7b36ba48dd0$var$PortalRoot;


var $5d465b8f84f7d74a$export$2e2bcd8739ae039 = (0, $3f8ee7b36ba48dd0$export$2e2bcd8739ae039);



var $ieaan = parcelRequire("ieaan");
const $76e00ffe77c40f50$var$ModalContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createContext({
    preventClick: null,
    onKeyDownHandler: null,
    id: null,
    title: null,
    hide_close_button: null,
    close_button_attributes: null,
    close_title: null,
    setBackgroundColor: null,
    onCloseClickHandler: null,
    contentRef: null,
    scrollRef: null,
    hide: null,
    contentId: null,
    close: null
});
var $76e00ffe77c40f50$export$2e2bcd8739ae039 = $76e00ffe77c40f50$var$ModalContext;


"use client";
let $9a3f9dc35e7bb3bc$var$tooltipPortal;
if (typeof globalThis !== 'undefined') {
    globalThis.tooltipPortal = globalThis.tooltipPortal || {};
    $9a3f9dc35e7bb3bc$var$tooltipPortal = globalThis.tooltipPortal;
} else $9a3f9dc35e7bb3bc$var$tooltipPortal = {};
function $9a3f9dc35e7bb3bc$var$TooltipPortal(props) {
    const { active: active, targetElement: targetElement, hideDelay: hideDelay, keepInDOM: keepInDOM, noAnimation: noAnimation, children: children } = props;
    const modalContext = (0, $ieaan.useContext)((0, $76e00ffe77c40f50$export$2e2bcd8739ae039));
    const [isMounted, setIsMounted] = (0, $ieaan.useState)(false);
    const [isActive, setIsActive] = (0, $ieaan.useState)(active);
    const [id] = (0, $ieaan.useState)(()=>(0, $11741836d1790446$export$d0c8ec0fe1b18b70)());
    const isInDOM = (0, $ieaan.useRef)(false);
    const theme = (0, $ad7f813f95b3e41b$export$2e2bcd8739ae039)();
    const makeTooltip = (0, $ieaan.useCallback)(()=>{
        if (!$9a3f9dc35e7bb3bc$var$tooltipPortal[id]) $9a3f9dc35e7bb3bc$var$tooltipPortal[id] = {
            count: 0
        };
    }, [
        id
    ]);
    const clearTimers = (0, $ieaan.useCallback)(()=>{
        var _tooltipPortal$id, _tooltipPortal$id2;
        clearTimeout((_tooltipPortal$id = $9a3f9dc35e7bb3bc$var$tooltipPortal[id]) === null || _tooltipPortal$id === void 0 ? void 0 : _tooltipPortal$id.delayTimeout);
        clearTimeout((_tooltipPortal$id2 = $9a3f9dc35e7bb3bc$var$tooltipPortal[id]) === null || _tooltipPortal$id2 === void 0 ? void 0 : _tooltipPortal$id2.hiddenTimeout);
    }, [
        id
    ]);
    (0, $ieaan.useEffect)(()=>{
        setIsMounted(true);
        clearTimers();
        if (active) {
            makeTooltip();
            setIsActive(true);
            isInDOM.current = true;
            if (!isMounted) $9a3f9dc35e7bb3bc$var$tooltipPortal[id].count++;
        } else if (!active && isMounted) {
            const delayRender = ()=>{
                setIsActive(false);
            };
            const delayHidden = ()=>{
                isInDOM.current = false;
            };
            if (noAnimation || globalThis.IS_TEST) {
                delayRender();
                delayHidden();
            } else if ($9a3f9dc35e7bb3bc$var$tooltipPortal[id]) {
                const delay = parseFloat(String(hideDelay));
                $9a3f9dc35e7bb3bc$var$tooltipPortal[id].delayTimeout = setTimeout(delayRender, delay);
                $9a3f9dc35e7bb3bc$var$tooltipPortal[id].hiddenTimeout = setTimeout(delayHidden, delay + 300);
            }
        }
        return clearTimers;
    }, [
        active,
        clearTimers,
        hideDelay,
        id,
        isMounted,
        makeTooltip,
        noAnimation
    ]);
    (0, $9738f50fda5b2f16$export$2e2bcd8739ae039)(()=>{
        if (keepInDOM) makeTooltip();
    });
    if (isInDOM.current || keepInDOM) return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $5d465b8f84f7d74a$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tooltip__portal', theme && (0, $db09087c4569f84b$export$23c366e92bb8901c)(theme), (modalContext === null || modalContext === void 0 ? void 0 : modalContext.id) && 'dnb-tooltip--inside-modal')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $102c8da1eed7491d$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, props, {
        targetElement: targetElement,
        active: isActive
    }), children)));
    return null;
}
var $9a3f9dc35e7bb3bc$export$2e2bcd8739ae039 = $9a3f9dc35e7bb3bc$var$TooltipPortal;


"use client";
const $d24b1e1646088a6a$var$_excluded = [
    "children"
];
function $d24b1e1646088a6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d24b1e1646088a6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d24b1e1646088a6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d24b1e1646088a6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d24b1e1646088a6a$var$TooltipWithEvents(props) {
    const { children: children } = props, restProps = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $d24b1e1646088a6a$var$_excluded);
    const { active: active, target: target, skipPortal: skipPortal, noAnimation: noAnimation, showDelay: showDelay, hideDelay: hideDelay, internalId: internalId } = restProps;
    const [isActive, setIsActive] = (0, $ieaan.useState)(active);
    const [isNotSemanticElement, setIsNotSemanticElement] = (0, $ieaan.useState)(false);
    const [isMounted, setIsMounted] = (0, $ieaan.useState)(!target);
    const [isControlled] = (0, $ieaan.useState)(()=>typeof active === 'boolean');
    const delayTimeout = (0, $ieaan.useRef)();
    const cloneRef = (0, $ieaan.useRef)();
    const targetRef = (0, $ieaan.useRef)();
    const clearTimers = ()=>{
        clearTimeout(delayTimeout.current);
    };
    (0, $ieaan.useLayoutEffect)(()=>{
        targetRef.current = (0, $911842e5a561b5ca$export$446ddc3de119a35c)(cloneRef);
    }, [
        target
    ]);
    (0, $ieaan.useLayoutEffect)(()=>{
        if (targetRef.current) {
            setIsMounted(true);
            if (!isControlled) addEvents(targetRef.current);
            handleSemanticElement();
        }
        return ()=>{
            clearTimers();
            removeEvents(targetRef.current);
        };
    }, []);
    const handleSemanticElement = ()=>{
        try {
            const targetElement = document.querySelector(`*[aria-describedby*="${internalId}"]`);
            if (targetElement) {
                const role = targetElement.getAttribute('role');
                if (/div|p|span/i.test(targetElement === null || targetElement === void 0 ? void 0 : targetElement.tagName) && (!role || role === 'text')) setIsNotSemanticElement(true);
            }
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
    };
    const addEvents = (element)=>{
        try {
            element.addEventListener('focus', onFocus);
            element.addEventListener('blur', onMouseLeave);
            element.addEventListener('mouseenter', onMouseEnter);
            element.addEventListener('mouseleave', onMouseLeave);
            element.addEventListener('touchstart', onMouseEnter);
            element.addEventListener('touchend', onMouseLeave);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
    };
    const removeEvents = (element)=>{
        if (!element) return;
        try {
            element.removeEventListener('focus', onFocus);
            element.removeEventListener('blur', onMouseLeave);
            element.removeEventListener('mouseenter', onMouseEnter);
            element.removeEventListener('mouseleave', onMouseLeave);
            element.removeEventListener('touchstart', onMouseEnter);
            element.removeEventListener('touchend', onMouseLeave);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
    };
    const onFocus = (e)=>{
        return onMouseEnter(e);
    };
    const onMouseEnter = (e)=>{
        try {
            const elem = e.currentTarget;
            if (elem.getAttribute('data-autofocus')) return;
            if ((0, $911842e5a561b5ca$export$971e5333ff27c622)(e.type)) elem.style.userSelect = 'none';
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
        const run = ()=>{
            setIsActive(true);
        };
        if (noAnimation || globalThis.IS_TEST) run();
        else {
            clearTimers();
            delayTimeout.current = setTimeout(run, parseFloat(String(showDelay)) || 1);
        }
    };
    const onMouseLeave = (e)=>{
        if (active) return;
        try {
            if ((0, $911842e5a561b5ca$export$971e5333ff27c622)(e.type)) {
                const elem = e.currentTarget;
                elem.style.userSelect = '';
            }
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
        clearTimers();
        const run = ()=>{
            setIsActive(false);
        };
        if (skipPortal) delayTimeout.current = setTimeout(run, parseFloat(String(hideDelay)));
        else run();
    };
    const componentWrapper = (0, $ieaan.useMemo)(()=>{
        if ((0, $ieaan.isValidElement)(target)) {
            const params = isNotSemanticElement ? (0, $911842e5a561b5ca$export$22dfc7bb2d427754)({
                className: props.className
            }) : {};
            return (0, $ieaan.cloneElement)(target, $d24b1e1646088a6a$var$_objectSpread($d24b1e1646088a6a$var$_objectSpread({
                ref: cloneRef
            }, params), {}, {
                'aria-describedby': (0, $11741836d1790446$export$ac6c18d26085326c)(target.props, internalId)
            }));
        } else cloneRef.current = target;
        return null;
    }, [
        target
    ]);
    (0, $911842e5a561b5ca$export$6ea2c3c743cd2a2f)(targetRef.current, internalId);
    (0, $ieaan.useEffect)(()=>{
        if (isControlled) setIsActive(active);
    }, [
        active,
        isControlled
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null, isMounted && (skipPortal ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $102c8da1eed7491d$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, restProps, {
        active: isActive,
        targetElement: targetRef.current
    }), children) : (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $9a3f9dc35e7bb3bc$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, restProps, {
        active: isActive,
        targetElement: targetRef.current,
        keepInDOM: true
    }), children)), componentWrapper);
}
var $d24b1e1646088a6a$export$2e2bcd8739ae039 = $d24b1e1646088a6a$var$TooltipWithEvents;





var $ieaan = parcelRequire("ieaan");

function $a2bcbd0e7ed11515$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a2bcbd0e7ed11515$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a2bcbd0e7ed11515$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a2bcbd0e7ed11515$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a2bcbd0e7ed11515$export$447d8a54a9350211(Base) {
    const Component = Base;
    const Derived = (props)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Component, $a2bcbd0e7ed11515$export$14a2491fda7f8fd4(props));
    };
    Object.defineProperty(Derived, 'name', {
        value: Base.name
    });
    for(const name in Base)Object.defineProperty(Derived, name, {
        value: Base[name]
    });
    return Derived;
}
function $a2bcbd0e7ed11515$export$89c08368efb58626(Base) {
    const Component = Base;
    class Derived extends Base {
        componentDidMount() {}
        render() {
            if (this.props !== this._prevProps) {
                this._prevProps = this.props;
                this._elem = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Component, $a2bcbd0e7ed11515$export$14a2491fda7f8fd4(this.props));
            }
            return this._elem;
        }
    }
    Object.defineProperty(Derived, 'name', {
        value: Base.name
    });
    Object.defineProperty(Derived, 'displayName', {
        value: Base.displayName || Base.name
    });
    return Derived;
}
function $a2bcbd0e7ed11515$export$14a2491fda7f8fd4(props) {
    let { overrideExistingValue: overrideExistingValue = true } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const isFrozen = Object.isFrozen(props);
    const newProps = isFrozen ? $a2bcbd0e7ed11515$var$_objectSpread({}, props) : props;
    for(const key in props)if (key.includes('_') && /^[a-z]+/.test(key) && !/[A-Z]/.test(key)) {
        const newKey = (0, $11741836d1790446$export$86f54f62aa7a7514)(key);
        if (overrideExistingValue || newProps[newKey] === undefined) newProps[(0, $11741836d1790446$export$86f54f62aa7a7514)(key)] = props[key];
        delete newProps[key];
    }
    return isFrozen ? Object.freeze(newProps) : newProps;
}


"use client";
const $afdc5ea86ffcb5b6$var$_excluded = [
    "targetElement",
    "targetSelector",
    "className",
    "id",
    "tooltip",
    "size",
    "fixedPosition",
    "skipPortal",
    "noAnimation",
    "showDelay",
    "hideDelay",
    "active",
    "position",
    "arrow",
    "align"
];
function $afdc5ea86ffcb5b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afdc5ea86ffcb5b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afdc5ea86ffcb5b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afdc5ea86ffcb5b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afdc5ea86ffcb5b6$var$Tooltip(localProps) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useContext((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const inherited = (0, $911842e5a561b5ca$export$2414da066cdcef)(localProps);
    const props = (0, $a2bcbd0e7ed11515$export$14a2491fda7f8fd4)($afdc5ea86ffcb5b6$var$_objectSpread($afdc5ea86ffcb5b6$var$_objectSpread($afdc5ea86ffcb5b6$var$_objectSpread($afdc5ea86ffcb5b6$var$_objectSpread($afdc5ea86ffcb5b6$var$_objectSpread({}, (0, $911842e5a561b5ca$export$9c21a3269931e1e6)), localProps), inherited), context.getTranslation(localProps)['Tooltip']), context.Tooltip));
    const { targetElement: targetElement, targetSelector: targetSelector, className: className, id: id, tooltip: tooltip, size: size, fixedPosition: fixedPosition, skipPortal: skipPortal, noAnimation: noAnimation, showDelay: showDelay, hideDelay: hideDelay, active: active, position: position, arrow: arrow, align: align } = props, params = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $afdc5ea86ffcb5b6$var$_excluded);
    const target = targetElement || targetSelector;
    const [element, setElement] = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useState();
    const [internalId] = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useState(()=>props.id || (0, $11741836d1790446$export$d0c8ec0fe1b18b70)());
    props.internalId = internalId;
    (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useEffect(()=>{
        const element = (0, $911842e5a561b5ca$export$2562999169740ceb)((0, $911842e5a561b5ca$export$446ddc3de119a35c)(target));
        setElement(element);
    }, [
        target
    ]);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tooltip', (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(props), className, size === 'large' && 'dnb-tooltip--large');
    const attributes = $afdc5ea86ffcb5b6$var$_objectSpread({
        className: classes
    }, params);
    (0, $11741836d1790446$export$4ddc669a9a6a5940)(localProps, attributes);
    if (target && !element) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $d24b1e1646088a6a$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        target: element,
        attributes: attributes
    }, props), props.children);
}
var $afdc5ea86ffcb5b6$export$2e2bcd8739ae039 = $afdc5ea86ffcb5b6$var$Tooltip;




var $ieaan = parcelRequire("ieaan");
var $923170eb2742d277$var$_path;
const $923170eb2742d277$var$launch = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $923170eb2742d277$var$_path || ($923170eb2742d277$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M5.857 2H2v12h12v-3.857M8.429 7.57 14 2m0 0H9.714M14 2v4.286"
    })));
var $923170eb2742d277$export$2e2bcd8739ae039 = $923170eb2742d277$var$launch;


"use client";
var $1f174d88b9f7c15a$var$_IconPrimary;
const $1f174d88b9f7c15a$var$_excluded = [
    "id",
    "element",
    "className",
    "children",
    "tooltip",
    "icon",
    "iconPosition",
    "omitClass",
    "innerRef",
    "targetBlankTitle",
    "noAnimation",
    "noHover",
    "noStyle",
    "noUnderline",
    "noIcon",
    "noLaunchIcon"
];
const $1f174d88b9f7c15a$var$defaultProps = {
    noAnimation: false,
    noStyle: false,
    noHover: false,
    noUnderline: false,
    noIcon: false,
    noLaunchIcon: false
};
function $1f174d88b9f7c15a$export$6c00cc313b6acc4c(localProps) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useContext((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const allProps = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $1f174d88b9f7c15a$var$defaultProps, {
        skeleton: context === null || context === void 0 ? void 0 : context.skeleton
    }, context === null || context === void 0 ? void 0 : context.getTranslation(localProps).Anchor, context === null || context === void 0 ? void 0 : context.Anchor);
    if (typeof allProps.inner_ref !== 'undefined') {
        allProps.innerRef = allProps.inner_ref;
        delete allProps.inner_ref;
    }
    if (!allProps.innerRef) allProps.innerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createRef();
    const { id: id, element: element, className: className, children: children, tooltip: tooltip, icon: icon, iconPosition: iconPosition = 'left', omitClass: omitClass, innerRef: innerRef, targetBlankTitle: targetBlankTitle, noAnimation: noAnimation, noHover: noHover, noStyle: noStyle, noUnderline: noUnderline, noIcon: noIcon, noLaunchIcon: noLaunchIcon } = allProps, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(allProps, $1f174d88b9f7c15a$var$_excluded);
    const attributes = rest;
    const internalId = id || 'id' + (0, $11741836d1790446$export$d0c8ec0fe1b18b70)();
    const as = element || 'a';
    const href = allProps.href || allProps.to;
    const _opensNewTab = $1f174d88b9f7c15a$export$d250f3a139860f83(allProps.target, href);
    const showLaunchIcon = _opensNewTab && !noIcon && !noLaunchIcon && !(className !== null && className !== void 0 && className.includes('dnb-anchor--no-icon')) && !(className !== null && className !== void 0 && className.includes('dnb-anchor--no-launch-icon')) && !omitClass;
    const showTooltip = (tooltip || _opensNewTab) && !allProps.title;
    const iconNode = icon && $1f174d88b9f7c15a$var$getIcon(icon);
    const suffix = iconPosition === 'right' && iconNode || showLaunchIcon && ($1f174d88b9f7c15a$var$_IconPrimary || ($1f174d88b9f7c15a$var$_IconPrimary = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $cad17f9ce60a2b23$export$2e2bcd8739ae039), {
        className: "dnb-anchor__launch-icon",
        icon: (0, $923170eb2742d277$export$2e2bcd8739ae039)
    })));
    const prefix = iconPosition === 'left' && iconNode;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $3d090471d65e4fa1$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        as: as,
        id: id,
        internalClass: as !== 'button',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(className, omitClass !== true && (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-anchor', prefix && 'dnb-anchor--icon-left', suffix && 'dnb-anchor--icon-right', typeof children !== 'string' && 'dnb-anchor--was-node', noAnimation && 'dnb-anchor--no-animation', noHover && 'dnb-anchor--no-hover', noStyle && 'dnb-anchor--no-style', noUnderline && 'dnb-anchor--no-underline', noIcon && !(className !== null && className !== void 0 && className.includes('dnb-anchor--no-icon')) && 'dnb-anchor--no-icon', noLaunchIcon && !(className !== null && className !== void 0 && className.includes('dnb-anchor--no-launch-icon')) && 'dnb-anchor--no-launch-icon'))
    }, attributes, {
        innerRef: innerRef
    }), prefix, children, suffix), showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $afdc5ea86ffcb5b6$export$2e2bcd8739ae039), {
        showDelay: 100,
        id: internalId + '-tooltip',
        targetElement: innerRef,
        tooltip: tooltip
    }, allProps.title || targetBlankTitle));
}
const $1f174d88b9f7c15a$var$Anchor = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).forwardRef((props, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($1f174d88b9f7c15a$export$6c00cc313b6acc4c, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        innerRef: ref
    }, props));
});
$1f174d88b9f7c15a$var$Anchor._supportsSpacingProps = true;
var $1f174d88b9f7c15a$export$2e2bcd8739ae039 = $1f174d88b9f7c15a$var$Anchor;
function $1f174d88b9f7c15a$export$29987426b5efd78e(event) {
    var _element$pathname;
    (0, $deeefef162515a83$export$c106dd0671a0fc2d)('"scrollToHashHandler" is deprecated.');
    const element = event.currentTarget;
    const href = element.getAttribute('href');
    if (typeof document === 'undefined' || !href.includes('#')) return;
    const isSamePath = href.startsWith('#') || window.location.href.includes((_element$pathname = element.pathname) === null || _element$pathname === void 0 ? void 0 : _element$pathname.replace(/\/$/, ''));
    if (isSamePath) return $1f174d88b9f7c15a$export$97d524d4c64bb6e3(href);
}
function $1f174d88b9f7c15a$export$97d524d4c64bb6e3(hash) {
    if (typeof document === 'undefined' || !hash || !hash.includes('#')) return;
    const id = hash.split(/#/g).reverse()[0];
    const anchorElem = document.getElementById(id);
    if (anchorElem instanceof HTMLElement) try {
        const scrollPadding = parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop);
        const top = (0, $deeefef162515a83$export$6fcff0dc60346367)(anchorElem) - scrollPadding || 0;
        window.scroll({
            top: top
        });
        return {
            element: anchorElem
        };
    } catch (error) {
        console.error(error);
    }
}
function $1f174d88b9f7c15a$var$getIcon(icon) {
    return $1f174d88b9f7c15a$export$5fb244b331be8433(icon) || (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $cad17f9ce60a2b23$export$2e2bcd8739ae039), {
        icon: icon
    });
}
function $1f174d88b9f7c15a$export$5fb244b331be8433(icon, className) {
    var _icon$props, _icon$props2, _icon$props2$classNam, _icon$props3;
    return icon !== null && icon !== void 0 && (_icon$props = icon.props) !== null && _icon$props !== void 0 && _icon$props.icon || icon !== null && icon !== void 0 && (_icon$props2 = icon.props) !== null && _icon$props2 !== void 0 && (_icon$props2$classNam = _icon$props2.className) !== null && _icon$props2$classNam !== void 0 && _icon$props2$classNam.includes('dnb-icon') ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).cloneElement(icon, {
        key: 'button-icon-clone',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))((_icon$props3 = icon.props) === null || _icon$props3 === void 0 ? void 0 : _icon$props3.className, className)
    }) : null;
}
const $1f174d88b9f7c15a$export$d250f3a139860f83 = (target, href)=>target === '_blank' && !/^(mailto|tel|sms)/.test(href);







var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");
const $05612a99cdf7c35a$var$_excluded = [
    "className",
    "children",
    "pseudoElementOnly"
];
function $05612a99cdf7c35a$export$2e2bcd8739ae039(_ref) {
    let { className: className = null, children: children = null, pseudoElementOnly: pseudoElementOnly = false } = _ref, props = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $05612a99cdf7c35a$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(pseudoElementOnly ? 'dnb-alignment-helper--pseudo-element-only' : 'dnb-alignment-helper', className),
        "aria-hidden": true
    }, props), children);
}


"use client";
var $62da03d0a8a66ef6$var$_span, $62da03d0a8a66ef6$var$_AlignmentHelper, $62da03d0a8a66ef6$var$_AlignmentHelper2;
const $62da03d0a8a66ef6$var$_excluded = [
    "class",
    "className",
    "variant",
    "size",
    "title",
    "custom_content",
    "tooltip",
    "status",
    "status_state",
    "status_props",
    "status_no_animation",
    "globalStatus",
    "id",
    "disabled",
    "text",
    "icon",
    "icon_position",
    "icon_size",
    "wrap",
    "bounding",
    "stretch",
    "skeleton",
    "element",
    "inner_ref",
    "innerRef"
];
function $62da03d0a8a66ef6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62da03d0a8a66ef6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62da03d0a8a66ef6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62da03d0a8a66ef6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $62da03d0a8a66ef6$export$5d8ef7ff85438b60 = {
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).oneOf([
        'primary',
        'secondary',
        'tertiary',
        'signal',
        'unstyled'
    ])
};
class $62da03d0a8a66ef6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).PureComponent {
    static getContent(props) {
        return (0, $5cdea43e47e2bcbb$export$51751cece1adcf33)(props);
    }
    componentDidMount() {
        if (this.props.innerRef) typeof this.props.innerRef === 'function' ? this.props.innerRef(this._ref.current) : this.props.innerRef.current = this._ref.current;
        if (this.props.inner_ref) typeof this.props.innerRef === 'function' ? this.props.inner_ref(this._ref.current) : this.props.inner_ref.current = this._ref.current;
    }
    render() {
        var _this$context, _this$context2, _this$context3, _this$context4, _this$context4$theme;
        const props = (0, $be16b996e1dc94eb$export$87ea024adc3494ce)(this.props, $62da03d0a8a66ef6$export$2e2bcd8739ae039.defaultProps, {
            skeleton: (_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.skeleton
        }, (0, $c81beeaa1b3509d1$export$8efbf5589742246)((_this$context2 = this.context) === null || _this$context2 === void 0 ? void 0 : _this$context2.FormRow), (0, $c81beeaa1b3509d1$export$8efbf5589742246)((_this$context3 = this.context) === null || _this$context3 === void 0 ? void 0 : _this$context3.formElement), this.context.Button);
        const { class: classProp, className: className, variant: variant, size: size, title: title, custom_content: custom_content, tooltip: tooltip, status: status, status_state: status_state, status_props: status_props, status_no_animation: status_no_animation, globalStatus: globalStatus, id: id, disabled: disabled, text: _text, icon: _icon, icon_position: icon_position, icon_size: icon_size, wrap: wrap, bounding: bounding, stretch: stretch, skeleton: skeleton, element: element, inner_ref: inner_ref, innerRef: innerRef } = props, attributes = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $62da03d0a8a66ef6$var$_excluded);
        const showStatus = (0, $11741836d1790446$export$a5f4aa7ad013c9e9)(status);
        let { text: text, icon: icon } = props;
        let usedVariant = variant;
        let usedSize = size;
        let iconSize = icon_size;
        const content = $62da03d0a8a66ef6$export$2e2bcd8739ae039.getContent(this.props);
        if (variant === 'tertiary' && (text || content) && !icon && icon !== false) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`Icon required: A Tertiary Button requires an icon to be WCAG compliant in most cases, because variant tertiary has no underline.
(Override this warning using icon={false}, or consider using one of the other variants)`);
        const isIconOnly = Boolean(!text && !content && icon);
        if (isIconOnly) {
            if (!usedVariant) usedVariant = 'secondary';
            if (!iconSize && (usedSize === 'default' || usedSize === 'large')) iconSize = 'medium';
            if (!usedSize) usedSize = 'medium';
        } else if (content) {
            if (!usedVariant) usedVariant = 'primary';
            if (!usedSize) usedSize = 'default';
        }
        if (!iconSize && variant === 'tertiary' && icon_position === 'top') iconSize = 'medium';
        const Element = element ? element : props.href || props.to ? (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) : 'button';
        if (Element === (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039)) {
            attributes.omitClass = true;
            if ((0, $1f174d88b9f7c15a$export$d250f3a139860f83)(props.target, props.href) && !icon) icon = (0, $923170eb2742d277$export$2e2bcd8739ae039);
        }
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(`dnb-button dnb-button--${usedVariant || 'primary'}`, (text || content || custom_content) && 'dnb-button--has-text', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)(variant === 'tertiary' ? 'font' : 'shape', skeleton, this.context), (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(props), classProp, className, (props.href || props.to) && '', icon && `dnb-button--icon-position-${icon_position} dnb-button--has-icon` + (iconSize ? ` dnb-button--icon-size-${iconSize}` : ""), usedSize && usedSize !== 'default' && `dnb-button--size-${usedSize}`, ((_this$context4 = this.context) === null || _this$context4 === void 0 ? void 0 : (_this$context4$theme = _this$context4.theme) === null || _this$context4$theme === void 0 ? void 0 : _this$context4$theme.darkBackground) && `dnb-button--on-dark-background`, (0, $11741836d1790446$export$7afc298d8ffd816)(stretch) && 'dnb-button--stretch', wrap && 'dnb-button--wrap', status && `dnb-button__status--${status_state}`, Element === (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) && 'dnb-anchor--no-style');
        const params = $62da03d0a8a66ef6$var$_objectSpread({
            className: classes,
            title: title,
            id: this._id,
            disabled: (0, $11741836d1790446$export$7afc298d8ffd816)(disabled)
        }, attributes);
        if (props.on_click || props.onClick) params.onClick = this.getOnClickHandler(props);
        if (Element === (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) && params.disabled) {
            const originalOnClick = params.onClick;
            params.onClick = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (typeof originalOnClick === 'function') originalOnClick(e);
            };
            params.tabIndex = -1;
            params['aria-disabled'] = true;
            delete params.disabled;
            if (params.href) delete params.href;
        }
        if (Element !== (0, $1f174d88b9f7c15a$export$2e2bcd8739ae039) && !params.type) params.type = params.type === '' ? undefined : 'button';
        if (isIconOnly) params['aria-label'] = params['aria-label'] || title;
        (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(params, skeleton, this.context);
        (0, $11741836d1790446$export$4ddc669a9a6a5940)(this.props, params);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Element, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
            ref: this._ref
        }, params), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($62da03d0a8a66ef6$var$Content, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, this.props, {
            icon: icon,
            icon_size: iconSize,
            content: text || content,
            custom_content: custom_content,
            isIconOnly: isIconOnly,
            skeleton: (0, $11741836d1790446$export$7afc298d8ffd816)(skeleton)
        }))), this.state.afterContent, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $2fad1ad7e24667d0$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
            show: showStatus,
            id: this._id + '-form-status',
            globalStatus: globalStatus,
            label: text,
            text: status,
            state: status_state,
            text_id: this._id + '-status',
            no_animation: status_no_animation,
            skeleton: skeleton
        }, status_props)), tooltip && this._ref && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $afdc5ea86ffcb5b6$export$2e2bcd8739ae039), {
            id: this._id + '-tooltip',
            targetElement: this._ref,
            tooltip: tooltip
        }));
    }
    constructor(props){
        super(props);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "getOnClickHandler", (src)=>(event)=>{
                const afterContent = (0, $11741836d1790446$export$89a1e257278b2134)(src, 'on_click', {
                    event: event
                });
                if (afterContent && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(afterContent)) this.setState({
                    afterContent: afterContent
                });
            });
        this._id = props.id || (props.status || props.tooltip) && (0, $11741836d1790446$export$d0c8ec0fe1b18b70)();
        this._ref = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createRef();
        this.state = {
            afterContent: null
        };
    }
}
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($62da03d0a8a66ef6$export$2e2bcd8739ae039, "contextType", (0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
$62da03d0a8a66ef6$export$2e2bcd8739ae039.defaultProps = {
    type: null,
    text: null,
    variant: null,
    size: null,
    title: null,
    icon: null,
    icon_position: 'right',
    icon_size: null,
    href: null,
    target: null,
    rel: null,
    to: null,
    id: null,
    custom_content: null,
    wrap: null,
    bounding: null,
    stretch: null,
    skeleton: null,
    disabled: null,
    tooltip: null,
    status: null,
    status_state: 'error',
    status_props: null,
    status_no_animation: null,
    globalStatus: null,
    inner_ref: null,
    className: null,
    class: null,
    innerRef: null,
    children: null,
    element: null,
    on_click: null,
    onClick: null
};
function $62da03d0a8a66ef6$var$Content(_ref) {
    let { title: title = null, content: content = null, custom_content: custom_content = null, icon: icon = null, icon_size: icon_size = 'default', bounding: bounding = null, skeleton: skeleton = null, isIconOnly: isIconOnly = null } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null, (0, $11741836d1790446$export$7afc298d8ffd816)(bounding) && ($62da03d0a8a66ef6$var$_span || ($62da03d0a8a66ef6$var$_span = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", {
        key: "button-bounding",
        className: "dnb-button__bounding"
    }))), custom_content && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, {
        key: "button-custom-content"
    }, custom_content), content && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null, $62da03d0a8a66ef6$var$_AlignmentHelper || ($62da03d0a8a66ef6$var$_AlignmentHelper = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $05612a99cdf7c35a$export$2e2bcd8739ae039), {
        key: "button-alignment",
        className: "dnb-button__alignment",
        pseudoElementOnly: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", {
        key: "button-text",
        className: "dnb-button__text dnb-skeleton--show-font"
    }, content)), !content && icon && ($62da03d0a8a66ef6$var$_AlignmentHelper2 || ($62da03d0a8a66ef6$var$_AlignmentHelper2 = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $05612a99cdf7c35a$export$2e2bcd8739ae039), {
        key: "button-alignment",
        className: "dnb-button__alignment",
        pseudoElementOnly: true
    }))), icon && ((0, $1f174d88b9f7c15a$export$5fb244b331be8433)(icon, 'dnb-button__icon') || (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $cad17f9ce60a2b23$export$2e2bcd8739ae039), {
        key: "button-icon",
        className: "dnb-button__icon",
        icon: icon,
        size: icon_size,
        "aria-hidden": isIconOnly && !title ? null : true,
        skeleton: skeleton
    })));
}
$62da03d0a8a66ef6$export$2e2bcd8739ae039._formElement = true;
$62da03d0a8a66ef6$export$2e2bcd8739ae039._supportsSpacingProps = true;






var $ieaan = parcelRequire("ieaan");


var $ljfqi = parcelRequire("ljfqi");





var $ieaan = parcelRequire("ieaan");


var $ljfqi = parcelRequire("ljfqi");





var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");




"use client";
const $b72c82c3d5da1e25$var$_excluded = [
    "variant",
    "breakout",
    "outset",
    "roundedCorner",
    "textColor",
    "backgroundColor",
    "dropShadow",
    "outline",
    "outlineWidth",
    "innerRef",
    "className",
    "children",
    "spacing",
    "style_type",
    "inner_ref"
];
function $b72c82c3d5da1e25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b72c82c3d5da1e25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b72c82c3d5da1e25$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b72c82c3d5da1e25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b72c82c3d5da1e25$var$defaultProps = {
    element: 'section'
};
function $b72c82c3d5da1e25$export$2e2bcd8739ae039(localProps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), $b72c82c3d5da1e25$export$a739c8d3f97ecf5f(localProps));
}
function $b72c82c3d5da1e25$export$a739c8d3f97ecf5f(localProps) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useContext((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const props = (0, $be16b996e1dc94eb$export$ad5cdd5a4635d9d0)(localProps, $b72c82c3d5da1e25$var$defaultProps, context.Section);
    const { variant: variant, breakout: breakout = !props.outset, outset: outset, roundedCorner: roundedCorner, textColor: textColor, backgroundColor: backgroundColor, dropShadow: dropShadow, outline: outline, outlineWidth: outlineWidth = typeof props.outline === 'undefined' && typeof props.outlineWidth === 'undefined' ? 'none' : props.outlineWidth, innerRef: innerRef, className: className, children: children, spacing: spacing, style_type: style_type, inner_ref: inner_ref } = props, attributes = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $b72c82c3d5da1e25$var$_excluded);
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useRef();
    const elementRef = innerRef || inner_ref || internalRef;
    return Object.freeze($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread({}, attributes), {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(`dnb-section dnb-section--${variant ? variant : style_type || 'default'}`, className, spacing && `dnb-section--spacing-${(0, $11741836d1790446$export$7afc298d8ffd816)(spacing) ? 'large' : spacing}`),
        style: $b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread($b72c82c3d5da1e25$var$_objectSpread({}, $b72c82c3d5da1e25$var$computeStyle(breakout, 'breakout', (value)=>`var(--breakout--${value ? 'on' : 'off'})`)), $b72c82c3d5da1e25$var$computeStyle(outset, 'outset', (value)=>value ? '1' : '0')), $b72c82c3d5da1e25$var$computeStyle(roundedCorner, 'rounded-corner', (value)=>typeof value === 'boolean' ? value && 'var(--rounded-corner--value)' : value.map((v)=>v ? 'var(--rounded-corner--value)' : '0').join(' '))), $b72c82c3d5da1e25$var$computeStyle(textColor, 'text-color', (value)=>(0, $deeefef162515a83$export$5551a2d24ff40153)(value))), $b72c82c3d5da1e25$var$computeStyle(backgroundColor, 'background-color', (value)=>(0, $deeefef162515a83$export$5551a2d24ff40153)(value))), $b72c82c3d5da1e25$var$computeStyle(dropShadow, 'drop-shadow', (value)=>value && 'var(--shadow-default)')), $b72c82c3d5da1e25$var$computeStyle(outline, 'outline-color', (value)=>typeof value === 'boolean' ? value && 'var(--outline-color--value)' : (0, $deeefef162515a83$export$5551a2d24ff40153)(value))), $b72c82c3d5da1e25$var$computeStyle(outlineWidth, 'outline-width', (value)=>typeof value === 'number' ? `${value}px` : value)), attributes === null || attributes === void 0 ? void 0 : attributes.style),
        innerRef: elementRef,
        children: children
    }));
}
function $b72c82c3d5da1e25$var$computeStyle(property, name, valueCallback) {
    let media = property;
    if (media !== null && (Array.isArray(media) || typeof media !== 'object')) media = {
        small: property,
        medium: property,
        large: property
    };
    const result = {};
    for(const size in media){
        var _media;
        if (typeof ((_media = media) === null || _media === void 0 ? void 0 : _media[size]) !== 'undefined') {
            var _media2;
            const value = valueCallback((_media2 = media) === null || _media2 === void 0 ? void 0 : _media2[size]);
            if (typeof value === 'string') result[`--${name}--${size}`] = value;
        }
    }
    return result;
}
$b72c82c3d5da1e25$export$2e2bcd8739ae039._name = 'Section';
$b72c82c3d5da1e25$export$2e2bcd8739ae039._supportsSpacingProps = true;



function $7f59fd5f0d1ece11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7f59fd5f0d1ece11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7f59fd5f0d1ece11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7f59fd5f0d1ece11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $7f59fd5f0d1ece11$var$EventEmitter {
    static createInstance(id) {
        return new $7f59fd5f0d1ece11$var$EventEmitter(id);
    }
    listen(fn) {
        if (!this.listeners.includes(fn)) this.listeners.push(fn);
        return this;
    }
    unlisten(fn) {
        for(let i = 0, l = this.listeners.length; i < l; i++)if (!fn || fn && fn === this.listeners[i]) this.listeners[i] = null;
    }
    remove() {
        this.unlisten();
        $7f59fd5f0d1ece11$var$scope.__EEE__[this.id].count = $7f59fd5f0d1ece11$var$scope.__EEE__[this.id].count - 1;
        if ($7f59fd5f0d1ece11$var$scope.__EEE__[this.id].count <= 0) delete $7f59fd5f0d1ece11$var$scope[this.id];
    }
    constructor(id){
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "update", (data)=>{
            this.set(data);
            $7f59fd5f0d1ece11$var$scope.__EEE__[this.id].instances.forEach((instance)=>{
                instance.listeners.forEach((fn)=>{
                    if (typeof fn === 'function') fn(instance.get());
                });
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "set", (data)=>{
            $7f59fd5f0d1ece11$var$scope.__EEE__[this.id].data = $7f59fd5f0d1ece11$var$_objectSpread($7f59fd5f0d1ece11$var$_objectSpread({}, $7f59fd5f0d1ece11$var$scope.__EEE__[this.id].data), data);
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "get", ()=>{
            return $7f59fd5f0d1ece11$var$scope.__EEE__[this.id].data;
        });
        $7f59fd5f0d1ece11$var$scope.__EEE__ = $7f59fd5f0d1ece11$var$scope.__EEE__ || {};
        if (!$7f59fd5f0d1ece11$var$scope.__EEE__[id]) $7f59fd5f0d1ece11$var$scope.__EEE__[id] = {
            instances: [],
            count: 0,
            data: {}
        };
        $7f59fd5f0d1ece11$var$scope.__EEE__[id].count = $7f59fd5f0d1ece11$var$scope.__EEE__[id].count + 1;
        $7f59fd5f0d1ece11$var$scope.__EEE__[id].instances.push(this);
        this.id = id;
        this.listeners = [];
        return this;
    }
}
const $7f59fd5f0d1ece11$var$scope = typeof window !== 'undefined' ? window : $7f59fd5f0d1ece11$var$EventEmitter;
var $7f59fd5f0d1ece11$export$2e2bcd8739ae039 = $7f59fd5f0d1ece11$var$EventEmitter;



var $26d57369cefb5383$var$_Fragment;
const $26d57369cefb5383$var$_excluded = [
    "id",
    "children",
    "selected_key",
    "content_style",
    "animate",
    "content_spacing"
];
class $26d57369cefb5383$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).PureComponent {
    componentDidMount() {
        if (this.props.id && this._eventEmitter) this._eventEmitter.listen((params)=>{
            if (this._eventEmitter && params.key !== this.state.key) this.setState(params);
        });
    }
    componentWillUnmount() {
        if (this._eventEmitter) {
            this._eventEmitter.remove();
            this._eventEmitter = null;
        }
    }
    render() {
        const _this$props = this.props, { id: id, children: children, selected_key: key, content_style: content_style, animate: animate, content_spacing: content_spacing } = _this$props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_this$props, $26d57369cefb5383$var$_excluded);
        if (!children) return $26d57369cefb5383$var$_Fragment || ($26d57369cefb5383$var$_Fragment = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, null));
        const params = rest;
        if (key) params['aria-labelledby'] = (0, $11741836d1790446$export$b31873477fdbab59)(params, `${id}-tab-${key}`);
        (0, $11741836d1790446$export$4ddc669a9a6a5940)(this.props, params);
        let content = children;
        if (typeof children === 'function') content = children(this.state);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $c329544388f437e5$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
            role: "tabpanel",
            tabIndex: "-1",
            id: `${id}-content`,
            element: content_style ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).forwardRef((props, ref)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $b72c82c3d5da1e25$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
                    spacing: content_style ? false : undefined,
                    style_type: content_style ? content_style : undefined,
                    innerRef: ref
                }, props));
            }) : 'div',
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))("dnb-tabs__content dnb-no-focus", (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(rest), content_spacing && `dnb-section--spacing-${(0, $11741836d1790446$export$7afc298d8ffd816)(content_spacing) ? 'large' : content_spacing}`),
            duration: 600,
            animate: animate === true
        }, params), content);
    }
    constructor(props){
        super(props);
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "state", {
            key: null
        });
        if (props.id) {
            this._eventEmitter = (0, $7f59fd5f0d1ece11$export$2e2bcd8739ae039).createInstance(props.id);
            this.state = this._eventEmitter.get();
        }
    }
}
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($26d57369cefb5383$export$2e2bcd8739ae039, "defaultProps", {
    selected_key: null,
    content_style: null,
    animate: null,
    content_spacing: true,
    children: null
});


const $6f50effd50029855$var$_excluded = [
    "displayName",
    "title",
    "hash",
    "selected",
    "disabled",
    "className"
];
function $6f50effd50029855$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f50effd50029855$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f50effd50029855$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f50effd50029855$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $6f50effd50029855$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).PureComponent {
    render() {
        const _this$props = this.props, { displayName: displayName, title: title, hash: hash, selected: selected, disabled: disabled, className: className } = _this$props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_this$props, $6f50effd50029855$var$_excluded);
        if (this.props.id) return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $26d57369cefb5383$export$2e2bcd8739ae039), rest);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tabs__content__inner', (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(rest), className)
        }, this.props.children);
    }
}
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($6f50effd50029855$export$2e2bcd8739ae039, "defaultProps", {
    displayName: 'CustomContent',
    title: null,
    hash: null,
    selected: null,
    disabled: null,
    children: null,
    className: null
});




"use client";
const $eea10711b390990c$var$_excluded = [
    "title",
    "key",
    "hash"
], $eea10711b390990c$var$_excluded2 = [
    "children"
], $eea10711b390990c$var$_excluded3 = [
    "children",
    "className"
];
function $eea10711b390990c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eea10711b390990c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eea10711b390990c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eea10711b390990c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $eea10711b390990c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).PureComponent {
    static getSelectedKeyOrFallback(selected_key, data) {
        let useKey = selected_key;
        if (!useKey) useKey = data.reduce((acc, _ref)=>{
            let { selected: selected, key: key } = _ref;
            return selected ? key : acc;
        }, null) || data[0] && data[0].key;
        else {
            const keyExists = data.findIndex((_ref2)=>{
                let { key: key } = _ref2;
                return key == selected_key;
            });
            if (keyExists === -1) useKey = data[0] && data[0].key;
        }
        return useKey;
    }
    static getDerivedStateFromProps(props, state) {
        if (state._listenForPropChanges) {
            if (props.data) {
                if (state._data !== props.data) {
                    state._data = props.data;
                    state.data = $eea10711b390990c$export$2e2bcd8739ae039.getData(props);
                }
            } else if (props.children) {
                if (state._data !== props.children) {
                    state._data = props.children;
                    state.data = $eea10711b390990c$export$2e2bcd8739ae039.getData(props);
                }
            }
            if (props.selected_key && state._selected_key !== props.selected_key) state.selected_key = state._selected_key = $eea10711b390990c$export$2e2bcd8739ae039.getSelectedKeyOrFallback(props.selected_key, state.data);
        }
        state._listenForPropChanges = true;
        return state;
    }
    static getData(props) {
        const addReactElement = (list, reactElem, reactElemIndex)=>{
            if (reactElem && reactElem.props && reactElem.props.displayName === 'CustomContent') {
                const dataProps = props.children && Array.isArray(props.children) && props.children[reactElemIndex] || {};
                const componentProps = $eea10711b390990c$var$_objectSpread({}, reactElem.props);
                if (componentProps.title === null) delete componentProps.title;
                const _dataProps$componentP = $eea10711b390990c$var$_objectSpread($eea10711b390990c$var$_objectSpread($eea10711b390990c$var$_objectSpread({}, dataProps), componentProps), {
                    children: null
                }), { title: title, key: _key, hash: hash } = _dataProps$componentP, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_dataProps$componentP, $eea10711b390990c$var$_excluded);
                list.push($eea10711b390990c$var$_objectSpread({
                    title: title,
                    key: (!_key && hash ? hash : _key) || (0, $11741836d1790446$export$c383cdd2a518017a)(title),
                    content: reactElem
                }, rest));
            }
        };
        let res = [];
        const data = !props.data && props.children ? props.children : props.data;
        if (Array.isArray(props.children) && props.children.some((element)=>typeof element === 'function' || (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(element))) res = props.children.reduce((list, reactElem, i)=>{
            addReactElement(list, reactElem, i);
            return list;
        }, []);
        if (!Array.isArray(props.children) && (typeof props.children === 'function' || (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(props.children))) addReactElement(res, props.children);
        if (!(res && res.length > 0)) {
            if (props.data && Array.isArray(data)) res = data;
            else if (typeof data === 'string') res = data[0] === '[' ? JSON.parse(data) : [];
            else if (data && typeof data === 'object') res = Object.entries(data).reduce((acc, _ref3)=>{
                let [key, obj] = _ref3;
                if (obj) acc.push($eea10711b390990c$var$_objectSpread({
                    key: key
                }, obj));
                return acc;
            }, []);
        }
        return res || [];
    }
    componentDidMount() {
        this._isMounted = true;
        if (document.readyState === 'complete') this.init();
        else if (typeof window !== 'undefined') window.addEventListener('load', this.init);
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.resetWhatInput();
        if (this._eventEmitter) {
            this._eventEmitter.remove();
            this._eventEmitter = null;
        }
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResizeHandler);
            window.removeEventListener('load', this.init);
        }
    }
    componentDidUpdate(props) {
        if (this._eventEmitter && (this.props.selected_key !== props.selected_key || this.props.data !== props.data)) {
            this.onResizeHandler();
            if (this._eventEmitter) {
                const selected_key = this.state.selected_key;
                this._eventEmitter.update(this.getEventArgs({
                    selected_key: selected_key
                }));
            }
        }
    }
    hasLastPosition() {
        return this.state.lastPosition > -1;
    }
    getLastPosition() {
        if (typeof window !== 'undefined') try {
            const pos = parseFloat(window.localStorage.getItem(`tabs-pos-${this._id}`));
            window.localStorage.removeItem(`tabs-pos-${this._id}`);
            return isNaN(pos) ? -1 : pos;
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
        return -1;
    }
    hasLastUsedTab() {
        if (typeof window !== 'undefined') try {
            const key = window.localStorage.getItem(`tabs-last-${this._id}`) || null;
            window.localStorage.removeItem(`tabs-last-${this._id}`);
            return key;
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
        return -1;
    }
    saveLastUsedTab() {
        if (typeof window !== 'undefined') try {
            window.localStorage.setItem(`tabs-last-${this._id}`, this.state.selected_key);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
    }
    saveLastPosition() {
        let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._tablistRef.current.scrollLeft;
        if (typeof window !== 'undefined') try {
            window.localStorage.setItem(`tabs-pos-${this._id}`, position);
        } catch (e) {
            (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
        }
    }
    hasScrollbar() {
        return this._tablistRef.current.scrollWidth - 1 > this._tablistRef.current.offsetWidth;
    }
    addScrollBehavior() {
        if (typeof window !== 'undefined') window.addEventListener('resize', this.onResizeHandler);
    }
    setLeftPosition(scrollLeft) {
        try {
            this._tablistRef.current.style.scrollBehavior = 'auto';
            this._tablistRef.current.scrollLeft = scrollLeft;
            this._tablistRef.current.style.scrollBehavior = 'smooth';
        } catch (e) {}
    }
    scrollToTab(_ref10) {
        let { type: type, behavior: behavior = 'smooth' } = _ref10;
        if (typeof window === 'undefined') return;
        if (window.IS_TEST) behavior = 'auto';
        const delay = ()=>{
            try {
                if (this.state.hasScrollbar && this._tablistRef.current) {
                    const first = this._tablistRef.current.querySelector('.dnb-tabs__button__snap:first-of-type');
                    const isFirst = first.classList.contains(type);
                    const last = this._tablistRef.current.querySelector('.dnb-tabs__button__snap:last-of-type');
                    const isLast = last.classList.contains(type);
                    const elem = this._tablistRef.current.querySelector(`.dnb-tabs__button.${type}`);
                    const style = window.getComputedStyle(this._tabsRef.current);
                    const margin = parseFloat(style.marginLeft);
                    let padding = margin < 0 ? parseFloat(style.paddingLeft) : 0;
                    if (!isFirst && !isLast && parseFloat(style.paddingLeft) < 16) {
                        const navButton = this._tabsRef.current.querySelector('.dnb-tabs__scroll-nav-button:first-of-type');
                        const additionalSpace = parseFloat(window.getComputedStyle(navButton).width) * 1.5;
                        padding += additionalSpace;
                    }
                    const leftPadding = (margin < 0 ? Math.abs(margin) : 0) + padding + parseFloat(window.getComputedStyle(first).paddingLeft);
                    const offsetLeft = elem.offsetLeft;
                    const left = elem && !isFirst ? offsetLeft - leftPadding : 0;
                    if (behavior === 'auto') this._tablistRef.current.style.scrollBehavior = 'auto';
                    this._tablistRef.current.scrollTo({
                        left: left,
                        behavior: behavior
                    });
                    if (behavior === 'auto') this._tablistRef.current.style.scrollBehavior = '';
                    this.setState({
                        isFirst: isFirst,
                        isLast: isLast
                    });
                }
            } catch (e) {
                (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
            }
        };
        window.requestAnimationFrame(delay);
    }
    getStepKey(useKey, stateKey) {
        const currentData = this.state.data.filter((_ref11)=>{
            let { disabled: disabled } = _ref11;
            return !disabled;
        });
        const currentIndex = currentData.reduce((acc, _ref12, i)=>{
            let { key: key } = _ref12;
            return key == stateKey ? i : acc;
        }, -1);
        let nextIndex = currentIndex + useKey;
        if (nextIndex < 0) nextIndex = currentData.length - 1;
        if (nextIndex >= currentData.length) nextIndex = 0;
        return currentData.reduce((acc, _ref13, i)=>{
            let { key: key } = _ref13;
            return i === nextIndex ? key : acc;
        }, null);
    }
    setWhatInput() {
        (0, (/*@__PURE__*/$parcel$interopDefault($90e367f98610ff85$exports))).specificKeys([
            9,
            37,
            39,
            33,
            34,
            35,
            36
        ]);
    }
    resetWhatInput() {
        (0, (/*@__PURE__*/$parcel$interopDefault($90e367f98610ff85$exports))).specificKeys([
            9
        ]);
    }
    warnAboutMissingContainer() {
        (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`Could not find the required <Tabs.Content id="${this._id}-content" ... /> that provides role="tabpanel"`);
    }
    getEventArgs(args) {
        const { selected_key: selected_key, focus_key: focus_key } = this.state;
        const key = typeof args.selected_key !== 'undefined' ? args.selected_key : selected_key;
        return $eea10711b390990c$var$_objectSpread({
            key: key,
            selected_key: selected_key,
            focus_key: focus_key,
            title: this.getCurrentTitle(key)
        }, args);
    }
    isFocus(tabKey) {
        return this.state.focus_key == tabKey;
    }
    isSelected(tabKey) {
        return this.state.selected_key == tabKey;
    }
    renderCachedContent() {
        const { selected_key: selected_key, data: data } = this.state;
        const { prevent_rerender: prevent_rerender, prerender: prerender } = this.props;
        if ((0, $11741836d1790446$export$7afc298d8ffd816)(prerender)) this._cache = Object.entries(data).reduce((acc, _ref14)=>{
            let [idx, cur] = _ref14;
            acc[cur.key] = $eea10711b390990c$var$_objectSpread($eea10711b390990c$var$_objectSpread({}, cur), {}, {
                content: this.getContent(cur.key)
            });
            return acc;
        }, {});
        else if ((0, $11741836d1790446$export$7afc298d8ffd816)(prevent_rerender)) this._cache = $eea10711b390990c$var$_objectSpread($eea10711b390990c$var$_objectSpread({}, this._cache || {}), {}, {
            [selected_key]: {
                content: this.getContent(selected_key)
            }
        });
        const cachedContent = Object.entries(this._cache).map((_ref15)=>{
            let [key, { content: content }] = _ref15;
            const hide = key !== String(selected_key);
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", {
                key: key,
                "aria-hidden": hide ? true : undefined,
                className: 'dnb-tabs__cached' + (hide ? " dnb-tabs__cached--hidden" : "")
            }, content);
        });
        return cachedContent;
    }
    renderContent() {
        const { prevent_rerender: prevent_rerender, prerender: prerender } = this.props;
        if ((0, $11741836d1790446$export$7afc298d8ffd816)(prevent_rerender) || (0, $11741836d1790446$export$7afc298d8ffd816)(prerender)) return this.renderCachedContent();
        return this.getContent(this.state.selected_key);
    }
    render() {
        var _this$context;
        const props = this._props = (0, $be16b996e1dc94eb$export$87ea024adc3494ce)(this.props, $eea10711b390990c$export$2e2bcd8739ae039.defaultProps, {
            skeleton: (_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.skeleton
        });
        const { render: customRenderer } = props;
        const TabItems = this.TabsHandler;
        TabItems.displayName = 'Tabs';
        const TabsList = this.TabsListHandler;
        TabsList.displayName = 'TabsList';
        const Wrapper = this.TabsWrapperHandler;
        Wrapper.displayName = 'TabsWrapper';
        const Content = this.TabContentHandler;
        Content.displayName = 'TabContent';
        if (typeof customRenderer === 'function') return customRenderer({
            Wrapper: Wrapper,
            Content: Content,
            TabsList: TabsList,
            Tabs: TabItems
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Wrapper, null, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(TabsList, null, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(TabItems, null)), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Content, null));
    }
    constructor(_props){
        var _this;
        super(_props);
        _this = this;
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "init", ()=>{
            if (this._isMounted) {
                this.addScrollBehavior();
                const hasScrollbar = this.hasScrollbar();
                const hasLastPosition = this.hasLastPosition();
                this.setScrollbarState({
                    hasScrollbar: hasScrollbar
                });
                if (hasLastPosition) this.setLeftPosition(this.state.lastPosition);
                if (hasScrollbar) this.scrollToTab({
                    type: 'selected',
                    behavior: hasLastPosition ? 'smooth' : 'auto'
                });
                if (this.hasLastUsedTab() !== null) this.setState(null, this.setFocusOnTabButton);
            }
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "setScrollbarState", function() {
            let { hasScrollbar: hasScrollbar = _this.hasScrollbar() } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (hasScrollbar !== _this.state.hasScrollbar) _this.setState({
                hasScrollbar: hasScrollbar
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onResizeHandler", ()=>{
            const hasScrollbar = this.hasScrollbar();
            this.setScrollbarState({
                hasScrollbar: hasScrollbar
            });
            if (hasScrollbar) this.scrollToTab({
                type: 'selected'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onTablistKeyDownHandler", (e)=>{
            switch((0, $9c7aa0fd8d0ea04f$export$2e2bcd8739ae039)(e)){
                case 'up':
                case 'page up':
                case 'left':
                    e.preventDefault();
                    this.focusPrevTab(e);
                    break;
                case 'down':
                case 'page down':
                case 'right':
                    e.preventDefault();
                    this.focusNextTab(e);
                    break;
                case 'home':
                    e.preventDefault();
                    this.focusFirstTab(e);
                    break;
                case 'end':
                    e.preventDefault();
                    this.focusLastTab(e);
                    break;
            }
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "focusFirstTab", (e)=>{
            const key = this.state.data[0].key;
            this.focusTab(key, e, 'step');
            this.scrollToTab({
                type: 'focus'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "focusLastTab", (e)=>{
            const key = this.state.data[this.state.data.length - 1].key;
            this.focusTab(key, e, 'step');
            this.scrollToTab({
                type: 'focus'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "focusPrevTab", (e)=>{
            this.focusTab(-1, e, 'step');
            this.scrollToTab({
                type: 'focus'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "focusNextTab", (e)=>{
            this.focusTab(1, e, 'step');
            this.scrollToTab({
                type: 'focus'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "openPrevTab", (e)=>{
            this.openTab(-1, e, 'step');
            this.scrollToTab({
                type: 'selected'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "openNextTab", (e)=>{
            this.openTab(1, e, 'step');
            this.scrollToTab({
                type: 'selected'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "handleVerticalScroll", ()=>{
            if ((0, $11741836d1790446$export$7afc298d8ffd816)(this.props.scroll) && this._tablistRef.current && typeof this._tablistRef.current.scrollIntoView === 'function') this._tablistRef.current.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onMouseDown", (event)=>{
            event.preventDefault();
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onKeyDownHandler", (event)=>{
            switch((0, $9c7aa0fd8d0ea04f$export$2e2bcd8739ae039)(event)){
                case 'enter':
                    try {
                        const elem = document.getElementById(`${this._id}-content`);
                        elem.focus({
                            preventScroll: true
                        });
                    } catch (e) {
                        this.warnAboutMissingContainer();
                    }
                    break;
            }
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onMouseEnterHandler", (event)=>{
            const selected_key = this.getCurrentKey(event);
            if (selected_key) (0, $11741836d1790446$export$89a1e257278b2134)(this, 'on_mouse_enter', this.getEventArgs({
                event: event,
                selected_key: selected_key
            }));
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "onClickHandler", (event)=>{
            const selected_key = this.getCurrentKey(event);
            if (selected_key) {
                const ret = (0, $11741836d1790446$export$89a1e257278b2134)(this, 'on_click', this.getEventArgs({
                    event: event,
                    selected_key: selected_key
                }));
                if (ret !== false) {
                    this.openTab(selected_key, event);
                    this.scrollToTab({
                        type: 'selected'
                    });
                }
            }
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "getCurrentKey", (event)=>{
            let selected_key;
            try {
                selected_key = function(elem) {
                    return (0, $1cd90c749d09b3aa$export$9cde4a31f3f732e7)('dnb-tabs__button', elem) || {
                        dataset: {}
                    };
                }(event.target).dataset.tabKey;
            } catch (e) {
                (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs Error:', e);
            }
            return selected_key;
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "getCurrentTitle", function() {
            let selected_key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selected_key;
            const current = _this.state.data.filter((_ref4)=>{
                let { key: key } = _ref4;
                return key == selected_key;
            })[0];
            return current && current.title || null;
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "focusTab", function(focus_key) {
            let event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (mode === 'step' && parseFloat(focus_key)) focus_key = _this.getStepKey(focus_key, _this.state.focus_key);
            _this.setState({
                focus_key: focus_key,
                _listenForPropChanges: false
            }, _this.setFocusOnTabButton);
            (0, $11741836d1790446$export$89a1e257278b2134)(_this, 'on_focus', _this.getEventArgs({
                event: event,
                focus_key: focus_key
            }));
            _this.setWhatInput();
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "setFocusOnTabButton", ()=>{
            try {
                const elem = this._tablistRef.current.querySelector('.dnb-tabs__button.focus');
                elem.focus({
                    preventScroll: true
                });
                document.getElementById(`${this._id}-content`);
            } catch (e) {
                (0, $deeefef162515a83$export$c106dd0671a0fc2d)(e);
            }
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "openTab", function(selected_key) {
            let event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            _this.saveLastPosition();
            _this.saveLastUsedTab();
            _this.resetWhatInput();
            if (mode === 'step' && parseFloat(selected_key)) selected_key = _this.getStepKey(selected_key, _this.state.selected_key);
            if (typeof selected_key !== 'undefined') _this.setState({
                selected_key: selected_key,
                focus_key: selected_key,
                _listenForPropChanges: false
            }, _this.handleVerticalScroll);
            (0, $11741836d1790446$export$89a1e257278b2134)(_this, 'on_change', _this.getEventArgs({
                event: event,
                selected_key: selected_key
            }));
            if (_this.props.onOpenTabNavigationFn && typeof window !== 'undefined') try {
                _this.props.onOpenTabNavigationFn(selected_key);
            } catch (e) {
                (0, $deeefef162515a83$export$c106dd0671a0fc2d)('Tabs Error:', e);
            }
            if (_this._eventEmitter) _this._eventEmitter.update(_this.getEventArgs({
                event: event,
                selected_key: selected_key
            }));
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "getContent", (selected_key)=>{
            const { children: children, content: _content } = this.props;
            const contentToRender = children || _content;
            let content = null;
            if (contentToRender) {
                if (typeof contentToRender === 'object' && contentToRender[selected_key]) content = contentToRender[selected_key];
                else if (typeof contentToRender === 'function') content = contentToRender.apply(this, [
                    selected_key
                ]);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(contentToRender)) content = contentToRender;
            }
            if (!content) {
                let items = [];
                if (Array.isArray(this.state.data)) items = this.state.data;
                else if (Array.isArray(contentToRender)) items = contentToRender;
                if (items) content = items.filter((_ref5)=>{
                    let { key: key } = _ref5;
                    return key && selected_key && key == selected_key;
                }).reduce((acc, _ref6)=>{
                    let { content: content } = _ref6;
                    return content || acc;
                }, null);
            }
            if (typeof content === 'function') {
                const Component = content;
                content = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(Component, null);
            }
            return content;
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "TabsWrapperHandler", (_ref7)=>{
            let { children: children } = _ref7, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref7, $eea10711b390990c$var$_excluded2);
            const { className: className, class: _className } = this.props;
            const _filterProps = (0, $de502bdad3b5fb4d$export$d697c39a2985a4c)(this.props, $eea10711b390990c$export$2e2bcd8739ae039.defaultProps), attributes = Object.assign({}, ((0, $c00257230a3091f0$export$2e2bcd8739ae039)(_filterProps), _filterProps));
            const params = $eea10711b390990c$var$_objectSpread($eea10711b390990c$var$_objectSpread({}, attributes), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tabs', (0, $9a6e1a0e3c9a63a2$export$4b11373d92b857f4)(this.props), className, _className)
            });
            (0, $11741836d1790446$export$4ddc669a9a6a5940)(this.props, params);
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, params, rest), children);
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "TabsListHandler", (_ref8)=>{
            let { children: children, className: className } = _ref8, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref8, $eea10711b390990c$var$_excluded3);
            const { align: align, tabs_style: tabs_style, tabs_spacing: tabs_spacing, no_border: no_border, nav_button_edge: nav_button_edge, breakout: breakout } = this.props;
            const { hasScrollbar: hasScrollbar } = this.state;
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tabs__tabs', className, align && `dnb-tabs__tabs--${align}`, tabs_style && `dnb-section dnb-section--${tabs_style}`, tabs_spacing && `dnb-section--spacing-${(0, $11741836d1790446$export$7afc298d8ffd816)(tabs_spacing) ? 'large' : tabs_spacing}`, hasScrollbar && 'dnb-tabs--has-scrollbar', nav_button_edge && 'dnb-tabs--at-edge', no_border && 'dnb-tabs__tabs--no-border', breakout && 'dnb-tabs__tabs--breakout'),
                ref: this._tabsRef
            }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($eea10711b390990c$var$ScrollNavButton, {
                onMouseDown: this.openPrevTab,
                icon: "chevron_left",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(hasScrollbar && (typeof this.state.isFirst !== 'undefined' || this.hasLastPosition()) && 'dnb-tabs__scroll-nav-button--visible', this.state.isFirst && 'dnb-tabs__scroll-nav-button--hide')
            }), children, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($eea10711b390990c$var$ScrollNavButton, {
                onMouseDown: this.openNextTab,
                icon: "chevron_right",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(hasScrollbar && (typeof this.state.isLast !== 'undefined' || this.hasLastPosition()) && 'dnb-tabs__scroll-nav-button--visible', this.state.isLast && 'dnb-tabs__scroll-nav-button--hide')
            }));
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "TabContentHandler", ()=>{
            const { selected_key: selected_key } = this.state;
            const content = this.renderContent();
            if (!this._eventEmitter && !content) (0, $deeefef162515a83$export$c106dd0671a0fc2d)(`No content was given to the Tabs component!
Tip: Check out other solutions like <Tabs.Content id="unique">Your content, outside of the Tabs component</Tabs.Content>
`);
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $26d57369cefb5383$export$2e2bcd8739ae039), {
                id: this._id,
                selected_key: selected_key,
                content_style: this.props.content_style,
                content_spacing: this.props.content_spacing,
                animate: this.props.prerender
            }, content);
        });
        (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(this, "TabsHandler", (props)=>{
            const { label: label, skeleton: skeleton, tab_element: tab_element } = $eea10711b390990c$var$_objectSpread($eea10711b390990c$var$_objectSpread({}, this._props), props);
            const { selected_key: selected_key } = this.state;
            const TabElement = tab_element || 'button';
            const tabs = this.state.data.map((_ref9)=>{
                let { title: title, key: key, disabled: disabled = false, to: to, href: href } = _ref9;
                const itemParams = {
                    to: to,
                    href: href
                };
                const isFocus = this.isFocus(key);
                const isSelected = this.isSelected(key);
                if (isSelected) itemParams['aria-controls'] = `${this._id}-content`;
                if ((0, $11741836d1790446$export$7afc298d8ffd816)(disabled)) {
                    itemParams.disabled = true;
                    itemParams['aria-disabled'] = true;
                }
                if (TabElement === 'button') itemParams.type = 'button';
                (0, $cf2e6f3341d791ce$export$8e9b8ca7ba972d4a)(itemParams, skeleton, this.context);
                return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tabs__button__snap', isFocus && 'focus', isSelected && 'selected'),
                    key: `tab-${key}`
                }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement(TabElement, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
                    role: "tab",
                    tabIndex: "-1",
                    id: `${this._id}-tab-${key}`,
                    "aria-selected": isSelected,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tabs__button', isFocus && 'focus', isSelected && 'selected'),
                    onMouseEnter: this.onMouseEnterHandler,
                    onClick: this.onClickHandler,
                    onKeyUp: this.onKeyDownHandler,
                    onMouseDown: this.onMouseDown,
                    "data-tab-key": key
                }, itemParams), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tabs__button__title', (0, $cf2e6f3341d791ce$export$4165d624d0b91f0d)('font', skeleton, this.context))
                }, title), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($eea10711b390990c$export$8ca53608f6ef5f6f, null, title)));
            });
            const params = {};
            if (label) params['aria-label'] = label;
            if (selected_key) params['aria-labelledby'] = (0, $11741836d1790446$export$b31873477fdbab59)(params, `${this._id}-tab-${selected_key}`);
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("div", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
                role: "tablist",
                className: "dnb-tabs__tabs__tablist",
                tabIndex: "0",
                onKeyDown: this.onTablistKeyDownHandler,
                ref: this._tablistRef
            }, params), tabs);
        });
        this._id = _props.id || (0, $11741836d1790446$export$d0c8ec0fe1b18b70)();
        const data = $eea10711b390990c$export$2e2bcd8739ae039.getData(_props);
        const _selected_key = $eea10711b390990c$export$2e2bcd8739ae039.getSelectedKeyOrFallback(_props.selected_key, data);
        const lastPosition = this.getLastPosition();
        this.state = {
            data: data,
            selected_key: _selected_key,
            focus_key: _selected_key,
            atEdge: false,
            lastPosition: lastPosition,
            hasScrollbar: lastPosition > -1,
            _selected_key: _selected_key,
            _data: _props.data || _props.children,
            _listenForPropChanges: true
        };
        this._tabsRef = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createRef();
        this._tablistRef = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createRef();
        if (_props.id) {
            this._eventEmitter = (0, $7f59fd5f0d1ece11$export$2e2bcd8739ae039).createInstance(_props.id);
            this._eventEmitter.set(this.getEventArgs({
                selected_key: _selected_key
            }));
        }
    }
}
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($eea10711b390990c$export$2e2bcd8739ae039, "contextType", (0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($eea10711b390990c$export$2e2bcd8739ae039, "defaultProps", {
    data: null,
    content: null,
    content_style: null,
    content_spacing: true,
    label: null,
    tab_element: 'button',
    selected_key: null,
    align: 'left',
    tabs_style: null,
    tabs_spacing: null,
    no_border: false,
    nav_button_edge: false,
    onOpenTabNavigationFn: null,
    prerender: false,
    prevent_rerender: false,
    scroll: null,
    skeleton: null,
    id: null,
    className: null,
    children: null,
    render: null,
    on_change: null,
    on_mouse_enter: null,
    on_click: null,
    on_focus: null,
    breakout: true
});
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($eea10711b390990c$export$2e2bcd8739ae039, "Content", (0, $6f50effd50029855$export$2e2bcd8739ae039));
(0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)($eea10711b390990c$export$2e2bcd8739ae039, "ContentWrapper", (0, $26d57369cefb5383$export$2e2bcd8739ae039));
const $eea10711b390990c$export$8ca53608f6ef5f6f = (_ref16)=>{
    let { children: children } = _ref16;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("span", {
        "aria-hidden": true,
        hidden: true,
        className: "dnb-dummy"
    }, children);
};
const $eea10711b390990c$var$ScrollNavButton = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        size: "medium",
        variant: "primary",
        tabIndex: "-1",
        bounding: true,
        "aria-hidden": true
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-tabs__scroll-nav-button', props.className)
    }));
};
$eea10711b390990c$export$2e2bcd8739ae039._supportsSpacingProps = true;



parcelRequire("ieaan");


parcelRequire("ieaan");





var $ieaan = parcelRequire("ieaan");


var $ljfqi = parcelRequire("ljfqi");
const $18267a16830f8f91$var$_excluded = [
    "breakout",
    "dashed",
    "fullscreen",
    "light",
    "medium",
    "className"
];
const $18267a16830f8f91$var$Hr = function() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let { breakout: breakout, dashed: dashed, fullscreen: fullscreen, light: light, medium: medium, className: className } = _ref, props = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $18267a16830f8f91$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $3d090471d65e4fa1$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        as: "hr",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(className, (breakout || fullscreen) && 'dnb-hr--breakout', light && 'dnb-hr--light', medium && 'dnb-hr--medium', dashed && 'dnb-hr--dashed')
    }, props));
};
$18267a16830f8f91$var$Hr._supportsSpacingProps = true;
var $18267a16830f8f91$export$2e2bcd8739ae039 = $18267a16830f8f91$var$Hr;


var $a395d78185689abd$export$2e2bcd8739ae039 = (0, $18267a16830f8f91$export$2e2bcd8739ae039);


parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");
var $863e05d76e4207f8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $863e05d76e4207f8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $ac97bd3bcf31462d$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $ac97bd3bcf31462d$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($863e05d76e4207f8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($ac97bd3bcf31462d$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $ac97bd3bcf31462d$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $ac97bd3bcf31462d$var$i = /^\s*$/, $ac97bd3bcf31462d$var$s = Object.create(null);
function $ac97bd3bcf31462d$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($ac97bd3bcf31462d$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $ac97bd3bcf31462d$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $ac97bd3bcf31462d$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($ac97bd3bcf31462d$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $ac97bd3bcf31462d$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $ac97bd3bcf31462d$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $ac97bd3bcf31462d$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $ac97bd3bcf31462d$var$a("", t);
        }, "");
    }
};
var $ac97bd3bcf31462d$export$2e2bcd8739ae039 = $ac97bd3bcf31462d$var$c;


const $788ef5f0a22132b3$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    var _i18n_services_logger, _i18n_services, _i18n_services_logger1, _i18n_services1, _console;
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services = i18n.services) === null || _i18n_services === void 0 ? void 0 : (_i18n_services_logger = _i18n_services.logger) === null || _i18n_services_logger === void 0 ? void 0 : _i18n_services_logger.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($788ef5f0a22132b3$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services1 = i18n.services) === null || _i18n_services1 === void 0 ? void 0 : (_i18n_services_logger1 = _i18n_services1.logger) === null || _i18n_services_logger1 === void 0 ? void 0 : _i18n_services_logger1.warn) i18n.services.logger.warn(...args);
    else if ((_console = console) === null || _console === void 0 ? void 0 : _console.warn) console.warn(...args);
};
const $788ef5f0a22132b3$var$alreadyWarned = {};
const $788ef5f0a22132b3$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($788ef5f0a22132b3$export$844ec244b1367d54(msg) && $788ef5f0a22132b3$var$alreadyWarned[msg]) return;
    if ($788ef5f0a22132b3$export$844ec244b1367d54(msg)) $788ef5f0a22132b3$var$alreadyWarned[msg] = new Date();
    $788ef5f0a22132b3$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $788ef5f0a22132b3$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $788ef5f0a22132b3$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $788ef5f0a22132b3$var$loadedClb(i18n, cb));
};
const $788ef5f0a22132b3$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($788ef5f0a22132b3$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $788ef5f0a22132b3$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $788ef5f0a22132b3$var$loadedClb(i18n, cb));
};
const $788ef5f0a22132b3$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $788ef5f0a22132b3$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $788ef5f0a22132b3$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($788ef5f0a22132b3$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $788ef5f0a22132b3$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $788ef5f0a22132b3$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $80cec8eabd80f098$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $80cec8eabd80f098$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $80cec8eabd80f098$var$unescapeHtmlEntity = (m)=>$80cec8eabd80f098$var$htmlEntities[m];
const $80cec8eabd80f098$export$e8bacd2802a88316 = (text)=>text.replace($80cec8eabd80f098$var$matchHtmlEntity, $80cec8eabd80f098$var$unescapeHtmlEntity);


let $5acb5a01c1fced2e$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $80cec8eabd80f098$export$e8bacd2802a88316
};
const $5acb5a01c1fced2e$export$2e2366488d12e20d = (options = {})=>{
    $5acb5a01c1fced2e$var$defaultOptions = {
        ...$5acb5a01c1fced2e$var$defaultOptions,
        ...options
    };
};
const $5acb5a01c1fced2e$export$212bb2fc580a90a8 = ()=>$5acb5a01c1fced2e$var$defaultOptions;


let $cef3f991bd1debe1$var$i18nInstance;
const $cef3f991bd1debe1$export$a039134f2fc7e0 = (instance)=>{
    $cef3f991bd1debe1$var$i18nInstance = instance;
};
const $cef3f991bd1debe1$export$64af334f494c2f47 = ()=>$cef3f991bd1debe1$var$i18nInstance;


const $c5570c9d85f055d7$var$hasChildren = (node, checkLength)=>{
    var _node_props;
    if (!node) return false;
    var _node_props_children;
    const base = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $c5570c9d85f055d7$var$getChildren = (node)=>{
    var _node_props, _node_props1;
    if (!node) return [];
    var _node_props_children;
    const children = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    return ((_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.i18nIsDynamicList) ? $c5570c9d85f055d7$var$getAsArray(children) : children;
};
const $c5570c9d85f055d7$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $ieaan.isValidElement));
const $c5570c9d85f055d7$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $c5570c9d85f055d7$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $c5570c9d85f055d7$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $c5570c9d85f055d7$var$getAsArray(children);
    var _i18nOptions_transKeepBasicHtmlNodesFor;
    const keepArray = (i18nOptions === null || i18nOptions === void 0 ? void 0 : i18nOptions.transSupportBasicHtmlNodes) ? (_i18nOptions_transKeepBasicHtmlNodesFor = i18nOptions.transKeepBasicHtmlNodesFor) !== null && _i18nOptions_transKeepBasicHtmlNodesFor !== void 0 ? _i18nOptions_transKeepBasicHtmlNodesFor : [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $ieaan.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $788ef5f0a22132b3$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $c5570c9d85f055d7$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $788ef5f0a22132b3$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $788ef5f0a22132b3$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $788ef5f0a22132b3$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $c5570c9d85f055d7$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap !== null && knownComponentsMap !== void 0 ? knownComponentsMap : {};
    const getData = (childs)=>{
        const childrenArray = $c5570c9d85f055d7$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(child)) return;
            if ($c5570c9d85f055d7$var$hasChildren(child)) getData($c5570c9d85f055d7$var$getChildren(child));
            else if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child) && !(0, $ieaan.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $ac97bd3bcf31462d$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        var _child_props;
        const childs = $c5570c9d85f055d7$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $c5570c9d85f055d7$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || ((_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.i18nIsDynamicList) ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $ieaan.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $ieaan.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            var _c_props_ref;
            return (0, $ieaan.createElement)(c.type, {
                ...props,
                key: i,
                ref: (_c_props_ref = c.props.ref) !== null && _c_props_ref !== void 0 ? _c_props_ref : c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $c5570c9d85f055d7$var$getAsArray(reactNode);
        const astNodes = $c5570c9d85f055d7$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            var _node_children_, _node_children;
            const translationContent = ((_node_children = node.children) === null || _node_children === void 0 ? void 0 : (_node_children_ = _node_children[0]) === null || _node_children_ === void 0 ? void 0 : _node_children_.content) && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $c5570c9d85f055d7$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $ieaan.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $c5570c9d85f055d7$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($c5570c9d85f055d7$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $ieaan.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $ieaan.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $ieaan.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $c5570c9d85f055d7$var$getAsArray(children || []));
    return $c5570c9d85f055d7$var$getChildren(result[0]);
};
const $c5570c9d85f055d7$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $ieaan.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $ieaan.createElement)((0, $ieaan.Fragment), null, comp);
    }
    return (0, $ieaan.createElement)(Componentized, {
        key: componentKey
    });
};
const $c5570c9d85f055d7$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$c5570c9d85f055d7$var$fixComponentProps(c, index, translation));
const $c5570c9d85f055d7$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $c5570c9d85f055d7$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $c5570c9d85f055d7$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $c5570c9d85f055d7$var$generateArrayComponents(components, translation);
    if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(components)) return $c5570c9d85f055d7$var$generateObjectComponents(components, translation);
    (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $c5570c9d85f055d7$var$isComponentsMap = (object)=>{
    if (!(0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $c5570c9d85f055d7$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    var _i18n_options, _i18n_options1, _i18n_options_interpolation, _i18n_options2, _i18n_options_interpolation1, _i18n_options3;
    const i18n = i18nFromProps || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $5acb5a01c1fced2e$export$212bb2fc580a90a8)(),
        ...(_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.react
    };
    let namespaces = ns || t.ns || ((_i18n_options1 = i18n.options) === null || _i18n_options1 === void 0 ? void 0 : _i18n_options1.defaultNS);
    namespaces = (0, $788ef5f0a22132b3$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $c5570c9d85f055d7$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if ((_i18n_options2 = i18n.options) === null || _i18n_options2 === void 0 ? void 0 : (_i18n_options_interpolation = _i18n_options2.interpolation) === null || _i18n_options_interpolation === void 0 ? void 0 : _i18n_options_interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !((_i18n_options3 = i18n.options) === null || _i18n_options3 === void 0 ? void 0 : (_i18n_options_interpolation1 = _i18n_options3.interpolation) === null || _i18n_options_interpolation1 === void 0 ? void 0 : _i18n_options_interpolation1.alwaysFormat) || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const generatedComponents = $c5570c9d85f055d7$var$generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($c5570c9d85f055d7$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $c5570c9d85f055d7$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== null && parent !== void 0 ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $ieaan.createElement)(useAsParent, additionalProps, content) : content;
}



var $ieaan = parcelRequire("ieaan");




const $de8f8501ef445db0$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $5acb5a01c1fced2e$export$2e2366488d12e20d)(instance.options.react);
        (0, $cef3f991bd1debe1$export$a039134f2fc7e0)(instance);
    }
};


const $631fe60334437123$export$5603ab5ced17ce64 = (0, $ieaan.createContext)();
class $631fe60334437123$export$ea171b67e3820290 {
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
    constructor(){
        this.usedNamespaces = {};
    }
}
const $631fe60334437123$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        var _ForComponent_getInitialProps;
        var _ref;
        const componentsInitialProps = (_ref = await ((_ForComponent_getInitialProps = ForComponent.getInitialProps) === null || _ForComponent_getInitialProps === void 0 ? void 0 : _ForComponent_getInitialProps.call(ForComponent, ctx))) !== null && _ref !== void 0 ? _ref : {};
        const i18nInitialProps = $631fe60334437123$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $631fe60334437123$export$704200e5d0b9e8f = ()=>{
    var _i18n_reportNamespaces;
    const i18n = (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    var _i18n_reportNamespaces_getUsedNamespaces;
    const namespaces = (_i18n_reportNamespaces_getUsedNamespaces = (_i18n_reportNamespaces = i18n.reportNamespaces) === null || _i18n_reportNamespaces === void 0 ? void 0 : _i18n_reportNamespaces.getUsedNamespaces()) !== null && _i18n_reportNamespaces_getUsedNamespaces !== void 0 ? _i18n_reportNamespaces_getUsedNamespaces : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $338e4881dec88176$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    var _i18n_options;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $ieaan.useContext)((0, $631fe60334437123$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    const t = tFromProps || (i18n === null || i18n === void 0 ? void 0 : i18n.t.bind(i18n));
    return (0, $c5570c9d85f055d7$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || (t === null || t === void 0 ? void 0 : t.ns) || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS),
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $ieaan = parcelRequire("ieaan");


const $0a2dcaaf70b12078$var$usePrevious = (value, ignore)=>{
    const ref = (0, $ieaan.useRef)();
    (0, $ieaan.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $0a2dcaaf70b12078$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $0a2dcaaf70b12078$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $ieaan.useCallback)($0a2dcaaf70b12078$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $0a2dcaaf70b12078$export$9fc83ad70ead8663 = (ns, props = {})=>{
    var _i18n_options_react, _i18n_options, _i18n_reportNamespaces_addUsedNamespaces, _i18n_reportNamespaces;
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $ieaan.useContext)((0, $631fe60334437123$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $631fe60334437123$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $788ef5f0a22132b3$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $788ef5f0a22132b3$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $788ef5f0a22132b3$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if ((_i18n_options_react = i18n.options.react) === null || _i18n_options_react === void 0 ? void 0 : _i18n_options_react.wait) (0, $788ef5f0a22132b3$export$5b28268982f175ba)(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $5acb5a01c1fced2e$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS);
    namespaces = (0, $788ef5f0a22132b3$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    (_i18n_reportNamespaces_addUsedNamespaces = (_i18n_reportNamespaces = i18n.reportNamespaces).addUsedNamespaces) === null || _i18n_reportNamespaces_addUsedNamespaces === void 0 ? void 0 : _i18n_reportNamespaces_addUsedNamespaces.call(_i18n_reportNamespaces, namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $788ef5f0a22132b3$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $0a2dcaaf70b12078$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$0a2dcaaf70b12078$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $ieaan.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $0a2dcaaf70b12078$var$usePrevious(joinedNS);
    const isMounted = (0, $ieaan.useRef)(true);
    (0, $ieaan.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $788ef5f0a22132b3$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $788ef5f0a22132b3$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n === null || i18n === void 0 ? void 0 : i18n.on(bindI18n, boundReset);
        if (bindI18nStore) i18n === null || i18n === void 0 ? void 0 : i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n && bindI18n) bindI18n === null || bindI18n === void 0 ? void 0 : bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $ieaan.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $788ef5f0a22132b3$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $788ef5f0a22132b3$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $ieaan = parcelRequire("ieaan");


const $897a72ae0fd4d410$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $ieaan.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $788ef5f0a22132b3$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $ieaan.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $ieaan.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $2f8b76f51aefa2ea$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $ieaan = parcelRequire("ieaan");

function $b8cab056955ecb0d$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $ieaan.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $ieaan.createElement)((0, $631fe60334437123$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $ieaan = parcelRequire("ieaan");

var $ieaan = parcelRequire("ieaan");

const $05248fcac2fb08ab$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    var _i18n_options;
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $ieaan.useContext)((0, $631fe60334437123$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cef3f991bd1debe1$export$64af334f494c2f47)();
    if ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $bc217581721fce81$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $05248fcac2fb08ab$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $ieaan.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $631fe60334437123$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $788ef5f0a22132b3$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $1523e0e577b08933$export$324d90190a8b822a = ()=>'';
const $1523e0e577b08933$export$2da9be4cfdb689b1 = ()=>'';
const $1523e0e577b08933$export$98e628dec113755e = ()=>'';
const $1523e0e577b08933$export$2e6c959c16ff56b8 = ()=>'';
const $1523e0e577b08933$export$4e35d5c922a95490 = ()=>'';
const $1523e0e577b08933$export$720a3b9db04b7a0f = ()=>'';



/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $37682150499c1c6a$export$dfd9b671c89acc8e = 7;
const $37682150499c1c6a$export$3913210603d8e9ae = 365.2425;
const $37682150499c1c6a$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $37682150499c1c6a$export$4dec998e48f9c246 = -$37682150499c1c6a$export$81caae6e1cc7a622;
const $37682150499c1c6a$export$4fad13613e88edc8 = 604800000;
const $37682150499c1c6a$export$b76b1809a2898f9a = 86400000;
const $37682150499c1c6a$export$91246f0b9bd9beff = 60000;
const $37682150499c1c6a$export$7f72910d6dfd237a = 3600000;
const $37682150499c1c6a$export$397c2d5776aa9055 = 1000;
const $37682150499c1c6a$export$3633035e63cee86a = 525600;
const $37682150499c1c6a$export$ab7da2ccd1075c38 = 43200;
const $37682150499c1c6a$export$2423174df8cd3cd2 = 1440;
const $37682150499c1c6a$export$f2f5ae5a8e2d8f9f = 60;
const $37682150499c1c6a$export$3c58128db900d44e = 3;
const $37682150499c1c6a$export$80d7e435f744f319 = 12;
const $37682150499c1c6a$export$4db7641526e3241f = 4;
const $37682150499c1c6a$export$698aec755e92c695 = 3600;
const $37682150499c1c6a$export$a77c1a7ebebe2a5a = 60;
const $37682150499c1c6a$export$815a9362476d2fe3 = $37682150499c1c6a$export$698aec755e92c695 * 24;
const $37682150499c1c6a$export$34804a017b31e2fe = $37682150499c1c6a$export$815a9362476d2fe3 * 7;
const $37682150499c1c6a$export$7271e9e3478110d1 = $37682150499c1c6a$export$815a9362476d2fe3 * $37682150499c1c6a$export$3913210603d8e9ae;
const $37682150499c1c6a$export$8e6600bbdee7dabb = $37682150499c1c6a$export$7271e9e3478110d1 / 12;
const $37682150499c1c6a$export$be1dccf2de902d31 = $37682150499c1c6a$export$8e6600bbdee7dabb * 3;
const $37682150499c1c6a$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $7c1787257eb00a81$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $37682150499c1c6a$export$2a7b97929c48d47d) in date) return date[0, $37682150499c1c6a$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$7c1787257eb00a81$export$2e2bcd8739ae039 = $7c1787257eb00a81$export$ead8a1812b171991;


function $e05a7d9b16061e55$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $7c1787257eb00a81$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}



function $f9702abd9ae62b8a$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $7c1787257eb00a81$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$f9702abd9ae62b8a$export$2e2bcd8739ae039 = $f9702abd9ae62b8a$export$e67a095c620b86fe;


function $f756ac946a5bd298$export$113002b5eff6e430(date) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}





function $8fed386bda761bf6$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$8fed386bda761bf6$export$2e2bcd8739ae039 = $8fed386bda761bf6$export$63fa379ae8a9ba2;


function $c01225e8282db0ef$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $8fed386bda761bf6$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $8fed386bda761bf6$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $f756ac946a5bd298$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $f756ac946a5bd298$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $37682150499c1c6a$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$c01225e8282db0ef$export$2e2bcd8739ae039 = $c01225e8282db0ef$export$4a02e9c37dab4871;


function $0e3b30b754be7297$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const sign = $0e3b30b754be7297$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $c01225e8282db0ef$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($0e3b30b754be7297$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $0e3b30b754be7297$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$0e3b30b754be7297$export$2e2bcd8739ae039 = $0e3b30b754be7297$export$86415ebf4eb36b8c;






var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");
var $4779e2ed9944bb95$exports = {};

$parcel$export($4779e2ed9944bb95$exports, "Container", function () { return $9c92da99f2492306$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Item", function () { return $2b6d53905ebe52fd$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Stack", function () { return $743f404748c291b2$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Horizontal", function () { return $806dc62f7614bebc$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "Vertical", function () { return $c4b063a9f8ac836f$export$2e2bcd8739ae039; });
$parcel$export($4779e2ed9944bb95$exports, "withChildren", function () { return $54a1423428abe660$export$2e2bcd8739ae039; });



parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");



parcelRequire("3SQhX");

var $ieaan = parcelRequire("ieaan");



parcelRequire("3SQhX");


function $ccaa0a2f61c56410$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccaa0a2f61c56410$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccaa0a2f61c56410$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccaa0a2f61c56410$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $ccaa0a2f61c56410$export$f44bcf56d375ea05 = {
    small: '40em',
    medium: '60em',
    large: '72em',
    'x-large': '80em',
    'xx-large': '90em'
};
function $ccaa0a2f61c56410$export$426729170c6eaa88(property, callback) {
    let { runOnInit: runOnInit = false } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let query = property;
    let when = null;
    let not = null;
    if (property && typeof property === 'object') {
        query = null;
        when = property.when || property;
        not = property.not;
    }
    const mediaQueryList = $ccaa0a2f61c56410$export$e57d90d0ec36fcbc({
        query: query,
        when: when,
        not: not
    });
    if (runOnInit) {
        if (typeof callback === 'function') callback(mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.matches, mediaQueryList);
    }
    return $ccaa0a2f61c56410$export$1946718a333328e0(mediaQueryList, callback);
}
const $ccaa0a2f61c56410$export$26316165d3b380c8 = ()=>typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
function $ccaa0a2f61c56410$export$e57d90d0ec36fcbc() {
    let { query: query, when: when, not: not = null } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let options = arguments.length > 2 ? arguments[2] : undefined;
    const isSupported = $ccaa0a2f61c56410$export$26316165d3b380c8();
    if (options !== null && options !== void 0 && options.disabled || !isSupported) return null;
    if (when) query = $ccaa0a2f61c56410$export$d7b58f10109feb02({
        query: query,
        when: when,
        not: not
    }, breakpoints, options);
    const mediaQueryString = $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(query, breakpoints, options);
    const mediaQueryList = window.matchMedia(mediaQueryString);
    if (options !== null && options !== void 0 && options.log) (0, $deeefef162515a83$export$c106dd0671a0fc2d)('MediaQuery:', mediaQueryString);
    return mediaQueryList;
}
function $ccaa0a2f61c56410$export$1946718a333328e0(mediaQueryList, callback) {
    if (!mediaQueryList) return ()=>null;
    const listener = (event)=>{
        if (typeof callback === 'function') callback(event === null || event === void 0 ? void 0 : event.matches, event);
    };
    if (mediaQueryList !== null && mediaQueryList !== void 0 && mediaQueryList.addEventListener) mediaQueryList.addEventListener('change', listener);
    return ()=>{
        if (mediaQueryList !== null && mediaQueryList !== void 0 && mediaQueryList.removeEventListener) mediaQueryList.removeEventListener('change', listener);
    };
}
function $ccaa0a2f61c56410$export$d7b58f10109feb02() {
    let { query: query = null, when: when = null, not: not = null } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let breakpoints = arguments.length > 1 ? arguments[1] : undefined;
    let options = arguments.length > 2 ? arguments[2] : undefined;
    if (when) {
        if (typeof when === 'string') when = when.split(/[ ,]/g);
        let listOfQueries = [];
        if (Array.isArray(when)) listOfQueries = listOfQueries.concat($ccaa0a2f61c56410$var$combineQueries(when, breakpoints, options));
        else if (typeof when === 'object') {
            const queryItem = $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(when, breakpoints, options);
            if (queryItem) listOfQueries.push(queryItem);
        }
        if (listOfQueries.length > 0) query = [
            listOfQueries.join(' '),
            query || ''
        ].filter(Boolean).join(' and ').replace(/ +/g, ' ').replace(/ ,/g, ',');
    }
    if ((0, $11741836d1790446$export$7afc298d8ffd816)(not)) query = $ccaa0a2f61c56410$var$reverseQuery(String(query));
    return query || 'not';
}
function $ccaa0a2f61c56410$var$reverseQuery(query) {
    if (query.startsWith('not')) return query.replace(/^not +/, '');
    if (!/^(screen|all|print|speech)/.test(query)) query = `all and ${query}`;
    return `not ${query}`;
}
function $ccaa0a2f61c56410$var$combineQueries(queries) {
    let breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let options = arguments.length > 2 ? arguments[2] : undefined;
    return queries.reduce((listOfQueries, when, i, arr)=>{
        if (breakpoints) breakpoints = $ccaa0a2f61c56410$var$mergeBreakpoints(breakpoints);
        const query = $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(when, breakpoints, options);
        if (query) {
            if (query !== 'and' && arr[i - 1] !== 'and') listOfQueries.push(', ');
            listOfQueries.push(query);
        }
        return listOfQueries;
    }, []).filter((query, i)=>{
        return !(i === 0 && query.startsWith(', '));
    });
}
function $ccaa0a2f61c56410$var$mergeBreakpoints(breakpoints) {
    return Object.entries($ccaa0a2f61c56410$var$_objectSpread($ccaa0a2f61c56410$var$_objectSpread({}, $ccaa0a2f61c56410$export$f44bcf56d375ea05), breakpoints)).sort((a, b)=>a[1] > b[1] ? 1 : -1).reduce((acc, _ref)=>{
        let [key, value] = _ref;
        acc[key] = value;
        return acc;
    }, {});
}
function $ccaa0a2f61c56410$export$a4ba2fd6a2f082d(query) {
    let breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let options = arguments.length > 2 ? arguments[2] : undefined;
    if (typeof query === 'string') return query;
    if (Array.isArray(query)) return query.reduce((acc, q, index)=>{
        acc += $ccaa0a2f61c56410$var$objToMediaQuery(q, breakpoints, options);
        if (index < query.length - 1) {
            if (q !== 'and' && query[index + 1] !== 'and') acc += ',';
            acc += ' ';
        }
        return acc;
    }, '');
    return $ccaa0a2f61c56410$var$objToMediaQuery(query, breakpoints, options);
}
function $ccaa0a2f61c56410$var$objToMediaQuery(obj) {
    let breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let options = arguments.length > 2 ? arguments[2] : undefined;
    if (typeof obj === 'string') return obj;
    let hasNot = false;
    let query = Object.keys(obj).reduce((acc, feature)=>{
        let value = obj[feature];
        feature = (0, $11741836d1790446$export$73bda83cddbc7187)(feature);
        if (feature === 'not') {
            hasNot = true;
            return acc;
        }
        if (feature === 'monochrome') feature = `(${feature})`;
        if (feature === 'min' || feature === 'max') feature = `${feature}-width`;
        if (typeof value === 'number' && /[height|width]$/.test(feature)) value = value + 'em';
        if (value === true) acc.push(feature);
        else if (value === false) acc.push('not ' + feature);
        else {
            value = $ccaa0a2f61c56410$var$getValueByFeature(value, breakpoints);
            if (typeof value !== 'undefined') acc.push(`(${feature}: ${value})`);
        }
        return acc;
    }, []);
    if (Array.isArray(query)) query = query.length > 0 ? query.join(' and ') : query.join('');
    if (hasNot) query = $ccaa0a2f61c56410$var$reverseQuery(query);
    if (options !== null && options !== void 0 && options.correctRange && /\(min-width: [0-9]+em\)/.test(query)) {
        const size = parseFloat(query.match(/\(min-width: ([0-9]+)em\)/)[1]) || 0;
        if (size > 0) {
            const correctedSize = (size * 16 + 0.1) / 16;
            query = query.replace(/(min-width: [0-9]+em)/, `min-width: ${correctedSize}em`);
        }
    }
    return query;
}
function $ccaa0a2f61c56410$var$getValueByFeature(value) {
    let types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    types = types || $ccaa0a2f61c56410$export$f44bcf56d375ea05;
    if (Object.prototype.hasOwnProperty.call(types, value)) value = types[value];
    return value;
}



"use client";
function $5c47cf00b4b6f77e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c47cf00b4b6f77e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c47cf00b4b6f77e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c47cf00b4b6f77e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5c47cf00b4b6f77e$var$makeLayoutEffect = ()=>{
    return typeof window === 'undefined' ? (0, $ieaan.useEffect) : window['__SSR_TEST__'] ? ()=>null : (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useLayoutEffect;
};
const $5c47cf00b4b6f77e$export$fad5e1e85bc5d785 = {
    small: {
        min: 0,
        max: 'small'
    },
    medium: {
        min: 'small',
        max: 'medium'
    },
    large: {
        min: 'medium'
    }
};
function $5c47cf00b4b6f77e$export$2e2bcd8739ae039() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { initialValue: initialValue = null, disabled: disabled, correctRange: correctRange = true, breakpoints: breakpoints, queries: queries = $5c47cf00b4b6f77e$export$fad5e1e85bc5d785, log: log } = props;
    const context = (0, $ieaan.useContext)((0, $e220d71a88fa3fa1$export$2e2bcd8739ae039));
    const refs = (0, $ieaan.useRef)({});
    const defaultsRef = (0, $ieaan.useRef)({});
    const resultRef = (0, $ieaan.useRef)({});
    const isMountedRef = (0, $ieaan.useRef)(false);
    const isDisabledRef = (0, $ieaan.useRef)(disabled);
    const removeListeners = (0, $ieaan.useCallback)(()=>{
        Object.entries(refs.current).forEach((_ref)=>{
            var _item$event;
            let [key, item] = _ref;
            item === null || item === void 0 || (_item$event = item.event) === null || _item$event === void 0 || _item$event.call(item);
            delete refs.current[key];
        });
    }, []);
    const runQuery = (0, $ieaan.useCallback)((_ref2)=>{
        let { when: when, name: name, key: key } = _ref2;
        if (!(0, $ccaa0a2f61c56410$export$26316165d3b380c8)()) return;
        const mediaQueryList = (0, $ccaa0a2f61c56410$export$e57d90d0ec36fcbc)({
            when: when
        }, breakpoints || context.breakpoints, {
            disabled: disabled,
            correctRange: correctRange,
            log: log
        });
        const event = (0, $ccaa0a2f61c56410$export$1946718a333328e0)(mediaQueryList, (match)=>{
            if (!isDisabledRef.current && match) {
                const state = $5c47cf00b4b6f77e$var$_objectSpread($5c47cf00b4b6f77e$var$_objectSpread({}, defaultsRef.current), {}, {
                    key: key,
                    isSSR: resultRef.current.isSSR
                });
                state[name] = match;
                updateRerender(state);
            }
        });
        return {
            event: event,
            mediaQueryList: mediaQueryList
        };
    }, [
        breakpoints,
        context.breakpoints,
        correctRange,
        disabled,
        log
    ]);
    const makeResult = (0, $ieaan.useCallback)(()=>{
        return Object.entries(queries).reduce((acc, _ref3)=>{
            let [k, when] = _ref3;
            const key = k;
            const name = `is${(0, $11741836d1790446$export$6fb43ff9addf7357)(key)}`;
            if (disabled) {
                acc[name] = false;
                return acc;
            }
            defaultsRef.current[name] = false;
            const item = runQuery({
                when: when,
                name: name,
                key: key
            });
            let hasMatch = undefined;
            if (typeof (initialValue === null || initialValue === void 0 ? void 0 : initialValue[name]) !== 'undefined' && !isMountedRef.current) hasMatch = initialValue[name];
            else {
                var _item$mediaQueryList;
                hasMatch = (item === null || item === void 0 ? void 0 : (_item$mediaQueryList = item.mediaQueryList) === null || _item$mediaQueryList === void 0 ? void 0 : _item$mediaQueryList.matches) || false;
            }
            acc[name] = hasMatch;
            if (hasMatch) acc.key = key;
            refs.current[key] = item;
            return acc;
        }, {
            isSSR: !(0, $ccaa0a2f61c56410$export$26316165d3b380c8)(),
            key: null
        });
    }, [
        disabled,
        initialValue,
        queries,
        runQuery
    ]);
    const [result, updateRerender] = (0, $ieaan.useState)(makeResult);
    resultRef.current = result;
    const useLayoutEffect = (0, $ieaan.useMemo)($5c47cf00b4b6f77e$var$makeLayoutEffect, []);
    useLayoutEffect(()=>{
        if (!isMountedRef.current) {
            isMountedRef.current = true;
            const result = makeResult();
            const hasChanged = Object.keys(result).some((key)=>resultRef.current[key] !== result[key]);
            if (hasChanged) updateRerender(result);
        }
        return removeListeners;
    }, [
        makeResult,
        removeListeners
    ]);
    useLayoutEffect(()=>{
        if (isDisabledRef.current && !disabled) updateRerender(makeResult());
        isDisabledRef.current = disabled;
    }, [
        disabled,
        makeResult
    ]);
    return result;
}




var $ieaan = parcelRequire("ieaan");


function $dd5c8d159e0e7768$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd5c8d159e0e7768$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd5c8d159e0e7768$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd5c8d159e0e7768$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $dd5c8d159e0e7768$export$f6ab8fdac90442ec = (0, $9a6e1a0e3c9a63a2$export$e275e554c9b8899e);
function $dd5c8d159e0e7768$export$ab5c332da23a9003(props) {
    const obj = {};
    for(const key in props)if ((0, $9a6e1a0e3c9a63a2$export$3eec253e4a999ac)(key) && typeof props[key] !== 'undefined') obj[key] = props[key];
    return obj;
}
function $dd5c8d159e0e7768$export$26933d4133c059f8(type, element) {
    var _element$props$type, _element$props, _element$props2;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(element)) return;
    return (_element$props$type = (_element$props = element.props) === null || _element$props === void 0 ? void 0 : _element$props[type]) !== null && _element$props$type !== void 0 ? _element$props$type : typeof ((_element$props2 = element.props) === null || _element$props2 === void 0 ? void 0 : _element$props2.space) === 'object' ? element.props.space[type] : undefined;
}
function $dd5c8d159e0e7768$export$5c501ecf46bfbf15(element) {
    var _element$type;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(element) && (element === null || element === void 0 ? void 0 : (_element$type = element.type) === null || _element$type === void 0 ? void 0 : _element$type['_isHeadingElement']) === true;
}
function $dd5c8d159e0e7768$export$4a972b2a98229b7c(element) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(element)) {
        var _element$type2, _element$props3;
        if ((element === null || element === void 0 ? void 0 : element.type) === (0, $ieaan.Fragment)) return 'children';
        const check = element === null || element === void 0 ? void 0 : (_element$type2 = element.type) === null || _element$type2 === void 0 ? void 0 : _element$type2['_supportsSpacingProps'];
        if (typeof check !== 'undefined') return check;
        const keys = [
            'space',
            'top',
            'right',
            'bottom',
            'left'
        ];
        const props = (_element$props3 = element === null || element === void 0 ? void 0 : element.props) !== null && _element$props3 !== void 0 ? _element$props3 : {};
        if (keys.some((key)=>key in props)) return true;
    }
    return undefined;
}
function $dd5c8d159e0e7768$export$531a6af995d5df92(element, spaceProps) {
    const variant = $dd5c8d159e0e7768$export$4a972b2a98229b7c(element);
    if (variant === false) return element;
    if (variant === 'children') return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Children.toArray(element).map((child)=>{
        var _child$props;
        const children = child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Children.toArray(children).map((element, i)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).cloneElement(child, $dd5c8d159e0e7768$var$_objectSpread({
                key: i
            }, child === null || child === void 0 ? void 0 : child.props), $dd5c8d159e0e7768$var$wrapWithSpace({
                element: element,
                spaceProps: spaceProps
            }));
        });
    });
    return $dd5c8d159e0e7768$var$wrapWithSpace({
        element: element,
        spaceProps: spaceProps,
        variant: variant
    });
}
function $dd5c8d159e0e7768$var$wrapWithSpace(_ref) {
    let { element: element, spaceProps: spaceProps, variant: variant = null } = _ref;
    return (variant !== null && variant !== void 0 ? variant : $dd5c8d159e0e7768$export$4a972b2a98229b7c(element) === true) ? (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).cloneElement(element, spaceProps) : $dd5c8d159e0e7768$export$4a972b2a98229b7c(element) === 'children' ? $dd5c8d159e0e7768$export$531a6af995d5df92(element, spaceProps) : (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), spaceProps, element);
}


"use client";
const $9c92da99f2492306$var$_excluded = [
    "spacing",
    "gap",
    "rowGap"
], $9c92da99f2492306$var$_excluded2 = [
    "className",
    "style",
    "children",
    "element",
    "direction",
    "wrap",
    "sizeCount",
    "rowGap",
    "justify",
    "align",
    "alignSelf",
    "divider",
    "gap",
    "breakpoints",
    "queries"
];
function $9c92da99f2492306$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c92da99f2492306$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c92da99f2492306$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c92da99f2492306$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9c92da99f2492306$var$propNames = [
    'direction',
    'wrap',
    'justify',
    'align',
    'divider',
    'spacing',
    'gap'
];
function $9c92da99f2492306$export$e3d3270fdbbcb8ec(props) {
    let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return $9c92da99f2492306$var$_objectSpread($9c92da99f2492306$var$_objectSpread({}, defaults), Object.fromEntries(Object.entries(props !== null && props !== void 0 ? props : {}).filter((_ref)=>{
        let [key] = _ref;
        return $9c92da99f2492306$var$propNames.includes(key) && !skip.includes(key);
    })));
}
function $9c92da99f2492306$var$handleDeprecatedProps(_ref2) {
    let { spacing: spacing, gap: gap, rowGap: rowGap } = _ref2, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref2, $9c92da99f2492306$var$_excluded);
    return $9c92da99f2492306$var$_objectSpread($9c92da99f2492306$var$_objectSpread({}, rest), {}, {
        rowGap: rowGap === true ? undefined : rowGap,
        gap: spacing !== null && spacing !== void 0 ? spacing : gap
    });
}
function $9c92da99f2492306$var$FlexContainer(props) {
    const _handleDeprecatedProp = $9c92da99f2492306$var$handleDeprecatedProps(props), { className: className, style: style, children: children, element: element = 'div', direction: direction = 'horizontal', wrap: wrap = true, sizeCount: sizeCount = 12, rowGap: rowGap, justify: justify = 'flex-start', align: align = 'flex-start', alignSelf: alignSelf, divider: divider = 'space', gap: gap = 'small', breakpoints: breakpoints, queries: queries } = _handleDeprecatedProp, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_handleDeprecatedProp, $9c92da99f2492306$var$_excluded2);
    const spacing = (0, $ieaan.useMemo)(()=>{
        var _ref3;
        return (_ref3 = direction === 'vertical' ? rowGap : undefined) !== null && _ref3 !== void 0 ? _ref3 : gap;
    }, [
        direction,
        gap,
        rowGap
    ]);
    const childrenArray = $9c92da99f2492306$var$replaceRootFragment($9c92da99f2492306$var$wrapChildren(props, children));
    const hasHeading = childrenArray.some((child, i)=>{
        const previousChild = childrenArray === null || childrenArray === void 0 ? void 0 : childrenArray[i - 1];
        return (0, $dd5c8d159e0e7768$export$5c501ecf46bfbf15)(child) || i > 0 && (0, $dd5c8d159e0e7768$export$5c501ecf46bfbf15)(previousChild);
    });
    const hasSizeProp = !hasHeading && direction === 'horizontal' && childrenArray.some((child)=>{
        var _child$props;
        return (_child$props = child['props']) === null || _child$props === void 0 ? void 0 : _child$props.size;
    });
    const { key: mediaKey } = (0, $5c47cf00b4b6f77e$export$2e2bcd8739ae039)({
        disabled: !hasSizeProp,
        breakpoints: breakpoints,
        queries: queries
    });
    const content = childrenArray.map((child, i)=>{
        var _previousChild$type;
        const isFirst = i === 0;
        const isLast = i >= childrenArray.length - 1;
        const previousChild = childrenArray === null || childrenArray === void 0 ? void 0 : childrenArray[i - 1];
        const isHeading = hasHeading && (0, $dd5c8d159e0e7768$export$5c501ecf46bfbf15)(previousChild);
        const start = direction === 'horizontal' ? 'left' : 'top';
        const end = direction === 'horizontal' ? 'right' : 'bottom';
        const endSpacing = 0;
        let startSpacing = null;
        if (!isHeading && (divider === 'line' && !isFirst || divider === 'line-framed')) {
            var _getSpaceValue, _getSpaceValue2;
            const spaceAboveLine = (_getSpaceValue = (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(end, previousChild)) !== null && _getSpaceValue !== void 0 ? _getSpaceValue : spacing;
            startSpacing = (_getSpaceValue2 = (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(start, child)) !== null && _getSpaceValue2 !== void 0 ? _getSpaceValue2 : spacing;
            return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Fragment, {
                key: `element-${i}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $a395d78185689abd$export$2e2bcd8739ae039), {
                top: !isFirst ? spaceAboveLine : 0,
                space: 0,
                className: "dnb-flex-container__hr"
            }), (0, $dd5c8d159e0e7768$export$531a6af995d5df92)(child, {
                space: {
                    [start]: startSpacing,
                    [end]: endSpacing
                }
            }), divider === 'line-framed' && isLast && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $a395d78185689abd$export$2e2bcd8739ae039), {
                top: spaceAboveLine,
                space: 0,
                className: "dnb-flex-container__hr"
            }));
        }
        if (isFirst && direction !== 'horizontal') startSpacing = 0;
        else {
            var _ref4, _getSpaceValue3;
            startSpacing = (_ref4 = (_getSpaceValue3 = (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(start, child)) !== null && _getSpaceValue3 !== void 0 ? _getSpaceValue3 : (0, $dd5c8d159e0e7768$export$26933d4133c059f8)(end, previousChild)) !== null && _ref4 !== void 0 ? _ref4 : spacing;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(previousChild) && (previousChild === null || previousChild === void 0 ? void 0 : (_previousChild$type = previousChild.type) === null || _previousChild$type === void 0 ? void 0 : _previousChild$type['_supportsSpacingProps']) === false) startSpacing = 0;
        const space = direction === 'horizontal' ? {
            [start]: endSpacing,
            [end]: startSpacing
        } : {
            [start]: startSpacing,
            [end]: endSpacing
        };
        return (0, $dd5c8d159e0e7768$export$531a6af995d5df92)(child, {
            key: (child === null || child === void 0 ? void 0 : child['key']) || `element-${i}`,
            space: space
        });
    });
    const n = 'dnb-flex-container';
    const rowGapClass = (0, $ieaan.useMemo)(()=>{
        if (rowGap !== false && direction === 'horizontal') return `${n}--row-gap-${rowGap !== null && rowGap !== void 0 ? rowGap : 'small'}`;
        return undefined;
    }, [
        direction,
        rowGap
    ]);
    const cn = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-flex-container', rowGapClass, className, direction && `${n}--direction-${direction}`, justify && `${n}--justify-${justify}`, align && `${n}--align-${align}`, alignSelf && `${n}--align-self-${alignSelf}`, spacing && `${n}--spacing-${spacing}`, wrap && `${n}--wrap`, hasSizeProp && `${n}--has-size`, divider && `${n}--divider-${divider}`);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        element: element,
        className: cn,
        "data-media-key": mediaKey,
        style: hasSizeProp ? $9c92da99f2492306$var$_objectSpread({
            '--sizeCount': sizeCount
        }, style) : style
    }, rest), content);
}
function $9c92da99f2492306$var$wrapChildren(props, children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Children.toArray(children).map((child)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).isValidElement(child) && child.type['_supportsSpacingProps'] === 'children') return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).cloneElement(child, child.props, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($9c92da99f2492306$var$FlexContainer, props, child.props.children));
        return child;
    });
}
function $9c92da99f2492306$var$replaceRootFragment(children) {
    const firstChild = children[0];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Children.count(children) === 1 && (firstChild === null || firstChild === void 0 ? void 0 : firstChild.type) === (0, $ieaan.Fragment)) {
        var _firstChild$props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).Children.toArray(firstChild === null || firstChild === void 0 ? void 0 : (_firstChild$props = firstChild.props) === null || _firstChild$props === void 0 ? void 0 : _firstChild$props.children);
    }
    return children;
}
$9c92da99f2492306$var$FlexContainer._supportsSpacingProps = true;
var $9c92da99f2492306$export$2e2bcd8739ae039 = $9c92da99f2492306$var$FlexContainer;





var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");

const $2b6d53905ebe52fd$var$_excluded = [
    "element",
    "className",
    "grow",
    "shrink",
    "alignSelf",
    "size",
    "style",
    "children"
];
function $2b6d53905ebe52fd$var$FlexItem(props) {
    const { element: element = 'div', className: className, grow: grow, shrink: shrink, alignSelf: alignSelf, size: size, style: style, children: children } = props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $2b6d53905ebe52fd$var$_excluded);
    const cn = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-flex-item', grow && 'dnb-flex-item--grow', shrink && 'dnb-flex-item--shrink', alignSelf && `dnb-flex-item--align-self-${alignSelf}`, size && 'dnb-flex-item--responsive');
    const spaceStyles = {};
    if (size) {
        if (isValidSize(size)) spaceStyles['--size--default'] = size;
        else {
            const sizes = size;
            for(const key in sizes)if (isValidSize(size[key])) spaceStyles[`--${key}`] = size[key];
        }
    }
    if (Object.keys(spaceStyles).length) return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), {
        element: element,
        className: cn,
        style: spaceStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-flex-item__spacer', className),
        style: style
    }, rest), children));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        element: element,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(cn, className),
        style: style
    }, rest), children);
    function isValidSize(size) {
        return typeof size === 'number' || size === 'auto';
    }
}
$2b6d53905ebe52fd$var$FlexItem._supportsSpacingProps = true;
var $2b6d53905ebe52fd$export$2e2bcd8739ae039 = $2b6d53905ebe52fd$var$FlexItem;





var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");

const $743f404748c291b2$var$_excluded = [
    "className",
    "direction",
    "alignSelf",
    "align",
    "gap",
    "children"
];
function $743f404748c291b2$var$Stack(props) {
    const { className: className, direction: direction = 'vertical', alignSelf: alignSelf = 'stretch', align: align = 'stretch', gap: gap = props.divider !== 'line' && props.divider !== 'line-framed' ? 'medium' : 'small', children: children } = props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $743f404748c291b2$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $9c92da99f2492306$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        element: "section",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-flex-stack', className),
        direction: direction,
        alignSelf: alignSelf,
        align: align,
        gap: gap
    }, rest), children);
}
$743f404748c291b2$var$Stack._supportsSpacingProps = true;
var $743f404748c291b2$export$2e2bcd8739ae039 = $743f404748c291b2$var$Stack;





var $ieaan = parcelRequire("ieaan");

const $806dc62f7614bebc$var$_excluded = [
    "children"
];
function $806dc62f7614bebc$var$Horizontal(_ref) {
    let { children: children } = _ref, props = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $806dc62f7614bebc$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $9c92da99f2492306$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, props, {
        direction: "horizontal"
    }), children);
}
$806dc62f7614bebc$var$Horizontal._supportsSpacingProps = true;
var $806dc62f7614bebc$export$2e2bcd8739ae039 = $806dc62f7614bebc$var$Horizontal;





var $ieaan = parcelRequire("ieaan");

const $c4b063a9f8ac836f$var$_excluded = [
    "children"
];
function $c4b063a9f8ac836f$var$Vertical(_ref) {
    let { children: children } = _ref, props = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(_ref, $c4b063a9f8ac836f$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $9c92da99f2492306$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({}, props, {
        direction: "vertical"
    }), children);
}
$c4b063a9f8ac836f$var$Vertical._supportsSpacingProps = true;
var $c4b063a9f8ac836f$export$2e2bcd8739ae039 = $c4b063a9f8ac836f$var$Vertical;


function $54a1423428abe660$var$withChildren(Component) {
    Component['_supportsSpacingProps'] = 'children';
    return Component;
}
var $54a1423428abe660$export$2e2bcd8739ae039 = $54a1423428abe660$var$withChildren;







var $ieaan = parcelRequire("ieaan");
const $aaae999405fb60c3$var$CardContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createContext(undefined);
var $aaae999405fb60c3$export$2e2bcd8739ae039 = $aaae999405fb60c3$var$CardContext;



var $9c2bf02738ee5bae$export$2e2bcd8739ae039 = (0, $92bd738e6af0b834$export$2e2bcd8739ae039);




var $ieaan = parcelRequire("ieaan");

function $89089e429f32bd45$export$2e2bcd8739ae039(customId) {
    var _React$useId;
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))) === null || (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))) === void 0 ? void 0 : (_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useId) === null || _React$useId === void 0 ? void 0 : _React$useId.call((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).useMemo(()=>{
        var _ref;
        return (_ref = customId !== null && customId !== void 0 ? customId : id === null || id === void 0 ? void 0 : id.replace(/:/, 'id-').replace(/:/, '')) !== null && _ref !== void 0 ? _ref : (0, $11741836d1790446$export$d0c8ec0fe1b18b70)();
    }, [
        customId,
        id
    ]);
}


"use client";
const $e5d3166d137618a2$var$_excluded = [
    "className",
    "stack",
    "direction",
    "gap",
    "spacing",
    "innerSpace",
    "alignSelf",
    "align",
    "divider",
    "rowGap",
    "responsive",
    "filled",
    "outset",
    "title",
    "children"
];
function $e5d3166d137618a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5d3166d137618a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5d3166d137618a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5d3166d137618a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e5d3166d137618a2$var$Card(props) {
    var _ref;
    const nestedContext = (0, $ieaan.useContext)((0, $aaae999405fb60c3$export$2e2bcd8739ae039));
    const { className: className, stack: stack, direction: direction, gap: gap, spacing: spacing, innerSpace: innerSpace, alignSelf: alignSelf = 'stretch', align: align, divider: divider = 'space', rowGap: rowGap, responsive: responsive = !(nestedContext !== null && nestedContext !== void 0 && nestedContext.isNested), filled: filled, outset: outset, title: title, children: children } = props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $e5d3166d137618a2$var$_excluded);
    const titleId = (0, $89089e429f32bd45$export$2e2bcd8739ae039)();
    const falseWhenSmall = {
        small: false,
        medium: true,
        large: true
    };
    const trueWhenSmall = {
        small: true,
        medium: false,
        large: false
    };
    const basisSpace = {
        top: 'medium',
        right: 'medium',
        bottom: 'large',
        left: 'medium'
    };
    const smallSpace = responsive ? $e5d3166d137618a2$var$_objectSpread($e5d3166d137618a2$var$_objectSpread({}, basisSpace), {}, {
        right: 0,
        left: 0
    }) : basisSpace;
    const params = (0, $b72c82c3d5da1e25$export$a739c8d3f97ecf5f)($e5d3166d137618a2$var$_objectSpread($e5d3166d137618a2$var$_objectSpread({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-card', className, responsive && 'dnb-card--responsive', filled && 'dnb-card--filled', !innerSpace && innerSpace != null && 'dnb-card--no-inner-space'),
        breakout: responsive ? trueWhenSmall : false,
        outset: nestedContext !== null && nestedContext !== void 0 && nestedContext.isNested ? false : outset === true ? falseWhenSmall : outset,
        roundedCorner: responsive ? falseWhenSmall : true,
        outline: 'var(--card-outline-color)',
        outlineWidth: 'var(--card-outline-width)',
        backgroundColor: 'var(--card-background-color)',
        innerSpace: innerSpace !== null && innerSpace !== void 0 ? innerSpace : {
            small: smallSpace,
            medium: basisSpace,
            large: basisSpace
        }
    }, rest), {}, {
        'aria-labelledby': (0, $11741836d1790446$export$b31873477fdbab59)(rest, title && titleId)
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $4779e2ed9944bb95$exports).Item, (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        alignSelf: alignSelf,
        element: "section"
    }, params), (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement($e5d3166d137618a2$var$Card.Provider, {
        disableCardBreakout: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $4779e2ed9944bb95$exports).Container, {
        direction: direction !== null && direction !== void 0 ? direction : 'vertical',
        divider: divider,
        alignSelf: alignSelf,
        align: stack ? 'stretch' : align,
        wrap: !stack,
        gap: (_ref = gap !== null && gap !== void 0 ? gap : spacing) !== null && _ref !== void 0 ? _ref : stack ? 'medium' : false,
        rowGap: rowGap
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $9c2bf02738ee5bae$export$2e2bcd8739ae039), {
        id: titleId,
        className: "dnb-card__title"
    }, title), children)));
}
$e5d3166d137618a2$var$Card._supportsSpacingProps = true;
$e5d3166d137618a2$var$Card.Provider = function CardProvider(_ref2) {
    let { disableCardBreakout: disableCardBreakout, children: children } = _ref2;
    const context = (0, $ieaan.useContext)((0, $aaae999405fb60c3$export$2e2bcd8739ae039)) || {};
    context.isNested = disableCardBreakout !== null && disableCardBreakout !== void 0 ? disableCardBreakout : context === null || context === void 0 ? void 0 : context.isNested;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $aaae999405fb60c3$export$2e2bcd8739ae039).Provider, {
        value: context
    }, children);
};
var $e5d3166d137618a2$export$2e2bcd8739ae039 = $e5d3166d137618a2$var$Card;



parcelRequire("ieaan");



var $ljfqi = parcelRequire("ljfqi");


function $456835a5566ee681$export$ed84005ac9356f7a(dateLeft, dateRight) {
    const diff = +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(dateLeft) - +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(dateRight);
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$456835a5566ee681$export$2e2bcd8739ae039 = $456835a5566ee681$export$ed84005ac9356f7a;


const $cecd163da27f5c1f$export$4795f83b11a5eac1 = {
    none: 'none',
    minor: 'minor',
    major: 'major',
    critical: 'critical'
};



parcelRequire("ieaan");
const $5190776e3cd7bd84$var$CustomDnbDoor = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 27.21 36.46",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M14.37 3.58h11.57a.79.79 0 0 1 .77.77V32.1a.76.76 0 0 1-.23.55.77.77 0 0 1-.54.22H14.37",
                        className: "custom_dnb_door_svg__cls-1"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M.5 32.45a.78.78 0 0 0 .17.48.76.76 0 0 0 .43.27l12.34 2.74a1 1 0 0 0 .34 0 .9.9 0 0 0 .31-.15.8.8 0 0 0 .21-.27.75.75 0 0 0 .07-.33V1.27a.75.75 0 0 0-.07-.33.7.7 0 0 0-.21-.27.9.9 0 0 0-.31-.15.65.65 0 0 0-.34 0L1.1 3.26a.76.76 0 0 0-.43.27A.78.78 0 0 0 .5 4z",
                        className: "custom_dnb_door_svg__cls-1"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M9 20.54a2.31 2.31 0 1 0-2.31-2.31A2.3 2.3 0 0 0 9 20.54",
                        className: "custom_dnb_door_svg__cls-1"
                    })
                ]
            })
        })
    });
var $5190776e3cd7bd84$export$2e2bcd8739ae039 = $5190776e3cd7bd84$var$CustomDnbDoor;



parcelRequire("ieaan");
const $fef5677c0b631fc1$var$CustomDnbMoneyBag = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 27.71 38.96",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        fill: "none",
                        stroke: "#a5e1d2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M19 15.68H8.87c-4.1 3-8.37 8-8.37 12.71 0 6.53 3.38 10.07 13.36 10.07 10.15 0 13.35-3.54 13.35-10.07 0-4.76-4.27-9.71-8.21-12.71M22.23.5 6.91 3A5.81 5.81 0 0 1 9.4 8.09h8.38c0-3.71 4.45-7.59 4.45-7.59"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M12.43 32.1h2.67l-3.2-4.24 3-3.35h-2.65l-2.31 2.82v-5.82H7.8V32.1h2.32V30l.53-.53zm8.02-7.77a2.79 2.79 0 0 0-2.32 1.24v-1.24h-2v7.59h2.32v-4.06a1.73 1.73 0 0 1 2-1.76h.89v-1.94a1.7 1.7 0 0 1-.89.17",
                        className: "custom_dnb_money_bag_svg__cls-2"
                    })
                ]
            })
        })
    });
var $fef5677c0b631fc1$export$2e2bcd8739ae039 = $fef5677c0b631fc1$var$CustomDnbMoneyBag;



parcelRequire("ieaan");
const $09e17901d5d22b1d$var$CustomDnbWallet = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30.29 29.55",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M27.92 13.81V9.26a2.75 2.75 0 0 0-2.65-2.67H24m3.9 7.22H22a1.24 1.24 0 0 0-1.25 1.26V19A1.23 1.23 0 0 0 22 20.25h6.54A1.24 1.24 0 0 0 29.79 19v-3.93a1.24 1.24 0 0 0-1.25-1.26zM24 6.59l-1.54-5.18a1.17 1.17 0 0 0-1.71-.79L7 6.59m17 0H7m20.92 13.82v6a2.75 2.75 0 0 1-2.65 2.67H3.15a2.75 2.75 0 0 1-2.65-2.7V9.26a2.75 2.75 0 0 1 2.65-2.67H7",
                        className: "custom_dnb_wallet_svg__cls-1"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M24 18.37a1.26 1.26 0 1 0-1.24-1.26A1.25 1.25 0 0 0 24 18.37",
                        className: "custom_dnb_wallet_svg__cls-1"
                    })
                ]
            })
        })
    });
var $09e17901d5d22b1d$export$2e2bcd8739ae039 = $09e17901d5d22b1d$var$CustomDnbWallet;



parcelRequire("ieaan");
const $18a341d907f43f4e$var$CustomDnbCalendar = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 39.5 39.5",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M9.8 15a.75.75 0 0 0 0 1.5zm19.9 1.5a.75.75 0 0 0 0-1.5zM5.27 5.92a.75.75 0 0 0 0-1.5zM.75 5.17v-.75a.75.75 0 0 0-.75.75zm0 33.58H0a.76.76 0 0 0 .75.75zm38 0v.75a.76.76 0 0 0 .75-.75zm0-33.58h.75a.75.75 0 0 0-.75-.75zm-4.52-.75a.75.75 0 0 0 0 1.5zm-19.91 0a.75.75 0 0 0 0 1.5zm10.86 1.5a.75.75 0 0 0 0-1.5zM10.55.75a.75.75 0 0 0-1.5 0zm-1.5 8.84a.75.75 0 0 0 1.5 0zM30.45.75a.75.75 0 0 0-1.5 0zM29 9.59a.75.75 0 0 0 1.5 0zM9.8 16.52h19.9V15H9.8zM5.27 4.42H.75v1.5h4.52zM0 5.17v33.58h1.5V5.17zM.75 39.5h38V38h-38zm38.75-.75V5.17H38v33.58zm-.75-34.33h-4.52v1.5h4.52zm-24.43 1.5h10.86v-1.5H14.32zM9.05.75v8.84h1.5V.75zM29 .75v8.84h1.5V.75z",
                className: "custom_dnb_calendar_svg__cls-1",
                "data-name": "Layer 1"
            })
        })
    });
var $18a341d907f43f4e$export$2e2bcd8739ae039 = $18a341d907f43f4e$var$CustomDnbCalendar;



parcelRequire("ieaan");
const $4fdf17dc453c2890$var$CustomDnbStatus = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("style", {
                    children: '.custom_dnb_status_svg__cls-1{fill:none;stroke:#b3b3b3;stroke-linecap:round;stroke-linejoin:round}'
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
                id: "custom_dnb_status_svg__Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                    id: "custom_dnb_status_svg__Layer_1-2",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                            d: "M18 35.5A17.5 17.5 0 1 0 .5 18 17.49 17.49 0 0 0 18 35.5",
                            className: "custom_dnb_status_svg__cls-1"
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                            d: "M3.54 20.28h3.62c3.35 0 3.06-2.84 5.52-14.65a.75.75 0 0 1 .32-.44.76.76 0 0 1 .43-.19.78.78 0 0 1 .48.17.7.7 0 0 1 .26.44l4.66 22.72a.8.8 0 0 0 .26.43.76.76 0 0 0 1 0 .82.82 0 0 0 .27-.43L23.53 15a.7.7 0 0 1 .25-.4.7.7 0 0 1 .43-.18.8.8 0 0 1 .46.11.8.8 0 0 1 .31.37c1.13 2.82 1.58 5.38 4.21 5.38h3.27",
                            className: "custom_dnb_status_svg__cls-1"
                        })
                    ]
                })
            })
        ]
    });
var $4fdf17dc453c2890$export$2e2bcd8739ae039 = $4fdf17dc453c2890$var$CustomDnbStatus;



parcelRequire("ieaan");
const $4b05afba65048d30$var$CustomDnbCreditcard = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 34.54 24.33",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M31.13.5H3.42A2.92 2.92 0 0 0 .5 3.42v17.5a2.91 2.91 0 0 0 2.92 2.91h27.71A2.91 2.91 0 0 0 34 20.92V3.42A2.91 2.91 0 0 0 31.13.5M.5 6.33H34",
                className: "custom_dnb_creditcard_svg__cls-1",
                "data-name": "Layer 1"
            })
        })
    });
var $4b05afba65048d30$export$2e2bcd8739ae039 = $4b05afba65048d30$var$CustomDnbCreditcard;



parcelRequire("ieaan");
const $7f8bda6e472477a7$var$CustomDnbMobileBank = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 32",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        fill: "#b3b3b3",
                        d: "M18 11.5a.5.5 0 0 0 1 0zm1 11a.5.5 0 0 0-1 0zM1.5 1h16V0h-16zm16 30h-16v1h16zM1 30.5v-29H0v29zm17-29v10h1v-10zm0 21v8h1v-8zM1.5 31a.5.5 0 0 1-.5-.5H0A1.5 1.5 0 0 0 1.5 32zm16 1a1.5 1.5 0 0 0 1.5-1.5h-1a.5.5 0 0 1-.5.5zm0-31a.5.5 0 0 1 .5.5h1A1.5 1.5 0 0 0 17.5 0zm-16-1A1.5 1.5 0 0 0 0 1.5h1a.5.5 0 0 1 .5-.5z"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M.5 25.5h18",
                        className: "custom_dnb_mobile_bank_svg__cls-2"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("circle", {
                        cx: 9.5,
                        cy: 28.5,
                        r: 1,
                        fill: "#c4c4c4"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M13.5 19v-2c.5.67 2.2 1.5 5 1.5s4.5-.83 5-1.5v2c-.5.67-2.2 1.5-5 1.5s-4.5-.83-5-1.5",
                        className: "custom_dnb_mobile_bank_svg__cls-4"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M13.5 17v-2c.5.67 2.2 1.5 5 1.5s4.5-.83 5-1.5v2c-.5.67-2.2 1.5-5 1.5s-4.5-.83-5-1.5",
                        className: "custom_dnb_mobile_bank_svg__cls-4"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M13.5 15c.33-.67 1.8-1.5 5-1.5s4.67.83 5 1.5",
                        className: "custom_dnb_mobile_bank_svg__cls-2"
                    })
                ]
            })
        })
    });
var $7f8bda6e472477a7$export$2e2bcd8739ae039 = $7f8bda6e472477a7$var$CustomDnbMobileBank;



parcelRequire("ieaan");
const $d14920b9380a63ce$var$CustomDnbSpare = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
            stroke: "#A5E1D2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M20 6a2 2 0 1 1 4 0m-6 8h7M8.983 12.35c-.342-.747.025-1.634.79-1.903a6.1 6.1 0 0 1 2.017-.353c.977 0 1.905.233 2.715.643C16.573 9.637 19.41 9 22.045 9 29.412 9 35 14.109 35 20.25c0 2.594-1.066 4.86-2.852 6.742a1.4 1.4 0 0 0-.291.459l-1.721 5.66a1.36 1.36 0 0 1-1.272.889H25.66a1.37 1.37 0 0 1-1.338-1.122l-.232-1.755A1.37 1.37 0 0 0 22.753 30h-2.347c-.651 0-1.213.471-1.338 1.123l-.157 1.755A1.37 1.37 0 0 1 17.573 34h-3.091c-.595 0-1.12-.393-1.3-.97l-1.17-4.379a1.37 1.37 0 0 0-.876-.901C9.442 27.192 5 25.031 5 22.48v-2.53c0-1.66 1.268-3.03 2.911-3.245a1.3 1.3 0 0 0 .819-.471l.746-.9a1.41 1.41 0 0 0 .194-1.483z"
        })
    });
var $d14920b9380a63ce$export$2e2bcd8739ae039 = $d14920b9380a63ce$var$CustomDnbSpare;



parcelRequire("ieaan");
const $c7a6533e6cb10a3e$var$CustomDnbOperational = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                fill: "#26b382",
                fillRule: "evenodd",
                d: "M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m4.15-9.27a.5.5 0 0 0-.71-.73L6.13 8.33 3.85 6.06a.5.5 0 0 0-.7 0 .5.5 0 0 0 0 .71L5.77 9.4a.51.51 0 0 0 .71 0z",
                "data-name": "Layer 1"
            })
        })
    });
var $c7a6533e6cb10a3e$export$2e2bcd8739ae039 = $c7a6533e6cb10a3e$var$CustomDnbOperational;



parcelRequire("ieaan");
const $44fa68bc2c98d639$var$CustomDnbMinor = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                fill: "#fdbb31",
                fillRule: "evenodd",
                d: "M14 7a7 7 0 1 1-7-7 7 7 0 0 1 7 7m-7 3a.5.5 0 1 1-.5.5.5.5 0 0 1 .5-.5m.5-6.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z",
                "data-name": "Layer 1"
            })
        })
    });
var $44fa68bc2c98d639$export$2e2bcd8739ae039 = $44fa68bc2c98d639$var$CustomDnbMinor;



parcelRequire("ieaan");
const $dfa1ef17590ab329$var$CustomDnbMajor = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                fill: "#ff5400",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "m7 4 3.14 5.5H3.86z"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m.43-11.25a.49.49 0 0 0-.86 0l-4 7a.5.5 0 0 0 0 .5.48.48 0 0 0 .43.25h8a.48.48 0 0 0 .43-.25.5.5 0 0 0 0-.5z"
                    })
                ]
            })
        })
    });
var $dfa1ef17590ab329$export$2e2bcd8739ae039 = $dfa1ef17590ab329$var$CustomDnbMajor;



parcelRequire("ieaan");
const $51312afaf7bbea49$var$CustomDnbCritical = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                fill: "#ff5400",
                fillRule: "evenodd",
                d: "M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m3.35-3.65a.48.48 0 0 1-.7 0L7 7.71l-2.65 2.64a.49.49 0 0 1-.7-.7L6.29 7 3.65 4.35a.49.49 0 0 1 .7-.7L7 6.29l2.65-2.64a.49.49 0 0 1 .7.7L7.71 7l2.64 2.65a.48.48 0 0 1 0 .7",
                "data-name": "Layer 1"
            })
        })
    });
var $51312afaf7bbea49$export$2e2bcd8739ae039 = $51312afaf7bbea49$var$CustomDnbCritical;



parcelRequire("ieaan");
const $213a35a27acea55a$var$CustomDnbUnderMaintenance = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("g", {
                fill: "#b3b3b3",
                "data-name": "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        d: "M7.9 9.06a3 3 0 0 1-.5.11 2.6 2.6 0 0 1-.4 0 2.7 2.7 0 0 1-.7-.09 3 3 0 0 1-.5-.17 2.6 2.6 0 0 1-.44-.23A3 3 0 0 1 5.2 3.8V6L7 7l1.8-1V3.8a3 3 0 0 1-.44 5.07 3 3 0 0 1-.46.19"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m.4-1.8v-2H7a4 4 0 0 1-.7-.07v2.07a.5.5 0 0 1-1 0V9.82A4 4 0 0 1 4.6 3a1 1 0 0 1 1.05-.1 1 1 0 0 1 .55.9v1.61l.8.45.8-.45V3.8A1 1 0 0 1 9.4 3a4 4 0 0 1-1 6.94v2.26a.5.5 0 0 1-1 0"
                    })
                ]
            })
        })
    });
var $213a35a27acea55a$export$2e2bcd8739ae039 = $213a35a27acea55a$var$CustomDnbUnderMaintenance;




var $ieaan = parcelRequire("ieaan");
var $e41c6e1a3d2d827e$var$_path;
const $e41c6e1a3d2d827e$var$exclamation_triangle = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $e41c6e1a3d2d827e$var$_path || ($e41c6e1a3d2d827e$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M8 9.06V5.88m-.177 6.133h.346m6.612-.257a2.038 2.038 0 0 1-.09 1.998 2.083 2.083 0 0 1-1.761.973H3.07a2.082 2.082 0 0 1-1.761-.973 2.04 2.04 0 0 1-.09-1.998l4.93-8.62c.171-.342.435-.629.762-.83a2.082 2.082 0 0 1 2.94.83l4.93 8.62Zm-6.533.257c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    })));
var $e41c6e1a3d2d827e$export$2e2bcd8739ae039 = $e41c6e1a3d2d827e$var$exclamation_triangle;


var $5a76cdf66a6b8d42$export$2e2bcd8739ae039 = (0, $e41c6e1a3d2d827e$export$2e2bcd8739ae039);



var $3dc9ae77036e7be5$export$2e2bcd8739ae039 = (0, $c6167291c77af966$export$2e2bcd8739ae039);




var $ieaan = parcelRequire("ieaan");
var $aba813b8c0d20ad3$var$_path;
const $aba813b8c0d20ad3$var$stop = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $aba813b8c0d20ad3$var$_path || ($aba813b8c0d20ad3$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeWidth: 1.5,
        d: "M12.95 3.05a7 7 0 0 0-9.9 9.9m9.9-9.9a7 7 0 1 1-9.9 9.9m9.9-9.9-9.9 9.9"
    })));
var $aba813b8c0d20ad3$export$2e2bcd8739ae039 = $aba813b8c0d20ad3$var$stop;


var $dcf2779cdc5e8ab5$export$2e2bcd8739ae039 = (0, $aba813b8c0d20ad3$export$2e2bcd8739ae039);




var $ieaan = parcelRequire("ieaan");
var $57fc06c0fedf3ba9$var$_path, $57fc06c0fedf3ba9$var$_path2;
const $57fc06c0fedf3ba9$var$account_card_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $57fc06c0fedf3ba9$var$_path || ($57fc06c0fedf3ba9$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        fill: "#000",
        d: "m11.622 9.75.449-.601-.2-.149h-.249v.75Zm-5.994 0V9h-.25l-.199.149.449.601Zm-.378-3a.75.75 0 0 0 0 1.5v-1.5ZM12 8.25a.75.75 0 0 0 0-1.5v1.5Zm1.5-7.5.496.562a.75.75 0 0 0-.62-1.302l.124.74Zm-9 1.5-.123-.74a.75.75 0 0 0-.236 1.398L4.5 2.25Zm1.5 3h-.75V6H6v-.75Zm4.875 0V6h.75v-.75h-.75Zm1.715 6.294a.75.75 0 0 0 1.032-1.088l-1.032 1.088ZM6.942 23.938a.75.75 0 0 0 .116-1.495l-.116 1.495ZM11.622 9H5.628v1.5h5.994V9Zm-6.443.149c-1.235.922-2.514 2.143-3.49 3.519C.716 14.035 0 15.619 0 17.25h1.5c0-1.2.536-2.481 1.411-3.714.87-1.224 2.03-2.338 3.165-3.185L5.18 9.15Zm.071-.899H12v-1.5H5.25v1.5ZM13.377.01l-9 1.5.246 1.48 9-1.5-.246-1.48ZM4.5 2.25l-.36.658-.002-.001-.002-.001-.003-.002A1.564 1.564 0 0 1 4.27 3c.103.081.246.21.391.395.284.361.59.951.59 1.855h1.5c0-1.278-.444-2.188-.91-2.782a3.86 3.86 0 0 0-.641-.645 3.062 3.062 0 0 0-.337-.23h-.001l-.001-.001-.36.658ZM6 6h4.875V4.5H6V6Zm5.625-.75c0-.828.519-1.782 1.157-2.61a11.026 11.026 0 0 1 1.211-1.325l.004-.003L13.5.75a171.156 171.156 0 0 0-.498-.56H13a.82.82 0 0 0-.034.031l-.093.086a12.513 12.513 0 0 0-1.28 1.416c-.674.876-1.468 2.172-1.468 3.526h1.5Zm1.997 5.206a17.389 17.389 0 0 0-1.551-1.307l-.897 1.202c.473.354.954.755 1.416 1.193l1.032-1.088ZM0 17.25c0 1.87.419 3.491 1.59 4.684 1.16 1.183 2.934 1.815 5.352 2.004l.116-1.495c-2.249-.176-3.6-.746-4.398-1.56-.787-.802-1.16-1.968-1.16-3.633H0ZM11.25 15h11v-1.5h-11V15Zm11 7.5h-11V24h11v-1.5ZM11 22.25v-2.5H9.5v2.5H11Zm0-2.5v-4.5H9.5v4.5H11Zm11.5-4.5v4.5H24v-4.5h-1.5Zm0 4.5v2.5H24v-2.5h-1.5Zm-12.25.75h13V19h-13v1.5Zm1 2a.25.25 0 0 1-.25-.25H9.5c0 .966.784 1.75 1.75 1.75v-1.5Zm11 1.5A1.75 1.75 0 0 0 24 22.25h-1.5a.25.25 0 0 1-.25.25V24Zm0-9a.25.25 0 0 1 .25.25H24a1.75 1.75 0 0 0-1.75-1.75V15Zm-11-1.5a1.75 1.75 0 0 0-1.75 1.75H11a.25.25 0 0 1 .25-.25v-1.5Z"
    })), $57fc06c0fedf3ba9$var$_path2 || ($57fc06c0fedf3ba9$var$_path2 = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        d: "M5.814 13.7V19H5.5v-5.3h.314Zm1.795 2.349-.548.603-.284.31.257.333.575.74v.327l-.562-.797-.361-.513-.42.466-.159.177.597-.744.905-1.129v.227Z"
    })));
var $57fc06c0fedf3ba9$export$2e2bcd8739ae039 = $57fc06c0fedf3ba9$var$account_card_medium;



var $ieaan = parcelRequire("ieaan");
var $b9b638ebb8114184$var$_path, $b9b638ebb8114184$var$_path2;
const $b9b638ebb8114184$var$account_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $b9b638ebb8114184$var$_path || ($b9b638ebb8114184$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M8.25 7.5H15m-.378 2.25H8.628c-2.371 1.77-4.878 4.67-4.878 7.5 0 3.918 1.945 6 7.875 6s7.875-2.082 7.875-6c0-2.83-2.507-5.73-4.878-7.5Zm1.878-9-9 1.5s1.5.818 1.5 3h4.875c0-2.182 2.625-4.5 2.625-4.5Z"
    })), $b9b638ebb8114184$var$_path2 || ($b9b638ebb8114184$var$_path2 = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        fill: "#000",
        d: "M10.799 19.5h1.575l-1.944-2.511L12.239 15h-1.611l-1.314 1.638V13.2H8v6.3h1.314v-1.287l.324-.36 1.161 1.647Zm4.651-4.59c-.576 0-1.071.306-1.323.774V15h-1.17v4.5h1.314v-2.457c0-.657.387-.999 1.152-.999.189 0 .36.018.495.045v-1.125a1.733 1.733 0 0 0-.468-.054Z"
    })));
var $b9b638ebb8114184$export$2e2bcd8739ae039 = $b9b638ebb8114184$var$account_medium;



var $ieaan = parcelRequire("ieaan");
var $f769a448ff6985fb$var$_path, $f769a448ff6985fb$var$_path2;
const $f769a448ff6985fb$var$cog_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $f769a448ff6985fb$var$_path || ($f769a448ff6985fb$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M10.54 2.434a1.957 1.957 0 0 0 2.908 0l.946-1.038a1.959 1.959 0 0 1 3.41 1.413l-.07 1.4a1.958 1.958 0 0 0 2.05 2.054l1.4-.071a1.959 1.959 0 0 1 1.41 3.41l-1.042.94a1.96 1.96 0 0 0 0 2.909l1.042.94a1.96 1.96 0 0 1-1.413 3.41l-1.4-.071a1.958 1.958 0 0 0-2.056 2.056l.071 1.4a1.959 1.959 0 0 1-3.402 1.41l-.94-1.041a1.96 1.96 0 0 0-2.909 0l-.945 1.04a1.959 1.959 0 0 1-3.406-1.407l.072-1.4a1.958 1.958 0 0 0-2.056-2.056l-1.4.07a1.958 1.958 0 0 1-1.416-3.406l1.041-.94a1.96 1.96 0 0 0 0-2.91l-1.04-.944a1.958 1.958 0 0 1 1.408-3.406l1.4.07a1.958 1.958 0 0 0 2.058-2.06l-.067-1.4A1.959 1.959 0 0 1 9.6 1.396l.94 1.038Z",
        clipRule: "evenodd"
    })), $f769a448ff6985fb$var$_path2 || ($f769a448ff6985fb$var$_path2 = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z",
        clipRule: "evenodd"
    })));
var $f769a448ff6985fb$export$2e2bcd8739ae039 = $f769a448ff6985fb$var$cog_medium;



var $ieaan = parcelRequire("ieaan");
var $99dd7cc4f112b7bd$var$_path;
const $99dd7cc4f112b7bd$var$log_in_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $99dd7cc4f112b7bd$var$_path || ($99dd7cc4f112b7bd$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M6.933 5.4V3.933A1.467 1.467 0 0 1 8.4 2.466h1.4m0 17.6H8.4A1.466 1.466 0 0 1 6.933 18.6v-1.466m9.1-4.767a.367.367 0 1 0-.339-.222.364.364 0 0 0 .34.226m-9.9 1.83 2.933-2.933m0 0H1m8.067 0L6.133 8.334m7.437-7.327 8.8 1.258a.732.732 0 0 1 .63.725v17.104a.733.733 0 0 1-.58.718l-8.8 2.172a.734.734 0 0 1-.887-.718V1.733a.731.731 0 0 1 .837-.726Z"
    })));
var $99dd7cc4f112b7bd$export$2e2bcd8739ae039 = $99dd7cc4f112b7bd$var$log_in_medium;



var $ieaan = parcelRequire("ieaan");
var $3fcb1d502b2a2f33$var$_path;
const $3fcb1d502b2a2f33$var$mobilephone = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $3fcb1d502b2a2f33$var$_path || ($3fcb1d502b2a2f33$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M7.2 3.227H9m-.88 8.77h.023M4.636 1h7c.352 0 .637.285.637.636v12.728a.636.636 0 0 1-.637.636h-7A.636.636 0 0 1 4 14.364V1.636C4 1.285 4.285 1 4.636 1Z"
    })));
var $3fcb1d502b2a2f33$export$2e2bcd8739ae039 = $3fcb1d502b2a2f33$var$mobilephone;



var $ieaan = parcelRequire("ieaan");
var $e1ca6ec3b8207d0f$var$_path;
const $e1ca6ec3b8207d0f$var$savings_account_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $e1ca6ec3b8207d0f$var$_path || ($e1ca6ec3b8207d0f$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M10.5 8.25h5.25m-3.75-6a1.5 1.5 0 1 1 3 0M3.737 7.013a1.05 1.05 0 0 1 .593-1.428 4.511 4.511 0 0 1 3.548.218C9.43 4.978 11.558 4.5 13.534 4.5c5.524 0 9.716 3.832 9.716 8.438 0 1.945-.8 3.644-2.139 5.056a1.04 1.04 0 0 0-.218.344l-1.291 4.245a1.023 1.023 0 0 1-.954.667h-2.402c-.489 0-.91-.353-1.004-.842l-.174-1.316a1.028 1.028 0 0 0-1.004-.842h-1.76c-.488 0-.909.353-1.003.843l-.118 1.315c-.093.49-.514.842-1.003.842H7.862c-.447 0-.841-.295-.976-.728l-.877-3.284c-.1-.32-.342-.572-.657-.675-1.27-.419-4.602-2.04-4.602-3.954v-1.897c0-1.244.951-2.272 2.184-2.433a.974.974 0 0 0 .613-.353l.56-.675c.257-.31.314-.745.146-1.112l-.516-1.126Z"
    })));
var $e1ca6ec3b8207d0f$export$2e2bcd8739ae039 = $e1ca6ec3b8207d0f$var$savings_account_medium;



var $ieaan = parcelRequire("ieaan");
var $16d77439b369692e$var$_path;
const $16d77439b369692e$var$wallet_medium = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), $16d77439b369692e$var$_path || ($16d77439b369692e$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M22 11.5V8a2 2 0 0 0-2-2h-1m3 5.5h-4.5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1H22m0-5h.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H22m0 0V21a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m0 0 10.467-4.55a1 1 0 0 1 1.357.629L19 6M6 6h13m-.179 8.003h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    })));
var $16d77439b369692e$export$2e2bcd8739ae039 = $16d77439b369692e$var$wallet_medium;


function $948a817567efcc0c$export$16b26cd5e98d9100(icon) {
    switch(icon){
        case 'Andre tjenester privat':
        case 'Other services personal':
        case 'Andre tjenester business':
        case 'Other services business':
        case 'Andre tjenester bedrift':
            return 0, $b9b638ebb8114184$export$2e2bcd8739ae039;
        case 'wallet':
        case 'Nettbank':
        case 'Corporate Internet banking':
            return 0, $16d77439b369692e$export$2e2bcd8739ae039;
        case 'credit-card':
        case 'Minibanker, Kort Og Betalingsterminaler':
            return 0, $57fc06c0fedf3ba9$export$2e2bcd8739ae039;
        case 'log-in':
        case 'Innlogging':
        case 'Login':
            return 0, $99dd7cc4f112b7bd$export$2e2bcd8739ae039;
        case 'calendar':
            return 0, $18a341d907f43f4e$export$2e2bcd8739ae039;
        case 'status':
            return 0, $4fdf17dc453c2890$export$2e2bcd8739ae039;
        case 'mobile-bank':
        case 'Mobilbank':
        case 'DNB Bedrift':
        case 'Sbanken Mobilbank':
            return 0, $3fcb1d502b2a2f33$export$2e2bcd8739ae039;
        case 'Spare':
        case 'Savings':
            return 0, $e1ca6ec3b8207d0f$export$2e2bcd8739ae039;
        // case 'DNB Bedrift':  
        // return bank_medium;
        default:
            return null;
    }
}
function $948a817567efcc0c$export$786e5ba88f046a47(status) {
    switch(status){
        case 'operational':
            return 'ok';
        case 'partial_outage':
            return 'partial';
        case 'degraded_performance':
            return 'partial';
        case 'major_outage':
            return 'down';
        case 'under_maintenance':
            return 'partial';
        default:
            break;
    }
}
function $948a817567efcc0c$export$9c3ee57c664156cd(status) {
    console.log("getStatusColor", status);
    switch(status){
        case 'operational':
        case 'none':
            return 'sea-green';
        case 'degraded_performance':
            return 'accent-yellow';
        case 'major':
        case 'major_outage':
        case 'critical':
        case 'minor':
        case 'minor_outage':
        case 'partial_outage':
            return 'accent-red';
        default:
            return 'sea-green';
    }
}
function $948a817567efcc0c$export$c742923ea4ac4c1c(status) {
    switch(status){
        case 'operational':
        case 'none':
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
        case 'minor':
        case 'minor_outage':
        case 'partial_outage':
            return 0, $5a76cdf66a6b8d42$export$2e2bcd8739ae039;
        case 'degraded_performance':
            return 0, $3dc9ae77036e7be5$export$2e2bcd8739ae039;
        case 'major':
        case 'major_outage':
        case 'critical':
            return 0, $dcf2779cdc5e8ab5$export$2e2bcd8739ae039;
        case 'under_maintenance':
            return 0, $f769a448ff6985fb$export$2e2bcd8739ae039;
        default:
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
    }
}
function $948a817567efcc0c$export$b40c13a3e6d581cb(status) {
    switch(status){
        case 'operational':
        case 'none':
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
        case 'minor_outage':
        case 'partial_outage':
        case 'minor':
            return 0, $5a76cdf66a6b8d42$export$2e2bcd8739ae039;
        case 'major_outage':
        case 'critical':
        case 'major':
            return 0, $dcf2779cdc5e8ab5$export$2e2bcd8739ae039;
        case 'degraded_performance':
            return 0, $3dc9ae77036e7be5$export$2e2bcd8739ae039;
        default:
            return 0, $90e0e6911f5d437e$export$2e2bcd8739ae039;
    }
}
function $948a817567efcc0c$export$30430f1e824a18e1(item) {
    let arr = [];
    for (let sub of item.subComponents)for (let incident of sub.incidents)arr.push(incident);
    let allIncidents = [
        ...item.incidents,
        ...arr
    ].sort((a, b)=>{
        return (0, $456835a5566ee681$export$2e2bcd8739ae039)(new Date(a.created_at), new Date(b.created_at));
    });
    return allIncidents;
}
function $948a817567efcc0c$export$7e162e1ca82c6723(groups, incidents) {
    let groupsCopy = [
        ...groups
    ];
    /* Iterate through all incidents, we need to attach them to the correct component */ for (let incident of incidents)for (let component of incident.components){
        let correctGroup;
        correctGroup = groupsCopy.find((e)=>e.id === component.id);
        if (correctGroup) correctGroup.incidents.push(incident);
        else /* If incident is not in one of our groups, check subgroups/components, and push to correct one */ for (let group of groupsCopy){
            let found = group.subComponents.find((el)=>el.id === component.id);
            if (found) {
                if (!group.incidents.some((e)=>e.id === incident.id)) group.incidents.push(incident);
            }
        }
    }
    return groupsCopy;
}
function $948a817567efcc0c$export$1ef61927080de40d(incident) {
    return incident.name.toLowerCase().includes('bankid');
}
function $948a817567efcc0c$export$dea2b423f9e4a3c5(path) {
    return '/' + path.split('/')[1];
}


function $ee14c77e46cdc1df$export$2e2bcd8739ae039({ item: item }) {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    let iconClass = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-status-icon', {
        'dnb-status-icon--operational': item.status === 'operational',
        'dnb-status-icon--minor': item.status === 'minor_outage' || item.status === 'partial_outage',
        'dnb-status-icon--major': item.status === 'major_outage',
        'dnb-status-icon--degraded_performance': item.status === 'degraded_performance',
        'dnb-status-icon--under_maintenance': item.status === 'under_maintenance'
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
        className: "dnb-status-list__item",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: iconClass,
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    size: "16",
                    icon: (0, $948a817567efcc0c$export$c742923ea4ac4c1c)(item.status),
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                children: t(item.name)
            })
        ]
    });
}
$ee14c77e46cdc1df$export$2e2bcd8739ae039.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};



parcelRequire("ieaan");


var $ljfqi = parcelRequire("ljfqi");



function $0bc1282718aeb9f8$export$2e2bcd8739ae039({ name: name, subtitle: subtitle, pageHeader: pageHeader, icon: icon }) {
    let headerClass = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-icon-header', {
        'dnb-icon-header--page-header': pageHeader
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: headerClass,
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-icon-header__icon",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    size: "auto",
                    icon: (0, $948a817567efcc0c$export$16b26cd5e98d9100)(icon),
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("h2", {
                children: [
                    name && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $60739c7e3f826d8d$exports.Fragment), {
                        children: name
                    }),
                    " ",
                    subtitle && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-icon-header__subtitle",
                        children: subtitle
                    })
                ]
            })
        ]
    });
}
$0bc1282718aeb9f8$export$2e2bcd8739ae039.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired,
    subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    pageHeader: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired
};




const $d8373414d63d1b0f$var$Group = ({ item: item })=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const daysSinceIncidentNumber = ()=>{
        if (item.incidents.length === 0) return '00';
        else {
            let sorted = item.incidents.sort((a, b)=>{
                return (0, $456835a5566ee681$export$2e2bcd8739ae039)(new Date(a.started_at), new Date(b.started_at));
            });
            let days = (0, $0e3b30b754be7297$export$2e2bcd8739ae039)(new Date(), new Date(sorted[0].started_at));
            /*if (days < 10) return `0${days}`;*/ return days.toString();
        }
    };
    const daysSinceIncidentText = ()=>{
        if (item.incidents.length === 0) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
            children: [
                t('No incidents in'),
                " ",
                t('over'),
                " 3 ",
                t('months')
            ]
        });
        else return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
            children: [
                daysSinceIncidentNumber(),
                " ",
                t('days since'),
                " ",
                t('last'),
                " ",
                t('incident')
            ]
        });
    };
    /*return (
    <article className='dnb-group'>
      <IconHeader name={t(item.name)} icon={item.name} />
      <div className='dnb-group-content'>
        <div className='dnb-group-content__left'>
          <div className='dnb-incident-counter'>
            <span className='dnb-incident-counter__number'>{daysSinceIncidentNumber()}</span>
            <span className='dnb-incident-counter__text'>{daysSinceIncidentText()}</span>
          </div>
        </div>
        <div className='dnb-group-content__right'>
          <div className='dnb-status-list'>
            <ul>
              {item.subComponents.map((el) => {
                return <GroupListItem item={el} key={el.id} />;
              })}
            </ul>
          </div>
        </div>
      </div>
    </article>
  );
};*/ return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
        className: "dnb-group",
        innerSpace: false,
        align: "stretch",
        outlineWidth: 1.5,
        radius: "1.5rem",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $0bc1282718aeb9f8$export$2e2bcd8739ae039), {
                name: t(item.name),
                icon: item.name
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-incident-counter",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                    className: "dnb-incident-counter__text",
                    children: daysSinceIncidentText()
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $a395d78185689abd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-group-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "dnb-group-content__left",
                        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "dnb-status-list",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
                                children: item.subComponents.map((el)=>{
                                    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee14c77e46cdc1df$export$2e2bcd8739ae039), {
                                        item: el
                                    }, el.id);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "dnb-group-content__right"
                    })
                ]
            })
        ]
    });
};
$d8373414d63d1b0f$var$Group.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};
var $d8373414d63d1b0f$export$2e2bcd8739ae039 = $d8373414d63d1b0f$var$Group;



const $28af0973880b5e9a$var$GroupsWrapper = ({ groups: groups })=>{
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: "dnb-groups-wrapper",
        children: groups.length > 0 && groups.map((item)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $d8373414d63d1b0f$export$2e2bcd8739ae039), {
                item: item
            }, item.id))
    });
};
$28af0973880b5e9a$var$GroupsWrapper.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};
var $28af0973880b5e9a$export$2e2bcd8739ae039 = $28af0973880b5e9a$var$GroupsWrapper;



parcelRequire("ieaan");

var $3b462a98d423171a$exports = {};

$parcel$export($3b462a98d423171a$exports, "Container", function () { return $c5056bdb3fca4cb3$export$2e2bcd8739ae039; });
$parcel$export($3b462a98d423171a$exports, "Item", function () { return $19d7ef6c1640e749$export$2e2bcd8739ae039; });





var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");

const $c5056bdb3fca4cb3$var$_excluded = [
    "columns",
    "rowGap",
    "columnGap",
    "style",
    "className",
    "children",
    "element"
];
function $c5056bdb3fca4cb3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5056bdb3fca4cb3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5056bdb3fca4cb3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5056bdb3fca4cb3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c5056bdb3fca4cb3$var$GridContainer(props) {
    const { columns: columns, rowGap: rowGap, columnGap: columnGap, style: style, className: className, children: children, element: element = 'div' } = props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $c5056bdb3fca4cb3$var$_excluded);
    const styleObj = $c5056bdb3fca4cb3$var$_objectSpread($c5056bdb3fca4cb3$var$_objectSpread({}, $c5056bdb3fca4cb3$var$compute(columns)), style);
    const n = 'dnb-grid-container';
    const unsetClasses = [];
    for(const prop in styleObj)if (styleObj[prop] === 'unset') {
        const disableClass = `${n}__disabled--${prop.replace(/--([a-z]+)-.*/, '$1')}`;
        unsetClasses.push(disableClass);
    }
    const cn = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))(n, className, unsetClasses, columnGap && `${n}--column-gap-${columnGap === true ? 'small' : columnGap}`, rowGap && `${n}--row-gap-${rowGap === true ? 'small' : rowGap}`);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        element: element,
        className: cn,
        style: styleObj
    }, rest), children);
}
$c5056bdb3fca4cb3$var$GridContainer._supportsSpacingProps = true;
var $c5056bdb3fca4cb3$export$2e2bcd8739ae039 = $c5056bdb3fca4cb3$var$GridContainer;
function $c5056bdb3fca4cb3$var$compute(columns) {
    if (!columns) return null;
    const result = {};
    if (typeof columns === 'number') columns = {
        small: columns,
        medium: columns,
        large: columns
    };
    for(const media in columns){
        var _columns;
        const value = (_columns = columns) === null || _columns === void 0 ? void 0 : _columns[media];
        result[`--${media}-columns`] = value || 'unset';
    }
    return result;
}






var $ieaan = parcelRequire("ieaan");

var $ljfqi = parcelRequire("ljfqi");

const $19d7ef6c1640e749$var$_excluded = [
    "element",
    "span",
    "className",
    "style",
    "children"
];
function $19d7ef6c1640e749$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19d7ef6c1640e749$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19d7ef6c1640e749$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c7fdd987e3d59d6d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19d7ef6c1640e749$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $19d7ef6c1640e749$var$media = [
    'small',
    'medium',
    'large'
];
function $19d7ef6c1640e749$var$GridItem(props) {
    const { element: element = 'div', span: span, className: className, style: style, children: children } = props, rest = (0, $3ed251c3e75e9f55$export$2e2bcd8739ae039)(props, $19d7ef6c1640e749$var$_excluded);
    const styleObj = $19d7ef6c1640e749$var$_objectSpread($19d7ef6c1640e749$var$_objectSpread({}, $19d7ef6c1640e749$var$compute(span, 'c')), style);
    const cn = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-grid-item', className);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement((0, $92bd738e6af0b834$export$2e2bcd8739ae039), (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        element: element,
        className: cn,
        style: styleObj
    }, rest), children);
}
$19d7ef6c1640e749$var$GridItem._supportsSpacingProps = true;
var $19d7ef6c1640e749$export$2e2bcd8739ae039 = $19d7ef6c1640e749$var$GridItem;
function $19d7ef6c1640e749$var$compute(span, modifier) {
    if (!span) return null;
    const result = {};
    const collect = (media, values)=>{
        values.forEach((value, i)=>{
            const pos = i === 0 ? 's' : 'e';
            if (i === 1 && value > 0) value += 1;
            if (value === 'end') value = '-1';
            result[makeStyle(media, pos)] = value;
        });
    };
    if (Array.isArray(span)) $19d7ef6c1640e749$var$media.forEach((media)=>{
        collect(media, span);
    });
    else for(const media in span){
        const values = span === null || span === void 0 ? void 0 : span[media];
        if (values === 'full') {
            result[makeStyle(media, 's')] = '1';
            result[makeStyle(media, 'e')] = '-1';
        } else if (Array.isArray(values)) collect(media, values);
    }
    return result;
    function makeStyle(media, pos) {
        return `--${media}-${modifier}-${pos}`;
    }
}






parcelRequire("ieaan");

const $9bb65aaaaefb5cdf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $9bb65aaaaefb5cdf$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $9bb65aaaaefb5cdf$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $47fded15351fa5db$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $65a63d0ee89ffdf6$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $65a63d0ee89ffdf6$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $65a63d0ee89ffdf6$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $65a63d0ee89ffdf6$export$cbf60ecb96cbb82f = {
    date: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $65a63d0ee89ffdf6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $65a63d0ee89ffdf6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $65a63d0ee89ffdf6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $a001ca238ce744d1$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $a001ca238ce744d1$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$a001ca238ce744d1$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $a04bc661e865b431$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $4e26238e924f114e$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $4e26238e924f114e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $4e26238e924f114e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $4e26238e924f114e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $4e26238e924f114e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $4e26238e924f114e$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $4e26238e924f114e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $4e26238e924f114e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $4e26238e924f114e$var$ordinalNumber,
    era: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $4e26238e924f114e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4e26238e924f114e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $d90c374667fc9bd5$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $d90c374667fc9bd5$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $d90c374667fc9bd5$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d90c374667fc9bd5$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d90c374667fc9bd5$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $70cb8aaf6e245039$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $8a8f5125e173ca9f$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $8a8f5125e173ca9f$var$parseOrdinalNumberPattern = /\d+/i;
const $8a8f5125e173ca9f$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $8a8f5125e173ca9f$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $8a8f5125e173ca9f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $8a8f5125e173ca9f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $8a8f5125e173ca9f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $8a8f5125e173ca9f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $8a8f5125e173ca9f$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $8a8f5125e173ca9f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $8a8f5125e173ca9f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $8a8f5125e173ca9f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $8a8f5125e173ca9f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $70cb8aaf6e245039$export$fdaf2fd6d7edde95)({
        matchPattern: $8a8f5125e173ca9f$var$matchOrdinalNumberPattern,
        parsePattern: $8a8f5125e173ca9f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a8f5125e173ca9f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $8a8f5125e173ca9f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8a8f5125e173ca9f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $ef15c8be5320e65f$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $9bb65aaaaefb5cdf$export$2c14ff85d6318973),
    formatLong: (0, $65a63d0ee89ffdf6$export$cbf60ecb96cbb82f),
    formatRelative: (0, $a001ca238ce744d1$export$8fbbfd65594f46a0),
    localize: (0, $4e26238e924f114e$export$b3bd0bc58e36cd63),
    match: (0, $8a8f5125e173ca9f$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$ef15c8be5320e65f$export$2e2bcd8739ae039 = $ef15c8be5320e65f$export$137380d9ce54f7f;


let $36bdc9e07551bf7d$var$defaultOptions = {};
function $36bdc9e07551bf7d$export$430a3269e24b912e() {
    return $36bdc9e07551bf7d$var$defaultOptions;
}
function $36bdc9e07551bf7d$export$95365be1b0704abc(newOptions) {
    $36bdc9e07551bf7d$var$defaultOptions = newOptions;
}




function $9053b48f59f32827$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$9053b48f59f32827$export$2e2bcd8739ae039 = $9053b48f59f32827$export$f91e89d3d0406102;



function $cde82db767bc9b6b$export$d3b42cd8452deec(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $c01225e8282db0ef$export$4a02e9c37dab4871)(_date, (0, $9053b48f59f32827$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$cde82db767bc9b6b$export$2e2bcd8739ae039 = $cde82db767bc9b6b$export$d3b42cd8452deec;





function $745fbff77e10d60d$export$42c81a444fbfb5d4(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    const weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$745fbff77e10d60d$export$2e2bcd8739ae039 = $745fbff77e10d60d$export$42c81a444fbfb5d4;


function $9461c79606c02f2c$export$6173213f95a4431e(date, options) {
    return (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$9461c79606c02f2c$export$2e2bcd8739ae039 = $9461c79606c02f2c$export$6173213f95a4431e;






function $23d284a44a393c3d$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $9461c79606c02f2c$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $9461c79606c02f2c$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$23d284a44a393c3d$export$2e2bcd8739ae039 = $23d284a44a393c3d$export$3dbc52535f6f8fcc;



function $5d98a96100403307$export$236bdfa374eb69a9(date, options) {
    const year = (0, $23d284a44a393c3d$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $7c1787257eb00a81$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $9461c79606c02f2c$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$5d98a96100403307$export$2e2bcd8739ae039 = $5d98a96100403307$export$236bdfa374eb69a9;



function $b249011336f9bc7f$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $9461c79606c02f2c$export$6173213f95a4431e)(_date) - +(0, $5d98a96100403307$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $37682150499c1c6a$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$b249011336f9bc7f$export$2e2bcd8739ae039 = $b249011336f9bc7f$export$7cabdc5698b63e2f;











function $c9463c2fda3f28c7$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const firstWeekOfNextYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $7c1787257eb00a81$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c9463c2fda3f28c7$export$2e2bcd8739ae039 = $c9463c2fda3f28c7$export$12d572480ceb6e58;



function $15d3c55c8e9bc2ef$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const year = (0, $c9463c2fda3f28c7$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $7c1787257eb00a81$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$15d3c55c8e9bc2ef$export$2e2bcd8739ae039 = $15d3c55c8e9bc2ef$export$bb7b45bb8e74da0f;



function $a9e104ef0f3c8cb9$export$efe19b760242b2fc(date, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(_date, options) - +(0, $15d3c55c8e9bc2ef$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $37682150499c1c6a$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$a9e104ef0f3c8cb9$export$2e2bcd8739ae039 = $a9e104ef0f3c8cb9$export$efe19b760242b2fc;



function $a25e318a409c6a3f$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $b26f1f7176577786$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $122af9549e803407$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $122af9549e803407$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $c9463c2fda3f28c7$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $23d284a44a393c3d$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $b26f1f7176577786$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $a9e104ef0f3c8cb9$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $b249011336f9bc7f$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $cde82db767bc9b6b$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $122af9549e803407$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $b26f1f7176577786$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $122af9549e803407$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $122af9549e803407$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $122af9549e803407$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $122af9549e803407$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $122af9549e803407$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $122af9549e803407$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $122af9549e803407$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $122af9549e803407$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(minutes, 2);
}
function $122af9549e803407$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $122af9549e803407$var$formatTimezone(offset, delimiter);
}
function $122af9549e803407$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $a25e318a409c6a3f$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $fccd8ac5b2f199a5$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $fccd8ac5b2f199a5$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $fccd8ac5b2f199a5$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $fccd8ac5b2f199a5$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $fccd8ac5b2f199a5$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $fccd8ac5b2f199a5$var$timeLongFormatter(timePattern, formatLong));
};
const $fccd8ac5b2f199a5$export$70cc8fd02856fd58 = {
    p: $fccd8ac5b2f199a5$var$timeLongFormatter,
    P: $fccd8ac5b2f199a5$var$dateTimeLongFormatter
};


const $7cb6c07d9954f47a$var$dayOfYearTokenRE = /^D+$/;
const $7cb6c07d9954f47a$var$weekYearTokenRE = /^Y+$/;
const $7cb6c07d9954f47a$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7cb6c07d9954f47a$export$c6cc36aa33304772(token) {
    return $7cb6c07d9954f47a$var$dayOfYearTokenRE.test(token);
}
function $7cb6c07d9954f47a$export$c6b49d6dceb604a1(token) {
    return $7cb6c07d9954f47a$var$weekYearTokenRE.test(token);
}
function $7cb6c07d9954f47a$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $7cb6c07d9954f47a$var$message(token, format, input);
    console.warn(_message);
    if ($7cb6c07d9954f47a$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7cb6c07d9954f47a$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $a0a0eb85328584c5$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$a0a0eb85328584c5$export$2e2bcd8739ae039 = $a0a0eb85328584c5$export$871608497c498473;



function $4d71b265e812de38$export$1ea939691cdc45b8(date) {
    return !(!(0, $a0a0eb85328584c5$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$4d71b265e812de38$export$2e2bcd8739ae039 = $4d71b265e812de38$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $5e113df2845e4dc9$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $5e113df2845e4dc9$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $5e113df2845e4dc9$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $5e113df2845e4dc9$var$doubleQuoteRegExp = /''/g;
const $5e113df2845e4dc9$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $5e113df2845e4dc9$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    const defaultOptions = (0, $36bdc9e07551bf7d$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    const locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ef15c8be5320e65f$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    const firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    const weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    const originalDate = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (!(0, $4d71b265e812de38$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($5e113df2845e4dc9$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $fccd8ac5b2f199a5$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($5e113df2845e4dc9$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $5e113df2845e4dc9$var$cleanEscapedString(substring)
        };
        if ((0, $122af9549e803407$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($5e113df2845e4dc9$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $7cb6c07d9954f47a$export$c6b49d6dceb604a1)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $7cb6c07d9954f47a$export$c6cc36aa33304772)(token)) (0, $7cb6c07d9954f47a$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $122af9549e803407$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $5e113df2845e4dc9$var$cleanEscapedString(input) {
    const matched = input.match($5e113df2845e4dc9$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($5e113df2845e4dc9$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$5e113df2845e4dc9$export$2e2bcd8739ae039 = $5e113df2845e4dc9$export$d9468344d3651243;








// Function to extract string on the left of || and put in norwegian, and on the right to english

//Function takes a string, if it finds ||, it assumes that string on the left is norwegian, and on the right is english
//the string it finds, it runs through the i18n t function, which further translates it
const $a37d7511f1690d99$var$FindLanguage = (incidentText)=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    console.log('Language: ' + i18n.language);
    let incidentTextInLanguage = incidentText;
    let splitter = incidentText.indexOf('||');
    // If we find splitter in the text
    if (splitter !== -1) {
        console.log('Found language splitter');
        // If the detected language is norwegian we select the left side of the string
        if (i18n.language === 'nb-NO' || i18n.language === 'no' || i18n.language === 'nb') incidentTextInLanguage = incidentText.substring(0, splitter);
        else incidentTextInLanguage = incidentText.substring(2 + splitter);
    // Else we do not find a splitter, and we return the string untouched.
    } else console.log('Did not find language splitter for text: -->' + incidentTextInLanguage + '<--');
    console.log('Returning this text: ' + t(incidentTextInLanguage));
    return t(incidentTextInLanguage);
};
var $a37d7511f1690d99$export$2e2bcd8739ae039 = $a37d7511f1690d99$var$FindLanguage;



const $1db01b5b63d8fe4c$var$StatusMessage = ({ incident: incident })=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    // Dirty hack to get relative path on incidents link
    var incidents_location = '';
    if (location.pathname === "/") incidents_location = '/incidents';
    else incidents_location = location.pathname + '/incidents';
    if ((0, $948a817567efcc0c$export$1ef61927080de40d)(incident)) incident.incident_updates[0].body = "Leverand\xf8r jobber med saken.||Vendor is working to resolve the issue.";
    /*return (
    <li role="status" className={`dnb-status-message dnb-status-message--${incident.impact}`}>
      <span className={`dnb-status-icon dnb-status-icon--${incident.impact}`}>
        <Icon icon={getStatusIcon(incident.impact)} aria-hidden size="20" />
      </span>
      <span className="dnb-status-message__text dnb-h--medium">{FindLanguage(incident.name)}</span>
      <span className="dnb-status-message__time">
        <time dateTime={format(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')}>
          {format(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')}
        </time>
      </span>
      <span className="dnb-status-message__time">
        {FindLanguage(incident.incident_updates[0].body)}
      </span>
    </li>
  );*/ console.log("Incident: ", incident);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
        className: `dnb-status-message dnb-status-message--${incident.impact}`,
        outline: "none",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Container, {
            columnGap: "medium",
            style: {
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            1,
                            10
                        ],
                        large: [
                            1,
                            10
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                            className: "dnb-heading-large",
                            children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(incident.name)
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: "dnb-no-statuses__last-updated",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                                dateTime: (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm'),
                                children: (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: "dnb-status-message__time",
                            children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(incident.incident_updates[0].body)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            11,
                            'end'
                        ],
                        large: [
                            11,
                            'end'
                        ]
                    },
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                        className: "dnb-button-custom",
                        text: t('See incidents'),
                        variant: "tertiary",
                        href: incidents_location,
                        target: "_self",
                        title: t('Go to the incident overview'),
                        icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039)
                    })
                })
            ]
        })
    });
};
$1db01b5b63d8fe4c$var$StatusMessage.propTypes = {
    incident: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};
var $1db01b5b63d8fe4c$export$2e2bcd8739ae039 = $1db01b5b63d8fe4c$var$StatusMessage;



parcelRequire("ieaan");



var $ljfqi = parcelRequire("ljfqi");


function $f9b0fd5354592e88$export$2e2bcd8739ae039(props) {
    let linkClass = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-status-link', {
        'dnb-status-link--right': props.iconPosition === 'right'
    });
    if (props.external) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("a", {
        href: props.href,
        className: linkClass,
        to: props.href,
        title: props.title,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            props.icon && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                icon: props.icon,
                size: "auto",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-button__text",
                children: props.children
            })
        ]
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $ee61663bcaa3deaf$export$a6c7ac8248d6e38a), {
        className: linkClass,
        to: props.href,
        title: props.title,
        relative: "path",
        children: [
            props.icon && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                "aria-hidden": true,
                icon: props.icon,
                size: "auto"
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "dnb-button__text",
                children: props.children
            })
        ]
    });
}
$f9b0fd5354592e88$export$2e2bcd8739ae039.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).any,
    iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    external: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool
};






const $125d6477a8342063$var$StatusMessageWrapper = ({ incidents: incidents, updateTimestamp: updateTimestamp, includedComponents: includedComponents })=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const incidentsList = incidents.filter((e)=>e.status !== 'resolved').filter((e)=>{
        if (e.components.length > 0) {
            if (e.components[0].id in includedComponents) return e;
        } else return e;
    }) // If we want to filter out only the components that are affected
    .map((incident)=>{
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $1db01b5b63d8fe4c$export$2e2bcd8739ae039), {
            incident: incident
        }, incident.id);
    });
    const lastUpdated = updateTimestamp !== null ? (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(updateTimestamp, 'dd.MM.yyyy, HH:mm') : '';
    // Dirty hack to get relative path on incidents link
    var incidents_location = '';
    if (location.pathname === "/") incidents_location = '/incidents';
    else incidents_location = location.pathname + '/incidents';
    if (incidentsList.length > 0) //return <ul className='dnb-status-messages-wrapper'>{incidentsList}</ul>;
    //return <Flex.Container className='dnb-status-messages-wrapper' direction='vertical' gap='small'>{incidentsList}</Flex.Container>;
    return incidentsList;
    else // Should use card here, to get the same style as the status messages
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
        className: "dnb-no-statuses",
        outline: "none",
        backgroundColor: "pistachio",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Container, {
            columnGap: "medium",
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            1,
                            10
                        ],
                        large: [
                            1,
                            10
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                            className: "dnb-heading-large",
                            children: t('All our systems and services are working as normal')
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                            className: "dnb-no-statuses__last-updated",
                            children: [
                                t('Last updated'),
                                ": ",
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                                    dateTime: lastUpdated,
                                    children: lastUpdated
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $3b462a98d423171a$exports).Item, {
                    span: {
                        small: 'full',
                        medium: [
                            11,
                            'end'
                        ],
                        large: [
                            11,
                            'end'
                        ]
                    },
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                        className: "dnb-button-custom",
                        text: t('See incidents'),
                        variant: "tertiary",
                        href: incidents_location,
                        target: "_self",
                        title: t('Go to the incident overview'),
                        icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039)
                    })
                })
            ]
        })
    });
};
var $125d6477a8342063$export$2e2bcd8739ae039 = $125d6477a8342063$var$StatusMessageWrapper;
$125d6477a8342063$var$StatusMessageWrapper.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    updateTimestamp: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};



parcelRequire("ieaan");



var $ljfqi = parcelRequire("ljfqi");



const $c13f7f1437f70ce1$var$Legend = (props)=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    let legendClass = (0, (/*@__PURE__*/$parcel$interopDefault($ljfqi)))('dnb-legend', {
        'dnb-legend--left': props.iconPosition === 'left'
    });
    const LegendData = [
        {
            id: 'operational',
            status: t('operational')
        },
        {
            id: 'minor',
            status: t('minor')
        },
        {
            id: 'major',
            status: t('major')
        },
        {
            id: 'degraded_performance',
            status: t('degraded_performance')
        },
        {
            id: 'under_maintenance',
            status: t('under_maintenance')
        }
    ];
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: legendClass,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
            children: LegendData.length > 0 && LegendData.map((item)=>{
                return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: `dnb-status-icon dnb-status-icon--${item.id}`,
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                icon: (0, $948a817567efcc0c$export$c742923ea4ac4c1c)(item.id),
                                size: "16"
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                            className: "dnb-legend__text",
                            children: item.status
                        })
                    ]
                }, `legend-${item.id}`);
            })
        })
    });
};
var $c13f7f1437f70ce1$export$2e2bcd8739ae039 = $c13f7f1437f70ce1$var$Legend;
$c13f7f1437f70ce1$var$Legend.propTypes = {
    iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};



parcelRequire("ieaan");



var $ieaan = parcelRequire("ieaan");



function $5a66ca5ff1e7abcd$export$d7deef7a3738e19d(date, interval, options) {
    const time = +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const [startTime, endTime] = [
        +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(interval.start, options === null || options === void 0 ? void 0 : options.in),
        +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(interval.end, options === null || options === void 0 ? void 0 : options.in)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$5a66ca5ff1e7abcd$export$2e2bcd8739ae039 = $5a66ca5ff1e7abcd$export$d7deef7a3738e19d;




function $802d7bb0636862ee$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $7c1787257eb00a81$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, +(0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$802d7bb0636862ee$export$2e2bcd8739ae039 = $802d7bb0636862ee$export$baf757aaf0c95c94;



function $146955a13de5ac75$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $802d7bb0636862ee$export$baf757aaf0c95c94)(date, amount * (0, $37682150499c1c6a$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$146955a13de5ac75$export$2e2bcd8739ae039 = $146955a13de5ac75$export$4a4306ad4fa0e5e6;


function $221f579b1555e59c$export$5e9fa51cd5bb1e71(date, amount, options) {
    return (0, $146955a13de5ac75$export$4a4306ad4fa0e5e6)(date, -amount, options);
}
var // Fallback for modularized imports:
$221f579b1555e59c$export$2e2bcd8739ae039 = $221f579b1555e59c$export$5e9fa51cd5bb1e71;




parcelRequire("ieaan");


var $20f4351cfe3c07e1$exports = {};
$20f4351cfe3c07e1$exports = $parcel$resolve("gjttY");


function $62e11398d2c2b8cd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-info-circle",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($20f4351cfe3c07e1$exports))),
                className: "dnb-info-circle__filler-square",
                alt: "Gjennomsiktig, lite firkantet bilde bare brukt for \xe5 stilsette infosirkelen",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-info-circle__content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-info-circle__top-text",
                        children: props.topText
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-info-circle__number",
                        children: props.number
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-info-circle__bottom-text",
                        children: props.bottomText
                    })
                ]
            })
        ]
    });
}
$62e11398d2c2b8cd$export$2e2bcd8739ae039.propTypes = {
    topText: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired,
    number: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).any.isRequired,
    bottomText: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string.isRequired
};



const $54659b67d0e65e69$var$StatusOverview = ({ groups: groups })=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const [incidentsLast24, setIncidentsLast24] = (0, $ieaan.useState)(0);
    const [operational, setOperational] = (0, $ieaan.useState)(0);
    const [total, setTotal] = (0, $ieaan.useState)(0);
    (0, $ieaan.useEffect)(()=>{
        const getIncidentsLast24Hours = ()=>{
            let total = 0;
            let now = new Date();
            let earliestDate = (0, $221f579b1555e59c$export$2e2bcd8739ae039)(now, 24);
            for (let group of groups){
                let incidents = group.incidents.filter((e)=>{
                    const yes = (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.started_at), {
                        start: earliestDate,
                        end: new Date()
                    });
                    if (yes) return e;
                });
                total += incidents.length;
            }
            setIncidentsLast24(total);
        };
        getIncidentsLast24Hours();
        const oper = ()=>{
            let operational = 0;
            let total = 0;
            for (let group of groups){
                const op = group.subComponents.filter((e)=>e.status === 'operational').length;
                const t = group.subComponents.length;
                operational += op;
                total += t;
            }
            return {
                operational: operational,
                total: total
            };
        };
        const { operational: operational, total: total } = oper();
        setOperational(operational);
        setTotal(total);
    }, [
        groups
    ]);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-status-overview",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $0bc1282718aeb9f8$export$2e2bcd8739ae039), {
                name: t('Incidents'),
                subtitle: t('Last 48 hours'),
                icon: "status"
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62e11398d2c2b8cd$export$2e2bcd8739ae039), {
                topText: t('Incidents'),
                number: incidentsLast24,
                bottomText: t('last 24 hours')
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62e11398d2c2b8cd$export$2e2bcd8739ae039), {
                topText: t('Systems'),
                number: `${operational}/${total}`,
                bottomText: t('working')
            })
        ]
    });
};
$54659b67d0e65e69$var$StatusOverview.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};
var $54659b67d0e65e69$export$2e2bcd8739ae039 = $54659b67d0e65e69$var$StatusOverview;



parcelRequire("ieaan");





var $ieaan = parcelRequire("ieaan");
var $46d2f88363187f49$var$_path;
const $46d2f88363187f49$var$information_bubble = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $46d2f88363187f49$var$_path || ($46d2f88363187f49$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M9 10.666h-.5a1 1 0 0 1-1-1v-2.5a.5.5 0 0 0-.5-.5h-.5m.664-2.41h.022M7.523.75a6.747 6.747 0 0 1 5.91 3.471 6.76 6.76 0 0 1-.168 6.856l1.985 4.173-4.169-1.987A6.757 6.757 0 0 1 1.008 9.37a6.772 6.772 0 0 1 3.497-7.913A6.757 6.757 0 0 1 7.523.75Z"
    })));
var $46d2f88363187f49$export$2e2bcd8739ae039 = $46d2f88363187f49$var$information_bubble;




parcelRequire("ieaan");




function $2e391ba95e263515$export$2e2bcd8739ae039({ item: item }) {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const formattedStartDate = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(item.scheduled_for), 'dd.MM.yyyy, HH:mm');
    const formattedEndDate = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(item.scheduled_until), 'dd.MM.yyyy, HH:mm');
    // Assigns the first update (which gets pushed), to the incidentUpdate, this until this one
    // is fixed: https://community.atlassian.com/t5/Statuspage-questions/Keeping-maintenance-message-from-scheduled-to-ongoing/qaq-p/1879278?utm_source=atlcomm&utm_medium=email&utm_campaign=accept_as_solution_reminder&utm_content=topic
    let incidentUpdate = item.incident_updates.filter((e)=>{
        if (e.status == 'scheduled') return e;
    });
    incidentUpdate = incidentUpdate[0].body;
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-planned-incident__time",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                        dateTime: item.scheduled_for,
                        children: formattedStartDate
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        children: " - "
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("time", {
                        dateTime: item.scheduled_until,
                        children: formattedEndDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h3", {
                children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(item.name)
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("p", {
                children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(incidentUpdate)
            })
        ]
    });
}
$2e391ba95e263515$export$2e2bcd8739ae039.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};


const $a9ee01301fa74513$var$PlannedIncidents = ({ maintenances: maintenances, includedComponents: includedComponents })=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const renderContent = ()=>{
        let maintenancesList = maintenances.filter((e)=>{
            if (e.components.length > 0) {
                if (e.components[0].id in includedComponents) return e;
            } else return e;
        });
        if (maintenancesList.length > 0) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
            className: "dnb-planned-incidents",
            style: {
                width: '100%',
                maxWidth: '100%'
            },
            children: maintenancesList.map((i)=>{
                return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $2e391ba95e263515$export$2e2bcd8739ae039), {
                    item: i
                }, i.id);
            })
        });
        else return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-planned-incidents__no-incidents",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                        icon: (0, $46d2f88363187f49$export$2e2bcd8739ae039),
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("p", {
                        children: [
                            t('There is currently no scheduled maintenance'),
                            "."
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-planned-incidents-wrapper",
        style: {
            width: '100%',
            maxWidth: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h2", {
                className: "dnb-planned-incidents__heading",
                children: t('Scheduled maintenance')
            }),
            renderContent()
        ]
    });
};
var $a9ee01301fa74513$export$2e2bcd8739ae039 = $a9ee01301fa74513$var$PlannedIncidents;
$a9ee01301fa74513$var$PlannedIncidents.propTypes = {
    maintenances: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};





const $839ef15b0a2ceacf$var$FrontpageComponents = ({ maintenances: maintenances, groups: groups, includedComponents: includedComponents, incidents: incidents })=>{
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $a9ee01301fa74513$export$2e2bcd8739ae039), {
                maintenances: maintenances,
                includedComponents: includedComponents
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-services-section",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h2", {
                        className: "dnb-services-section__heading",
                        children: "Services"
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $c13f7f1437f70ce1$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $28af0973880b5e9a$export$2e2bcd8739ae039), {
                        groups: groups,
                        incidents: incidents
                    })
                ]
            })
        ]
    });
};
$839ef15b0a2ceacf$var$FrontpageComponents.propTypes = {
    maintenances: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};
var $839ef15b0a2ceacf$export$2e2bcd8739ae039 = $839ef15b0a2ceacf$var$FrontpageComponents;



function $05bb2c4ee1fde64f$export$2e2bcd8739ae039({ groups: groups, incidents: incidents, maintenances: maintenances, updateTimestamp: updateTimestamp, includedComponents: includedComponents }) {
    const groupsWithIncidents = (0, $948a817567efcc0c$export$7e162e1ca82c6723)(groups, incidents);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
        className: "p_home-page",
        role: "main",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("section", {
            className: "dnb-center-content",
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $125d6477a8342063$export$2e2bcd8739ae039), {
                    incidents: incidents,
                    updateTimestamp: updateTimestamp,
                    includedComponents: includedComponents
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $839ef15b0a2ceacf$export$2e2bcd8739ae039), {
                    maintenances: maintenances,
                    groups: groupsWithIncidents,
                    incidents: incidents,
                    includedComponents: includedComponents
                })
            ]
        })
    });
}
$05bb2c4ee1fde64f$export$2e2bcd8739ae039.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    isFetchingStatusPage: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    maintenances: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    updateTimestamp: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    includedComponents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};



parcelRequire("ieaan");






var $ieaan = parcelRequire("ieaan");
var $c2d6136bdaab29eb$var$_path;
const $c2d6136bdaab29eb$var$home = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("svg", (0, $8fc6b500ae8ef18e$export$2e2bcd8739ae039)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), $c2d6136bdaab29eb$var$_path || ($c2d6136bdaab29eb$var$_path = (0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M5.667 12.976v-3.66c0-.367.298-.664.666-.664h3.334c.368 0 .666.297.666.665v3.659m-8 1.996h11.334c.736 0 1.333-.596 1.333-1.33V6.674c0-.43-.208-.833-.558-1.083L8.775 1.553a1.336 1.336 0 0 0-1.55 0l-5.667 4.04A1.33 1.33 0 0 0 1 6.674v6.966c0 .735.597 1.33 1.333 1.33Z"
    })));
var $c2d6136bdaab29eb$export$2e2bcd8739ae039 = $c2d6136bdaab29eb$var$home;




parcelRequire("ieaan");
const $09a5b5c9c72636b7$var$CustomDnbLogo = (props)=>/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 57.3 46",
        ...props,
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("g", {
            "data-name": "Layer 2",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("path", {
                d: "M56.7 30a7.3 7.3 0 0 0 .6-3 5.49 5.49 0 0 0-2.1-4.4 4.1 4.1 0 0 0-1.1-.7l-.1-.1.1-.1a5.34 5.34 0 0 0 1.7-4.2 5.35 5.35 0 0 0-2.1-4.6 8.8 8.8 0 0 0-5-1.2h-6.2a.68.68 0 0 0-.7.7v20.5a.68.68 0 0 0 .7.7h7.1a9.83 9.83 0 0 0 5.4-1.4 8.7 8.7 0 0 0 1.7-2.2M43.9 13.8h4.9a6.45 6.45 0 0 1 3.8.9 3.28 3.28 0 0 1 1.2 2.9 3.16 3.16 0 0 1-3.4 3.5h-6.6v-7.3zm5.7 17.7h-5.8v-8.4h6.6c2.9 0 4.9 1.6 4.9 3.9 0 1.1 0 4.5-5.7 4.5m-13.3 2.1h.2a.55.55 0 0 0 .4-.6V0h-2v28.9L21.5 11.8a.55.55 0 0 0-.5-.3h-.2a.55.55 0 0 0-.4.6V46h2V16.3l13.4 17.1a.76.76 0 0 0 .5.2m-22.4-3.3a12.07 12.07 0 0 0 2.4-7.5c0-1.5-.2-5.1-2.4-7.8a8.4 8.4 0 0 0-3.4-2.5 10.5 10.5 0 0 0-3.9-.8H.7a.68.68 0 0 0-.7.7v20.5a.68.68 0 0 0 .7.7h5.9a9.2 9.2 0 0 0 3.8-.7 10 10 0 0 0 3.5-2.6m-7.3 1.2H2V13.8h4.6a7 7 0 0 1 5.7 2.5c1.8 2.2 1.9 5.5 1.9 6.5a10.46 10.46 0 0 1-1.9 6.2 7 7 0 0 1-5.7 2.5",
                className: "custom_dnb_logo_svg__cls-1",
                "data-name": "Layer 1"
            })
        })
    });
var $09a5b5c9c72636b7$export$2e2bcd8739ae039 = $09a5b5c9c72636b7$var$CustomDnbLogo;



const $c851a5131cd8667e$var$Header = ()=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("header", {
        className: "dnb-header",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-header__content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $ee61663bcaa3deaf$export$a6c7ac8248d6e38a), {
                        to: "/",
                        "aria-label": t('DNB Status front page'),
                        title: t('DNB Status front page'),
                        className: "dnb-main-title",
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                                children: "DNB Status"
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-main-title__logo",
                                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                    icon: (0, $09a5b5c9c72636b7$export$2e2bcd8739ae039),
                                    size: "xx-large"
                                })
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-main-title__sub",
                                children: "Status"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                        text: "dnb.no",
                        icon: (0, $c2d6136bdaab29eb$export$2e2bcd8739ae039),
                        variant: "secondary",
                        icon_position: "left",
                        href: "https://www.dnb.no/",
                        target: "_blank"
                    })
                ]
            })
        })
    });
};
var $c851a5131cd8667e$export$2e2bcd8739ae039 = $c851a5131cd8667e$var$Header;



parcelRequire("ieaan");

const $41b6d7e12730d823$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("footer", {
        className: "dnb-footer",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-footer__content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                    className: "dnb-footer__copyright",
                    children: "\xa9 DNB"
                })
            })
        })
    });
};
var $41b6d7e12730d823$export$2e2bcd8739ae039 = $41b6d7e12730d823$var$Footer;



parcelRequire("ieaan");
var $0cdd67f3eabac774$exports = {};
$0cdd67f3eabac774$exports = $parcel$resolve("dEznS");



function $7ec8b67fa7687b7e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("header", {
        className: "dnb-loading",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
            className: "dnb-loading__icon",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0cdd67f3eabac774$exports))),
                alt: "Loading..."
            })
        })
    });
}



var $ieaan = parcelRequire("ieaan");
const $4cb3579337f6afdd$var$GENERIC_ERROR = "Vi har noen problemer som gj\xf8r at vi ikke klarer \xe5 innhente status p\xe5 systemene v\xe5re. Det skal ikke p\xe5virke selve driften av systemene, s\xe5 forh\xe5pentlig fungerer alt fint. Sjekk gjerne innom igjen om noen minutter.";
function $4cb3579337f6afdd$export$2e2bcd8739ae039({ page: page, getIncidents: getIncidents = true, getComponents: getComponents = true, incidentsType: incidentsType = '', getScheduledMaintenances: getScheduledMaintenances = true, scheduledMaintenancesType: scheduledMaintenancesType = {
    in_progress: true,
    scheduled: false,
    completed: false
}, updateInterval: updateInterval = null, includedComponents: includedComponents = {} }) {
    const [groups, setGroups] = (0, $ieaan.useState)([]);
    const [incidents, setIncidents] = (0, $ieaan.useState)([]);
    const [maintenances, setMaintenances] = (0, $ieaan.useState)([]);
    const [error, setError] = (0, $ieaan.useState)(null);
    const [updateTimestamp, setUpdateTimestamp] = (0, $ieaan.useState)(null);
    const [intervalId, setIntervalId] = (0, $ieaan.useState)(null);
    (0, $ieaan.useEffect)(()=>{
        getComponents && fetchComponents();
        getIncidents && fetchIncidents(incidentsType);
        getScheduledMaintenances && fetchScheduledMaintenances(scheduledMaintenancesType);
        if (updateInterval && !intervalId) {
            const id = setInterval(()=>{
                getComponents && fetchComponents();
                getIncidents && fetchIncidents(incidentsType);
                getScheduledMaintenances && fetchScheduledMaintenances(scheduledMaintenancesType);
            }, updateInterval);
            setIntervalId(id);
        }
        return ()=>{
            if (intervalId) clearInterval(intervalId);
        };
        async function fetchScheduledMaintenances(filter) {
            let url;
            url = '/scheduled-maintenances.json';
            const { data: data, error: error } = await getStatusPageData(url);
            if (!error) {
                let scheduled_maintenances = data.scheduled_maintenances.filter((e)=>{
                    if (filter[e.status]) return e;
                });
                setMaintenances(scheduled_maintenances);
            } else setError(error);
        }
        async function fetchIncidents(filter) {
            let url;
            if (filter === '') url = '/incidents.json';
            else url = `/incidents/${filter}.json`;
            const { data: data, error: error } = await getStatusPageData(url);
            if (!error) {
                setIncidents(data.incidents);
                setUpdateTimestamp(new Date());
            } else setError(error);
        }
        async function fetchComponents() {
            const { data: data, error: error } = await getStatusPageData('/components.json');
            if (!error) {
                const tempGroups = [];
                for (let component of data.components){
                    component.incidents = [];
                    if (component.group) {
                        component.subComponents = component.components.map((id)=>data.components.find((e)=>e.id === id));
                        if (includedComponents.hasOwnProperty(component.id)) {
                            console.log('Included ' + component.id + ' ' + component.name);
                            tempGroups.push(component);
                        } else console.log('Not included ' + component.id + ' ' + component.name);
                    }
                }
                setGroups(tempGroups);
            } else setError(error);
        }
        async function getStatusPageData(endpoint) {
            try {
                const url = `https://${page}.statuspage.io/api/v2${endpoint}`;
                let response = await fetch(url);
                if (response.ok) {
                    let data = await response.json();
                    return {
                        data: data
                    };
                } else return {
                    error: $4cb3579337f6afdd$var$GENERIC_ERROR
                };
            } catch (error) {
                return {
                    error: $4cb3579337f6afdd$var$GENERIC_ERROR
                };
            }
        }
    }, [
        getComponents,
        getIncidents,
        getScheduledMaintenances,
        incidentsType,
        scheduledMaintenancesType,
        updateInterval,
        intervalId,
        page
    ]);
    return {
        groups: groups,
        incidents: incidents,
        maintenances: maintenances,
        error: error,
        updateTimestamp: updateTimestamp
    };
}



parcelRequire("ieaan");


parcelRequire("ieaan");



var $47658ea72bda9870$exports = {};
$47658ea72bda9870$exports = $parcel$resolve("3ehqk");





parcelRequire("ieaan");



function $9782eb266730637b$export$5846dc2d57a5c860(date, options) {
    return (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getFullYear();
}
var // Fallback for modularized imports:
$9782eb266730637b$export$2e2bcd8739ae039 = $9782eb266730637b$export$5846dc2d57a5c860;





function $3a7664a91dacafb6$export$2e2bcd8739ae039({ date: date, incrementWeek: incrementWeek, decrementWeek: decrementWeek }) {
    const week = (0, $b249011336f9bc7f$export$2e2bcd8739ae039)(date);
    const year = (0, $9782eb266730637b$export$2e2bcd8739ae039)(date);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-month-picker",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("button", {
                className: "dnb-small-button dnb-small-button--prev",
                onClick: ()=>decrementWeek(),
                "aria-label": "G\xe5 til forrige uke",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                    size: "25",
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-month-picker__current-week",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                    children: [
                        "Uke ",
                        week,
                        " ",
                        year
                    ]
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("button", {
                className: "dnb-small-button dnb-small-button--next",
                onClick: ()=>incrementWeek(),
                "aria-label": "G\xe5 til neste uke",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039),
                    size: "25",
                    "aria-hidden": true
                })
            })
        ]
    });
}
$3a7664a91dacafb6$export$2e2bcd8739ae039.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    incrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func,
    decrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func
};



const $b74d20f62e4fd045$var$HistoryHeader = ({ date: date, incrementWeek: incrementWeek, decrementWeek: decrementWeek })=>{
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "dnb-history-header",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-history-header__actions",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f9b0fd5354592e88$export$2e2bcd8739ae039), {
                        href: "/",
                        title: t('Back to the front page'),
                        icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                        children: t('Back')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f9b0fd5354592e88$export$2e2bcd8739ae039), {
                        href: "/",
                        title: t('Subscribe to updates'),
                        children: t('Subscribe to updates')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-history-header__content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("h2", {
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($47658ea72bda9870$exports))),
                                size: "auto",
                                "aria-hidden": true
                            }),
                            t('History')
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $3a7664a91dacafb6$export$2e2bcd8739ae039), {
                        date: date,
                        decrementWeek: decrementWeek,
                        incrementWeek: incrementWeek
                    })
                ]
            })
        ]
    });
};
$b74d20f62e4fd045$var$HistoryHeader.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date),
    incrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func,
    decrementWeek: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).func
};
var $b74d20f62e4fd045$export$2e2bcd8739ae039 = $b74d20f62e4fd045$var$HistoryHeader;



parcelRequire("ieaan");




function $af9de907ec618575$export$6ea683876c36b8d2(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return +(0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(laterDate_, options) === +(0, $745fbff77e10d60d$export$42c81a444fbfb5d4)(earlierDate_, options);
}
var // Fallback for modularized imports:
$af9de907ec618575$export$2e2bcd8739ae039 = $af9de907ec618575$export$6ea683876c36b8d2;



function $45397e0bd0a09e73$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $e05a7d9b16061e55$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$45397e0bd0a09e73$export$2e2bcd8739ae039 = $45397e0bd0a09e73$export$5841f9eb9773f25f;




var $ieaan = parcelRequire("ieaan");






const $fd69deb2242d3b89$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $fd69deb2242d3b89$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $fd69deb2242d3b89$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};



const $20d7cb3bcc724425$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $20d7cb3bcc724425$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $20d7cb3bcc724425$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $20d7cb3bcc724425$export$cbf60ecb96cbb82f = {
    date: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $20d7cb3bcc724425$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $20d7cb3bcc724425$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $47fded15351fa5db$export$38e44e97ce4dbb7d)({
        formats: $20d7cb3bcc724425$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $e986719f1e8e2d8d$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $e986719f1e8e2d8d$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$e986719f1e8e2d8d$var$formatRelativeLocale[token];



const $7b80591259fcde5f$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $7b80591259fcde5f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $7b80591259fcde5f$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $7b80591259fcde5f$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $7b80591259fcde5f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
const $7b80591259fcde5f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $7b80591259fcde5f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7b80591259fcde5f$var$ordinalNumber,
    era: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $a04bc661e865b431$export$63596d6ee8878b25)({
        values: $7b80591259fcde5f$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};




const $53b6ee5e08c77e5f$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $53b6ee5e08c77e5f$var$parseOrdinalNumberPattern = /\d+/i;
const $53b6ee5e08c77e5f$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $53b6ee5e08c77e5f$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $53b6ee5e08c77e5f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $53b6ee5e08c77e5f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $53b6ee5e08c77e5f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $53b6ee5e08c77e5f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $53b6ee5e08c77e5f$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $53b6ee5e08c77e5f$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $53b6ee5e08c77e5f$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
const $53b6ee5e08c77e5f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $53b6ee5e08c77e5f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $70cb8aaf6e245039$export$fdaf2fd6d7edde95)({
        matchPattern: $53b6ee5e08c77e5f$var$matchOrdinalNumberPattern,
        parsePattern: $53b6ee5e08c77e5f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53b6ee5e08c77e5f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d90c374667fc9bd5$export$1430a0f35710914d)({
        matchPatterns: $53b6ee5e08c77e5f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $53b6ee5e08c77e5f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $c8d01de8f15790bb$export$38ef0e3f791a121e = {
    code: "nb",
    formatDistance: (0, $fd69deb2242d3b89$export$2c14ff85d6318973),
    formatLong: (0, $20d7cb3bcc724425$export$cbf60ecb96cbb82f),
    formatRelative: (0, $e986719f1e8e2d8d$export$8fbbfd65594f46a0),
    localize: (0, $7b80591259fcde5f$export$b3bd0bc58e36cd63),
    match: (0, $53b6ee5e08c77e5f$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$c8d01de8f15790bb$export$2e2bcd8739ae039 = $c8d01de8f15790bb$export$38ef0e3f791a121e;





function $f33c67b2bf6fd23c$export$2e2bcd8739ae039({ item: item }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const [isClosed, setClosed] = (0, $ieaan.useState)([
        true
    ]);
    const date = new Date(item.started_at);
    const formattedDate = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(date, 'dd');
    const formattedMonth = (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(date, 'MMM', {
        locale: (0, $c8d01de8f15790bb$export$38ef0e3f791a121e)
    });
    const sortedIncidentUpdates = item.incident_updates.sort((a, b)=>{
        return (0, $456835a5566ee681$export$2e2bcd8739ae039)(new Date(a.created_at), new Date(b.created_at));
    });
    const formattedIncidentStatusDate = (date)=>{
        let dateObj;
        if (typeof date === 'string') dateObj = new Date(date);
        else dateObj = date;
        return (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(dateObj, 'dd.MM.yy HH:mm');
    };
    //const affectedComponentsString = item.components.map((e) => e.name).join(', ');
    // Trying to map with translated names
    const affectedComponentsString = item.components.map((e)=>t(e.name)).join(', ');
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("article", {
        className: `dnb-historic-incident-card dnb-historic-incident-card--${item.impact}`,
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-card-date",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-card-date__day",
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                        className: "dnb-card-date__month",
                        children: formattedMonth
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-card-text",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h3", {
                        children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(item.name)
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                        children: [
                            t('Incident'),
                            " ",
                            t('affected'),
                            ": ",
                            affectedComponentsString
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                        children: [
                            t('Incident'),
                            " ",
                            t('started'),
                            ": ",
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                children: formattedIncidentStatusDate(item.started_at)
                            })
                        ]
                    }),
                    item.resolved_at && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                        children: [
                            t('Incident'),
                            " ",
                            t('resolved'),
                            ": ",
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                children: formattedIncidentStatusDate(item.resolved_at)
                            })
                        ]
                    }),
                    item.incident_updates.length > 0 && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("button", {
                        "aria-expanded": isClosed === true ? 'false' : 'true',
                        className: `dnb-status-text-button ${isClosed ? '' : 'dnb-status-text-button--clicked'}`,
                        onClick: ()=>setClosed(!isClosed),
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-status-text-button__text",
                                children: isClosed ? t('Show log') : t('Hide log')
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                className: "dnb-status-text-button__icon",
                                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                    icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039),
                                    size: "20",
                                    "aria-hidden": true
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: `dnb-status-icon dnb-status-icon--${item.impact}`,
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    class: "",
                    icon: (0, $948a817567efcc0c$export$c742923ea4ac4c1c)(item.impact),
                    "aria-hidden": true,
                    size: "25"
                })
            }),
            item.incident_updates.length > 0 && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: `dnb-incident-history ${isClosed ? '' : 'dnb-incident-history--open'}`,
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
                    children: item.incident_updates.map((e)=>{
                        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                    className: "dnb-incident-history__body",
                                    children: (0, $a37d7511f1690d99$export$2e2bcd8739ae039)(e.body)
                                }),
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                    className: "dnb-incident-history__date",
                                    children: formattedIncidentStatusDate(e.updated_at)
                                })
                            ]
                        }, e.id);
                    })
                })
            })
        ]
    });
}
$f33c67b2bf6fd23c$export$2e2bcd8739ae039.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object
};


function $1688829d097592bb$export$2e2bcd8739ae039({ group: group, date: date }) {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    /* All resolved incidents in the same month / year as currently selected */ const resolvedIncidents = group.incidents.filter((e)=>{
        if (e.status === 'resolved' && (0, $af9de907ec618575$export$2e2bcd8739ae039)(date, new Date(e.started_at)) && (0, $45397e0bd0a09e73$export$2e2bcd8739ae039)(date, new Date(e.started_at))) return e;
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "left",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                    children: [
                        resolvedIncidents.length,
                        " ",
                        t('incidents')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "right",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
                    className: "incident-list",
                    children: resolvedIncidents.map((e)=>{
                        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f33c67b2bf6fd23c$export$2e2bcd8739ae039), {
                            item: e
                        }, e.id);
                    })
                })
            })
        ]
    });
}
$1688829d097592bb$export$2e2bcd8739ae039.propTypes = {
    group: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).object,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).instanceOf(Date)
};



var $ieaan = parcelRequire("ieaan");


function $6cc55444142e86f5$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $f9702abd9ae62b8a$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(amount)) return (0, $7c1787257eb00a81$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$6cc55444142e86f5$export$2e2bcd8739ae039 = $6cc55444142e86f5$export$dd412b56f1e4d8aa;


function $08f9c67d76427a6a$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $6cc55444142e86f5$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$08f9c67d76427a6a$export$2e2bcd8739ae039 = $08f9c67d76427a6a$export$ef501a2bb4f3ee6b;



function $2c053222becae1a0$export$b4d8ae6376193efb(date, amount, options) {
    return (0, $08f9c67d76427a6a$export$ef501a2bb4f3ee6b)(date, -amount, options);
}
var // Fallback for modularized imports:
$2c053222becae1a0$export$2e2bcd8739ae039 = $2c053222becae1a0$export$b4d8ae6376193efb;


function $a991984b621a0dfb$export$2e2bcd8739ae039(initialDate) {
    const [date, setDate] = (0, $ieaan.useState)(initialDate);
    function incrementWeek() {
        let newDate = (0, $08f9c67d76427a6a$export$2e2bcd8739ae039)(date, 1);
        setDate(newDate);
    }
    function decrementWeek() {
        let newDate = (0, $2c053222becae1a0$export$2e2bcd8739ae039)(date, 1);
        setDate(newDate);
    }
    return {
        date: date,
        incrementWeek: incrementWeek,
        decrementWeek: decrementWeek
    };
}



function $7b4fbae4d9f02598$export$2e2bcd8739ae039({ groups: groups, incidents: incidents }) {
    const { date: date, incrementWeek: incrementWeek, decrementWeek: decrementWeek } = (0, $a991984b621a0dfb$export$2e2bcd8739ae039)(new Date());
    const resolvedIncidents = incidents.filter((e)=>e.status === 'resolved');
    const mergedGroupsAndIncidents = (0, $948a817567efcc0c$export$7e162e1ca82c6723)(groups, resolvedIncidents);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: "p_history-page",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $b74d20f62e4fd045$export$2e2bcd8739ae039), {
                    date: date,
                    incrementWeek: incrementWeek,
                    decrementWeek: decrementWeek
                })
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: mergedGroupsAndIncidents.map((group)=>{
                    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $1688829d097592bb$export$2e2bcd8739ae039), {
                        group: group,
                        date: date
                    }, group.id);
                })
            })
        ]
    });
}
$7b4fbae4d9f02598$export$2e2bcd8739ae039.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};




var $ieaan = parcelRequire("ieaan");



var $ieaan = parcelRequire("ieaan");
var $9a84188630d61b9c$exports = {};
'use strict';
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var $d327c535b9e1ec65$export$4659b591c19bdf3d;
var $d327c535b9e1ec65$export$98e6a39c04603d36;
'use strict';
$d327c535b9e1ec65$export$4659b591c19bdf3d = $d327c535b9e1ec65$var$matchQuery;
$d327c535b9e1ec65$export$98e6a39c04603d36 = $d327c535b9e1ec65$var$parseQuery;
// -----------------------------------------------------------------------------
var $d327c535b9e1ec65$var$RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, $d327c535b9e1ec65$var$RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, $d327c535b9e1ec65$var$RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, $d327c535b9e1ec65$var$RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, $d327c535b9e1ec65$var$RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
function $d327c535b9e1ec65$var$matchQuery(mediaQuery, values) {
    return $d327c535b9e1ec65$var$parseQuery(mediaQuery).some(function(query) {
        var inverse = query.inverse;
        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === 'all' || values.type === query.type;
        // Quit early when `type` doesn't match, but take "not" into account.
        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
        var expressionsMatch = query.expressions.every(function(expression) {
            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
            // Missing or falsy values don't match.
            if (!value) return false;
            switch(feature){
                case 'orientation':
                case 'scan':
                    return value.toLowerCase() === expValue.toLowerCase();
                case 'width':
                case 'height':
                case 'device-width':
                case 'device-height':
                    expValue = $d327c535b9e1ec65$var$toPx(expValue);
                    value = $d327c535b9e1ec65$var$toPx(value);
                    break;
                case 'resolution':
                    expValue = $d327c535b9e1ec65$var$toDpi(expValue);
                    value = $d327c535b9e1ec65$var$toDpi(value);
                    break;
                case 'aspect-ratio':
                case 'device-aspect-ratio':
                case /* Deprecated */ 'device-pixel-ratio':
                    expValue = $d327c535b9e1ec65$var$toDecimal(expValue);
                    value = $d327c535b9e1ec65$var$toDecimal(value);
                    break;
                case 'grid':
                case 'color':
                case 'color-index':
                case 'monochrome':
                    expValue = parseInt(expValue, 10) || 1;
                    value = parseInt(value, 10) || 0;
                    break;
            }
            switch(modifier){
                case 'min':
                    return value >= expValue;
                case 'max':
                    return value <= expValue;
                default:
                    return value === expValue;
            }
        });
        return expressionsMatch && !inverse || !expressionsMatch && inverse;
    });
}
function $d327c535b9e1ec65$var$parseQuery(mediaQuery) {
    return mediaQuery.split(',').map(function(query) {
        query = query.trim();
        var captures = query.match($d327c535b9e1ec65$var$RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || '', parsed = {};
        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
        parsed.type = type ? type.toLowerCase() : 'all';
        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];
        parsed.expressions = expressions.map(function(expression) {
            var captures = expression.match($d327c535b9e1ec65$var$RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match($d327c535b9e1ec65$var$RE_MQ_FEATURE);
            return {
                modifier: feature[1],
                feature: feature[2],
                value: captures[2]
            };
        });
        return parsed;
    });
}
// -- Utilities ----------------------------------------------------------------
function $d327c535b9e1ec65$var$toDecimal(ratio) {
    var decimal = Number(ratio), numbers;
    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }
    return decimal;
}
function $d327c535b9e1ec65$var$toDpi(resolution) {
    var value = parseFloat(resolution), units = String(resolution).match($d327c535b9e1ec65$var$RE_RESOLUTION_UNIT)[1];
    switch(units){
        case 'dpcm':
            return value / 2.54;
        case 'dppx':
            return value * 96;
        default:
            return value;
    }
}
function $d327c535b9e1ec65$var$toPx(length) {
    var value = parseFloat(length), units = String(length).match($d327c535b9e1ec65$var$RE_LENGTH_UNIT)[1];
    switch(units){
        case 'em':
            return value * 16;
        case 'rem':
            return value * 16;
        case 'cm':
            return value * 96 / 2.54;
        case 'mm':
            return value * 96 / 2.54 / 10;
        case 'in':
            return value * 96;
        case 'pt':
            return value * 72;
        case 'pc':
            return value * 72 / 12;
        default:
            return value;
    }
}


var $9a84188630d61b9c$require$staticMatch = $d327c535b9e1ec65$export$4659b591c19bdf3d;
var $9a84188630d61b9c$var$dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
// our fake MediaQueryList
function $9a84188630d61b9c$var$Mql(query, values, forceStatic) {
    var self = this;
    var mql;
    // matchMedia will return null in FF when it's called in a hidden iframe
    // ref: https://stackoverflow.com/a/12330568
    if ($9a84188630d61b9c$var$dynamicMatch && !forceStatic) mql = $9a84188630d61b9c$var$dynamicMatch.call(window, query);
    if (mql) {
        this.matches = mql.matches;
        this.media = mql.media;
        // TODO: is there a time it makes sense to remove this listener?
        mql.addListener(update);
    } else {
        this.matches = $9a84188630d61b9c$require$staticMatch(query, values);
        this.media = query;
    }
    this.addListener = addListener;
    this.removeListener = removeListener;
    this.dispose = dispose;
    function addListener(listener) {
        if (mql) mql.addListener(listener);
    }
    function removeListener(listener) {
        if (mql) mql.removeListener(listener);
    }
    // update ourselves!
    function update(evt) {
        self.matches = evt.matches;
        self.media = evt.media;
    }
    function dispose() {
        if (mql) mql.removeListener(update);
    }
}
function $9a84188630d61b9c$var$matchMedia(query, values, forceStatic) {
    return new $9a84188630d61b9c$var$Mql(query, values, forceStatic);
}
$9a84188630d61b9c$exports = $9a84188630d61b9c$var$matchMedia;


/* eslint-disable no-var, prefer-template */ var $9dc9dafb31137c82$var$uppercasePattern = /[A-Z]/g;
var $9dc9dafb31137c82$var$msPattern = /^ms-/;
var $9dc9dafb31137c82$var$cache = {};
function $9dc9dafb31137c82$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $9dc9dafb31137c82$var$hyphenateStyleName(name) {
    if ($9dc9dafb31137c82$var$cache.hasOwnProperty(name)) return $9dc9dafb31137c82$var$cache[name];
    var hName = name.replace($9dc9dafb31137c82$var$uppercasePattern, $9dc9dafb31137c82$var$toHyphenLower);
    return $9dc9dafb31137c82$var$cache[name] = $9dc9dafb31137c82$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $9dc9dafb31137c82$export$2e2bcd8739ae039 = $9dc9dafb31137c82$var$hyphenateStyleName;


function $7a7bef077832c42c$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $7a7bef077832c42c$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $7a7bef077832c42c$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $7a7bef077832c42c$export$967a6b9924a689f7(a, b);
    return $7a7bef077832c42c$export$3e67810a3f0e9f1c(a, b);
}



const $0c39afd075ee7cc9$var$stringOrNumber = (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number
]);
// media types
const $0c39afd075ee7cc9$var$types = {
    all: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    grid: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    aural: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    braille: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    handheld: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    print: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    projection: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    screen: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    tty: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    tv: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    embossed: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool
};
// properties that match media queries
const $0c39afd075ee7cc9$var$matchers = {
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).oneOf([
        'portrait',
        'landscape'
    ]),
    scan: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).oneOf([
        'progressive',
        'interlace'
    ]),
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    deviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    height: $0c39afd075ee7cc9$var$stringOrNumber,
    deviceHeight: $0c39afd075ee7cc9$var$stringOrNumber,
    width: $0c39afd075ee7cc9$var$stringOrNumber,
    deviceWidth: $0c39afd075ee7cc9$var$stringOrNumber,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    colorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    monochrome: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).bool,
    resolution: $0c39afd075ee7cc9$var$stringOrNumber,
    type: Object.keys($0c39afd075ee7cc9$var$types)
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { type: $0c39afd075ee7cc9$var$type, ...$0c39afd075ee7cc9$var$featureMatchers } = $0c39afd075ee7cc9$var$matchers;
// media features
const $0c39afd075ee7cc9$var$features = {
    minAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    maxAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    minDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    maxDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    minHeight: $0c39afd075ee7cc9$var$stringOrNumber,
    maxHeight: $0c39afd075ee7cc9$var$stringOrNumber,
    minDeviceHeight: $0c39afd075ee7cc9$var$stringOrNumber,
    maxDeviceHeight: $0c39afd075ee7cc9$var$stringOrNumber,
    minWidth: $0c39afd075ee7cc9$var$stringOrNumber,
    maxWidth: $0c39afd075ee7cc9$var$stringOrNumber,
    minDeviceWidth: $0c39afd075ee7cc9$var$stringOrNumber,
    maxDeviceWidth: $0c39afd075ee7cc9$var$stringOrNumber,
    minColor: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    maxColor: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    minColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    maxColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    minMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    maxMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    minResolution: $0c39afd075ee7cc9$var$stringOrNumber,
    maxResolution: $0c39afd075ee7cc9$var$stringOrNumber,
    ...$0c39afd075ee7cc9$var$featureMatchers
};
const $0c39afd075ee7cc9$var$all = {
    ...$0c39afd075ee7cc9$var$types,
    ...$0c39afd075ee7cc9$var$features
};
var $0c39afd075ee7cc9$var$mq = {
    all: $0c39afd075ee7cc9$var$all,
    types: $0c39afd075ee7cc9$var$types,
    matchers: $0c39afd075ee7cc9$var$matchers,
    features: $0c39afd075ee7cc9$var$features
};
const $0c39afd075ee7cc9$var$negate = (cond)=>`not ${cond}`;
const $0c39afd075ee7cc9$var$keyVal = (k, v)=>{
    const realKey = (0, $9dc9dafb31137c82$export$2e2bcd8739ae039)(k);
    // px shorthand
    if (typeof v === 'number') v = `${v}px`;
    if (v === true) return realKey;
    if (v === false) return $0c39afd075ee7cc9$var$negate(realKey);
    return `(${realKey}: ${v})`;
};
const $0c39afd075ee7cc9$var$join = (conds)=>conds.join(' and ');
const $0c39afd075ee7cc9$export$da99e50c1f5e8cc8 = (obj)=>{
    const rules = [];
    Object.keys($0c39afd075ee7cc9$var$mq.all).forEach((k)=>{
        const v = obj[k];
        if (v != null) rules.push($0c39afd075ee7cc9$var$keyVal(k, v));
    });
    return $0c39afd075ee7cc9$var$join(rules);
};
const $0c39afd075ee7cc9$export$841858b892ce1f4c = (0, $ieaan.createContext)(undefined);
const $0c39afd075ee7cc9$var$makeQuery = (settings)=>settings.query || $0c39afd075ee7cc9$export$da99e50c1f5e8cc8(settings);
const $0c39afd075ee7cc9$var$hyphenateKeys = (obj)=>{
    if (!obj) return undefined;
    const keys = Object.keys(obj);
    return keys.reduce((result, key)=>{
        result[(0, $9dc9dafb31137c82$export$2e2bcd8739ae039)(key)] = obj[key];
        return result;
    }, {});
};
const $0c39afd075ee7cc9$var$useIsUpdate = ()=>{
    const ref = (0, $ieaan.useRef)(false);
    (0, $ieaan.useEffect)(()=>{
        ref.current = true;
    }, []);
    return ref.current;
};
const $0c39afd075ee7cc9$var$useDevice = (deviceFromProps)=>{
    const deviceFromContext = (0, $ieaan.useContext)($0c39afd075ee7cc9$export$841858b892ce1f4c);
    const getDevice = ()=>$0c39afd075ee7cc9$var$hyphenateKeys(deviceFromProps) || $0c39afd075ee7cc9$var$hyphenateKeys(deviceFromContext);
    const [device, setDevice] = (0, $ieaan.useState)(getDevice);
    (0, $ieaan.useEffect)(()=>{
        const newDevice = getDevice();
        if (!(0, $7a7bef077832c42c$export$3e67810a3f0e9f1c)(device, newDevice)) setDevice(newDevice);
    }, [
        deviceFromProps,
        deviceFromContext
    ]);
    return device;
};
const $0c39afd075ee7cc9$var$useQuery = (settings)=>{
    const getQuery = ()=>$0c39afd075ee7cc9$var$makeQuery(settings);
    const [query, setQuery] = (0, $ieaan.useState)(getQuery);
    (0, $ieaan.useEffect)(()=>{
        const newQuery = getQuery();
        if (query !== newQuery) setQuery(newQuery);
    }, [
        settings
    ]);
    return query;
};
const $0c39afd075ee7cc9$var$useMatchMedia = (query, device)=>{
    const getMatchMedia = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9a84188630d61b9c$exports)))(query, device || {}, !!device);
    const [mq, setMq] = (0, $ieaan.useState)(getMatchMedia);
    const isUpdate = $0c39afd075ee7cc9$var$useIsUpdate();
    (0, $ieaan.useEffect)(()=>{
        if (isUpdate) {
            // skip on mounting, it has already been set
            const newMq = getMatchMedia();
            setMq(newMq);
            return ()=>{
                if (newMq) newMq.dispose();
            };
        }
    }, [
        query,
        device
    ]);
    return mq;
};
const $0c39afd075ee7cc9$var$useMatches = (mediaQuery)=>{
    const [matches, setMatches] = (0, $ieaan.useState)(mediaQuery.matches);
    (0, $ieaan.useEffect)(()=>{
        const updateMatches = (ev)=>{
            setMatches(ev.matches);
        };
        mediaQuery.addListener(updateMatches);
        setMatches(mediaQuery.matches);
        return ()=>{
            mediaQuery.removeListener(updateMatches);
        };
    }, [
        mediaQuery
    ]);
    return matches;
};
const $0c39afd075ee7cc9$export$32d5543ab307c01 = (settings, device, onChange)=>{
    const deviceSettings = $0c39afd075ee7cc9$var$useDevice(device);
    const query = $0c39afd075ee7cc9$var$useQuery(settings);
    if (!query) throw new Error('Invalid or missing MediaQuery!');
    const mq = $0c39afd075ee7cc9$var$useMatchMedia(query, deviceSettings);
    const matches = $0c39afd075ee7cc9$var$useMatches(mq);
    const isUpdate = $0c39afd075ee7cc9$var$useIsUpdate();
    (0, $ieaan.useEffect)(()=>{
        if (isUpdate && onChange) onChange(matches);
    }, [
        matches
    ]);
    (0, $ieaan.useEffect)(()=>()=>{
            if (mq) mq.dispose();
        }, []);
    return matches;
};
// ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
const $0c39afd075ee7cc9$export$b745838c41029eb3 = ({ children: children, device: device, onChange: onChange, ...settings })=>{
    const matches = $0c39afd075ee7cc9$export$32d5543ab307c01(settings, device, onChange);
    if (typeof children === 'function') return children(matches);
    return matches ? children : null;
};



var $577d92a998c8b63a$exports = {};
"use strict";
Object.defineProperty($577d92a998c8b63a$exports, "__esModule", {
    value: true
});
$577d92a998c8b63a$exports["default"] = void 0;

var $577d92a998c8b63a$var$_slider = $577d92a998c8b63a$var$_interopRequireDefault((parcelRequire("dxAMn")));
function $577d92a998c8b63a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $577d92a998c8b63a$var$_default = $577d92a998c8b63a$exports["default"] = $577d92a998c8b63a$var$_slider["default"];





parcelRequire("ieaan");



parcelRequire("ieaan");





function $e7067f2e4884a13e$export$2e2bcd8739ae039({ incidents: incidents }) {
    const incidentsLast48Hours = incidents.filter((e)=>{
        if (e.status !== 'resolved') return e;
        let now = new Date();
        let earliestDate = (0, $221f579b1555e59c$export$2e2bcd8739ae039)(now, 48);
        const yes = (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.started_at), {
            start: earliestDate,
            end: new Date()
        });
        if (yes) return e;
    });
    const list = incidentsLast48Hours.map((i)=>{
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("li", {
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f33c67b2bf6fd23c$export$2e2bcd8739ae039), {
                item: i
            })
        }, i.id);
    });
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("ul", {
        className: "dnb-incidents-list",
        children: list
    });
}
$e7067f2e4884a13e$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};




function $edc4a3bb7ad0f54c$export$2e2bcd8739ae039({ incidents: incidents }) {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: "dnb-incidents-list-wrapper",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
            className: "dnb-center-content",
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                    className: "dnb-incidents-list-wrapper__header",
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h3", {
                        className: "dnb-incidents-list-wrapper__title",
                        children: t('Ongoing incidents')
                    })
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e7067f2e4884a13e$export$2e2bcd8739ae039), {
                    incidents: incidents
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $c13f7f1437f70ce1$export$2e2bcd8739ae039), {
                    iconPosition: "left"
                })
            ]
        })
    });
}
$edc4a3bb7ad0f54c$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};



parcelRequire("ieaan");

var $b83f933edb512c41$exports = {};
$b83f933edb512c41$exports = $parcel$resolve("5Q54I");





function $8f3cad532d32ccae$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: "dnb-no-incidents",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
            className: "dnb-center-content",
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("h3", {
                    children: [
                        t('Not much is happening here'),
                        "..."
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                    children: [
                        t('No incidents in the last 48 hours'),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                    className: "dnb-no-incidents__buttons",
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f9b0fd5354592e88$export$2e2bcd8739ae039), {
                            "aria-hidden": true,
                            href: "/",
                            title: t('Back to the front page'),
                            icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                            children: t('Back to the front page')
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f9b0fd5354592e88$export$2e2bcd8739ae039), {
                            href: "https://www.dnb.no/",
                            title: t('Go to dnb.no'),
                            iconPosition: "right",
                            icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039),
                            external: true,
                            children: t('Go to dnb.no')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("figure", {
                    className: "dnb-image-wrapper",
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b83f933edb512c41$exports))),
                        alt: "En tegning av en avslappet person for \xe5 illustrere at det ikke er noen aktive hendelser akkurat n\xe5."
                    })
                })
            ]
        })
    });
}










function $dbb55ad9ef8f2c61$export$2e2bcd8739ae039({ groups: groups, incidents: incidents }) {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const [incidentsCount, setIncidentsCount] = (0, $ieaan.useState)(0);
    (0, $ieaan.useEffect)(()=>{
        let now = new Date();
        let earliestDate = (0, $221f579b1555e59c$export$2e2bcd8739ae039)(now, 48);
        let relevantIncidents = incidents.filter((e)=>{
            if (e.status !== 'resolved') return e;
            else {
                const yes = (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.updated_at), {
                    start: earliestDate,
                    end: new Date()
                });
                if (yes) return e;
            }
        });
        setIncidentsCount(relevantIncidents.length);
    }, [
        incidents
    ]);
    const groupsWithIncidents = (0, $948a817567efcc0c$export$7e162e1ca82c6723)(groups, incidents);
    function CustomNextArrow(props) {
        const { className: className, onClick: onClick } = props;
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("button", {
            className: className,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "slick-button-icon slick-button-icon--next",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    "aria-hidden": true,
                    size: "auto",
                    icon: (0, $13d0d04576b49b35$export$2e2bcd8739ae039)
                })
            })
        });
    }
    function CustomPrevArrow(props) {
        const { className: className, onClick: onClick } = props;
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("button", {
            className: className,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                className: "slick-button-icon slick-button-icon--prev",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                    "aria-hidden": true,
                    size: "auto",
                    icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039)
                })
            })
        });
    }
    let smallScreenSliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)(CustomNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)(CustomPrevArrow, {})
    };
    /* Get the right number of incidents for each group last 48 hours */ const componentIncidentsCountList48h = groupsWithIncidents.map((group)=>{
        let now = new Date();
        let earliestDate = (0, $221f579b1555e59c$export$2e2bcd8739ae039)(now, 48);
        let incidents = group.incidents.filter((e)=>{
            if (e.status !== 'resolved') return e;
            else {
                const yes = (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.updated_at), {
                    start: earliestDate,
                    end: new Date()
                });
                if (yes) return e;
            }
        });
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62e11398d2c2b8cd$export$2e2bcd8739ae039), {
            topText: t(group.name),
            number: incidents.length.toString(),
            bottomText: incidents.length === 1 ? t('incident') : t('incidents')
        }, group.id);
    });
    const componentIncidentsCountListAll = groupsWithIncidents.map((group)=>{
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62e11398d2c2b8cd$export$2e2bcd8739ae039), {
            topText: t(group.name),
            number: group.incidents.length.toString(),
            bottomText: group.incidents.length === 1 ? t('incident') : t('incidents')
        }, group.id);
    });
    const isSmallScreen = (0, $0c39afd075ee7cc9$export$32d5543ab307c01)({
        query: '(max-width: 30rem)'
    });
    const renderContent = ()=>{
        if (incidentsCount > 0) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                    className: "dnb-center-content",
                    children: [
                        isSmallScreen && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "dnb-indicents-mobile-slider",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($577d92a998c8b63a$exports))), {
                                ...smallScreenSliderSettings,
                                children: componentIncidentsCountList48h
                            })
                        }),
                        !isSmallScreen && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "dnb-incidents-info-circles",
                            children: componentIncidentsCountList48h
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $edc4a3bb7ad0f54c$export$2e2bcd8739ae039), {
                    incidents: incidents
                })
            ]
        });
        else return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $8f3cad532d32ccae$export$2e2bcd8739ae039), {});
    };
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("main", {
        className: "p_incidents-page",
        role: "main",
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-center-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $f9b0fd5354592e88$export$2e2bcd8739ae039), {
                        href: "/",
                        icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                        title: t('Back to the front page'),
                        children: t('Back')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $0bc1282718aeb9f8$export$2e2bcd8739ae039), {
                        name: t('Incidents'),
                        subtitle: t('Last 48 hours'),
                        pageHeader: true,
                        icon: "calendar"
                    })
                ]
            }),
            renderContent(),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-center-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $0bc1282718aeb9f8$export$2e2bcd8739ae039), {
                        name: t('Incidents'),
                        subtitle: t('Last 90 days'),
                        pageHeader: true,
                        icon: "calendar"
                    }),
                    isSmallScreen && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "dnb-indicents-mobile-slider",
                        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($577d92a998c8b63a$exports))), {
                            ...smallScreenSliderSettings,
                            children: componentIncidentsCountListAll
                        })
                    }),
                    !isSmallScreen && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "dnb-incidents-info-circles",
                        children: componentIncidentsCountListAll
                    })
                ]
            })
        ]
    });
}
$dbb55ad9ef8f2c61$export$2e2bcd8739ae039.propTypes = {
    groups: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};



parcelRequire("ieaan");






var $ieaan = parcelRequire("ieaan");




function $afc41f9a060402a8$export$70823084e2deb1ea(date, amount, options) {
    return (0, $6cc55444142e86f5$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$afc41f9a060402a8$export$2e2bcd8739ae039 = $afc41f9a060402a8$export$70823084e2deb1ea;








function $b66aecc48eb0b618$export$2e2bcd8739ae039({ incidents: incidents = [], filterType: filterType = 'ongoing', timeRange: timeRange = 48, title: title, className: className = '' }) {
    const { t: t, i18n: i18n } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const [filteredIncidents, setFilteredIncidents] = (0, $ieaan.useState)([]);
    // Helper function to handle bilingual text (Norwegian||English)
    const findLanguage = (text)=>{
        if (!text) return '';
        const splitter = text.indexOf('||');
        if (splitter !== -1) {
            // If the detected language is norwegian we select the left side of the string
            if (i18n.language === 'nb-NO' || i18n.language === 'no' || i18n.language === 'nb') return text.substring(0, splitter);
            else return text.substring(splitter + 2);
        }
        return text;
    };
    // Helper function to get status text - only four options
    const getStatusText = (status)=>{
        switch(status){
            case 'operational':
            case 'none':
                return t('Operational');
            case 'minor_outage':
            case 'partial_outage':
            case 'minor':
                return t('Partial outage');
            case 'major_outage':
            case 'critical':
            case 'major':
                return t('Major outage');
            case 'degraded_performance':
                return t('Degraded performance');
            default:
                return status;
        }
    };
    (0, $ieaan.useEffect)(()=>{
        if (!incidents || !Array.isArray(incidents)) {
            setFilteredIncidents([]);
            return;
        }
        let filtered = [];
        switch(filterType){
            case 'ongoing':
                // Only unresolved incidents
                filtered = incidents.filter((e)=>e.status !== 'resolved');
                break;
            case 'historic':
                // Only resolved incidents
                filtered = incidents.filter((e)=>e.status === 'resolved');
                break;
            case 'hours':
                // Incidents within the last X hours
                {
                    let now = new Date();
                    let earliestDate = (0, $221f579b1555e59c$export$2e2bcd8739ae039)(now, timeRange);
                    filtered = incidents.filter((e)=>{
                        if (e.status !== 'resolved') return true;
                        else return (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.updated_at), {
                            start: earliestDate,
                            end: now
                        });
                    });
                }
                break;
            case 'days':
                // Incidents within the last X days
                {
                    let now = new Date();
                    let earliestDate = (0, $afc41f9a060402a8$export$2e2bcd8739ae039)(now, timeRange);
                    filtered = incidents.filter((e)=>{
                        if (e.status !== 'resolved') return true;
                        else return (0, $5a66ca5ff1e7abcd$export$2e2bcd8739ae039)(new Date(e.updated_at), {
                            start: earliestDate,
                            end: now
                        });
                    });
                }
                break;
            case 'all':
                // All incidents
                filtered = incidents;
                break;
            default:
                filtered = incidents.filter((e)=>e.status !== 'resolved');
        }
        setFilteredIncidents(filtered);
    }, [
        incidents,
        filterType,
        timeRange
    ]);
    const renderIncidentCard = (incident)=>{
        try {
            const startedAt = incident.started_at ? (0, $5e113df2845e4dc9$export$2e2bcd8739ae039)(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm') : 'N/A';
            const latestUpdate = incident.incident_updates && incident.incident_updates.length > 0 ? incident.incident_updates[0] : null;
            // Get affected components
            const affectedComponents = incident.components && incident.components.length > 0 ? incident.components.map((c)=>t(c.name || c)).join(', ') : '';
            const impactStatus = incident.impact || 'none';
            return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
                className: "incident-viewer__card",
                outline: "none",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                    className: "incident-viewer__card-content",
                    children: [
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "incident-viewer__card-header",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                                className: "incident-viewer__card-start",
                                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                                    className: "incident-viewer__label",
                                    children: [
                                        t('Incident started'),
                                        ": ",
                                        startedAt
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "incident-viewer__right-section",
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                                className: `incident-viewer__status-container incident-viewer__status-container--${impactStatus}`,
                                children: [
                                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                        className: `incident-viewer__icon-circle incident-viewer__icon-circle--${impactStatus}`,
                                        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $18e1fb7032604f9e$export$2e2bcd8739ae039), {
                                            icon: (0, $948a817567efcc0c$export$b40c13a3e6d581cb)(impactStatus),
                                            size: "16"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("span", {
                                        className: `incident-viewer__status-text`,
                                        children: getStatusText(impactStatus)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h3", {
                            className: "incident-viewer__title",
                            children: incident.name ? findLanguage(incident.name) : 'Incident'
                        }),
                        affectedComponents && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: `incident-viewer__affected incident-viewer__affected--${impactStatus}`,
                            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("span", {
                                className: "incident-viewer__affected-label",
                                children: [
                                    t('Incident affects'),
                                    ": ",
                                    affectedComponents
                                ]
                            })
                        }),
                        latestUpdate && latestUpdate.body && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                            className: "incident-viewer__description",
                            children: findLanguage(latestUpdate.body)
                        }),
                        incident.incident_updates && incident.incident_updates.length > 1 && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                            className: "incident-viewer__guidance",
                            children: [
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("strong", {
                                    children: [
                                        t('Customer Guidance'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("p", {
                                    children: t("If you're unable to log in, please use web banking or contact support at 800 123 456. We apologize for the inconvenience and appreciate your patience.")
                                })
                            ]
                        })
                    ]
                })
            }, incident.id);
        } catch (error) {
            console.error('Error rendering incident card:', error, incident);
            return null;
        }
    };
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
        className: `incident-viewer ${className}`,
        children: [
            title && /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h2", {
                className: "incident-viewer__section-title",
                children: title
            }),
            filteredIncidents.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "incident-viewer__list",
                children: filteredIncidents.map((incident)=>renderIncidentCard(incident))
            }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $e5d3166d137618a2$export$2e2bcd8739ae039), {
                className: "incident-viewer__empty-card",
                outline: "none",
                backgroundColor: "pistachio",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                    className: "incident-viewer__empty-content",
                    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                        className: "incident-viewer__empty-title",
                        children: filterType === 'ongoing' ? t('All systems are currently operating normally.') : t('No resolved incidents in the archive.')
                    })
                })
            })
        ]
    });
}
$b66aecc48eb0b618$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array,
    filterType: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).oneOf([
        'ongoing',
        'historic',
        'hours',
        'days',
        'all'
    ]),
    timeRange: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).string
};





function $12faf44e51eb8812$export$2e2bcd8739ae039({ incidents: incidents = [] }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const navigate = (0, $ee61663bcaa3deaf$export$9770f232ac06a008)();
    const location = (0, $ee61663bcaa3deaf$export$45d76561a5302f2b)();
    // Determine if we're on the business tab or personal tab
    const isBusiness = location.pathname.startsWith('/business');
    const homeRoute = isBusiness ? '/business' : '/';
    const archiveRoute = isBusiness ? '/business/archive' : '/archive';
    if (!incidents) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
        className: "p_incidents-page",
        role: "main",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("p", {
                children: "Loading incidents..."
            })
        })
    });
    try {
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-center-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                        className: "incidents-header",
                        children: [
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                                className: "back-button",
                                text: t('Back'),
                                variant: "secondary",
                                size: "medium",
                                icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                                icon_position: "left",
                                onClick: ()=>navigate(homeRoute)
                            }),
                            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                                className: "archive-button",
                                text: t('Archive'),
                                variant: "secondary",
                                size: "medium",
                                onClick: ()=>navigate(archiveRoute)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                        className: "incidents-page-title",
                        children: t('Ongoing incidents')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $b66aecc48eb0b618$export$2e2bcd8739ae039), {
                        incidents: incidents,
                        filterType: "ongoing"
                    })
                ]
            })
        });
    } catch (error) {
        console.error('OngoingIncidentPage render error:', error);
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("p", {
                    children: [
                        "Error loading incidents page: ",
                        error.message
                    ]
                })
            })
        });
    }
}
$12faf44e51eb8812$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};



parcelRequire("ieaan");







function $d41e63f8456ed3d6$export$2e2bcd8739ae039({ incidents: incidents = [] }) {
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const navigate = (0, $ee61663bcaa3deaf$export$9770f232ac06a008)();
    const location = (0, $ee61663bcaa3deaf$export$45d76561a5302f2b)();
    // Determine if we're on the business tab or personal tab
    const isBusiness = location.pathname.startsWith('/business');
    const incidentsRoute = isBusiness ? '/business/incidents' : '/incidents';
    // Add a check to ensure incidents is an array
    if (!incidents) return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
        className: "p_incidents-page",
        role: "main",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
            className: "dnb-center-content",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("p", {
                children: "Loading archived incidents..."
            })
        })
    });
    try {
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                className: "dnb-center-content",
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                        className: "incidents-header",
                        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $62da03d0a8a66ef6$export$2e2bcd8739ae039), {
                            className: "back-button",
                            text: t('Back'),
                            variant: "secondary",
                            size: "medium",
                            icon: (0, $caf45c133b27358d$export$2e2bcd8739ae039),
                            icon_position: "left",
                            onClick: ()=>navigate(incidentsRoute)
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("h1", {
                        className: "incidents-page-title",
                        children: t('Archive')
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $b66aecc48eb0b618$export$2e2bcd8739ae039), {
                        incidents: incidents,
                        filterType: "historic"
                    })
                ]
            })
        });
    } catch (error) {
        console.error('ArchivePage render error:', error);
        return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("main", {
            className: "p_incidents-page",
            role: "main",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
                className: "dnb-center-content",
                children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("p", {
                    children: [
                        "Error loading archive page: ",
                        error.message
                    ]
                })
            })
        });
    }
}
$d41e63f8456ed3d6$export$2e2bcd8739ae039.propTypes = {
    incidents: (0, (/*@__PURE__*/$parcel$interopDefault($9bb40a131bb21204$exports))).array
};





var $b00a38d86ff97cb9$exports = {};
$b00a38d86ff97cb9$exports = JSON.parse("{\"page\":\"n3pkrn6d6qtk\"}");


//const config = require('./dev.json')
const $caf4cd8c41e1fa55$var$statusPageConfigPersonal = {
    //Preprod page: 'cr0lphtyqjz0', //Production page: 'n3pkrn6d6qtk'
    page: $b00a38d86ff97cb9$exports.page,
    getIncidents: true,
    incidentsType: '',
    getComponents: true,
    getScheduledMaintenances: true,
    scheduledMaintenancesType: {
        in_progress: true,
        scheduled: true,
        completed: false
    },
    updateInterval: 30000,
    includedComponents: {
        //#PROD
        //Innlogging
        l2lgzys2gz88: 'Innlogging',
        tnw56bcc739s: 'BankID',
        '1dm46zl9zk0z': "BankID p\xe5 mobil for Telenor",
        '8b23mx7mnkcv': "BankID p\xe5 mobil for Telia",
        xyynf61zkx6m: "BankID p\xe5 mobil for Ice.net",
        hfq6c7k81w89: 'BankID (OIDC)',
        '1pfztystjrzk': 'BankID App',
        l3t64spqnfzn: 'DigiPass',
        cttbsnk1nnk4: 'GO3Phonecode',
        //Nettbank
        rtdlds1sbwl7: 'Nettbank',
        gtsl57dxb26f: 'Kontoer/balanse Nett',
        y6ng73k0nqp8: "Overf\xf8ringer Nett",
        przh27kqfg7w: 'Betalinger Nett',
        //Mobilbank
        '4klj7trfzvp5': 'Mobilbank',
        '4yvx39ckc5jy': 'Betalinger Mobil',
        qkxyg79t7d7g: 'Kontoer/Balanse Mobil',
        txjq2s9926sw: "Overf\xf8ringer Mobil",
        ypxdcjjrsvcr: 'Regninger Mobil',
        //Kort
        c3cvf4lsnfzg: 'Minibanker, kort og betalingsterminaler',
        '0gtsdyvskqng': 'Kort',
        //Spare
        '6dldw262pd9z': 'Spare',
        '9mdp0dscmp7z': 'Pensjonskonto Flex',
        //Andre tjenester
        ldbl8vk30rb6: 'Andre tjenester privat',
        '1n9zpt1sh5dh': 'Andre tjenester privat',
        // Sbanken Mobilbank
        '1zl3jrflgc9t': 'Sbanken Mobilbank',
        'ck6y3x1fmz7q': 'Betalinger Mobil',
        'jdxr3vjj5d6b': 'Kontoer/Balanse Mobil',
        'p5151pwllfd3': "Overf\xf8ringer Mobil",
        '9n1z2j6zpfw5': 'Regninger Mobil',
        //#Test / Dev
        // Nettbank
        vcn6bh1rx3yg: 'Corporate internet banking',
        wl494vvmvckp: 'Nettbank',
        vtkxbj52qf6w: "Overf\xf8ringer Nett",
        ndlfykymrw0v: 'Kontoer/balanse Nett',
        // Kort
        hdyvd0v0w8gh: 'Minibankenr',
        '603y3yfkdhf3': 'Kort',
        //Mobilbank
        wcfk3rn3hpdl: 'Mobilbank',
        vjbyt2zktkrm: 'Betalinger Mobil',
        wds7kg6y5prc: 'Kontoer/Balanse Mobil',
        gyg6gyl54cnv: "Overf\xf8ring Mobil",
        //Sbanken Mobilbank
        'z08v9zqhc37g': 'Sbanken Mobilbank',
        'hjrc9m2drl1t': 'Betalinger Mobil',
        'fql7qp08r937': 'Kontoer/Balanse Mobil',
        // Innlogging
        // Innlogging
        z2fqtbpsh52z: 'Innlogging',
        qsytltngrx8r: 'BankID mob TN',
        '2rt3lmgbsy7v': 'BankID mob TL',
        cqd3nnsblbyh: 'BankID mob ICE',
        md8v5vg7xc9k: 'BankID OIDC',
        stv8gcy7fxxh: 'BankID App',
        kv3m47y6d6f2: 'BankID',
        //Andre tjenester privat
        '49g1fjyryvkb': 'Andre tjenester privat',
        gkcsc9yk7grw: 'Andre tjenester privat'
    }
};
const $caf4cd8c41e1fa55$var$statusPageConfigBusiness = {
    page: $b00a38d86ff97cb9$exports.page,
    getIncidents: true,
    incidentsType: '',
    getComponents: true,
    getScheduledMaintenances: true,
    scheduledMaintenancesType: {
        in_progress: true,
        scheduled: true,
        completed: false
    },
    updateInterval: 30000,
    includedComponents: {
        // #PROD#
        // DNB Bedrift (app)
        'h14z7m281186': 'DNB Bedrift (app)',
        '11b0x4pr6xb2': 'Payments',
        //Corporate internet banking
        xlnqvn1tr7zb: 'Corporate Internet banking',
        '8y74k6rbjrqm': 'Transactions',
        l465c623dflm: 'Payments Overview',
        '5bx84bcgntst': 'Payments',
        z9w32g0yr69f: 'Account Overview',
        'tn52rl4sqb2x': 'International Payments',
        //Innlogging
        l2lgzys2gz88: 'Innlogging',
        tnw56bcc739s: 'BankID',
        '1dm46zl9zk0z': "BankID p\xe5 mobil for Telenor",
        '8b23mx7mnkcv': "BankID p\xe5 mobil for Telia",
        xyynf61zkx6m: "BankID p\xe5 mobil for Ice.net",
        hfq6c7k81w89: 'BankID (OIDC)',
        l3t64spqnfzn: 'DigiPass',
        cttbsnk1nnk4: 'GO3Phonecode',
        '1pfztystjrzk': 'BankID App',
        //Andre tjenester bedrift
        'xdhm469t57s2': 'Andre tjenester bedrift',
        'x4dfh4vtjt2p': 'Andre tjenester bedrift',
        //#Test / Dev
        // Innlogging
        z2fqtbpsh52z: 'Innlogging',
        qsytltngrx8r: 'BankID mob TN',
        '2rt3lmgbsy7v': 'BankID mob TL',
        cqd3nnsblbyh: 'BankID mob ICE',
        md8v5vg7xc9k: 'BankID OIDC',
        stv8gcy7fxxh: 'BankID App',
        kv3m47y6d6f2: 'BankID',
        // Corporate internet banking
        vcn6bh1rx3yg: 'Corporate internet banking',
        '7vg5p63crcvg': 'International Payments',
        // Andre tjenester bedrift
        jtzztlxn7p9y: 'Andre tjenester bedrift',
        mj2lgfg7yn0d: 'Andre tjenester bedrift'
    }
};
function $caf4cd8c41e1fa55$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $60739c7e3f826d8d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $ee61663bcaa3deaf$export$9ba4e89fdfa1fc54), {
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $c851a5131cd8667e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)($caf4cd8c41e1fa55$var$Content, {})
                ]
            }),
            /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $41b6d7e12730d823$export$2e2bcd8739ae039), {})
        ]
    });
}
const $caf4cd8c41e1fa55$var$Content = ()=>{
    const navigate = (0, $ee61663bcaa3deaf$export$9770f232ac06a008)();
    const location = (0, $ee61663bcaa3deaf$export$45d76561a5302f2b)();
    const { t: t } = (0, $0a2dcaaf70b12078$export$9fc83ad70ead8663)();
    const personal = (0, $4cb3579337f6afdd$export$2e2bcd8739ae039)($caf4cd8c41e1fa55$var$statusPageConfigPersonal);
    const business = (0, $4cb3579337f6afdd$export$2e2bcd8739ae039)($caf4cd8c41e1fa55$var$statusPageConfigBusiness);
    return /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)("div", {
        className: "dnb-center-content",
        children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $eea10711b390990c$export$2e2bcd8739ae039), {
            data: [
                {
                    title: t('Personal'),
                    key: '/'
                },
                {
                    title: t('Business'),
                    key: '/business'
                }
            ],
            tabs_style: "white",
            selected_key: (0, $948a817567efcc0c$export$dea2b423f9e4a3c5)(location.pathname),
            on_change: ({ key: key })=>navigate(key),
            align: "left",
            children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)((0, $ee61663bcaa3deaf$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee61663bcaa3deaf$export$e7b0ac011bb776c6), {
                        path: "/incidents",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $12faf44e51eb8812$export$2e2bcd8739ae039), {
                            incidents: personal.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee61663bcaa3deaf$export$e7b0ac011bb776c6), {
                        path: "/archive",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $d41e63f8456ed3d6$export$2e2bcd8739ae039), {
                            incidents: personal.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee61663bcaa3deaf$export$e7b0ac011bb776c6), {
                        path: "/business/incidents",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $12faf44e51eb8812$export$2e2bcd8739ae039), {
                            incidents: business.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee61663bcaa3deaf$export$e7b0ac011bb776c6), {
                        path: "/business/archive",
                        element: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $d41e63f8456ed3d6$export$2e2bcd8739ae039), {
                            incidents: business.incidents
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee61663bcaa3deaf$export$e7b0ac011bb776c6), {
                        path: "/history",
                        element: personal.groups.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $7b4fbae4d9f02598$export$2e2bcd8739ae039), {
                            groups: personal.groups,
                            incidents: personal.incidents
                        }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsxs)("div", {
                            children: [
                                t('Loading'),
                                "..."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee61663bcaa3deaf$export$e7b0ac011bb776c6), {
                        path: "/business",
                        element: business.groups.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $05bb2c4ee1fde64f$export$2e2bcd8739ae039), {
                            groups: business.groups,
                            incidents: business.incidents,
                            maintenances: business.maintenances,
                            updateTimestamp: business.updateTimestamp,
                            includedComponents: $caf4cd8c41e1fa55$var$statusPageConfigBusiness.includedComponents
                        }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $7ec8b67fa7687b7e$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $ee61663bcaa3deaf$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: personal.groups.length > 0 ? /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $05bb2c4ee1fde64f$export$2e2bcd8739ae039), {
                            groups: personal.groups,
                            incidents: personal.incidents,
                            maintenances: personal.maintenances,
                            updateTimestamp: personal.updateTimestamp,
                            includedComponents: $caf4cd8c41e1fa55$var$statusPageConfigPersonal.includedComponents
                        }) : /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $7ec8b67fa7687b7e$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
};


const $156c1d4c5addba0b$var$isString = (obj)=>typeof obj === 'string';
const $156c1d4c5addba0b$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $156c1d4c5addba0b$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $156c1d4c5addba0b$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $156c1d4c5addba0b$var$lastOfPathSeparatorRegExp = /###/g;
const $156c1d4c5addba0b$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($156c1d4c5addba0b$var$lastOfPathSeparatorRegExp, '.') : key;
const $156c1d4c5addba0b$var$canNotTraverseDeeper = (object)=>!object || $156c1d4c5addba0b$var$isString(object);
const $156c1d4c5addba0b$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$156c1d4c5addba0b$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($156c1d4c5addba0b$var$canNotTraverseDeeper(object)) return {};
        const key = $156c1d4c5addba0b$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($156c1d4c5addba0b$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $156c1d4c5addba0b$var$cleanKey(stack[stackIndex])
    };
};
const $156c1d4c5addba0b$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $156c1d4c5addba0b$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $156c1d4c5addba0b$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $156c1d4c5addba0b$var$getLastOfPath(object, p, Object);
        if ((last === null || last === void 0 ? void 0 : last.obj) && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $156c1d4c5addba0b$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $156c1d4c5addba0b$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $156c1d4c5addba0b$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $156c1d4c5addba0b$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $156c1d4c5addba0b$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $156c1d4c5addba0b$var$getPath(data, key);
    if (value !== undefined) return value;
    return $156c1d4c5addba0b$var$getPath(defaultData, key);
};
const $156c1d4c5addba0b$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($156c1d4c5addba0b$var$isString(target[prop]) || target[prop] instanceof String || $156c1d4c5addba0b$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $156c1d4c5addba0b$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $156c1d4c5addba0b$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $156c1d4c5addba0b$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $156c1d4c5addba0b$var$escape = (data)=>{
    if ($156c1d4c5addba0b$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$156c1d4c5addba0b$var$_entityMap[s]);
    return data;
};
class $156c1d4c5addba0b$var$RegExpCache {
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
}
const $156c1d4c5addba0b$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $156c1d4c5addba0b$var$looksLikeObjectPathRegExpCache = new $156c1d4c5addba0b$var$RegExpCache(20);
const $156c1d4c5addba0b$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $156c1d4c5addba0b$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $156c1d4c5addba0b$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $156c1d4c5addba0b$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $156c1d4c5addba0b$var$getCleanedCode = (code)=>code === null || code === void 0 ? void 0 : code.replace('_', '-');
const $156c1d4c5addba0b$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        var _console_type_apply, _console_type, _console;
        (_console = console) === null || _console === void 0 ? void 0 : (_console_type = _console[type]) === null || _console_type === void 0 ? void 0 : (_console_type_apply = _console_type.apply) === null || _console_type_apply === void 0 ? void 0 : _console_type_apply.call(_console_type, console, args);
    }
};
class $156c1d4c5addba0b$var$Logger {
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $156c1d4c5addba0b$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($156c1d4c5addba0b$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $156c1d4c5addba0b$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $156c1d4c5addba0b$var$Logger(this.logger, options);
    }
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
}
var $156c1d4c5addba0b$var$baseLogger = new $156c1d4c5addba0b$var$Logger();
class $156c1d4c5addba0b$var$EventEmitter {
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
    constructor(){
        this.observers = {};
    }
}
class $156c1d4c5addba0b$var$ResourceStore extends $156c1d4c5addba0b$var$EventEmitter {
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        var _this_data_lng, _this_data;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($156c1d4c5addba0b$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $156c1d4c5addba0b$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$156c1d4c5addba0b$var$isString(key)) return result;
        return $156c1d4c5addba0b$var$deepFind((_this_data = this.data) === null || _this_data === void 0 ? void 0 : (_this_data_lng = _this_data[lng]) === null || _this_data_lng === void 0 ? void 0 : _this_data_lng[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $156c1d4c5addba0b$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($156c1d4c5addba0b$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $156c1d4c5addba0b$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $156c1d4c5addba0b$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $156c1d4c5addba0b$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
}
var $156c1d4c5addba0b$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            var _this_processors_processor;
            var _this_processors_processor_process;
            value = (_this_processors_processor_process = (_this_processors_processor = this.processors[processor]) === null || _this_processors_processor === void 0 ? void 0 : _this_processors_processor.process(value, key, options, translator)) !== null && _this_processors_processor_process !== void 0 ? _this_processors_processor_process : value;
        });
        return value;
    }
};
const $156c1d4c5addba0b$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $156c1d4c5addba0b$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        var _proxy_revoke;
        proxy === null || proxy === void 0 ? void 0 : (_proxy_revoke = proxy.revoke) === null || _proxy_revoke === void 0 ? void 0 : _proxy_revoke.call(proxy);
        if (key === $156c1d4c5addba0b$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$156c1d4c5addba0b$var$PATH_KEY]: path } = selector($156c1d4c5addba0b$var$createProxy());
    var _opts_keySeparator;
    return path.join((_opts_keySeparator = opts === null || opts === void 0 ? void 0 : opts.keySeparator) !== null && _opts_keySeparator !== void 0 ? _opts_keySeparator : '.');
}
const $156c1d4c5addba0b$var$checkedLoadedFor = {};
const $156c1d4c5addba0b$var$shouldHandleAsObject = (res)=>!$156c1d4c5addba0b$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $156c1d4c5addba0b$var$Translator extends $156c1d4c5addba0b$var$EventEmitter {
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        return (resolved === null || resolved === void 0 ? void 0 : resolved.res) !== undefined;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$156c1d4c5addba0b$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $156c1d4c5addba0b$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $156c1d4c5addba0b$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if ((lng === null || lng === void 0 ? void 0 : lng.toLowerCase()) === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved === null || resolved === void 0 ? void 0 : resolved.res;
        const resUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.usedKey) || key;
        const resExactUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.exactUsedKey) || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$156c1d4c5addba0b$var$isString(opt.count);
        const hasDefaultValue = $156c1d4c5addba0b$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $156c1d4c5addba0b$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($156c1d4c5addba0b$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $156c1d4c5addba0b$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $156c1d4c5addba0b$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    var _this_backendConnector;
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if ((_this_backendConnector = this.backendConnector) === null || _this_backendConnector === void 0 ? void 0 : _this_backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        var _this_i18nFormat;
        if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            var _opt_interpolation;
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $156c1d4c5addba0b$var$isString(res) && ((opt === null || opt === void 0 ? void 0 : (_opt_interpolation = opt.interpolation) === null || _opt_interpolation === void 0 ? void 0 : _opt_interpolation.skipOnVariables) !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$156c1d4c5addba0b$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if ((lastKey === null || lastKey === void 0 ? void 0 : lastKey[0]) === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $156c1d4c5addba0b$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && (postProcessorNames === null || postProcessorNames === void 0 ? void 0 : postProcessorNames.length) && opt.applyPostProcessor !== false) res = $156c1d4c5addba0b$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($156c1d4c5addba0b$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$156c1d4c5addba0b$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($156c1d4c5addba0b$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                var _this_utils, _this_utils1;
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$156c1d4c5addba0b$var$checkedLoadedFor[`${codes[0]}-${ns}`] && ((_this_utils = this.utils) === null || _this_utils === void 0 ? void 0 : _this_utils.hasLoadedNamespace) && !((_this_utils1 = this.utils) === null || _this_utils1 === void 0 ? void 0 : _this_utils1.hasLoadedNamespace(usedNS))) {
                    $156c1d4c5addba0b$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    var _this_i18nFormat;
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        var _this_i18nFormat;
        if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$156c1d4c5addba0b$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
    constructor(services, options = {}){
        super();
        $156c1d4c5addba0b$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('translator');
    }
}
class $156c1d4c5addba0b$var$LanguageUtil {
    getScriptPartFromCode(code) {
        code = $156c1d4c5addba0b$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $156c1d4c5addba0b$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($156c1d4c5addba0b$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($156c1d4c5addba0b$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($156c1d4c5addba0b$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($156c1d4c5addba0b$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('languageUtils');
    }
}
const $156c1d4c5addba0b$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $156c1d4c5addba0b$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $156c1d4c5addba0b$var$PluralResolver {
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $156c1d4c5addba0b$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $156c1d4c5addba0b$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $156c1d4c5addba0b$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return (rule === null || rule === void 0 ? void 0 : rule.resolvedOptions().pluralCategories.length) > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$156c1d4c5addba0b$var$suffixesOrder[pluralCategory1] - $156c1d4c5addba0b$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
}
const $156c1d4c5addba0b$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $156c1d4c5addba0b$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $156c1d4c5addba0b$var$isString(key)) {
        path = $156c1d4c5addba0b$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $156c1d4c5addba0b$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $156c1d4c5addba0b$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $156c1d4c5addba0b$var$Interpolator {
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $156c1d4c5addba0b$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $156c1d4c5addba0b$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $156c1d4c5addba0b$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $156c1d4c5addba0b$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $156c1d4c5addba0b$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $156c1d4c5addba0b$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $156c1d4c5addba0b$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if ((existingRegExp === null || existingRegExp === void 0 ? void 0 : existingRegExp.source) === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        var _options_interpolation;
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $156c1d4c5addba0b$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($156c1d4c5addba0b$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = (options === null || options === void 0 ? void 0 : options.missingInterpolationHandler) || this.options.missingInterpolationHandler;
        const skipOnVariables = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.skipOnVariables) !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$156c1d4c5addba0b$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $156c1d4c5addba0b$var$regexSafe(this.escape(val)) : $156c1d4c5addba0b$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $156c1d4c5addba0b$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$156c1d4c5addba0b$var$isString(value) && !this.useRawValueToEscape) value = $156c1d4c5addba0b$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            var _matchedSingleQuotes_length;
            if (((_matchedSingleQuotes_length = matchedSingleQuotes === null || matchedSingleQuotes === void 0 ? void 0 : matchedSingleQuotes.length) !== null && _matchedSingleQuotes_length !== void 0 ? _matchedSingleQuotes_length : 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$156c1d4c5addba0b$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$156c1d4c5addba0b$var$isString(value)) return value;
            if (!$156c1d4c5addba0b$var$isString(value)) value = $156c1d4c5addba0b$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
    constructor(options = {}){
        var _options_interpolation;
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.format) || ((value)=>value);
        this.init(options);
    }
}
const $156c1d4c5addba0b$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $156c1d4c5addba0b$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($156c1d4c5addba0b$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $156c1d4c5addba0b$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($156c1d4c5addba0b$var$getCleanedCode(l), o)(v);
class $156c1d4c5addba0b$var$Formatter {
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $156c1d4c5addba0b$var$createCachedFormatter : $156c1d4c5addba0b$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $156c1d4c5addba0b$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $156c1d4c5addba0b$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    var _options_formatParams;
                    const valOptions = (options === null || options === void 0 ? void 0 : (_options_formatParams = options.formatParams) === null || _options_formatParams === void 0 ? void 0 : _options_formatParams[options.interpolationkey]) || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
    constructor(options = {}){
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
}
const $156c1d4c5addba0b$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $156c1d4c5addba0b$var$Connector extends $156c1d4c5addba0b$var$EventEmitter {
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $156c1d4c5addba0b$var$pushPath(q.loaded, [
                lng
            ], ns);
            $156c1d4c5addba0b$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($156c1d4c5addba0b$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($156c1d4c5addba0b$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        var _this_services_utils, _this_services, _this_services_utils1, _this_services1, _this_backend;
        if (((_this_services = this.services) === null || _this_services === void 0 ? void 0 : (_this_services_utils = _this_services.utils) === null || _this_services_utils === void 0 ? void 0 : _this_services_utils.hasLoadedNamespace) && !((_this_services1 = this.services) === null || _this_services1 === void 0 ? void 0 : (_this_services_utils1 = _this_services1.utils) === null || _this_services_utils1 === void 0 ? void 0 : _this_services_utils1.hasLoadedNamespace(namespace))) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if ((_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : _this_backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
    constructor(backend, store, services, options = {}){
        var _this_backend_init, _this_backend;
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $156c1d4c5addba0b$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        (_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : (_this_backend_init = _this_backend.init) === null || _this_backend_init === void 0 ? void 0 : _this_backend_init.call(_this_backend, services, options.backend, options);
    }
}
const $156c1d4c5addba0b$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($156c1d4c5addba0b$var$isString(args[1])) ret.defaultValue = args[1];
            if ($156c1d4c5addba0b$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $156c1d4c5addba0b$var$transformOptions = (options)=>{
    var _options_supportedLngs_indexOf, _options_supportedLngs;
    if ($156c1d4c5addba0b$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($156c1d4c5addba0b$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($156c1d4c5addba0b$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (((_options_supportedLngs = options.supportedLngs) === null || _options_supportedLngs === void 0 ? void 0 : (_options_supportedLngs_indexOf = _options_supportedLngs.indexOf) === null || _options_supportedLngs_indexOf === void 0 ? void 0 : _options_supportedLngs_indexOf.call(_options_supportedLngs, 'cimode')) < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $156c1d4c5addba0b$var$noop = ()=>{};
const $156c1d4c5addba0b$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $156c1d4c5addba0b$var$I18n extends $156c1d4c5addba0b$var$EventEmitter {
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($156c1d4c5addba0b$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $156c1d4c5addba0b$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$156c1d4c5addba0b$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $156c1d4c5addba0b$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $156c1d4c5addba0b$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $156c1d4c5addba0b$var$Formatter;
            const lu = new $156c1d4c5addba0b$var$LanguageUtil(this.options);
            this.store = new $156c1d4c5addba0b$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $156c1d4c5addba0b$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $156c1d4c5addba0b$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $156c1d4c5addba0b$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $156c1d4c5addba0b$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $156c1d4c5addba0b$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $156c1d4c5addba0b$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $156c1d4c5addba0b$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $156c1d4c5addba0b$var$noop) {
        let usedCallback = callback;
        const usedLng = $156c1d4c5addba0b$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            var _this_options_preload_forEach, _this_options_preload;
            if ((usedLng === null || usedLng === void 0 ? void 0 : usedLng.toLowerCase()) === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            (_this_options_preload = this.options.preload) === null || _this_options_preload === void 0 ? void 0 : (_this_options_preload_forEach = _this_options_preload.forEach) === null || _this_options_preload_forEach === void 0 ? void 0 : _this_options_preload_forEach.call(_this_options_preload, (l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $156c1d4c5addba0b$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $156c1d4c5addba0b$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $156c1d4c5addba0b$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $156c1d4c5addba0b$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $156c1d4c5addba0b$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($156c1d4c5addba0b$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                var _this_services_languageDetector_cacheUserLanguage, _this_services_languageDetector;
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                (_this_services_languageDetector = this.services.languageDetector) === null || _this_services_languageDetector === void 0 ? void 0 : (_this_services_languageDetector_cacheUserLanguage = _this_services_languageDetector.cacheUserLanguage) === null || _this_services_languageDetector_cacheUserLanguage === void 0 ? void 0 : _this_services_languageDetector_cacheUserLanguage.call(_this_services_languageDetector, l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(k, {
                    ...this.options,
                    ...opts
                });
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $156c1d4c5addba0b$export$ec2cccc18ab4c2ae(key, {
                    ...this.options,
                    ...opts
                });
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($156c1d4c5addba0b$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        var _this_translator;
        return (_this_translator = this.translator) === null || _this_translator === void 0 ? void 0 : _this_translator.translate(...args);
    }
    exists(...args) {
        var _this_translator;
        return (_this_translator = this.translator) === null || _this_translator === void 0 ? void 0 : _this_translator.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $156c1d4c5addba0b$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($156c1d4c5addba0b$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $156c1d4c5addba0b$var$defer();
        if ($156c1d4c5addba0b$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        var _this_languages, _this_services;
        if (!lng) lng = this.resolvedLanguage || (((_this_languages = this.languages) === null || _this_languages === void 0 ? void 0 : _this_languages.length) > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = ((_this_services = this.services) === null || _this_services === void 0 ? void 0 : _this_services.languageUtils) || new $156c1d4c5addba0b$var$LanguageUtil($156c1d4c5addba0b$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        return new $156c1d4c5addba0b$var$I18n(options, callback);
    }
    cloneInstance(options = {}, callback = $156c1d4c5addba0b$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $156c1d4c5addba0b$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $156c1d4c5addba0b$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $156c1d4c5addba0b$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
    constructor(options = {}, callback){
        super();
        this.options = $156c1d4c5addba0b$var$transformOptions(options);
        this.services = {};
        this.logger = $156c1d4c5addba0b$var$baseLogger;
        this.modules = {
            external: []
        };
        $156c1d4c5addba0b$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
}
const $156c1d4c5addba0b$export$2e2bcd8739ae039 = $156c1d4c5addba0b$var$I18n.createInstance();
$156c1d4c5addba0b$export$2e2bcd8739ae039.createInstance = $156c1d4c5addba0b$var$I18n.createInstance;
const $156c1d4c5addba0b$export$99152e8d49ca4e7d = $156c1d4c5addba0b$export$2e2bcd8739ae039.createInstance;
const $156c1d4c5addba0b$export$147ec2801e896265 = $156c1d4c5addba0b$export$2e2bcd8739ae039.dir;
const $156c1d4c5addba0b$export$2cd8252107eb640b = $156c1d4c5addba0b$export$2e2bcd8739ae039.init;
const $156c1d4c5addba0b$export$d3d08d944062d7e = $156c1d4c5addba0b$export$2e2bcd8739ae039.loadResources;
const $156c1d4c5addba0b$export$a5d9bf5d83fcab09 = $156c1d4c5addba0b$export$2e2bcd8739ae039.reloadResources;
const $156c1d4c5addba0b$export$1f96ae73734a86cc = $156c1d4c5addba0b$export$2e2bcd8739ae039.use;
const $156c1d4c5addba0b$export$61465194746e7fd2 = $156c1d4c5addba0b$export$2e2bcd8739ae039.changeLanguage;
const $156c1d4c5addba0b$export$f90d180fc7da3b3b = $156c1d4c5addba0b$export$2e2bcd8739ae039.getFixedT;
const $156c1d4c5addba0b$export$625550452a3fa3ec = $156c1d4c5addba0b$export$2e2bcd8739ae039.t;
const $156c1d4c5addba0b$export$f7e9f41ea797a17 = $156c1d4c5addba0b$export$2e2bcd8739ae039.exists;
const $156c1d4c5addba0b$export$2b4b218e406d2d00 = $156c1d4c5addba0b$export$2e2bcd8739ae039.setDefaultNamespace;
const $156c1d4c5addba0b$export$93d9ee97c1ad3f31 = $156c1d4c5addba0b$export$2e2bcd8739ae039.hasLoadedNamespace;
const $156c1d4c5addba0b$export$83be934b53fff43b = $156c1d4c5addba0b$export$2e2bcd8739ae039.loadNamespaces;
const $156c1d4c5addba0b$export$8cd7e7a54fa865bc = $156c1d4c5addba0b$export$2e2bcd8739ae039.loadLanguages;



const { slice: $e10a9fba5fb103db$var$slice, forEach: $e10a9fba5fb103db$var$forEach } = [];
function $e10a9fba5fb103db$var$defaults(obj) {
    $e10a9fba5fb103db$var$forEach.call($e10a9fba5fb103db$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $e10a9fba5fb103db$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $e10a9fba5fb103db$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $e10a9fba5fb103db$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$e10a9fba5fb103db$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$e10a9fba5fb103db$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $e10a9fba5fb103db$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $e10a9fba5fb103db$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $e10a9fba5fb103db$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $e10a9fba5fb103db$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $e10a9fba5fb103db$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $e10a9fba5fb103db$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            var _window_location_hash;
            let { search: search } = window.location;
            if (!window.location.search && ((_window_location_hash = window.location.hash) === null || _window_location_hash === void 0 ? void 0 : _window_location_hash.indexOf('?')) > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $e10a9fba5fb103db$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    var _language_index;
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return (_language_index = language[index]) === null || _language_index === void 0 ? void 0 : _language_index.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $e10a9fba5fb103db$var$hasLocalStorageSupport = null;
const $e10a9fba5fb103db$var$localStorageAvailable = ()=>{
    if ($e10a9fba5fb103db$var$hasLocalStorageSupport !== null) return $e10a9fba5fb103db$var$hasLocalStorageSupport;
    try {
        $e10a9fba5fb103db$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$e10a9fba5fb103db$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $e10a9fba5fb103db$var$hasLocalStorageSupport = false;
    }
    return $e10a9fba5fb103db$var$hasLocalStorageSupport;
};
var $e10a9fba5fb103db$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $e10a9fba5fb103db$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $e10a9fba5fb103db$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $e10a9fba5fb103db$var$hasSessionStorageSupport = null;
const $e10a9fba5fb103db$var$sessionStorageAvailable = ()=>{
    if ($e10a9fba5fb103db$var$hasSessionStorageSupport !== null) return $e10a9fba5fb103db$var$hasSessionStorageSupport;
    try {
        $e10a9fba5fb103db$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$e10a9fba5fb103db$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $e10a9fba5fb103db$var$hasSessionStorageSupport = false;
    }
    return $e10a9fba5fb103db$var$hasSessionStorageSupport;
};
var $e10a9fba5fb103db$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $e10a9fba5fb103db$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $e10a9fba5fb103db$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $e10a9fba5fb103db$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $e10a9fba5fb103db$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $e10a9fba5fb103db$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        var _language_index;
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return (_language_index = language[index]) === null || _language_index === void 0 ? void 0 : _language_index.replace('/', '');
    }
};
var $e10a9fba5fb103db$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        var _window_location_hostname, _window_location;
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && ((_window_location = window.location) === null || _window_location === void 0 ? void 0 : (_window_location_hostname = _window_location.hostname) === null || _window_location_hostname === void 0 ? void 0 : _window_location_hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $e10a9fba5fb103db$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $e10a9fba5fb103db$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $e10a9fba5fb103db$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$e10a9fba5fb103db$var$canCookies) $e10a9fba5fb103db$var$order.splice(1, 1);
const $e10a9fba5fb103db$var$getDefaults = ()=>({
        order: $e10a9fba5fb103db$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $e10a9fba5fb103db$export$2e2bcd8739ae039 {
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $e10a9fba5fb103db$var$defaults(options, this.options || {}, $e10a9fba5fb103db$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($e10a9fba5fb103db$var$cookie$1);
        this.addDetector($e10a9fba5fb103db$var$querystring);
        this.addDetector($e10a9fba5fb103db$var$localStorage);
        this.addDetector($e10a9fba5fb103db$var$sessionStorage);
        this.addDetector($e10a9fba5fb103db$var$navigator$1);
        this.addDetector($e10a9fba5fb103db$var$htmlTag);
        this.addDetector($e10a9fba5fb103db$var$path);
        this.addDetector($e10a9fba5fb103db$var$subdomain);
        this.addDetector($e10a9fba5fb103db$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$e10a9fba5fb103db$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
}
$e10a9fba5fb103db$export$2e2bcd8739ae039.type = 'languageDetector';



//import React from 'react';
//import DnbStatusLink from './components/dnb-status-link/DnbStatusLink';
// the translations
// (tip move them in a JSON file and import them)
const $c9ba6a600c92ba5a$var$norwegian = {
    translation: {
        'We will be undergoing scheduled maintenance during this time': "Vi vil gjennomf\xf8re planlagt vedlikehold under denne tiden",
        "Det er for tiden problemer med konto/saldo p\xe5 mobil.": "Det er for tiden problemer med konto/saldo p\xe5 mobil.",
        'Andre tjenester privat': 'Andre tjenester privat',
        'Andre tjenester privat': 'Andre Tjenester Privat',
        'Andre tjenester bedrift': 'Andre tjenester bedrift',
        'Andre tjenester bedrift': 'Andre Tjenester Bedrift',
        'Scheduled maintenance is currently in progress. We will provide updates as necessary.': "Vedlikehold p\xe5g\xe5r, vi oppdaterer etter behov.",
        'We are continuing to investigate this issue.': "Det jobbes fortsatt med \xe5 l\xf8se feilen.",
        'We are currently investigating this issue.': 'Det jobbes med problemet.',
        'We are working on solving the incident.': "Det jobbes med \xe5 l\xf8se problemet s\xe5 raskt som mulig.",
        'This incident has been resolved.': "Dette problemet er l\xf8st.",
        'Corporate Internet banking': 'Nettbank Bedrift',
        'Corporate Internet Banking': 'Nettbank Bedrift',
        'Account Overview': 'Kontooversikt',
        'International Payments': 'Betaling Utland',
        Transactions: 'Transaksjoner',
        'Payments Overview': 'Betalingsoversikt',
        Payments: 'Betaling',
        'DNB Bedrift': 'Mobilbank Bedrift',
        Personal: 'Privat',
        Business: 'Bedrift',
        Loading: 'Laster',
        'All our systems and services are working as normal': "Alle v\xe5re systemer fungerer normalt",
        'See incidents': 'Se hendelser',
        'Last updated': 'Sist oppdatert',
        'Go to the incident overview': "G\xe5 til hendelsesoversikt",
        incidents: 'hendelser',
        Incidents: 'Hendelser',
        incident: 'hendelse',
        Incident: 'Hendelse',
        resolved: "l\xf8st",
        started: 'oppstod',
        'Last 48 hours': 'Siste 48 timer',
        'last 24 hours': 'siste 24 timer',
        'Last 90 days': 'Siste 90 dager',
        Systems: 'Systemer',
        working: 'fungerer',
        'There is currently no scheduled maintenance': 'Det er for tiden ingen planlagte vedlikehold',
        'Scheduled maintenance': 'Planlagt vedlikehold',
        'days since': 'dager siden',
        last: 'siste',
        'No incidents in': "Ingen hendelser p\xe5",
        over: 'over',
        months: "m\xe5neder",
        Nettbank: 'Nettbank',
        'Kontoer/balanse Nett': 'Kontoer/balanse',
        "Overf\xf8ringer Nett": "Overf\xf8ringer",
        'Betalinger Nett': 'Betalinger',
        'Minibanker, Kort Og Betalingsterminaler': 'Minibanker, Kort Og Betalingsterminaler',
        'Minibanker, kort og betalingsterminaler': 'Minibanker, Kort Og Betalingsterminaler',
        Kort: 'Kort',
        Innlogging: 'Innlogging',
        'BankID (OIDC)': "BankID p\xe5 DNBs mobilapplikasjoner",
        DigiPass: 'Innlogging uten BankID',
        GO3Phonecode: 'Personlig kode',
        Mobilbank: 'Mobilbank',
        'Sbanken Mobilbank': 'Sbanken Mobilbank',
        'Betalinger Mobil': 'Betalinger',
        'Kontoer/Balanse Mobil': 'Kontoer/balanse',
        "Overf\xf8ringer Mobil": "Overf\xf8ringer",
        'Regninger Mobil': 'Regninger',
        operational: 'Normal drift',
        minor: 'Redusert funksjonalitet',
        major: 'Utilgjengelig',
        critical: 'Utilgjengelig',
        degraded_performance: 'Redusert funksjonalitet',
        under_maintenance: 'Vedlikehold',
        'Affected systems': "System(er) som vil bli p\xe5virket",
        //Header.js
        'DNB Status front page': 'Forsiden DNB Status',
        'Go to dnb.no': "G\xe5 til dnb.no",
        // HistoryHeader.js
        'Back to the front page': "G\xe5 tilbake til startsiden",
        Back: 'Tilbake',
        'Subscribe to updates': "Abonn\xe9r p\xe5 oppdateringer",
        History: 'Historikk',
        // HistoricIncidentCard.js
        'Show log': 'Vis logg',
        'Hide log': 'Skjul logg',
        affect: "p\xe5virker",
        affected: "p\xe5virket",
        // IncidentsListWrapper.js
        'Ongoing incidents': 'Aktive hendelser',
        // NoIncident.js
        'Not much is happening here': 'Her skjer det ikke stort',
        // IncidentsNoIncidents.js
        'No incidents in the last 48 hours': 'Ingen hendelser de siste 48 timene'
    }
};
const $c9ba6a600c92ba5a$var$resources = {
    en: {
        translation: {
            //'Vi jobber med problemet.': 'We are working on solving the incident.',
            'We will be undergoing scheduled maintenance during this time': 'We will be undergoing scheduled maintenance during this time',
            "Det er for tiden problemer med konto/saldo p\xe5 mobil.": 'We are currently experiencing issues with accounts / balances on Mobile.',
            // Components
            'Minibanker, kort og betalingsterminaler': 'Cash Machines/ATMs, Cards, And Payment Terminals',
            'Andre tjenester privat': 'Other Services Personal',
            'Andre Tjenester Privat': 'Other Services Personal',
            'Andre tjenester bedrift': 'Other Services Business',
            'Andre Tjenester Bedrift': 'Other Services Business',
            Kort: 'Cards',
            Innlogging: 'Login',
            'DNB Bedrift': 'Corporate Mobile Bank',
            'BankID (OIDC)': 'BankID (OIDC)',
            DigiPass: 'DigiPass',
            GO3Phonecode: 'GO3Phonecode',
            Mobilbank: 'Mobile Bank',
            'Sbanken Mobilbank': 'Sbanken Mobile Bank',
            'Betalinger Mobil': 'Payments',
            'Kontoer/Balanse Mobil': 'Accounts/balance',
            "Overf\xf8ringer Mobil": 'Transactions',
            'Regninger Mobil': 'Invoices/Bills',
            Nettbank: 'Internet Bank',
            'Kontoer/balanse Nett': 'Accounts/balance',
            "Overf\xf8ringer Nett": 'Transactions',
            'Betalinger Nett': 'Payments',
            'Minibanker, Kort Og Betalingsterminaler': 'Cash Machines/ATMs, Cards, And Payment Terminals',
            'Corporate Internet banking': 'Corporate Internet Banking',
            // End components
            Personal: 'Personal',
            Business: 'Business',
            Loading: 'Loading',
            'All our systems and services are working as normal': 'All our systems and services are working as normal',
            'See incidents': 'See incidents',
            'Last updated': 'Last updated',
            'Go to the incident overview': 'Go to the incident overview',
            incidents: 'incidents',
            Incidents: 'Incidents',
            incident: 'incident',
            Incident: 'Incident',
            resolved: 'resolved',
            started: 'started',
            'Last 48 hours': 'Last 48 hours',
            'last 24 hours': 'last 24 hours',
            'Last 90 days': 'Last 90 days',
            Systems: 'Systems',
            working: 'working',
            'There is currently no scheduled maintenance': 'There is currently no scheduled maintenance',
            'Scheduled maintenance': 'Scheduled maintenance',
            'days since': 'days since',
            last: 'last',
            'No incidents in': 'No incidents in',
            over: 'over',
            months: 'months',
            'Scheduled maintenance is currently in progress. We will provide updates as necessary.': 'Scheduled maintenance is currently in progress. We will provide updates as necessary.',
            'This incident has been resolved.': 'This incident has been resolved.',
            operational: 'Operational',
            minor: 'Minor outage',
            major: 'Major outage',
            critical: 'Critical',
            degraded_performance: 'Degraded performance',
            under_maintenance: 'Under maintenance',
            'Affected systems': 'Affected systems',
            // Header.js
            'DNB Status front page': 'DNB Status front page',
            'Go to dnb.no': 'Go to dnb.no',
            // HistoryHeader.js
            'Back to the front page': 'Back to the front page',
            Back: 'Back',
            'Subscribe to updates': 'Subscribe to updates',
            History: 'History',
            // HistoricIncidentCard.js
            'Show log': 'Show log',
            'Hide log': 'Hide log',
            affect: 'affect',
            // IncidentsListWrapper.js
            'Ongoing incidents': 'Ongoing incidents',
            // NoIncident.js
            'Not much is happening here': 'Not much is happening here',
            // IncidentsNoIncidents.js
            'No incidents in the last 48 hours': 'No incidents in the last 48 hours'
        }
    },
    no: $c9ba6a600c92ba5a$var$norwegian,
    nb: $c9ba6a600c92ba5a$var$norwegian
};
(0, $156c1d4c5addba0b$export$2e2bcd8739ae039).use((0, $de8f8501ef445db0$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
.use((0, $e10a9fba5fb103db$export$2e2bcd8739ae039)).init({
    resources: $c9ba6a600c92ba5a$var$resources,
    //lng: 'no',
    fallbackLng: 'en',
    detection: {
        order: [
            'navigator'
        ]
    },
    debug: true,
    keySeparator: false,
    nsSeparator: false,
    namespaceSeparator: false,
    interpolation: {
        escapeValue: false
    }
});
var $c9ba6a600c92ba5a$export$2e2bcd8739ae039 = (0, $156c1d4c5addba0b$export$2e2bcd8739ae039);


// Deprecated in react 18
//var mountNode = document.getElementById('root');
//ReactDOM.render(<App />, mountNode);
const $226ab363cb34c004$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($c75051cfa147f10e$exports))).createRoot(document.getElementById('root'));
$226ab363cb34c004$var$root.render(/*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ieaan))).StrictMode, {
    children: /*#__PURE__*/ (0, $60739c7e3f826d8d$exports.jsx)((0, $caf4cd8c41e1fa55$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=public.3d299288.js.map
